window.iorad = window.iorad || {};

window.iorad.base = {
  models: {}, // types
  views: {}, // types
  collections: {}, // types
  events: {}, // Backbone.Events
  router: null, // iorad.editor.Router instance
  templates: {}, // strings
  controllers: {}, // controller instances
};

window.iorad.stepTypes = [
  'READ',
  'LEFT_CLICK',
  'RIGHT_CLICK',
  'SCROLL',
  'TYPING',
  'DRAG',
  'DROP',
  'HOVER',
  'SELECT_TEXT',
];


window.iorad.visibilityOptions = [
  'is_sharing_disabled',
  'is_print_portrait_disabled', 'is_print_landscape_disabled', 'is_print_qr_disabled',
  'is_live_disabled',
  'is_step_image_preview_disabled',
  'is_navigation_disabled',
  'is_progress_bar_disabled',
  'is_step_counter_disabled',
  'is_language_disabled',
  'is_logo_disabled',
  'is_favicon_disabled',
  'is_info_disabled',
  'is_description_disabled',
  'is_duration_disabled', 'is_stepsnumber_disabled', 'is_fullscreen_disabled',
  'is_cover_disabled',
  'is_trysteps_disabled', 'is_watchsteps_disabled', 'is_quizsteps_disabled',
  'is_viewsteps_disabled', 'is_mobilequick_disabled',
  'is_actionlabel_disabled',
  'is_commenting_disabled',
  'is_recommended_disabled',
  'is_ask_thesquare_disabled',
  'is_playbar_disabled',
];
window.iorad.defaultViewOptions = [
  'is_trysteps_default',
  'is_watchsteps_default',
  'is_quizsteps_default',
  'is_viewsteps_default',
  'is_mobilequick_default',
  'is_pdf_default',
  'is_live_default',
];
window.iorad.forceDeviceOptions = [
  'is_adaptive_device',
  'is_desktop_device',
  'is_mobile_device',
];
window.iorad.screenshotZoomOptions = [
  'is_adaptive_screenshot_zoom',
  'is_75_screenshot_zoom',
  'is_half_screenshot_zoom',
  'is_full_screenshot_zoom',
];
window.iorad.stepPanelOptions = [
  'is_full_step_panel',
  'is_minimized_step_panel',
  'is_steptext_step_panel',
  'is_navbar_step_panel',
  'is_hidden_step_panel',
];
window.iorad.allLayoutOptions = window.iorad.visibilityOptions
  .concat(window.iorad.defaultViewOptions)
  .concat(window.iorad.forceDeviceOptions)
  .concat(window.iorad.screenshotZoomOptions)
  .concat(window.iorad.stepPanelOptions);
window.iorad.allLayoutOptionsAllModes = _.flatten(window.iorad.allLayoutOptions.map(function (option) {
  return [
    'direct_' + option,
    'embed_' + option,
    'widget_' + option,
  ];
}));

window.iorad.getStepLabel = function ({
  step,
  mobile,
  fullInfo,
}) {
  var stepType = step.type;
  var dblClick = step.event && step.event.dblclick;

  var label = iorad.base.Utils.capitalize(stepType.replace(/_/g, ' ').toLowerCase());
  if (stepType === 'READ') label = 'Info';
  if (stepType === 'LEFT_CLICK') {
    if (mobile) {
      label = dblClick ? 'Double Tap' : 'Tap';
    } else {
      label = dblClick ? 'Double Click' : 'Click';
    }
  }
  if (stepType === 'RIGHT_CLICK') {
    label = mobile ? 'Two Finger Tap' : 'Right Click';
  }
  if (stepType === 'HOVER') {
    if (mobile) label = 'Long Press';
  }
  if (stepType === 'TYPING') label = 'Type';
  if (stepType === 'DRAG_AND_DROP') label = 'Drag & Drop';
  if (stepType === 'SELECT_TEXT') label = 'Select Text';

  var trKey = 'STEP_TYPES::' + label;
  var translationExists = (window.i18next && window.i18next.exists(trKey));
  var translationExistsNoFallback = (window.i18next && window.i18next.exists(trKey, { lngs: [window.i18next.language] }));
  label = translationExists ? window.i18next.t(trKey) : label;
  return !fullInfo
    ? label
    : {
      label: label,
      translationExists: translationExists,
      translationExistsNoFallback: translationExistsNoFallback,
    };
};

// noty override
(function() {
  var closeIconSvg =
    '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M1 1L13 13M1 13L13 1" stroke="white" stroke-width="1.6" />' +
    '</svg>';
  var infoIconSvg =
    '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">' +
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M0 0.533307L0.533322 0H15.4667L16 0.533307V15.4667L15.4667 16H0.533322L0 15.4667V0.533307ZM1.06664 1.06661V14.9334H14.9334V1.06661H1.06664ZM8.58244 4L9 3.58244L9 2.41756L8.58244 2H7.41756L7 2.41756V3.58244L7.41756 4L8.58244 4ZM7.50001 5.3H6.5V7.3H7.50001V12.4H6.5V14H10V12.4H9.10001V5.3H8.5H7.50001Z" fill="white"/>' +
    '</svg>';

  var oldNotifications = []; // NOTE: this includes notifications that aren't visible anymore
  // Equal in terms of what the end-user sees
  function areNotificationsEqual(a, b) {
    return (
      a.text === b.text &&
      _.isEqual(
        (a.buttons || []).map(button => button.text),
        (b.buttons || []).map(button => button.text),
      )
    );
  }
  function handleMultipleNotifications(props) {
    // For "success" notification without buttons, we want to skip it if it's a duplicate
    // (even of those that are not visible anymore, up to X seconds old).
    if (
      props.type === 'success' &&
      !(props.buttons && props.buttons.length > 0)
    ) {
      const OLD_NOTIFICATION_DURATION = 10 * 1000;
      oldNotifications = oldNotifications.filter(x => props.timeStamp - x.timeStamp <= OLD_NOTIFICATION_DURATION);
      if (oldNotifications.some(oldNotification => areNotificationsEqual(oldNotification, props))) {
        // skip duplicate
        return true;
      }
      oldNotifications.push(props);
    }

    // For other kind of notifications, we want to hide the old duplicates
    // => Editor/Player already automatically closes the others, only keeping 1 visible
  }

  var notyOriginal = window.noty;
  var multilineHeight = 40;
  var closeAllNotificationsKey = 'd';
  window.noty = function(options) {
    const timeStamp = Date.now();
    const realUuid = window.uuidv4();
    if (handleMultipleNotifications({
      ...options,
      realUuid,
      timeStamp,
    })) {
      // skipped
      return null;
    }

    var hasButtons =
      (options.buttons && options.buttons.length > 0) ||
      options.text.match(/<\/a>/);

    if (options.timeout === undefined) options.timeout = hasButtons ? false : 5000;

    var layout = options.layout || 'top';

    if (!options.animation) options.animation = {};
    $.extend(options.animation, {
      open: typeof options.animation.open !== 'undefined' ? options.animation.open : ('noty_open_' + layout),
      close: typeof options.animation.close !== 'undefined' ? options.animation.close : ('noty_close_' + layout)
    });

    if (!options.callback) options.callback = {};

    var buttonKeys =
      hasButtons ?
        options.buttons.map(function(button) {
          return button.text[0].toLowerCase();
        }) :
        [];
    if (hasButtons) {
      options.buttons = options.buttons.map(function(button, bi) {
        var shortcutSuffix = !button.disableShortcut ?
          (' (' + buttonKeys[bi].toUpperCase() + ')')
          : '';
        return _.extend({}, button, {
          text: button.text + shortcutSuffix,
          onClick: function () {
            if (options.customType === 'featureAccessError') {
              var expiresDate = new Date();
              expiresDate.setTime(expiresDate.getTime() + (2 * 60 * 60 * 1000)); // 2 hours
              document.cookie = 'noty_upgrade_click=' + realUuid +
                '; expires=' + expiresDate.toUTCString() +
                '; path=/' +
                '; SameSite=None; Secure';
            }


            // NOTE: send event before callback is handled
            // to get url/document/window properties
            // before they change
            if (!iorad.app.notracking) {
              iorad.app.controllers.sync.saveNotyStatistics({
                url_pathname: siteWindow.location.pathname,
                url_search: siteWindow.location.search,
                url_hash: siteWindow.location.hash,
                document_title: siteWindow.document.title,
                window_embedded: siteWindow.top !== siteWindow,
                window_width: siteWindow.innerWidth,
                window_height: siteWindow.innerHeight,
                noty_type: options.customType || options.type,
                noty_uuid: realUuid,
                noty_message: options.text,
                noty_action_label: button.text,
                noty_action_href: null,
                noty_action_target: null,
                noty_action_callback: true,
                noty_auto_dismiss: typeof options.timeout === 'boolean' ? null : options.timeout,
                feature_name: options.featureName,
                event_type: 'action:click',
              });
            }

            button.onClick.apply(this, arguments);
          },
        });
      });
    }

    var onShowPassed = options.callback.onShow;
    var afterClosePassed = options.callback.afterClose;

    var handleKeyPress = function(event) {
      if (
        $(event.target).is('input:not([readonly]):not([type=radio]):not([type=checkbox]), textarea, [contentEditable], [contentEditable=true]')
      ) {
        return;
      }

      var buttonIFound = buttonKeys.indexOf(event.key.toLowerCase());
      if (buttonIFound !== -1) {
        var buttonFound = options.buttons[buttonIFound];
        if (buttonFound.onClick && !buttonFound.disableShortcut) {
          buttonFound.onClick(notyEl, event);
          return;
        }
      }

      if (event.key === closeAllNotificationsKey) {
        notyEl.close();
      }
    };

    var onShow = function() {
      if (onShowPassed) onShowPassed.apply(this, arguments);
      requestAnimationFrame(function() {
        if (this.$message[0].clientHeight > multilineHeight) {
          this.$bar.addClass('noty_multiline');
        }
        document.addEventListener('keypress', handleKeyPress);
        if (siteWindow !== document) {
          siteWindow.addEventListener('keypress', handleKeyPress);
        }
      }.bind(this));
    };
    var afterClose = function() {
      if (afterClosePassed) afterClosePassed.apply(this, arguments);
      document.removeEventListener('keypress', handleKeyPress);
      if (siteWindow !== document) {
        siteWindow.removeEventListener('keypress', handleKeyPress);
      }
    };
    options.callback.onShow = onShow;
    options.callback.afterClose = afterClose;

    var notyEl = notyOriginal.apply(this, arguments);

    if (hasButtons) {
      notyEl.$bar.find('.noty_bar').prepend(infoIconSvg);
    }

    if (options.closeButton !== false) {
      var defaultClose = function() {
        notyEl.close();
      };
      options.closeButton =
        $.extend({}, {onClick: defaultClose}, options.closeButton);
    }

    if (options.closeButton) {
      var $close = $('<div>').addClass('noty_close').html(closeIconSvg);
      notyEl.$bar.find('.noty_bar').append($close);
      notyEl.$bar
        .on('click', function(event) {
          options.closeButton.onClick.call($close, notyEl, event);
        });
    }

    var closeCleanUp = notyEl.closeCleanUp;
    notyEl.closeCleanUp = function() {
      var result = closeCleanUp.apply(this, arguments);
      document.removeEventListener('keypress', handleKeyPress);
      if (siteWindow !== document) {
        siteWindow.removeEventListener('keypress', handleKeyPress);
      }
      return result;
    };

    return notyEl;
  };
})();

// Mustache i18next integration
// Usage example: {{#i18n}}PDF::Portrait{{/i18n}}
//                Will just return "Portrait" if no translation can be found
// Wraps text in a FONT with notranslate class when translation exists (excluding fallback)
//                WHY: useful to prevent google translate
function i18nLambda(path, render) {
  var lastPart = path && _.last(path.split('::'));
  var text = window.i18next.exists(path) ? window.i18next.t(path) : lastPart;
  var translationExistsNoFallback = window.i18next.exists(path, {
    lngs: [window.i18next.language], // exclude fallback language
  });
  return translationExistsNoFallback ?
    '<font class="i18next notranslate">' + render(text) + '</font>'
    :
    render(text);
}
// Like i18nLambda without the FONT & notranslate,
// only use as last resort, e.g. in HTML attributes
function i18nUnsafeLambda(path, render) {
  var lastPart = path && _.last(path.split('::'));
  var text = window.i18next.exists(path) ? window.i18next.t(path) : lastPart;
  return render(text);
}
Mustache.Context.prototype._lookup = Mustache.Context.prototype.lookup;
Mustache.Context.prototype.lookup = function i18nLookup (name) {
  if (name === 'i18n') return i18nLambda;
  if (name === 'i18nUnsafe') return i18nUnsafeLambda;
  return this._lookup(name);
};

;
// Based on https://github.com/Maluen/Backbone-Debugger/blob/master/js/backboneAgent/Component.js
// (which in turn is inspired from Backbone).
// General Component class with Backbone Events included.

iorad.base.Component = (function() {

  // constructor
  var Component = function() {
    if (typeof this.initialize == 'function') {
      this.initialize.apply(this, arguments);
    }
  };

  Component.extend = function(ChildProps, ChildStaticProps) {

    var Super = this; // (the Component itself or the subtype we are extending)

    var Child;

    // child constructor
    if (ChildProps.hasOwnProperty('constructor')) {
      // custom constructor
      Child = ChildProps.constructor;
    } else {
      // default constructor
      Child = function() {
        Super.apply(this, arguments);
      }
    }

    _.extend(Child, Super, ChildStaticProps); // inherit static properties
    Child.__super = Super; // keep reference to super type
    Child.prototype = Object.create(Super.prototype);
    Child.prototype.__super = Super.prototype; // keep reference to super prototype
    _.extend(Child.prototype, ChildProps);

    return Child;
  }

  _.extend(Component.prototype, Backbone.Events);

  return Component;

})();
;
/* eslint-disable no-var */
// It is used by editor and player as well as by nodejs app

(function() {
  var findWhere =
    typeof require !== 'undefined' ?
      require('lodash/find') :
      _.findWhere;
  var map =
    typeof require !== 'undefined' ?
      require('lodash/map') :
      _.map;
  var extend =
    typeof require !== 'undefined' ?
      require('lodash/extend') :
      _.extend;
  var values =
    typeof require !== 'undefined' ?
      require('lodash/values') :
      _.values;
  var range =
    typeof require !== 'undefined' ?
      require('lodash/range') :
      _.range;
  var isEqual =
    typeof require !== 'undefined' ?
      require('lodash/isEqual') :
      _.isEqual;
  var has =
    typeof require !== 'undefined' ?
      require('lodash/has') :
      _.has;

  // NOTE: this is more restrictive than the site version
  // since there is no need to support embed code of external integrations
  var STEP_DESCRIPTION_APP_SANITIZE_RULES = {
    allowedTags: ['b', 'span', 'a', 'br', 'u'],
    allowedAttributes: {
      a: ['href', 'target', 'rel'],
    },
  };

  var STEP_DESCRIPTION_SANITIZE_RULES = {
    allowedTags: ['b', 'strong', 'span', 'a', 'br', 'u'],
    allowedAttributes: {
      b: ['style'],
      span: ['style'],
      a: ['href', 'target', 'rel'],
    },
  };

  var STEP_INFOTEXT_SANITIZE_RULES = {
    allowedTags: ['b', 'span', 'a', 'br', 'u', 'ul', 'ol', 'li', 'div'],
    allowedAttributes: {
      a: ['href', 'target', 'rel', 'class'],
    },
    allowedClasses: {
      '*': ['wysiwyg-text-align-left', 'wysiwyg-text-align-center', 'wysiwyg-text-align-right']
    },
  };

  var STEP_INFOTEXT_EMBED_ALLOWED_HOSTNAMES = [
    'www.youtube.com',
    'player.vimeo.com',
    'docs.google.com',
    'fast.wistia.net',
    '1drv.ms'
  ];
  var STEP_INFOTEXT_EMBED_ALLOW_ATTRIBUTE_VALUES = [
    'accelerometer',
    'autoplay',
    'clipboard-write',
    'encrypted-media',
    'gyroscope',
    'picture-in-picture',
    'web-share',

    'fullscreen',
  ];
  var STEP_INFOTEXT_EMBED_SANITIZE_RULES = {
    allowedTags: ['iframe'],
    allowedAttributes: {
      iframe: [
        'src',
        'name',
        'width',
        'height',
        'allowfullscreen',
        'frameborder',
        'allow',
      ],
    },
    transformTags: {
      iframe: function(tagName, attribs) {
        var newAttribs = extend({}, attribs);
        if (newAttribs.allow) {
          newAttribs.allow = newAttribs.allow
            .split(';')
            .map(function (allowSingle) {
              return allowSingle.trim();
            })
            .filter(function (allowSingle) {
              return allowSingle && STEP_INFOTEXT_EMBED_ALLOW_ATTRIBUTE_VALUES.includes(allowSingle);
            })
            .join('; ');
          if (!newAttribs.allow) {
            delete newAttribs.allow;
          }
        }
        return {
          tagName: tagName,
          attribs: newAttribs,
        };
      },
    },
    allowedClasses: {
      'iframe': []
    },
    allowedIframeHostnames: STEP_INFOTEXT_EMBED_ALLOWED_HOSTNAMES,
    allowIframeRelativeUrls: false,
    allowedSchemes: ['https'],
  };

  var exportStatics = {
    getScaledSize: function(targetSize, containerSize) {
      var containerWidth = containerSize[0];
      var containerHeight = containerSize[1];
      var targetWidth = targetSize[0];
      var targetHeight = targetSize[1];
      var targetScale = Math.min(
        1, // scale-down only
        containerWidth / targetWidth,
        containerHeight / targetHeight
      );
      var scaledWidth = targetWidth * targetScale;
      var scaledHeight = targetHeight * targetScale;
      var targetLeft = (containerWidth - scaledWidth) / 2;
      var targetTop = (containerHeight - scaledHeight) / 2;

      return {
        targetWidth,
        targetHeight,
        scaledWidth,
        scaledHeight,
        targetLeft,
        targetTop,
        targetScale
      }
    },
    // copy from iorad.base.Utils
    isFileProtocolURL: function(url) {
      if (!url) return false;
      if (url.startsWith('file://')) return true;
      if (
        window.location.href.startsWith('file://') &&
        !url.startsWith('https://') &&
        !url.startsWith('http://') &&
        !url.split(':')[0] !== 'data'
      ) {
        var a = document.createElement('a');
        a.href = url;
        var absoluteURL = a.href;
        return absoluteURL.startsWith('file://');
      }

      return false;
    },
    loadImage: function(url, disableCORS) {
      return new Promise(function(resolve, reject) {
        var image = new Image();
        image.onload = function () {
          resolve(image);
        };
        image.onerror = function () {
          console.error('Cannot load image ' + url);
          reject('Cannot load image');
        };
        if (!exportStatics.isFileProtocolURL(url) && !disableCORS) {
          image.crossOrigin = "Anonymous";
        }
        image.src = url;
      });
    },
    getUrlMaskedCanvas: function(imgUrl, mask, maskColorHex) {
      return exportStatics.loadImage(imgUrl)
        .then(function(img) {
          var canvas = document.createElement('canvas');

          var imgWidth = img.width;
          var imgHeight = img.height;

          canvas.setAttribute('width', imgWidth);
          canvas.setAttribute('height', imgHeight);

          var context = canvas.getContext('2d');
          context.drawImage(img, 0, 0, imgWidth, imgHeight);
          var maskRgb = exportStatics.hexToRgb(maskColorHex || '#000000');
          var maskColor = 'rgba(' + maskRgb.join(', ') + ', ' + mask / 100 + ')';

          context.beginPath();
          context.fillStyle = maskColor;
          context.rect(0, 0, imgWidth, imgHeight);
          context.fill();

          return canvas;
        });
    },
    isValidColor: function(color) {
      //fast check for this bug: https://github.com/iorad/iorad/issues/1273
      if (color === '#000000') {
        return true;
      }

      if (/^#[a-f0-9]+$/i.test(color) === false) {
        return false;
      }

      // credits to http://stackoverflow.com/questions/6386090/validating-css-color-names
      // var $dummy = $('<div></div>'),
      //   emptyColor = $dummy.css('color');

      // $dummy.css('color', color);
      // return emptyColor !== $dummy.css('color');
      var $dummy = document.createElement("div");
      var emptyColor = $dummy.style.color;

      $dummy.style.color = color;
      return emptyColor !== $dummy.style.color;
    },
    isImageDark: function(imgUrl, mask, maskType) {
      return exportStatics.getUrlMaskedCanvas(imgUrl, mask, maskType)
        .then(function(canvas) {
          var imageData = canvas.getContext('2d').getImageData(0, 0, canvas.width, canvas.height);

          // examine every pixel
          var darkometer = 0;
          var transparentPixels = 0;
          for (var i = 0; i < imageData.data.length; i += 4) {
            var r = imageData.data[i];
            var g = imageData.data[i + 1];
            var b = imageData.data[i + 2];
            var a = imageData.data[i + 3];

            if (a === 0) {
              transparentPixels = transparentPixels + 1;
              continue;
            }

            if (((r * 299 + g * 587 + b * 114) / 1000) < 128) {
              darkometer = darkometer + 1;
            }
          }

          // more than half pixels are dark
          var isImageDark =
            darkometer > (imageData.data.length / 8 - transparentPixels / 2);
          return isImageDark;
        });
    },
    isThemeDark: function(opts) {
      return (
        (
          opts.headerBackground &&
          opts.backgroundImageDark !== false
        ) ||
        (
          !opts.headerBackground &&
          opts.colorPrimary &&
          exportStatics.getContrastColor(opts.colorPrimary) === '#ffffff'
        )
      );
    },
    getBaseLogo: function(opts, baseThemes) {
      var isImageTheme =
        (opts.headerBackground || opts.internalKey === 'image') &&
        opts.internalKey !== 'bright' && opts.internalKey !== 'dark';
      var dark = exportStatics.isThemeDark(opts);
      var imageBase = findWhere(baseThemes, { internalKey: 'image' }) || {};
      var darkBase = findWhere(baseThemes, { internalKey: 'dark' }) || {};
      var brightBase = findWhere(baseThemes, { internalKey: 'bright' }) || {};
      var contrastBase = dark ? darkBase : brightBase;
      var imageBaseLogoName = dark ? 'logoImageDark' : 'logoImage';
      var baseTheme = isImageTheme ? imageBase : contrastBase;
      var baseLogo = // apply specific base logo for image theme if specified
        (isImageTheme ? imageBase[imageBaseLogoName] : '') ||
        contrastBase.logoImage;
      if (!baseLogo) return '';
      var baseLogoCached = baseLogo + '?lastModified=' + baseTheme.lastModified;
      return baseLogoCached;
    },
    getBaseFavicon: function(opts, baseThemes) {
      var isImageTheme =
        (opts.headerBackground || opts.internalKey === 'image') &&
        opts.internalKey !== 'bright' && opts.internalKey !== 'dark';
      var dark = exportStatics.isThemeDark(opts);
      var imageBase = findWhere(baseThemes, { internalKey: 'image' }) || {};
      var darkBase = findWhere(baseThemes, { internalKey: 'dark' }) || {};
      var brightBase = findWhere(baseThemes, { internalKey: 'bright' }) || {};
      var contrastBase = dark ? darkBase : brightBase;
      var imageBaseFaviconName = dark ? 'faviconImageDark' : 'faviconImage';
      var baseTheme = isImageTheme ? imageBase : contrastBase;
      var baseFavicon = // apply specific base favicon for image theme if specified
        (isImageTheme ? imageBase[imageBaseFaviconName] : '') ||
        contrastBase.faviconImage;
      if (!baseFavicon) return '';
      var baseFaviconCached = baseFavicon + '?lastModified=' + baseTheme.lastModified;
      return baseFaviconCached;
    },
    getBaseContrastTheme: function(opts, baseThemes) {
      var dark = exportStatics.isThemeDark(opts);
      var baseColorTheme = findWhere(
        baseThemes, {internalKey: dark ? 'dark' : 'bright'}
      ) || {};

      var baseTheme = extend({}, baseColorTheme); // avoid modifying the original
      return baseTheme;
    },
    // paying for non-extendable design from before, returns hex string
    getHeaderMaskColor: function(theme) {
      var attrValue = theme.headerMaskType;
      return (
        (attrValue === 'black' || !attrValue) ? '#000000' :
        attrValue === 'white' ? '#ffffff' :
        attrValue
      );
    },
    // Some colors (font, highlight) are calculated
    // to contrast with the background.
    // We just detect if background is dark or bright
    // and choose colors respectevely.
    // Note, that some contrast colors change depending on
    // whether the cover is expanded or collapsed
    // since they are visible in both cases and
    // cover can have different bg colors, expanded vs collapsed
    themeToItemColors: function(theme, baseThemes, activeThemeId, coverOpen) {
      var hex6 = exportStatics.colorToHex6;

      // === theme options
      var customOpts = theme ? theme : {};
      var customHeaderMaskColor = (theme && exportStatics.getHeaderMaskColor(theme));
      // set only if value is not empty, so it doesn't override base theme
      if (customHeaderMaskColor) {
        customOpts.headerMaskColor = customHeaderMaskColor;
      }
      var themeId =
        isFinite(activeThemeId) ?
        activeThemeId :
        null;
      var baseTheme =
        customOpts.baseTheme ?
          findWhere(values(baseThemes), { name: customOpts.baseTheme }) :
          (
            findWhere(values(baseThemes), { id: themeId }) ||
            !theme && findWhere(values(baseThemes), { internalKey: 'bright' })
          );
      if (baseTheme && baseTheme.headerMaskType) {
        baseTheme.headerMaskColor = // old style support
          baseTheme.headerMaskType === 'white' ? '#ffffff' :
          baseTheme.headerMaskType === 'black' ? '#000000' :
          baseTheme.headerMaskType ? baseTheme.headerMaskType :
          '#000000';
      }

      var opts = extend({}, (baseTheme || {}), customOpts);
      if (customOpts.logoImage && !customOpts.headerBackground) {
        // don't use default background if custom logo (see #6128)
        opts.headerBackground = null;
      }
      if (customOpts.headerMaskColor && !customOpts.headerBackground) {
        // don't use custom mask if not using custom background (#6525)
        opts.headerMaskColor = (baseTheme && baseTheme.headerMaskColor) || null;
      }

      var baseContrastTheme = exportStatics.getBaseContrastTheme(opts, baseThemes);

      // === theme generals
      var coverBackgroundImage = opts.headerBackground ? (
        opts.headerBackground +
        ((opts.lastModified && opts.headerBackground.indexOf('cache=') === -1) ?
          (opts.headerBackground.indexOf('?') === -1 ? '?' : '&') + 'cache=' + opts.lastModified
        : '')
      ) : null;
      var mask = coverBackgroundImage ?
        Math.max(0, Math.min(100, (parseFloat(opts.headerMask) || 0)))
        : 0;
      var maskColorRgb =
        (opts.headerMaskColor && exportStatics.hexToRgb(opts.headerMaskColor))
        || [0, 0, 0];
      var maskColor = 'rgba(' + maskColorRgb.join(', ') + ', ' + mask / 100 + ')';
      var playerMenuBackgroundImage = coverBackgroundImage;

      var primary =
        (opts.colorPrimary && !coverBackgroundImage) ?
          hex6(opts.colorPrimary) :
          baseContrastTheme.colorPrimary;

      var coverBackground = coverBackgroundImage ? maskColor : primary; // default

      var headerBackgroundIsBased = baseTheme &&
        // only on new theme
        typeof opts.headerBackgroundFilename === 'undefined' &&
        baseTheme.headerBackground === opts.headerBackground &&
        // don't use colorPrimary if it is based on baseTheme
        opts.colorPrimary !== baseTheme.colorPrimary;

      if (headerBackgroundIsBased) {
        primary = coverBackground = hex6(opts.colorPrimary);
      }

      var primaryCont = exportStatics.getContrastColor(primary);

      var primaryDark = primaryCont === '#ffffff';

      var progressCont = primaryDark ? 'AAAAAA' : '000000';

      var addTransparency = exportStatics.addTransparency;

      // === theme specials
      // = header
      var hFont = customOpts.headerFontColor || primaryCont;
      var hFontContrast = exportStatics.getContrastColor(hFont);
      var hFontDark = hFont === '#ffffff';

      var header = {
        mask: mask,
        headerMaskColor: opts.headerMaskColor,
        primaryCont: primaryCont,
        coverBackground: coverBackground,
        collapsedCoverBackground:
          playerMenuBackgroundImage ? maskColor : primary,
        font: hFont,
        dark: primaryDark,
        coverBackgroundImage: coverBackgroundImage,
        playerMenuBackgroundImage: playerMenuBackgroundImage,
        backgroundImage:
          coverOpen ? coverBackgroundImage : playerMenuBackgroundImage,
        activeMenuItemBackground: addTransparency(primaryCont, 2),
        progressFirst: addTransparency(progressCont, 3),
        progressSecond: addTransparency(progressCont, 6),
        borderColor: primaryDark ? '#000000' : '#f4f4f4',
        borderColorHover: hFont,
        buttonBackground: hFont,
        buttonBackgroundHover: hFontDark
          ? '#3b3b3b' // darken(white, 30%)
          : '#4c4c4c', // lighten(black, 30%)
        buttonFont: hFontDark ? '#000000' : '#ffffff',
        helpCenterButtonBackground: hFontDark ? addTransparency('#ffffff', '20') : addTransparency('#000000', '05'),
        helpCenterButtonBackgroundHover: hFontDark ? '#ffffff' : '#000000',
        helpCenterButtonFont: hFontDark ? '#ffffff' : '#000000',
        helpCenterButtonFontHover: hFontDark ? '#000000' : '#ffffff',
        outline: addTransparency(hFont, 5),
      };
      // = popup
      var pBackground = primary;
      var pFont = customOpts.headerFontColor || primaryCont;
      var pDark = header.dark;
      var popup = {
        background:
          header.backgroundImage ?
            (pDark ? 'rgba(0, 0, 0, .90)' : 'rgba(255, 255, 255, 1)') :
            pBackground,
        font: pFont,
        contentBackground: (!header.backgroundImage && pDark) ?
          addTransparency(pFont, 2) : 'rgba(0, 0, 0, 0)',
        buttonBackground: (!header.backgroundImage && pDark) ?
          addTransparency(pFont, 2) : 'rgba(0, 0, 0, 0)',
        buttonBackgroundHover: (!header.backgroundImage && pDark) ?
          addTransparency(pFont, 3) : 'rgba(0, 0, 0, 0)',
        buttonBorder: (!header.backgroundImage && pDark) ?
          'rgba(0, 0, 0, 0)' : addTransparency(pFont, 2),
        buttonBorderHover: (!header.backgroundImage && pDark) ?
          'rgba(0, 0, 0, 0)' : addTransparency(pFont, 3),
        dropDownHoverBackground: addTransparency(pFont, 1),
      };
      // = finish
      var finish = {
        background: primary,
        font: primaryCont,
        mutedFont: addTransparency(primaryCont, 2),
        buttonBackground:
          primaryDark ? addTransparency(primaryCont, 2) : primary,
        buttonBackgroundHover:
          primaryDark ? addTransparency(primaryCont, 3) : primary,
        buttonBorder:
          primaryDark ? '#00000000' : addTransparency(primaryCont, 2),
        buttonBorderHover:
          primaryDark ? '#00000000' : addTransparency(primaryCont, 3),
      };

      var logoOpts = theme ? theme : baseThemes;
      var logoCroppedImage =
        !logoOpts.logoImage ?
          logoOpts.logoImage :
            (
              logoOpts.logoImage.split('.').slice(0, -1).join('.') +
              '_cropped.' +
              logoOpts.logoImage.split('.').pop()
            );
      var logo = {
        image: logoOpts.logoImage,
        croppedImage: logoCroppedImage,
        href: logoOpts.logoHref,
        targetBlank: logoOpts.logoTargetBlank,
        baseImage: exportStatics.getBaseLogo(baseContrastTheme, baseThemes),
        isBaseTheme: logoOpts.isBaseTheme,
        logoCropped: !!logoOpts.logoCropped,
      };

      var faviconOpts = theme ? theme : baseThemes;
      var faviconCroppedImage =
        !faviconOpts.faviconImage ?
          faviconOpts.faviconImage :
            (
              faviconOpts.faviconImage.split('.').slice(0, -1).join('.') +
              '_cropped.' +
              faviconOpts.faviconImage.split('.').pop()
            );
      var favicon = {
        image: faviconOpts.faviconImage,
        croppedImage: faviconCroppedImage,
        baseImage: exportStatics.getBaseFavicon(baseContrastTheme, baseThemes),
        isBaseTheme: faviconOpts.isBaseTheme,
        faviconCropped: !!faviconOpts.faviconCropped,
      };

      var fontOpts = theme ? theme : baseThemes;
      var font = {
        primaryFamily: fontOpts.primaryFontFamily || 'Libre Franklin',
        secondaryFamily: fontOpts.secondaryFontFamily || 'Fahkwang',
        stepTextFontSize: fontOpts.stepTextFontSize || 15,
      };

      var closedCaptioningOpts = theme ? theme : baseThemes;
      var closedCaptioning = {
        ccFontFamily: closedCaptioningOpts.ccFontFamily || 'Poppins',
        ccFontColor: closedCaptioningOpts.ccFontColor || '#ffffff',
        ccFontSize: closedCaptioningOpts.ccFontSize || 16,
        ccBackgroundColor: closedCaptioningOpts.ccBackgroundColor || '#000000',
        ccBackgroundOpacity: closedCaptioningOpts.ccBackgroundOpacity || 100,
      }
      closedCaptioning.ccBackgroundColorRgba = 'rgba(' +
        exportStatics.hexToRgb(closedCaptioning.ccBackgroundColor).join(', ') +
        ', ' +
        (Math.max(0, Math.min(100, closedCaptioning.ccBackgroundOpacity))) / 100 +
      ')';

      var accentColor = opts.accentColor;

      return {
        header: header,
        popup: popup,
        finish: finish,
        logo: logo,
        favicon: favicon,
        font: font,
        cc: closedCaptioning,
        accentColor: accentColor,
      };
    },

    addTransparency: function(hexColor, alpha) {
      var rgbList = exportStatics.hexToRgb(hexColor);
      return rgbList &&
        ('rgba(' + rgbList.join(', ') + ', .' + alpha + ')');
    },

    getDefaultLogoUrl: function(staticRoot) {
      if (typeof staticRoot === 'undefined') {
        staticRoot = (window.STATIC_ROOT || '');
      }
      return staticRoot + 'images/base/logo/logo-new-square-small.svg';
    },

    getDefaultFaviconUrl: function(staticRoot) {
      if (typeof staticRoot === 'undefined') {
        staticRoot = (window.STATIC_ROOT || '');
      }
      return staticRoot + 'images/base/favicon.ico';
    },

    getContrastColor: function(color) {
      return !color ? '' : exportStatics.contrastColor(
        exportStatics.colorToHexTriplet(color)
      );
    },
    // YIQ contrast - credits to http://24ways.org/2010/calculating-color-contrast/
    contrastColor: function(hexTripletColor) {
      var color = hexTripletColor;
      color = color.substring(1); // remove #
      var r = parseInt(color.substr(0, 2), 16);
      var g = parseInt(color.substr(2, 2), 16);
      var b = parseInt(color.substr(4, 2), 16);
      var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
      return (yiq >= 128) ? '#000000' : '#ffffff';
    },
    // convert color (eg 'red', 'rgb(255,0,0)', '#ff000000') to hex triplet (eg '#ff000000')
    colorToHexTriplet: function(color) {
      if (!color) return color;
      if (exportStatics.startsWith(color, '#')) return exportStatics.normalizeHex(color);
      else if (exportStatics.startsWith(color, 'rgba')) {
        color = exportStatics.rgbaToRgb(color);
      } else if (!exportStatics.startsWith(color, 'rgb')) {
        // is a word, convert it to rgb first
        color = exportStatics.colorWordToRgb(color);
      }
      return color ? exportStatics.rgbToHex(color) : '';
    },
    colorToHex6: function(color) {
      return exportStatics.colorToHexTriplet(color).substr(0, 7);
    },
    // normalize hex value into 8 digit format (#ff00aaff)
    normalizeHex: function(color) {
      if (!exportStatics.startsWith(color, '#')) return color;
      if (color.length === 4 || color.length === 5) {
        return (
          color[0] +
          color[1] + color[1] +
          color[2] + color[2] +
          color[3] + color[3] +
          (color[4] || 'f') + (color[4] || 'f')
        );
      }
      if (color.length === 7) return color + 'ff';
      return color;
    },
    // rgba string to rgb string
    // based on http://stackoverflow.com/a/2645218
    rgbaToRgb: function(rgbaColor) {
      var rgbaArray = exportStatics.rgbaToArray(rgbaColor);

      // background is directly extracted from the rgba color!
      // TODO: check if this works in all cases
      var backgroundRgbArray = [ rgbaArray[0], rgbaArray[1], rgbaArray[2] ];

      // normalize
      function normalize(array) {
        return map(array, function(item) {
          return item / 255;
        });
      }
      rgbaArray = normalize(rgbaArray);
      backgroundRgbArray = normalize(backgroundRgbArray);

      var rgbArray = [];
      rgbArray[0] =
        ((1 - rgbaArray[3]) * backgroundRgbArray[0]) + (rgbaArray[3] * rgbaArray[0]);
      rgbArray[1] =
        ((1 - rgbaArray[3]) * backgroundRgbArray[1]) + (rgbaArray[3] * rgbaArray[1]);
      rgbArray[2] =
        ((1 - rgbaArray[3]) * backgroundRgbArray[2]) + (rgbaArray[3] * rgbaArray[2]);

      // denormalize
      function denormalize(array) {
        return map(array, function(item) {
          return item * 255;
        });
      }
      rgbArray = denormalize(rgbArray);

      return 'rgb(' + rgbArray[0] + ',' + rgbArray[1] + ',' + rgbArray[2] + ')';
    },
    // rgba string to array
    rgbaToArray: function(rgbaColor) {
      var rgbaArray = rgbaColor.split(",");
      rgbaArray[0] = rgbaArray[0].substr(rgbaArray[0].indexOf('(') + 1); // from " rgb( XYZ " to " XYZ "
      rgbaArray[3] = rgbaArray[3].substr(0, rgbaArray[3].indexOf(')')); // from " XYZ ) " to "  XYZ "
      rgbaArray = map(rgbaArray, function(value) {
        return parseInt(value.trim(), 10);
      });
      return rgbaArray;
    },
    // eg from 'red' to 'rgb(255,0,0)'
    // Note: not super efficient, rely on getComputedStyle (IE9+)
    colorWordToRgb: function(colorWord) {
      // node version
      if (typeof require !== 'undefined') {
        var convert = require('color-convert');
        var rgbArray = convert.keyword.rgb(colorWord);
        return rgbArray && 'rgb(' + rgbArray.join(',') + ')';
      }
      var div = document.createElement('div');
      div.style.color = colorWord;
      div.style.display = 'none';
      document.body.appendChild(div);
      var rgbColor = window.getComputedStyle(div).color;
      if (!div.style.color) {
        // invalid color, computed style will inherit the parent
        // which will provide value that is not meant, return empty
        return '';
      }
      document.body.removeChild(div);
      return rgbColor;
    },
    // accepts string (eg rgb(255,255,255)) or array (eg [255,255,255])
    rgbToHex: function(rgb) {
      function componentToHex(c) {
        var hex = c.toString(16);
        return hex.length == 1 ? '0' + hex : hex;
      }
      var rgbArray = (typeof rgb == 'string') ? exportStatics.rgbToArray(rgb) : rgb;
      return '#' + componentToHex(rgbArray[0]) + componentToHex(rgbArray[1]) +
        componentToHex(rgbArray[2]);
    },
    // rgb string to array
    rgbToArray: function(rgbColor) {
      var rgbArray = rgbColor.split(',');
      rgbArray[0] = rgbArray[0].substr(rgbArray[0].indexOf('(') + 1); // from " rgb( XYZ " to " XYZ "
      rgbArray[2] = rgbArray[2].substr(0, rgbArray[2].indexOf(')')); // from " XYZ ) " to "  XYZ "
      rgbArray = map(rgbArray, function(value) {
        return parseInt(value.trim(), 10);
      });
      return rgbArray;
    },

    // hex (eg #fff to rgb(255, 255, 255))
    hexToRgb: function(hex) {
      // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
      var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, function(m, r, g, b) {
        return r + r + g + g + b + b;
      });

      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

      return result ? [
        parseInt(result[1], 16),
        parseInt(result[2], 16),
        parseInt(result[3], 16)
      ] : null;
    },

    removeBlanksFromImage: function(img) {
      var canvas = document.createElement('canvas');
      var imgWidth = img.width;
      var imgHeight = img.height;

      canvas.setAttribute('width', imgWidth);
      canvas.setAttribute('height', imgHeight);
      var context = canvas.getContext('2d');
      context.drawImage(img, 0, 0);

      var croppedCanvas = document.createElement('canvas');
      var rect =
        exportStatics.extractNoBlankRectFromCanvas(canvas, imgWidth, imgHeight);
      croppedCanvas.setAttribute('width', rect.width);

      croppedCanvas.setAttribute('height', rect.height);

      return exportStatics.cropCanvas(
        canvas, croppedCanvas, rect.top, rect.bottom, rect.left, rect.right,
        rect.width, rect.height
      );
    },
    // CLIENT SIDE ONLY!
    extractNoBlankRectFromCanvas: function(canvas, imgWidth, imgHeight) {
      var context = canvas.getContext('2d');

      var imageData = context.getImageData(0, 0, imgWidth, imgHeight);
      var data = imageData.data;
      var getRBG = function(x, y) {
        var offset = imgWidth * y + x;
        return {
          red:     data[offset * 4],
          green:   data[offset * 4 + 1],
          blue:    data[offset * 4 + 2],
          opacity: data[offset * 4 + 3]
        };
      };
      var isBlank = function(rgb) {
        // many images contain noise, as the white is not a pure #fff white
        return (rgb.red > 200 && rgb.green > 200 && rgb.blue > 200) ||
          rgb.opacity === 0;
      };
      function isPixelEqualRow(pixel, y) {
        return function(x) {
          var rgb = getRBG(x, y);
          return isEqual(pixel, rgb);
        };
      }
      function isPixelEqualColumn(pixel, x) {
        return function(y) {
          var rgb = getRBG(x, y);
          return isEqual(pixel, rgb);
        };
      }

      var scanY = function(fromTop) {
        var offset = fromTop ? 1 : -1;

        // loop through each row
        for (var y = fromTop ? 0 : imgHeight - 1; fromTop ? (y < imgHeight) : (y > -1); y += offset) {

          // loop through each column
          var firstRGB = getRBG(0, y);
          var cropLine =
            isBlank(firstRGB) &&
            range(1, imgWidth).every(isPixelEqualRow(firstRGB, y));

          if (!cropLine) return fromTop ? y : y + 1;
        }
        return null; // all image is white
      };
      var scanX = function(fromLeft, cropTop, cropBottom) {
        var offset = fromLeft ? 1 : -1;

        // loop through each column
        for (var x = fromLeft ? 0 : imgWidth - 1; fromLeft ? (x < imgWidth) : (x > -1); x += offset) {

          // loop through each row
          var firstRGB = getRBG(x, 0);
          var cropLine =
            isBlank(firstRGB) &&
            range(cropTop, cropBottom).every(isPixelEqualColumn(firstRGB, x));

          if (!cropLine) return fromLeft ? x : x + 1;
        }
        return null; // all image is white
      };

      var top = scanY(true);
      var bottom = scanY(false);
      var left = scanX(true, top, bottom);
      var right = scanX(false, top, bottom);
      var width = right - left;
      var height = bottom - top;

      return {
        top: top, bottom: bottom, left: left, right: right,
        width: width, height: height,
      };
    },

    cropCanvas: function(
      originalCanvas, croppedCanvas, top, bottom, left, right, width, height
    ) {
      croppedCanvas
        .getContext('2d')
        .drawImage(
          originalCanvas, left, top, width, height,
          0, 0, width, height
        );

      return croppedCanvas;
    },

    startsWith: function(target, search) {
      return target.indexOf(search) == 0;
    },

    trimLeft: function(target) {
      return target.replace(/^\s+/, "");
    },

    trimRight: function(target) {
      return target.replace(/\s+$/, "");
    },

    // based on http://stackoverflow.com/a/4004010
    getCookies: function() {
      var c = document.cookie,
        v = 0,
        cookies = {};
      if (document.cookie.match(/^\s*\$Version=(?:"1"|1);\s*(.*)/)) {
        c = RegExp.$1;
        v = 1;
      }
      if (v === 0) {
        map(c.split(/[,;]/), function(cookie) {
          var parts = cookie.split(/=/, 2),
            name = decodeURIComponent(exportStatics.trimLeft(parts[0])),
            value = parts.length > 1 ? decodeURIComponent(exportStatics.trimRight(parts[1])) : null;
          cookies[name] = value;
        });
      } else {
        c.match(/(?:^|\s+)([!#$%&'*+\-.0-9A-Z^`a-z|~]+)=([!#$%&'*+\-.0-9A-Z^`a-z|~]*|"(?:[\x20-\x7E\x80\xFF]|\\[\x00-\x7F])*")(?=\s*[,;]|$)/g).map(function($0, $1) {
          var name = $0,
            value = $1.charAt(0) === '"' ? $1.substr(1, -1).replace(/\\(.)/g, "$1") : $1;
          cookies[name] = value;
        });
      }
      return cookies;
    },

    getCookie: function(name) {
      var cookies = exportStatics.getCookies();
      return has(cookies, name) ? cookies[name] : '';
    },

    setCookie: function(name, value, days, domain, path) {
      var expires = '';
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toUTCString();
      }
      document.cookie = name + '=' + (value || '') +
        expires +
        (domain ? '; domain=' + domain : '') +
        (path ? '; path=' + path : '') +
        '; SameSite=None; Secure';
    },

    // based on https://stackoverflow.com/a/33366171
    clearAllCookies: function(name) {
      var cookies = document.cookie.split('; ');
      for (var c = 0; c < cookies.length; c++) {
        var cookieName = encodeURIComponent(cookies[c].split(';')[0].split('=')[0]);
        if (!name || cookieName === name) {
          document.cookie = cookieName + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/'; // no domain, root path
        }
        var d = window.location.hostname.split('.');
        while (d.length > 0) {
          var cookieBase = cookieName + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' + d.join('.') + ' ;path=';
          var p = location.pathname.split('/');
          if (!name || cookieName === name) {
            document.cookie = cookieBase + '/'; // with domain, root path
          }
          while (p.length > 0) {
            if (!name || cookieName === name) {
              document.cookie = cookieBase + p.join('/'); // with domain, with path
            }
            p.pop();
          }
          d.shift();
        }
      }
      // https://github.com/iorad/iorad/issues/9799
      if (exportStatics.getCookie(name)) {
        exportStatics.setCookie(name, '', -1, window.location.hostname, '/');
        exportStatics.setCookie(name, '', -1, '.' + window.location.hostname, '/');
        exportStatics.setCookie(name, '', -1, window.location.hostname.split('.').slice(-2).join('.'), '/');
        exportStatics.setCookie(name, '', -1, '.' + window.location.hostname.split('.').slice(-2).join('.'), '/');
      }
    },

    isCookieConsentAccepted: function (type) {
      // exception for player & help-center (library)
      if (
        window.location.pathname.startsWith('/player/') ||
        window.location.pathname.startsWith('/library/') ||
        window.location.pathname.startsWith('/help-center/')
      ) {
        return true;
      }

      var cookies = exportStatics.getCookies();
      if (cookies.cookieconsent_status_v3 === 'allow') return true;
      if (type && cookies.cookieconsent_status_v3 === 'allow-selection') {
        var allowList = (cookies.cookieconsent_status_v3_selection || '').split('|');
        var groupValue = type.split('.')[0];
        return allowList.includes(type) || allowList.includes(groupValue);
      }

      return false;
    },

    // replace all &amp;nbsp; to &nbsp;
    // replace all &amp;amp; to &amp;
    fixInfotextTitle: function(title) {
      if (!title) return title;

      return title.replace(/&amp;nbsp;/g, '&nbsp;').replace(/&amp;amp;/g, '&amp;');

      // var openTag = '<b>';
      // var closeTag = '</b>';
      // if (!title.startsWith(openTag)) return title;

      // function replaceText(text) {
      //   var firstText = openTag + text;
      //   var lastText = text + closeTag;

      //   if (title.startsWith(firstText)) {
      //     title = openTag + ' ' + title.substring(firstText.length, title.length);
      //   }

      //   if (title.endsWith(lastText)) {
      //     title = title.substring(0, title.length - lastText.length) + ' ' + closeTag;
      //   }
      // }

      // replaceText('&nbsp;');

      // replaceText('&amp;nbsp;');

      // return title;
    },

    STEP_DESCRIPTION_APP_SANITIZE_RULES,
    STEP_DESCRIPTION_SANITIZE_RULES,
    STEP_INFOTEXT_SANITIZE_RULES,
    STEP_INFOTEXT_EMBED_ALLOWED_HOSTNAMES,
    STEP_INFOTEXT_EMBED_SANITIZE_RULES,

    tutorialLayoutVisibilityOptions: [
      { key: 'is_playbar_disabled', label: 'Playbar', group: 'playbar_navigation' },
      { key: 'is_navigation_disabled', label: 'Navigation', group: 'playbar_navigation' },
      { key: 'is_progress_bar_disabled', label: 'Progress Bar', group: 'playbar_navigation' },
      { key: 'is_step_counter_disabled', label: 'Step Counter', group: 'playbar_navigation' },
      { key: 'is_sharing_disabled', label: 'Share', group: 'playbar_navigation' },
      { key: 'is_language_disabled', label: 'Language', group: 'playbar_navigation' },
      { key: 'is_fullscreen_disabled', label: 'Fullscreen', group: 'playbar_navigation' },
      { key: 'is_commenting_disabled', label: 'Comments', group: 'playbar_navigation' },
      { key: 'is_recommended_disabled', label: 'Recommended', group: 'playbar_navigation' },

      { key: 'is_cover_disabled', label: 'Cover', group: 'cover_appearance' },
      { key: 'is_logo_disabled', label: 'Logo', group: 'cover_appearance' },
      { key: 'is_favicon_disabled', label: 'Favicon', group: 'cover_appearance' },
      { key: 'is_info_disabled', label: 'Creator & Edit Date', group: 'cover_appearance' },
      { key: 'is_duration_disabled', label: 'Completion Time', group: 'cover_appearance' },
      { key: 'is_stepsnumber_disabled', label: 'Steps Number', group: 'cover_appearance' },
      { key: 'is_actionlabel_disabled', label: 'Action Label', group: 'cover_appearance' },
      { key: 'is_description_disabled', label: 'Info', group: 'cover_appearance' },

      { key: 'is_trysteps_disabled', label: 'Try', group: 'modes_outputs' },
      { key: 'is_viewsteps_disabled', label: 'Scroll', group: 'modes_outputs' },
      { key: 'is_mobilequick_disabled', label: 'Slide', group: 'modes_outputs' },
      { key: 'is_watchsteps_disabled', label: 'Watch', group: 'modes_outputs' },
      { key: 'is_quizsteps_disabled', label: 'Quiz', group: 'modes_outputs' },
      { key: 'is_live_disabled', label: 'Live', group: 'modes_outputs' },
      { key: 'is_print_portrait_disabled', label: 'PDF Portrait', group: 'modes_outputs' },
      { key: 'is_print_landscape_disabled', label: 'PDF Landscape', group: 'modes_outputs' },
      { key: 'is_print_qr_disabled', label: 'PDF QR', group: 'modes_outputs' },

      // { key: 'is_step_image_preview_disabled', label: 'Step Image Preview' },
      // { key: 'is_ask_thesquare_disabled', label: 'Ask The Square' },
    ],
    tutorialLayoutDevicesOptions: [
      {
        key: 'is_adaptive_device',
        label: 'Adaptive',
        desc: 'Player is responsive to the device it\'s being viewed on.',
        isDefault: () => true,
      },
      { key: 'is_desktop_device', label: 'Desktop', desc: 'Force the desktop player, no matter how it\'s being viewed.' },
      { key: 'is_mobile_device', label: 'Mobile', desc: 'Force the mobile player, no matter how it\'s being viewed.' },
    ],
    tutorialLayoutDefaultViewOptions: [
      {
        key: 'is_trysteps_default',
        label: 'Try',
        isDefault: (mode) => mode !== 'widget', // default to "Try It" in other modes
      },
      { key: 'is_viewsteps_default', label: 'Scroll' },
      {
        key: 'is_mobilequick_default',
        label: 'Slide',
        isDefault: (mode) => mode === 'widget', // default to "Slide It" in widget
      },
      { key: 'is_watchsteps_default', label: 'Watch' },
      { key: 'is_quizsteps_default', label: 'Quiz' },
      // { key: 'is_pdf_default', label: 'Print' },
      { key: 'is_live_default', label: 'Live' },
    ],
    tutorialLayoutScreenshotZoomOptions: [
      {
        key: 'is_adaptive_screenshot_zoom',
        label: '100%',
        isDefault: () => true,
      },
      {
        key: 'is_75_screenshot_zoom',
        label: '75%',
      },
      {
        key: 'is_half_screenshot_zoom',
        label: '50%',
      },
      {
        key: 'is_full_screenshot_zoom',
        label: '0% (full screenshot)',
      },
    ],
    tutorialLayoutStepPanelOptions: [
      {
        key: 'is_full_step_panel',
        label: 'Expanded',
        desc: 'Fully expand the instruction and dock it to the right.',
      },
      {
        key: 'is_minimized_step_panel',
        label: 'Minimized',
        desc: 'Default the instruction to the bottom right corner.',
        isDefault: () => true,
        replaceKeys: ['is_steptext_step_panel'], // Handle REMOVED option: Steptext hidden => Minimized
      },
      {
        key: 'is_steptext_step_panel',
        label: 'Only Step Text',
        desc: '',
        hidden: true, // REMOVED: keep in JS list for setting to false when selecting other options
      },
      {
        key: 'is_navbar_step_panel',
        label: 'Collapsed',
        desc: 'Collapse the instruction - allows learner to expand.',
      },
      {
        key: 'is_hidden_step_panel',
        label: 'Hidden',
        desc: 'Hide the text instructions all together.',
      },
    ],
  };

  if (typeof module === 'object') {
    module.exports = exportStatics;
  } else {
    window.iorad = window.iorad || {};
    window.iorad.base = window.iorad.base || {};
    window.iorad.base.Export = exportStatics;
  }
})();

;
iorad.base.Utils = {
  // credits to http://stackoverflow.com/a/9601429
  invertColor: function(hexTripletColor) {
    var color = hexTripletColor;
    color = color.substring(1); // remove #
    color = parseInt(color, 16); // convert to integer
    color = 0xFFFFFF ^ color; // invert three bytes
    color = color.toString(16); // convert to hex
    color = ("000000" + color).slice(-6); // pad with leading zeros
    color = "#" + color; // prepend #
    return color;
  },

  // if the hex value is less than half, meaning it is on the darker side of the spectrum,
  // it returns white, otherwise black.
  // credits to http://24ways.org/2010/calculating-color-contrast/
  // getContrast50: function(hexTripletColor) {
  //   var color = hexTripletColor;
  //   var color = color.substring(1); // remove #
  //   return (parseInt(color, 16) > 0xffffff / 2) ? '#000000' : '#ffffff';
  // },

  // lightens or darkens a color, return the hex value as string WITHOUT the starting #
  // credits to http://stackoverflow.com/a/13542669
  shadeColor: function(hexTripletColor, percent) {
    var color = hexTripletColor;
    var num = parseInt(color, 16),
      amt = Math.round(2.55 * percent),
      R = (num >> 16) + amt,
      G = (num >> 8 & 0x00FF) + amt,
      B = (num & 0x0000FF) + amt;
    return (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 + (G < 255 ? G < 1 ? 0 : G : 255) * 0x100 + (B < 255 ? B < 1 ? 0 : B : 255)).toString(16).slice(1);
  },


  // http://stackoverflow.com/questions/5560248
  shadeColorAlt: function(color, percent) {

    var R = parseInt(color.substring(1,3),16);
    var G = parseInt(color.substring(3,5),16);
    var B = parseInt(color.substring(5,7),16);

    R = parseInt(R * (100 + percent) / 100);
    G = parseInt(G * (100 + percent) / 100);
    B = parseInt(B * (100 + percent) / 100);

    R = (R<255)?R:255;
    G = (G<255)?G:255;
    B = (B<255)?B:255;

    var RR = ((R.toString(16).length==1)?"0"+R.toString(16):R.toString(16));
    var GG = ((G.toString(16).length==1)?"0"+G.toString(16):G.toString(16));
    var BB = ((B.toString(16).length==1)?"0"+B.toString(16):B.toString(16));

    return "#"+RR+GG+BB;
  },

  // return the shaded light or black color depending on what contrasts more with the given color and by using
  // the given shade percent.
  // minContrastColor: function(hexTripletColor, lightShadePercent, darkShadePercent) {
  //   if (lightShadePercent === undefined) lightShadePercent = 90; // default

  //   var lightHexTripletColor = this.shadeColor('#000000', lightShadePercent);
  //   var darkHexTripletColor = this.shadeColor('#000000', 100 - darkShadePercent);

  //   if (this.isDarkColor(hexTripletColor, lightHexTripletColor, darkHexTripletColor)) {
  //     return lightHexTripletColor;
  //   } else {
  //     return darkHexTripletColor;
  //   }
  // },

  // Note: in case color is equally dark and light, it is considered light.
  isDarkColor: function(hexTripletColor, lightHexTripletColor, darkHexTripletColor) {
    if (lightHexTripletColor === undefined) lightHexTripletColor = '#ffffff';
    if (darkHexTripletColor === undefined) darkHexTripletColor = '#000000';

    var color = parseInt(hexTripletColor.substring(1), 16); // remove # and convert to int
    var light = parseInt(lightHexTripletColor.substring(1), 16); // remove # and convert to int
    var dark = parseInt(darkHexTripletColor.substring(1), 16); // remove # and convert to int

    var lightDistance = Math.abs(color - light);
    var darkDistance = Math.abs(color - dark);

    return darkDistance < lightDistance;
  },

  // Take a canvas and a bounding box and return the most common
  // color in that box
  // based on http://stackoverflow.com/a/2541680
  mostCommonColor: function(canvas, left, top, width, height, quality) {
    // defaults
    quality = quality || 5; // only visit every 5 pixels
    left = left || 0;
    top = top || 0;
    width = width || canvas.width;
    height = height || canvas.height;

    var data = canvas.getContext('2d').getImageData(left, top, width, height);
    var length = data.data.length;
    var count = 0;
    var rgb = {r:0,g:0,b:0};
    var i = -4;
    while ( (i += quality * 4) < length ) {
        ++count;
        rgb.r += data.data[i];
        rgb.g += data.data[i+1];
        rgb.b += data.data[i+2];
    }

    // ~~ used to floor values
    rgb.r = ~~(rgb.r/count);
    rgb.g = ~~(rgb.g/count);
    rgb.b = ~~(rgb.b/count);

    return iorad.base.Export.rgbToHex([rgb.r, rgb.g, rgb.b]);
  },

  // Take a canvas and a bounding box and return the most dominant
  // color in that box
  mostDominantColor: function(canvas, left, top, width, height, quality) {
    // defaults
    quality = quality || 5; // only visit every 5 pixels
    left = left || 0;
    top = top || 0;
    width = width || canvas.width;
    height = height || canvas.height;

    var data = canvas.getContext('2d').getImageData(left, top, width, height);
    var length = data.data.length;
    var colorCounts = {};
    var i = 0;
    while (i < length) {
      var colorKey = 'c_' + data.data[i] + '_' + data.data[i + 1] + '_' + data.data[i + 2];
      if (colorCounts[colorKey]) {
        colorCounts[colorKey].count += 1;
      } else {
        colorCounts[colorKey] = {
          color: [data.data[i], data.data[i + 1], data.data[i + 2]],
          count: 1
        };
      }

      i += quality * 4;
    }

    var dominantColor = _.max(colorCounts, function(v) { return v.count; });

    return iorad.base.Export.rgbToHex(dominantColor.color);
  },

  /**
   * Only allow hex colors.
   *
   * @param color
   * @return boolean
   */
  isValidColor: function(color) {
    return iorad.base.Export.isValidColor(color);

    // //fast check for this bug: https://github.com/iorad/iorad/issues/1273
    // if (color === '#000000') {
    //   return true;
    // }

    // if (/^#[a-f0-9]+$/i.test(color) === false) {
    //   return false;
    // }

    // // credits to http://stackoverflow.com/questions/6386090/validating-css-color-names
    // var $dummy = $('<div></div>'),
    //   emptyColor = $dummy.css('color');

    // $dummy.css('color', color);
    // return emptyColor !== $dummy.css('color');
  },
  // based on http://jquery-howto.blogspot.it/2009/09/get-url-parameters-values-with-jquery.html
  // Read a page's GET URL variables and return them as an associative array.
  getUrlParameters: function(href) {
    href = href || window.location.href;

    var vars = {};
    var varEntry;

    // remove # parameters if any (selects everything before the #)
    var hashIndex = href.indexOf('#');
    if (hashIndex == -1) hashIndex = undefined;
    href = href.slice(0, hashIndex);

    var questionIndex = href.indexOf('?');
    if (questionIndex === -1) return vars;

    var queryParts = href.slice(questionIndex + 1).split('&');
    for (var i = 0; i < queryParts.length; i++) {
      varEntry = queryParts[i].split('=');
      if (varEntry[0]) {
        vars[varEntry[0]] = typeof varEntry[1] !== 'undefined' ?
          decodeURIComponent(varEntry[1])
          : ''; // e.g "foo=bar&some&other=true", here varEntry[1] of "some" is undefined but it's value is the empty string
      }
    }
    return vars;
  },

  createUrl: function(options) {
    options = options || {};

    var newBase = options.base || window.location.href.split('?')[0].split('#')[0];
    var newHash = (typeof options.hash !== 'undefined' ? options.hash : window.location.hash) || '';
    var newUrlParameters = options.urlParameters || this.getUrlParameters();

    var newPath = '';
    _.each(_.keys(newUrlParameters), _.bind(function(name) {
      var value = newUrlParameters[name];
      newPath += (newPath === '' ? '?' : '&') + name + '=' + encodeURIComponent(value);
    }, this));

    var newUrl = newBase + newPath + newHash;
    return newUrl;
  },

  shortLink: {
    possibleChars: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'], // eslint-disable-line comma-spacing
  },
  encodeShortLinkId: function(id) {
    id = parseInt(id, 10);

    let result = '';

    let temp = id;
    const possibleChars = iorad.base.Utils.shortLink.possibleChars;
    const totalNumber = possibleChars.length;
    while (temp >= totalNumber) {
      result = possibleChars[(temp % totalNumber)] + result;
      temp = Math.floor(temp / totalNumber);
    }
    result = possibleChars[(temp % totalNumber)] + result;

    return result;
  },
  decodeShortLinkId: function(encodedId) {
    let result = 0;
    const possibleChars = iorad.base.Utils.shortLink.possibleChars;
    const totalNumber = possibleChars.length;
    if (encodedId.length > 0) {
      while (encodedId) {
        const index = possibleChars.indexOf(encodedId[0]);
        const power = encodedId.length - 1;
        result += index * (Math.pow(totalNumber, power));
        encodedId = encodedId.substring(1);
      }
    }
    return result;
  },

  // we support pretty url from old stuff module=330&mt=How-to-be-awesome
  // to: /330/How-to-be-awesome so we need to pass these pattern accordingly
  getPlayerParameters: function() {
    var playerUrlRegex = /player\/(\d+)/;
    var matched = playerUrlRegex.exec(window.location.href);
    if (matched && matched.length >= 2) {
      return {
        module: matched[1]
      }
    }
    return undefined;
  },

  // e.g. if we are in 'http://www.foo.com/some/path/bar.html?a=b', return 'http://www.foo.com/some/path/'
  getDirBasePath: function() {
    var path = location.pathname; // e.g. '/some/path/bar.html', always contains at least a '/'
    var dirPath = path.substr(0, path.lastIndexOf('/') + 1); // e.g. '/some/path/some.html' -> '/some/path/'
    var origin = location.origin; // e.g. 'http://www.foo.com'

    return origin + dirPath;
  },

  // as window.location.origin but that works also on ie.
  // based on http://tosbourn.com/a-fix-for-window-location-origin-in-internet-explorer/
  // getLocationOrigin: function() {
  //   return window.location.protocol + "//" +
  //     window.location.hostname +
  //     (window.location.port ? ':' + window.location.port : '');
  // },

  deepClone: function deepClone(o) {
    if (_.isArray(o)) return _.map(o, deepClone);
    else if (_.isObject(o)) {
      return _.object(_.map(o, function(v, k) {
        return [k, deepClone(v)];
      }));
    } else return o;
  },

  // String utilities

  // based on http://stackoverflow.com/a/1145525
  // A replace all function without using regex (that have to be escaped)
  replaceAll: function(target, search, replacement) {
    if (!target) return target;
    if (replacement === undefined) replacement = '';
    return target.split(search).join(replacement);
  },

  startsWith: function(target, search) {
    return target.indexOf(search) == 0;
  },

  capitalize: function(target) {
    if (!target || typeof target !== "string") {
      return '';
    }
    return target.charAt(0).toUpperCase() + target.slice(1);
  },

  uncapitalize: function(target) {
    if (!target || typeof target !== "string") {
      return '';
    }
    return target.charAt(0).toLowerCase() + target.substr(1);
  },

  // getDuration: function(seconds) {
  //   return {
  //     hours: Math.floor(seconds / 3600),
  //     minutes: Math.floor((seconds % 3600) / 60),
  //     seconds: Math.floor(seconds % 60),
  //   };
  // },

  // http://stackoverflow.com/a/30335883
  // This code counts words that contains only alphanumeric characters and '_' char.
  countWords: function(target) {
    // Clean and match sub-strings in a string.
    function extractSubstr(str, regexp) {
      return str.replace(/[^\w\s]|_/g, '')
          .replace(/\s+/g, ' ')
          .toLowerCase().match(regexp) || [];
    }

    // Find words by searching for sequences of non-whitespace characters.
    function getWordsByNonWhiteSpace(str) {
        return extractSubstr(str, /\S+/g);
    }

    // Find words by searching for valid characters between word-boundaries.
    function getWordsByWordBoundaries(str) {
        return extractSubstr(str, /\b[a-z\d]+\b/g);
    }

    return getWordsByWordBoundaries(target).length;
  },

  // Some promise utilities

  // credits https://github.com/mtimofiiv/promise-hash/blob/master/lib/promise-hash.js
  promiseHash: function(hashOfPromises) {
    var keys = Object.keys(hashOfPromises);
    return Promise.all(keys.map(function(key) {
      return hashOfPromises[key];
    })).then(function(list) {
      return list.reduce(function(hashOfResolved, value, i) {
        hashOfResolved[keys[i]] = value;
        return hashOfResolved;
      }, {});
    });
  },

  promiseDefer: function() {
    var defer = {};
    var promise = new Promise(function(resolve, reject) {
      defer.resolve = resolve;
      defer.reject = reject;
    });
    defer.promise = promise;
    return defer;
  },

  promiseAllSettled: function(array) {
    return Promise.all(array.map(function(item) {
      return Promise.resolve(item)
        .then(function(value) {
          return { status: 'fulfilled', value: value };
        }, function(reason) {
          return { status: 'rejected', reason: reason };
        });
    }));
  },

  // A promise that resolves after the set number of ms
  delay: function(ms) {
    return new Promise(function(resolve) {
      setTimeout(function() {
        resolve();
      }, ms);
    });
  },
  setTimeoutPromise: function(delayTime) {
    var timeout = {delayTime: delayTime, finished: false};
    timeout.cancel = function() {
      clearTimeout(timeout.timeoutId);
    };
    timeout.pause = function() {
      timeout.cancel();
      timeout.resumeTime = timeout.delayTime - (Date.now() - timeout.resumeStartTime);
    };
    var promise = new Promise(function(resolve) {
      timeout.resumeStartTime = Date.now();
      timeout.resumeTime = timeout.delayTime;
      timeout.resume = function(customResumeTime, callback) {
        if (timeout.finished) return;
        if (customResumeTime) timeout.resumeTime = customResumeTime;
        timeout.timeoutId = setTimeout(function() {
          timeout.finished = true;
          if (callback) {
            callback();
          }
          resolve();
        }, timeout.resumeTime);
      };
      timeout.resume();
    });
    timeout.promise = promise;
    return timeout;
  },

  // Take a promise and return another promise that passes on the
  // first's return if it completes in a given time otherwise raises a
  // timeout error
  timeout: function(promise, timeoutMs) {
    return new Promise(function(resolve, reject) {
      var timedOut = false;
      promise
        .then(function(value) {
          if (!timedOut) {
            clearTimeout(timeoutId);
            resolve(value);
          }
        })
        .catch(function(error) {
          if (!timedOut) {
            clearTimeout(timeoutId);
            reject(error);
          }
        });
      var timeoutId = setTimeout(function() {
        timedOut = true;
        reject(new Error('Timeout!'));
      }, timeoutMs);
    });
  },

  // NOTE: this is "leading: false" and "trailing: true".
  debounce: function (handle, ms) {
    let lastThis;
    let lastArgs;
    let timer;
    const fn = function (...args) {
      lastThis = this;
      lastArgs = args;
      if (typeof timer !== 'undefined') {
        clearTimeout(timer);
        timer = undefined;
      }
      timer = setTimeout(() => {
        timer = undefined;
        handle.apply(lastThis, lastArgs);
      }, ms);
    };
    fn.cancel = function () {
      if (typeof timer !== 'undefined') {
        clearTimeout(timer);
        timer = undefined;
      }
    };
    fn.flush = function () {
      if (typeof timer !== 'undefined') {
        clearTimeout(timer);
        timer = undefined;
        handle.apply(lastThis, lastArgs);
      }
    };
    return fn;
  },

  /**
   * Clones a canvas to a new blank canvas with old canvas image content.
   *
   * @param oldCanvas the old canvas
   * @returns {*} new cloned canvas
   */
  cloneCanvas: function(oldCanvas) {
    var newCanvas = document.createElement('canvas'),
      newContext = newCanvas.getContext('2d');

    newCanvas.width = oldCanvas.width;
    newCanvas.height = oldCanvas.height;

    newContext.drawImage(oldCanvas, 0, 0);

    return newCanvas;
  },

  // credits http://stackoverflow.com/a/13382873
  // Note: the function return value is cached to speed up computation
  // getScrollbarWidth: _.memoize(function() {
  //   var outer = document.createElement("div");
  //   outer.style.visibility = "hidden";
  //   outer.style.width = "100px";
  //   outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps
  //   document.body.appendChild(outer);

  //   var widthNoScroll = outer.offsetWidth;
  //   // force scrollbars
  //   outer.style.overflow = "scroll";

  //   // add innerdiv
  //   var inner = document.createElement("div");
  //   inner.style.width = "100%";
  //   outer.appendChild(inner);

  //   var widthWithScroll = inner.offsetWidth;

  //   // remove divs
  //   outer.parentNode.removeChild(outer);

  //   return widthNoScroll - widthWithScroll;
  // }),

  // supported options: useCSSForEl
  getElementBounds: function($el, options) {
    options = options || {};

    var elBounds;
    if (options.useCSSForEl) {
      elBounds = {
        top: parseInt($el.css('top'), 10),
        left: parseInt($el.css('left'), 10),
        width: parseInt($el.css('width'), 10),
        height: parseInt($el.css('height'), 10)
      }
    } else {
      var elPosition;
      if (options.relativeElement) {
        var relativeOffset = options.relativeElement.offset();
        var targetOffset = $el.offset();
        elPosition = {
          top: targetOffset.top - relativeOffset.top,
          left: targetOffset.left - targetOffset.left,
        }
      } else {
        elPosition = $el.position();
      }
      elBounds = {
        top: elPosition.top,
        left: elPosition.left,
        width: $el.width(),
        height: $el.height()
      };
    }
    elBounds['bottom'] = elBounds.top + elBounds.height;
    elBounds['right'] = elBounds.left + elBounds.width;

    return elBounds;
  },

  // supported options: useCSSForEl, useCSSForContainer, useWeakCheck
  // Note: $container is the element viewport (without scrollbars)
  isIntoView: function($el, $container, options) {
    options = options || {};

    var $scrollableElement = options.scrollableElement || $container;

    var elBounds = this.getElementBounds($el, {
        useCSSForEl: options.useCSSForEl,
        relativeElement: $container
      }),
      containerBounds = this.getElementBounds($container, {
        useCSSForEl: options.useCSSForContainer
      });
    var containerScrollTop = $scrollableElement.scrollTop(),
      containerScrollLeft = $scrollableElement.scrollLeft(),
      containerScrollBottom = containerScrollTop + containerBounds.height,
      containerScrollRight = containerScrollLeft + containerBounds.width;

    if (options.weakCheck) {
      // uses weaker but more effective form of check:
      // the element is into view if at least one of its corners is into view (instead that all of them).
      var isTopIntoView = elBounds.top >= containerScrollTop && elBounds.top <= containerScrollBottom,
        isLeftIntoView = elBounds.left >= containerScrollLeft && elBounds.left <= containerScrollRight,
        isRightIntoView = elBounds.right <= containerScrollRight && elBounds.right >= containerScrollLeft,
        isBottomIntoView = elBounds.bottom <= containerScrollBottom && elBounds.bottom >= containerScrollTop;

      return (isTopIntoView && isLeftIntoView) || // top left
        (isTopIntoView && isRightIntoView) || // top right
        (isBottomIntoView && isLeftIntoView) || // bottom left
        (isBottomIntoView && isRightIntoView) // bottom right
    }

    // standard check
    return elBounds.top >= containerScrollTop &&
      elBounds.left >= containerScrollLeft &&
      elBounds.top + elBounds.height <= containerScrollBottom &&
      elBounds.left + elBounds.width <= containerScrollRight;
  },

  // supported options: useCSSForEl
  // Note: $container is the scrollable element
  makeIntoView: function($el, $container, margin, options) {
    options = options || {};
    margin = margin || 0;

    var elBounds = this.getElementBounds($el, {
      useCSSForEl: options.useCSSForEl
    });

    var marginVertical = margin;
    var marginHorizontal = margin;
    if (options.marginCenter) {
      marginVertical = ($container.height() / 2) - (elBounds.height / 2);
      marginHorizontal = ($container.width() / 2) - (elBounds.width / 2);
    }

    $container.scrollTop(elBounds.top - marginVertical);
    $container.scrollLeft(elBounds.left - marginHorizontal);
  },

  // check if the tab/document is currently visible
  // (uses the Visibility API in a cross-browser way)
  isDocumentHidden: function() {
    return _.some(['hidden', 'mozHidden', 'msHidden', 'webkitHidden'], function(hidden) {
      return (document[hidden] === true);
    });
  },

  /**
   * Converts serverTime to userLocalTime with assumption that
   * serverTime has `MMM DD, YYYY h:m A` format with UTC timezone
   *
   * @param serverTime
   */
  toLocalTime: function(serverTime) {
    serverTime += ' UTC';
    var serverDate = new Date(serverTime);
    var localFormat = { month: 'short', day: 'numeric', year: 'numeric'};

    return serverDate.toLocaleDateString('en-US', localFormat);
  },

  //api processing for iorad.js to create/edit tutorials
  getParentDomain: function() {
    // bug: https://github.com/iorad/iorad/issues/2733
    // bug: https://github.com/iorad/iorad/issues/2735
    //if (referrerURL) {
    //  return referrerURL;
    //}
    //try {
    //  return (window.location != window.parent.location) ? document.referrer : document.location.origin;
    //} catch (e) {
    //  return '*';
    //}
    return '*';
  },
  /**
   * Extracts tutorial params from provided player url.
   *
   * @param playerUrl
   *
   * @return object with base_url, tutorialId, tutorialTitle
   */
  extractTutorialParams: function(playerUrl) {
    var splits = playerUrl.split('/'),
      len = splits.length;

    return {
      base_url: splits[len - 3],
      tutorialId: splits[len - 2],
      tutorialTitle: splits[len - 1]
    };
  },

  /**
   * Checks if iorad pages are embedded (within an iframe)
   */
  isEmbedded: function() {
    var isEmbedded = false;
    try {
      isEmbedded = siteWindow.top !== siteWindow;
    } catch (err) {
      // embedded with cross-origin restrictions
      isEmbedded = true;
    }
    return isEmbedded;
  },

  // see http://stackoverflow.com/a/8809891
  getBackgroundImageUrl: function(element) {
    var el = $(element);

    var backgroundImage = el.css('background-image');

    // ^ Either "none" or url("...urlhere..")
    var urlMatches = /^url\((['"]?)(.*)\1\)$/.exec(backgroundImage);
    var url = urlMatches ? urlMatches[2] : ""; // If matched, retrieve url, otherwise ""

    return url;
  },

  // Note: url must respect same-origin policy!
  getUrlImageData: function(imageUrl, disableCORS) {
    var me = this;
    return new Promise(function(resolve, reject) {
      // load image
      var image = document.createElement("img");
      // Don't try and do CORs on a data url or file://, they get angry ;)
      var isFileImg = iorad.base.Utils.isFileProtocolURL(imageUrl);
      if (!disableCORS && imageUrl.split(':')[0] !== "data" && !isFileImg) {
        image.crossOrigin = "Anonymous";
      }
      image.onload = _.partial(resolve, image);
      image.onerror = reject;
      image.src = imageUrl;
    }).then(function(image) {
      // get image data-uri

      var canvas = document.createElement("canvas");
      if (image.width > 0) canvas.width = image.width;
      if (image.height > 0) canvas.height = image.height;

      var ctx = canvas.getContext("2d");
      ctx.drawImage(image, 0, 0);
      return canvas.toDataURL("image/png");
    });
  },

  cropCanvas: function(canvas, cropBounds) {
    var croppedCanvas = document.createElement("canvas");
    croppedCanvas.width = cropBounds.width;
    croppedCanvas.height = cropBounds.height;

    var ctx = croppedCanvas.getContext("2d");
    ctx.drawImage(canvas, cropBounds.left, cropBounds.top,
      cropBounds.width, cropBounds.height,
      0, 0, croppedCanvas.width, croppedCanvas.height);
    return croppedCanvas;
  },

  stripHtmlTags: function(html, sanitizeRules) {
    var div = document.createElement('div');
    div.innerHTML = sanitizeHtml(html, sanitizeRules);
    return div.innerText || div.textContent;
  },

  // credits http://stackoverflow.com/a/22648406
  isURL: function(str) {
     var urlRegex = '^(?:(?:http|https)://)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$';
     var url = new RegExp(urlRegex, 'i');
     return str.length < 2083 && url.test(str);
  },

  /**
   * Animates height changing
   *
   * @param $el element which height is changing
   * @param changeHeight function that will change $el's height
   * @returns promise that resolves when animation is done
   */
  animateHeight: function($el, changeHeight) {
    var oldHeight = $el.height();
    changeHeight();
    var newHeight = $el.height();
    $el.height(oldHeight);
    return new Promise(function(resolve) {
      $el.animate({height: newHeight}, 'fast', function() {
        $el.height('auto');
        resolve();
      });
    });
  },

  isFileProtocolURL: function(url) {
    if (!url) return false;
    if (url.startsWith('file://')) return true;
    if (
      window.location.href.startsWith('file://') &&
      !url.startsWith('https://') &&
      !url.startsWith('http://') &&
      !url.split(':')[0] !== 'data'
    ) {
      var a = document.createElement('a');
      a.href = url;
      var absoluteURL = a.href;
      return absoluteURL.startsWith('file://');
    }

    return false;
  },

  loadImage: function(url, disableCORS) {
    return new Promise(function(resolve, reject) {
      var image = new Image();
      image.onload = function () {
        resolve(image);
      };
      image.onerror = function () {
        console.error('Cannot load image ' + url);
        reject('Cannot load image');
      };
      if (!iorad.base.Utils.isFileProtocolURL(url) && !disableCORS) {
        image.crossOrigin = "Anonymous";
      }
      image.src = url;
    });
  },

  isCustomTheme: function(id) {
    return id != null && !isNaN(id) && parseInt(id, 10) > 0;
  },

  // emailToDomain: function(email) {
  //   var start = Math.min(email.length, email.indexOf('@') + 1);
  //   return email.substr(start);
  // },

  // Also works on Safari
  // http://stackoverflow.com/a/5100158/1418049
  dataURItoBlob: function(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var arr = dataURI.split(',');
    var byteString;
    if (arr[0].indexOf('base64') >= 0)
        byteString = atob(arr[1]);
    else
        byteString = unescape(arr[1]);

    // separate out the mime component
    var mimeString = arr[0].split(':')[1].split(';')[0];

    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], {type:mimeString});
  },

  getExtensionAttribute: function(attr) {
    var namespacedAttr = 'data-iorad-extension' + (typeof attr !== 'undefined' ? '-' + attr : '');
    var value = siteWindow.document.documentElement.getAttribute(namespacedAttr); // newer versions
    if (value === null) {
      value = siteWindow.document.body.getAttribute(namespacedAttr); // older versions
    }
    return value;
  },
  // NOTE: make sure to call this only after the content script has loaded
  getChromeExtensionId: function() {
    var build = iorad.base.Utils.getExtensionAttribute('build') || 'standard';
    return iorad.base.Settings.get(
      'capture.extension.chrome.builds.' + build + '.id'
    );
  },
  isExtensionContentScriptLoaded: function() {
    var extensionAttribute = iorad.base.Utils.getExtensionAttribute('content-loaded');
    return Boolean(extensionAttribute);
  },
  waitForContentScript: function() {
    return new Promise(function(resolve) {
      function check() {
        if (iorad.base.Utils.isExtensionContentScriptLoaded()) {
          resolve();
          return;
        }
        setTimeout(check, 100);
      }
      check();
    });
  },
  waitForExtensionMessaging: function(data = {}) {
    return new Promise(function (resolve, reject) {
      var interval;
      siteWindow.addEventListener('message', function onMessage(event) {
        try {
          var message = event.data;
          if (typeof message !== 'object' || message === null) return;
          if (message.from !== 'iorad-extension' || message.to !== 'page') return;

          if (message.topic === 'pong') {
            siteWindow.removeEventListener('message', onMessage);
            if (typeof interval !== 'undefined') {
              clearInterval(interval);
              interval = undefined;
            }
            resolve();
          }
        } catch (err) {
          reject(err);
        }
      });
      function sendPing() {
        try {
          siteWindow.postMessage({
            topic: 'ping',
            from: 'page',
            to: 'iorad-extension',
            data
          }, '*');
        } catch (err) {
          reject(err);
        }
      }
      interval = setInterval(sendPing, 500);
      sendPing();
    });
  },

  // very simple get implementation
  // Note: path doesn't support [i] syntax, just use i directly,
  // e.g: step.1.index
  get: function(obj, path) {
    if (!obj) return undefined;
    var pathParts = path.split('.');

    var currentObj = obj;
    for (var i = 0; i < pathParts.length - 1; i++) {
      var currentProp = pathParts[i];
      currentObj = currentObj[currentProp];
      if (!currentObj) return undefined;
    }
    var lastProp = pathParts[pathParts.length - 1];
    return currentObj[lastProp];
  },

  // very simple set implementation
  // Note: path doesn't support [i] syntax, just use i directly,
  // e.g: step.1.index
  set: function(obj, path, value) {
    if (!obj) return obj;
    var pathParts = path.split('.');

    var parentObj = null;
    var currentObj = obj;
    for (var i = 0; i < pathParts.length - 1; i++) {
      var currentProp = pathParts[i];
      parentObj = currentObj;
      currentObj = currentObj[currentProp];
      if (!currentObj) {
        currentObj = parentObj[currentProp] = {};
      }
    }
    var lastProp = pathParts[pathParts.length - 1];
    currentObj[lastProp] = value;

    return obj;
  },

  areColorsEqual: function(colorA, colorB) {
    return (iorad.base.Export.colorToHex6(colorA) || '').toLowerCase() === (iorad.base.Export.colorToHex6(colorB) || '').toLowerCase();
  },

  getUrlMaskedCanvas: function(imgUrl, mask, maskColorHex) {
    return iorad.base.Utils.loadImage(imgUrl)
      .then(function(img) {
        var $canvas = $('<canvas>');
        var canvas = $canvas[0];
        var imgWidth = img.width;
        var imgHeight = img.height;
        $canvas.attr({ width: imgWidth, height: imgHeight });
        var context = canvas.getContext('2d');
        context.drawImage(img, 0, 0, imgWidth, imgHeight);
        var maskRgb = iorad.base.Export.hexToRgb(maskColorHex || '#000000');
        var maskColor = 'rgba(' + maskRgb.join(', ') + ', ' + mask / 100 + ')';

        context.beginPath();
        context.fillStyle = maskColor;
        context.rect(0, 0, imgWidth, imgHeight);
        context.fill();

        return canvas;
      });
  },

  // for contrast purpose
  isImageDark: function(imgUrl, mask, maskType) {
    return iorad.base.Utils.getUrlMaskedCanvas(imgUrl, mask, maskType)
      .then(function(canvas) {
        var imageData = canvas.getContext('2d').getImageData(0, 0, canvas.width, canvas.height);

        // examine every pixel
        var darkometer = 0;
        var transparentPixels = 0;
        for (var i = 0; i < imageData.data.length; i += 4) {
          var r = imageData.data[i];
          var g = imageData.data[i + 1];
          var b = imageData.data[i + 2];
          var a = imageData.data[i + 3];

          if (a === 0) {
            transparentPixels = transparentPixels + 1;
            continue;
          }

          if (((r * 299 + g * 587 + b * 114) / 1000) < 128) {
            darkometer = darkometer + 1;
          }
        }

        // more than half pixels are dark
        var isImageDark =
          darkometer > (imageData.data.length / 8 - transparentPixels / 2);
        return isImageDark;
      });
  },

  // Detect which browser prefix to use for the specified CSS value
  // (e.g., background-image: -moz-linear-gradient(...);
  //        background-image:   -o-linear-gradient(...); etc).
  // credits https://stackoverflow.com/a/43190173/1418049
  getCssValuePrefix: function() {
    var prefixes = ['-o-', '-ms-', '-moz-', '-webkit-'];

    // Create a temporary DOM object for testing
    var dom = document.createElement('div');
    for (var i = 0; i < prefixes.length; i++) {
      // Attempt to set the style
      dom.style.background = prefixes[i] + 'linear-gradient(#000000, #ffffff)';

      // Detect if the style was successfully set
      if (dom.style.background) {
        return prefixes[i];
      }
    }

    return ''; // default to standard syntax
  },

  escapeRegExp: function(target) {
    return target.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
  },

  isYoutubeUrl: function(url) {
    const newUrl = new URL(url);

    return ['www.youtube.com', 'youtube.com', 'youtu.be'].indexOf((newUrl).hostname) > -1;
  },

  isVimeoUrl: function(url) {
    const newUrl = new URL(url);

    return ['player.vimeo.com', 'vimeo.com'].indexOf((newUrl).hostname) > -1;
  },

  isGoogleDocsUrl: function(url) {
    const newUrl = new URL(url);

    return ['docs.google.com'].indexOf((newUrl).hostname) > -1;
  },

  // https://docs.wistia.com/docs/construct-a-wistia-embed-code#the-regex
  isWistiaUrl: function(url) {
    const newUrl = new URL(url);
    return ['wistia.com', 'wi.st'].some((hostname) => (newUrl.hostname || '').endsWith('.' + hostname));
  },

  accessibilityFocus: function($el) {
    if (!$el.length) return;
    const el = $el[0];
    try {
      const firstButtonRole = el && (el.querySelector('button') || el.querySelector('[role="button"]'));
      console.log('accessibilityFocus', firstButtonRole, el);
      if (el.getAttribute('role') === 'button' || el.tagName === 'BUTTON') {
        el.focus();
      } else if (firstButtonRole) {
        firstButtonRole.focus();
      } else {
        el.focus();
      }
    } catch (err) {
      console.error(err);
    }
  },

  accessibilityFocusBack: function($el) {
    let triggeredId = $el;
    if (typeof $el !== 'string') {
      triggeredId = $el.attr('id');
    }
    iorad.base.Utils.accessibilityFocus($('[aria-controls="' + triggeredId + '"]'));
  },

  accessibilityButtonOnKeyPress: function(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      event.target.click();
    }
  },

  getPlayerModeIcon: function (id, { size } = {}) {
    const html = window.litHTML.html;
    const modeIcons = {
      try: {
        L: html`
          <svg width="70" height="50" viewBox="0 0 70 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="1" width="68" height="48" stroke="black" stroke-width="1.6" stroke-linejoin="bevel"/>
            <path d="M46.8 49L46.8 33L69 33" stroke="black" stroke-width="1.6" stroke-linejoin="bevel"/>
            <rect x="46" y="45" width="22.6667" height="4" fill="black"/>
            <path d="M34.2387 22.6587L32.1719 23.5263L35.6424 31.7934L37.7092 30.9258L34.2387 22.6587Z" fill="black"/>
            <path d="M30.1207 15.6897V28.2414L33.4828 24.9914L33.9311 24.8794H39.3104L30.1207 15.6897Z" fill="black"/>
          </svg>
        `,
        M: html`
          <svg width="34" height="24" viewBox="0 0 34 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1H33V23H1V1Z" stroke="black" stroke-width="1.6" stroke-linejoin="bevel"/>
            <path d="M23 20H24H33V23H23V20Z" fill="black"/>
            <path d="M17.082 10.6825L15.8661 11.193L17.9079 16.0568L19.1239 15.5463L17.082 10.6825Z" fill="black"/>
            <path d="M14.6593 6.58246V13.9671L16.6373 12.055L16.9011 11.989H20.0659L14.6593 6.58246Z" fill="black"/>
          </svg>
        `,
        S: html`
          <svg width="26" height="18" viewBox="0 0 26 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1H25V17H1V1Z" stroke="black" stroke-width="1.6" stroke-linejoin="bevel"/>
            <path d="M15 15H16H25V17H15V15Z" fill="black"/>
            <path d="M12.4227 8.10007L11.2068 8.61053L13.2486 13.4743L14.4646 12.9639L12.4227 8.10007Z" fill="black"/>
            <path d="M10 4V11.3846L11.978 9.47251L12.2418 9.40658H15.4066L10 4Z" fill="black"/>
          </svg>
        `,
      },
      view: {
        L: html`
          <svg width="70" height="50" viewBox="0 0 70 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="1" width="68" height="48" stroke="black" stroke-width="1.6" stroke-linejoin="bevel"/>
            <line x1="69" y1="24.8" x2="1" y2="24.8" stroke="black" stroke-width="1.6"/>
            <rect x="69" y="1" width="23" height="4" transform="rotate(90 69 1)" fill="black"/>
            <rect x="1" y="45" width="68" height="4" fill="black"/>
          </svg>
        `,
        M: html`
          <svg width="34" height="24" viewBox="0 0 34 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1H33V23H1V1Z" stroke="black" stroke-width="1.6" stroke-linejoin="bevel"/>
            <rect x="1" y="20" width="32" height="3" fill="black"/>
            <rect x="33" y="1.5" width="10" height="3" transform="rotate(90 33 1.5)" fill="black"/>
            <line x1="1" y1="12.2" x2="33" y2="12.2" stroke="black" stroke-width="1.6"/>
          </svg>
        `,
        S: html`
          <svg width="26" height="18" viewBox="0 0 26 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1H25V17H1V1Z" stroke="black" stroke-width="1.6" stroke-linejoin="bevel"/>
            <rect x="1" y="15" width="24" height="2" fill="black"/>
            <rect x="25" y="1.13635" width="8" height="3" transform="rotate(90 25 1.13635)" fill="black"/>
            <line x1="1" y1="9.33635" x2="25" y2="9.33635" stroke="black" stroke-width="1.6"/>
          </svg>
        `,
      },
      slide: {
        L: html`
          <svg width="70" height="50" viewBox="0 0 70 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="1" width="68" height="48" stroke="black" stroke-width="1.6" stroke-linejoin="bevel"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M53.5657 30.5657L52.4343 29.4343L57.8686 24L52.4343 18.5657L53.5657 17.4343L60.1314 24L53.5657 30.5657Z" fill="black"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.4343 17.4343L19.5657 18.5657L14.1314 24L19.5657 29.4343L18.4343 30.5657L11.8686 24L18.4343 17.4343Z" fill="black"/>
            <rect x="1" y="45" width="68" height="4" fill="black"/>
          </svg>
        `,
        M: html`
          <svg width="34" height="26" viewBox="0 0 34 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1H33V25H1V1Z" stroke="black" stroke-width="1.6" stroke-linejoin="bevel"/>
            <path d="M11 8L7 12L11 16" stroke="black" stroke-width="1.6"/>
            <path d="M23 16L27 12L23 8" stroke="black" stroke-width="1.6"/>
            <rect x="1" y="22" width="32" height="3" fill="black"/>
          </svg>
        `,
        S: html`
          <svg width="26" height="18" viewBox="0 0 26 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1H25V17H1V1Z" stroke="black" stroke-width="1.6" stroke-linejoin="bevel"/>
            <path d="M9 5L8 6L6 8L8 10L9 11" stroke="black" stroke-width="1.6"/>
            <path d="M17 5L18 6L20 8L18 10L17 11" stroke="black" stroke-width="1.6"/>
            <rect x="1" y="15" width="24" height="2" fill="black"/>
          </svg>
        `,
      },
      watch: {
        L: html`
          <svg width="70" height="50" viewBox="0 0 70 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="1" width="68" height="48" stroke="black" stroke-width="1.6" stroke-linejoin="bevel"/>
            <rect x="1" y="45" width="68" height="4" fill="black"/>
            <g clip-path="url(#clip0_787_2112)">
            <path d="M43 24L29 32L29 16L43 24Z" fill="black"/>
            </g>
            <defs>
            <clipPath id="clip0_787_2112">
            <rect width="14" height="16" fill="white" transform="translate(29 16)"/>
            </clipPath>
            </defs>
          </svg>
        `,
        M: html`
          <svg width="34" height="24" viewBox="0 0 34 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1H33V23H1V1Z" stroke="black" stroke-width="1.6" stroke-linejoin="bevel"/>
            <rect x="1" y="20" width="32" height="3" fill="black"/>
            <path d="M14 7L22 11.3505L14.0384 16L14 7Z" fill="black"/>
          </svg>
        `,
        S: html`
          <svg width="26" height="18" viewBox="0 0 26 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1H25V17H1V1Z" stroke="black" stroke-width="1.6" stroke-linejoin="bevel"/>
            <rect x="1" y="14.8636" width="24" height="2" fill="black"/>
            <path d="M10 4.86365L17 8.73078L10.0336 12.8636L10 4.86365Z" fill="black"/>
          </svg>
        `,
      },
      quiz: {
        L: html`
          <svg width="70" height="50" viewBox="0 0 70 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="1" width="68" height="48" stroke="black" stroke-width="1.6" stroke-linejoin="bevel"/>
            <path d="M46.8 49L46.8 33L69 33" stroke="black" stroke-width="1.6" stroke-linejoin="bevel"/>
            <rect x="46" y="45" width="22.6667" height="4" fill="black"/>
            <path d="M39.6003 24.7H35.0003M36.5002 16.5H33.5002M35.0002 18.5V16.5M41.7131 18.7986L40.2876 20.2014M30.4255 20.2014L29 18.7986M35.0002 20.5V25.5M41.5002 24.5C41.5002 27.8137 38.8139 30.5 35.5002 30.5C32.1865 30.5 29.5002 27.8137 29.5002 24.5C29.5002 21.1863 32.1865 18.5 35.5002 18.5C38.8139 18.5 41.5002 21.1863 41.5002 24.5Z" stroke="black" stroke-width="1.6"/>
          </svg>
        `,
        M: html`
          <svg width="34" height="26" viewBox="0 0 34 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 0.863647H33V24.8636H1V0.863647Z" stroke="black" stroke-width="1.6" stroke-linejoin="bevel"/>
            <path d="M23 21.8636H24H33V24.8636H23V21.8636Z" fill="black"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M16.043 8.62448C15.377 8.79383 14.7704 9.11143 14.2576 9.54L13.6344 8.91348L12.5 10.0418L13.2217 10.7674C12.8149 11.4645 12.582 12.2776 12.582 13.1429C12.582 15.6987 14.6145 17.8 17.1576 17.8C19.7007 17.8 21.7332 15.6987 21.7332 13.1429C21.7332 12.2304 21.4742 11.3759 21.0253 10.6542L21.6344 10.0418L20.5 8.91349L19.9576 9.45878C19.3055 8.94405 18.5118 8.60443 17.643 8.5115V8H16.043V8.62448ZM17.1576 10.0857C15.5302 10.0857 14.182 11.4383 14.182 13.1429C14.182 14.8475 15.5302 16.2 17.1576 16.2C18.785 16.2 20.1332 14.8475 20.1332 13.1429C20.1332 11.4383 18.785 10.0857 17.1576 10.0857ZM16.5672 11H17.643V12.7H19.0672L19.0672 13.5H16.5672L16.5672 11Z" fill="black"/>
          </svg>
        `,
        S: html`
          <svg width="26" height="18" viewBox="0 0 26 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 0.863647H25V16.8636H1V0.863647Z" stroke="black" stroke-width="1.6" stroke-linejoin="bevel"/>
            <path d="M15 14.8636H16H25V16.8636H15V14.8636Z" fill="black"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.043 4.62448C11.377 4.79383 10.7704 5.11143 10.2576 5.54L9.6344 4.91348L8.5 6.04181L9.22168 6.76737C8.81488 7.46452 8.58195 8.27764 8.58195 9.14286C8.58195 11.6987 10.6145 13.8 13.1576 13.8C15.7007 13.8 17.7332 11.6987 17.7332 9.14286C17.7332 8.23038 17.4742 7.37585 17.0253 6.65419L17.6344 6.04183L16.5 4.91349L15.9576 5.45878C15.3055 4.94405 14.5118 4.60443 13.643 4.5115V4H12.043V4.62448ZM13.1576 6.08571C11.5302 6.08571 10.182 7.43825 10.182 9.14286C10.182 10.8475 11.5302 12.2 13.1576 12.2C14.785 12.2 16.1332 10.8475 16.1332 9.14286C16.1332 7.43825 14.785 6.08571 13.1576 6.08571ZM12.5672 7H13.643V8.7H15.0672L15.0672 9.5H12.5672L12.5672 7Z" fill="black"/>
          </svg>
        `,
      },
      live: {
        L: html`
          <svg width="70" height="50" viewBox="0 0 70 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="1" width="68" height="48" stroke="black" stroke-width="1.6" stroke-linejoin="bevel"/>
            <path d="M46.8 49L46.8 33L69 33" stroke="black" stroke-width="1.6" stroke-linejoin="bevel"/>
            <rect x="46" y="45" width="22.6667" height="4" fill="black"/>
            <path d="M43 16V32" stroke="black" stroke-width="1.6" stroke-linejoin="round"/>
            <path d="M40 19V29" stroke="black" stroke-width="1.6" stroke-linejoin="round"/>
            <path d="M27 32L27 16" stroke="black" stroke-width="1.6" stroke-linejoin="round"/>
            <path d="M30 29L30 19" stroke="black" stroke-width="1.6" stroke-linejoin="round"/>
            <path d="M38 24C38 22.344 36.656 21 35 21C33.344 21 32 22.344 32 24C32 25.6575 33.344 27 35 27C36.656 27 38 25.6575 38 24Z" fill="black"/>
          </svg>
        `,
        M: html`
          <svg width="34" height="26" viewBox="0 0 34 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1H33V25H1V1Z" stroke="black" stroke-width="1.6" stroke-linejoin="bevel"/>
            <rect x="23" y="21.8636" width="10" height="3" fill="black"/>
            <path d="M24 7V19" stroke="black" stroke-width="1.6" stroke-linejoin="round"/>
            <path d="M21 9V17" stroke="black" stroke-width="1.6" stroke-linejoin="round"/>
            <path d="M10 19L10 7" stroke="black" stroke-width="1.6" stroke-linejoin="round"/>
            <path d="M13 17L13 9" stroke="black" stroke-width="1.6" stroke-linejoin="round"/>
            <path d="M19 13C19 11.896 18.104 11 17 11C15.896 11 15 11.896 15 13C15 14.105 15.896 15 17 15C18.104 15 19 14.105 19 13Z" fill="black"/>
          </svg>
        `,
        S: html`
          <svg width="26" height="18" viewBox="0 0 26 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 2.86365L20 13.8636" stroke="black" stroke-width="1.6" stroke-linejoin="round"/>
            <path d="M17 5.86365V11.8636" stroke="black" stroke-width="1.6" stroke-linejoin="round"/>
            <path d="M6 14.8636L6 2.86365" stroke="black" stroke-width="1.6" stroke-linejoin="round"/>
            <path d="M9 11.8636L9 5.86365" stroke="black" stroke-width="1.6" stroke-linejoin="round"/>
            <path d="M15 8.86365C15 7.75965 14.104 6.86365 13 6.86365C11.896 6.86365 11 7.75965 11 8.86365C11 9.96865 11.896 10.8636 13 10.8636C14.104 10.8636 15 9.96865 15 8.86365Z" fill="black"/>
            <rect x="15" y="14.8636" width="10" height="2" fill="black"/>
            <path d="M1 1H25V17H1V1Z" stroke="black" stroke-width="1.6" stroke-linejoin="bevel"/>
          </svg>
        `,
      },
      edit: {
        L: html`
          <svg width="70" height="50" viewBox="0 0 70 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="1" width="68" height="48" stroke="black" stroke-width="1.6" stroke-linejoin="bevel"/>
            <rect x="1" y="45" width="68" height="4" fill="black"/>
            <path d="M29.1875 27.0842L29.1875 25.6947L30.5625 25.6947L30.5625 27.0842L29.1875 27.0842Z" fill="black"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M28.5 27.7789L28.5 25L31.25 25L31.25 27.7789L28.5 27.7789Z" fill="black"/>
            <path d="M34.3125 27.0842L34.3125 25.6947L35.6875 25.6947L35.6875 27.0842L34.3125 27.0842Z" fill="black"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M33.625 27.7789L33.625 25L36.375 25L36.375 27.7789L33.625 27.7789Z" fill="black"/>
            <path d="M39.4375 27.0842L39.4375 25.6947L40.8125 25.6947L40.8125 27.0842L39.4375 27.0842Z" fill="black"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M38.75 27.7789L38.75 25L41.5 25L41.5 27.7789L38.75 27.7789Z" fill="black"/>
          </svg>
        `,
        M: html`
          <svg width="34" height="24" viewBox="0 0 34 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1H33V23H1V1Z" stroke="black" stroke-width="1.6" stroke-linejoin="bevel"/>
            <rect x="1" y="20" width="32" height="3" fill="black"/>
            <path d="M12.1875 13.0842L12.1875 11.6947L13.5625 11.6947L13.5625 13.0842L12.1875 13.0842Z" fill="black"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5 13.7789L11.5 11L14.25 11L14.25 13.7789L11.5 13.7789Z" fill="black"/>
            <path d="M16.3125 13.0842L16.3125 11.6947L17.6875 11.6947L17.6875 13.0842L16.3125 13.0842Z" fill="black"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M15.625 13.7789L15.625 11L18.375 11L18.375 13.7789L15.625 13.7789Z" fill="black"/>
            <path d="M20.4375 13.0842L20.4375 11.6947L21.8125 11.6947L21.8125 13.0842L20.4375 13.0842Z" fill="black"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M19.75 13.7789L19.75 11L22.5 11L22.5 13.7789L19.75 13.7789Z" fill="black"/>
          </svg>
        `,
        S: html`
          <svg width="26" height="18" viewBox="0 0 26 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1H25V17H1V1Z" stroke="black" stroke-width="1.6" stroke-linejoin="bevel"/>
            <rect x="1" y="14.8636" width="24" height="2" fill="black"/>
            <path d="M9.39063 9.78856L9.39063 8.77803L10.4219 8.77803L10.4219 9.78856L9.39063 9.78856Z" fill="black"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.875 10.2938L8.875 8.27277L10.9375 8.27277L10.9375 10.2938L8.875 10.2938Z" fill="black"/>
            <path d="M12.4844 9.78856L12.4844 8.77803L13.5156 8.77803L13.5156 9.78856L12.4844 9.78856Z" fill="black"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9688 10.2938L11.9687 8.27277L14.0313 8.27277L14.0313 10.2938L11.9688 10.2938Z" fill="black"/>
            <path d="M15.5781 9.78856L15.5781 8.77803L16.6094 8.77803L16.6094 9.78856L15.5781 9.78856Z" fill="black"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M15.0625 10.2938L15.0625 8.27277L17.125 8.27277L17.125 10.2938L15.0625 10.2938Z" fill="black"/>
          </svg>
        `,
      },
    };

    const modeIcon = modeIcons[id];
    return size ? modeIcon[size] : modeIcon.L;
  },

  getPlayerMode: function (iconSize = 'S') {
    return {
      try: {
        icon: this.getPlayerModeIcon('try', { size: iconSize }),
        text: i18next.isInitialized ? i18next.t('Try') : 'Try',
        shortText: i18next.isInitialized ? i18next.t('Try') : 'Try',
        message: i18next.isInitialized ? i18next.t('Practice the steps interactively') : 'Practice the steps interactively',
        href: '#trysteps-1',
        altKey: 'is_trysteps_default'
      },
      view: {
        icon: this.getPlayerModeIcon('view', { size: iconSize }),
        text: i18next.isInitialized ? i18next.t('Scroll') : 'Scroll',
        shortText: i18next.isInitialized ? i18next.t('Scroll') : 'Scroll',
        message: i18next.isInitialized ? i18next.t('See steps as a scrollable list') : 'See steps as a scrollable list',
        href: '#viewsteps',
        altKey: 'is_viewsteps_default'
      },
      slide: {
        icon: this.getPlayerModeIcon('slide', { size: iconSize }),
        text: i18next.isInitialized ? i18next.t('Slide') : 'Slide',
        shortText: i18next.isInitialized ? i18next.t('Slide') : 'Slide',
        message: i18next.isInitialized ? i18next.t('See steps as a slideshow') : 'See steps as a slideshow',
        href: '#mobilequick-1',
        altKey: 'is_mobilequick_default'
      },
      watch: {
        icon: this.getPlayerModeIcon('watch', { size: iconSize }),
        text: i18next.isInitialized ? i18next.t('Watch') : 'Watch',
        shortText: i18next.isInitialized ? i18next.t('Watch') : 'Watch',
        message: i18next.isInitialized ? i18next.t('See steps as a video') : 'See steps as a video',
        href: '#watchsteps-1',
        altKey: 'is_watchsteps_default'
      },
      quiz: {
        icon: this.getPlayerModeIcon('quiz', { size: iconSize }),
        text: i18next.isInitialized ? i18next.t('Quiz') : 'Quiz',
        shortText: i18next.isInitialized ? i18next.t('Quiz') : 'Quiz',
        message: i18next.isInitialized ? i18next.t('Measure speed & accuracy') : 'Measure speed & accuracy',
        href: '#quizsteps-1',
        altKey: 'is_quizsteps_default'
      },
      live: {
        icon: this.getPlayerModeIcon('live', { size: iconSize }),
        text: i18next.isInitialized ? i18next.t('Live') : 'Live',
        shortText: i18next.isInitialized ? i18next.t('Live') : 'Live',
        href: '#live',
        altKey: 'is_live_default'
      },
    };
  },

  getPlayerModeInArray: function (iconSize = 'S') {
    const playerMode = this.getPlayerMode(iconSize);
    return Object.keys(playerMode).map((mode) => ({
      id: mode,
      ...playerMode[mode]
    }));
  }
};

;
iorad.base.Settings = {
  // - 'downloaded' for downloaded app (e.g. downloaded player uploaded into user static server)
  // - 'vagrant' for local vagrant version of node server,
  // - 'prod' for test.iorad.com
  // - 'live' for www.iorad.com
  // keep sure to specify below all the possible envs!
  envs: ['downloaded', 'vagrant', 'prod', 'staging', 'live', 'k8s'],
  // TODO: This needs to be set automatically, you shouldn't have to
  // edit this file when doing a deploy!  <-- it is right now if using .env file!
  env: 'vagrant', // current used environment, replaced by grunt

  values: {
    'logging': {
      'live': {
        'isDisabled': true
      },
      'k8s': {
        'isDisabled': true
      },
      '*': {
        'isDisabled': false
      }
    },

    'server': {
      'fetch': {
      },
      'save': {
        'downloaded': {
          'fontRemotePath': window.IORAD_ROOT + '/api/tutorial/customFont?tutorial_id=%tutorial_id%&user_id=%user_id%&font_family=%font_family%&cache=%cache%',
        },
        'prod': {
          'themeImageRemotePath': 'https://t3.iorad.com/capture/tutorials/%user_id%/%imagename%?cache=%cache%',
          'imageRemotePath': 'https://t3.iorad.com/capture/tutorials/%user_id%/%tutorial_id%/%image_id%.%image_ext%?cache=%cache%',
          'audioRemotePath': 'https://t3.iorad.com/capture/tutorials/%user_id%/%tutorial_id%/%audio_id%.%audio_ext%?cache=%cache%',
          'videoRemotePath': 'https://t3.iorad.com/capture/tutorials/%user_id%/%tutorial_id%/%video_id%.%video_ext%?cache=%cache%',
          'musicRemotePath': 'https://t3.iorad.com/assets/music/%music_id%.%music_ext%?cache=%cache%',
        },
        'live': {
          'themeImageRemotePath': 'https://s3.iorad.com/capture/tutorials/%user_id%/%imagename%?cache=%cache%',
          'imageRemotePath': 'https://s3.iorad.com/capture/tutorials/%user_id%/%tutorial_id%/%image_id%.%image_ext%?cache=%cache%',
          'audioRemotePath': 'https://s3.iorad.com/capture/tutorials/%user_id%/%tutorial_id%/%audio_id%.%audio_ext%?cache=%cache%',
          'videoRemotePath': 'https://s3.iorad.com/capture/tutorials/%user_id%/%tutorial_id%/%video_id%.%video_ext%?cache=%cache%',
          'musicRemotePath': 'https://s3.iorad.com/assets/music/%music_id%.%music_ext%?cache=%cache%',
        },
        '*': {
          'type': 'POST',
          'url': '/api/tutorial/save',
          'saveIdleTimeout': 2000,
          'themeImageRemotePath': '%cdn_host%/capture/tutorials/%user_id%/%imagename%?cache=%cache%',
          'imageRemotePath': '%cdn_host%/capture/tutorials/%user_id%/%tutorial_id%/%image_id%.%image_ext%?cache=%cache%',
          'audioRemotePath': '%cdn_host%/capture/tutorials/%user_id%/%tutorial_id%/%audio_id%.%audio_ext%?cache=%cache%',
          'videoRemotePath': '%cdn_host%/capture/tutorials/%user_id%/%tutorial_id%/%video_id%.%video_ext%?cache=%cache%',
          'musicRemotePath': '%cdn_host%/assets/music/%music_id%.%music_ext%?cache=%cache%',
          'fontRemotePath': '/api/tutorial/customFont?tutorial_id=%tutorial_id%&user_id=%user_id%&font_family=%font_family%&cache=%cache%',
          'decryptedAssetRemotePath': '/api/tutorial/decryptedAsset?tutorial_id=%tutorial_id%&user_id=%user_id%&key=%key%&name=%name%&cache=%cache%',
          'exitUnsavedWarning': true // show a warning when closing window if there is unsaved data
        }
      },
      'saveImage': {
        'options': {
          '*': {
            "concurrencyLimit": -1,
          }
        }
      },
      'progress': {
        'downloaded': {
          'isEnabled': false
        },
        '*': {
          'type': 'POST',
          'url': '/tutorial/progress?tutorial_id=%tutorial_id%&step=%step%',
          'isEnabled': true
        }
      },
      'statistics': {
        'downloaded': {
          'isEnabled': false
        },
        '*': {
          'isEnabled': true
        }
      },
      'playerURL': {
        'downloaded': {
          'override': {
            'PUBLIC_LINK': '%dirBasePath%index.html',
            'PUBLIC_LINK_IFRAME_HASH_TEMPLATE': '%dirBasePath%index.html?iframeHash=%7B%7BIORAD_IFRAME_HASH_PLACEHOLDER%7D%7D',
            'QUIZ_LINK': '%dirBasePath%index.html?iframeHash=quizsteps-1',
            'SHORT_LINK': undefined,
            'SHORT_LINK_IFRAME_HASH_TEMPLATE': undefined,
            'SHORT_LINK_HELP_CENTER': undefined,
            'SHORT_LINK_HELP_CENTER_IFRAME_HASH_TEMPLATE': undefined,
            'VIEW_LIVE_LINK': (window.getPlayerURLData || {}).VIEW_LIVE_LINK,
          }
        },
        '*': {
          'EMBED': '<p><iframe src="%publicLink%" width="1px" height="500px" style="border:0;min-width:100%;" allowfullscreen="true" allow="camera; microphone; clipboard-write" referrerpolicy="strict-origin-when-cross-origin"></iframe></p>%tutorialText%',
          'LIVE_CODE': '<script type="text/javascript" src="https://www.iorad.com/assets/embed/inject.js"></script>'
        }
      },
      'knownContacts': {
      },
      'knownLabel': {
      },
      'getSharedUserList': {
      },
      'lang': {
        'downloaded': {
          // TODO: use custom templates
          'url': window.STATIC_ROOT + 'lang/%lang%.json'
        },
        '*': {
          'url': '/api/user/getLanguageTemplate?languageCode=%lang%&userId=%user_id%',
        }
      },
      'domainLogo': {
        '*': {
          'url': '/api/tutorial/domainLogo?tutorial_id=%tutorialID%',
        }
      },
      'domainFavicon': {
        '*': {
          'url': '/api/tutorial/domainFavicon?tutorial_id=%tutorialID%',
        }
      },
      'services': {
        'downloaded': {
          'node': {
            'url': window.IORAD_ROOT + '/api/%path%'
          }
        },
        'vagrant': {
          'node': {
            'url': '/api/%path%'
          }
        },
        '*': {
          'type': 'POST',
          'node': {
            'url': '/api/%path%'
          }
        }
      },
    },

    'avatar': {
      'vagrant': {
        'url': '/api/user/avatar?userId=%user_id%'
      },
      '*': {
        'url': '/api/user/avatar?userId=%user_id%'
      }
    },

    'homepage': {
      'downloaded': {
        'url': window.IORAD_ROOT + '/'
      },
      '*': {
        'url': '/'
      }
    },

    'mytutorials': {
      'downloaded': {
        'url': window.IORAD_ROOT + '/tutorials'
      },
      '*': {
        'url': '/tutorials'
      }
    },

    'contactus': {
      'downloaded': {
        'url': window.IORAD_ROOT + '/contactus'
      },
      '*': {
        'url': '/contactus'
      }
    },

    'createNewTutorial': {
      'downloaded': {
        'url': window.IORAD_ROOT + '/createNewTutorial/'
      },
      '*': {
        'url': '/createNewTutorial/'
      }
    },

    'editTutorial': {
      'downloaded': {
        'isEnabled': false
      },
      '*': {
        'isEnabled': true,
        'url': '/editor/?data=0&module=%tutorialID%&uid=%userID%&returnTo=%returnTo%%hash%'
      }
    },

    'signup': {
      'vagrant': {
        'url': '/signup'
      },
      'downloaded': {
        'url': window.IORAD_ROOT + '/signup'
      },
      '*': {
        'url': '/signup'
      }
    },

    'login': {
      'vagrant': {
        'url': '/login'
      },
      'downloaded': {
        'url': window.IORAD_ROOT + '/login'
      },
      '*': {
        'url': '/login'
      }
    },

    'updateSubscription': {
      'downloaded': {
        'url': window.IORAD_ROOT + '/upgradeplan'
      },
      '*': {
        'url': '/upgradeplan'
      }
    },

    'accountAdmin': {
      'downloaded': {
        'url': window.IORAD_ROOT + '/account/settings/admin'
      },
      '*': {
        'url': '/account/settings/admin'
      }
    },

    'siteError': {
      'downloaded': {
        'url': window.IORAD_ROOT + '/siteError/?errormsg=%error_message%'
      },
      '*': {
        'url': '/siteError?errormsg=%error_message%'
      }
    },

    'capture': {
      'app': {
        'vagrant': {
          'location': {
            'bundled': {
              'windows': 'https://test.iorad.com/server/webstart/iorad-capture.exe',
              'mac': 'https://test.iorad.com/server/webstart/iorad-capture.pkg.dmg'
            },
          }
        },
        'prod': {
          'supported': {
            'os': ['mac', 'windows', 'linux']
          }
        },
        '*': {
          'location': {
            'bundled': {
              'windows': '/server/webstart/iorad-capture.exe',
              'mac': '/server/webstart/iorad-capture.pkg.dmg'
            },
          },
          'fileSize': {
            'bundled': {
              'windows': '14 Mb',
              'mac': '20 Mb'
            }
          },
          'supported': {
            'os': ['mac', 'windows']
          }
        }

      },
      'getCaptureVersions': {
        '*': {
          'ajax': false,
          'type': 'GET',
          'url': '/webstart/versions'
        }
      },
      'getCaptureNumber': {
      },
      'processing': {
        'msg': 'Hold on. Still processing.',
        'capturedMedia': {
          'msg': 'Hold on. Still processing captured media.'
        },
      },
      'restore': {
        '*': {
          'isEnabled': false
        }
      },
      'extension': {
        'chrome': {
          // This is the id assigned to the Chrome extension
          'builds': {
            'standard': {
              'id': 'kjfmedbganalpkohkeghhpppicoigdal',
            },
            'ci': {
              'id': 'fheghmognccmbkljflobhkcfkiajllip',
            }
          },
          'webstore': {
            'vagrant': {
              'url': 'https://chrome.google.com/webstore/detail/iorad-capture-development/fheghmognccmbkljflobhkcfkiajllip',
            },
            'prod': {
              'url': 'https://chrome.google.com/webstore/detail/iorad-capture-development/fheghmognccmbkljflobhkcfkiajllip',
            },
            '*': {
              'url': 'https://chrome.google.com/webstore/detail/iorad-the-tutorial-builde/kjfmedbganalpkohkeghhpppicoigdal',
            }
          },
        }
      }
    },

    'translate': {
      'downloaded': {
        'scheme': 'https://' // make it work also on file://
      },
      '*': {
        'scheme': '//'
      }
    },

    'editor': {
      'wysihtml5': {
        '*': {
          'styleFilename': '/_dist/styles/editor/common/wysihtml5.css',
          'infotextStyleFilename': '/_dist/styles/editor/common/infotext_wysihtml5.css',
        }
      },
    },

    'player': {
      'wysihtml5': {
        '*': {
          'commentsStyleFilename': '/_dist/styles/player/common/comments_wysihtml5.css',
        }
      },
      'views': {
        'minToShow': 100
      }
    },

    'tracking': {
      '*': {
        'isEnabled': true
      }
    },

    'liveUrlConfig': {
      'prod': {
        'isEnabled': true
      },
      'vagrant': {
        'isEnabled': true
      },
      '*': {
        'isEnabled': false
      }
    },

    'commenting': {
      'prod': {
        'isEnabled': true
      },
      'vagrant': {
        'isEnabled': true
      },
      '*': {
        'isEnabled': true
      }
    },
    'video': {
      'prod': {
        'isEnabled': true
      },
      'vagrant': {
        'isEnabled': true
      },
      '*': {
        'isEnabled': true
      }
    },

    'components': {
      'downloaded': {
        'basePath': window.IORAD_ROOT + '/_dist/scripts/components'
      },
      '*': {
        'basePath': '/_dist/scripts/components'
      }
    },

    'default': {
      'themeId': -1
    }
  },

  get: function(name, variables) {
    var self = this;
    var pathFragments = name.split('.');
    var start = this.values;
    var env = this.env;
    var envParent;
    var envParentIndex;
    for (var i = 0; i < pathFragments.length; i++) {
      var fragment = pathFragments[i];
      if ('*' in start && envParent === undefined) {
        // keep track of the first wildcard env
        envParent = start;
        envParentIndex = i;
      }
      if (start[env]) {
        // use current env
        envParent = start;
        envParentIndex = i;
        start = start[env];
      }
      start = start[fragment];
      if (start === undefined) {
        if (envParent !== undefined && '*' in envParent && env != '*') {
          // try with * env
          env = '*';
          start = envParent;
          i = envParentIndex - 1; // because of the i++
        } else {
          // not found
          return undefined;
        }
      }
    }

    // don't modify original settings
    start = iorad.base.Utils.deepClone(start);

    // if the getted setting still contains env properties, remove those not related to the current
    // and merge the current env with the wildcard env.
    var removeEnvs = function(target) {
      if (target && typeof target == 'object') { // object or array
        // recursion (depth-first so to avoid collisions with "sub envs")
        _.each(target, function(value, key) {
          target[key] = removeEnvs(target[key]);
        });

        if (!_.isArray(target)) { // objects only
          if ('*' in target) {
            // merge * with target
            _.extend(target, target['*']);
            delete target['*'];
          }
          _.each(self.envs, function(possibleEnv) {
            if (possibleEnv in target) {
              if (possibleEnv === self.env) {
                // merge env
                _.extend(target, target[possibleEnv]);
              }
              // (true also for foreign envs)
              delete target[possibleEnv];
            }
          });
        }
      }
      return target;
    }
    start = removeEnvs(start);

    var replaceVars = function(target) {
      if (typeof target == 'object') {
        for (var prop in target) {
          if (target.hasOwnProperty(prop)) {
            target[prop] = replaceVars(target[prop]);
          }
        }
      } else if (typeof target == 'string') {
        // replace variables in string with their specified values
        for (var variable in variables) {
          if (variables.hasOwnProperty(variable)) {
            target = iorad.base.Utils.replaceAll(target, '%' + variable + '%', variables[variable]);
          }
        }
      }
      return target;
    }
    if (variables) start = replaceVars(start);

    return start;
  }
}

;
//global configuration

window.setLocationHash = function(hash, options) {
  hash = hash || '';
  if (hash[0] !== '#') hash = '#' + hash;
  options = options || {};

  if (siteWindow.parent !== window || options.isReplace) {
    window.location.replace(hash);
  } else {
    window.location.assign(hash);
  }
};

// Sync site and app hashes
window.setLocationHash(siteWindow.location.hash); // match initial hash (#4438)
var siteWindowHash = siteWindow.location.hash;
var windowHash = window.location.hash;
var checkHashSync = function() {
  if (siteWindow.location.pathname !== window.location.pathname) return;

  if (siteWindow.location.hash !== siteWindowHash) {
    siteWindowHash = siteWindow.location.hash;

    windowHash = siteWindowHash;
    window.setLocationHash(windowHash);
  } else if (window.location.hash !== windowHash) {
    windowHash = window.location.hash;
    siteWindowHash = windowHash;
    siteWindow.ioradNodeApp.setLocation(siteWindowHash, { isHash: true });
  }
};
window.addEventListener('hashchange', checkHashSync);
siteWindow.addEventListener('hashchange', checkHashSync);
checkHashSync();

window.stopHashSync = function() {
  window.removeEventListener('hashchange', checkHashSync);
  siteWindow.removeEventListener('hashchange', checkHashSync);
};

// Since we use <base target="_parent" />, we need to do this manually in case of sandboxed
// iframe (See issue #3818)
document.documentElement.addEventListener('click', function(e) {
  if (e.defaultPrevented) return;
  var target = e.target;
  for(var i = 0; i < 5 && target.parentNode && target.tagName !== 'A'; i++, target=target.parentNode)
    ;
  if (!target || !target.getAttribute) return;
  if (target.getAttribute('target') === '_blank') return;
  var href = target.getAttribute('href');
  if (href) {
    e.preventDefault();
    var isHash = (href[0] === '#');
    siteWindow.ioradNodeApp.setLocation(href, { isHash: isHash });
  }
}, false);

var isIE = /MSIE|Trident/.test(window.navigator.userAgent);

// Noty defaults
if ($ && $.noty) {
  _.extend($.noty.defaults, {
    theme: 'relax',
    timeout: 5000,
    killer: true,
    maxVisible: 1
  });
}

// IE + iframe
if (isIE && window.self !== window.top && typeof jQuery !== 'undefined') {
  // jQuery workaround when in fullscreen for https://github.com/iorad/iorad/issues/1213

  var multiplier = 100;

  var fixBoundsFunction = function(originalFunction) {
    return function() {
      var ret = originalFunction.apply(this, arguments);

      var el = this instanceof jQuery ? this[0] : this;

      var isValidGet = arguments.length === 0 && // no arguments -> get
        _.isObject(ret) && // is valid return
        el.offsetWidth < el.clientWidth; // the bug is showing up

      if (isValidGet) {
        _.each(['left', 'top', 'right', 'bottom', 'width', 'height'], function(bound) {
          if (typeof ret[bound] !== 'undefined') ret[bound] *= multiplier;
        });
      }

      return ret;
    }
  };

  // jQuery width, height
  var fixSizeFunction = function(originalFunction, isOuter) {
    return function() {
      var ret = originalFunction.apply(this, arguments);

      var el = this instanceof jQuery ? this[0] : this;

      var isValidGet = (arguments.length === 0 || isOuter) && // no arguments -> get, in case of outer size the argument means "include margins" thus is still a valid get even with it
        _.isNumber(ret) && // is valid return
        el.offsetWidth < el.clientWidth; // the bug is showing up

      if (isValidGet) {
        ret *= multiplier;
      }

      return ret;
    }
  };

  jQuery.fn.offset = fixBoundsFunction(jQuery.fn.offset);
  jQuery.fn.position = fixBoundsFunction(jQuery.fn.position);
  HTMLElement.prototype.getBoundingClientRect = fixBoundsFunction(HTMLElement.prototype.getBoundingClientRect);

  jQuery.fn.width = fixSizeFunction(jQuery.fn.width);
  jQuery.fn.height = fixSizeFunction(jQuery.fn.height);
  jQuery.fn.innerWidth = fixSizeFunction(jQuery.fn.innerWidth);
  jQuery.fn.innerHeight = fixSizeFunction(jQuery.fn.innerHeight);
  jQuery.fn.outerWidth = fixSizeFunction(jQuery.fn.outerWidth, true);
  jQuery.fn.outerHeight = fixSizeFunction(jQuery.fn.outerHeight, true);
  jQuery.fn.scrollTop = fixSizeFunction(jQuery.fn.scrollTop);
  jQuery.fn.scrollLeft = fixSizeFunction(jQuery.fn.scrollLeft);

}

var forceLog = false;
if (typeof window.console === 'undefined') {
  // Fix for undefined console object
  // (e.g. on old environments like sharepoint with IE9 compatibility mode)
  window.console = {};
}
var consoleMethods = ['assert', 'clear', 'count', 'debug', 'dir', 'dirxml',
  'error', 'group', 'groupCollapsed', 'groupEnd', 'info',
  'log', 'profile', 'profileEnd', 'time', 'timeEnd',
  'timeline', 'timelineEnd', 'timeStamp', 'trace', 'warn'
];
_.each(consoleMethods, function(methodName) {
  if (typeof window.console[methodName] !== 'function') {
    // provide a dummy function to prevent exceptions when calling the method
    window.console[methodName] = function() {};
  } else {
    // wrap method to disable logging when needed
    var originalMethod = window.console[methodName];
    window.console[methodName] = function () {
      if (
        iorad &&
        iorad.base &&
        iorad.base.Settings &&
        iorad.base.Settings.get('logging.isDisabled') &&
        !forceLog
      ) {
        return;
      }
      originalMethod.apply(window.console, arguments);
    };
  }
});
iorad.base.withLoggingEnabled = function(cb) {
  forceLog = true;
  try {
    cb();
  } finally {
    forceLog = false;
  }
};

// wrap to disable logging when needed
window.onerror = function() {
  // return true to suppress exception
  return (iorad && iorad.base && iorad.base.Settings && iorad.base.Settings.get('logging.isDisabled'));
};

// Check browser compatibility
if (isIE && !document.addEventListener) { // IE <= 8
  noty({
    text: "Your browser is ancient and needs to be updated. Jump into your time machine and install a new one!",
    type: 'warning'
  });
}

// Backbone-Relational
if (typeof Backbone.Relational !== 'undefined') {
  Backbone.Relational.showWarnings = false;
}

// Fix Google Translate + SVG error
// a[b].target.className.indexOf is not a function
if (window.SVGAnimatedString && typeof window.SVGAnimatedString.prototype.indexOf !== 'function') {
  window.SVGAnimatedString.prototype.indexOf = function() {
    return this.baseVal.indexOf.apply(this.baseVal, arguments);
  };
}

// Fix #6014
// https://github.com/goldfire/howler.js/issues/395#issuecomment-208574643
// https://stackoverflow.com/a/34823090/1418049
if (window.Howler) {
  document.documentElement.addEventListener('click', function(e) {
    if (window.Howler.ctx && window.Howler.ctx.state && window.Howler.ctx.state === 'suspended') {
      window.Howler.ctx.resume().then(function() {
        console.log('AudioContext resumed!');
      });
    }
  }, true);
}

if (
  window.ioradIsPreviewPlayer &&
  window.customIoradNavigatorUAData &&
  window.customIoradNavigatorUAData.platform === 'iPhone'
) {
  // HACK: Force fullscreen to be disabled on iOS/Android Preview
  Object.defineProperty(document, screenfull.raw.fullscreenEnabled, {
    get: () => false,
    configurable: true,
    enumerable: true,
  });
  if (siteWindow !== document) {
    Object.defineProperty(siteWindow, screenfull.raw.fullscreenEnabled, {
      get: () => false,
      configurable: true,
      enumerable: true,
    });
  }
}

// Fix #7933
// Fix screenful.js not being able to detect fullscreen
// when loading a new page while already in fullscreen
var siteDocument = siteWindow && siteWindow.document;
if (siteDocument) {
  var isFullScreen = siteDocument.fullScreen ||
      siteDocument.mozFullScreen ||
      siteDocument.webkitIsFullScreen ||
      (siteDocument.msFullscreenElement != null);
  if (isFullScreen && !screenfull.isFullscreen) {
    screenfull.toggle();
  }
}

;
iorad.base.Factory = iorad.base.Component.extend({}, { // STATIC PROPERTIES!

  types: {},
  defaultType: 'defaultType',

  // return the type from this specific factory if exists,
  // otherwise return the default type.
  get: function(typeName) {
    return this.types[typeName] ||
      (this.defaultType && this.defaultType !== typeName && this.types[this.defaultType]);
  },

  // Note: all the arguments after the first one will be passed to the type constructor.
  // based on http://stackoverflow.com/a/3362623
  create: function(typeName) {
    var Constructor = this.get(typeName);
    var constructorArgs = Array.prototype.slice.call(arguments, 1); // from second argument

    // Create a new instance
    var inst = Object.create(Constructor.prototype);

    // Call the original Constructor with the temp
    // instance as its context (i.e. its 'this' value)
    var ret = Constructor.apply(inst, constructorArgs);

    // If an object has been returned then return it otherwise
    // return the original instance.
    // (consistent with behaviour of the new operator)
    return Object(ret) === ret ? ret : inst;
  }

});
;
 // Using backbone-deep-model library
iorad.base.models.theme = Backbone.DeepModel.extend({
  defaults: function() {
    return {
      id: null,
      name: null, // string
      baseTheme: null, // base theme, string
      colorPrimary: null, // string
      minContrastPercent: null, // int
      logoImage: null, // string (url)
      logoHref: null, // string (url)
      logoName: null, //string
      logoTargetBlank: null, // bool,
      faviconImage: null, // string (url)
      faviconName: null, //string
      notyDisplayed: null, // bool
      dynamicBackgroundEnabled: true, // bool
    };
  },
});

;
/*
 * Steps are hierarchical and susume both the steps and slides from
 * the old models. Rigth now we only display the top level but in
 * future it will be possible to expand them.
 *
 * See: https://github.com/iorad/iorad/wiki/Tutorial-JSON-(Proposal)
 */
iorad.base.models.step = Backbone.DeepModel.extend({ // Using backbone-deep-model library

  getScreenshotsController: function() {}, // MANDATORY for child types

  defaults: function() {
    return {
      id: null,
      type: null,
      description: null,
      hidden: false,
      // marker: {
      //   type: 'rectangle', // [+] if undefined or null it means 'rectangle'
      //   x: 0, // [+] x coordinate of the step marker (absolute to screenshot)
      //   y: 0, // [+] y coordinate of the step marker
      //   width: 100, // [+] width of the step marker
      //   height: 100, // [+] heigth of the step marker
      //   color: '#111111', // [+] optional
      //   borderWidth: 3, // [+] optional
      // },
      // event: {
      //   name: 'none'
      // },
      // component: {
      //   name: 'none'
      // },
      // screenshot: {
      //   id: 'a',
      //   frames: [
      //     {
      //       id: 'a.png'
      //     }
      //   ]
      // }
    };
  },

  // returned by a method to prevent circular inclusions between model and collection types.
  getStepsCollectionType: function() {
    return iorad.base.collections.steps;
  },

  initialize: function(attributes, options) {
    this._screenshotsController = this.getScreenshotsController();

    // Every step can have a 0 or more sub-steps
    var StepsCollection = this.getStepsCollectionType();
    this.steps = new StepsCollection();

    // re-trigger substeps events in order to allow higher nodes in the steps tree to monitor child changes
    // (e.g. for saving changes)
    this.listenTo(this.steps, 'all', _.bind(function() {
      // As of Backbone >= 1.2.0, all model "change" events MUST have the signature
      // (event, model, ...), otherwise the internal "_onModelEvent" function will fail
      this.trigger('change', this, { subSteps: true });
      this.trigger('subSteps:all');
    }, this));
    ['change', 'add', 'remove', 'reset', 'sort'].forEach(_.bind(function(eventName) {
      this.listenTo(this.steps, eventName, _.bind(function() {
        var args = [].slice.call(arguments);
        this.trigger.apply(this, ['subSteps:' + eventName, this].concat(args));
      }, this));
    }, this));

    this.listenTo(this, 'change:steps reset', this.updateSubSteps);
    this.listenTo(this, 'scale', this.reload.bind(this));
    this.updateSubSteps({ silentReset: true });
  },

  changedAttributes: function() {
    // do not report the unset of steps, since it would lead to complete removal of the sub steps
    // on the "smart save" side of things
    var result = Backbone.DeepModel.prototype.changedAttributes.apply(this, arguments);
    return _.omit(result, 'steps');
  },

  updateSubSteps: function(options) {
    options = options || {};

    this.steps.reset(this.get('steps') || [], {
      silent: options.silentReset,
    });
    this.unset('steps', {
      silent: true,
    });
  },

  toJSON: function() {
    // Note: the slide "steps" attribute isn't keeped updated by the app, we need the javascript "step" property instead
    var step = iorad.base.Utils.deepClone(this.omit('steps'));
    step.steps = this.steps.toJSON();
    return step;
  },

  // extends the Backbone.Model clone method
  // by also recursively cloning the sub-steps
  clone: function(options) {
    options = options || {};

    var cloneStep = Backbone.DeepModel.prototype.clone.apply(this, arguments);

    var cloneSubSteps = [];
    // recursivelly also clone the sub-steps since aren't cloned by default
    for (var i = 0, l = this.steps.length; i < l; i++) {
      var subStepClone = this.steps.at(i).clone(options); // recursion
      cloneSubSteps.push(subStepClone);
    }
    cloneStep.steps.reset(cloneSubSteps, {
      silent: options.silent,
    });

    return cloneStep;
  },

  // Not all steps have screenshots themselves, so this method looks
  // in self then in children until it finds one. It returns the first
  // it finds.
  _getScreenshotData: function() {
    var screenshot;
    if (this.has('screenshot')) {
      return this.get('screenshot');
    } else {
      for (var i = 0; i < this.steps.length; i++) {
        screenshot = this.steps.getModelAt(i)._getScreenshotData();
        if (screenshot) {
          return screenshot;
        }
      }
      return null;
    }
  },

  // Return a canvas element containing the full composited screenshot
  getScreenshotCanvas: function() {
    var screenshotSize = this.originalScreenshotSize();
    return this._screenshotsController.getScreenshotCanvas(
      this.id || this.cid,
      screenshotSize.width,
      screenshotSize.height,
      this._getScreenshotData()
    );
  },

  preload: function() {
    if (!this._preloadPromise) {
      this._preloadPromise = this.getScreenshotCanvas().catch((err) => {
        // Retry if it fails (only once)
        console.error(err);
        return iorad.base.Utils.delay(300)
          .then(() => {
            return this.getScreenshotCanvas();
          })
          .catch(subErr => {
            // give up
            delete this._preloadPromise;
            throw subErr;
          });
      });
    }
    return this._preloadPromise;
  },

  reload: function() {
    this._preloadPromise = null;
    this.preload({force: true});
  },

  // Return a list of sub-steps that match a given predicate including
  // this step if it matches
  subSteps: function(predicate) {
    if (!predicate) {
      predicate = function() {
        return true;
      };
    }
    var values = [];
    if (predicate(this)) {
      values.push(this);
    }
    this.steps.each(function(step) {
      values = values.concat(step.subSteps(predicate));
    });
    return values;
  },

  // // Get a list sub steps with componetns
  // withComponents: function () {
  //   return this.subSteps(function (step) { return step.has('component'); });
  // },

  // withMarkers: function () {
  //   return this.subSteps(function (step) { return step.has('marker'); });
  // },

  // Get the description for this step, just return the description
  // attribute if has one otherwise combine the descriptions of sub
  // steps (this part needs more work!)
  getDescription: function() {
    if (this.has('description')) {
      return this.get('description');
    }
    return _.compact(_.map(this.subSteps(), function(step) {
      return step.get('description');
    })).join(', ');
  },

  setDescription: function(newDescription) {
    if (newDescription === this.get('description')) return;

    var newDescriptionText = iorad.base.Utils.stripHtmlTags(newDescription, iorad.base.Export.STEP_DESCRIPTION_APP_SANITIZE_RULES);
    var descriptionText = iorad.base.Utils.stripHtmlTags(this.get('description'), iorad.base.Export.STEP_DESCRIPTION_APP_SANITIZE_RULES);
    var textChanged = newDescriptionText !== descriptionText;
    var modTime = new Date().toISOString();
    this.set({
      description: newDescription,
      descriptionModTime: modTime,
      descriptionTextModTime: textChanged ? modTime : this.get('descriptionTextModTime'),
      aiWrittenDescription: null,
      aiWrittenDescriptionOriginal: null,
    });
  },

  scale: 1,//default

  //scales screenshot and marker sizes
  setScale: function(scale, markerBounds) {
    scale = Number(scale.toFixed(2));
    if (this.scale === scale) return;
    var screenshotSize = this.originalScreenshotSize();
    this.set({
      'screenshot.width': screenshotSize.width * scale,
      'screenshot.height': screenshotSize.height * scale,
    });
    var originalMarkerBounds = this.originalMarkerBounds(markerBounds);
    _.each(['width', 'height', 'x', 'y'], function(prop) {
      this.set('marker.bounds.' + prop, originalMarkerBounds[prop] * scale);
    }.bind(this));
    this.scale = scale;
    this.trigger('scale', this);
  },

  // NOTE: markerBounds passed as parameter for steps that use default bounds
  //       e.g. SCROLL (see #2455)
  originalMarkerBounds: function (markerBounds) {
    markerBounds = markerBounds || this.get('marker.bounds');
    return {
      width: markerBounds.width / this.scale,
      height: markerBounds.height / this.scale,
      x: markerBounds.x / this.scale,
      y: markerBounds.y / this.scale,
    };
  },

  originalScreenshotSize: function() {
    var screenshot = this.get('screenshot');
    return {
      'width': screenshot.width / this.scale,
      'height': screenshot.height / this.scale,
    };
  },

  getStepReadDuration: function(wordDuration, imageDuration) {
    var WORD_DURATION = 250; // milliseconds
    var IMAGE_DURATION = 0; // milliseconds
    if (typeof wordDuration === 'undefined') {
      wordDuration = WORD_DURATION;
    }
    if (typeof imageDuration === 'undefined') {
      imageDuration = IMAGE_DURATION;
    }

    var stepDuration;
    if (
      this.steps &&
      this.steps.length > 0 &&
      !this.get('summary') &&
      this.get('type') !== 'SCROLL' // ignore broken non-postprocessed SCROLL substeps (See https://github.com/iorad/iorad/issues/12775)
    ) {
      stepDuration = this.steps.getReadDuration();
    } else {
      var parser = document.createElement('div');
      parser.innerHTML = sanitizeHtml(this.get('description'), iorad.base.Export.STEP_DESCRIPTION_APP_SANITIZE_RULES);
      var descriptionText = parser.innerText;
      var descriptionWords = descriptionText.trim().split(/\s+/);
      stepDuration = (descriptionWords.length * wordDuration) + imageDuration;
    }
    return stepDuration;
  },

  isReadAutoadvance: function () {
    return (
      this.get('type') === 'READ' &&
      this.get('event.autoadvance') !== false
    );
  },

  isReadInfotext: function () {
    return (
      this.get('type') === 'READ' &&
      this.get('event.infotext') === true
    );
  },
});

;
iorad.base.models.tutorial = Backbone.DeepModel.extend({

  defaults: function() {
    var layoutOptions = window.iorad.allLayoutOptionsAllModes.reduce(function (obj, option) {
      obj[option] = false;
      return obj;
    }, {});

    return _.extend({
      title: 'How to be awesome',
      author: 'Anon Ymous',
      authoremail: '',
      created: Date.now(), // number of milliseconds or formatted date as string
      updated: Date.now(), // number of milliseconds or formatted date as string
      views: 0,
      likes: 0,
      duration: 0, // number of milliseconds (compatible with JavaScript Date object)
      liked: false,
      public: true,
      theme: null, // id of used theme (optional)
      isLiveTutorial: false,
      liveDisabled: false,
      category: '',
      subcategory: '',
      markerColorsApplyToAll: false,
      emailDomains: '',
      isEmailDomainAllowed: false,
      liveURL: null,
      liveExactURL: null,
      language: window.userAcceptedLocale,
    }, layoutOptions);
  },

  setSteps: function(steps) {
    if (this.steps) this.stopListening(this.steps);
    this.steps = steps;
  },

  setTitle: function (newTitle) {
    if (newTitle === this.get('title')) return;

    this.set({
      title: newTitle,
      aiWrittenTitle: null,
      aiWrittenTitleOriginal: null,
    });
  },

  setDescription: function (newDescription) {
    if (newDescription === this.get('description')) return;
    this.set({
      description: newDescription,
      aiWrittenDescription: null,
      aiWrittenDescriptionOriginal: null,
    });
  },

  setSearch: function (newSearch) {
    if (newSearch === this.get('search')) return;
    this.set({
      search: newSearch,
      aiWrittenSearch: null,
      aiWrittenSearchOriginal: null,
    });
  },

  normalizeLiveURL: function(url) {
    // validate url with the core URL parser
    // (adding protocol since otherwise it throws)
    if (!url) return '';
    try {
      new URL(url);
      if (url.indexOf(':/') === -1) {
        // still no protocol
        // (the URL parser didn't detected it, it happens when the url contains a port,
        // e.g. local.iorad.com:9000/editor.html?module=DEV&uid=DEV#finish)
        throw new Error();
      }
    } catch (e) {
      try {
        // try by adding protocol
        url = (new URL('http://' + url)).href;
      } catch (e) {
        return '';
      }
    }

    // remove protocol
    url = url.slice(url.indexOf('//') + 2);

    // remove ending /
    if (url[url.length-1] === '/') url = url.slice(0, url.length-1);

    return url;
  },

  validateUrl: function(url) {
    // http://stackoverflow.com/questions/3809401/what-is-a-good-regular-expression-to-match-a-url
    // return url.match(new RegExp(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/gi));
    return !!this.normalizeLiveURL(url);
  },

  setLiveURL: function (url) {
    this.set('liveURL', this.normalizeLiveURL(url));
  },

  setLiveExactURL: function (url) {
    this.set('liveExactURL', this.normalizeLiveURL(url));
  },

  // @param labelsToAdd array
  extendLabel: function(labelsToAdd) {
    var currentLabels = _.map((this.get('label') || '').split(';'), function(label) {
      return label.trim();
    });
    var newLabels = _.uniq(_.compact(currentLabels.concat(labelsToAdd)));
    this.set('label', newLabels.join(';'));
  },

  setCategory: function(newCategory) {
    var oldCategory = this.get('category');
    var oldSubcategory = this.get('subcategory');
    this.set({
      category: newCategory,
      subcategory: (oldCategory !== newCategory)
        ? ''
        : oldSubcategory,
    });
  },

  setSubcategory: function(newSubcategory) {
    this.set('subcategory', newSubcategory);
  },

  // can be used for both created and updated date.
  // format: June 28, 2013
  getFormattedDate: function(dateAttribute) {
    var attribute = this.get(dateAttribute);

    var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July",
      "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    var date = new Date(attribute);
    var monthName = monthNames[date.getMonth()];
    var day = date.getDate();
    var year = date.getFullYear();
    var formattedDate = monthName + " " + year;

    return formattedDate;
  },

  // NOTE: duration must be in milliseconds
  getFormattedDuration: function(duration) {
    if (typeof duration === 'undefined') {
      duration = this.get('duration');
    }
    var durationMinutes = Math.ceil(Math.max(duration / 60000, 1));

    var durationString;
    var minuteDurationKey = 'TUTORIAL_DURATION::min';
    if (window.i18next && window.i18next.exists(minuteDurationKey)) {
      durationString = window.i18next.t(minuteDurationKey, { count: durationMinutes });
    } else {
      var strNail = (durationMinutes > 1 || durationMinutes === 0) ? 's' : '';
      durationString = 'min' + strNail;
    }

    return durationMinutes + ' ' + durationString;
  },

  isLive: function(stepsCollection) {
    return stepsCollection.length > 0 && typeof stepsCollection.getModelAt(0).get('component.locator') !== 'undefined';
  },

  disableLive: function() {
    this.set('liveDisabled', true);
    this.set('guideMeMode', 'practice');
  },

  enableLive: function() {
    this.set('liveDisabled', false);
    this.set('guideMeMode', 'practice,live');
  },

  getFormattedReadDuration: function(stepsCollection) {
    var duration = stepsCollection.getReadDuration(stepsCollection);
    return this.getFormattedDuration(duration);
  },

  getFormattedPlayDuration: function (stepsCollection) {
    var duration = stepsCollection.getPlayDuration(stepsCollection);
    return this.getFormattedDuration(duration);
  },

  isPublic: function() {
    return this.get('public') && !this.get('list_type');
  },

  isUnlisted: function() {
    return this.get('public') && this.get('list_type');
  },

  isInviteOnly: function() {
    return !this.get('public') && !this.get('embedOnly');
  },

  isEmbedOnly: function() {
    return !this.get('public') && this.get('embedOnly');
  },

  getDomainUrl: function () {
    var tutorialLiveURL = this.get('isLiveTutorial') && (
      this.get('liveURL') ?
        ('https://' + this.get('liveURL'))
        :
        iorad.app.data.stepsCollection.getModelAt(0).get('window.url')
    );
    var tutorialLiveURLIsValid = false;
    var tutorialLiveURLParsed;
    if (tutorialLiveURL && typeof tutorialLiveURL === 'string') {
      try {
        tutorialLiveURLParsed = new URL(tutorialLiveURL);
      } catch (err) {
        console.error(err);
        tutorialLiveURLParsed = { hostname: null };
      }
      var tutorialLiveURLHostname = tutorialLiveURLParsed.hostname;
      if (tutorialLiveURLHostname) {
        var tutorialLiveURLHostnameParts = tutorialLiveURLHostname.split('.');
        if (!(
          tutorialLiveURLHostnameParts.length === 1 ||
          tutorialLiveURL.startsWith('file:') ||
          ['localhost', 'local', 'pprod'].includes(_.last(tutorialLiveURLHostnameParts)) ||
          tutorialLiveURLHostname.includes('%')
        )) {
          tutorialLiveURLIsValid = true;
        }
      }
    }
    return tutorialLiveURLIsValid ? tutorialLiveURL : null;
  },

  getDomainUrlHostname: function () {
    const domainUrl = this.getDomainUrl();
    if (!domainUrl) return null;
    try {
      return (new URL(domainUrl)).hostname;
    } catch (err) {
      console.error(err);
      return null;
    }
  },

  getDomainUrlRuleContains: function () {
    if (this.getDomainUrl() && this.get('isLiveTutorial') && this.get('liveURL')) {
      var tutorialLivePostFilterMode = this.get('livePostFilterMode');
      var tutorialLivePostFilterValue = this.get('livePostFilterValue');
      if (tutorialLivePostFilterMode === 'URL_CONTAINS' && tutorialLivePostFilterValue) {
        return tutorialLivePostFilterValue;
      }
    }
    return null;
  },

  // NOTE: assumes that url is valid
  getDomainLabel: function (url, options) {
    url = url || this.getDomainUrl();
    options = options || {};
    if (!url) return null;
    return (
      (new URL(url).host)
        .replace(/\.[^\.]+$/, '')
        .replace(/^www./, '')
        .split('.')
        .slice(
          options.base ?
            -1 // base domain only
            :
            0 // all
        )
        .reverse()
        .map(_.bind(function (target) {
          // capitalize like lodash
          if (target.toLowerCase() === 'iorad') {
            // special case for iorad: use full lowercase
            return 'iorad';
          }
          return target.charAt(0).toUpperCase() + target.slice(1).toLowerCase();
        }, this))
        .join(' ')
    );
  },

  getScreenshotOverlayAllStepsEnabled: function () {
    if (iorad.app === iorad.player && iorad.player.getParameters.screenshotOverlayAllStepsEnabled) {
      return iorad.player.getParameters.screenshotOverlayAllStepsEnabled === 'true';
    }
    return this.get('screenshotOverlayAllStepsEnabled');
  },

  getScreenshotOverlayColor: function () {
    if (iorad.app === iorad.player && iorad.player.getParameters.screenshotOverlayColor) {
      return iorad.player.getParameters.screenshotOverlayColor;
    }
    return this.get('screenshotOverlayColor');
  },

  getScreenshotOverlayOpacity: function () {
    if (iorad.app === iorad.player && iorad.player.getParameters.screenshotOverlayOpacity) {
      return Number(iorad.player.getParameters.screenshotOverlayOpacity);
    }
    return this.get('screenshotOverlayOpacity');
  },

  getScreenshotOverlayEnter: function () {
    if (iorad.app === iorad.player && iorad.player.getParameters.screenshotOverlayEnter) {
      return iorad.player.getParameters.screenshotOverlayEnter;
    }
    return this.get('screenshotOverlayEnter');
  },

  getScreenshotOverlayFadeInDuration: function () {
    if (iorad.app === iorad.player && iorad.player.getParameters.screenshotOverlayFadeInDuration) {
      return Number(iorad.player.getParameters.screenshotOverlayFadeInDuration);
    }
    return this.get('screenshotOverlayFadeInDuration');
  },

  getScreenshotOverlayDynamicMousePosition: function () {
    if (
      iorad.app === iorad.player &&
      iorad.player.getParameters.screenshotOverlayDynamicMousePosition
    ) {
      return iorad.player.getParameters.screenshotOverlayDynamicMousePosition === 'true';
    }
    return this.get('screenshotOverlayDynamicMousePosition');
  },

  getScreenshotOverlayHideOnTransparentInfoSteps: function () {
    if (
      iorad.app === iorad.player &&
      iorad.player.getParameters.screenshotOverlayHideOnTransparentInfoSteps
    ) {
      return iorad.player.getParameters.screenshotOverlayHideOnTransparentInfoSteps === 'true';
    }
    return this.get('screenshotOverlayHideOnTransparentInfoSteps');
  },

  getDefaultQuizStarterText: function() {
    return {
      title: i18next.t('Quiz Time'),
      titleIsHTML: false,
      text: [
        i18next.t("Let's test your memory!"),
        i18next.t("You'll be performing the same task in the quiz——give it your best shot."),
        i18next.t('Click anywhere to begin.'),
      ].join('\n\n'),
      textIsHTML: false,
    };
  },

  isLimitedTrial: function () {
    return Boolean(
      this.get('account_is_trialing') &&
      (
        this.get('account_trialing_end') ||
        this.get('account_is_trialing_with_quota')
      )
    );
  },
});

;
iorad.base.models.markerColors = Backbone.Model.extend({

  defaults: function () {
    const siteThemeColor = window.getComputedStyle(document.documentElement).getPropertyValue('--site-theme-color') || '#FF00D6';
    
    return {
      'READ': siteThemeColor,
      'font_READ': '',

      'LEFT_CLICK': siteThemeColor,
      'font_LEFT_CLICK': '',

      'RIGHT_CLICK': siteThemeColor,
      'font_RIGHT_CLICK': '',

      'SCROLL': siteThemeColor,
      'font_SCROLL': '',

      'TYPING': siteThemeColor,
      'font_TYPING': '',

      'DRAG': siteThemeColor,
      'font_DRAG': '',

      'DROP': siteThemeColor,
      'font_DROP': '',

      'DRAG_AND_DROP': siteThemeColor,
      'font_DRAG_AND_DROP': '',

      'HOVER': siteThemeColor,
      'font_HOVER': '',

      'SELECT_TEXT': siteThemeColor,
      'font_SELECT_TEXT': '',
    };
  },

  setColors: function(markerColor, markerFontColor) {
    var changedAttributes = _.keys(this.attributes).reduce(function(obj, key) {
      if (key.startsWith('font_')) {
        if (markerFontColor) obj[key] = markerFontColor;
      } else {
        if (markerColor) obj[key] = markerColor;
      }
      return obj;
    }, {});
    if (!_.isEmpty(changedAttributes)) {
      this.set(changedAttributes);
    }
  },
});

;
iorad.base.models.liveUrlConfig = Backbone.Model.extend({
  defaults: function () {
    return {
    };
  },
});

;
iorad.base.models.framesUrlCache = Backbone.Model.extend({
  defaults: function () {
    return {
    };
  },
});

;
iorad.base.collections.themes = Backbone.Collection.extend({
  model: iorad.base.models.theme,
});
;
iorad.base.collections.steps = Backbone.Collection.extend({
  model: iorad.base.models.step,

  comparator: 'index',

  position: -1,

  triggers: function(custom) {
    if (custom) this.trigger(custom);
    // Second argument is for backwards compatability
    this.trigger('changeCurrent', this.position, this.position);
  },

  // Backwards compatability with old slides collection
  getSteps: function() {
    return this;
  },

  insert: function(steps, atIndex) {
    if (atIndex == null) {
      atIndex = this.position + 1;
    }
    atIndex = Math.min(this.length, atIndex);
    if (!_.isArray(steps)) {
      steps = [steps];
    }
    this.each(function(item, index) {
      if (index >= atIndex) {
        index = index + steps.length;
      }
      item.set('index', index);
    });
    _.each(steps, function(item, index) {
      if (item instanceof Backbone.Model) {
        item.set('index', atIndex + index);
      } else {
        item.index = atIndex + index;
      }
    });
    this.add(steps, {
      at: atIndex,
    });
    this.trigger('resize');
  },

  // Set current step to the step number (1-indexed for legacy
  // reasons) or to a given step model
  setCurrentStep: function(stepNumber, options) {
    options = options || {};

    var prevPosition = this.position;
    if (stepNumber instanceof Backbone.Model) {
      stepNumber = this.indexOf(stepNumber) + 1;
    }
    this.position = stepNumber - 1;
    // Sending position twice for backwards compatability with old
    // code that had seperate slides and steps
    if (this.position !== prevPosition || options.force) {
      //only trigger if currentStep changed
      this.trigger('changeCurrent', this.position, this.position);
    }
  },

  getCurrentStepNumber: function() {
    return this.position + 1;
  },

  getCurrentModel: function() {
    if (this.position < 0) {
      // with this.at, negative number(s) return the model(s) from the end
      // => prevent it
      return null;
    }
    return this.at(this.position);
  },

  getNextModel: function() {
    if (this.position < 0) {
      // with this.at, negative number(s) return the model(s) from the end
      // => prevent it
      return this.at(0);
    }
    return this.at(this.position + 1);
  },

  getPreviousModel: function() {
    if (this.position <= 0) {
      // with this.at, negative number(s) return the model(s) from the end
      // => prevent it
      return null;
    }
    return this.at(this.position - 1);
  },

  getModelAt: function (position) {
    if (position < 0) {
      // with this.at, negative number(s) return the model(s) from the end
      // => prevent it
      return null;
    }
    return this.at(position);
  },

  getFlattenedPosition: function() {
    var flattenedPosition = 0;
    for (var i = this.position - 1; i >= 0; i--) {
      var aStep = this.at(i);
      if (
        !aStep.get('summary') &&
        aStep.steps.length > 0 &&
        aStep.get('type') !== 'SCROLL' // ignore broken non-postprocessed SCROLL substeps (See https://github.com/iorad/iorad/issues/12775)
      ) {
        flattenedPosition += aStep.steps.length;
      } else {
        flattenedPosition++;
      }
    }
    return flattenedPosition;
  },

  // start to listen to collection change events for preloading the step images.
  // Note: the activate function is needed to lazy start the preloading just when displaying steps
  activateImagesPreloading: function() {
    if (!this.imagesPreloadingActivated) {
      this.listenTo(this, 'reset', this.preload);
      this.preload();
      this.imagesPreloadingActivated = true;
    }
  },

  // Preload the screenshots for the steps, in order
  preload: function() {
    if (this._preloading) {
      // TODO: block current preloading instead that ignoring the new request (e.g. after reset) !
      return;
    }
    this._preloading = true;
    this._preloaded = false;
    this.sort();

    var accumulatedTime = 0;
    console.log('Start preloader');
    var toPreload = _.clone(this.models);
    var preloadNext = _.bind(function() {
      var next = toPreload.shift();
      if (!next) {
        this._preloading = false;
        this._preloaded = true;
        this.trigger('preloaded');
        console.log('Preloading complete');
        return;
      }
      var startTime = Date.now();
      next.preload().then(function() {
        var endTime = Date.now();
        accumulatedTime += endTime - startTime;
        if (accumulatedTime >= 200) {
          accumulatedTime = 0;
          // (delay used to prevent UI blocking)
          return iorad.base.Utils.delay(150);
        }
      }).then(preloadNext);
    }, this);
    _.defer(preloadNext);
  },

  preloaded: function() {
    return new Promise(_.bind(function(resolve) {
      if (this._preloaded) {
        resolve();
      } else {
        if (!this._preloading) this.preload();
        this.listenToOnce(this, 'preloaded', resolve);
      }
    }, this));
  },

  // NOTE: duration must be in milliseconds
  // result: '1 min: 24 secs'
  getFormattedDuration: function(duration) {
    if (!duration) return '';

    var durationMinutes = Math.floor(duration / 60000);
    var durationLeft = duration - (durationMinutes * 60000);
    var durationSeconds = Math.ceil(durationLeft / 1000);

    var durationMinWord;
    var minuteDurationKey = 'STEPS_DURATION::min';
    if (window.i18next && window.i18next.exists(minuteDurationKey)) {
      durationMinWord = window.i18next.t(minuteDurationKey, { count: durationMinutes });
    } else {
      var minStrNail = (durationMinutes > 1 || durationMinutes === 0) ? 's' : '';
      durationMinWord = 'min' + minStrNail;
    }

    var durationSecWord;
    var secondDurationKey = 'STEPS_DURATION::sec';
    if (window.i18next && window.i18next.exists(secondDurationKey)) {
      durationSecWord = window.i18next.t(secondDurationKey, { count: durationSeconds });
    } else {
      var secStrNail = (durationSeconds > 1 || durationSeconds === 0) ? 's' : '';
      durationSecWord = 'sec' + secStrNail;
    }

    return (durationMinutes + ' ' + durationMinWord) +
      ': ' +
      (durationSeconds + ' ' + durationSecWord);
  },

  getReadDuration: function() {
    return this.reduce(_.bind(function(duration, stepModel) {
      var stepDuration = stepModel.getStepReadDuration();
      return duration + stepDuration;
    }, this), 0);
  },

  getFormattedReadDuration: function() {
    return this.getFormattedDuration(this.getReadDuration());
  },

  getPlayDuration: function () {
    return this.reduce(_.bind(function (duration, stepModel) {
      var stepDuration = (
        stepModel.get('videoDurationMS') ||
        stepModel.get('audioDurationMS') ||
        stepModel.getStepReadDuration() // for obsolete tutorials or for steps that have been manually modified (e.g. type changed)
      );
      return duration + stepDuration;
    }, this), 0);
  },

  getFormattedPlayDuration: function () {
    return this.getFormattedDuration(this.getPlayDuration());
  },

  getCaptureDuration: function() {
    return this.reduce(_.bind(function(duration, stepModel) {
      var stepDuration = stepModel.get('event.captureDuration') ||
        stepModel.getStepReadDuration(); // for obsolete tutorials or for steps that have been manually modified (e.g. type changed)
      return duration + stepDuration;
    }, this), 0);
  },

  getFormattedCaptureDuration: function() {
    return this.getFormattedDuration(this.getCaptureDuration());
  },

  getQuizDefaultAccuracy: function() {
    return 80;
  },

  toQuiz: function() {
    // exclude all READ steps and the last step (where reports are shown)
    var stepModels = this.filter(_.bind(function(stepModel, i) {
      return stepModel.get('type') !== 'READ' && i < this.length - 1;
    }, this));
    var newCollection = new this.constructor(stepModels);
    return newCollection;
  },
});

;
// Keep in sync models and collections with the backends.

iorad.base.SyncController = (function() {

  var processEnv = window.__processEnv || {};

  var SyncController = function() {
    this.initialize.apply(this, arguments);
  };

  _.extend(SyncController.prototype, Backbone.Events, {

    initialize: function (app, tutorial, stepsCollection, themesCollection, defaultSettings, markerColors, liveUrlConfig, framesUrlCache) {
      this.app = app;
      this.tutorial = tutorial;
      this.stepsCollection = stepsCollection;
      this.themesCollection = themesCollection;
      this.defaultSettings = defaultSettings; // optional (editor only, actually)
      this.markerColors = markerColors;
      this.liveUrlConfig = liveUrlConfig;
      this.framesUrlCache = framesUrlCache;
      this.version = undefined;
      if (iorad.app === iorad.player) {
        this.localforageComponent = new iorad.player.LocalforageComponent();
      }
    },

    userId: -1,
    tutorialId: -1,

    _callNodeService: function(servicePath, httpMethod, params, options) {
      return new Promise(_.bind(function(resolve, reject) {
        try {
          options = options || {};

          options.disableDefaults = options.disableDefaults || false;

          var endpoint = iorad.base.Settings.get('server.services.node.url', {
            path: servicePath,
          });

          params = params || {};

          if (options.storedSettings && options.storedSettings.override) {
            if (typeof options.storedSettings.override !== 'boolean') {
              return resolve(options.storedSettings.override);
            }
            if (options.storedSettings.url) endpoint = options.storedSettings.url;
            if (options.storedSettings.type) httpMethod = options.storedSettings.type;
            if (options.storedSettings.params) params = options.storedSettings.params;
          }

          var extraOptions = {};

          if (!options.disableDefaults) {
            if (params instanceof FormData) {
              params.append('user_id', this.userId);
              params.append('tutorial_id', this.tutorialId);
            } else {
              params = _.defaults(params, {
                user_id: this.userId,
                tutorial_id: this.tutorialId,
              });
            }
          }

          var sendJson = (params instanceof FormData === false && httpMethod !== 'GET');

          var success = function(data, reqStatus, jqXHR) {
            if (reqStatus !== 'success' && jqXHR.status !== 204) {
              reject(reqStatus);
            } else {
              resolve(data);
            }
          };
          var error = function(req, errorMsg) {
            reject(req.responseJSON || req.responseText || errorMsg);
          };
          var credentialless = siteWindow.location.href.match(/[?&]credentialless=true(&|$|#)/);
          extraOptions = _.defaults({
            url: endpoint,
            type: httpMethod,
            data: sendJson ? JSON.stringify(params) : params,
            contentType: sendJson ? 'application/json' : false,
            xhrFields: {
              withCredentials: credentialless ? false : (
                typeof options.withCredentials !== 'undefined'
                  ? options.withCredentials
                  : true // send cookies even in cross origin requests (needed in development)
              ),
            },
            headers: {
              ...(credentialless ? { 'iorad-credentialless': 'true' } : {}),
            },
            timeout: options.timeout || 0,
            dataType: 'json',
            processData: params instanceof FormData ? false : true,
            success: success,
            error: error,
          }, extraOptions);

          $.ajax(extraOptions);
        } catch (err) {
          reject(err);
        }
      }, this));
    },

    // return a promise that resolves with an object {PUBLIC_LINK, EMBED}.
    // the PUBLIC_LINK will be obtained from the server if an override is not specified.
    getPlayerURL: function(options) {
      options = options || {};

      var me = this;

      var override = iorad.base.Settings.get('server.playerURL.override');
      if (override) {
        var publicLink = iorad.base.Settings.get('server.playerURL.override.PUBLIC_LINK', {
          dirBasePath: iorad.base.Utils.getDirBasePath()
        });
        var publicLinkIframeHashTemplate = iorad.base.Settings.get('server.playerURL.override.PUBLIC_LINK_IFRAME_HASH_TEMPLATE', {
          dirBasePath: iorad.base.Utils.getDirBasePath(),
        });
        var quizLink = iorad.base.Settings.get('server.playerURL.override.QUIZ_LINK', {
          dirBasePath: iorad.base.Utils.getDirBasePath(),
        });
        return Promise.resolve({
          PUBLIC_LINK: publicLink,
          PUBLIC_LINK_IFRAME_HASH_TEMPLATE: publicLinkIframeHashTemplate,
          QUIZ_LINK: quizLink,
          EMBED: iorad.base.Settings.get('server.playerURL.EMBED', {
            publicLink: publicLink,
            tutorialText: me.getEmbedCodeTutorialText()
          }),
          EMBED_IFRAME_HASH_TEMPLATE: iorad.base.Settings.get('server.playerURL.EMBED', {
            publicLink: publicLinkIframeHashTemplate,
            tutorialText: me.getEmbedCodeTutorialText()
          }),
          SHORT_LINK: iorad.base.Settings.get('server.playerURL.override.SHORT_LINK'),
          SHORT_LINK_IFRAME_HASH_TEMPLATE: iorad.base.Settings.get('server.playerURL.override.SHORT_LINK_IFRAME_HASH_TEMPLATE'),
          SHORT_LINK_HELP_CENTER: iorad.base.Settings.get('server.playerURL.override.SHORT_LINK_HELP_CENTER'),
          SHORT_LINK_HELP_CENTER_IFRAME_HASH_TEMPLATE: iorad.base.Settings.get('server.playerURL.override.SHORT_LINK_HELP_CENTER_IFRAME_HASH_TEMPLATE'),
          STATIC_LINK: iorad.base.Settings.get('server.playerURL.override.STATIC_LINK'),
          VIEW_LIVE_LINK: iorad.base.Settings.get('server.playerURL.override.VIEW_LIVE_LINK'),
          LIVE_CODE: iorad.base.Settings.get('server.playerURL.LIVE_CODE'),
        });
      }

      var getEncodedTutorialTitle = _.bind(function() {
        return this.tutorial.get('title').replace(/[^a-zA-Z0-9]/g, '-');
      }, this);

      // use (prefetched) client-side cache for quick response on change
      // Note: assumes that short url doesn't change
      var promise;
      if (window.getPlayerURLData && !window.getPlayerURLData._partial && !options.refetch) {

        // update cache with current tutorial title
        function updateLinkWithTitle(linkType) {
          var link = window.getPlayerURLData[linkType];

          var suffix = '';
          var suffixIndex = link.indexOf('?');
          if (suffixIndex !== -1) {
            // remove suffix to add it back later
            suffix = link.slice(suffixIndex);
            link = link.slice(0, suffixIndex);
          }

          var publicLinkParts = link.split('/');
          publicLinkParts[publicLinkParts.length - 1] = getEncodedTutorialTitle(); // last part is tutorial title
          var newPublicLink = publicLinkParts.join('/') + suffix;
          window.getPlayerURLData[linkType] = newPublicLink;
        }
        updateLinkWithTitle('PUBLIC_LINK');
        updateLinkWithTitle('PUBLIC_LINK_IFRAME_HASH_TEMPLATE');
        updateLinkWithTitle('QUIZ_LINK');

        promise = Promise.resolve(window.getPlayerURLData);
      } else {
        // no cache yet (or refetch)
        if (options.refetch && !options.doNotUpdateCache) {
          // clear cache, need in case of multiple fast calls
          window.oldGetPlayerURLData = window.getPlayerURLData;
          window.getPlayerURLData = undefined;
        }
        promise = this.callGetPlayerURLService(options).then(_.bind(function(data) {
          if (!options.doNotUpdateCache) {
            // update cache
            window.getPlayerURLData = data;
          }

          return data;
        }, this));
      }

      return promise.then(function(data) {
        var publicLink = data.PUBLIC_LINK;
        if (publicLink.startsWith('//')) {
          // protocol is missing from returned url since can be either https or http,
          // add what we are using now.
          publicLink = location.protocol + publicLink;
        }
        var publicLinkIframeHashTemplate = data.PUBLIC_LINK_IFRAME_HASH_TEMPLATE;
        if (publicLinkIframeHashTemplate.startsWith('//')) {
          // protocol is missing from returned url since can be either https or http,
          // add what we are using now.
          publicLinkIframeHashTemplate = location.protocol + publicLinkIframeHashTemplate;
        }
        var quizLink = data.QUIZ_LINK;
        if (quizLink.startsWith('//')) {
          // protocol is missing from returned url since can be either https or http,
          // add what we are using now.
          quizLink = location.protocol + quizLink;
        }
        var viewLiveLink =
          (data.VIEW_LIVE_LINK.startsWith('//') ? location.protocol : '') +
          data.VIEW_LIVE_LINK;

        return Promise.resolve(_.extend({}, data, {
          PUBLIC_LINK: publicLink,
          PUBLIC_LINK_IFRAME_HASH_TEMPLATE: publicLinkIframeHashTemplate,
          QUIZ_LINK: quizLink,
          VIEW_LIVE_LINK: viewLiveLink,
          LIVE_CODE: iorad.base.Settings.get('server.playerURL.LIVE_CODE'),
        }));
      });
    },

    // #2533
    // TODO: obsolete (server-side code changed)
    getEmbedCodeTutorialText: function() {
      var text = '';

      var template = '<p style="display: none;">{{description}}</p>';
      var stripHtmlEl = document.createElement("div");
      this.stepsCollection.each(function(step) {
        var description = step.getDescription();

        // step description may contain html => strip it
        stripHtmlEl.innerHTML = sanitizeHtml(description, iorad.base.Export.STEP_DESCRIPTION_APP_SANITIZE_RULES);
        description = stripHtmlEl.textContent;

        text += Mustache.render(template, {
          description: description
        });
      }, this);

      return text;
    },

    // moved to separate function so to be overridable by subtypes
    callGetPlayerURLService: function(options) {
      options = options || {};
      return this._callNodeService('tutorial/getPlayerURL', 'GET', {
        is_share_url: true,
      });
    },

    extensionStatus: function() {
      return this._callNodeService('extensionStatus', 'GET');
    },

    detectLanguage: function(text) {
      return this._callNodeService('tutorial/detectLanguage', 'POST', {
        text: text,
      }, {
        withCredentials: false, // make it work on downloaded player env
      });
    },

    saveNotyStatistics: function (data) {
      return this._callNodeService('user/saveNotyStatistics', 'POST', data);
    },

    saveUserData: function (data) {
      return this._callNodeService('user/saveUserData', 'POST', data).catch(_.bind(function(err) {
        console.error(err);
        // noty({
        //   text: 'Unexpected error.',
        //   type: 'error',
        // });
      }, this));
    },

    checkUnexpectedError: function (err, details, options) {
      options = options || {};

      details = details || {};
      if (details.name) {
        console.error(details.name, err);
      } else {
        console.error(err);
      }

      var browserIsBot = (
        typeof navigator.userAgent === 'string' &&
        Boolean(navigator.userAgent.match(/bot|crawler|spider|crawling|scanner|audit|slurp|megaindex|yandex|facebookexternalhit|bing|tdd-content|BUbiNG|Qwantify/i))
      );
      if (
        browserIsBot ||
        (iorad.app === iorad.player && iorad.player.notracking) ||
        (iorad.app === iorad.player && window.downloadPlayerType) ||
        (iorad.app !== iorad.editor && options.editorOnly) ||
        options.ioradSkipNotify
      ) {
        return Promise.resolve();
      }

      return this._callNodeService('checkUnexpectedError', 'POST', {
        err: err instanceof Error ? _.extend({
          message: err.message,
          stack: err.stack,
        }, err) : err,
        details: _.extend({
          app: iorad.app === iorad.player ? 'player' : 'editor',
          appReferrer: siteWindow.document.referrer,
        }, details),
      });
    },

    hasEditAccess: function() {
      if (!this.hasEditAccessPromise) {
        this.hasEditAccessPromise = this._callNodeService('tutorial/hasEditAccess', 'GET');
      }
      return this.hasEditAccessPromise;
    },

    canUpdateDisabledStatus: function() {
      if (!this.canUpdateDisabledStatusPromise) {
        this.canUpdateDisabledStatusPromise = this._callNodeService('tutorial/canUpdateDisabledStatus', 'GET');
      }
      return this.canUpdateDisabledStatusPromise;
    },

    publishDraft: function() {
      return this._callNodeService('tutorial/publishDraft', 'POST')
        .then(_.bind(function(result) {
          var playerURL = result.playerURL;

          iorad.app.draftPublished = true;

          siteWindow.ioradNodeApp.setLocation(
            iorad.base.Settings.get('mytutorials.url')
          );

          var publishedPlayerURL = playerURL +
            (playerURL.indexOf('?') === -1 ? '?' : '&') +
            'draftPublished=true';
          window.open(publishedPlayerURL, '_blank');
        }, this))
        .catch(_.bind(function(err) {
          console.error(err);
          noty({
            text: 'Operation failed.',
            type: 'error',
          });
        }, this));
    },

    getRecommendedSuggestions: function (params) {
      return this._callNodeService('tutorial/getRecommendedSuggestions', 'GET', params);
    },

    getLastEditorAvatarURL: function() {
      return window.tutorialLastEditorImg || iorad.base.Settings.get('avatar.url', {
        user_id: this.tutorial.get('last_editor_id'),
      });
    },

    getDecryptedAssetRemotePath: function(name, cache) {
      return iorad.base.Settings.get('server.save.decryptedAssetRemotePath', {
        user_id: this.userId,
        tutorial_id: this.tutorialId,
        key: encodeURIComponent(this.tutorial.get('assetsKey') || ''),
        name: encodeURIComponent(name),
        cache: cache || '',
      });
    },

    fetchDecryptedAsset: function (name, cache) {
      return new Promise((resolve, reject) => {
        const decryptedAssetRemotePath = this.getDecryptedAssetRemotePath(name, cache);

        const xhr = new XMLHttpRequest();
        xhr.open('GET', decryptedAssetRemotePath, true);
        //xhr.responseType = 'blob';
        xhr.timeout = 10000;
        xhr.onload = function () {
          if (xhr.status === 200) {
            resolve(xhr.response);
          } else {
            reject(new Error(xhr.statusText, {
              cause: {
                statusCode: xhr.status,
              },
            }));
          }
        };
        xhr.onerror = function () {
          reject(new Error(xhr.statusText, {
            cause: {
              statusCode: xhr.status,
            },
          }));
        };
        xhr.send();
      });
    },

    getImageRemotePath: function(imageId, imageExt, cache) {
      return iorad.base.Settings.get('server.save.imageRemotePath', {
        user_id: this.userId,
        tutorial_id: this.tutorialId,
        image_id: imageId,
        image_ext: imageExt || 'png',
        cache: cache || '',
        cdn_host: processEnv.CDN_HOST ? "//" + processEnv.CDN_HOST : ""
      });
    },

    getThemeImageRemotePath: function(imagename, cache) {
      return iorad.base.Settings.get('server.save.themeImageRemotePath', {
        user_id: this.userId,
        imagename: imagename,
        cache: cache || '',
        cdn_host: processEnv.CDN_HOST ? "//" + processEnv.CDN_HOST : ""
      });
    },

    getAudioRemotePath: function(audioId, audioExt, cache) {
      return iorad.base.Settings.get('server.save.audioRemotePath', {
        user_id: this.userId || iorad.player.userId,
        tutorial_id: this.tutorialId || iorad.player.tutorialId,
        audio_id: audioId,
        audio_ext: audioExt || 'mp3',
        cache: cache || '',
        cdn_host: processEnv.CDN_HOST ? "//" + processEnv.CDN_HOST : ""
      });
    },

    getVideoRemotePath: function(videoId, videoExt, cache) {
      return iorad.base.Settings.get('server.save.videoRemotePath', {
        user_id: this.userId || iorad.player.userId,
        tutorial_id: this.tutorialId || iorad.player.tutorialId,
        video_id: videoId,
        video_ext: videoExt || 'mp4',
        cache: cache || '',
        cdn_host: processEnv.CDN_HOST ? "//" + processEnv.CDN_HOST : ""
      });
    },

    getMusicRemotePath: function (musicId, musicExt, cache) {
      return iorad.base.Settings.get('server.save.musicRemotePath', {
        user_id: this.userId || iorad.player.userId,
        tutorial_id: this.tutorialId || iorad.player.tutorialId,
        music_id: musicId,
        music_ext: musicExt || 'mp3',
        cache: cache || '',
        cdn_host: processEnv.CDN_HOST ? "//" + processEnv.CDN_HOST : ""
      });
    },

    getFontRemotePath: function (fontFamily, cache) {
      return iorad.base.Settings.get('server.save.fontRemotePath', {
        user_id: this.userId || iorad.player.userId,
        tutorial_id: this.tutorialId || iorad.player.tutorialId,
        font_family: fontFamily,
        cache: cache || '',
        cdn_host: processEnv.CDN_HOST ? "//" + processEnv.CDN_HOST : ""
      });
    },

    getThemeFontRemotePath: function(imagename, cache, userId) {
      return iorad.base.Settings.get('server.save.themeImageRemotePath', {
        user_id: userId || this.userId || iorad.player.userId,
        imagename,
        cache: cache || '',
        cdn_host: processEnv.CDN_HOST ? "//" + processEnv.CDN_HOST : ""
      });
    },

    getQuestionUrl: function ({
      roleId,
      urlId,
      productName,
      productLabel,
      questionId,
      questionName,
      answerId,
      helpCenterShare = false,
    }) {
      var url;
      if (helpCenterShare && urlId) {
        url = '/s/hq/' + [
          urlId,
          roleId || '0',
          questionId,
          ...(answerId ? [answerId] : []),
        ].map(val => iorad.base.Utils.encodeShortLinkId(val)).join('/');
      } else {
        url = `${productName ? `/product/${productName}` : ''}/thesquare/questions/${questionId}/${(productLabel + ' ' + questionName).replace(/[^a-zA-Z0-9]/g, '-')}`;
        if (answerId) {
          url = `${url}/answers/${answerId}?fixedQuestionIdExpanded=${questionId}`;
        }
      }
      if (iorad.app === iorad.player && window.downloadPlayerType) {
        url = window.IORAD_ROOT + url;
      }
      return url;
    },

    getProductQuestionsUrl: function ({
      roleId,
      urlId,
      productId,
      helpCenterShare = false,
    }) {
      var url;
      if (helpCenterShare && urlId) {
        url = `/library/${urlId}/${roleId ? `?roleId=${encodeURIComponent(roleId)}` : ''}`;
      } else {
        url = `/thesquare/questions?productId=${encodeURIComponent(productId)}&resetFilters=1`;
      }
      if (iorad.app === iorad.player && window.downloadPlayerType) {
        url = window.IORAD_ROOT + url;
      }
      return url;
    },

    getCustomFontCSSText: function(fontFamily, defaultFontFamily) {
      return new Promise(_.bind(function(resolve, reject) {
        var fontFamilyToWeights = {
          'Libre Franklin': [300, 600],
          'Fahkwang': [400, 500],
        };
        var fontWeights = fontFamilyToWeights[fontFamily] || [400, 500, 600, 700, 800];
        var endpoint = 'https://fonts.googleapis.com/css?family=' + encodeURIComponent(fontFamily) + ':' + fontWeights.join(',');
        var success = function (data, reqStatus, jqXHR) {
          if (reqStatus !== 'success' && jqXHR.status !== 204) {
            reject(reqStatus);
          } else {
            var cssText = data;
            var finalCssText = cssText
              .replace(
                new RegExp(
                  iorad.base.Utils.escapeRegExp("font-family: '" + fontFamily + "'"),
                  'g'
                ),
                "font-family: '" + defaultFontFamily + "'"
              );

            // Some custom fonts may not have all weights available,
            // in that case we need to create fake font-faces for the missing weights,
            // we will use the closest available weight
            // See #14135
            const supportedFontFaces = [...finalCssText.matchAll(/@font-face {[\s\S]+?}/g)]
              .map(fontFace => {
                const fontFaceText = fontFace[0];
                const weight = fontFaceText.match(/font-weight: (\d+);/)[1];
                return {
                  weight: parseInt(weight),
                  text: fontFaceText,
                };
              });
            const supportedWeights = _.uniq(supportedFontFaces.map(fontFace => fontFace.weight));
            const missingWeights = fontWeights.filter(weight => !supportedWeights.includes(weight));
            if (missingWeights.length > 0 && supportedWeights.length > 0) {
              missingWeights.forEach(missingWeight => {
                const minBy = _.min; // underscorejs doesn't have minBy, but _.min accepts iteratee
                const closestWeight = minBy(supportedWeights, (w) => Math.abs(missingWeight - w));
                // clone closestWeight into weight
                const closestFontFaces = supportedFontFaces.filter(fontFace => fontFace.weight === closestWeight);
                const fakeFontFacesText = closestFontFaces
                  .map(fontFace => fontFace.text.replace(/font-weight: (\d+);/, `font-weight: ${missingWeight};`))
                  .join('\n');
                finalCssText += fakeFontFacesText;
              });
            }

            resolve(finalCssText);
          }
        };
        var error = function (req, errorMsg) {
          reject(req.responseJSON || req.responseText || errorMsg);
        };

        // TODO: change theme.font_data to mediumtext if we allowed for more fonts
        const match = fontFamily.match(new RegExp(`-([0-9]+).(ttf|woff2|woff)$`));
        if (match) {
          const url = this.getThemeFontRemotePath(fontFamily, '', match[1]);
          const ext = fontFamily.split('.')[1];
          const data = `
            @font-face {
              font-family: "${defaultFontFamily}";
              src: url("${url}") format("${ext === 'ttf' ? 'opentype' : ext}"),
              font-weight: 400;
            }
          `;

          success(data, 'success', { status: 204 });

          return;
        }

        function runAjax() {
          return $.ajax({
            url: endpoint,
            type: 'GET',
            contentType: false,
            xhrFields: {
              withCredentials: false, // prevent CORS errors
            },
            timeout: 0,
            success: success,
            error: error,
          });
        }

        try {
          window.ajaxCache = window.ajaxCache || {};
          window.ajaxCache[endpoint] = window.ajaxCache[endpoint] || {};
          if (window.ajaxCache[endpoint].promise) {
            return window.ajaxCache[endpoint].promise.then(success, error);
          }
          window.ajaxCache[endpoint].promise = runAjax();
        } catch (err) {
          console.error(err);

          runAjax();
        }

        // $.ajax({
        //   url: endpoint,
        //   type: 'GET',
        //   contentType: false,
        //   xhrFields: {
        //     withCredentials: false, // prevent CORS errors
        //   },
        //   timeout: 0,
        //   success: success,
        //   error: error,
        // });
      }, this));
    },

    insertFontToDocument: async function(fontRule, prefix = 'iorad-custom-font-') {
      const failures = [];
      try {
        const dataId = prefix + fontRule.name;
        const existingFontEl = document.querySelector('[data-id="' + dataId + '"]');
        if (!existingFontEl || existingFontEl.getAttribute('data-font-family') !== fontRule.family) {
          console.log('loading font', fontRule.family);
          const cssText = await this.getCustomFontCSSText(
            fontRule.family,
            fontRule.defaultFamily || fontRule.family
          );
          console.log('adding font', fontRule.family);
          // https://developer.mozilla.org/en-US/docs/Web/API/CSS_Font_Loading_API
          const cssTextFontFaceMatches = [...cssText.matchAll(/@font-face {([\s\S]+?)}/g)];
          await Promise.all(cssTextFontFaceMatches.map(async fontFaceMatch => {
            const fontFaceContentText = fontFaceMatch[1];
            const fontFaceContentLines = [...fontFaceContentText.matchAll(/^(.+)$/mg)].map(match => match[1]);
            const fontFaceProps = fontFaceContentLines.map(line => line.trim().match(/(.+?):(.+);/)).map(match => {
              if (!match) {
                return {
                  key: '',
                  value: '',
                };
              }
              return {
                key: match[1].trim().replace(/-./g, p => p.slice(1).toUpperCase()), // e.g. 'font-family' => 'fontFamily'
                value: match[2].trim().replace(/^'/, '').replace(/'$/, ''), // e.g. "'Libre Franklin'" => "Libre Franklin"
              };
            });
            const fontFaceFamily = fontFaceProps.find(prop => prop.key === 'fontFamily');
            const fontFaceSrc = fontFaceProps.find(prop => prop.key === 'src'); // e.g. "url(...) format('woff2')" => "url()"
            if (fontFaceFamily && fontFaceSrc) {
              const fontFaceDescriptors = fontFaceProps.filter(prop => !['fontFamily', 'src'].includes(prop.key)).map(prop => {
                // https://developer.mozilla.org/en-US/docs/Web/API/FontFace/FontFace#descriptors
                return {
                  key: prop.key.replace(/^font./, p => p.slice('font'.length).toLowerCase()), // e.g. "fontWeight" => "weight",
                  value: prop.value,
                };
              }).reduce((obj, prop) => {
                obj[prop.key] = prop.value;
                return obj;
              }, {});
              const matches = fontFaceSrc.value.match(/(url\(.+?\))/);
              if (matches) {
                const font = new FontFace(
                  fontFaceFamily.value,
                  matches[1], // e.g. "url(...) format('woff2')" => "url()"
                  fontFaceDescriptors
                );
                document.fonts.add(font);
                await font.load();
              }
            }
          }));
          const styleEl = document.createElement('style');
          styleEl.setAttribute('data-id', dataId);
          styleEl.setAttribute('data-font-family', fontRule.family);
          styleEl.innerHTML = ''; // empty since we use the font loading API
          if (existingFontEl) existingFontEl.remove();
          document.head.appendChild(styleEl);
        }
      } catch (err) {
        console.error(err);
        failures.push(err);
      }

      return failures;
    },

    getLocalforage: function() {
      if (!window.localforage && iorad.app === iorad.player) {
        return this.localforageComponent.load();
      }
      return Promise.resolve(window.localforage);
    },

    getCacheStore: function () {
      if (!this.getCacheStorePromise) {
        this.getCacheStorePromise = this.getLocalforage()
          .then(_.bind(function (localforage) {
            return localforage.createInstance({
              name: 'iorad.cache.v2',
              version: 1.0,
            });
          }, this));
      }
      return this.getCacheStorePromise;
    },

    getCacheTutorialKeyPrefix: function () {
      return 'tutorial.' + this.tutorialId + '.';
    },

    getJsonCacheKey: function () {
      var cacheKey = this.getCacheTutorialKeyPrefix() + 'json';
      return cacheKey;
    },

    getImageCacheKey: function (id) {
      var cacheKey = this.getCacheTutorialKeyPrefix() + 'image.' + id;
      return cacheKey;
    },

    // Fetch models and collections from server
    fetch: function(onSuccess, onFailure) {
      // execute request to server to get json (slides + images), parse it, create models and collections from it

      this.app.events.trigger("sync:fetch:before");

      var json = window.tutorialJson || {};
      this.version = window.tutorialVersion;

      if (typeof json != 'object') json = JSON.parse(json);
      else json = iorad.base.Utils.deepClone(json); // don't modify original window.tutorialJson
      console.log('Fetched JSON: ', json);

      return Promise.resolve()
        .then(_.bind(function () {
          var themesList = json.themes || [];
          var tutorial = json.tutorial || {};
          var defaultSettings = json.default || {};
          var markerColors = json.markerColors || {};
          var liveUrlConfig = json.liveUrlConfig || {};
          var framesUrlCache = json.framesUrlCache || {};
          var stepsList = json.steps || [];
          var screenshotsMap = json.screenshots || {}; // optional (mandatory if screenshots are referenced by id)
          var framesMap = json.frames || {}; // optional (mandatory if frames are referenced by id)
          var extractedFramesById = json.extractedFramesById;

          // use default standard theme if current one doesn't exist
          var currentTheme = _.findWhere(themesList, {
            id: tutorial.theme
          });
          var isStandardTheme = _.some(tutorial.baseThemes, function (standardTheme) {
            return standardTheme.id === tutorial.theme;
          });
          if (!currentTheme && !isStandardTheme) tutorial.theme = null;

          var processStepsList = _.bind(function (stepsList) {
            for (var i = 0, l = stepsList.length; i < l; i++) {
              var step = stepsList[i];
              // recursion
              if (step.steps) step.steps = processStepsList(step.steps);

              // resolve step screenshots from its list (if any)
              // (quick optimization for screenshots duplication,
              // needed in downloaded env since has base64 directly in fetched json)
              // Note: this will modify the fetched json!
              if (_.isString(step.screenshot)) { // screenshot is referenced by id
                // put the screenshot back
                step.screenshot = screenshotsMap[step.screenshot];
                // also process screenshot frames
                if (step.screenshot.frames) {
                  for (var j = 0; j < step.screenshot.frames.length; j++) {
                    var frame = step.screenshot.frames[j];
                    if (_.isString(frame)) { // frame is referenced by id
                      step.screenshot.frames[j] = framesMap[frame];
                    }
                  }
                }
              }
              if (
                step.screenshot &&
                !step.screenshot.frames &&
                step.screenshot.extractedFrameId
              ) {
                // recalculate step.screenshot.frames from extractedFramesById
                const frames = [];
                let extractedFrame = extractedFramesById[step.screenshot.extractedFrameId];
                while (extractedFrame) {
                  frames.unshift(_.omit(extractedFrame, 'previousFrameId'));
                  extractedFrame = extractedFrame.previousFrameId ?
                    extractedFramesById[extractedFrame.previousFrameId]
                    : null;
                }
                step.screenshot.frames = frames;
                delete step.screenshot.extractedFrameId;
              }

              // translate step descriptions (player-only)
              if (iorad.app === iorad.player) {
                var learnerChangedLanguage = iorad.player.controllers.language.learnerChangedLanguage();
                if (learnerChangedLanguage) {
                  step.description = this.app.controllers.language.translateStepDescription(step.description);
                }
              }
            }
            return stepsList;
          }, this);
          stepsList = processStepsList(stepsList);
          delete json.extractedFramesById;

          // set themes data (don't move below tutorial since its a dependency and must be setted first)
          this.themesCollection.reset(themesList);

          // set tutorial data
          if (tutorial) this.tutorial.set(tutorial);

          // set tutorial defaults data (if exists and is supported by current app)
          if (defaultSettings && this.defaultSettings) this.defaultSettings.set(defaultSettings);

          // set marker colors
          if (markerColors) this.markerColors.set(markerColors);
          this.markerColors.setColors(iorad.app.getParameters.markerColor, iorad.app.getParameters.markerFontColor);

          // set live url config
          if (liveUrlConfig) this.liveUrlConfig.set(liveUrlConfig);

          // set frames url cache
          if (framesUrlCache) this.framesUrlCache.set(framesUrlCache);

          // set steps data
          if (stepsList.length != 0) {
            this.stepsCollection.reset(stepsList);
          }

          this.app.events.trigger("sync:fetch:success");
          onSuccess(json);
        }, this));
    }

  });

  // Borrow the Backbone `extend` feature from View.
  SyncController.extend = Backbone.View.extend;

  return SyncController;
})();

;
iorad.base.ClientDetectController = (function() {
  "use strict";

  const browserInitial = {
    name: '',
    isOpera: false,
    isFirefox: false,
    isSafari: false, // TODO: this is not working right now
    isChrome: false,
    isIE: false,
    isEdge: false,
    isNewEdge: false,
  };

  const osInitial = {
    name: '',
    isWindows: false,
    isMac: false,
    isIOS: false,
    isLinux: false,
  };

  const deviceInitial = {
    name: '',
    isSmallScreen: false,
    isMobile: false,
    isPhone: false,
    isTablet: false,
    isDesktop: false,
  };

  const navigatorUADataInitial = {
    architecture: '',
    brand: '',
    model: '',
    platform: '',
    version: '',
    mobile: undefined, // currently undefined in chrome experimental
  };

  var ClientDetect = function() {
    this.initialize.apply(this, arguments);
  };
  _.extend(ClientDetect.prototype, Backbone.Events);
  _.extend(ClientDetect.prototype, {

    initialize: function() {
      this.navigatorUAData = navigatorUADataInitial;
      this.supportsClientHints = false;

      this.browser = browserInitial;
      this.os = osInitial;
      this.device = deviceInitial;
    },

    start: function() {
      return Promise.resolve()
        .then(this.detectNavigatorUAData.bind(this))
        .then(this.detectBrowser.bind(this))
        .then(this.detectOS.bind(this))
        .then(this.detectDevice.bind(this));
    },

    // ua-client-hints, newer browsers only (chrome experimental)
    // TODO: update once finalized in each browser
    detectNavigatorUAData: function() {
      // reset
      this.supportsClientHints = false;
      this.navigatorUAData = { ...navigatorUADataInitial };

      const getNavigatorUAData = (
        window.customIoradNavigatorUAData ? () => Promise.resolve(window.customIoradNavigatorUAData)
          : typeof navigator.getUserAgent === 'function' ? navigator.getUserAgent.bind(navigator)
            : null
      );
      if (getNavigatorUAData) {
        return getNavigatorUAData().then(_.bind(function(navigatorUAData) {
          this.supportsClientHints = true;
          this.navigatorUAData = {
            architecture: navigatorUAData.architecture || '',
            brand: navigatorUAData.brand || '',
            model: navigatorUAData.brand || '',
            platform: navigatorUAData.platform || '',
            version: navigatorUAData.version || '',
            mobile: typeof navigatorUAData.mobile === 'boolean' ? navigatorUAData.mobile : undefined,
          };
        }, this));
      }
    },

    // TODO: Maybe better to use Modernizr?
    detectBrowser: function() {
      // reset
      this.browser = { ...browserInitial };

      var isOpera = !!window.opera ||
        this.navigatorUAData.brand.indexOf("Opera") !== -1 ||
        navigator.userAgent.indexOf(' OPR/') !== -1;
      if (isOpera) {
        this.browser.isOpera = true;
        this.browser.name = 'opera';
        return;
      }

      var isEdge = this.navigatorUAData.brand.indexOf("Edge") !== -1 ||
        !!navigator.userAgent.match(/ Edge\/\d+/);
      if (isEdge) {
        this.browser.isEdge = true;
        this.browser.name = 'edge';
        return;
      }

      var isNewEdge = !!navigator.userAgent.match(/ Edg\/\d+/);
      if (isNewEdge) {
        this.browser.isNewEdge = true;
        this.browser.name = 'newEdge';
        return;
      }

      var isFirefox = this.navigatorUAData.brand.indexOf("Firefox") !== -1 ||
        typeof InstallTrigger !== 'undefined';
      if (isFirefox) {
        this.browser.isFirefox = true;
        this.browser.name = 'firefox';
        return;
      }

      var isSafari = this.navigatorUAData.brand.indexOf("Safari") !== -1 ||
        (window.navigator.userAgent.indexOf('Safari') !== -1 && window.navigator.userAgent.indexOf('Chrome') === -1); // Chrome can also contain "Safari" in the UA
      if (isSafari) {
        this.browser.isSafari = true;
        this.browser.name = 'safari';
        return;
      }

      var isChrome = !!window.chrome && !isOpera && !isEdge && !isNewEdge;
      if (isChrome) {
        this.browser.isChrome = true;
        this.browser.name = 'chrome';
        return;
      }

      var isIE = /MSIE|Trident/.test(window.navigator.userAgent);
      if (isIE) {
        this.browser.isIE = true;
        this.browser.name = 'explorer';
        return;
      }
    },

    detectOS: function() {
      this.os = { ...osInitial };

      var isWindows = this.navigatorUAData.platform.indexOf("Windows") !== -1 ||
        navigator.appVersion.indexOf("Win") !== -1;
      if (isWindows) {
        this.os.isWindows = true;
        this.os.name = 'windows';
        return;
      }

      var isMac = this.navigatorUAData.platform.indexOf("Mac") !== -1 ||
        navigator.appVersion.indexOf("Mac") !== -1;
      if (isMac) {
        this.os.isMac = true;
        this.os.name = 'mac';
        return;
      }

      var isIOS = !!this.navigatorUAData.platform.match(/(iOS|iPad|iPhone|iPod)/g) ||
        !!navigator.userAgent.match(/(iPad|iPhone|iPod)/g);
      if (isIOS) {
        this.os.isIOS = true;
        this.os.name = 'iOS';
        return;
      }

      var isLinux = this.navigatorUAData.platform.indexOf("Linux") !== -1 ||
        navigator.appVersion.indexOf("Linux") !== -1;
      if (isLinux) {
        this.os.isLinux = true;
        this.os.name = 'linux';
        return;
      }
    },

    detectDevice: function() {
      // reset
      this.device = { ...deviceInitial };

      var isMobile = (typeof this.navigatorUAData.mobile === 'boolean')
        ? this.navigatorUAData.mobile
        : /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
            window.navigator.userAgent.toLowerCase()
          );
      this.device.isMobile = isMobile;

      const screenWidth = window.ioradIsPreviewPlayer ?
        window.innerWidth
        :
        window.screen.width;
      this.device.isSmallScreen = window.innerWidth <= 767;
      var isPhone = isMobile && screenWidth <= 640;
      if (isPhone) {
        this.device.isPhone = true;
        this.device.name = 'phone';
        return;
      }

      var isTablet = isMobile && !isPhone;
      if (isTablet) {
        this.device.isTablet = true;
        this.device.name = 'tablet';
        return;
      }

      // default
      this.device.isDesktop = true;
      this.device.name = 'desktop';
    },

  });

  // Borrow the Backbone `extend` feature from View.
  ClientDetect.extend = Backbone.View.extend;

  return ClientDetect;
})();

;
// Handle loading and compositing of screenshots
// NOTE: Don't use this directly, use the methods of the Step model instead!

iorad.base.ScreenshotsController = (function() {

  var ScreenshotsController = function() {
    this.initialize.apply(this, arguments);
  };

  _.extend(ScreenshotsController.prototype, Backbone.Events, {

    initialize: function(syncController, captureController, options) {
      options = options || {};

      this._syncController = syncController;
      this.setCaptureController(captureController);

      this.disableCORS = options.disableCORS || false;

      // Lookup from frame ids composite key to canvases
      this._partialCompositeLookup = {};

      this.imgPromiseByUrl = {}; // <url, Promise of Image object>
    },

    // Always setted by the editor, by player only when in preview mode.
    setCaptureController: function(captureController) {
      this._captureController = captureController;
    },

    _loadFrameImg: function(frame) {
      var playerPreviewEditor;
      try {
        playerPreviewEditor = iorad.player &&
          siteWindow.parent != siteWindow &&
          siteWindow.parent.iorad &&
          siteWindow.parent.iorad.editor;
      } catch (err) { // cors
        playerPreviewEditor = false;
      }
      if (playerPreviewEditor) {
        return playerPreviewEditor.controllers.screenshots._loadFrameImg(frame);
      }

      var canUseCapture = Boolean(
        this._captureController &&
        this._captureController._transport
      );

      var errors = [];

      var getUrl = _.bind(function (storedCache) {
        var triedRemote = false;
        var getUrlTryRemote = _.bind(function () {
          return Promise.resolve()
            .then(_.bind(function () {
              return (frame.encrypted || iorad.app === iorad.editor)
                ? this._syncController.getDecryptedAssetRemotePath(frame.id + '.png')
                : this._syncController.getImageRemotePath(frame.id);
            }, this))
            .catch(_.bind(function (err) {
              errors.push([err, {
                name: 'base: screenshots: _loadFrameImg: remoteImageUrl',
                'frame.id': frame && frame.id,
                'frame.encrypted': frame && frame.encrypted,
              }]);
              // continue
            }, this));
        }, this);

        return Promise.resolve()
          .then(_.bind(function (url) {
            if (url) return url;
            if (iorad.app.data.framesUrlCache.get(frame.id)) {
              return Promise.resolve(iorad.app.data.framesUrlCache.get(frame.id))
                .catch(_.bind(function (err) {
                  errors.push([err, {
                    name: 'base: screenshots: _loadFrameImg: framesUrlCache',
                    'frame.id': frame && frame.id,
                  }]);
                  // continue
                }, this));
            }
          }, this))
          .then(_.bind(function (url) {
            if (url) return url;
            if (storedCache) {
              return Promise.resolve(
                storedCache.action === 'delete'
                  ? undefined // image is set as deleted
                  : storedCache.data.imageDataURI
              )
                .catch(_.bind(function (err) {
                  errors.push([err, {
                    name: 'base: screenshots: _loadFrameImg: storedCache',
                    'frame.id': frame && frame.id,
                    'storedCache.action': storedCache && storedCache.action,
                    'typeof(storedCache.data.imageDataURI)': typeof (
                      storedCache &&
                      storedCache.data &&
                      storedCache.data.imageDataURI
                    ),
                  }]);
                  // continue
                }, this));
            }
          }, this))
          .then(_.bind(function (url) {
            if (url) return url;
            if (frame.url) {
              // If for some reason we've already got a url
              return Promise.resolve()
                .then(_.bind(function () {
                  return frame.url;
                }, this))
                .catch(_.bind(function (err) {
                  errors.push([err, {
                    name: 'base: screenshots: _loadFrameImg: frame.url',
                    'frame.id': frame && frame.id,
                    'typeof(frame.url)': typeof (
                      frame &&
                      frame.url
                    ),
                  }]);
                  // continue
                }, this));
            }
          }, this))
          .then(_.bind(function (url) {
            if (url) return url;
            if (frame.saved || iorad.app.getParameters.revision) {
              // the image is on the server, use remote url
              triedRemote = true;
              return getUrlTryRemote();
            }
          }, this))
          .then(_.bind(function (url) {
            if (url) return url;
            if (canUseCapture) {
              // try to retrieve the base64 url from the capture service
              return Promise.resolve()
                .then(_.bind(function () {
                  return this._captureController.getImageData(frame.id);
                }, this))
                .catch(_.bind(function (err) {
                  errors.push([err, {
                    name: 'base: screenshots: _loadFrameImg: capture service',
                    'frame.id': frame && frame.id,
                  }]);
                  // continue
                }, this));
            }
          }, this))
          .then(_.bind(function (url) {
            if (url) return url;
            if (!triedRemote) { // e.g. we tried capture but it failed, try remote as last resort
              triedRemote = true;
              return getUrlTryRemote();
            }
          }, this))
          .catch(_.bind(function (err) {
            // TODO: what to do? Show warning, contact the author?
            // We could also show a default "not found" image
            errors.push(err, {
              name: 'base: screenshots: _loadFrameImg: unexpected',
              'frame.id': frame && frame.id,
            });
            // continue
          }, this))
          .then(_.bind(function (url) {
            if (url) return url;
            if (errors.length === 0) {
              errors.push([new Error('unknown frame url (default)'), {
                name: 'base: screenshots: _loadFrameImg: default',
                'frame.id': frame && frame.id,
              }]);
            }
          }, this));
      }, this);

      return Promise.resolve()
        .then(_.bind(function () {
          if (iorad.app === iorad.editor) {
            var cacheKey = this._syncController.getImageCacheKey(frame.id);
            return this._syncController.getCache(cacheKey);
          }
          return null;
        }, this))
        .then(_.bind(function (storedCache) {
          return getUrl(storedCache);
        }, this))
        .then(_.bind(function (url) {
          if (!url) {
            throw new Error('url is not defined');
          }
          var isRemoteImg = url.split(':')[0] !== 'data';
          var isFileImg = iorad.base.Utils.isFileProtocolURL(url);

          var imgPromise;
          if (isRemoteImg && this.imgPromiseByUrl[url]) {
            imgPromise = this.imgPromiseByUrl[url];
          } else {
            var img = new Image();
            // Don't try and do CORs on a data url, they get angry ;)
            if (
              !this.disableCORS &&
              isRemoteImg &&
              !isFileImg &&
              !iorad.app.controllers.clientDetect.browser.isIE
            ) {
              img.crossOrigin = 'Anonymous';
            }
            imgPromise = new Promise(_.bind(function (resolve, reject) {
              img.addEventListener('load', _.bind(function () {
                resolve(img);
              }, this));
              img.addEventListener('error', _.bind(function (err) {
                if (isRemoteImg) delete this.imgPromiseByUrl[url];
                errors.push([err, {
                  name: 'base: screenshots: _loadFrameImg: img error',
                  remoteUrl: isRemoteImg ? url : undefined,
                  isRemoteImg: isRemoteImg,
                  isFileImg: isFileImg,
                  imgCrossOrigin: img.crossOrigin,
                }]);
                reject(err);
              }, this));
              img.src = url;
            }, this));
            if (isRemoteImg) this.imgPromiseByUrl[url] = imgPromise;
          }

          return imgPromise;
        }, this))
        .catch(_.bind(function (err) {
          errors.forEach(_.bind(function (errArray) {
            iorad.app.controllers.sync.checkUnexpectedError(
              errArray[0],
              errArray[1],
              { editorOnly: true }
            );
          }, this));
          throw err;
        }, this))
        .then(_.bind(function (img) {
          var frameWithImage = _.extend({
            img: img
          }, frame);
          return frameWithImage;
        }, this));
    },

    // Return a canvas element containing the full composited screenshot
    getScreenshotCanvas: function(id, width, height, screenshotData) {
      var self = this;
      var frames = screenshotData.frames || [{
        id: screenshotData.id,
        url: screenshotData.url,
        saved: screenshotData.saved,
        encrypted: screenshotData.encrypted,
      }];
      var partialId = _.pluck(frames, 'id').join(';') + ':' + screenshotData.width;

      // TODO: this might not work (see #1831)
      if (partialId in this._partialCompositeLookup) {
        // console.log('Screenshot id', id, 'already in cache');
        return this._partialCompositeLookup[partialId];
      }


      var canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      var context = canvas.getContext('2d');
      context.clearRect(0, 0, width, height); // clear the canvas

      var baseFrames = _.clone(frames);
      var newFrames = [];
      var baseCanvasPromise = Promise.resolve();
      while (baseFrames.length) {
        var basePartialId = _.pluck(baseFrames, 'id').join(';');
        var promise = this._partialCompositeLookup[basePartialId];
        if (promise) {
          baseCanvasPromise = promise;
          break;
        }
        newFrames.unshift(baseFrames.pop());
      }


      console.log('Loading screenshot id', id, 'based on', baseFrames.length, 'frames already composited and', newFrames, 'remaining to composite');

      return this._partialCompositeLookup[partialId] = baseCanvasPromise
        .then(function(baseCanvas) {
          if (baseCanvas) {
            try {
              context.drawImage(baseCanvas, 0, 0, width, height);
            } catch (err) {
              iorad.app.controllers.sync.checkUnexpectedError(err, {
                name: 'base: screenshots: getScreenshotCanvas: context.drawImage: baseCanvas',
                width: width,
                height: height,
              }, { editorOnly: true });
              throw err;
            }
          }

          return Promise.all(_.map(newFrames, _.bind(self._loadFrameImg, self)))
            .then(function(framesWithImages) {
              _.each(framesWithImages, function(frame) {
                try {
                  context.drawImage(
                    frame.img,
                    frame.x || 0,
                    frame.y || 0,
                    frame.width || width,
                    frame.height || height
                  );
                } catch (err) {
                  iorad.app.controllers.sync.checkUnexpectedError(err, {
                    name: 'base: screenshots: getScreenshotCanvas: context.drawImage: frame.img',
                    'frame.id': frame && frame.id,
                    'frame.img.width': frame && frame.img && frame.img.width,
                    'frame.img.height': frame && frame.img && frame.img.height,
                    'frame.x': frame && frame.x,
                    'frame.y': frame && frame.y,
                    'frame.width': frame && frame.width,
                    'frame.height': frame && frame.height,
                    'width': width,
                    'height': height,
                    'canvas.width': canvas.width,
                    'canvas.height': canvas.height,
                  }, { editorOnly: true });
                  throw err;
                }
              });
              console.log('Loaded screenshot id', id);
              return canvas;
            });
        })
        .catch(function(err) {
          delete self._partialCompositeLookup[partialId];
          throw err;
        });
    }
  });

  // Borrow the Backbone `extend` feature from View.
  ScreenshotsController.extend = Backbone.View.extend;

  return ScreenshotsController;
})();

;
iorad.base.LanguageController = (function() {
  "use strict";

  var LanguageController = function() {
    this.initialize.apply(this, arguments);
  };
  _.extend(LanguageController.prototype, Backbone.Events);
  _.extend(LanguageController.prototype, {

    initialize: function() {
    },

    start: function(languageCode) {
      return new Promise(_.bind(function(resolve, reject) {
        try {
          window.i18next
            .use(window.i18nextXHRBackend)
            .init({
              fallbackLng: 'en',
              lng: languageCode || 'en',
              partialBundledLanguages: true, // OPTIMIZATION: preload initial translation (see resources) to prevent initial render-blocking XHR
              resources: window.languageResources,
              debug: false,
              nsSeparator: ':::',
              keySeparator: '::',
              backend: {
                loadPath: iorad.base.Settings.get('server.lang.url', {
                  lang: '{{lng}}', // template replaced by i18next
                  user_id: iorad.app.userId,
                }),
                crossDomain: true
              }
            }, function(err) {
              if (err) {
                iorad.app.controllers.sync.checkUnexpectedError(err, {
                  name: 'base: language: start',
                  languageCode: languageCode,
                });
              }

              var defaultLanguage = i18next.language || 'en';
              resolve(defaultLanguage);
            });
        } catch (err) {
          reject(err);
        }
      }, this));
    },

    detectLanguage: function() {
      var text = iorad.app.data.stepsCollection.getModelAt(0).getDescription();

      return iorad.app.controllers.sync.detectLanguage(text);
    },

    getLanguageName: function(languageCode) {
      if (!languageCode) return '';
      var languageCodeSimple = languageCode.split('-')[0];

      var languages = this.list;
      var selectedLanguageObj = _.find(languages, _.bind(function(languageObj) {
        return languageCode.toLowerCase() === languageObj.code.toLowerCase();
      }, this));
      if (!selectedLanguageObj && languageCodeSimple !== languageCode) {
        // try again without region
        selectedLanguageObj = _.find(languages, _.bind(function(languageObj) {
          return languageCodeSimple.toLowerCase() === languageObj.code.split('-')[0].toLowerCase();
        }, this));
      }
      return selectedLanguageObj ? selectedLanguageObj.name : '';
    },

    getLanguageCode: function(languageName) {
      if (!languageName) return '';

      function normalize(str) {
        return str.toLowerCase().replace(/[()]/g, '').replace(/\s+/g, ' ').trim();
      }

      var languages = this.list;
      var selectedLanguageObj = _.find(languages, _.bind(function(languageObj) {
        return normalize(languageName) === normalize(languageObj.name);
      }, this));

      return selectedLanguageObj && selectedLanguageObj.code;
    },

    translateStepDescription: function(description) {
      if (!description) return description;
      var translatedDescription = this.translateStepDescriptionSimple(description);
      if (!translatedDescription) {
        translatedDescription = this.translateStepDescriptionByJoin(description);
      }
      return translatedDescription || description;
    },

    translateStepDescriptionSimple: function(description) {
      var parser = document.createElement('div');
      parser.innerHTML = sanitizeHtml(description.trim(), iorad.base.Export.STEP_DESCRIPTION_APP_SANITIZE_RULES);

      var componentStrings = {};
      var components = parser.querySelectorAll('b');
      var c = 0;
      _.forEach(components, _.bind(function(component) {
        var $component = $(component);

        if ($component.parents('b').length) {
          return; // continue
        }

        if (component.innerHTML.trim() !== '') {
          // valid component
          c++;
          componentStrings['c' + c] = component.outerHTML;
          var textNode = document.createTextNode('{{c' + c + '}}');
          $component.replaceWith(textNode);
        } else {
          // invalid component
          $component.remove();
        }
      }, this));
      var generalDescription = parser.innerHTML.trim();

      var key = 'STEP_DESCRIPTIONS::' + generalDescription;
      return window.i18next.exists(key) ? window.i18next.t(key, componentStrings) : '';
    },

    translateStepDescriptionByJoin: function(description) {
      // try with multiple joined descriptions
      var andString = ' and ';
      var andKey = 'STEP_DESCRIPTIONS::' + andString;
      var translatedAndString = window.i18next.exists(andKey) ? window.i18next.t(andKey) : andString;
      var descriptionParts = description.split(andString);
      return _.map(descriptionParts, _.bind(function(part, i) {
        var capitalizedPart = iorad.base.Utils.capitalize(part);
        var capitalizedTranslation = this.translateStepDescriptionSimple(capitalizedPart);
        return capitalizedTranslation
          ? (i === 0 ? capitalizedTranslation : iorad.base.Utils.uncapitalize(capitalizedTranslation))
          : part;
      }, this)).join(translatedAndString);
    },

    // TODO: match google translate list (including names)
    // based on Google Translate API: https://cloud.google.com/translate/docs/languages
    list: [
      {"code" : "en", "name": "English"},
      {"code" : "da", "name": "Danish"},
      {"code" : "nl", "name": "Dutch"},
      {"code" : "fr", "name": "French"},
      {"code" : "de", "name": "German"},
      {"code" : "it", "name": "Italian"},
      {"code" : "ja", "name": "Japanese"},
      {"code" : "ko", "name": "Korean"},
      {"code" : "no", "name": "Norwegian"},
      {"code" : "pl", "name": "Polish"},
      {"code" : "pt", "name": "Portuguese"},
      {"code" : "ru", "name": "Russian"},
      {"code" : "es", "name": "Spanish"},
      {"code" : "zh-CN", "name": "Chinese (Simplified)"},
      {"code" : "zh-TW", "name": "Chinese (Traditional)"},
      {"code" : "ilo", "name": "Ilocano"},
      {"code" : "af", "name": "Afrikaans"},
      {"code" : "sq", "name": "Albanian"},
      {"code" : "am", "name": "Amharic"},
      {"code" : "ar", "name": "Arabic"},
      {"code" : "hy", "name": "Armenian"},
      {"code" : "az", "name": "Azeerbaijani"},
      {"code" : "eu", "name": "Basque"},
      {"code" : "be", "name": "Belarusian"},
      {"code" : "bn", "name": "Bengali"},
      {"code" : "bs", "name": "Bosnian"},
      {"code" : "bg", "name": "Bulgarian"},
      {"code" : "ca", "name": "Catalan"},
      {"code" : "ceb", "name": "Cebuano"},
      {"code" : "co", "name": "Corsican"},
      {"code" : "hr", "name": "Croatian"},
      {"code" : "cs", "name": "Czech"},
      {"code" : "eo", "name": "Esperanto"},
      {"code" : "et", "name": "Estonian"},
      {"code" : "fi", "name": "Finnish"},
      {"code" : "fy", "name": "Frisian"},
      {"code" : "gl", "name": "Galician"},
      {"code" : "ka", "name": "Georgian"},
      {"code" : "el", "name": "Greek"},
      {"code" : "gu", "name": "Gujarati"},
      {"code" : "ht", "name": "Haitian Creole"},
      {"code" : "ha", "name": "Hausa"},
      {"code" : "haw", "name": "Hawaiian"},
      {"code" : "iw", "name": "Hebrew"},
      {"code" : "hi", "name": "Hindi"},
      {"code" : "hmn", "name": "Hmong"},
      {"code" : "hu", "name": "Hungarian"},
      {"code" : "is", "name": "Icelandic"},
      {"code" : "ig", "name": "Igbo"},
      {"code" : "id", "name": "Indonesian"},
      {"code" : "ga", "name": "Irish"},
      {"code" : "jw", "name": "Javanese"},
      {"code" : "kn", "name": "Kannada"},
      {"code" : "kk", "name": "Kazakh"},
      {"code" : "km", "name": "Khmer"},
      {"code" : "ku", "name": "Kurdish"},
      {"code" : "ky", "name": "Kyrgyz"},
      {"code" : "lo", "name": "Lao"},
      {"code" : "la", "name": "Latin"},
      {"code" : "lv", "name": "Latvian"},
      {"code" : "lt", "name": "Lithuanian"},
      {"code" : "lb", "name": "Luxembourgish"},
      {"code" : "mk", "name": "Macedonian"},
      {"code" : "mg", "name": "Malagasy"},
      {"code" : "ms", "name": "Malay"},
      {"code" : "ml", "name": "Malayalam"},
      {"code" : "mt", "name": "Maltese"},
      {"code" : "mi", "name": "Maori"},
      {"code" : "mr", "name": "Marathi"},
      {"code" : "mn", "name": "Mongolian"},
      {"code" : "my", "name": "Myanmar (Burmese)"},
      {"code" : "ne", "name": "Nepali"},
      {"code" : "ny", "name": "Nyanja (Chichewa)"},
      {"code" : "ps", "name": "Pashto"},
      {"code" : "fa", "name": "Persian"},
      {"code" : "pa", "name": "Punjabi"},
      {"code" : "ro", "name": "Romanian"},
      {"code" : "sm", "name": "Samoan"},
      {"code" : "gd", "name": "Scots Gaelic"},
      {"code" : "sr", "name": "Serbian"},
      {"code" : "st", "name": "Sesotho"},
      {"code" : "sn", "name": "Shona"},
      {"code" : "sd", "name": "Sindhi"},
      {"code" : "si", "name": "Sinhala (Sinhalese)"},
      {"code" : "sk", "name": "Slovak"},
      {"code" : "sl", "name": "Slovenian"},
      {"code" : "so", "name": "Somali"},
      {"code" : "su", "name": "Sundanese"},
      {"code" : "sw", "name": "Swahili"},
      {"code" : "sv", "name": "Swedish"},
      {"code" : "tl", "name": "Tagalog (Filipino)"},
      {"code" : "tg", "name": "Tajik"},
      {"code" : "ta", "name": "Tamil"},
      {"code" : "te", "name": "Telugu"},
      {"code" : "th", "name": "Thai"},
      {"code" : "tr", "name": "Turkish"},
      {"code" : "uk", "name": "Ukrainian"},
      {"code" : "ur", "name": "Urdu"},
      {"code" : "uz", "name": "Uzbek"},
      {"code" : "vi", "name": "Vietnamese"},
      {"code" : "cy", "name": "Welsh"},
      {"code" : "xh", "name": "Xhosa"},
      {"code" : "yi", "name": "Yiddish"},
      {"code" : "yo", "name": "Yoruba"},
      {"code" : "zu", "name": "Zulu"}
    ]

  });

  // Borrow the Backbone `extend` feature from View.
  LanguageController.extend = Backbone.View.extend;

  return LanguageController;
})();

;
iorad.base.ViewsController = iorad.base.Component.extend({
  initialize: function(tutorialModel, stepsCollection, themesCollection) {
    this.tutorial = tutorialModel;
    this.stepsCollection = stepsCollection;
    this.themesCollection = themesCollection;
  },
});

;
iorad.base.HubspotController = iorad.base.Component.extend({
  name: 'hubspot',

  initialize: function (tutorial) {
    this.tutorial = tutorial;
  },

  trackEvent: function (name, data) {
    var params = {
      eventId: name
    };
    if (typeof data === 'number') {
      // data must be the "contact revenue" (optional)
      params.eventRevenue = data;
    }
    iorad.app.controllers.sync._callNodeService('/user/hubspot/trackEvent', 'GET', params);
    console.log('trackHubspotEvent', params);
  }
});

;
// Tracks user activity and sends it to Google Analytics.
// Note: assumes that the Google Analytics API
// is already included in the page.

iorad.base.GoogleAnalyticsController = iorad.base.Component.extend({
  name: 'googleAnalytics',

  initialize: function(tutorial) {
    this.tutorial = tutorial;
  },

  /**
   * @deprecated Use sendEventToOwnerUsingGA4 instead
   *
   * uses https://developers.google.com/analytics/devguides/collection/protocol/v1/devguide
   * to send the event to the tutorial author Google Analytics account,
   * if they have added their GA id.
   */
  sendEventToOwnerUsingUniversalAnalytics: function (eventName, eventData, resolve, reject) {
    var endpoint = 'https://www.google-analytics.com/collect';
    var params = {
      v: 1, // protocol version
      tid: window.ownerGoogleAnalyticsId, // UA-XXXX-Y
      cid: this.uuid, // client id
      ds: 'web', // data source
      t: 'event', // hit type
      ec: 'iorad', // event category
      ea: eventName, // event action

      // optional
      vp: siteWindow.innerWidth + 'x' + siteWindow.innerHeight, // viewport size
      dl: siteWindow.location.protocol + '//' + siteWindow.location.host + siteWindow.location.pathname, // document location (no query/hash to prevent duplicated reports)
      dt: siteWindow.document.title, // document title
    };
    if (Number.isInteger(eventData)) {
      params.ev = eventData; // event value
    }
    if (siteWindow.screen && siteWindow.screen.width && siteWindow.screen.height) {
      params.sr = siteWindow.screen.width + 'x' + siteWindow.screen.height; // screen resolution, e.g. "1920x1080"
    }

    var success = _.bind(function (data, reqStatus, jqXHR) {
      if (reqStatus !== 'success' && jqXHR.status !== 204) {
        reject(reqStatus);
      } else {
        resolve(data);
      }
    }, this);

    var error = _.bind(function (req, errorMsg) {
      reject(req.responseJSON || req.responseText || errorMsg);
    }, this);

    $.ajax({
      url: endpoint,
      type: 'POST',
      data: params,
      contentType: false,
      xhrFields: {
        withCredentials: false, // prevent CORS errors
      },
      timeout: 0,
      success: success,
      error: error,
    });
  },

  sendEventToOwnerUsingGA4: function (eventName, eventData, resolve, reject) {
    var measurementId = window.ownerGoogleAnalyticsId;
    var apiSecret = window.ownerGoogleAnalyticsSecret;

    // use this endpoint to debug
    var endpoint = siteWindow.location.hostname.endsWith('.iorad.dev')
      ? `https://www.google-analytics.com/debug/mp/collect?measurement_id=${measurementId}&api_secret=${apiSecret}`
      : `https://www.google-analytics.com/mp/collect?measurement_id=${measurementId}&api_secret=${apiSecret}`;

    var params = {
      data_source: 'web',
      category: 'iorad',
      view_port: siteWindow.innerWidth + 'x' + siteWindow.innerHeight,
      document_location: siteWindow.location.protocol + '//' + siteWindow.location.host + siteWindow.location.pathname,
      document_title: siteWindow.document.title,
    };

    if (Number.isInteger(eventData)) {
      params.event_value = eventData; // event value
    }

    if (siteWindow.screen && siteWindow.screen.width && siteWindow.screen.height) {
      params.screen_resolution = siteWindow.screen.width + 'x' + siteWindow.screen.height; // screen resolution, e.g. "1920x1080"
    }

    $.ajax({
      url: endpoint,
      type: 'POST',
      data: JSON.stringify({
        client_id: this.uuid,
        events: [{
          name: eventName.replaceAll('-', '_'),
          params: { ...params },
        }]
      }),
      contentType: 'text/plain',
      success: function (data) {
        resolve(data);
      },
      error: function (req, error) {
        reject(req.responseJSON || req.responseText || error);
      },
    });
  },

  getAPI: function() {
    if (!this.apiPromise) {
      this.apiPromise = new Promise(function(resolve) {
        var timer = setInterval(function() {
          if (siteWindow.dataLayer) {
            clearInterval(timer);
            resolve(siteWindow.dataLayer);
          }
        }, 100);
      });
    }
    return this.apiPromise;
  },

  trackEvent: function(name, data) {
    this.getAPI().then(function(api) {
      var params = { event: name.replaceAll('-', '_') };
      if (Number.isInteger(data)) {
        params.eventValue = data;
      }
      api.push(params);
    });

    // server-side XHR for tutorial owner GA
    this.sendEventToOwner(name, data);
  },

  sendEventToOwner: function(eventName, eventData) {
    return new Promise(_.bind(function (resolve, reject) {
      if (!window.ownerGoogleAnalyticsId) {
        // nothing to do
        resolve();
        return;
      }

      if (!this.uuid) {
        var localStorageUuidKey = 'iorad.player.controllers.tracking.googleAnalytics.uuid'; // same for all tutorials
        try {
          this.uuid = localStorage.getItem(localStorageUuidKey);
        } catch (err) {
          // 3rd party cookies/data are disabled or invalid json data
          console.error(err);
        }
        if (!this.uuid) {
          this.uuid = window.uuidv4();
          try {
            localStorage.setItem(localStorageUuidKey, this.uuid);
          } catch (err) {
            // 3rd party cookies/data are disabled
            console.error(err);
          }
        }
      }

      if (window.ownerGoogleAnalyticsId.startsWith('UA-')) {
        this.sendEventToOwnerUsingUniversalAnalytics(eventName, eventData, resolve, reject);
      } else {
        this.sendEventToOwnerUsingGA4(eventName, eventData, resolve, reject);
      }
    }, this));
  },
});

;
// Tracks user activity and sends it to the parent windows.

iorad.base.EmbeddedTrackingController = iorad.base.Component.extend({
  name: 'embedded',

  initialize: function(tutorial) {
    this.tutorial = tutorial;
  },

  trackEvent: function(name, data) {
    var currentWindow = siteWindow;
    while (currentWindow.parent !== currentWindow && currentWindow.parent) {
      try {
        currentWindow.parent.postMessage({
          topic: 'iorad-tracking',
          eventName: name,
          data: data,
          tutorial: {
            id: this.tutorial.get('moduleID'),
            title: this.tutorial.get('title'),
          },
        }, '*');
      } catch (err) {
        iorad.app.controllers.sync.checkUnexpectedError(err, {
          name: 'base: tracking: embedded: trackEvent',
          eventName: name,
          eventData: data,
        });
      }

      currentWindow = currentWindow.parent;
    }
  },
});

;
iorad.base.TrackingController = iorad.base.Component.extend({

  initialize: function(tutorial, options) {
    options = options || {};

    this.tutorial = tutorial;
    this.isEnabled = iorad.base.Settings.get('tracking.isEnabled');
    this.providers = options.providers || [];
    this.exclusions = options.exclusions || {}; // <provider name: String, excluded: Bool>

    // listen only after fetch is completed
    // (avoids to catch fake initial changes)
    this.listenTo(iorad.app.events, 'sync:fetch:success', this.setupEvents);
  },

  setupEvents: function() {},

  // abstract: should track the event by using the api
  trackEvent: function(name, data, options) {
    if (!this.isEnabled) return;
    options = options || {};
    this.providers
      .filter(_.bind(function (provider) {
        if (options.exclusions && typeof options.exclusions[provider.name] !== 'undefined') {
          return !options.exclusions[provider.name];
        }
        if (typeof this.exclusions[provider.name] !== 'undefined') {
          return !this.exclusions[provider.name];
        }
        return true;
      }, this))
      .forEach(_.bind(function (provider) {
        provider.trackEvent(name, data);
      }, this));
  },
});

;
iorad.base.View = Backbone.Chaplin.View.extend({
  _isRemoved: false,

  initialize: function () {
    Backbone.Chaplin.View.prototype.initialize.apply(this, arguments);

    this.allowFocusVisibleOnInteractions();
  },

  allowFocusVisibleOnInteractions: function () {
    const domListenerIndexes = [];

    const allowFocusVisible = () => {
      $('body').addClass('focus-visible-allowed');

      domListenerIndexes.forEach(index => {
        this.stopDOMListening(index);
      });
      domListenerIndexes.length = 0;
    };
    domListenerIndexes.push(
      this.listenToDOM(document, 'keydown', allowFocusVisible, true)
    );
    domListenerIndexes.push(
      this.listenToDOM(document, 'mousedown', allowFocusVisible, true)
    );
  },

  getTemplateFunction: function() {
    // partially apply the Mustache.render function, return a function that can
    // be passed a `data` hash.
    return Mustache.compile(this.template);
  },

  show: function() {
    this.$el.show();
  },

  hide: function() {
    this.$el.hide();
  },

  isShown: function() {
    return this.$el.css('display') != 'none';
  },

  isRemoved: function() {
    return this._isRemoved;
  },

  listenToDOM: function(el, eventName, handler, useCapture) {
    this.domListeners = this.domListeners || [];

    if (el instanceof jQuery) el = el[0];
    if (!el) return undefined;

    handler = _.bind(handler, this);

    el.addEventListener(eventName, handler, useCapture);

    var domListener = [el, eventName, handler, useCapture];
    var domListenerIndex = this.domListeners.length;
    this.domListeners.push(domListener);
    return domListenerIndex;
  },
  stopDOMListening: function(domListenerIndex) {
    this.domListeners = this.domListeners || [];

    var domListener = this.domListeners[domListenerIndex];
    if (!domListener) return;

    var el = domListener[0],
      eventName = domListener[1],
      handler = domListener[2],
      useCapture = domListener[3];

    el.removeEventListener(eventName, handler, useCapture);

    delete this.domListeners[domListenerIndex];
  },
  clearDOMListeners: function() {
    this.domListeners = this.domListeners || [];

    for (var i = 0, l = this.domListeners.length; i < l; i++) {
      this.stopDOMListening(i);
    }
    this.domListeners = [];
  },

  remove: function() {
    this.clearDOMListeners();

    Backbone.Chaplin.View.prototype.remove.apply(this, arguments);

    this._isRemoved = true;
    this.trigger('remove');
  }

});
;
iorad.base.CollectionView = Backbone.Chaplin.CollectionView.extend({
  getTemplateFunction: iorad.base.View.prototype.getTemplateFunction
});
;
// Extends BaseView with properties that apply to every specific marker type.
// Note: BaseView must have a Backbone-like extend function property.
// This allows to create different chains of inheritance depending on the marker type.

iorad.base.views.markerCommon = function(BaseView) {
  return BaseView.extend({
    initialize: function() {
      BaseView.prototype.initialize.apply(this, arguments);
      this.transitionDuration = 400;
    },

    // Note: call this only after the browser rendering is complete, since relies on css properties
    // and could do size calculations.
    updateBounds: function(transition) {
      this.$el.stop();
      var bounds = this.getBounds();

      // only update the changed css properties to prevent flickering on some browsers (#2515)
      var cssChanges = {};
      var hasChanges = false;
      var $this = this;
      return new Promise(function(resolve) {
        _.each(['left', 'top', 'width', 'height'], function(cssProp) {
          var boundsProp;
          if (cssProp == 'left') boundsProp = 'x';
          else if (cssProp == 'top') boundsProp = 'y';
          else boundsProp = cssProp;

          var newCssValue = bounds[boundsProp] + 'px';
          if ($this.$el.css(cssProp) != newCssValue) {
            cssChanges[cssProp] = newCssValue;
            hasChanges = true;
          }
        });
        if (hasChanges) {
          var useTransition = transition && (!iorad.player || (iorad.player.ready && !$('#main .device-change-overlay').is(':visible')));
          if (useTransition) {
            $this.$el.animate(cssChanges, $this.transitionDuration, 'swing', resolve);
          } else {
            $this.$el.css(cssChanges);
            resolve();
          }
        } else {
          resolve();
        }
      });
    },

    getBounds: function() {
      var bounds = iorad.base.Utils.deepClone(this.model.get('marker.bounds') || {});

      // get defaults for missing values (if any)
      _.each(['x', 'y', 'width', 'height'], function(bound) {
        if (typeof bounds[bound] == 'undefined') bounds[bound] = this.getDefaultBounds(bound);
      }, this);

      return bounds;
    },

    getDefaultBounds: function(bound) {
      var defaultBounds = {
        x: 0,
        y: 0,
        width: 100,
        height: 100
      };
      return bound ? defaultBounds[bound] : defaultBounds;
    },

    // function that specify the slide containment jQuery element,
    // i.e. the element where the marker can move.
    getSlideContainmentEl: function() {
      // find the FIRST div ancestor with a canvas inside
      return this.$el.parent().closest('div').find('canvas');
    },
  });
};
;
(function() {
  var Super = iorad.base.views.markerCommon(iorad.base.View);
  iorad.base.views.MarkerDefault = Super.extend({
    /* Keep this blank */
  });
})();
;
(function() {
  var Super = iorad.base.views.markerCommon(iorad.base.View);
  iorad.base.views.MarkerRead = Super.extend({

  });
})();
;
(function() {
  var Super = iorad.base.views.markerCommon(iorad.base.View);
  iorad.base.views.MarkerLeftClick = Super.extend({

  });
})();
;
(function() {
  var Super = iorad.base.views.markerCommon(iorad.base.View);
  iorad.base.views.MarkerTyping = Super.extend({
    isEventMatch: function () {
      return typeof this.model.get('event.match') === 'undefined' ?
        Boolean(this.model.get('event.casesensitive')) // old tutorials
        :
        Boolean(this.model.get('event.match'));
    },

    getEventMatchType: function () {
      return this.model.get('event.matchType') || 'case';
    },
  });
})();

;
(function() {
  var Super = iorad.base.views.markerCommon(iorad.base.View);
  iorad.base.views.MarkerScroll = Super.extend({

    scrollbarWidth: 17, // fixed to have same appareance in all devices
    getDefaultBounds: function(bound) {
      var left, top, width, height,
          slideContainmentEl = this.getSlideContainmentEl();

      var isHorizontal = this.model.get('event.horizontal');
      if (isHorizontal) {
        // wrap the scrollTool scrollbar with the marker
        height = this.scrollbarWidth;
        // move to bottom border taking all horizontal space
        left = 0;
        top = slideContainmentEl.height() - height;
        width = slideContainmentEl.width();
      } else {
        // wrap the scrollTool scrollbar with the marker
        width = this.scrollbarWidth;
        // move to right border taking all vertical space
        left = slideContainmentEl.width() - width;
        top = 0;
        height = slideContainmentEl.height();
      }

      var defaultBounds = {x: left, y: top, width: width, height: height};
      return bound? defaultBounds[bound] : defaultBounds;
    }

  });
})();

;
(function() {
  var Super = iorad.base.views.markerCommon(iorad.base.View);
  iorad.base.views.MarkerSelectText = Super.extend({

  });
})();
;
(function() {
  var Super = iorad.base.views.markerCommon(iorad.base.View);
  iorad.base.views.MarkerDrag = Super.extend({

  });
})();
;
(function() {
  var Super = iorad.base.views.markerCommon(iorad.base.View);
  iorad.base.views.MarkerDrop = Super.extend({

  });
})();
;
(function() {
  var Super = iorad.base.views.markerCommon(iorad.base.View);
  iorad.base.views.MarkerHover = Super.extend({

  });
})();
;
(function() {
  var Super = iorad.base.views.markerCommon(iorad.base.View);
  iorad.base.views.MarkerRightClick = Super.extend({

  });
})();
;
iorad.base.views.MarkerFactory = iorad.base.Factory.extend({}, { // STATIC PROPERTIES
  types: {
    'defaultType': iorad.base.views.MarkerDefault,
    'READ': iorad.base.views.MarkerRead,
    'LEFT_CLICK': iorad.base.views.MarkerLeftClick,
    'RIGHT_CLICK': iorad.base.views.MarkerRightClick,
    'TYPING': iorad.base.views.MarkerTyping,
    'SCROLL': iorad.base.views.MarkerScroll,
    'DRAG': iorad.base.views.MarkerDrag,
    'DROP': iorad.base.views.MarkerDrop,
    'HOVER': iorad.base.views.MarkerHover,
    'SELECT_TEXT': iorad.base.views.MarkerSelectText,
  }
});
;
iorad.base.views.step_screenshot = iorad.base.View.extend({


  initialize: function() {
    this.load();
  },

  load: function() {
    this.isLoaded = false;

    if (this.canvas) $(this.canvas).remove();
    this.canvas = document.createElement('canvas');
    this.canvas.className = 'screenshot-canvas';
    this.$el.append(this.canvas);

    this.size = {};

    if (this.model) this.setStep(this.model);
    else this.setSize(1128, 640); // default size
  },

  hasStep: function() {
    return (this.model) ? true : false;
  },

  setStep: function(step) {
    if (this.model) {
      this.stopListening(this.model);
    }
    // We allow updating of the model in place so that later on we can
    // optimise here and keep around frames if they can be reused
    this.model = step;
    this.listenTo(this.model, 'scale', this.load.bind(this));
    this.setSize(step.get('screenshot.width'), step.get('screenshot.height'));
    this.listenTo(this.model, 'change:description', this.updateAlt.bind(this));
    this.updateAlt();
    this.render();
  },

  setSize: function(width, height) {
    this.size.width = width;
    this.size.height = height;
    this.canvas.width = this.size.width;
    this.canvas.height = this.size.height;
    this.resize(this.size.width, this.size.height); // default: ratio = 1
  },

  updateAlt: function () {
    const altText = iorad.base.Utils.stripHtmlTags(this.model.get('description') || '', iorad.base.Export.STEP_DESCRIPTION_APP_SANITIZE_RULES);
    $(this.canvas)
      .attr('role', 'img')
      .attr('alt', altText)
      .attr('aria-label', altText);
  },

  resize: function(width, height) {
    this.canvas.style.width = width + 'px';
    this.canvas.style.height = height + 'px';
  },

  getCommonColour: function() {
    return iorad.base.Utils.mostCommonColor(this.canvas, null, null, null, null, 10);
  },

  render: function() {
    // do a proper render by re-appending canvas to prevent bugs like #1216 (IE bug)
    iorad.base.View.prototype.render.apply(this, arguments);
    this.$el.append(this.canvas);

    // Clear all current frames
    this.isLoaded = false;
    iorad.app.events.trigger('screenshot:load:before');
    this.$el.addClass('loading');
    if (this.$el.closest('#interactive-image, .stepimg').find('.overlay-loading').length === 0) {
      this.$el.closest('#interactive-image, .stepimg').prepend('<div class="overlay-loading"></div>');
    }

    var step = this.model;
    var me = this;

    this.model.preload().then(function(canvas) {
      //console.log(canvas);
      if (step !== me.model) {
        // too late
        iorad.app.events.trigger('screenshot:load:finished', false);
        return;
      }

      // TODO: Maybe we should just replace the canvas we have with this new canvas
      var context = me.canvas.getContext('2d');
      // image will be scaled if needed
      context.drawImage(canvas, 0, 0, me.size.width, me.size.height);

      me.$el.removeClass('loading');
      me.$el.closest('#interactive-image, .stepimg').find('.overlay-loading').remove();
      me.isLoaded = true;
      me.trigger('load');
      iorad.app.events.trigger('screenshot:load:finished', true);

    }).catch(function(error) {
      console.log('failed when rendering stepScreenshot: ', error);
    });

    return this;
  }

});

;
iorad.base.Router = Backbone.Router.extend({

  initialize: function(options) {
    options = options || {};

    // the global event bus (required)
    this.globalBus = options.globalBus;

    this.setupRouteGlobalEvent();
  },

  setupRouteGlobalEvent: function() {
    // emits an event on the global event bus on route,
    // so that the client can listen to events coming from any of the existing router
    // (there might be more than one)
    this.listenTo(this, 'route', function() {
      // (keep any event argument)
      this.globalBus.trigger.apply(this.globalBus, ['route'].concat(arguments));
    });
  },

  // Starts the route handling after data are ready (e.g. after the fetch),
  // or the app could try to access not-yet existing data (since the fetch could be asynchronous)
  start: function() {
    this.dataReady(_.bind(function() {
      if (!Backbone.history.start()) this.notFound();
      this.trigger('started');
    }, this));
  },

  dataReady: function(callback) {
    if (this.isDataReady) callback();
    else this.listenToOnce(this, 'dataReady', callback);
  },

  // call this function to notify the router that the data are ready
  notifyDataReady: function() {
    this.isDataReady = true;
    this.trigger('dataReady');
    iorad.app.events.trigger('router:dataReady', this);
  },

  // Called (only) on router start if the initial route cannot be found (like a 404)
  // Just redirect to the home by default.
  notFound: function() {
    this.navigate('', {
      trigger: true
    });
  },

  getCurrent: function(route) {
    if (route && Backbone.History.started) {
      var Router = this,
        // Get current fragment from Backbone.History
        fragment = Backbone.history.fragment,
        // Get current object of routes and convert to array-pairs
        routes = _.pairs(Router.routes);

      // Loop through array pairs and return
      // array on first truthful match.
      var matched = _.find(routes, function(handler) {
        var route = handler[0];

        // Convert the route to RegExp using the 
        // Backbone Router's internal convert
        // function (if it already isn't a RegExp)
        route = _.isRegExp(route) ? route : Router._routeToRegExp(route);

        // Test the regexp against the current fragment
        return route.test(fragment);
      });

      // Returns callback name or false if 
      // no matches are found
      return matched ? matched[1] : false;
    } else {
      // Just return current hash fragment in History
      return Backbone.history.fragment
    }
  },

  navigate: function(fragment, options) {
    options = options || {};
    var isEmbedded = siteWindow.parent !== siteWindow;
    return Backbone.Router.prototype.navigate.call(this, fragment, _.extend({}, options, {
      replace: typeof options.replace !== 'undefined'
        ? options.replace
        : isEmbedded, // do not change parent history when embedded
    }));
  },

});
;
window.iorad = window.iorad || {};

window.iorad.player = window.iorad.app = {
  models: {},
  views: {},
  collections: {},
  events: {},
  routers: {},
  templates: {},
  workers: {}, // strings
  helpers: {},
  data: {},
  controllers: {},
  helpers: {}
};

iorad.player.data.MARKER_MARGIN = 75;
iorad.player.data.MARKER_BORDER = 6;

_.extend(iorad.player.events, Backbone.Events);

;
// NOTE: always use functions to prevent dependency issues (e.g. with i18next not being ready yet)
iorad.player.successNotificationList = {
  quizRecordingStopped: function () {
    return 'Recording stopped. Uploading...';
  },
  quizRecordingStarted: function () {
    return 'Recording started';
  },
  quizRecordingCanceled: function () {
    return 'Recording cancelled';
  },
  draftPublished: function () {
    return 'Published.';
  },
  tutorialPublicCheck: function () {
    return i18next.t('Public: found on Google.');
  },
  revisionPreview: function () {
    return i18next.t('Preview only. Player settings disabled.');
  },
  emptyTutorial: function () {
    return i18next.t('Blank tutorial. Nothing to see here.');
  },
  tutorialActivated: function () {
    return i18next.t('Tutorial activated.');
  },
};

;
iorad.player.PdfMakeComponent = iorad.base.Component.extend({

  componentsBase: iorad.base.Settings.get('components.basePath'),
  componentSrc: function(language) {
    var languageSuffix = language ? '_' + language : '';
    return 'vendor/pdfmake' + languageSuffix + '.js';
  },

  isLoaded: function() {
    return typeof window.pdfMake !== 'undefined';
  },

  exports: function() {
    return window.pdfMake;
  },

  load: function(language) {
    if (this.loadPromise) return this.loadPromise; // loading

    var me = this;
    this.loadPromise = new Promise(function(resolve, reject) {
      if (me.isLoaded()) resolve();
      else {
        var componentScript = document.createElement('script');
        componentScript.type = 'text/javascript';
        componentScript.async = true;
        componentScript.src = me.componentsBase + '/' + me.componentSrc(language);
        componentScript.onload = resolve;
        document.body.appendChild(componentScript);
      }
    }).then(function() {
      return me.exports();
    });

    return this.loadPromise;
  }

});
;
iorad.player.LocalforageComponent = iorad.base.Component.extend({

  componentsBase: iorad.base.Settings.get('components.basePath'),
  componentSrc: function() {
    return 'vendor/localforage.js';
  },

  isLoaded: function() {
    return typeof window.localforage !== 'undefined';
  },

  exports: function() {
    return window.localforage;
  },

  load: function() {
    if (this.loadPromise) return this.loadPromise; // loading

    var me = this;
    this.loadPromise = new Promise(function(resolve, reject) {
      if (me.isLoaded()) resolve();
      else {
        var componentScript = document.createElement('script');
        componentScript.type = 'text/javascript';
        componentScript.async = true;
        componentScript.src = me.componentsBase + '/' + me.componentSrc();
        componentScript.onload = resolve;
        document.body.appendChild(componentScript);
      }
    }).then(function() {
      return me.exports();
    });

    return this.loadPromise;
  }

});
;
iorad.player.QrStylingComponent = iorad.base.Component.extend({

  componentsBase: iorad.base.Settings.get('components.basePath'),
  componentSrc: function() {
    return 'vendor/qr-code-styling.js';
  },

  isLoaded: function() {
    return typeof window.QRCodeStyling !== 'undefined';
  },

  exports: function() {
    return window.QRCodeStyling;
  },

  load: function() {
    if (this.loadPromise) return this.loadPromise; // loading

    var me = this;
    this.loadPromise = new Promise(function(resolve, reject) {
      if (me.isLoaded()) resolve();
      else {
        var componentScript = document.createElement('script');
        componentScript.type = 'text/javascript';
        componentScript.async = true;
        componentScript.src = me.componentsBase + '/' + me.componentSrc();
        componentScript.onload = resolve;
        document.body.appendChild(componentScript);
      }
    }).then(function() {
      return me.exports();
    });

    return this.loadPromise;
  }

});
;
iorad.player.EmojisComponent = iorad.base.Component.extend({

  componentsBase: iorad.base.Settings.get('components.basePath'),
  componentSrc: function () {
    return 'vendor/emojis.js';
  },

  isLoaded: function () {
    return typeof window.emojis !== 'undefined';
  },

  exports: function () {
    return window.emojis;
  },

  load: function () {
    if (this.loadPromise) return this.loadPromise; // loading

    var me = this;
    this.loadPromise = new Promise(function (resolve, reject) {
      if (me.isLoaded()) resolve();
      else {
        var componentScript = document.createElement('script');
        componentScript.type = 'text/javascript';
        componentScript.async = true;
        componentScript.src = me.componentsBase + '/' + me.componentSrc();
        componentScript.onload = resolve;
        document.body.appendChild(componentScript);
      }
    }).then(function () {
      return me.exports();
    });

    return this.loadPromise;
  }

});
;
iorad.player.Wysihtml5Component = iorad.base.Component.extend({

  componentsBase: iorad.base.Settings.get('components.basePath'),
  componentSrc: function () {
    return 'vendor/wysihtml5.js';
  },

  isLoaded: function () {
    return typeof window.wysihtml5 !== 'undefined';
  },

  exports: function () {
    return window.wysihtml5;
  },

  load: function () {
    if (this.loadPromise) return this.loadPromise; // loading

    var me = this;
    this.loadPromise = new Promise(function (resolve, reject) {
      if (me.isLoaded()) resolve();
      else {
        var componentScript = document.createElement('script');
        componentScript.type = 'text/javascript';
        componentScript.async = true;
        componentScript.src = me.componentsBase + '/' + me.componentSrc();
        componentScript.onload = resolve;
        document.body.appendChild(componentScript);
      }
    }).then(function () {
      return me.exports();
    });

    return this.loadPromise;
  }
});

;
iorad.player.SyncController = iorad.base.SyncController.extend({

  initialize: function() {
    iorad.base.SyncController.prototype.initialize.apply(this, arguments);
  },

  saveStatistics: function (uuid, embedType, embedUrl, name, data, onlyProgress) {
    return this._callNodeService('tutorial/saveStatistics', 'POST', {
      uuid: uuid,
      embedType: embedType,
      embedUrl: embedUrl,
      name: name,
      data: data,
      onlyProgress: onlyProgress,
    });
  },

  trackPlaySession: function(eventName, eventData) {
    return this._callNodeService('tutorial/trackPlaySession', 'POST', {
      event_name: eventName,
      event_data: eventData,
    });
  },

  updateDisabledStatus: function(disabled) {
    return this._callNodeService('tutorial/updateDisabledStatus', 'POST', {
      tutorial_ids: [this.tutorialId],
      disabled: disabled,
    }).then((result) => {
      siteWindow.parent.postMessage({
        from: 'iorad-web-app',
        topic: 'player:updateDisabledStatus',
        data: {
          disabled,
        },
      }, '*');
      return result;
    });
  },

  loadPlayer: function(lang, helpcenter, roleId) {
    return this._callNodeService('loadPlayer', 'GET', {
      lang: lang,
      helpcenter: helpcenter,
      roleId: roleId,
    });
  },

  getPlayerUser: function() {
    if (!this.getPlayerUserPromise) {
      this.getPlayerUserPromise = this._callNodeService('loadPlayerUser', 'GET')
        .catch(_.bind(function (err) {
          this.getPlayerUserPromise = undefined;
          return Promise.reject(err);
        }, this));
    }
    return this.getPlayerUserPromise;
  },

  saveQuizRecording: function (blob) {
    var formData = new FormData();
    formData.append('FileContents', blob);
    formData.append('mime_type', blob.type);
    return this._callNodeService('tutorial/saveQuizRecording', 'POST', formData);
  },

  listComments: function (params) {
    return this._callNodeService('tutorial/listComments', 'GET', params);
  },

  createComment: function (data) {
    return this._callNodeService('tutorial/createComment', 'POST', data);
  },

  editComment: function (data) {
    return this._callNodeService('tutorial/editComment', 'POST', data);
  },
});

;
// Based on:
/*
Source code created by Rustici Software, LLC is licensed under a
Creative Commons Attribution 3.0 United States License
(http://creativecommons.org/licenses/by/3.0/us/)

Want to make SCORM easy? See our solutions at http://www.scorm.com.
*/

// Original wrapper modified to add support for both SCORM 1.* (1.1, 1.2) and SCORM 2004.

iorad.player.SCORMController = (function() {

  var SCORMController = function() {
    if (typeof this.initialize === 'function') {
      this.initialize.apply(this, arguments);
    }
  };

  // Constants
  var SCORM_TRUE = "true";
  var SCORM_FALSE = "false";
  var SCORM_NO_ERROR = "0";

  _.extend(SCORMController.prototype, Backbone.Events, {

    // Track whether or not we successfully connected.
    connected: false,

    // Since the Unload handler will be called twice, from both the onunload
    // and onbeforeunload events, ensure that we only call Terminate once.
    disconnectCalled: false,

    API: null,
    // can be either '1.*' or '2004', setted on findAPI
    APIVersion: undefined,

    initialize: function() {
      this.connect();

      $(window).on('beforeunload', _.bind(this.disconnect, this));
    },

    getAPI: function(win) {
      // In SCORM 1.1 and SCORM 1.2, the API object is always named “API”.
      // In SCORM 2004, the object is named “API_1484_11″.
      if (win.API) {
        this.APIVersion = '1.*';
        return win.API;
      }
      if (win.API_1484_11) {
        this.APIVersion = '2004';
        return win.API_1484_11;
      }
    },

    findAPI: function(win) {
      win = win || window;

      // Check to see if the window (win) contains the API
      // if the window (win) does not contain the API and
      // the window (win) has a parent window and the parent window
      // is not the same as the window (win)
      var nesting = 0;
      while (!this.getAPI(win) && win.parent && win.parent !== win) {

        // Note: 7 is an arbitrary number, but should be more than sufficient
        if (++nesting > 7) {
          console.log("Error finding API in window -- too deeply nested.");
          return;
        }

        // set the variable that represents the window being
        // being searched to be the parent of the current window
        // then search for the API again
        win = win.parent;
      }
      var API = this.getAPI(win);

      // if the API is null (could not be found in the current window)
      // and the current window has an opener window
      // try to find the API in the current window’s opener
      if (!API && win.opener && typeof win.opener !== "undefined") {
        API = this.findAPI(win.opener);
      }

      if (!API) {
        // Alert the user that the API Adapter could not be found
        console.log("Unable to find an API adapter");
      }

      return API;
    },

    // methodName must be of SCORM 2004,
    // will be transformed into 1.* version if needed
    callAPI: function(methodName, args) {
      if (this.APIVersion === "1.*") {
        if (methodName === 'Terminate') methodName = "LMSFinish";
        else methodName = "LMS" + methodName;
      }

      this.API[methodName].apply(this.API, args);
    },

    connect: function() {
      this.API = this.findAPI();

      if (!this.API) {
        console.log("ERROR - Could not establish a connection with the LMS.\n\nYour results may not be recorded.");
        return;
      }

      var result = this.callAPI('Initialize', [""]);

      if (result == SCORM_FALSE) {
        var errorNumber = this.callAPI('GetLastError');
        var errorString = this.callAPI('GetErrorString', [errorNumber]);
        var diagnostic = this.callAPI('GetDiagnostic', [errorNumber]);

        var errorDescription = "Number: " + errorNumber + "\nDescription: " + errorString + "\nDiagnostic: " + diagnostic;

        console.log("Error - Could not initialize communication with the LMS.\n\nYour results may not be recorded.\n\n" + errorDescription);
        return;
      }

      this.connected = true;

      // https://github.com/iorad/iorad/issues/13921#issuecomment-1873366082
      this.setCompletition(false, false);
    },

    disconnect: function() {
      if (this.connected == false || this.disconnectCalled == true) return;

      var result = this.callAPI('Terminate', [""]);
      this.disconnectCalled = true;

      if (result == SCORM_FALSE) {
        var errorNumber = this.callAPI('GetLastError');
        var errorString = this.callAPI('GetErrorString', [errorNumber]);
        var diagnostic = this.callAPI('GetDiagnostic', [errorNumber]);

        var errorDescription = "Number: " + errorNumber + "\nDescription: " + errorString + "\nDiagnostic: " + diagnostic;

        console.log("Error - Could not terminate communication with the LMS.\n\nYour results may not be recorded.\n\n" + errorDescription);
        return;
      }
    },

    get: function(element) {
      if (this.connected == false || this.disconnectCalled == true) return;

      var result = this.callAPI('GetValue', [element]);

      if (result == "") {
        var errorNumber = this.callAPI('GetLastError');
        if (errorNumber != SCORM_NO_ERROR) {
          var errorString = this.callAPI('GetErrorString', [errorNumber]);
          var diagnostic = this.callAPI('GetDiagnostic', [errorNumber]);

          var errorDescription = "Number: " + errorNumber + "\nDescription: " + errorString + "\nDiagnostic: " + diagnostic;

          console.log("Error - Could not retrieve a value from the LMS.\n\n" + errorDescription);
          return "";
        }
      }

      return result;
    },

    set: function(element, value) {
      if (this.connected == false || this.disconnectCalled == true) return;

      var result = this.callAPI('SetValue', [element, value]);
      if (result == SCORM_FALSE) {
        var errorNumber = this.callAPI('GetLastError');
        var errorString = this.callAPI('GetErrorString', [errorNumber]);
        var diagnostic = this.callAPI('GetDiagnostic', [errorNumber]);

        var errorDescription = "Number: " + errorNumber + "\nDescription: " + errorString + "\nDiagnostic: " + diagnostic;

        console.log("Error - Could not store a value in the LMS.\n\nYour results may not be recorded.\n\n" + errorDescription);
        return;
      }
    },

    // measure must be a number between 0 and 1
    setProgress: function(measure) {
      this.set("cmi.progress_measure", measure);
    },

    // based on https://stackoverflow.com/a/22801798
    setSessionTime: function(elapsedSeconds) {
      var ts = elapsedSeconds;

      var sec = (ts % 60);

      ts -= sec;
      var tmp = (ts % 3600); // # of seconds in the total # of minutes
      ts -= tmp; // # of seconds in the total # of hours

      // convert seconds to conform to CMITimespan type (e.g. SS.00)
      sec = Math.round(sec * 100) / 100;

      var strSec = String(sec);
      var strWholeSec = strSec;
      var strFractionSec = '';
      if (strSec.indexOf('.') !== -1) {
        strWholeSec = strSec.substring(0, strSec.indexOf('.'));
        strFractionSec = strSec.substring(strSec.indexOf('.') + 1, strSec.length);
      }
      if (strWholeSec.length < 2) {
        strWholeSec = '0' + strWholeSec;
      }
      strSec = strWholeSec;
      if (strFractionSec.length) {
        strSec = strSec + '.' + strFractionSec;
      }

      var hourStr = String(
        ((ts % 3600) != 0) ? 0 : (ts / 3600)
      );
      if (hourStr.length < 2) hourStr = '0' + hourStr;

      var minStr = String(
        ((tmp % 60) != 0) ? 0 : (tmp / 60)
      );
      if (minStr.length < 2) minStr = '0' + minStr;

      this.set("cmi.core.session_time", hourStr + ':' + minStr + ':' + strSec);
    },

    setCompletition: function(isComplete, isSuccess) {
      this.set("cmi.completion_status", isComplete ? 'completed' : 'incomplete');
      this.set("cmi.success_status", isSuccess ? 'passed' : 'failed');
      this.set("cmi.core.lesson_status", isComplete ? (isSuccess ? 'passed' : 'failed') : 'incomplete');
    },

    setScore: function(percent) {
      // The cmi.core.score.raw must be a normalized value between 0 and 100.
      this.set("cmi.core.score.raw", String(percent));
    },
  });

  return SCORMController;
})();
;
// Controller for the player progress api.

iorad.player.ProgressController = (function() {

  var ProgressController = function() {
    this.initialize.apply(this, arguments);
  };

  _.extend(ProgressController.prototype, Backbone.Events, {

    // this will be setted by the player on init
    tutorialId: -1,

    initialize: function(stepsCollection, scormController) {
      this.stepsCollection = stepsCollection;
      this.scormController = scormController;

      this.listenTo(this.stepsCollection, 'changeCurrent', this.onCurrentStepChange);
      this.listenTo(iorad.player.controllers.quiz, 'progress', this.onQuizProgress);
      this.listenTo(iorad.player.controllers.quiz, 'end', this.onQuizEnd);
      this.listenTo(iorad.player.events, 'ready:quick', this.onQuickReady);
    },

    // We assume a step is completed as soon as it is displayed
    // (for simplicity and for handling the last-step case)
    onCurrentStepChange: function() {
      var currentStepNumber = this.stepsCollection.getCurrentStepNumber();

      if (iorad.player.tab !== 'quiz') {
        // that's valid progress
        if (this.scormController) {
          var measure = currentStepNumber / this.stepsCollection.length;
          this.scormController.setProgress(measure);
          if (measure === 1) {
            this.scormController.setCompletition(true, true);
          }
        }
      }
    },

    onQuizProgress: function(intermediateReport) {
      if (this.scormController) {
        var measure = intermediateReport.progressPercent / 100;
        this.scormController.setProgress(measure);
      }
    },

    onQuizEnd: function (finalReport) {
      if (this.scormController) {
        this.scormController.setProgress(1);
        this.scormController.setCompletition(true, finalReport.passed);
        this.scormController.setSessionTime(finalReport.userSpeedTimestamp / 1000);
        this.scormController.setScore(finalReport.accuracyPercent);
      }
    },

    onQuickReady: function() {
      if (this.scormController) {
        this.scormController.setProgress(1);
        this.scormController.setCompletition(true, true);
      }
    },
  });

  return ProgressController;
})();
;
iorad.player.QuizController = (function() {
  var QuizController = function() {
    this.initialize.apply(this, arguments);
  };

  _.extend(QuizController.prototype, Backbone.Events, {
    initialize: function(tutorial, stepsCollection) {
      this.tutorial = tutorial;
      this.stepsCollection = stepsCollection;

      this.active = false;
      this.recorder = null;

      this.listenTo(iorad.player.events, 'player:ready', function() { this.listenActivation(); });
      this.listenTo(this.stepsCollection, 'changeCurrent', this.onCurrentStepChange);
    },

    listenActivation: function() {
      var check = _.bind(function() {
        if (iorad.player.controllers.views.isModalTab(iorad.player.tab)) {
          return;
        }
        var newActive = this.shouldActivate();
        if (newActive !== this.active) {
          if (newActive) {
            this.activate();
          } else {
            this.deactivate();
          }
        }
      }, this);
      this.listenTo(iorad.player.events, 'tab', check);
      this.listenTo(iorad.player.controllers.views, 'change:coverOpen', check);
      check();
    },

    shouldActivate: function() {
      return !iorad.player.controllers.views.isCoverOpen() &&
        iorad.player.tab === 'quiz';
    },

    activate: function() {
      this.active = true;
      this.reports = {};
      this.finalReport = null;
      this.startTimestamp = Date.now();
      this.endTimestamp = undefined;
      this.trigger('active', true);
      this.startRecording(); // TODO: delay this.startTimestamp after recording started
      this.onCurrentStepChange(); // for the initial progress event
    },

    setupRecording: function() {
      if (iorad.player.getParameters.quizRecording !== 'true') return Promise.resolve();
      if (this.recorder) return Promise.resolve();
      this.recorder = {};

      var setupUserStream = _.bind(function () {
        return navigator.mediaDevices.getUserMedia({
          video: {
            echoCancellation: false,
            noiseSuppression: true, // NOTE: not supported in Safari (browser will ignore it)
          },
          audio: {
            echoCancellation: false,
            noiseSuppression: true, // NOTE: not supported in Safari (browser will ignore it)
          }
        }).then(_.bind(function (userStream) {
          var video = document.createElement('video');
          if ('srcObject' in video) {
            video.srcObject = userStream;
          } else {
            // Avoid using this in new browsers, as it is going away.
            video.src = URL.createObjectURL(userStream);
          }
          video.volume = 0;
          video.play();

          this.recorder.userStream = userStream;
          this.recorder.video = video;
        }, this));
      }, this);

      var setupDisplayStream = _.bind(function () {
        return navigator.mediaDevices.getDisplayMedia({
          audio: false,
          video: true,
          displaySurface: 'browser',
          cursor: 'always',
        }).then(_.bind(function (displayStream) {
          this.recorder.displayStream = displayStream;
        }, this));
      }, this);

      var setupMergedStream = _.bind(function () {
        var tracks = []
          .concat(this.recorder.displayStream.getVideoTracks())
          .concat(this.recorder.userStream.getAudioTracks());
        var mergedStream = new MediaStream(tracks);
        this.recorder.mergedStream = mergedStream;
      }, this);

      var setupMediaRecorder = _.bind(function () {
        this.recorder.chunks = [];

        this.recorder.mediaRecorder = new MediaRecorder(this.recorder.mergedStream, {
          mimeType: 'video/webm',
        });

        this.recorder.mediaRecorder.ondataavailable = _.bind(function (e) {
          console.log('mediaRecorder ondataavailable');
          this.recorder.chunks.push(e.data);
        }, this);

        this.recorder.mediaRecorder.stop = _.bind(function () {
          if (!this.recorder.stopped) {
            this.cancelRecording();
            return;
          }

          console.log('mediaRecorder stopped');
          var blob = new Blob(this.recorder.chunks, {
            type: this.recorder.mediaRecorder.mimeType
          });
          this.cleanupRecording();
          this.trigger('recording:stop');

          noty({
            type: 'information',
            text: iorad.player.successNotificationList.quizRecordingStopped(),
            closeButton: false,
            timeout: 0,
          });
          iorad.player.controllers.sync.saveQuizRecording(blob)
            .then(function (uploadedData) {
              noty({
                type: 'information',
                text: 'Upload completed',
                buttons: [{
                  addClass: 'btn btn-primary btn-green btn-small',
                  text: 'View',
                  onClick: _.bind(function ($noty) {
                    $noty.close();
                    var uploadedUrl = iorad.base.controllers.sync.getDecryptedAssetRemotePath(uploadedData.name, Date.now());
                    window.open(uploadedUrl, '_blank');
                  }, this)
                }]
              });
            })
            .catch(function (err) {
              console.error(err);
              noty({
                type: 'error',
                text: 'Upload failed: ' + String((err && err.message) || err),
              });
            });
        }, this);

        this.recorder.onDisplayStreamInactivated = _.bind(function () {
          console.log('displayStream inactivated');
          // ondataavailable is called shortly after (2ms) the displayStream is inactivated
          this.trigger('recording:inactive');
          setTimeout(_.bind(function () {
            if (!this.recorder.mediaRecorder.stop) return; // too late
            this.recorder.mediaRecorder.stop();
          }, this), 500);
        }, this);
        this.recorder.displayStream.addEventListener('inactive', this.recorder.onDisplayStreamInactivated);
      }, this);

      return Promise.resolve()
        .then(setupUserStream)
        .then(setupDisplayStream)
        .then(setupMergedStream)
        .then(setupMediaRecorder)
        .catch(_.bind(function (err) {
          iorad.app.controllers.sync.checkUnexpectedError(err, {
            name: 'player: quiz: setupRecording',
          });
          noty({
            type: 'error',
            text: String((err && err.message) || err),
          });
          this.cleanupRecording();
          return Promise.reject(err);
        }, this));
    },

    startRecording: function() {
      return this.setupRecording()
        .then(_.bind(function() {
          if (!this.recorder) return; // recording is disabled
          if (this.recorder.started) return;
          this.recorder.started = true;
          this.recorder.mediaRecorder.start();
          noty({
            type: 'information',
            text: iorad.player.successNotificationList.quizRecordingStarted(),
          });
          this.trigger('recording:start');
        }, this));
    },

    cleanupRecording: function() {
      if (!this.recorder) return;

      if (this.recorder.video) {
        this.recorder.video.src = undefined;
        this.recorder.video.srcObject = undefined;
      }

      if (this.recorder.mediaRecorder) {
        this.recorder.mediaRecorder.ondataavailable = undefined;
        this.recorder.mediaRecorder.stop = undefined;
      }

      this.recorder.start = undefined;

      if (this.recorder.displayStream) {
        this.recorder.displayStream.removeEventListener('inactive', this.recorder.onDisplayStreamInactivated);
      }

      var tracks = []
        .concat(this.recorder.userStream ? this.recorder.userStream.getTracks() : [])
        .concat(this.recorder.displayStream ? this.recorder.displayStream.getTracks() : []);
      tracks.forEach(_.bind(function (track) {
        track.stop();
      }, this));

      this.recorder = null;
    },

    cancelRecording: function() {
      if (!this.recorder) return;
      this.cleanupRecording();
      noty({
        type: 'information',
        text: iorad.player.successNotificationList.quizRecordingCanceled(),
      });
      this.trigger('recording:cancel');
    },

    stopRecording: function () {
      if (!this.recorder) return;
      this.recorder.stopped = true;

      var tracks = []
        .concat(this.recorder.userStream.getTracks())
        .concat(this.recorder.displayStream.getTracks());
      tracks.forEach(_.bind(function (track) {
        track.stop();
      }, this));
    },

    deactivate: function() {
      this.active = false;
      this.trigger('active', false);
      this.cancelRecording();
    },

    isActive: function() {
      return this.active;
    },

    restart: function() {
      this.activate();
    },

    // NOTE: this is called from the outside on step completion/failure
    checkStepCompletition: function(completed) {
      if (!this.active) return;

      var stepModel = this.stepsCollection.getCurrentModel();
      if (!stepModel) return;

      if (stepModel.get('type') === 'READ') { // in case of 'quizIncludedStepsType' === 'all'
        return;
      }

      var stepIndex = stepModel.get('index');

      var stepReport = this.reports[stepIndex] || {};

      // one single failure is enough to mark the step as failed
      stepReport.success = (stepReport.success === false)
        ? stepReport.success
        : !!completed;

      this.reports[stepIndex] = stepReport;
    },

    onCurrentStepChange: function() {
      if (!this.active) return;

      if (this.stepsCollection.position >= this.stepsCollection.length - 1) {
        this.endTimestamp = Date.now();
        this.finalReport = this.createReport();
        this.trigger('end', this.finalReport);
        this.stopRecording();
      } else {
        this.trigger('progress', this.createReport());
      }
    },

    getFormattedDuration: function(speedMS, roundMinutes) {
      var minutes = Math[roundMinutes ? 'ceil' : 'floor'](speedMS / (1000 * 60));
      var seconds = roundMinutes ? 0 : Math.ceil((speedMS - (minutes * 1000 * 60)) / 1000);

      var minutesStr = minutes === 0 ? '00'
        : minutes < 10 ? ('0' + minutes)
        : String(minutes);

      var secondsStr = seconds === 0 ? '00'
        : seconds < 10 ? ('0' + seconds)
        : String(seconds);

      return minutesStr + ':' + secondsStr;
    },

    createReport: function() {
      var successIndexes = _.filter(_.keys(this.reports), _.bind(function(stepIndex) {
        var stepReport = this.reports[stepIndex];
        return stepReport.success;
      }, this));

      var quizStepsCollection = this.stepsCollection.toQuiz();

      var durationType = this.tutorial.get('quizDurationType') || 'capture';
      var quizDuration = durationType === 'custom' ?
        this.tutorial.get('quizDurationTime')
        : durationType === 'capture' ?
          quizStepsCollection.getCaptureDuration()
          :
          quizStepsCollection.getReadDuration();

      var minAccuracyType = this.tutorial.get('quizAccuracyType') || 'default';
      var minAccuracyPercent = minAccuracyType === 'custom' ?
        this.tutorial.get('quizAccuracyPercent')
        :
        quizStepsCollection.getQuizDefaultAccuracy();

      var userAccuracyPercent = Math.floor((successIndexes.length / quizStepsCollection.length) * 100);

      var currentStepModel = this.stepsCollection.getCurrentModel();
      var quizCurrentStepIndex = currentStepModel ? quizStepsCollection.indexOf(currentStepModel) : -1;
      var quizCurrentStepNumber = quizCurrentStepIndex + 1;

      var endTimestamp = this.endTimestamp || Date.now();
      var userSpeedTimestamp = endTimestamp - this.startTimestamp;

      return {
        userSpeed: this.getFormattedDuration(userSpeedTimestamp),
        userSpeedTimestamp: userSpeedTimestamp,
        idealSpeed: this.getFormattedDuration(quizDuration, true),
        accuracy: successIndexes.length + '/' + quizStepsCollection.length,
        accuracyPercent: userAccuracyPercent,
        passed: userAccuracyPercent >= minAccuracyPercent,
        currentStepNumber: quizCurrentStepNumber,
        progressPercent: Math.floor((quizCurrentStepNumber / quizStepsCollection.length) * 100),
        stepReports: this.reports,
      };
    },

    getFinalReport: function() {
      return this.finalReport;
    },
  });

  return QuizController;
})();

;
// Controller for the player statistics api.

iorad.player.StatisticsController = (function() {

  var StatisticsController = function() {
    this.initialize.apply(this, arguments);
  };

  _.extend(StatisticsController.prototype, Backbone.Events, {

    initialize: function(stepsCollection, tutorial, tutorialId) {
      this.stepsCollection = stepsCollection;
      this.tutorial = tutorial;
      this.tutorialId = tutorialId;

      this.embedType = undefined;
      if (iorad.base.Utils.isEmbedded()) {
        if (iorad.player.getParameters.extensionEmbed) {
          if (iorad.player.getParameters.widgetEmbed) {
            this.embedType = 'widget';
          } else {
            this.embedType = 'extension';
          }
        } else if (iorad.player.getParameters.helpcenter) {
          this.embedType = 'helpcenter';
        } else {
          this.embedType = 'embed';
        }
      }
      this.embedUrl = this.embedType ?
        (iorad.player.getParameters.embedUrl || siteWindow.document.referrer)
        :
        undefined;

      this.lastView = {};

      this.localStorageKey = 'iorad.player.StatisticsController.' + this.tutorialId;
      this.uuid = undefined; // same for all tutorials, created and returned by the server (cookie & return value)
      this.retrieveData();

      this.listenTo(iorad.player.events, 'ready tab change:coverOpen', function() { this.checkPlayback(); });
      this.listenTo(this.stepsCollection, 'changeCurrent', function() { this.checkPlayback(); });
      this.listenTo(iorad.player.controllers.quiz, 'end', function () { this.checkPlayback(); });

      this.listenTo(iorad.player.events, 'pdfDownload:done', this.sendPdfDownload);
      this.listenTo(iorad.player.events, 'selectedTranslation', this.onSelectedTranslation);
    },

    retrieveData: function() {
      try {
        var storedDataString = localStorage.getItem(this.localStorageKey);
        this.storedData = storedDataString ? JSON.parse(storedDataString) : {};
      } catch (err) {
        // 3rd party cookies/data are disabled or invalid json data
        console.error(err);
        this.storedData = {};
      }
    },

    persistData: function() {
      try {
        localStorage.setItem(this.localStorageKey, JSON.stringify(this.storedData));
      } catch (err) {
        // 3rd party cookies/data are disabled
        console.error(err);
      }
    },

    getData: function(path) {
      if (Array.isArray(path)) path = path.join('.');
      return iorad.base.Utils.get(this.storedData, path);
    },

    setData: function(path, value) {
      if (Array.isArray(path)) path = path.join('.');
      iorad.base.Utils.set(this.storedData, path, value);
      this.persistData();
    },

    checkPlayback: function() {
      if (
        !iorad.player.mode ||
        iorad.player.mode === 'print' ||
        iorad.player.controllers.views.isModalTab(iorad.player.tab) ||
        iorad.player.controllers.views.isPopupOpen() ||
        iorad.player.controllers.views.isCoverOpen() ||
        this.stepsCollection.getCurrentStepNumber() <= 0
      ) {
        this.lastView = {};
        return;
      }

      // (duplicate calls are ignored via cache)
      this.sendLaunch();

      // We assume a step is completed as soon as it is displayed
      // (for simplicity and for handling the last-step case)
      this.sendProgress();

      if (this.stepsCollection.getCurrentStepNumber() === this.stepsCollection.length) {
        this.sendComplete();
      }
    },

    getStatisticsMode: function() {
      // so far, "watch" and "quiz" are not technically a mode, just an interactive mode feature
      return iorad.player.tab === 'watch' ? 'watch'
        : iorad.player.tab === 'quiz' ? 'quiz'
        : iorad.player.mode;
    },

    // NOTE: this is called often, even if there was no actual launch
    sendLaunch: function() {
      var statisticsMode = this.getStatisticsMode();
      if (!statisticsMode) return;

      var path = [statisticsMode, 'launched'];
      this.saveStatistics(path);
    },

    sendProgress: function() {
      var statisticsMode = this.getStatisticsMode();
      if (!statisticsMode) return;

      var dateNow = Date.now();
      var stepIndex = this.stepsCollection.getCurrentStepNumber() - 1;

      var newLastView = {
        statisticsMode: statisticsMode,
        stepIndex: stepIndex,
        timestamp: dateNow,
      };
      var shouldResetTimeSpent = (
        typeof this.lastView.statisticsMode === 'undefined' ||
        newLastView.statisticsMode !== this.lastView.statisticsMode ||
        typeof this.lastView.stepIndex === 'undefined' ||
        newLastView.stepIndex < this.lastView.stepIndex ||
        typeof this.lastView.timestamp === 'undefined'
      );
      var timeSpent = shouldResetTimeSpent
        ? 0
        : newLastView.timestamp - this.lastView.timestamp;
      this.lastView = newLastView;

      var path = [statisticsMode, 'steps', stepIndex, 'viewed'];

      var quizReport;
      if (statisticsMode === 'quiz') {
        quizReport = iorad.player.controllers.quiz.getFinalReport() ||
          iorad.player.controllers.quiz.createReport();
      }

      this.saveStatistics(
        path,
        {
          timeSpent: timeSpent,
          quizReport: quizReport,
        },
        {
          // viewed events are also used to track learner progress
          // which requires for the event to be sent every time
          // regardless of cache
          ignoreExisting: true,
        }
      );
    },

    sendComplete: function() {
      var statisticsMode = this.getStatisticsMode();
      if (!statisticsMode) return;

      var path = [statisticsMode, 'completed'];
      this.saveStatistics(path);

      if (
        siteWindow.top !== siteWindow
      ) {
        siteWindow.parent.postMessage({
          from: 'iorad-web-app',
          topic: 'player:finish',
          data: {
            tutorialId: this.tutorialId,
            mode: statisticsMode,
          },
        }, '*');
      }
    },

    sendPdfDownload: function(layoutType) {
      var type = layoutType === 'short' ? 'portrait' : 'landscape';
      var path = ['pdfDownloads', type];
      this.saveStatistics(path);
    },

    onSelectedTranslation: function(languageCode) {
      var tutorialLanguage = (iorad.player.data.tutorial.get('language') || 'en');
      if (languageCode !== tutorialLanguage) {
        this.sendTranslations(languageCode);
      }
    },

    sendTranslations: function(languageCode) {
      var type = languageCode.toLowerCase();
      var path = ['translations', type];
      this.saveStatistics(path);
    },

    saveStatistics: function(path, data, options) {
      if (!iorad.base.Settings.get('server.statistics.isEnabled')) return;

      options = options || {};
      iorad.player.events.trigger('statistics:' + path.join(':'), data);
      var exists = !!this.getData(path);
      if (exists && !options.ignoreExisting) return;
      this.enqueueApiCall(_.bind(function() {

        if (siteWindow.top !== siteWindow) {
          siteWindow.parent.postMessage({
            from: 'iorad-web-app',
            topic: 'save:statistics',
            data: path,
          }, '*');
        }

        // first call: this.uuid is undefined
        // => the server reads it from cookies or generates it (if first time or if 3rd party cookies disabled)
        // on the following calls the returned uuid is passed to the server,
        // this way even in case of disabled cookies, the same uuid is used for the whole player session
        // if cookies work, then the same uuid is used in the whole site and even in the extension
        return iorad.player.controllers.sync.saveStatistics(
          this.uuid,
          this.embedType,
          this.embedUrl,
          path.join('.'),
          data,
          exists
        )
          .then(_.bind(function (uuid) {
            this.uuid = uuid;
          }, this));
      }, this));

      this.setData(path, true);
    },

    enqueueApiCall: function(fn) {
      if (this.saveStatisticsApiPromise) {
        return Promise.resolve(this.saveStatisticsApiPromise)
          .then(
            _.bind(function() {
              return this.enqueueApiCall(fn);
            }, this),
            _.bind(function () {
              return this.enqueueApiCall(fn);
            }, this)
          );
      }
      var fnPromise;
      try {
        fnPromise = Promise.resolve(fn());
      } catch (err) {
        // synchronous error while executing fn
        fnPromise = Promise.reject(err);
      }
      this.saveStatisticsApiPromise = fnPromise
        .then(_.bind(function (res) {
          this.saveStatisticsApiPromise = undefined;
          return res;
        }, this))
        .catch(_.bind(function (err) {
          this.saveStatisticsApiPromise = undefined;
          return Promise.reject(err);
        }, this));
      return this.saveStatisticsApiPromise;
    },
  });

  return StatisticsController;
})();

;
iorad.player.ClientDetectController = iorad.base.ClientDetectController.extend({});
;
iorad.player.ScreenshotsController = iorad.base.ScreenshotsController.extend({
  initialize: function() {
    iorad.base.ScreenshotsController.prototype.initialize.apply(this, arguments);
  },

  // NOTE: only call this after tutorial is fetched
  // NOTE: this is called multiple times (when tutorial changes) make sure to avoid memory leaks
  resetZoom: function() {
    this.zoomSequence = [1, 0.5, 0];

    var customZoom = iorad.player.getParameters.screenshotZoom
      ? parseFloat(iorad.player.getParameters.screenshotZoom)
      : (iorad.player.getParameters.fullshot === 'true')
        ? 0
        : iorad.player.data.tutorial.getLayoutOption('is_75_screenshot_zoom')
          ? 0.75
          : iorad.player.data.tutorial.getLayoutOption('is_half_screenshot_zoom')
            ? 0.5
            : iorad.player.data.tutorial.getLayoutOption('is_full_screenshot_zoom')
              ? 0
              : 1;
    if (isNaN(customZoom)) {
      customZoom = 1;
    }

    // add customZoom to the zoom sequence
    var customZoomIndex = _.findIndex(this.zoomSequence, _.bind(function(v) {
      return v < customZoom;
    }, this));
    if (customZoomIndex === -1) customZoomIndex = this.zoomSequence.length;
    this.zoomSequence.splice(customZoomIndex, 0, customZoom);

    // remove consecutive equal values from zoomSequence
    this.zoomSequence = _.filter(this.zoomSequence, _.bind(function(v, i) {
      // NOTE: always keep the 0th element as there is nothing before it
      return i === 0 || v !== this.zoomSequence[i - 1];
    }, this));

    // make loopable
    // e.g  [1, 0.8, 0.6, 0.4] => [1, 0.8, 0.6, 0.4, 0.6, 0.8]
    this.zoomSequence = this.zoomSequence.concat(this.zoomSequence.slice(1, -1).reverse());

    this.zoomIndex = _.findIndex(this.zoomSequence, _.bind(function(v) {
      return v === customZoom;
    }, this));
    if (this.zoomIndex === -1) this.zoomIndex = 0;

    this.trigger('change:zoom', this.getCurrentZoom());
  },

  getCurrentZoomIndex: function() {
    return this.zoomIndex;
  },

  getCurrentZoom: function() {
    return this.zoomSequence[this.getCurrentZoomIndex()];
  },

  getNextZoomIndex: function() {
    return (this.zoomIndex + 1) % this.zoomSequence.length;
  },

  getNextZoom: function() {
    return this.zoomSequence[this.getNextZoomIndex()];
  },

  getPreviousZoomIndex: function() {
    var previousZoomIndex = this.zoomIndex - 1;
    if (previousZoomIndex < 0) {
      previousZoomIndex = this.zoomSequence.length - 1;
    }
    return previousZoomIndex;
  },

  getPreviousZoom: function() {
    return this.zoomSequence[this.getPreviousZoomIndex()];
  },

  zoomNext: function() {
    this.zoomIndex = this.getNextZoomIndex();
    this.replaceUrl();
    this.trigger('change:zoom', this.getCurrentZoom());
  },

  zoomPrevious: function() {
    this.zoomIndex = this.getPreviousZoomIndex();
    this.replaceUrl();
    this.trigger('change:zoom', this.getCurrentZoom());
  },

  isNextZoomIn: function () {
    return this.getNextZoom() > this.getCurrentZoom();
  },

  replaceUrl: function() {
    if (
      iorad.player.controllers.clientDetect.browser.isFirefox ||
      iorad.player.router.isPreviewMode()
    ) {
      // - TODO: on firefox causes page reload on any hash change (See #10131).
      // - On preview player causes infinite loading on device change (see #10353)
      return;
    }

    iorad.player.getParameters.screenshotZoom = this.getCurrentZoom() + '';
    delete iorad.player.getParameters.fullshot;

    var newUrl = iorad.base.Utils.createUrl({
      urlParameters: iorad.player.getParameters,
    });

    // NOTE: makes sure to replace both window and siteWindow to avoid
    // bugs like https://github.com/iorad/iorad/issues/7905#issuecomment-565803657
    window.history.replaceState({}, 'ioradNodeApp', newUrl);
    siteWindow.ioradNodeApp.setLocation(newUrl, { historyReplaceState: true }); // change url without reloading the page
  },
});

;
iorad.player.ViewsController = iorad.base.ViewsController.extend({

  initialize: function() {
    iorad.base.ViewsController.prototype.initialize.apply(this, arguments);

    this._coverOpen = true;
    this.renderOperations = {};
    this.ignoredRenderOperations = {};
    this._forceStepPanel = '';
    this._forceStepPanelFromMode = '';
    this._stepPanelBeforeForce = '';

    this.COLLAPSED_STEP_PANEL = 'navbarOnly';
    this.UNCOLLAPSED_STEP_PANEL = 'minimized';
    this.EXPANDED_STEP_PANEL = 'full';
    this.UNEXPANDED_STEP_PANEL = 'minimized';

    this.listenTo(this.stepsCollection, 'changeCurrent reset', _.bind(function () {
      this.updateStepPanel(); // to show full panel on last slide, to update panel on audioId change
    }, this));
    this.listenTo(iorad.player.events, 'tab', _.bind(function () {
      this.updateStepPanel(); // to show full panel on modal tabs
    }, this));
    this.listenTo(iorad.player.events, 'change:mode', _.bind(function () {
      this.updateStepPanel(); // to handle mobilequick special "full" rules
    }, this));
    this.listenTo(this, 'change:forceStepPanel', _.bind(function () {
      this.updateStepPanel(); // to show full panel on modal tabs
    }, this));
    this.listenTo(this.tutorial, window.iorad.stepPanelOptions.map(o => `change:direct_${o} change:embed_${o} change:widget_${o}`).join(' '), () => {
      this.updateStepPanel();
    });
    this.listenTo(iorad.player.events, 'sound:mute sound:unmute audio:volume', () => {
      this.updateStepPanel();
    });
    $(window).on('resize', () => {
      this.updateStepPanel(); // for the playerIsSmallWidth check
    });
    this.updateStepPanel();
  },

  updateStepPanel: function () {
    const currentStep = this.stepsCollection.getCurrentModel();

    var getForcedStepPanel = _.bind(function () {
      // var forceFull = (
      //   this.stepsCollection.position === this.stepsCollection.length - 1 && // bring back on last step
      //   iorad.player.getParameters.videoExport !== 'true' // except if in video-export
      // ) || (
      //   this.isModalTab(iorad.player.tab) // bring back in modal tabs
      // ) || (
      //   iorad.player.getParameters.fullStepPanel === 'true'
      // );
      // if (forceFull) {
      //   //return 'full';
      // }

      var forceStepPanel = this.getForceStepPanel();
      if (forceStepPanel) {
        return forceStepPanel;
      }

      var forceFull = iorad.player.getParameters.fullStepPanel === 'true';
      if (forceFull) {
        return 'full';
      }

      var forceMinimized = (
        iorad.player.getParameters.minimizedStepPanel === 'true' ||
        iorad.player.getParameters.steptextStepPanel === 'true' // Handle REMOVED option: Steptext hidden => Minimized
      );
      if (forceMinimized) {
        return 'minimized';
      }

      // REMOVED
      // var forceSteptextOnly = iorad.player.getParameters.steptextStepPanel === 'true';
      // if (forceSteptextOnly) {
      //   return 'steptextOnly';
      // }

      var forceNavbarOnly = iorad.player.getParameters.navbarStepPanel === 'true';
      if (forceNavbarOnly) {
        return 'navbarOnly';
      }

      var forceHideEverything = iorad.player.getParameters.hiddenStepPanel === 'true';
      if (forceHideEverything) {
        return 'hideEverything';
      }

      // default
      return '';
    }, this);

    var getDefaultStepPanel = _.bind(function () {
      // priority this over default: https://github.com/iorad/iorad/issues/15045#issuecomment-2537784856
      if (currentStep && currentStep.get('event.stepPanelHidden')) {
        return 'hideEverything';
      }

      if (this.tutorial.getLayoutOption('is_hidden_step_panel')) {
        return 'hideEverything';
      }

      if (this.tutorial.getLayoutOption('is_navbar_step_panel')) {
        return 'navbarOnly';
      }

      if (this.tutorial.getLayoutOption('is_full_step_panel')) {
        return 'full';
      }

      if (
        this.tutorial.getLayoutOption('is_minimized_step_panel') ||
        this.tutorial.getLayoutOption('is_steptext_step_panel') // Handle REMOVED option: Steptext hidden => Minimized
      ) {
        return 'minimized';
      }
      // REMOVED
      // if (this.tutorial.getLayoutOption('is_steptext_step_panel')) {
      //   return 'steptextOnly';
      // }
      return 'minimized';
    }, this);

    var forcedStepPanel = getForcedStepPanel();
    var defaultStepPanel = getDefaultStepPanel();
    var stepPanel = forcedStepPanel || defaultStepPanel;
    if (
      stepPanel === 'full' &&
      iorad.player.mode === 'mobilequick' &&
      (!forcedStepPanel || this._forceStepPanelFromMode !== 'mobilequick')
    ) {
      // in Slide It, only show "Full" when explicitly forced from there
      stepPanel = 'minimized';
    } else if (
      stepPanel === 'full' &&
      iorad.player.mode === 'interactive' &&
      this.tutorial.get('isMobile') &&
      (!forcedStepPanel || this._forceStepPanelFromMode !== 'interactive')
    ) {
      // In Mobile Tutorial & Interactive, only show "Full" when explicitly forced from there
      stepPanel = 'minimized';
    }
    const playerIsSmallWidth = window.innerWidth < 800;
    const withAudio = (
      currentStep &&
      currentStep.get('audioId') != null &&
      !iorad.player.controllers.audio.isMuted() &&
      !iorad.player.audioVolumeDisabled
    );
    if (
      !forcedStepPanel &&
      ['full', 'minimized'].includes(stepPanel) &&
      playerIsSmallWidth
    ) {
      // Save space when in small width
      if (withAudio) {
        stepPanel = 'minimized';
      } else {
        stepPanel = 'minimized';
      }
    }

    var oldStepPanel = $('html').attr('data-stepPanel');
    $('html').attr('data-stepPanel', stepPanel);
    if (oldStepPanel !== stepPanel) {
      iorad.player.oldStepPanelType = iorad.player.stepPanelType;
      iorad.player.stepPanelType = stepPanel;
      iorad.player.events.trigger('change:stepPanel', stepPanel);
    }
  },

  doShowDuration: function() {
    var durationMinutes = this.tutorial.get('duration') / 60000;
    return (durationMinutes < 15);
  },

  isFullscreenBtnVisible: function() {
    return false;
  },

  setNextPlayerData: function(data) {
    var nextTutorialData = null;

    if (data.nextTutorials && data.nextTutorials.length) {
      nextTutorialData = {
        tutorial: data.nextTutorials[0],
        showTimer: data.showTimer
      };

      this.trigger('set:tutorialData', nextTutorialData);
    }
  },

  setCoverOpen: function(value, instant, force) {
    if (value && iorad.player.getParameters.coverDisabled && !force) return;
    if (this._coverOpen !== value) {
      if (value === false && !instant) {
        this.notifyBeforeCoverOpen(value);
        this.collapseCover().then(function() {
          this.notifyCoverOpen(value);
        }.bind(this));
      } else {
        this.notifyBeforeCoverOpen(value);
        this.notifyCoverOpen(value);
      }
    }
  },

  notifyBeforeCoverOpen: function(value) {
    this.trigger('before:change:coverOpen', value);
    iorad.player.events.trigger('before:change:coverOpen', value);

    try {
      if (siteWindow.parent !== siteWindow) {
        siteWindow.parent.postMessage({
          topic: 'player:before:change:coverOpen',
          from: 'iorad-web-app',
          data: value,
        }, '*');
      }
    } catch (e) {
      console.error(e);
    }
  },

  notifyCoverOpen: function(value) {
    this._coverOpen = value;
    this.trigger('change:coverOpen', value);
    iorad.player.events.trigger('change:coverOpen', value);

    try {
      if (siteWindow.parent !== siteWindow) {
        siteWindow.parent.postMessage({
          topic: 'player:change:coverOpen',
          from: 'iorad-web-app',
          data: value,
        }, '*');
      }
    } catch (e) {
      console.error(e);
    }
  },

  getThemeColors: function() {
    var currentTheme = this.themesCollection.get(
      this.tutorial.get('theme')
    );
    return iorad.base.Export.themeToItemColors(
      currentTheme && currentTheme.attributes,
      this.tutorial.get('baseThemes'),
      this.tutorial.get('theme'),
      this.isCoverOpen()
    );
  },

  collapseCover: function() {
    var ic = this.getThemeColors();
    $('#header .header-inner')
      .css('background-color', ic.header.collapsedCoverBackground);

    $('#header').addClass('collapsing');
    this.trigger('change:coverCollapsing');
    return new Promise(function(resolve) {
      $('#header').removeClass('collapsing');
      resolve();
    });
  },

  isCoverOpen: function() {
    return this._coverOpen;
  },

  isCoverCollapsing: function() {
    return $('#header').hasClass('collapsing');
  },

  setTooltipOnOverflow: function(viewEl, position) {
    if (!viewEl) return;

    if (!viewEl.is(':visible')) {
      return;
    }

    viewEl.find('.tooltip').each(function() {
      const tooltipEl = $(this);
      const innerEl = tooltipEl.find('.tooltip-inner');
      const textEl = tooltipEl.find('.tooltip-text');

      if (!innerEl.length || !textEl.length) {
        return;
      }

      if (tooltipEl.is(':visible')) {
        const offset = innerEl.offset();

        tooltipEl.toggleClass('show', Boolean(innerEl.get(0).scrollWidth > innerEl.get(0).offsetWidth));

        const positionCss = {
          left: offset.left,
          top: offset.top + innerEl.height(),
        };

        if (position === 'top') {
          positionCss.top = 'auto';
          positionCss.bottom = window.innerHeight - offset.top;
        }

        textEl.css({
          position: 'fixed',
          bottom: 'auto',
          'max-width': 'max-content',
          ...positionCss,
        });
      }
    });
  },

  getCopyright: function() {
    var companySection = window.copyrightCompanyName;
    if (!companySection) return '';

    var createdDate = new Date(this.tutorial.get('created') + ' UTC');
    var createdYear = createdDate.getFullYear();

    var currentDate = new Date();
    var currentYear = currentDate.getFullYear();

    var yearSection = (createdYear !== currentYear) ?
      (createdYear + ' - ' + currentYear)
      :
      createdYear;

    return '© ' + yearSection + ' ' + companySection;
  },

  // copy of clearRenderOperation
  clearIgnoredRenderOperation: function(operationName) {
    const clearFn = this.ignoredRenderOperations[operationName];
    if (clearFn) {
      try {
        clearFn();
      } catch (err) {
        console.error(err);
      }
      delete this.ignoredRenderOperations[operationName];
    }
  },

  addToIgnoredRenderOperation: function(operationName, handler) {
    this.clearIgnoredRenderOperation(operationName);
    const clearFn = handler(this.clearIgnoredRenderOperation.bind(this, operationName));
    if (clearFn) {
      this.ignoredRenderOperations[operationName] = clearFn;
    }
  },

  clearRenderOperation: function(operationName) {
    var clearFn = this.renderOperations[operationName];
    if (clearFn) {
      try {
        clearFn();
      } catch (err) {
        console.error(err);
      }
      delete this.renderOperations[operationName];
      if (_.isEmpty(this.renderOperations)) {
        this.trigger('renderOperations:empty');
      }
    }
  },

  registerRenderOperation: function(operationName, handler) {
    if (
      // #15167
      !iorad.player.ready &&
      [
        'header.getPlayerUser', 'playbar.getPlayerUser', 'player.fontFamily',
        'header.logo'/* , 'header.backgroundImage' */, 'header.creatorImg'
      ].some(x => operationName.indexOf(x) > -1) &&
      iorad.player.getParameters.videoExport !== 'true'
    ) {
      this.addToIgnoredRenderOperation(operationName, handler);
      return;
    }
    this.clearRenderOperation(operationName);
    var clearFn = handler(this.clearRenderOperation.bind(this, operationName));
    if (clearFn) {
      this.renderOperations[operationName] = clearFn;
    }
  },

  registerImageUrlRender: function(operationName, imageUrl) {
    this.registerRenderOperation(operationName, function(onComplete) {
      if (imageUrl) {
        var image = new Image();
        image.addEventListener('load', onComplete);
        image.addEventListener('error', onComplete);
        if (!iorad.base.Utils.isFileProtocolURL(imageUrl)) {
          image.crossOrigin = 'Anonymous';
        }
        image.src = imageUrl;
        return function clear() {
          image.removeEventListener('load', onComplete);
          image.removeEventListener('error', onComplete);
        };
      }
      return null;
    }.bind(this));
  },

  registerImageElementRender: function(operationName, image) {
    this.registerRenderOperation(operationName, function(onComplete) {
      if (image && !image.complete) {
        image.addEventListener('load', onComplete);
        image.addEventListener('error', onComplete);
        return function clear() {
          image.removeEventListener('load', onComplete);
          image.removeEventListener('error', onComplete);
        }.bind(this);
      }
      return null;
    }.bind(this));
  },

  waitForRenderOperations: function(options) {
    return new Promise(function(resolve, reject) {
      try {
        options = options || {};

        if (_.isEmpty(this.renderOperations)) resolve();
        else {
          var timeout;
          if (options.timeoutMS) {
            timeout = setTimeout(function() {
              console.warn('waitForRenderOperations: TIMEOUT!');
              resolve();
            }.bind(this), options.timeoutMS);
          }
          this.listenToOnce(this, 'renderOperations:empty', function() {
            if (timeout) clearTimeout(timeout);
            setTimeout(function() {
              this.waitForRenderOperations(options).then(resolve, reject);
            }.bind(this), 0);
          }.bind(this));
        }
      } catch (err) {
        reject(err);
      }
    }.bind(this));
  },

  getFullscreenRequestElement: function () {
    var isPreviewMode = iorad.player.router.isPreviewMode();
    var ioradPlayerIframe = isPreviewMode ?
      siteWindow.parent.document.body.querySelector('iframe[name="ioradPlayerPreviewIframe"]')
      :
      siteWindow.document.body.querySelector('iframe[name="ioradPlayerIframe"]');
    var ioradPlayerIframeContainer = ioradPlayerIframe.parentElement;

    return ioradPlayerIframeContainer;
  },

  getFullscreenRequestDocument: function () {
    var el = this.getFullscreenRequestElement();
    return el.ownerDocument;
  },

  isFullscreen: function () {
    if (!screenfull.enabled) return false;
    var fullscreenRequestDocument = this.getFullscreenRequestDocument();
    return (
      screenfull.isFullscreen ||
      // #7831: fullscreen.js can not track siteWindow.document.documentElement
      // from fullscreen.js toggle
      Boolean(fullscreenRequestDocument[screenfull.raw.fullscreenElement])
    );
  },

  exitFullscreen: function () {
    if (!screenfull.enabled) return;
    var fullscreenRequestDocument = this.getFullscreenRequestDocument();
    // close fullscreen first
    if (screenfull.isFullscreen) {
      screenfull.toggle();
    } else if (fullscreenRequestDocument[screenfull.raw.fullscreenElement]) {
      fullscreenRequestDocument[screenfull.raw.exitFullscreen]();
    }
  },

  toggleFullscreen: function () {
    if (this.isFullscreen()) {
      this.exitFullscreen();
    } else {
      screenfull.request(this.getFullscreenRequestElement());
    }
  },

  setForceStepPanel: function (value) {
    var forceStepPanel = value;
    if (
      forceStepPanel !== this._forceStepPanel ||
      (
        forceStepPanel === 'full' &&
        iorad.player.mode === 'mobilequick' &&
        this._forceStepPanelFromMode !== 'mobilequick'
      )
    ) {
      if (this._forceStepPanel === '') {
        this._stepPanelBeforeForce = $('html').attr('data-stepPanel');
      }
      this._forceStepPanel = forceStepPanel;
      this._forceStepPanelFromMode = iorad.player.mode;
      this.trigger('change:forceStepPanel', this._forceStepPanel);
    }
  },

  getForceStepPanel: function () {
    return this._forceStepPanel;
  },

  isStepPanelCollapsed: function () {
    const stepPanel = $('html').attr('data-stepPanel');
    return stepPanel === this.COLLAPSED_STEP_PANEL;
  },

  isStepPanelExpanded: function () {
    const stepPanel = $('html').attr('data-stepPanel');
    return stepPanel === this.EXPANDED_STEP_PANEL;
  },

  collapseStepPanel: function () {
    const stepPanel = $('html').attr('data-stepPanel');
    if (stepPanel === this.COLLAPSED_STEP_PANEL) return; // already collapsed

    if (
      this._forceStepPanel &&
      this._stepPanelBeforeForce === this.COLLAPSED_STEP_PANEL
    ) {
      // back to default which is collapsed
      this.setForceStepPanel('');
    } else {
      this.setForceStepPanel(this.COLLAPSED_STEP_PANEL);
    }

    this.trigger('collapseStepPanel');
  },

  // NOTE: when uncollapsing, we always want to go to Minimized
  uncollapseStepPanel: function () {
    const stepPanel = $('html').attr('data-stepPanel');
    if (stepPanel === this.UNCOLLAPSED_STEP_PANEL) return; // already uncollapsed

    if (
      this._forceStepPanel &&
      this._stepPanelBeforeForce === this.UNCOLLAPSED_STEP_PANEL
    ) {
      // back to default which is uncollapsed
      this.setForceStepPanel('');
    } else {
      this.setForceStepPanel(this.UNCOLLAPSED_STEP_PANEL);
    }

    this.trigger('uncollapseStepPanel');
  },

  toggleCollapseStepPanel: function () {
    const stepPanel = $('html').attr('data-stepPanel');
    if (stepPanel === this.COLLAPSED_STEP_PANEL) {
      this.uncollapseStepPanel();
    } else {
      this.collapseStepPanel();
    }
  },

  expandStepPanel: function () {
    const stepPanel = $('html').attr('data-stepPanel');
    if (stepPanel === this.EXPANDED_STEP_PANEL) return; // already expanded

    if (
      this._forceStepPanel &&
      this._stepPanelBeforeForce === this.EXPANDED_STEP_PANEL &&
      iorad.player.mode !== 'mobilequick' // "Slide It" doesn't support default expanded
    ) {
      // back to default which is expanded
      this.setForceStepPanel('');
    } else {
      this.setForceStepPanel(this.EXPANDED_STEP_PANEL);
    }

    this.trigger('expandStepPanel');
  },

  // NOTE: when unexpanding, anything non-full goes
  unexpandStepPanel: function () {
    const stepPanel = $('html').attr('data-stepPanel');
    if (stepPanel !== this.EXPANDED_STEP_PANEL) return; // already unexpanded

    if (
      this._forceStepPanel &&
      this._stepPanelBeforeForce !== this.EXPANDED_STEP_PANEL
    ) {
      // back to default which is unexpanded
      this.setForceStepPanel('');
    } else {
      this.setForceStepPanel(this.UNEXPANDED_STEP_PANEL);
    }

    this.trigger('unexpandStepPanel');
  },

  toggleExpandStepPanel: function () {
    const stepPanel = $('html').attr('data-stepPanel');
    if (stepPanel === this.EXPANDED_STEP_PANEL) {
      this.unexpandStepPanel();
    } else {
      this.expandStepPanel();
    }
  },

  isModalTab: function (tab) {
    return ['pdf', 'share', 'comments', 'media', 'steps', 'selector'].includes(tab);
  },

  isPopupOpen: function () {
    return ['share', 'comments', 'media', 'steps', 'selector', 'language', 'pdf', 'advanced'].includes(iorad.player.tab);
  },
});

;
(function() {
  var view,
    audioStateMap = {}, // <step id, audioState>
    currentStepId = 0, // is step.index + 1
    langCode = '',
    soundCache = {}; //cache the sound by step id as key {key: {sound: , isLoaded}}

  function createAudioState(stepId) {
    return {
      // NOTE: items should not contain spaces since are used as HTML classes
      classes: [], // see view.getAllAudioStateClasses() for all possible classes
      hint: '',
      stepId: stepId,
    };
  }

  function getAudioState(stepId) {
    if (typeof stepId === 'undefined') {
      stepId = currentStepId;
    }
    var audioState = audioStateMap[stepId];
    if (typeof audioState === 'undefined') {
      audioState = audioStateMap[stepId] = createAudioState(stepId);
    }
    return audioState;
  }

  function updateAudioState(fn, stepId) {
    var audioState = getAudioState(stepId);
    var newAudioState = iorad.base.Utils.deepClone(audioState);
    fn(newAudioState);
    if (!_.isEqual(newAudioState, audioState)) {
      audioStateMap[newAudioState.stepId] = newAudioState;
      view.trigger('change:audioState', newAudioState);
    }
  }

  function onSoundLoad(stepId) {
    // use regular function to keep `this`
    return function () {
      soundCache[stepId + langCode] = {
        sound: this,
        isLoading: false,
        isLoaded: true
      };

      if (currentStepId === stepId) {
        updateAudioState(function (newAudioState) {
          if (Howler._muted) {
            newAudioState.classes.push(['mute']);
            newAudioState.hint = i18next.t('Audio is muted.');
          } else {
            newAudioState.classes = ['load'];
            newAudioState.hint = i18next.t('Audio is available.');
          }
        });

        iorad.player.events.trigger('sound:load', view.sound);
        view.trigger('loaded');
        if (Howler._muted) {
          this.on('end'); //end immediately
        }
      }
    }
  }

  function onSoundLoadError(stepId) {
    // use regular function to keep `this`
    return function () {
      // `this` is the sound, is null or window (in non strict mode) if step has no url
      if (this && this !== window) {
        soundCache[stepId + langCode] = {
          sound: this,
          isLoading: false,
          isLoaded: false
        };
      }

      if (stepId === currentStepId) {
        var tutorialNoAudio = !view.collection.some(stepModel =>
          stepModel.get('audioId') != null
        );

        var msg = i18next.t('This step has no audio.');
        if (view.collection.getCurrentStepNumber() == 0 || tutorialNoAudio) {
          //overview
          msg = i18next.t('This tutorial has no audio.');
        }

        updateAudioState(function (newAudioState) {
          newAudioState.classes = ['load-error'];
          if (tutorialNoAudio) {
            newAudioState.classes.push('tutorial-no-audio');
          }
          newAudioState.hint = msg;
        });

        view.trigger('loaderror');
        iorad.player.events.trigger('sound:loaderror', view.sound);
      }
    };
  }

  function onSoundPlay() {
    updateAudioState(function (newAudioState) {
      newAudioState.classes = ['play'];
      newAudioState.hint = i18next.t('Audio is playing.');
    });

    iorad.player.events.trigger('sound:play', view.sound);
  }

  function onSoundEnd() {
    updateAudioState(function (newAudioState) {
      newAudioState.classes = ['end'];
      newAudioState.hint = i18next.t('Audio is done.');
      if (Howler._muted) {
        newAudioState.classes.push(['mute']);
        newAudioState.hint = i18next.t('Audio is muted.');
      }
    });

    iorad.player.events.trigger('sound:end', view.sound);
  }

  function onSoundMute() {
    updateAudioState(function (newAudioState) {
      newAudioState.classes.push(['mute']);
      newAudioState.hint = i18next.t('Audio is muted.');
    });

    iorad.player.events.trigger('sound:mute', view.sound);
  }

  function onSoundUnmute() {
    updateAudioState(function (newAudioState) {
      if (newAudioState.classes.indexOf('load') >= 0) {
        newAudioState.hint = i18next.t('Audio is available.'); //will not go here currently
      } else if (newAudioState.classes.indexOf('end') >= 0) {
        newAudioState.hint = i18next.t('Audio is done.');
      } else {
        newAudioState.classes = ['play'];
        newAudioState.hint = i18next.t('Audio is playing.');
      }
      var muteClassIndex = newAudioState.classes.indexOf('mute');
      if (muteClassIndex >= 0) {
        newAudioState.classes.splice(muteClassIndex, 1);
      }
    });

    iorad.player.events.trigger('sound:unmute', view.sound);

    this.resetAudio();
  }

  iorad.player.AudioController = iorad.base.Component.extend({

    initialize: function(tutorialModel, stepsCollection) {
      view = this;

      this.model = tutorialModel;
      this.collection = stepsCollection;

      this.listenTo(this.collection, 'changeCurrent reset', this.resetAudio);
      this.listenTo(iorad.player.controllers.views, 'change:coverOpen', this.resetAudio);
      this.listenTo(iorad.player.events, 'mode', this.onModeChange);
      this.listenTo(iorad.player.events, 'tab', this.onTabChange);
      this.listenTo(iorad.player.events, 'toggle:languageDropdown', this.onLanguageDropdownToggle);
      this.listenTo(iorad.player.events, 'ready', this.onModeReady);
      this.listenTo(iorad.player.events, 'sound:play', this.trackAudioPlay);
      this.listenTo(iorad.player.events, 'sound:end', this.trackAudioFinish);
      this.listenTo(iorad.player.events, 'sound:loaderror', this.trackAudioLoadError);
      this.listenTo(this.model, 'change:quizMuteAudio', this.onQuizMuteAudioChange);
      this.listenTo(this.model, 'change:audioMutedByDefault', this.onAudioMutedByDefaultChange);

      this.transcriptionState = null;
      this.transcriptionEnabled = true; // #14781 on by default

      try {
        const item = localStorage.getItem('iorad_tutorial_audioTranscription'); // save for all tutorials
        this.transcriptionEnabled = item == null ? true : (item === 'true');
      } catch (err) {
        // 3rd party cookies/data are disabled
        console.error(err);
      }

      this.setupTranscription();

      this.resetAudio();
    },

    setupTranscription: function () {
      var TRANSCRIPTION_STEP_MS = 3000;
      var animationFrameRunning = false;

      var updateTranscriptionState = _.bind(function (newTranscriptionState) {
        var changed = (this.transcriptionState && this.transcriptionState.key) !== (newTranscriptionState && newTranscriptionState.key);
        if (changed) {
          this.transcriptionState = newTranscriptionState;
          this.trigger('change:transcriptionState', newTranscriptionState);
        }
      }, this);

      var animationFrameStep = _.bind(function () {
        var sound = iorad.player.controllers.audio.sound;
        var stepModel = this.collection.getCurrentModel();
        var tutorialAudioTranscriptionEnabled = this.model.get('audioTranscriptionEnabled');
        var audioTranscription = stepModel && stepModel.get('audioTranscription');
        if (
          this.transcriptionEnabled &&
          tutorialAudioTranscriptionEnabled &&
          sound &&
          iorad.player.controllers.audio.audioPlaying &&
          audioTranscription
        ) {
          try {
            // NOTE: renamed to sound.seek() in newer HOWER versions
            var seekMS = Math.floor(sound.pos() * 1000);

            // find the word that starts right before seekMS
            // its startTime is used to calculate the current transcription step
            // this way a word that overflows a step is still counted in the previous step
            // which "grows in size (time)" to make room for the overflow
            var startTimeBeforeSeek = _.last(
              audioTranscription.words
                .map(_.bind(function (wordItem) {
                  var startTimeMS = (Number(wordItem.startTime.seconds) * 1000) + Math.floor((wordItem.startTime.nanos / 1000000));
                  return startTimeMS;
                }, this))
                .filter(_.bind(function (startTimeMS) {
                  return startTimeMS <= seekMS;
                }, this))
            );
            if (!startTimeBeforeSeek) {
              startTimeBeforeSeek = 0;
            }

            var transcriptionStep = Math.floor(startTimeBeforeSeek / TRANSCRIPTION_STEP_MS);
            var transcriptionStepStartMs = transcriptionStep * TRANSCRIPTION_STEP_MS;
            var transcriptionStepEndMs = (transcriptionStep + 1) * TRANSCRIPTION_STEP_MS;

            var wordsToDisplay = audioTranscription.words.filter(_.bind(function (wordItem) {
              var startTimeMS = (Number(wordItem.startTime.seconds) * 1000) + Math.floor((wordItem.startTime.nanos / 1000000));
              var endTimeMS = (Number(wordItem.endTime.seconds) * 1000) + Math.floor((wordItem.endTime.nanos / 1000000));
              return (startTimeMS >= transcriptionStepStartMs && startTimeMS < transcriptionStepEndMs);
            }, this)).map(_.bind(function (wordItem) {
              return wordItem.word;
            }, this));

            updateTranscriptionState({
              key: stepModel.get('index') + '-' + transcriptionStep,
              wordsToDisplay: wordsToDisplay,
            });
          } finally {
            window.requestAnimationFrame(animationFrameStep);
          }
        } else {
          animationFrameRunning = false;
          updateTranscriptionState(null);
        }
      }, this);

      var check = _.bind(function () {
        if (!animationFrameRunning) {
          window.requestAnimationFrame(animationFrameStep);
          animationFrameRunning = true;
        }
      }, this);
      this.listenTo(this, 'change:audioState', check);
      this.listenTo(this, 'change:transcriptionEnabled', check);
      this.listenTo(iorad.player.events, 'sound:load sound:end sound:play sound:loaderror sound:mute sound:unmute', check);
      check();
    },

    getTranscriptionState: function() {
      return this.transcriptionState;
    },

    toggleTranscription: function(value) {
      if (typeof value === 'undefined') {
        value = !this.transcriptionEnabled;
      } else {
        value = Boolean(value);
      }
      if (value !== this.transcriptionEnabled) {
        this.transcriptionEnabled = value;
        this.trigger('change:transcriptionEnabled', value);
      }

      try {
        localStorage.setItem('iorad_tutorial_audioTranscription', value);
      } catch (err) {
        // 3rd party cookies/data are disabled
        console.error(err);
      }
    },

    getTranscriptionStateClasses: function(stepId) {
      if (typeof stepId === 'undefined') {
        stepId = this.collection.getCurrentStepNumber();
      }

      var classes = [];

      var stepModel = stepId > 0 ? this.collection.getModelAt(stepId - 1) : null;
      var tutorialAudioTranscriptionEnabled = this.model.get('audioTranscriptionEnabled');
      var audioTranscription = stepModel && stepModel.get('audioTranscription');
      if (!tutorialAudioTranscriptionEnabled || !audioTranscription) {
        classes.push('step-no-transcription');
      }

      if (this.transcriptionEnabled) {
        classes.push('enabled');
      } else {
        classes.push('disabled');
      }

      return classes;
    },

    getTranscriptionStateHint: function (stepId) {
      if (typeof stepId === 'undefined') {
        stepId = this.collection.getCurrentStepNumber();
      }

      var stepModel = this.collection.getModelAt(stepId - 1);
      var tutorialAudioTranscriptionEnabled = this.model.get('audioTranscriptionEnabled');
      var audioTranscription = stepModel && stepModel.get('audioTranscription');
      if (!tutorialAudioTranscriptionEnabled || !audioTranscription) {
        return i18next.t('This step has no transcription.');
      }

      if (!this.transcriptionEnabled) {
        return i18next.t('Transcription is enabled.');
      }
      return i18next.t('Transcription is disabled.');
    },

    getAllTranscriptionStateClasses: function() {
      return ['step-no-transcription', 'enabled', 'disabled'];
    },

    getTotalPlayTime: function () {
      return this.sound ? (this.sound._duration * 1000) : 0;
    },

    getRemainingPlayTime: function() {
      return (this.audioEnded || !this.sound) ?
        0 :
        (this.getTotalPlayTime() - (this.sound.pos() * 1000));
    },

    isAudioLoadingFinished: function() {
      return this.isSoundLoaded() || this.audioLoadFailed;
    },
    willAudioPlayFinish: function() {
      return !this.audioEnded && !this.audioLoadFailed;
    },

    waitForAudioLoading: function() {
      var stepModel = this.collection.getCurrentModel();
      if (!stepModel || stepModel.get('audioId') == null || this.isAudioLoadingFinished()) {
        return Promise.resolve();
      }
      var $this = this;
      return new Promise(function(resolve) {
        $this.once('loaded loaderror', resolve);
      });
    },
    waitForAudioFinish: function(delayAfterFinish) {
      delayAfterFinish = delayAfterFinish == undefined ? 0 : delayAfterFinish;
      if (this.audioEnded) {
        var audioEndTime = this.audioPlayStartTime + (this.sound._duration * 1000);
        var delayLeft = (audioEndTime + delayAfterFinish) - Date.now();
        if (delayLeft <= 0) return Promise.resolve();
        return iorad.base.Utils.setTimeoutPromise(delayLeft).promise;
      }
      if (!this.willAudioPlayFinish()) {
        return Promise.resolve();
      }
      var _this = this;
      return new Promise(function(resolve) {
        _this.listenToOnce(iorad.player.events, 'sound:end sound:loaderror', resolve);
      })
        .then(function() {
          return iorad.base.Utils.setTimeoutPromise(delayAfterFinish).promise;
        });
    },

    trackAudioReset: function() {
      this.audioLoadFailed = false;
      this.audioEnded = false;
      this.audioPlaying = false;
      this.audioPlayStartTime = 0;
    },
    trackAudioPlay: function() {
      this.audioEnded = false;
      this.audioPlaying = true;
      this.audioPlayStartTime = Date.now();
    },
    trackAudioFinish: function() {
      this.audioEnded = true;
      this.audioPlaying = false;
      this.audioPlayStartTime = 0;
      this.trigger('afterAudio');
    },
    trackAudioLoadError: function() {
      this.audioLoadFailed = true;
      this.audioEnded = false;
      this.audioPlaying = false;
      this.audioPlayStartTime = 0;
      this.trigger('afterAudio');
    },

    afterAudio: function(callback) {
      if (this.audioEnded === true) callback();
      else this.listenToOnce(this, 'afterAudio', callback);
    },

    // NOTE: forceToggle is optional
    toggleAudio: function(forceToggle) {
      var audioState = getAudioState();
      if (audioState.classes.indexOf('load-error') >= 0 && typeof forceToggle === 'undefined') {
        return false;
      }

      if (forceToggle === true || (typeof forceToggle === 'undefined' && Howler._muted)) {
        Howler.unmute();
        if (this.sound) this.sound.on('unmute');
      } else if (forceToggle === false || (typeof forceToggle === 'undefined' && !Howler._muted)) {
        Howler.mute();
        if (this.sound) this.sound.on('mute');
      }

      if (iorad.player.router.isHelpcenterMode()) {
        try {
          localStorage.setItem('iorad-player-helpcenter-' + iorad.player.getParameters.helpcenter + '-audioMuted', Howler._muted);
        } catch (err) {
          // 3rd party cookies/data are disabled
          console.error(err);
        }
      }

      return false;
    },

    toggleVolume: function (forceToggle) {
      if (forceToggle === true || (typeof forceToggle === 'undefined' && iorad.player.audioVolumeDisabled)) {
        iorad.player.audioVolumeDisabled = false;
        Howler.volume(1);
        if (this.sound) {
          this.sound._volume = 1;
        }
        iorad.player.events.trigger('audio:volume', this.video);
      } else if (forceToggle === false || (typeof forceToggle === 'undefined' && !iorad.player.audioVolumeDisabled)) {
        iorad.player.audioVolumeDisabled = true;
        Howler.volume(0);
        if (this.sound) {
          this.sound._volume = 0;
        }
        iorad.player.events.trigger('audio:volume', this.video);
      }
    },

    // stepId is the step number
    preloadAudio: function (stepId) {
      var audioId;
      var url;

      var playerPreviewEditor;
      try {
        playerPreviewEditor = iorad.player &&
          siteWindow.parent != siteWindow &&
          siteWindow.parent.iorad &&
          siteWindow.parent.iorad.editor;
      } catch (err) { // cors
        playerPreviewEditor = false;
      }

      if (stepId > 0 && stepId <= view.collection.length && !soundCache[stepId + langCode]) {
        audioId = view.collection.getModelAt(stepId - 1).get('audioId');

        if (view.collection.getModelAt(stepId - 1).get('_audioUrl')) {
          url = view.collection.getModelAt(stepId - 1).get('_audioUrl');
        } else {
          const lastModtime = view.collection.getModelAt(stepId - 1).get('audioModTime');
          const audioEncrypted = view.collection.getModelAt(stepId - 1).get('audioEncrypted');
          url = (audioId != null)
            ? (audioEncrypted || playerPreviewEditor)
              ? iorad.player.controllers.sync.getDecryptedAssetRemotePath(audioId + '.mp3', lastModtime)
              : iorad.player.controllers.sync.getAudioRemotePath(audioId, 'mp3', lastModtime)
            : '';
        }

        if (url) {
          return new Promise((resolve, reject) => {
            const sound = new Howl({
              urls: [url],
              format: 'mp3',
              onload: function () {
                soundCache[stepId + langCode] = {
                  sound: this,
                  isLoading: false,
                  isLoaded: true
                };
                resolve(sound);
              },
              onloaderror: function (err) {
                soundCache[stepId + langCode] = {
                  sound: this,
                  isLoading: false,
                  isLoaded: false
                };
                reject(err);
              }
            });
            soundCache[stepId + langCode] = {
              sound,
              isLoading: true,
              isLoaded: false,
            };
          });
        }
      }

      return Promise.resolve(null);
    },

    _eagerLoadAudio: function () {
      this.preloadAudio(currentStepId - 1);
      this.preloadAudio(currentStepId + 1);
    },

    initAudio: function () {
      var stepId = this.collection.getCurrentStepNumber(); // might be 0
      var currentStepModel = this.collection.getCurrentModel(); // might be NULL
      currentStepId = stepId;
      langCode = iorad.player.data.tutorial.get('selectedTranslation') || '';

      // prefer video in case this step has both audioId and videoId
      if (currentStepModel && currentStepModel.get('videoId') == null) {
        var audioId;
        var url;
        var self = this;
        var audioDurationMS;

        var playerPreviewEditor;
        try {
          playerPreviewEditor = iorad.player &&
            siteWindow.parent != siteWindow &&
            siteWindow.parent.iorad &&
            siteWindow.parent.iorad.editor;
        } catch (err) { // cors
          playerPreviewEditor = false;
        }

        audioId = currentStepModel.get('audioId');
        audioDurationMS = currentStepModel.get('audioDurationMS');

        if (currentStepModel.get('_audioUrl')) {
          url = currentStepModel.get('_audioUrl');
        } else {
          const lastModtime = currentStepModel.get('audioModTime');
          const audioEncrypted = currentStepModel.get('audioEncrypted');
          url = (audioId != null)
            ? (audioEncrypted || playerPreviewEditor)
              ? iorad.player.controllers.sync.getDecryptedAssetRemotePath(audioId + '.mp3', lastModtime)
              : iorad.player.controllers.sync.getAudioRemotePath(audioId, 'mp3', lastModtime)
            : '';
        }

        if (url) {
          var cachedSound = soundCache[stepId + langCode];
          if (cachedSound) {
            this.sound = cachedSound.sound;
            //update sound event hooks here
            this.sound._onload = [onSoundLoad(stepId)];
            this.sound._onloaderror = [onSoundLoadError(stepId)];
            this.sound._onplay = [onSoundPlay];
            this.sound._onend = [onSoundEnd];

            this.sound._volume = iorad.player.audioVolumeDisabled ? 0 : 1;

            if (!cachedSound.isLoading) {
              updateAudioState(_.bind(function (newAudioState) {
                if (cachedSound.isLoaded === true) {
                  if (Howler._muted) {
                    newAudioState.classes.push('mute');
                    newAudioState.hint = i18next.t('Audio is muted.');
                  } else {
                    newAudioState.classes = ['load'];
                    newAudioState.hint = i18next.t('Audio is available.');
                  }
                } else if (cachedSound.isLoaded === false) {
                  var tutorialNoAudio = !view.collection.some(_.bind(function (stepModel) {
                    return stepModel.get('audioId') != null;
                  }, this));

                  var msg = i18next.t('This step has no audio.');
                  if (self.collection.getCurrentStepNumber() == 0 || tutorialNoAudio) {
                    msg = i18next.t('This tutorial has no audio.');
                  }

                  newAudioState.classes = ['load-error'];
                  if (tutorialNoAudio) {
                    newAudioState.classes.push('tutorial-no-audio');
                  }
                  newAudioState.hint = msg;
                }
              }, this));
              if (cachedSound.isLoaded === true) {
                this.sound.on('load');
              } else if (cachedSound.isLoaded === false) {
                this.sound.on('loaderror');
              }
            }

          } else {
            this.sound = new Howl({
              urls: [url],
              format: 'mp3',
              onload: onSoundLoad(stepId),
              onloaderror: onSoundLoadError(stepId),
              onplay: onSoundPlay,
              onend: onSoundEnd
            });
            soundCache[stepId + langCode] = {
              sound: this.sound,
              isLoading: true,
              isLoaded: false,
            };
            this.sound._volume = iorad.player.audioVolumeDisabled ? 0 : 1;
          }


          this.sound._onmute = [onSoundMute];
          this.sound._onunmute = [onSoundUnmute.bind(this)];

          if (Howler._muted) this.sound.on('mute');

          var coverOpen = iorad.player.controllers.views.isCoverOpen();
          var tab = iorad.player.tab;
          var autoStartTimeout = 0;
          if (
            !Howler._muted &&
            !coverOpen &&
            !this.modeChanging &&
            !iorad.player.controllers.views.isModalTab(tab) &&
            !iorad.player.controllers.autoplay.paused
          ) {
            this.autoStartTimer = iorad.base.Utils.setTimeoutPromise(autoStartTimeout);
            this.autoStartTimer.promise
              .then(_.bind(function () {
                this.autoStartTimer = undefined;
                if (
                  iorad.player.getParameters.videoExport === 'true' &&
                  !iorad.player.videoExportReady
                ) {
                  // keep still at the start until videoExport is ready
                  this.sound.volume = 0;
                  this.sound.play();
                  this.sound.pause();
                  this.sound.currentTime = 0;
                  this.listenToOnce(iorad.player.events, 'videoExportReady', () => {
                    this.sound.volume = 1;
                    this.sound.play();
                  });
                } else {
                  this.sound.play();
                }
              }, this));
          }
        } else {
          this.sound = null;
          onSoundLoadError.call(null);
        }
      }

      this._eagerLoadAudio();
    },

    onModeChange: function(mode) {
      if (
        mode === iorad.player.oldMode ||
        mode === 'print' ||
        iorad.player.oldMode === 'print'
      ) {
        // ignore
        return;
      }

      this.modeChanging = mode;
      this.stopSoundAndAutoplay();
    },

    applyQuizMuteAudio: function () {
      this.quizMuteAudioApplied = true;
      this.audioMutedByDefaultApplied = false;
      this.quickDefaultMuted = false;

      var quizMuteAudio = this.model.get('quizMuteAudio');
      this.toggleAudio(!quizMuteAudio);
    },

    applyQuickMuteAudio: function () {
      this.quizMuteAudioApplied = true;
      this.audioMutedByDefaultApplied = false;
      this.quickDefaultMuted = true;

      // always muted by default
      this.toggleAudio(false);
    },

    applyAudioMutedByDefault: function () {
      this.audioMutedByDefaultApplied = true;
      this.quizMuteAudioApplied = false;
      this.quickDefaultMuted = false;

      var audioMutedByDefault = this.model.get('audioMutedByDefault');
      this.toggleAudio(!audioMutedByDefault);
    },

    onTabChange: function (tab) {
      var oldTab = iorad.player.oldTab;

      if (iorad.player.controllers.views.isModalTab(tab)) {
        this.tabBeforeModal = oldTab;
        this.stopSoundAndAutoplay();
      } else if (iorad.player.controllers.views.isModalTab(oldTab) && tab === this.tabBeforeModal) {
        // going back to the original tab, this won't trigger a mode change,
        // thus we do it manually to reset audio
        this.modeChanging = iorad.player.mode;
        this.onModeReady(iorad.player.mode);
      } else if (tab === 'quiz') {
        if (!this.quizMuteAudioApplied) this.applyQuizMuteAudio();
      } else if (tab === 'view') {
        if (!this.quickDefaultMuted) this.applyQuickMuteAudio();
      } else if (!iorad.player.controllers.views.isModalTab(tab)) {
        if (!this.audioMutedByDefaultApplied) this.applyAudioMutedByDefault();
      }
    },

    onLanguageDropdownToggle: function(expanded) {
      if (expanded) {
        this.stopSoundAndAutoplay();
      } else if (!iorad.player.controllers.views.isModalTab(iorad.player.tab)) {
        // going back to the original tab, this won't trigger a mode change,
        // thus we do it manually to reset audio
        this.modeChanging = iorad.player.mode;
        this.onModeReady(iorad.player.mode);
      }
    },

    onQuizMuteAudioChange: function () {
      this.quizMuteAudioApplied = false;
      if (iorad.player.tab === 'quiz') {
        this.applyQuizMuteAudio();
      }
    },

    onAudioMutedByDefaultChange: function () {
      this.audioMutedByDefaultApplied = false;
      if (iorad.player.tab !== 'quiz' && !iorad.player.controllers.views.isModalTab(iorad.player.tab)) {
        this.applyAudioMutedByDefault();
      }
    },

    stopSoundAndAutoplay: function() {
      if (this.sound) this.sound.stop();
      if (this.autoStartTimer) {
        this.autoStartTimer.cancel();
        this.autoStartTimer = undefined;
      }
    },

    getStoredHelpcenterAudioMuted: function() {
      try {
        return localStorage.getItem('iorad-player-helpcenter-' + iorad.player.getParameters.helpcenter + '-audioMuted');
      } catch (err) {
        // 3rd party cookies/data are disabled
        console.error(err);
      }
    },

    onModeReady: function(mode) {
      if (!this.modeChanging) return;
      this.modeChanging = undefined;

      if (
        iorad.player.router.isHelpcenterMode() &&
        this.getStoredHelpcenterAudioMuted() === 'true' &&
        !this.helpcenterDefaultMuted
      ) {
        // muted by default
        this.helpcenterDefaultMuted = true;
        this.toggleAudio(false);
      }

      this.resetAudio();
    },

    resetAudio: function() {
      this.trackAudioReset();
      this.stopSoundAndAutoplay();
      this.initAudio();
    },

    // muted state is global
    isMuted: function() {
      return Howler._muted === true;
    },

    isSoundLoaded: function(stepId) {
      if (typeof stepId === 'undefined') {
        stepId = currentStepId;
      }
      var stepNumber = stepId;
      var cachedSound = soundCache[stepNumber + langCode];
      if (cachedSound && cachedSound.isLoaded) {
        return true;
      }
      return false;
    },

    getAudioState: function(stepId) {
      return getAudioState(stepId);
    },

    getAudioStateClasses: function(stepId) {
      var audioState = getAudioState(stepId);
      var classes = _.clone(audioState.classes);
      var isMuted = this.isMuted();
      if (classes.length === 0 || audioState.stepId !== currentStepId) {
        // default
        var step = this.collection.getModelAt(audioState.stepId - 1);
        var hasAudio = step && step.get('audioId') != null;
        if (!hasAudio) {
          var tutorialNoAudio = !this.collection.some(_.bind(function (stepModel) {
            return stepModel.get('audioId') != null;
          }, this));
          classes = ['load-error'];
          if (tutorialNoAudio) {
            classes.push('tutorial-no-audio');
          }
        } else {
          if (isMuted) {
            classes = ['mute'];
          } else {
            classes = ['load'];
          }
        }
      } else if (isMuted && classes.indexOf('load-error') === -1) {
        classes = ['mute'];
      }
      return classes;
    },

    getAudioStateHint: function(stepId) {
      var audioState = getAudioState(stepId);
      var classes = _.clone(audioState.classes);
      var hint = audioState.hint;
      var isMuted = this.isMuted();
      if (!hint || audioState.stepId !== currentStepId) {
        // default
        var step = this.collection.getModelAt(audioState.stepId - 1);
        var hasAudio = step && step.get('audioId') != null;
        if (!hasAudio) {
          var tutorialNoAudio = !this.collection.some(_.bind(function (stepModel) {
            return stepModel.get('audioId') != null;
          }, this));
          hint = tutorialNoAudio
            ? i18next.t('This tutorial has no audio.')
            : i18next.t('This step has no audio.');
        } else {
          if (isMuted) {
            hint = i18next.t('Audio is muted.');
          } else {
            hint = i18next.t('Audio available.');
          }
        }
      } else if (isMuted && classes.indexOf('load-error') === -1) {
        hint = i18next.t('Audio is muted.');
      }
      return hint;
    },

    getAllAudioStateClasses: function() {
      return ['tutorial-no-audio', 'load-error', 'load', 'play', 'mute', 'end'];
    },

    pause: function() {
      if (!this.sound || !this.audioPlaying) return;
      this.sound.pause();
      this.audioPaused = true;
      this.audioPlaying = false;
    },
    resume: function() {
      if (!this.sound || !this.audioPaused) return;
      this.sound.play();
      this.audioPaused = false;
      this.audioPlaying = true;
    },

    isAudioCompletitionRequired: function () {
      const stepModel = iorad.player.data.stepsCollection.getCurrentModel();
      if (!stepModel) return false;
      const audioId = stepModel.get('audioId');
      const audioModTime = stepModel.get('audioModTime');

      let audioCompletedBefore = false;
      try {
        audioCompletedBefore = localStorage.getItem('iorad_tutorial_' + iorad.player.tutorialId + '_audioCompletition_' + audioId + '_' + audioModTime) === 'true';
      } catch (err) {
        // 3rd party cookies/data are disabled
        console.error(err);
      }

      const audioCompletedNow = _.intersection(this.getAudioStateClasses(), ['load', 'play']).length === 0;
      const completitionRequired = iorad.player.data.tutorial.get('requireAudioCompletition') &&
        audioId != null &&
        !audioCompletedBefore &&
        !audioCompletedNow;
      return completitionRequired;
    },

    storeAudioCompletion: function (audioId, audioModTime) {
      try {
        localStorage.setItem('iorad_tutorial_' + iorad.player.tutorialId + '_audioCompletition_' + audioId + '_' + audioModTime, 'true');
      } catch (err) {
        // 3rd party cookies/data are disabled
        console.error(err);
      }
    },
  });
})();

;
(function() {
  var view,
    videoStateMap = {}, // <step id, videoState>
    currentStepId = 0, // is step.index + 1
    langCode = '',
    videoCache = {}; //cache the video by step id as key {key: {video: , isLoaded}}

  // var videoPlayOnLoaded = true;

  const videoList = [];
  function Video({ urls, format, durationMS, onload, onloaderror, onplay, onend, onmute, onunmute }) {
    // constructor

    const videoEl = document.createElement('video');

    const video = {
      _videoEl: videoEl, // NOTE: video specific

      _duration: 0,

      _onload: onload ? (Array.isArray(onload) ? onload : [onload]) : [],
      _onloaderror: onloaderror ? (Array.isArray(onloaderror) ? onloaderror : [onloaderror]) : [],
      _onplay: onplay ? (Array.isArray(onplay) ? onplay : [onplay]) : [],
      _onend: onend ? (Array.isArray(onend) ? onend : [onend]) : [],
      _onmute: onmute ? (Array.isArray(onmute) ? onmute : [onmute]) : [],
      _onunmute: onunmute ? (Array.isArray(onunmute) ? onunmute : [onunmute]) : [],

      on: (eventName) => { // this is actually an event trigger
        const fnList = video[`_on${eventName}`];
        fnList.forEach(fn => fn.call(video));
      },
      pos: () => {
        return videoEl.currentTime;
      },
      play: () => {
        videoEl.play();
      },
      pause: () => {
        videoEl.pause();
      },
      stop: () => {
        videoEl.pause();

        // disabled for now
        // if (!videoPlayOnLoaded) {
        //   videoEl.currentTime = 0;
        // }

        videoEl.currentTime = 0;
      },
    };

    const onCanplaythrough = () => {
      videoEl.removeEventListener('canplaythrough', onCanplaythrough);
      videoEl.removeEventListener('error', onError);

      videoEl.addEventListener('play', () => {
        video._onplay.forEach(fn => fn.call(video));
      });
      videoEl.addEventListener('ended', () => {
        video._onend.forEach(fn => fn.call(video));
      });
      videoEl.volume = !iorad.player.videoVolumeDisabled ? 1 : 0;

      // videoEl.duration cannot be trusted since the 'canplaythrough' event
      // can happen before the video has fully loaded
      // See #13423
      video._duration = durationMS ? (durationMS / 1000) : videoEl.duration;

      video._onload.forEach(fn => fn.call(video));
    };
    const onError = (err) => {
      console.error(err);

      videoEl.removeEventListener('canplaythrough', onCanplaythrough);
      videoEl.removeEventListener('error', onError);

      video._onloaderror.forEach(fn => fn.call(video));
    };
    videoEl.addEventListener('canplaythrough', onCanplaythrough);
    videoEl.addEventListener('error', onError);
    videoEl.muted = true; // for IOS
    videoEl.setAttribute('playsinline', ''); // for IOS
    if (iorad.player.controllers.clientDetect.os.isIOS) {
      // NOTE: this shows the video controls, which will then be hidden by CSS
      videoEl.setAttribute('controls', ''); // required for IOS correct autoplay (TODO: is this still needed?)
    }
    videoEl.setAttribute('type', `video/${format}`); // for IOS
    videoEl.src = [urls[0]];
    videoEl.load();

    videoList.push(video);
    return video;
  }
  Video._muted = false;
  iorad.player.videoMuted = false;
  Video.mute = () => {
    Video._muted = true;
    iorad.player.videoMuted = true;
    // NOTE: 'mute' event must be manually triggered on each video (same behaviour as audio Howler)
  };
  Video.unmute = () => {
    Video._muted = false;
    iorad.player.videoMuted = false;
    // NOTE: 'unmute' event must be manually triggered on each video (same behaviour as audio Howler)
  };
  Video.videoList = videoList;

  function createVideoState(stepId) {
    return {
      // NOTE: items should not contain spaces since are used as HTML classes
      classes: [], // see view.getAllVideoStateClasses() for all possible classes
      hint: '',
      stepId: stepId,
    };
  }

  function getVideoState(stepId) {
    if (typeof stepId === 'undefined') {
      stepId = currentStepId;
    }
    var videoState = videoStateMap[stepId];
    if (typeof videoState === 'undefined') {
      videoState = videoStateMap[stepId] = createVideoState(stepId);
    }
    return videoState;
  }

  function updateVideoState(fn, stepId) {
    var videoState = getVideoState(stepId);
    var newVideoState = iorad.base.Utils.deepClone(videoState);
    fn(newVideoState);
    if (!_.isEqual(newVideoState, videoState)) {
      videoStateMap[newVideoState.stepId] = newVideoState;
      view.trigger('change:videoState', newVideoState);
    }
  }

  function onVideoLoad(stepId) {
    // use regular function to keep `this`
    return function () {
      videoCache[stepId + langCode] = {
        video: this,
        isLoading: false,
        isLoaded: true
      };

      if (stepId === currentStepId) {
        updateVideoState(function (newVideoState) {
          if (iorad.player.videoMuted) {
            newVideoState.classes.push(['mute']);
            newVideoState.hint = i18next.t('Video is muted.');
          } else {
            newVideoState.classes = ['load'];
            newVideoState.hint = i18next.t('Video is available.');
          }
        });

        iorad.player.events.trigger('video:load', view.video);
        view.trigger('loaded');
        if (iorad.player.videoMuted) {
          this.on('end'); //end immediately
        }
      }
    };
  }

  function onVideoLoadError(stepId) {
    // use regular function to keep `this`
    return function () {
      // `this` is the video, is null or window (in non strict mode) if step has no url
      if (this && this !== window) {
        videoCache[stepId + langCode] = {
          video: this,
          isLoading: false,
          isLoaded: false
        };
      }

      if (stepId === currentStepId) {
        var tutorialNoVideo = !view.collection.some(stepModel =>
          stepModel.get('videoId') != null
        );

        var msg = i18next.t('This step has no video.');
        if (view.collection.getCurrentStepNumber() == 0 || tutorialNoVideo) {
          //overview
          msg = i18next.t('This tutorial has no video.');
        }

        updateVideoState(function (newVideoState) {
          newVideoState.classes = ['load-error'];
          if (tutorialNoVideo) {
            newVideoState.classes.push('tutorial-no-video');
          }
          newVideoState.hint = msg;
        });

        view.trigger('loaderror');
        iorad.player.events.trigger('video:loaderror', view.video);
      }
    };
  }

  function onVideoPlay() {
    updateVideoState(function (newVideoState) {
      newVideoState.classes = ['play'];
      newVideoState.hint = i18next.t('Video is playing.');
    });

    iorad.player.events.trigger('video:play', view.video);
  }

  function onVideoEnd() {
    updateVideoState(function (newVideoState) {
      newVideoState.classes = ['end'];
      newVideoState.hint = i18next.t('Video is done.');
      if (iorad.player.videoMuted) {
        newVideoState.classes.push(['mute']);
        newVideoState.hint = i18next.t('Video is muted.');
      }
    });

    iorad.player.events.trigger('video:end', view.video);
  }

  function onVideoMute() {
    updateVideoState(function (newVideoState) {
      newVideoState.classes.push(['mute']);
      newVideoState.hint = i18next.t('Video is muted.');
    });

    iorad.player.events.trigger('video:mute', view.video);
  }

  function onVideoUnmute() {
    updateVideoState(function (newVideoState) {
      if (newVideoState.classes.indexOf('load') >= 0) {
        newVideoState.hint = i18next.t('Video is available.'); //will not go here currently
      } else if (newVideoState.classes.indexOf('end') >= 0) {
        newVideoState.hint = i18next.t('Video is done.');
      } else {
        newVideoState.classes = ['play'];
        newVideoState.hint = i18next.t('Video is playing.');
      }
      var muteClassIndex = newVideoState.classes.indexOf('mute');
      if (muteClassIndex >= 0) {
        newVideoState.classes.splice(muteClassIndex, 1);
      }
    });

    iorad.player.events.trigger('video:unmute', view.video);

    this.resetVideo();
  }

  iorad.player.VideoController = iorad.base.Component.extend({

    initialize: function(tutorialModel, stepsCollection) {
      view = this;

      this.model = tutorialModel;
      this.collection = stepsCollection;

      this.listenTo(this.collection, 'changeCurrent reset', this.resetVideo);
      this.listenTo(iorad.player.controllers.views, 'change:coverOpen', this.resetVideo);
      this.listenTo(iorad.player.events, 'mode', this.onModeChange);
      this.listenTo(iorad.player.events, 'tab', this.onTabChange);
      this.listenTo(iorad.player.events, 'toggle:languageDropdown', this.onLanguageDropdownToggle);
      this.listenTo(iorad.player.events, 'ready', this.onModeReady);
      this.listenTo(iorad.player.events, 'video:play', this.trackVideoPlay);
      this.listenTo(iorad.player.events, 'video:end', this.trackVideoFinish);
      this.listenTo(iorad.player.events, 'video:loaderror', this.trackVideoLoadError);
      this.listenTo(this.model, 'change:quizMuteVideo', this.onQuizMuteVideoChange);
      this.listenTo(this.model, 'change:videoMutedByDefault', this.onVideoMutedByDefaultChange);

      this.transcriptionState = null;
      this.transcriptionEnabled = true; // #14781 on by default

      try {
        const item = localStorage.getItem('iorad_tutorial_videoTranscription'); // save for all tutorials
        this.transcriptionEnabled = item == null ? true : (item === 'true');
      } catch (err) {
        // 3rd party cookies/data are disabled
        console.error(err);
      }

      this.setupTranscription();

      this.resetVideo();
    },

    setupTranscription: function () {
      var TRANSCRIPTION_STEP_MS = 1000;
      var animationFrameRunning = false;

      var updateTranscriptionState = _.bind(function (newTranscriptionState) {
        var changed = (this.transcriptionState && this.transcriptionState.key) !== (newTranscriptionState && newTranscriptionState.key);
        if (changed) {
          this.transcriptionState = newTranscriptionState;
          this.trigger('change:transcriptionState', newTranscriptionState);
        }
      }, this);

      var animationFrameStep = _.bind(function () {
        var video = iorad.player.controllers.video.video;
        var stepModel = this.collection.getCurrentModel();
        var tutorialVideoTranscriptionEnabled = this.model.get('videoTranscriptionEnabled');
        var videoTranscription = stepModel && stepModel.get('videoTranscription');
        if (
          this.transcriptionEnabled &&
          tutorialVideoTranscriptionEnabled &&
          video &&
          iorad.player.controllers.video.videoPlaying &&
          videoTranscription
        ) {
          try {
            var seekMS = Math.floor(video.pos() * 1000);

            // find the word that starts right before seekMS
            // its startTime is used to calculate the current transcription step
            // this way a word that overflows a step is still counted in the previous step
            // which "grows in size (time)" to make room for the overflow
            var startTimeBeforeSeek = _.last(
              videoTranscription.words
                .map(_.bind(function (wordItem) {
                  var startTimeMS = (Number(wordItem.startTime.seconds) * 1000) + Math.floor((wordItem.startTime.nanos / 1000000));
                  return startTimeMS;
                }, this))
                .filter(_.bind(function (startTimeMS) {
                  return startTimeMS <= seekMS;
                }, this))
            );
            if (!startTimeBeforeSeek) {
              startTimeBeforeSeek = 0;
            }

            var transcriptionStep = Math.floor(startTimeBeforeSeek / TRANSCRIPTION_STEP_MS);
            var transcriptionStepStartMs = transcriptionStep * TRANSCRIPTION_STEP_MS;
            var transcriptionStepEndMs = (transcriptionStep + 1) * TRANSCRIPTION_STEP_MS;

            var wordsToDisplay = videoTranscription.words.filter(_.bind(function (wordItem) {
              var startTimeMS = (Number(wordItem.startTime.seconds) * 1000) + Math.floor((wordItem.startTime.nanos / 1000000));
              var endTimeMS = (Number(wordItem.endTime.seconds) * 1000) + Math.floor((wordItem.endTime.nanos / 1000000));
              return (startTimeMS >= transcriptionStepStartMs && startTimeMS < transcriptionStepEndMs);
            }, this)).map(_.bind(function (wordItem) {
              return wordItem.word;
            }, this));

            updateTranscriptionState({
              key: stepModel.get('index') + '-' + transcriptionStep,
              wordsToDisplay: wordsToDisplay,
            });
          } finally {
            window.requestAnimationFrame(animationFrameStep);
          }
        } else {
          animationFrameRunning = false;
          updateTranscriptionState(null);
        }
      }, this);

      var check = _.bind(function () {
        if (!animationFrameRunning) {
          window.requestAnimationFrame(animationFrameStep);
          animationFrameRunning = true;
        }
      }, this);
      this.listenTo(this, 'change:videoState', check);
      this.listenTo(this, 'change:transcriptionEnabled', check);
      this.listenTo(iorad.player.events, 'video:load video:end video:play video:loaderror video:mute video:unmute', check);
      check();
    },

    getTranscriptionState: function() {
      return this.transcriptionState;
    },

    toggleTranscription: function(value) {
      if (typeof value === 'undefined') {
        value = !this.transcriptionEnabled;
      } else {
        value = Boolean(value);
      }
      if (value !== this.transcriptionEnabled) {
        this.transcriptionEnabled = value;
        this.trigger('change:transcriptionEnabled', value);
      }

      try {
        localStorage.setItem('iorad_tutorial_videoTranscription', value);
      } catch (err) {
        // 3rd party cookies/data are disabled
        console.error(err);
      }
    },

    getTranscriptionStateClasses: function(stepId) {
      if (typeof stepId === 'undefined') {
        stepId = this.collection.getCurrentStepNumber();
      }

      var classes = [];

      var stepModel = this.collection.getModelAt(stepId - 1);
      var tutorialVideoTranscriptionEnabled = this.model.get('videoTranscriptionEnabled');
      var videoTranscription = stepModel && stepModel.get('videoTranscription');
      if (!tutorialVideoTranscriptionEnabled || !videoTranscription) {
        classes.push('step-no-transcription');
      }

      if (this.transcriptionEnabled) {
        classes.push('enabled');
      } else {
        classes.push('disabled');
      }

      return classes;
    },

    getTranscriptionStateHint: function (stepId) {
      if (typeof stepId === 'undefined') {
        stepId = this.collection.getCurrentStepNumber();
      }

      var stepModel = this.collection.getModelAt(stepId - 1);
      var tutorialVideoTranscriptionEnabled = this.model.get('videoTranscriptionEnabled');
      var videoTranscription = stepModel && stepModel.get('videoTranscription');
      if (!tutorialVideoTranscriptionEnabled || !videoTranscription) {
        return i18next.t('This step has no transcription.');
      }

      if (!this.transcriptionEnabled) {
        return i18next.t('Transcription is enabled.');
      }
      return i18next.t('Transcription is disabled.');
    },

    getAllTranscriptionStateClasses: function() {
      return ['step-no-transcription', 'enabled', 'disabled'];
    },

    getTotalPlayTime: function () {
      return this.video ? (this.video._duration * 1000) : 0;
    },

    getRemainingPlayTime: function() {
      return (this.videoEnded || !this.video) ?
        0 :
        (this.getTotalPlayTime() - (this.video.pos() * 1000));
    },

    isVideoLoadingFinished: function() {
      return this.isVideoLoaded() || this.videoLoadFailed;
    },
    willVideoPlayFinish: function() {
      return !this.videoEnded && !this.videoLoadFailed;
    },

    waitForVideoLoading: function() {
      var stepModel = this.collection.getCurrentModel();
      if (!stepModel || stepModel.get('videoId') == null || this.isVideoLoadingFinished()) {
        return Promise.resolve();
      }
      var $this = this;
      return new Promise(function(resolve) {
        $this.once('loaded loaderror', resolve);
      });
    },
    waitForVideoFinish: function(delayAfterFinish) {
      delayAfterFinish = delayAfterFinish == undefined ? 0 : delayAfterFinish;
      if (this.videoEnded) {
        var videoEndTime = this.videoPlayStartTime + (this.video._duration * 1000);
        var delayLeft = (videoEndTime + delayAfterFinish) - Date.now();
        if (delayLeft <= 0) return Promise.resolve();
        return iorad.base.Utils.setTimeoutPromise(delayLeft).promise;
      }
      if (!this.willVideoPlayFinish()) {
        return Promise.resolve();
      }
      var _this = this;
      return new Promise(function(resolve) {
        _this.listenToOnce(iorad.player.events, 'video:end video:loaderror', resolve);
      })
        .then(function() { return iorad.base.Utils.setTimeoutPromise(delayAfterFinish).promise; });
    },

    trackVideoReset: function() {
      this.videoLoadFailed = false;
      this.videoEnded = false;
      this.videoPlaying = false;
      this.videoPlayStartTime = 0;
    },
    trackVideoPlay: function() {
      this.videoEnded = false;
      this.videoPlaying = true;
      this.videoPlayStartTime = Date.now();
    },
    trackVideoFinish: function() {
      this.videoEnded = true;
      this.videoPlaying = false;
      this.videoPlayStartTime = 0;
      this.trigger('afterVideo');
    },
    trackVideoLoadError: function() {
      this.videoLoadFailed = true;
      this.videoEnded = false;
      this.videoPlaying = false;
      this.videoPlayStartTime = 0;
      this.trigger('afterVideo');
    },

    afterVideo: function(callback) {
      if (this.videoEnded === true) callback();
      else this.listenToOnce(this, 'afterVideo', callback);
    },

    // NOTE: forceToggle is optional
    toggleVideo: function(forceToggle) {
      var videoState = getVideoState();
      if (videoState.classes.indexOf('load-error') >= 0 && typeof forceToggle === 'undefined') {
        return false;
      }

      if (forceToggle === true || (typeof forceToggle === 'undefined' && iorad.player.videoMuted)) {
        Video.unmute();
        if (this.video) this.video.on('unmute');
      } else if (forceToggle === false || (typeof forceToggle === 'undefined' && !iorad.player.videoMuted)) {
        Video.mute();
        if (this.video) this.video.on('mute');
      }

      if (iorad.player.router.isHelpcenterMode()) {
        try {
          localStorage.setItem('iorad-player-helpcenter-' + iorad.player.getParameters.helpcenter + '-videoMuted', iorad.player.videoMuted);
        } catch (err) {
          // 3rd party cookies/data are disabled
          console.error(err);
        }
      }

      return false;
    },

    toggleDisplay: function (forceToggle) {
      if (forceToggle === true || (typeof forceToggle === 'undefined' && iorad.player.videoDisplayDisabled)) {
        iorad.player.videoDisplayDisabled = false;
        iorad.player.events.trigger('video:display', this.video);
      } else if (forceToggle === false || (typeof forceToggle === 'undefined' && !iorad.player.videoDisplayDisabled)) {
        iorad.player.videoDisplayDisabled = true;
        iorad.player.events.trigger('video:display', this.video);
      }
    },

    toggleVolume: function (forceToggle) {
      if (forceToggle === true || (typeof forceToggle === 'undefined' && iorad.player.videoVolumeDisabled)) {
        iorad.player.videoVolumeDisabled = false;
        Video.videoList.forEach(video => {
          video._videoEl.volume = 1;
        });
        iorad.player.events.trigger('video:volume', this.video);
      } else if (forceToggle === false || (typeof forceToggle === 'undefined' && !iorad.player.videoVolumeDisabled)) {
        iorad.player.videoVolumeDisabled = true;
        Video.videoList.forEach(video => {
          video._videoEl.volume = 0;
        });
        iorad.player.events.trigger('video:volume', this.video);
      }
    },

    // stepId is the step number
    preloadVideo: function (stepId) {
      var videoId;
      var url;
      var durationMS;

      var playerPreviewEditor;
      try {
        playerPreviewEditor = iorad.player &&
          siteWindow.parent != siteWindow &&
          siteWindow.parent.iorad &&
          siteWindow.parent.iorad.editor;
      } catch (err) { // cors
        playerPreviewEditor = false;
      }

      if (stepId > 0 && stepId <= view.collection.length && !videoCache[stepId + langCode]) {
        videoId = view.collection.getModelAt(stepId - 1).get('videoId');
        url = view.collection.getModelAt(stepId - 1).get('videoData');
        durationMS = view.collection.getModelAt(stepId - 1).get('videoDurationMS');
        const videoFileExtension = view.collection.getModelAt(stepId - 1).get('videoFileExtension') || 'mp4';

        if (!url) {
          if (view.collection.getModelAt(stepId - 1).get('_videoUrl')) {
            url = view.collection.getModelAt(stepId - 1).get('_videoUrl');
          } else {
            const lastModtime = view.collection.getModelAt(stepId - 1).get('videoModTime');
            const videoEncrypted = view.collection.getModelAt(stepId - 1).get('videoEncrypted');
            url = (videoId != null)
              ? (videoEncrypted || playerPreviewEditor)
                ? iorad.player.controllers.sync.getDecryptedAssetRemotePath(videoId + '.' + videoFileExtension, lastModtime)
                : iorad.player.controllers.sync.getVideoRemotePath(videoId, videoFileExtension, lastModtime)
              : '';
          }
        }

        if (url) {
          return new Promise((resolve, reject) => {
            const video = new Video({
              urls: [url],
              format: videoFileExtension,
              durationMS,
              onload: function () {
                videoCache[stepId + langCode] = {
                  video: this,
                  isLoading: false,
                  isLoaded: true
                };
                resolve(video);
              },
              onloaderror: function (err) {
                videoCache[stepId + langCode] = {
                  video: this,
                  isLoading: false,
                  isLoaded: false
                };
                reject(err);
              },
            });
            videoCache[stepId + langCode] = {
              video,
              isLoading: true,
              isLoaded: false,
            };
          });
        }
      }

      return Promise.resolve(null);
    },

    _eagerLoadVideo: function () {
      this.preloadVideo(currentStepId - 1);
      this.preloadVideo(currentStepId + 1);
    },

    initVideo: function () {
      var stepId = this.collection.getCurrentStepNumber(); // might be 0
      var currentStepModel = this.collection.getCurrentModel(); // might be NULL
      var videoId;
      var url;
      var durationMS;
      var self = this;
      currentStepId = stepId;
      langCode = iorad.player.data.tutorial.get('selectedTranslation') || '';

      if (currentStepModel) {
        var playerPreviewEditor;
        try {
          playerPreviewEditor = iorad.player &&
            siteWindow.parent != siteWindow &&
            siteWindow.parent.iorad &&
            siteWindow.parent.iorad.editor;
        } catch (err) { // cors
          playerPreviewEditor = false;
        }

        videoId = currentStepModel.get('videoId');
        url = currentStepModel.get('videoData');
        durationMS = currentStepModel.get('videoDurationMS');
        const videoFileExtension = currentStepModel.get('videoFileExtension') || 'mp4';

        if (currentStepModel.get('_videoUrl')) {
          url = currentStepModel.get('_videoUrl');
        } else {
          const lastModtime = currentStepModel.get('videoModTime');
          const videoEncrypted = currentStepModel.get('videoEncrypted');
          url = (videoId != null)
            ? (videoEncrypted || playerPreviewEditor)
              ? iorad.player.controllers.sync.getDecryptedAssetRemotePath(videoId + '.' + videoFileExtension, lastModtime)
              : iorad.player.controllers.sync.getVideoRemotePath(videoId, videoFileExtension, lastModtime)
            : '';
        }

        if (url) {
          var cachedVideo = videoCache[stepId + langCode];
          if (cachedVideo) {
            this.video = cachedVideo.video;
            //update video event hooks here
            this.video._onload = [onVideoLoad(stepId)];
            this.video._onloaderror = [onVideoLoadError(stepId)];
            this.video._onplay = [onVideoPlay];
            this.video._onend = [onVideoEnd];

            if (!cachedVideo.isLoading) {
              updateVideoState(_.bind(function (newVideoState) {
                if (cachedVideo.isLoaded === true) {
                  if (iorad.player.videoMuted) {
                    newVideoState.classes.push('mute');
                    newVideoState.hint = i18next.t('Video is muted.');
                  } else {
                    newVideoState.classes = ['load'];
                    newVideoState.hint = i18next.t('Video is available.');
                  }
                } else if (cachedVideo.isLoaded === false) {
                  var tutorialNoVideo = !view.collection.some(_.bind(function (stepModel) {
                    return stepModel.get('videoId') != null;
                  }, this));

                  var msg = i18next.t('This step has no video.');
                  if (self.collection.getCurrentStepNumber() == 0 || tutorialNoVideo) {
                    msg = i18next.t('This tutorial has no video.');
                  }

                  newVideoState.classes = ['load-error'];
                  if (tutorialNoVideo) {
                    newVideoState.classes.push('tutorial-no-video');
                  }
                  newVideoState.hint = msg;
                }
              }, this));
              if (cachedVideo.isLoaded === true) {

                this.video.on('load');
              } else if (cachedVideo.isLoaded === false) {
                this.video.on('loaderror');
              }
            }

          } else {
            this.video = new Video({
              urls: [url],
              format: videoFileExtension,
              durationMS,
              onload: onVideoLoad(stepId),
              onloaderror: onVideoLoadError(stepId),
              onplay: onVideoPlay,
              onend: onVideoEnd
            });
            videoCache[currentStepId + langCode] = {
              video: this.video,
              isLoading: true,
              isLoaded: false,
            };
          }


          this.video._onmute = [onVideoMute];
          this.video._onunmute = [onVideoUnmute.bind(this)];

          if (iorad.player.videoMuted) this.video.on('mute');

          var coverOpen = iorad.player.controllers.views.isCoverOpen();
          var tab = iorad.player.tab;
          var autoStartTimeout = 0;
          if (
            !iorad.player.videoMuted &&
            !coverOpen &&
            !this.modeChanging &&
            !iorad.player.controllers.views.isModalTab(tab) &&
            !iorad.player.controllers.autoplay.paused
          ) {
            this.autoStartTimer = iorad.base.Utils.setTimeoutPromise(autoStartTimeout);
            this.autoStartTimer.promise
              .then(_.bind(function () {
                this.autoStartTimer = undefined;
                if (
                  iorad.player.getParameters.videoExport === 'true' &&
                  !iorad.player.videoExportReady
                ) {
                  // show first frame of video until videoExport is ready
                  this.video._videoEl.volume = 0;
                  this.video.play();
                  this.video._videoEl.muted = false; // for IOS
                  this.video.stop();
                  this.listenToOnce(iorad.player.events, 'videoExportReady', () => {
                    this.video._videoEl.volume = 1;
                    this.video.play();
                  });
                } else {
                  this.video.play();
                  this.video._videoEl.muted = false; // for IOS
                }
              }, this));
          }
        } else {
          this.video = null;
          onVideoLoadError.call(null);
        }
      }

      this._eagerLoadVideo();
    },

    onModeChange: function(mode) {
      // videoPlayOnLoaded = mode !== 'quick';

      if (
        mode === iorad.player.oldMode ||
        mode === 'print' ||
        iorad.player.oldMode === 'print'
      ) {
        // ignore
        return;
      }

      this.modeChanging = mode;
      this.stopVideoAndAutoplay();
    },

    applyQuizMuteVideo: function () {
      this.quizMuteVideoApplied = true;
      this.videoMutedByDefaultApplied = false;
      this.quickDefaultMuted = false;

      var quizMuteVideo = this.model.get('quizMuteVideo');
      this.toggleVideo(!quizMuteVideo);
    },

    applyQuickMuteVideo: function () {
      this.quizMuteVideoApplied = true;
      this.videoMutedByDefaultApplied = false;
      this.quickDefaultMuted = true;

      // always muted by default
      this.toggleVideo(false);
    },

    applyVideoMutedByDefault: function () {
      this.videoMutedByDefaultApplied = true;
      this.quizMuteVideoApplied = false;
      this.quickDefaultMuted = false;

      var videoMutedByDefault = this.model.get('videoMutedByDefault');
      this.toggleVideo(!videoMutedByDefault);
    },

    onTabChange: function (tab) {
      var oldTab = iorad.player.oldTab;

      if (iorad.player.controllers.views.isModalTab(tab)) {
        this.tabBeforeModal = oldTab;
        this.stopVideoAndAutoplay();
      } else if (iorad.player.controllers.views.isModalTab(oldTab) && tab === this.tabBeforeModal) {
        // going back to the original tab, this won't trigger a mode change,
        // thus we do it manually to reset video
        this.modeChanging = iorad.player.mode;
        this.onModeReady(iorad.player.mode);
      } else if (tab === 'quiz') {
        if (!this.quizMuteVideoApplied) this.applyQuizMuteVideo();
      } else if (tab === 'view') {
        if (!this.quickDefaultMuted) this.applyQuickMuteVideo();
      } else if (!iorad.player.controllers.views.isModalTab(tab)) {
        if (!this.videoMutedByDefaultApplied) this.applyVideoMutedByDefault();
      }
    },

    onLanguageDropdownToggle: function(expanded) {
      if (expanded) {
        this.stopVideoAndAutoplay();
      } else if (!iorad.player.controllers.views.isModalTab(iorad.player.tab)) {
        // going back to the original tab, this won't trigger a mode change,
        // thus we do it manually to reset video
        this.modeChanging = iorad.player.mode;
        this.onModeReady(iorad.player.mode);
      }
    },

    onQuizMuteVideoChange: function () {
      this.quizMuteVideoApplied = false;
      if (iorad.player.tab === 'quiz') {
        this.applyQuizMuteVideo();
      }
    },

    onVideoMutedByDefaultChange: function () {
      this.videoMutedByDefaultApplied = false;
      if (iorad.player.tab !== 'quiz' && !iorad.player.controllers.views.isModalTab(iorad.player.tab)) {
        this.applyVideoMutedByDefault();
      }
    },

    stopVideoAndAutoplay: function() {
      if (this.video) this.video.stop();
      if (this.autoStartTimer) {
        this.autoStartTimer.cancel();
        this.autoStartTimer = undefined;
      }
    },

    getStoredHelpcenterVideoMuted: function() {
      try {
        return localStorage.getItem('iorad-player-helpcenter-' + iorad.player.getParameters.helpcenter + '-videoMuted');
      } catch (err) {
        // 3rd party cookies/data are disabled
        console.error(err);
      }
    },

    onModeReady: function(mode) {
      if (!this.modeChanging) return;
      this.modeChanging = undefined;

      if (
        iorad.player.router.isHelpcenterMode() &&
        this.getStoredHelpcenterVideoMuted() === 'true' &&
        !this.helpcenterDefaultMuted
      ) {
        // muted by default
        this.helpcenterDefaultMuted = true;
        this.toggleVideo(false);
      }

      this.resetVideo();
    },

    resetVideo: function() {
      this.trackVideoReset();
      this.stopVideoAndAutoplay();
      this.initVideo();
    },

    // muted state is global
    isMuted: function() {
      return iorad.player.videoMuted === true;
    },

    isVideoLoaded: function(stepId) {
      if (typeof stepId === 'undefined') {
        stepId = currentStepId;
      }
      var stepNumber = stepId;
      var cachedVideo = videoCache[stepNumber + langCode];
      if (cachedVideo && cachedVideo.isLoaded) {
        return true;
      }
      return false;
    },

    getVideoCurrentTime: function(stepId) {
      var cachedVideo = videoCache[stepId + langCode];
      if (cachedVideo && cachedVideo.isLoaded) {
        return cachedVideo.video.pos();
      }

      return 0;
    },

    getVideoState: function(stepId) {
      return getVideoState(stepId);
    },

    getVideoStateClasses: function(stepId) {
      var videoState = getVideoState(stepId);
      var classes = _.clone(videoState.classes);
      var isMuted = this.isMuted();
      if (classes.length === 0 || videoState.stepId !== currentStepId) {
        // default
        var step = this.collection.getModelAt(videoState.stepId - 1);
        var hasVideo = step && step.get('videoId') != null;
        if (!hasVideo) {
          var tutorialNoVideo = !this.collection.some(_.bind(function (stepModel) {
            return stepModel.get('videoId') != null;
          }, this));
          classes = ['load-error'];
          if (tutorialNoVideo) {
            classes.push('tutorial-no-video');
          }
        } else {
          if (isMuted) {
            classes = ['mute'];
          } else {
            classes = ['load'];
          }
        }
      } else if (isMuted && classes.indexOf('load-error') === -1) {
        classes = ['mute'];
      }
      return classes;
    },

    getVideoStateHint: function(stepId) {
      var videoState = getVideoState(stepId);
      var classes = _.clone(videoState.classes);
      var hint = videoState.hint;
      var isMuted = this.isMuted();
      if (!hint || videoState.stepId !== currentStepId) {
        // default
        var step = this.collection.getModelAt(videoState.stepId - 1);
        var hasVideo = step && step.get('videoId') != null;
        if (!hasVideo) {
          var tutorialNoVideo = !this.collection.some(_.bind(function (stepModel) {
            return stepModel.get('videoId') != null;
          }, this));
          hint = tutorialNoVideo
            ? i18next.t('This tutorial has no video.')
            : i18next.t('This step has no video.');
        } else {
          if (isMuted) {
            hint = i18next.t('Video is muted.');
          } else {
            hint = i18next.t('Video available.');
          }
        }
      } else if (isMuted && classes.indexOf('load-error') === -1) {
        hint = i18next.t('Video is muted.');
      }
      return hint;
    },

    getAllVideoStateClasses: function() {
      return ['tutorial-no-video', 'load-error', 'load', 'play', 'mute', 'end'];
    },

    pause: function() {
      if (!this.video || !this.videoPlaying) return;
      this.video.pause();
      this.videoPaused = true;
      this.videoPlaying = false;
    },
    resume: function() {
      if (!this.video || !this.videoPaused) return;
      this.video.play();
      this.video._videoEl.muted = false; // for IOS
      this.videoPaused = false;
      this.videoPlaying = true;
    },

    isVideoCompletitionRequired: function () {
      const stepModel = iorad.player.data.stepsCollection.getCurrentModel();
      if (!stepModel) return false;
      const videoId = stepModel.get('videoId');
      const videoModTime = stepModel.get('videoModTime');

      let videoCompletedBefore = false;
      try {
        videoCompletedBefore = localStorage.getItem('iorad_tutorial_' + iorad.player.tutorialId + '_videoCompletition_' + videoId + '_' + videoModTime) === 'true';
      } catch (err) {
        // 3rd party cookies/data are disabled
        console.error(err);
      }

      const videoCompletedNow = _.intersection(this.getVideoStateClasses(), ['load', 'play']).length === 0;
      const completitionRequired = iorad.player.data.tutorial.get('requireVideoCompletition') &&
        videoId != null &&
        !videoCompletedBefore &&
        !videoCompletedNow;
      return completitionRequired;
    },

    storeVideoCompletion: function (videoId, videoModTime) {
      try {
        localStorage.setItem('iorad_tutorial_' + iorad.player.tutorialId + '_videoCompletition_' + videoId + '_' + videoModTime, 'true');
      } catch (err) {
        // 3rd party cookies/data are disabled
        console.error(err);
      }
    },
  });
})();

;
(function () {
  iorad.player.MusicController = iorad.base.Component.extend({
    initialize: function (tutorial, stepsCollection) {
      this.tutorial = tutorial;
      this.stepsCollection = stepsCollection;
      this.muted = true;
      this.stopped = true;
      this.quizMuteMusicApplied = false;
      this.musicMutedByDefaultApplied = false;
      this.quickDefaultMuted = false;

      this.listenTo(iorad.player.events, 'change:coverOpen', this.check);
      this.listenTo(iorad.player.data.stepsCollection, 'changeCurrent reset', this.check);
      this.listenTo(iorad.player.controllers.audio, 'change:audioState', this.check);
      this.listenTo(iorad.player.controllers.autoplay, 'change:paused', this.check);
      this.listenTo(iorad.player.events, 'update:playbar', this.check);
      this.listenTo(iorad.player.events, 'tab', this.onTabChange);
      this.listenTo(this.tutorial, 'change:quizMuteMusic', this.onQuizMuteAudioChange);
      this.listenTo(this.tutorial, 'change:musicMutedByDefault', this.onAudioMutedByDefaultChange);
    },

    applyQuizMuteMusic: function () {
      this.quizMuteMusicApplied = true;
      this.musicMutedByDefaultApplied = false;
      this.quickDefaultMuted = false;

      var quizMuteMusic = this.tutorial.get('quizMuteMusic');
      this.toggleMusic(!quizMuteMusic);
    },

    applyQuickMuteMusic: function () {
      this.quizMuteMusicApplied = false;
      this.musicMutedByDefaultApplied = false;
      this.quickDefaultMuted = true;

      this.toggleMusic(false);
    },

    applyMusicMutedByDefault: function () {
      this.musicMutedByDefaultApplied = true;
      this.quizMuteMusicApplied = false;
      this.quickDefaultMuted = false;

      var musicMutedByDefault = this.tutorial.get('musicMutedByDefault');
      this.toggleMusic(!musicMutedByDefault);
    },

    onTabChange: function (tab) {
      if (tab === 'quiz') {
        if (!this.quizMuteMusicApplied) this.applyQuizMuteMusic();
      } else if (tab === 'view') {
        if (!this.quickDefaultMuted) this.applyQuickMuteMusic();
      } else if (!iorad.player.controllers.views.isModalTab(iorad.player.tab)) {
        if (!this.musicMutedByDefaultApplied) this.applyMusicMutedByDefault();
      }

      this.check();
    },

    onQuizMuteAudioChange: function () {
      this.quizMuteMusicApplied = false;
      if (iorad.player.tab === 'quiz') {
        this.applyQuizMuteMusic();
      }
    },

    onAudioMutedByDefaultChange: function () {
      this.musicMutedByDefaultApplied = false;
      if (
        iorad.player.tab !== 'quiz' &&
        iorad.player.tab !== 'view' &&
        !iorad.player.controllers.views.isModalTab(iorad.player.tab)
      ) {
        this.applyMusicMutedByDefault();
      }
    },

    check: function () {
      const coverOpen = iorad.player.controllers.views.isCoverOpen();
      const isLastStep = this.stepsCollection.position === this.stepsCollection.length - 1;
      const audioStateClasses = iorad.player.controllers.audio.getAudioStateClasses();
      const videoStateClasses = iorad.player.controllers.video.getVideoStateClasses();
      const audioPlaying = _.intersection(audioStateClasses, ['load', 'play']).length > 0;
      const videoPlaying = _.intersection(videoStateClasses, ['load', 'play']).length > 0;

      // whenever there is the Play button visible and clickable in the playbar
      // TODO: this is too tighly coupled with the playbar view, move shared code to 3rd component
      const playbarView = iorad.player.router && iorad.player.router.playbarView;
      const playbarViewTemplateData = (playbarView && playbarView.templateData) || {};
      const {
        isStepProgressBtnHidden,
        isStepProgressBtnDisabled,
        showStepProgressPlay,
      } = playbarViewTemplateData;
      const isProgressPaused = (
        showStepProgressPlay &&
        !isStepProgressBtnHidden &&
        !isStepProgressBtnDisabled
      );

      const readyToAutoPlay = (
        !this.muted &&
        !coverOpen &&
        (!isLastStep || audioPlaying || videoPlaying) &&
        !isProgressPaused &&
        !iorad.player.controllers.views.isModalTab(iorad.player.tab)
      );
      const shouldFadeOut = (
        !this.muted &&
        !coverOpen &&
        isLastStep &&
        !audioPlaying &&
        !videoPlaying
      );
      const shouldPause = isProgressPaused && !coverOpen;

      if (iorad.player.tab === 'media') {
        // let it play but with no volume,
        // so to detect correct checked state in media popup
        if (this.audioEl) this.audioEl.volume = 0;
      } else {
        if (this.audioEl && this.audioEl.volume === 0) {
          // restore volume
          this.audioEl.volume = this.getInitialVolume();
        }

        if (readyToAutoPlay) {
          this.play();
        } else if (shouldFadeOut) {
          this.fadeOut();
        } else if (shouldPause) {
          this.stop({ pause: true });
        } else {
          this.stop();
        }
      }
    },

    hasMusic: function () {
      var deviceSupported = !iorad.app.controllers.clientDetect.device.isPhone;
      if (!deviceSupported) return false;

      var musicEnabled = this.tutorial.get('musicEnabled');
      if (!musicEnabled) return false;

      var musicId = this.tutorial.get('musicId');
      if (!musicId) {
        return false;
      }

      return true;
    },

    getInitialVolume: function () {
      if (iorad.player.tab === 'media') return 0;
      return this.tutorial.get('musicVolume') || 0.2;
    },

    play: function () {
      if (this.fadingOut) {
        $(this.audioEl).stop(true, true);
        this.fadingOut = false;
        this.audioEl.volume = this.getInitialVolume();
        return;
      }
      if (!this.stopped || this.muted) return;

      if (!this.hasMusic()) return;
      var musicId = this.tutorial.get('musicId');
      var _musicUrl = this.tutorial.get('_musicUrl');

      if (!this.audioEl) {
        var audioEl = document.createElement('audio');
        audioEl.autoplay = true;
        audioEl.controls = false;
        audioEl.loop = true;
        audioEl.hidden = true;
        audioEl.volume = this.getInitialVolume();
        audioEl.src = _musicUrl || iorad.player.controllers.sync.getMusicRemotePath(musicId);
        document.body.appendChild(audioEl);
        this.audioEl = audioEl;
      } else {
        this.audioEl.volume = this.getInitialVolume();
        this.audioEl.play();
      }

      this.stopped = false;
      this.trigger('change:musicState');
    },

    stop: function (options) {
      options = options || {};

      if (this.stopped) {
        if (!options.pause && this.audioEl && this.audioEl.currentTime) {
          // paused -> stopped
          this.audioEl.currentTime = 0;
        }
        return;
      }
      if (this.audioEl) {
        this.audioEl.pause();
        if (!options.pause) {
          this.audioEl.currentTime = 0;
        }
      }
      if (this.fadingOut) {
        $(this.audioEl).stop(true, true);
        this.fadingOut = false;
      }
      this.stopped = true;
      this.trigger('change:musicState');
    },

    fadeOut: function () {
      if (this.stopped || this.muted || !this.audioEl || this.fadingOut) return;
      this.fadingOut = true;
      $(this.audioEl).animate({ volume: 0 }, 5000, 'linear', _.bind(function () {
        this.fadingOut = false;
        this.stop();
      }, this));
    },

    toggleMusic: function (forceToggle) {
      if (forceToggle === true || (typeof forceToggle === 'undefined' && this.muted)) {
        this.muted = false;
        this.play();
        this.trigger('change:musicState');
      } else if (forceToggle === false || (typeof forceToggle === 'undefined' && !this.muted)) {
        this.muted = true;
        this.stop();
        this.trigger('change:musicState');
      }

      // this.muted = typeof forceToggle !== 'undefined' ? !forceToggle : !this.muted;
      // if (this.stopped) this.play();
      // else this.stop();
    },

    getMusicStateClasses: function () {
      return !this.hasMusic() ? ['load-error']
        : this.muted ? ['mute']
          : ['play'];
    },

    getMusicStateHint: function () {
      return !this.hasMusic() ? i18next.t('No music.')
        : this.muted ? i18next.t('Music is muted.')
          : i18next.t('Music is playing.');
    },

    getAllMusicStateClasses: function () {
      return ['load-error', 'mute', 'play'];
    },
  });
}());

;
iorad.player.LiveController = iorad.base.Component.extend({
  initialize: function(tutorialModel, stepsCollection) {
    this.tutorial = tutorialModel;
    this.stepsCollection = stepsCollection;

    this.extensionInstalled = false;
    this.waitingForExtensionInstall = false;
    this.waitingTryLiveRedirect = null;

    this.loaded = false;
    _.defer(_.bind(function() {
      this.checkExtensionInstalled().then(_.bind(function () {
        this.updateBannerData();
        this.loaded = true;
      }, this));
    }, this));
    this.listenTo(this.tutorial, 'change:embedWidget change:liveDisabled', this.updateBannerData);
    this.updateBannerData();

    // wait for extension installation
    siteWindow.addEventListener('message', _.bind(function(event) {
      var message = event.data;
      //if (event.source !== siteWindow) return;
      if (typeof message !== 'object' || message === null) return;

      if (message.topic === 'ioradExtensionInstalled') {
        // the extension notified its installation
        if (this.waitingForExtensionInstall) this.onExtensionJustInstalled();
      }
    }, this), false);
  },

  checkExtensionInstalled: function() {
    if (window.downloadPlayerType) {
      // HACK: even if not installed, this leads to showing "Perform the steps in the real app"
      // and to open VIEW_LIVE_LINK which will take care of all the install/play flow
      // in the actual tutorial
      return Promise.resolve()
        .then(() => {
          this.extensionInstalled = true;
        });
    }
    return iorad.player.controllers.sync.extensionStatus().then(_.bind(function(status) {
      this.extensionInstalled = status.enabled;
    }, this));
  },

  mustInstallExtension: function() {
    return !this.extensionInstalled &&
      !this.tutorial.get('embedWidget') &&
      iorad.player.getParameters.extensionEmbed != 'true';
  },

  canInstallExtension: function() {
    var browser = iorad.player.controllers.clientDetect.browser;
    return browser.isChrome || browser.isFirefox || browser.isEdge || browser.isNewEdge;
  },

  preferredSupportedBrowser: function() {
    var browser = iorad.player.controllers.clientDetect.browser;
    return browser.isIE ? 'edge' : 'chrome';
  },

  updateBannerData: function() {
    var data;
    var isLiveEnabled = this.tutorial.get('liveDisabled') !== true;
    const REGULAR_MESSAGE = 'iorad add-on required.';
    if (this.mustInstallExtension()) {
      if (this.canInstallExtension()) {
        data = {
          message: i18next.t(REGULAR_MESSAGE),
          buttonText: i18next.t('Get iorad add-on'),
          type: 'can_install_extension',
        };
      } else {
        data = {
          message: i18next.t(REGULAR_MESSAGE),
          buttonText: i18next.t('Install ' + this.preferredSupportedBrowser()),
          type: 'cannot_install_extension',
        };
      }
    } else {
      if (this.waitingTryLiveRedirect) {
        data = {
          message: 'Live Mode starting',
          buttonText: `Redirecting${this.waitingTryLiveRedirect.url ? (' to: ' + this.waitingTryLiveRedirect.url) : ''}`,
          type: 'waiting_live_redirect',
        };
      } else {
        data = {
          message: i18next.t('Perform the steps in the real app.'),
          buttonText: i18next.t(isLiveEnabled ? 'Go Live' : 'Start'),
          type: 'extension_installed',
        };
      }
    }

    this.bannerData = data;
    this.trigger('change:bannerData', this.bannerData);
  },

  getBannerData: function() {
    return this.bannerData;
  },

  tryLive: function(options) {
    options = options || {};
    var newWindow = (typeof options.newWindow === 'undefined') ? true : options.newWindow;

    if (this.mustInstallExtension()) {
      this.installExtension();
    } else {
      this.openViewLiveLink(newWindow);
    }
  },

  installExtension: function() {
    if (!this.canInstallExtension()) {
      var newBrowser = this.preferredSupportedBrowser();
      if (newBrowser === 'edge') {
        siteWindow.ioradNodeApp.setLocation('https://www.microsoft.com/en-us/windows/microsoft-edge/microsoft-edge', {
          isNewWindow: true,
        });
      } else {
        siteWindow.ioradNodeApp.setLocation('https://www.google.com/chrome/', {
          isNewWindow: true,
        });
      }
      return;
    }

    this.waitingForExtensionInstall = true;
    siteWindow.ioradNodeApp.setLocation('#isViewLive=true', { isHash: true }); // HACK: tell the extension we're waiting for installation
    if (siteWindow !== window.top) {
      // tell the extension to redirect for us,
      // to avoid popup blockers
      iorad.player.controllers.sync.getPlayerURL()
        .then(_.bind(function(playerUrlData) {
          $('html').attr('data-view-live-redirect', playerUrlData.VIEW_LIVE_LINK);
        }));
    }

    var browser = iorad.player.controllers.clientDetect.browser;
    if (browser.isChrome) {
      var webStoreUrl = iorad.base.Settings.get('capture.extension.chrome.webstore.url');
      siteWindow.ioradNodeApp.setLocation(webStoreUrl, {
        isNewWindow: true,
      });
    } else if (browser.isFirefox) {
      siteWindow.ioradNodeApp.setLocation('https://addons.mozilla.org/addon/iorad-the-tutorial-builder/', {
        isNewWindow: true,
      });
    } else if (browser.isNewEdge || browser.isEdge) {
      siteWindow.ioradNodeApp.setLocation('https://microsoftedge.microsoft.com/addons/detail/iorad-the-tutorial-buil/mlbfaljhddmcadhldbpbphcghlobfboa', {
        isNewWindow: true,
      });
    } else {
      var chromeExtensionId = iorad.base.Utils.getChromeExtensionId();
      var webstoreLink = 'https://chrome.google.com/webstore/detail/' +
      chromeExtensionId;
      siteWindow.ioradNodeApp.setLocation(webstoreLink, {
        isNewWindow: true,
      });
    }
  },

  openViewLiveLink: function(newWindow) {
    this.trigger('openViewLiveLink');

    if (typeof newWindow === 'undefined') newWindow = true;

    iorad.player.controllers.sync.getPlayerURL()
      .then(_.bind(function(playerUrlData) {
        if (
          iorad.player.getParameters.extensionEmbed === 'true'
        ) {
          siteWindow.parent.postMessage({
            from: 'iorad-web-app',
            topic: 'player:goLive',
            data: {
              playerUrlData: playerUrlData,
            },
          }, '*');
        } else {
          siteWindow.ioradNodeApp.setLocation(playerUrlData.VIEW_LIVE_LINK, {
            isNewWindow: newWindow,
          });
        }
      }));
  },

  onExtensionJustInstalled: function() {
    this.extensionInstalled = true;
    iorad.player.events.trigger('extension:installed');

    // NOTE: this is actually a "fake" URL, since the actual redirect is much more complex
    //       (see api/tutorial/viewLive service) or handled directly by the extension itself.
    // It might also be null.
    const domainUrlHostname = this.tutorial.getDomainUrlHostname();
    this.waitingTryLiveRedirect = {
      url: domainUrlHostname ? `https://${domainUrlHostname}` : '',
    };
    this.updateBannerData();

    if (siteWindow !== window.top) {
      // redirect is handled by the extension itself
      this.trigger('openViewLiveLink'); // still trigger the event for tracking purposes
      return;
    }

    setTimeout(_.bind(function() { // give the extension some extra time to start header override
      this.tryLive({ newWindow: false });
    }, this), 2000);
  },
});

;
iorad.player.LanguageController = iorad.base.LanguageController.extend({

  start: function() {
    return iorad.base.LanguageController.prototype.start.apply(this, arguments)
      .then(_.bind(function(languageCode) {
        this.setGoogleTranslateCookie(languageCode);
        return languageCode;
      }, this));
  },

  setGoogleTranslateCookie: function(languageCode) {
    // NOTE: this funtion might be called before dataReady, which
    // means the tutorial JSON will still contain default values
    iorad.base.Export.clearAllCookies('googtrans');
    if (
      iorad.player.getParameters.disableGoogleTranslate !== 'true' &&
      (
        this.learnerChangedLanguage() ||
        languageCode !== 'en' ||
        (iorad.player.data.tutorial.get('language') || 'en') !== 'en'
      )
    ) {
      iorad.base.Export.setCookie('googtrans', '/auto/' + languageCode, undefined, window.location.hostname, '/');
      iorad.base.Export.setCookie('googtrans', '/auto/' + languageCode, undefined, '.' + window.location.hostname, '/');
      iorad.base.Export.setCookie('googtrans', '/auto/' + languageCode, undefined, window.location.hostname.split('.').slice(-2).join('.'), '/');
      iorad.base.Export.setCookie('googtrans', '/auto/' + languageCode, undefined, '.' + window.location.hostname.split('.').slice(-2).join('.'), '/');
    }
  },

  changeLanguage: function(languageCode, languageName) {
    languageName = languageName || this.getLanguageName(languageCode);

    iorad.player.selectedTranslation = languageCode;
    iorad.player.selectedTranslationName = languageName;
    iorad.player.events.trigger('selectedTranslation', languageCode);
    iorad.player.events.trigger('selectedTranslationName', languageName);
  },

  learnerChangedLanguage: function() {
    return iorad.player.getParameters.lang &&
      iorad.player.getParameters.lang !== (iorad.player.data.tutorial.get('language') || 'en');
  },

});

;
iorad.player.AutoplayController = iorad.base.Component.extend({
  initialize: function(opts) {
    this.model = opts.model;
    this.collection = opts.collection;
    if (window.location.search.indexOf('autoplayLog=true') !== -1) {
      window.ioradAutoplayLog = true;
    }

    var checkReady = _.bind(function () {
      if (this.isReadyToAutoplay()) {
        if (iorad.player.tab === 'media') {
          if (typeof pausedBeforeMedia === 'undefined') {
            this.pausedBeforeMedia = this.paused;
          }
          this.pauseAutoplay();
        } else if (iorad.player.oldTab === 'media') {
          if (!this.pausedBeforeMedia) {
            this.resumeAutoplay();
          }
          this.pausedBeforeMedia = undefined;
        } else {
          this.startAutoplay();
        }
      } else {
        this.stopAutoplay();
      }
    }, this);
    this.listenTo(iorad.player.events, 'ready tab change:coverOpen mode videoExportReady', function() {
      checkReady();
    });

    this.listenTo(this.collection, 'changeCurrent reset', this.onCurrentStepChange);
    this.listenTo(iorad.player.events, 'ready:interactive', this.onCurrentStepChange);
    this.onCurrentStepChange();
    this.setSpeed();
  },
  setSpeed: function(speed) {
    this.speed = this.getSpeedOptionsMap()[speed] ? speed : '1x';
    iorad.player.events.trigger('autoplaySpeedChanged', {speed: this.getSpeed()});
  },
  getSpeed: function() {
    return this.speed;
  },
  getSpeedOptionsMap: function() {
    var map = {};
    map['1x'] = {animationSpeed: 1, wordReadTime: 460, navLabel: '1x'};
    map['1.5x'] = {animationSpeed: 0.75, wordReadTime: 375, navLabel: '1.5x'};
    map['.5x'] = {animationSpeed: 2, wordReadTime: 600, navLabel: '.5x'};
    return map;
  },
  getSpeedFromName: function(speedName) {
    var map = this.getSpeedOptionsMap();
    return map[speedName] || map['1x'];
  },
  getSpeedOptions: function() {
    return this.getSpeedFromName(this.getSpeed());
  },
  scaleSpeedOnResume: function(value) {
    return (
      value /
      this.getSpeedFromName(this.speedBeforePause).animationSpeed * this.getSpeedFromName(this.speed).animationSpeed
    );
  },
  getAutoplaySettings: function() {
    var autoplaySpeed = this.getSpeedOptions();
    // when step is changed, before any animation starts
    var initialDelayForStep = 1000 * autoplaySpeed.animationSpeed;
    // time to wait after progress-bar complete, before moving to the next action
    var delayAfterActions = 700 * autoplaySpeed.animationSpeed;
    // time to wait after all step actions complete, before moving to the next step
    var delayAfterStepCompleted = 0 * autoplaySpeed.animationSpeed;
    var delayAfterStepCompletedForTyping = 1000 * autoplaySpeed.animationSpeed;
    // delays for specific tools
    var delayAfterActionsTyping = 700 * autoplaySpeed.animationSpeed;
    var delayAfterDragMarkerClick = 700; // speed independent (marker-drag::moveNearDropTool always uses same time)
    // the time to wait between characters when progressing typing
    var delayForCharacterTyping = 40 * autoplaySpeed.animationSpeed;
    // the time to wait between characters when progressing selection
    var delayForCharacterSelection = 20 * autoplaySpeed.animationSpeed;
    // step will be changed only after this amount of ms has been passed after the audio finished playing
    var delayAfterAudio = 1000;
    // step will be changed only after this amount of ms has been passed after the video finished playing
    var delayAfterVideo = 1000;
    // the time that will take the animation of cursor moving
    var cursorMoveTime = 700 * autoplaySpeed.animationSpeed;
    // before step plays, wait the time relative to number of words in description
    var wordReadTime = autoplaySpeed.wordReadTime;
    // the click visualization
    var clickAnimationTime = 400;
    var doubleClickAnimationTime = 500;
    // when step has audio, progress-bar time will be calculater shorter by this value
    var audioProgressBarSubstraction = 300;
    // when step has video, progress-bar time will be calculater shorter by this value
    var videoProgressBarSubstraction = 300;
    // the value above is only used when the audio is longer than this value
    var audioProgressBarSubstractionMinLength = 5000;
    // the value above is only used when the video is longer than this value
    var videoProgressBarSubstractionMinLength = 5000;
    var cursorHeight = 36;
    var cursorWidth = 21;

    return {
      initialDelayForStep: initialDelayForStep,
      delayAfterActions: delayAfterActions,
      delayAfterStepCompleted: delayAfterStepCompleted,
      delayAfterStepCompletedForTyping: delayAfterStepCompletedForTyping,
      delayForCursorMove: cursorMoveTime,
      delayAfterActionsTyping: delayAfterActionsTyping,
      delayForCursorMoveTyping: cursorMoveTime,
      delayAfterDragMarkerClick: delayAfterDragMarkerClick,
      delayForCursorMoveDragDrop: cursorMoveTime,
      delayForCharacterTyping: delayForCharacterTyping,
      delayForCharacterSelection: delayForCharacterSelection,
      delayAfterAudio: delayAfterAudio,
      delayAfterVideo: delayAfterVideo,
      cursorMoveTime: cursorMoveTime,
      wordReadTime: wordReadTime,
      clickAnimationTime: clickAnimationTime,
      doubleClickAnimationTime: doubleClickAnimationTime,
      delayForClickAnimation: clickAnimationTime,
      cursorHeight: cursorHeight,
      cursorWidth: cursorWidth,
      audioProgressBarSubstraction: audioProgressBarSubstraction,
      audioProgressBarSubstractionMinLength: audioProgressBarSubstractionMinLength,
      videoProgressBarSubstraction: videoProgressBarSubstraction,
      videoProgressBarSubstractionMinLength: videoProgressBarSubstractionMinLength,
    };
  },
  getMarkerListView: function() {
    var metaInteractiveView = iorad.player.router.layoutModes.metaInteractiveView;
    if (!metaInteractiveView) return null;
    var interactiveSlide = metaInteractiveView.interactiveSlide;
    if (!interactiveSlide) return null;
    return interactiveSlide.hlView;
  },
  waitForMarkerTransition: function() {
    var markerListView = this.getMarkerListView();
    var activeMarkers = markerListView.getActiveMarkers();
    return Promise.all([
      activeMarkers[0].waitForTransition(),
      markerListView.waitForImageTransition(),
    ]);
  },
  isReadyToAutoplay: function() {
    if (!iorad.player.router) return false; // too early
    if (iorad.player.getParameters.videoExport === 'true') {
      return iorad.player.videoExportReady;
    }
    var coverDisabled = iorad.player.router.isCoverDisabled();
    var coverOpen = iorad.player.controllers.views.isCoverOpen();
    return (
      (
        iorad.player.tab === 'watch' ||
        (
          iorad.player.tab === 'media' &&
          iorad.player.oldTab === 'watch'
        )
      ) && (
        coverDisabled ?
          (iorad.player.mode === 'interactive')
          : !coverOpen
      )
    );
  },
  onCurrentStepChange: function() {
    var $this = this;
    // controller loads early and binds the listener first, but we want to let listeners of view files to execute first
    setTimeout(function() {
      $this.autoplayCurrentStepChanged = true;
      // when step changed after autoplay finished - play again
      if (!$this.isRunning && $this.isReadyToAutoplay()) $this.startAutoplay();
    });
  },
  clearAutoplayStyles: function() {
    $('#autoplay-style').remove();
  },
  setAutoplayStyles: function(settings, clickColor) {
    this.clearAutoplayStyles();
    var $style = $('<style>').attr({ id: 'autoplay-style' });
    $style.html(
      '#autoplay-cursor:before {background-color: ' + clickColor + ' !important;}' +
      '#autoplay-cursor.click-animation:before {' +
      'animation-duration: ' + (settings.clickAnimationTime / 1000) + 's !important;}' +
      '#autoplay-cursor.click-animation.double:before {' +
      'animation-duration: ' + (settings.doubleClickAnimationTime / 1000) + 's !important;}' +
      '#playing-player .stepimg .image-surround .marker.autoplay-drag.DRAG,'
    );
    $('html').append($style);
  },
  startAutoplay: function() {
    if (this.isRunning) return Promise.resolve();
    this.isRunning = true;

    $('html').addClass('watch-mode-active');

    var settings = this.getAutoplaySettings();
    this.setAutoplayStyles(settings);

    var $autoplayCursor = $('<div>').attr({ id: 'autoplay-cursor' });
    this.$autoplayCursor = $autoplayCursor;
    this.moveCursorToCenter();
    $('#playing-player').prepend(this.$autoplayCursor);

    return this.autoplayActionLoop();
  },
  pauseAutoplay: function() {
    if (this.paused) return;
    this.speedBeforePause = this.speed;
    this.pauseTimers();
    this.pauseCursor();
    this.pauseTimerForActiveMarkers();
    iorad.player.controllers.audio.pause();
    iorad.player.controllers.video.pause();
    this.paused = true;
    this.trigger('change:paused', this.paused);
  },
  resumeAutoplay: function() {
    this.resumeTimers();
    this.resumeCursor();
    this.resumeTimerForActiveMarkers(_.bind(function() {
      this.trigger('change:resume');
    }, this));
    iorad.player.controllers.audio.resume();
    iorad.player.controllers.video.resume();
    this.paused = false;
    this.trigger('change:paused', this.paused);
  },
  stopAutoplay: function() {
    if (!this.isRunning) return;
    this.isRunning = false;

    $('html').removeClass('watch-mode-active');

    this.clearAutoplayStyles();

    this.$autoplayCursor.remove();
    this.$autoplayCursor = undefined;

    this.paused = false;

    // TODO: clear all active timers and event listeners
    iorad.player.events.trigger('step:timerCanceled');
    this.cancelTimers();

    var markerListView = this.getMarkerListView();
    if (markerListView) markerListView.reset(); // reset markers to their initial state
  },
  getTypingToolAnimationTime: function(settings, opts) {
    var typingAction = settings.delayForCharacterTyping * opts.typingText.length;
    var submitAction =
      settings.delayAfterActionsTyping +
      settings.delayForCursorMoveTyping +
      settings.clickAnimationTime;
    return {
      total: typingAction + (opts.typingSubmit ? submitAction : 0) + settings.delayAfterStepCompletedForTyping,
      typingAction: typingAction,
      submitAction: submitAction,
    };
  },
  getDragAndDropAnimationTime: function(settings) {
    var cursorMoveToDrag = settings.delayForCursorMoveDragDrop;
    var drag = settings.delayAfterDragMarkerClick + settings.delayForCursorMoveDragDrop;
    return {
      total: cursorMoveToDrag + drag,
      cursorMoveToDrag: cursorMoveToDrag,
      drag: drag
    };
  },
  getToolToAnimationTimeMap: function() {
    var toolToAnimationTimeMap = _.extend(
      {},
      ['LEFT_CLICK', 'RIGHT_CLICK', 'SCROLL', 'HOVER', 'READ'].reduce(
        function(map, cursorMoveOnlyTool) {
          map[cursorMoveOnlyTool] = function(settings) {
            return {total: settings.delayForCursorMove + settings.delayAfterStepCompleted};
          };
          return map;
        },
        {}
      ),
      {
        'TYPING': this.getTypingToolAnimationTime,
        'DRAG_AND_DROP': this.getDragAndDropAnimationTime,
        'SELECT_TEXT': function(settings) {return {total: settings.delayForCursorMove + settings.delayForCursorMove};},
      }
    );
    return toolToAnimationTimeMap;
  },
  getTypingText: function(step) {
    return step.get('event.text') || 'Example text';
  },
  isTypingSubmit: function(step) {
    return Boolean(
      step.get('event.submit') &&
      !(step.get('summary')) &&
      step.steps.some(subStep => subStep.get('type') === 'LEFT_CLICK')
    );
  },
  getStepAnimationTime: function(settings, step) {
    if (!step) return 0; // too early
    var toolToAnimationTimeMap = this.getToolToAnimationTimeMap();
    return toolToAnimationTimeMap[step.get('type')](
      settings,
      {
        typingText: this.getTypingText(step),
        typingSubmit: this.isTypingSubmit(step),
      }
    );
  },
  autoplayActionLoop: function() {
    if (!this.isRunning) return Promise.resolve();
    var $this = this;
    var settings = $this.getAutoplaySettings();
    var stepModel = $this.collection.getCurrentModel();
    if (!stepModel) return Promise.resolve();
    var stepChanged = false;
    this.listenToOnce(this.collection, 'changeCurrent reset', function() {
      stepChanged = true;
    });
    var isStepUnchanged = function() { return !stepChanged; };

    var audioMuted = iorad.player.controllers.audio.isMuted();
    var videoMuted = iorad.player.controllers.video.isMuted();

    var initialDelay =
      (
        (stepModel.get('audioId') != null && !audioMuted) ||
        (stepModel.get('videoId') != null && !videoMuted)
      ) ?
        settings.initialDelayForStep :
        stepModel.getStepReadDuration(settings.wordReadTime);
    if (['TYPING', 'READ'].indexOf(stepModel.get('type')) !== -1) {
      $this.$autoplayCursor.addClass('hide');
    } else {
      $this.$autoplayCursor.removeClass('hide');
    }
    return Promise.resolve()
      .then(() => iorad.player.controllers.audio.waitForAudioLoading())
      .then(() => iorad.player.controllers.video.waitForVideoLoading())
      .then(function () {
        var animationTime = $this.getStepAnimationTime(settings, stepModel);
        var stepProgressDuration = $this.getFinishingProgressbarTime(initialDelay + animationTime.total) + 10;
        var metaInteractiveView = iorad.player.router.layoutModes.metaInteractiveView;
        if (metaInteractiveView) {
          $this.trigger('setWatchModeProgressTimer', stepProgressDuration);
          return Promise.resolve();
        }
      })
      .then(function() {
        return $this.waitSafely(isStepUnchanged)(initialDelay)
          .then(function() {
            return $this.waitForMarkerTransition();
          })
          .then(function() {
            return $this.performAutoplayAction($this.getAutoplaySettings(), isStepUnchanged);
          })
          .catch(function(error) { // TODO: supress only canceling on step change
            console.log('Autoplay action canceled - ' + error.message);
          });
      })
      .then(function() {
        return $this.autoplayActionLoop(settings);
      });
  },
  addClassTemporarily: function(className, time) {
    var me = this;
    me.$autoplayCursor.addClass(className);
    return me.waitSafely(me.currentStepUnchangedCheck())(time)
      .then(function() {
        me.$autoplayCursor.removeClass(className);
      });
  },
  timers: [],
  cancelTimers: function() {
    this.timers.map(_.bind(function(timer) {
      timer.cancel();
    }, this));
  },
  pauseTimers: function() {
    this.timers.map(_.bind(function(timer) {
      timer.pause();
    }, this));
  },
  resumeTimers: function() {
    this.timers.map(_.bind(function(timer) {
      // scale the remaining time with updated speed
      timer.resume(this.scaleSpeedOnResume);
    }, this));
  },
  waitSafely: function(isOkToContinue) {
    var timers = this.timers;
    return function(delayTime) {
      if (window.ioradAutoplayLog) {
        console.log('Waiting on sleep, duration - ' + delayTime);
      }
      var timer = iorad.base.Utils.setTimeoutPromise(delayTime);
      timers.push(timer);
      return timer.promise
        .then(function() {
          timers.splice(timers.indexOf(timer), 1);
          if (!isOkToContinue()) {
            return Promise.reject(new Error('Step changed'));
          }
        });
    };
  },
  startTimerForActiveMarkers: function(timerTime) {
    var markerListView = this.getMarkerListView();
    var activeMarkers = markerListView ? markerListView.getActiveMarkers() : [];
    activeMarkers.map(function(marker) {
      marker.startTimer(timerTime - 50);
    });
  },
  pauseTimerForActiveMarkers: function() {
    var markerListView = this.getMarkerListView();
    var activeMarkers = markerListView ? markerListView.getActiveMarkers() : [];
    activeMarkers.map(function(marker) {marker.pauseTimer();});
  },
  resumeTimerForActiveMarkers: function(callback) {
    var markerListView = this.getMarkerListView();
    var activeMarkers = markerListView ? markerListView.getActiveMarkers() : [];
    activeMarkers.map(function(marker) {marker.resumeTimer(callback);});
  },
  currentStepUnchangedCheck: function() {
    var me = this;
    return function() {
      return !me.autoplayCurrentStepChanged;
    };
  },
  getWaitForAudioTime: function(settings) {
    var remainingPlayTime = iorad.player.controllers.audio.getRemainingPlayTime() + settings.delayAfterAudio;
    return Math.max(
      0,
      (
        remainingPlayTime >= settings.audioProgressBarSubstractionMinLength ?
          remainingPlayTime - settings.audioProgressBarSubstraction :
          remainingPlayTime
      )
    );
  },
  getWaitForVideoTime: function(settings) {
    var remainingPlayTime = iorad.player.controllers.video.getRemainingPlayTime() + settings.delayAfterVideo;
    return Math.max(
      0,
      (
        remainingPlayTime >= settings.videoProgressBarSubstractionMinLength ?
          remainingPlayTime - settings.videoProgressBarSubstraction :
          remainingPlayTime
      )
    );
  },
  getFinishingProgressbarTime: function(animationTime) {
    var audioTime = this.getWaitForAudioTime(this.getAutoplaySettings());
    var videoTime = this.getWaitForVideoTime(this.getAutoplaySettings());
    return Math.max(animationTime, audioTime, videoTime);
  },
  waitForAudioOrVideoFinishOrFixedTime: function (fixedTime, skipLoading, delayAfterAudio, delayAfterVideo) {
    delayAfterAudio = delayAfterAudio == undefined ? 0 : delayAfterAudio;
    delayAfterVideo = delayAfterVideo == undefined ? 0 : delayAfterVideo;
    this.autoplayCurrentStepChanged = false;
    var stepModel = this.collection.getCurrentModel();
    if (!stepModel) return Promise.resolve();
    var hasAudio = stepModel.get('audioId') != null;
    var hasVideo = stepModel.get('videoId') != null;

    if (
      (
        !hasAudio &&
        !hasVideo
      ) ||
      (
        !iorad.player.controllers.audio.willAudioPlayFinish() &&
        !iorad.player.controllers.video.willVideoPlayFinish()
      ) ||
      (
        (skipLoading && !iorad.player.controllers.audio.audioPlaying) &&
        (skipLoading && !iorad.player.controllers.video.videoPlaying)
      ) ||
      (
        iorad.player.controllers.audio.isMuted() &&
        iorad.player.controllers.video.isMuted()
      )
    ) {
      return this.waitSafely(this.currentStepUnchangedCheck())(fixedTime);
    }
    return hasVideo ?
      iorad.player.controllers.video.waitForVideoFinish(delayAfterVideo)
      :
      iorad.player.controllers.audio.waitForAudioFinish(delayAfterAudio);
  },
  autoplayStepDone: function(isStepUnchanged, settings) {
    var $this = this;
    return this.waitForAudioOrVideoFinishOrFixedTime(0, true, settings.delayAfterAudio, settings.delayAfterVideo)
      .then(function() {
        if ($this.paused) return Promise.reject(new Error('Autoplay paused'));
        if (!isStepUnchanged()) return Promise.reject(new Error('Step changed'));
        var isLastStep = $this.collection.position >= $this.collection.length - 1;
        if (isLastStep) {
          return $this.stopAutoplay();
        }
        iorad.player.events.trigger('interactive:next');
      });
  },
  performAutoplayAction: function(settings, isStepUnchanged) {
    var $this = this;
    this.autoplayCurrentStepChanged = false;
    var currentStep = this.collection.getCurrentModel();
    if (iorad.player.mode !== 'interactive' || !this.isRunning || !currentStep) {
      this.stopAutoplay();
      return Promise.resolve();
    }
    var currentTool = currentStep.get('type');
    var animationTime = this.getStepAnimationTime(settings, currentStep);
    var delayAndCheckStateIsSame = this.waitSafely(isStepUnchanged);
    $this.$autoplayCursor.removeClass('caret');
    var customColor = iorad.player.data.markerColors.get(currentTool) || '';
    this.setAutoplayStyles(settings, customColor);
    var logTimeFromLastFinish = function() {
      if (window.ioradAutoplayLog) {
        console.log(
          '%cTime since progress-bar ended - %c' +
          (Date.now() - window.lastTimerFinish),
          'color: blue', 'color: green'
        );
      }
    };
    var markerListView = this.getMarkerListView();
    var activeMarkers = markerListView.getActiveMarkers();
    var $interactiveImage = $('#interactive-image');
    var $markerArea = activeMarkers[0].$el;

    // # simple one-action types
    if (['LEFT_CLICK', 'RIGHT_CLICK', 'SCROLL', 'HOVER', 'READ'].indexOf(currentTool) !== -1) {
      if (currentTool !== 'READ') this.moveCursorToElement($markerArea[0], settings.cursorMoveTime);
      this.startTimerForActiveMarkers(this.getFinishingProgressbarTime(animationTime.total));
      return delayAndCheckStateIsSame(settings.delayForCursorMove)
        .then(function() {
          if (['LEFT_CLICK', 'RIGHT_CLICK'].indexOf(currentTool) !== -1) {
            if (currentStep.get('event.dblclick')) {
              return $this.addClassTemporarily(
                'double click-animation', settings.doubleClickAnimationTime
              );
            }
            return $this.addClassTemporarily(
              'click-animation', settings.clickAnimationTime
            );
          }
        })
        .then(function() {
          logTimeFromLastFinish();
          return delayAndCheckStateIsSame(settings.delayAfterStepCompleted);
        })
        .then(function() { return $this.autoplayStepDone(isStepUnchanged, settings); });
    }
    // # type
    if (currentTool === 'TYPING') {
      var $markerInput = $interactiveImage.find('.marker.active .typingTool');
      var text = this.getTypingText(currentStep);
      $this.$autoplayCursor.addClass('hide');
      this.startTimerForActiveMarkers(
        this.isTypingSubmit(currentStep) ?
          animationTime.typingAction :
          this.getFinishingProgressbarTime(animationTime.typingAction)
      );
      return Promise.resolve()
        .then(function() {
          // fill the input character by character (generate the promise that does that)
          var typingAnimation = _.range(0, text.length).reduce(
            function(animationPromise, currentLength) {
              return animationPromise
                .then(function() {
                  $markerInput.val(text.substr(0, currentLength + 1));
                })
                .then(function() { return delayAndCheckStateIsSame(settings.delayForCharacterTyping); });
            },
            Promise.resolve()
          );
          return typingAnimation;
        })
        .then(function() {
          if ($this.isTypingSubmit(currentStep)) {
            logTimeFromLastFinish();
            return delayAndCheckStateIsSame(settings.delayAfterActions)
              .then(function() {
                var typingMarker = markerListView.getMarkerView('TYPING');
                typingMarker._completed();
                $this.startTimerForActiveMarkers($this.getFinishingProgressbarTime(animationTime.submitAction));
                return delayAndCheckStateIsSame(settings.delayAfterActionsTyping);
              })
              .then(function() {
                $this.$autoplayCursor.removeClass('hide');
                var clickMarker = markerListView.getMarkerView('LEFT_CLICK');
                $this.moveCursorToElement(clickMarker.el, settings.cursorMoveTime);
                return delayAndCheckStateIsSame(settings.delayForCursorMoveTyping);
              })
              .then(function() {
                return $this.addClassTemporarily(
                  'click-animation', settings.clickAnimationTime
                );
              });
          }
        })
        .then(function() {
          logTimeFromLastFinish();
          return delayAndCheckStateIsSame(settings.delayAfterStepCompletedForTyping);
        })
        .then(function() {
          return $this.autoplayStepDone(isStepUnchanged, settings);
        });
    }
    if (currentTool === 'DRAG_AND_DROP') {
      var dragMarker = markerListView.getMarkerView('DRAG');
      var dropMarker = markerListView.getMarkerView('DROP');
      this.moveCursorToElement(dragMarker.el, settings.cursorMoveTime);
      $this.startTimerForActiveMarkers(animationTime.cursorMoveToDrag);
      return delayAndCheckStateIsSame(settings.delayForCursorMoveDragDrop)
        .then(function() {
          logTimeFromLastFinish();
          return delayAndCheckStateIsSame(settings.delayAfterActions);
        })
        .then(function() {
          dragMarker.onMouseDown();
          $this.startTimerForActiveMarkers($this.getFinishingProgressbarTime(animationTime.drag));
          // we need to wait a bit for markers to move
          return $this.addClassTemporarily(
            'click-animation', settings.delayAfterDragMarkerClick
          );
        })
        .then(function() {
          $this.moveCursorToElement(dropMarker.el, settings.cursorMoveTime, true);
        })
        .then(function() { return delayAndCheckStateIsSame(settings.delayForCursorMoveDragDrop); })
        .then(function() {
          logTimeFromLastFinish();
          return delayAndCheckStateIsSame(settings.delayAfterStepCompleted);
        })
        .then(function() {
          dragMarker.$el.removeClass('autoplay-drag');
          return $this.autoplayStepDone(isStepUnchanged, settings);
        });
    }
    if (currentTool === 'SELECT_TEXT') {
      var $textArea = $interactiveImage.find('.marker.active .selectTextTool');
      $textArea[0].select();
      $textArea[0].setSelectionRange(0, 0);
      var textAreaRect = $textArea[0].getBoundingClientRect();
      $this.$autoplayCursor.addClass('caret');
      this.$autoplayCursor.css({
        left: Math.round(textAreaRect.left + 12) - settings.cursorWidth / 2,
        top: Math.round(textAreaRect.top + 12) - settings.cursorHeight / 2,
      });
      $this.startTimerForActiveMarkers($this.getFinishingProgressbarTime(animationTime.total));
      return delayAndCheckStateIsSame(settings.delayForCursorMove)
        .then(function() {
          $this.addClassTemporarily(
            'click-animation', settings.clickAnimationTime
          );
        })
        .then(function() {
          $this.$autoplayCursor.css({
            left: Math.round(textAreaRect.left + textAreaRect.width - 12 - settings.cursorWidth / 2),
            top: Math.round(textAreaRect.top + textAreaRect.height - 12 - settings.cursorHeight / 2),
          });
          // animate text selection
          _.range(0, 100).reduce(
            function(animationPromise, currentLength) {
              return animationPromise
                .then(function() {
                  $textArea[0].setSelectionRange(0, currentLength + 1);
                })
                .then(function() {
                  return delayAndCheckStateIsSame(settings.delayForCharacterSelection);
                });
            },
            Promise.resolve()
          );
        })
        .then(function() { return delayAndCheckStateIsSame(settings.delayForCursorMove); })
        .then(function() {
          logTimeFromLastFinish();
          return delayAndCheckStateIsSame(settings.delayAfterStepCompleted);
        })
        .then(function() {
          $this.$autoplayCursor.removeClass('caret');
          return $this.autoplayStepDone(isStepUnchanged, settings);
        });

    }
    // # other tools
    return delayAndCheckStateIsSame(settings.delayAfterStepCompleted)
      .then(function() { return $this.autoplayStepDone(isStepUnchanged, settings); });
  },
  moveCursorToCenter: function() {
    this.$autoplayCursor.css({left: '50%', top: '50%'});
  },
  moveCursorToElement: function(el, cursorMoveTime, moveDragFrame) {
    var rect = el.getBoundingClientRect();
    var isCaret = this.$autoplayCursor.hasClass('caret');
    var leftShift = isCaret ? -5 : 0;
    var topShift = isCaret ? -12 : 0;
    // NOTE: use rect.top instead of rect.y (and rect.left instead of rect.x)
    // since is the only one supported in Edge
    this.cursorMoveAnimation = {
      animationTimeLeft: cursorMoveTime,
      targetProps: {
        left: Math.round(rect.left + (rect.width / 2) + leftShift),
        top: Math.round(rect.top + (rect.height / 2) + topShift),
      },
    };
    if (moveDragFrame) {
      // NOTE: containment-relative
      var markerListView = this.getMarkerListView();
      var dropMarker = markerListView.getMarkerView('DROP');
      var markerDropCSSBounds = iorad.base.Utils.getElementBounds(dropMarker.$el, {
        useCSSForEl: true
      });
      this.dragFrameMoveAnimation = {
        targetProps: {
          left: Math.round(markerDropCSSBounds.left + (markerDropCSSBounds.width / 2) + leftShift),
          top: Math.round(markerDropCSSBounds.top + (markerDropCSSBounds.height / 2) + topShift),
        }
      };
    }
    return this.resumeCursor(true);
  },
  resumeCursor: function(start) {
    if (!this.cursorMoveAnimation) return Promise.resolve();
    this.cursorMoveAnimation.animationResumeTime = Date.now();
    var _this = this;
    var animationTime =
      start ?
        this.cursorMoveAnimation.animationTimeLeft :
        this.scaleSpeedOnResume(this.cursorMoveAnimation.animationTimeLeft);
    return Promise.all([
      // cursor itself
      new Promise(function(resolve) {
        _this.$autoplayCursor.animate(
          _this.cursorMoveAnimation.targetProps,
          animationTime,
          'swing',
          function() {
            _this.cursorMoveAnimation = null;
            resolve();
          }
        );
      }),
      // drag frame
      new Promise(function(resolve) {
        if (!_this.dragFrameMoveAnimation) return resolve();
        var markerListView = _this.getMarkerListView();
        var dragMarker = markerListView.getMarkerView('DRAG');
        dragMarker.$el.animate(
          _this.dragFrameMoveAnimation.targetProps,
          animationTime,
          'swing',
          function() {
            _this.dragFrameMoveAnimation = null;
            resolve();
          }
        );
      }),
    ]);
  },
  pauseCursor: function() {
    if (!this.cursorMoveAnimation) return;
    this.$autoplayCursor.stop();
    if (this.dragFrameMoveAnimation) {
      var markerListView = this.getMarkerListView();
      var dragMarker = markerListView.getMarkerView('DRAG');
      dragMarker.$el.stop();
    }
    this.cursorMoveAnimation.animationTimeLeft -= Date.now() - this.cursorMoveAnimation.animationResumeTime;
  },
});

;
iorad.player.HubspotController = iorad.base.HubspotController.extend({});

;
iorad.player.GoogleAnalyticsController = iorad.base.GoogleAnalyticsController.extend({});
;
iorad.player.EmbeddedTrackingController = iorad.base.EmbeddedTrackingController.extend({});
;
iorad.player.TrackingController = iorad.base.TrackingController.extend({
  setupEvents: function() {
    this.listenTo(iorad.player.events, 'extension:installed', this.trackEvent.bind(this, 'installed-extension-player'));
    this.listenTo(iorad.player.events, 'pdfDownload:done', this.trackPDF.bind(this));
    this.listenTo(iorad.player.controllers.live, 'openViewLiveLink', this.trackEvent.bind(this, 'player-golive'));

    this.listenTo(iorad.player.controllers.quiz, 'progress', this.trackQuizProgress.bind(this));
    this.listenTo(iorad.player.controllers.quiz, 'end', this.trackQuizCompleted.bind(this));
    this.listenTo(iorad.player.events, 'statistics:watch:completed', this.trackEvent.bind(this, 'player-mode-watch-completed'));
    this.listenTo(iorad.player.events, 'statistics:interactive:completed', this.trackEvent.bind(this, 'player-mode-try-completed'));
    this.listenTo(iorad.player.events, 'statistics:quick:completed', this.trackEvent.bind(this, 'player-mode-view-completed'));
    this.listenTo(iorad.player.events, 'statistics:mobilequick:completed', this.trackEvent.bind(this, 'player-mode-mobile-completed'));

    this.monitorMode();
    this.monitorTimeSpent();

    this.trackViewed();
    this.trackLanguage();
  },

  trackPDF: function(layoutType) {
    if (layoutType === 'short') {
      this.trackEvent('player-pdf-portrait');
    } else if (layoutType === 'long') {
      this.trackEvent('player-pdf-landscape');
    }
  },

  trackQuizProgress: function (intermediateReport) {
    this.trackEvent('player-mode-quiz-progress', intermediateReport);
  },

  trackQuizCompleted: function(finalReport) {
    this.trackEvent('player-mode-quiz-completed', finalReport);
  },

  monitorMode: function() {
    var lastMode;
    var check = _.bind(function(mode) {
      var newMode;
      if (mode === 'interactive') {
        newMode = 'try';
      } else if (mode === 'quick') {
        newMode = 'view';
      }

      if (newMode && newMode !== lastMode) {
        this.trackEvent('player-mode-' + newMode);
        lastMode = newMode;
      }
    }, this);

    this.listenTo(iorad.player.events, 'ready', check);
    check(iorad.player.mode);
  },

  monitorTimeSpent: function() {
    var active = true;

    iorad.player.controllers.sync.trackPlaySession('start');

    var INTERVAL_SECONDS = 10;
    var totalTimeSpent = 0; // seconds
    setInterval(_.bind(function () {
      if (active && !document.hidden) {
        totalTimeSpent += 1;
        if (totalTimeSpent % INTERVAL_SECONDS === 0) {
          this.trackEvent('player-time-spent', INTERVAL_SECONDS);
          iorad.player.controllers.sync.trackPlaySession('time-spent', { timeSpent: INTERVAL_SECONDS });
        }
      }
    }, this), 1000);

    // monitor inactivity:
    // set user as inactive after INACTIVE_TIME
    // set it back as active on mousemove
    var inactiveTimeout;
    var INACTIVE_TIME = 60 * 1000; // 1 minute
    var onInactive = _.bind(function () {
      active = false;
    }, this);
    var restartInactiveTimer = _.bind(function() {
      active = true;
      if (typeof inactiveTimeout !== 'undefined') {
        clearTimeout(inactiveTimeout);
        inactiveTimeout = undefined;
      }
      inactiveTimeout = setTimeout(_.bind(function() {
        inactiveTimeout = undefined;
        onInactive();
      }, this), INACTIVE_TIME);
    }, this);
    window.addEventListener('mousemove', _.throttle(_.bind(function() {
      restartInactiveTimer();
    }, this), 500));
    restartInactiveTimer();
  },

  trackViewed: function() {
    if (iorad.app.controllers.clientDetect.device.isPhone) {
      this.trackEvent('player-viewed-mobile');
    } else {
      this.trackEvent('player-viewed-desktop');
    }
    if (iorad.base.Utils.isEmbedded()) {
      this.trackEvent('player-embedded');
    }
  },

  trackLanguage: function() {
    if (iorad.player.controllers.language.learnerChangedLanguage()) {
      var lang = iorad.player.getParameters.lang;
      this.trackEvent('player-language');
      this.trackEvent('player-language-' + lang);
    }
  },
});

;
// Controller for the player statistics api.

iorad.player.VideoExportController = (function() {

  var VideoExportController = function() {
    this.initialize.apply(this, arguments);
  };

  _.extend(VideoExportController.prototype, Backbone.Events, {

    initialize: function(stepsCollection, tutorial) {
      this.stepsCollection = stepsCollection;
      this.tutorial = tutorial;

      this.preloadScreenshotsBlocking();
      this.preloadVideoBlocking();
      this.preloadAudioBlocking();
    },

    // Preload all the screenshots and prevent player startup
    // until all are loaded (via registerRenderOperation).
    preloadScreenshotsBlocking: function() {
      this.listenTo(iorad.player.events, 'router:dataReady', function(router) {
        if (router === iorad.player.router) {
          this.stepsCollection.forEach(_.bind(function(stepModel) {
            var operationName = 'step.' + stepModel.get('index') + '.screenshot.preload';
            iorad.player.controllers.views.registerRenderOperation(operationName, _.bind(function(onComplete) {
              var cleared = false;
              stepModel.preload().then(
                function() {
                  if (!cleared) {
                    console.log(operationName, 'success');
                    onComplete();
                  }
                },
                function(err) {
                  if (!cleared) {
                    console.log(operationName, 'failed', err);
                    onComplete();
                  }
                }
              );
              return function clear() {
                cleared = true;
              };
            }, this));
          }, this));
        }
      });
    },

    // Preload all the video and prevent player startup
    // until all are loaded (via registerRenderOperation).
    preloadVideoBlocking: function() {
      this.listenTo(iorad.player.events, 'router:dataReady', function(router) {
        if (router === iorad.player.router) {
          this.stepsCollection.forEach(_.bind(function(stepModel) {
            var stepHasVideo = stepModel.get('videoId') != null;
            if (!stepHasVideo) return;
            var stepId = stepModel.get('index') + 1;
            var operationName = 'step.' + stepModel.get('index') + '.video.preload';
            iorad.player.controllers.views.registerRenderOperation(operationName, _.bind(function(onComplete) {
              var cleared = false;
              iorad.player.controllers.video.preloadVideo(stepId).then(
                function() {
                  if (!cleared) {
                    console.log(operationName, 'success');
                    onComplete();
                  }
                },
                function(err) {
                  if (!cleared) {
                    console.log(operationName, 'failed', err);
                    onComplete();
                  }
                }
              );
              return function clear() {
                cleared = true;
              };
            }, this));
          }, this));
        }
      });
    },

    // Preload all the audio and prevent player startup
    // until all are loaded (via registerRenderOperation).
    preloadAudioBlocking: function() {
      this.listenTo(iorad.player.events, 'router:dataReady', function(router) {
        if (router === iorad.player.router) {
          this.stepsCollection.forEach(_.bind(function(stepModel) {
            var stepHasAudio = stepModel.get('audioId') != null;
            if (!stepHasAudio) return;
            var stepId = stepModel.get('index') + 1;
            var operationName = 'step.' + stepModel.get('index') + '.audio.preload';
            iorad.player.controllers.views.registerRenderOperation(operationName, _.bind(function(onComplete) {
              var cleared = false;
              iorad.player.controllers.audio.preloadAudio(stepId).then(
                function() {
                  if (!cleared) {
                    console.log(operationName, 'success');
                    onComplete();
                  }
                },
                function(err) {
                  if (!cleared) {
                    console.log(operationName, 'failed', err);
                    onComplete();
                  }
                }
              );
              return function clear() {
                cleared = true;
              };
            }, this));
          }, this));
        }
      });
    },
  });

  return VideoExportController;
})();

;
iorad.player.models.step = iorad.base.models.step.extend({

  getStepsCollectionType: function() {
    return iorad.player.collections.steps;
  },

  getScreenshotsController: function() {
    return iorad.player.controllers.screenshots;
  }

});
;
iorad.player.models.theme = iorad.base.models.theme.extend({});
;
iorad.player.models.tutorial = iorad.base.models.tutorial.extend({

  getFormattedDescription: function() {
    var description = this.get('description');
    if (!description) return description;

    var formattedDescription = description;
    // remove new lines
    var formattedDescription = formattedDescription.replace(/\n/g, '');

    return formattedDescription;
  },

  getOption: function(optionName) {
    var optionAttributeName = this.getOptionAttributeName(optionName);
    return this.get(optionAttributeName);
  },
  hasOptionChanged: function(optionName) {
    var optionAttributeName = this.getOptionAttributeName(optionName);
    return this.hasChanged(optionAttributeName);
  },

  getOptionAttributeName: function(optionName) {
    if (!iorad.player.router) return undefined; // too early
    var frameMode = iorad.player.router.getFrameMode();
    return frameMode + '_' + optionName;
  },

  isSharingDisabled: function() {
    return (
      this.getLayoutOption('is_sharing_disabled') ||
      (
        !this.isPublic() &&
        !this.isUnlisted()
      )
    );
  },

  isCommentingDisabled: function () {
    return Boolean(
      window.downloadPlayerType ||
      !this.get('commentingEnabled') ||
      this.getLayoutOption('is_commenting_disabled') ||
      !iorad.base.Settings.get('commenting.isEnabled')
    );
  },

  getLayoutOption: function(key) {
    return this.isCustomLayoutPermitted() ? this.getOption(key) : false;
  },
  hasLayoutOptionChanged: function(key) {
    return this.isCustomLayoutPermitted() ? this.hasOptionChanged(key) : false;
  },

  isCustomLayoutPermitted: function() {
    return true;
  },

  isGoLiveAvailable: function() {
    var isExtensionEmbed = iorad.player.getParameters.extensionEmbed === 'true';
    var isPhone = iorad.app.controllers.clientDetect.device.isPhone;

    if (isPhone && isExtensionEmbed) return false;

    return (
      this.get('isLiveTutorial') &&
      !this.get('liveDisabled') &&
      this.get('guideMeMode') !== 'practice'
    );
  },

  isDoItAvailable: function () {
    var isExtensionEmbed = iorad.player.getParameters.extensionEmbed === 'true';
    var isPhone = iorad.app.controllers.clientDetect.device.isPhone;

    if (isPhone && isExtensionEmbed) return false;

    return (
      this.get('isLiveTutorial') &&
      this.get('doitEnabled') &&
      !this.getLayoutOption('is_live_disabled')
    ) || (iorad.player.getParameters.isViewLive === 'true');
  },

  isQuizAvailable: function() {
    return this.get('quizEnabled') &&
      !this.getLayoutOption('is_quizsteps_disabled');
  },

  isPrintDisabled: function() {
    return this.getLayoutOption('is_print_portrait_disabled') &&
      this.getLayoutOption('is_print_landscape_disabled');
  },
});

;
iorad.player.models.markerColors = iorad.base.models.markerColors.extend({
});
;
iorad.player.models.liveUrlConfig = iorad.base.models.liveUrlConfig.extend({
});

;
iorad.player.models.framesUrlCache = iorad.base.models.framesUrlCache.extend({
});

;
// Note: supposes that the collection is "static",
// i.e. as soon as elements are inserted, they do not change,
// so there is no need to listen to events such as add, remove, reset, etc.

iorad.player.collections.LazyCollection = Backbone.Collection.extend({

  // how many more items to load on each request
  readLength: 5,

  constructor: function(collection) {
    Backbone.Collection.call(this); // no models or options
    this.hookCollection(collection);

    // index of the next model to load
    this.index = 0; // no model yet

    // preload the first batch immediately to prevent the flickering on load
    // TODO: this should probably be moved after view initialization (during gives error)
    this.readMore();
    this.collection.on('reset', this.resetOriginal.bind(this));
  },

  resetOriginal: function(collection) {
    this.hookCollection(collection);
    this.reset();
    this.index = 0;
    this.readMore();
  },

  hookCollection: function(collection) {
    if (this.collection) {
      // clear
      this.stopListening(this.collection);
    }
    this.collection = collection;
  },

  // load 'readLength' items into the collection
  readMore: function() {
    var start = this.index;

    var end = this.index + this.readLength;
    if (end > this.collection.length) {
      // not enough items
      end = this.collection.length;
    }

    for (var i = start, l = end; i < l; i++) {
      this.index++;
      this.add(this.collection.at(i));
    }
  },

  hasMore: function() {
    return this.index !== this.collection.length;
  }

});

;
iorad.player.collections.steps = iorad.base.collections.steps.extend({
  model: iorad.player.models.step
});

;
iorad.player.collections.themes = iorad.base.collections.themes.extend({
  model: iorad.player.models.theme
});
;
iorad.player.helpers.positioning = iorad.player.helpers.positioning || {};

iorad.player.helpers.positioning.image = function(model, element, options) {
  options = options || {};
  var imgcontainer = $('.imgcontainer', element); // can be considered as the image (wraps it)
  var marker = $('.marker', element);

  var x = parseInt(marker.css('left'), 10);
  var y = parseInt(marker.css('top'), 10);
  var width = parseInt(marker.css('width'), 10);
  var height = parseInt(marker.css('height'), 10);
  var markerBorderSize = parseInt(marker.css('border-left-width'), 10);
  if (!isFinite(markerBorderSize)) markerBorderSize = 0;//default

  var stepimg = imgcontainer.parents('.stepimg'); // the viewport
  var viewport = options.viewport;
  var viewportWidth = viewport ? viewport.width : stepimg.width();
  var viewportHeight = viewport ? viewport.height : stepimg.height();

  // Calculate image moving to make the marker into view

  //var spaceVertical = markerBorderSize + 10; // at least cover the marker border for left/top gap
  //var spaceHorizontal = markerBorderSize + 10; // at least cover the marker border for left/top gap
  var spaceVertical = (viewportHeight / 2) - (height / 2); // viewport center
  var spaceHorizontal = (viewportWidth / 2) - (width / 2); // viewport center
  // make sure to keep the marker left/top border visible
  var minSpace = typeof options.minSpace !== 'undefined' ? options.minSpace : 75;
  if (spaceVertical < minSpace) spaceVertical = minSpace;
  if (spaceHorizontal < minSpace) spaceHorizontal = minSpace;

  var top = -(y - spaceVertical);
  var left = -(x - spaceHorizontal);

  // Fix possible right gap
  // var imageWidth = imgcontainer.width();
  // var rightOverflow = imageWidth - viewportWidth + left; // left is negative
  // if (rightOverflow <= 0) {
  //   // only needed right gap is for showing the marker right border
  //   left -= rightOverflow + markerBorderSize;
  // }
  // // Fix possible bottom gap
  // var imageHeight = imgcontainer.height();
  // var bottomOverflow = imageHeight - viewportHeight + top; // top is negative
  // if (bottomOverflow <= 0) {
  //   // only needed bottom gap is for showing the marker bottom border
  //   top -= bottomOverflow + markerBorderSize;
  // }

  // Fix possible left gap
  // (Some might have been created by the "space", make sure isn't too much)
  if (left > markerBorderSize) {
    // only needed left gap is for showing the marker left border
    left = markerBorderSize;
  }
  // Fix possible top gap
  if (top > markerBorderSize) {
    // only needed left gap is for showing the marker left border
    top = markerBorderSize;
  }

  if (options.hammerit) {
    iorad.player.helpers.positioning.hammerIt(
      imgcontainer,
      {
        width: function() {
          return viewport ? viewport.width : stepimg.width();
        },
        height: function() {
          return viewport ? viewport.height : stepimg.height();
        },
      },
      left,
      top,
      iorad.player.controllers.screenshots.getCurrentZoom()
    );
  } else {
    imgcontainer.css({
      top: top + 'px',
      left: left + 'px'
    });
  }
};

// see https://stackoverflow.com/a/51031551
iorad.player.helpers.positioning.hammerIt = function hammerIt(imgcontainer, viewport, initialPosX, initialPosY, initialZoom) {
  initialPosX = initialPosX || 0;
  initialPosY = initialPosY || 0;
  if (typeof initialZoom === 'undefined') {
    initialZoom = 1;
  }

  var existingData = imgcontainer.data('hammertime');
  if (existingData) {
    var changed = existingData.viewportWidth !== viewport.width() ||
      existingData.viewportHeight !== viewport.height() ||
      existingData.initialPosX !== initialPosX ||
      existingData.initialPosY !== initialPosY ||
      existingData.initialZoom !== initialZoom ||
      existingData.contentWidth !== imgcontainer.width() ||
      existingData.contentHeight !== imgcontainer.height();
    if (!changed) {
      return;
    }
    existingData.instance.destroy();
    existingData.containerInstance.destroy();
  }

  imgcontainer.css({
    top: '0px',
    left: '0px'
  });

  var stepimg = imgcontainer.closest('.stepimg');
  var contentWidth = imgcontainer.width();
  var contentHeight = imgcontainer.height();

  var hammertime = new window.Hammer(imgcontainer[0], {});
  var containerHammertime = new window.Hammer(stepimg[0], {});

  hammertime.get('pinch').set({ enable: true });
  var posX = initialPosX,
      posY = initialPosY,
      last_posX = posX,
      last_posY = posY,
      scale = 1,
      last_scale = scale,
      pinchZoomOrigin,
      initialValidPosX,
      initialValidPosY;

  var DOUBLETAP_SCALE = 2;
  var MAX_SCALE = 4;

  // convert point from window-relative to content-relative
  // TODO: take scroll into account if needed
  function getRelativePosition(point) {
    var contentBounds = imgcontainer[0].getBoundingClientRect();
    return {
      x: (point.x - contentBounds.left) / (contentWidth * scale / 2) - 1,
      y: (point.y - contentBounds.top) / (contentHeight * scale / 2) - 1,
    };
  }

  function calculateShift(aScale) {
    var scaledContentWidth = (contentWidth * aScale);
    var scaledContentHeight = (contentHeight * aScale);
    return {
      x: (scaledContentWidth >= contentWidth)
        ? (scaledContentWidth - contentWidth) / 2
        : -((contentWidth - scaledContentWidth) / 2),
      y: (scaledContentHeight >= contentHeight)
        ? (scaledContentHeight - contentHeight) / 2
        : -((contentHeight - scaledContentHeight) / 2),
    };
  }

  // scale to fit the whole content into the viewport
  function getMinScale() {
    var viewportWidth = viewport.width();
    var viewportHeight = viewport.height();
    return Math.min(
      1,
      viewportWidth / contentWidth,
      viewportHeight / contentHeight
    );
  }

  function scaleFrom(zoomOrigin, currentScale, newScale) {
    var currentShift = calculateShift(currentScale);
    var newShift = calculateShift(newScale);

    var shift = {
      x: currentShift.x - newShift.x,
      y: currentShift.y - newShift.y,
    };
    return {
      x: zoomOrigin.x * shift.x,
      y: zoomOrigin.y * shift.y,
    };
  }

  function update() {
    var viewportWidth = viewport.width();
    var viewportHeight = viewport.height();

    var shift = calculateShift(scale);
    var leftmostX = shift.x;
    var topmostY = shift.y;
    var rightmostX = -(leftmostX + (contentWidth - viewportWidth));
    var downmostY = -(topmostY + (contentHeight - viewportHeight));

    var maxX = Math.max(leftmostX, rightmostX);
    var minX = Math.min(leftmostX, rightmostX);
    var maxY = Math.max(topmostY, downmostY);
    var minY = Math.min(topmostY, downmostY);

    posX = Math.min(posX, maxX);
    posX = Math.max(posX, minX);
    posY = Math.min(posY, maxY);
    posY = Math.max(posY, minY);
    imgcontainer[0].style.transform = "translate3d(" + posX + "px," + posY + "px, 0) " +
      "scale3d(" + scale + ", " + scale + ", 1)";


    // keep image horizontally and vertically centered (when smaller than viewport)
    var widthDifference = viewportWidth - (contentWidth * scale);
    var heightDifference = viewportHeight - (contentHeight * scale);
    imgcontainer.css({
      left: widthDifference > 0 ? Math.max(0, widthDifference / 2) : 0,
      top: heightDifference > 0 ? Math.max(0, heightDifference / 2) : 0,
    });
    var MARKER_BORDER = 6;
    stepimg.children('.step-infotext').css({
      left: widthDifference > 0 ? Math.max(0, widthDifference / 2) - MARKER_BORDER : '',
      width: widthDifference > 0 ? (contentWidth * scale) + (MARKER_BORDER * 2) : '',
      top: heightDifference > 0 ? Math.max(0, heightDifference / 2) - MARKER_BORDER : '',
      height: heightDifference > 0 ? (contentHeight * scale) + (MARKER_BORDER * 2) : '',
    });
  }

  function commit() {
    last_scale = scale;
    last_posX = posX;
    last_posY = posY;
  }

  var minScale = getMinScale();

  var scaleToTransitionTimeout;
  function scaleTo(newScale, options) {
    options = options || {};
    scale = newScale;
    var newShift = calculateShift(newScale);
    var percentScale = (minScale === 1)
      ? newScale
      : (newScale - minScale) / (1 - minScale);
    posX = (initialValidPosX * percentScale) + newShift.x;
    posY = (initialValidPosY * percentScale) + newShift.y;

    if (scaleToTransitionTimeout) {
      clearTimeout(scaleToTransitionTimeout);
      scaleToTransitionTimeout = undefined;
    }
    if (options.noTransition) {
      imgcontainer[0].style.transition = 'none';
    } else {
      imgcontainer[0].style.transition = '0.3s';
      scaleToTransitionTimeout = setTimeout(function() {
        scaleToTransitionTimeout = undefined;
        imgcontainer[0].style.transition = 'none';
      }, 300);
    }

    commit();
  }
  function zoomTo(zoomFactor, options) {
    var newScale;
    if (zoomFactor >= 1) {
      newScale = zoomFactor;
    } else {
      newScale = minScale + ((1 - minScale) * zoomFactor);
    }
    return scaleTo(newScale, options);
  }

  hammertime.on('pan pinchstart pinch panend pinchend', function(ev) {
    if (ev.type === 'pan') {
      posX = last_posX + ev.deltaX;
      posY = last_posY + ev.deltaY;
    }
    if (ev.type == 'panend') {
      commit();
    }

    if (ev.type === 'pinchstart') {
      pinchZoomOrigin = getRelativePosition(ev.center);
    }
    if (ev.type == 'pinch') {
      var newScale = Math.max(getMinScale(), Math.min(last_scale * (ev.scale), MAX_SCALE));
      var d = scaleFrom(pinchZoomOrigin, last_scale, newScale);
      scale = newScale;
      posX = d.x + last_posX + ev.deltaX;
      posY = d.y + last_posY + ev.deltaY;
    }
    if (ev.type == 'pinchend') {
      commit();
    }

    update();
  });
  containerHammertime.on('tap', function(ev) {
    if (
      ev.target !== imgcontainer[0] &&
      !jQuery.contains(imgcontainer[0], ev.target) &&
      ev.target !== stepimg[0]
    ) return;

    if (ev.type == 'tap') {
      iorad.player.controllers.screenshots.zoomNext();
    }

    update();
  });

  update();
  initialValidPosX = posX;
  initialValidPosY = posY;

  imgcontainer.data('hammertime', {
    instance: hammertime,
    containerInstance: containerHammertime,
    viewportWidth: viewport.width(),
    viewportHeight: viewport.height(),
    initialPosX: initialPosX,
    initialPosY: initialPosY,
    initialZoom: initialZoom,
    contentWidth: contentWidth,
    contentHeight: contentHeight,

    zoomTo: zoomTo,
    update: update,
  });

  if (initialZoom !== 1) {
    zoomTo(initialZoom, { noTransition: true });
    update();
  }
};

;
iorad.player.templates.comments_editor = "<div class=\"comments-editor cf\">\n  <div class=\"comments-wysihtml5-sandbox-container\">\n    <textarea class=\"comments-editor-textarea\" placeholder=\"Click to add text.\"></textarea>\n  </div>\n  <ul class=\"comments-editor-toolbar wysiwyg inline\">\n    <li class=\"editor-list editor-bold\" data-wysihtml5-command=\"bold\" title=\"CTRL+B\" unselectable=\"on\">\n      Highlight\n      <svg width=\"10\" height=\"12\" viewBox=\"0 0 10 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.68599 0.5L3.88404 1.07843L0.5 11.2534H2.30401L3.22754 8.40838H7.27246L7.96227 10.4825L8.22994 11.2534H10L6.61596 1.07843L5.81401 0.5H4.68599ZM6.7103 6.71809L5.25 2.32732L3.7897 6.71809H6.7103Z\" fill=\"var(--site-theme-color)\"/>\n      </svg>\n    </li>\n    <li class=\"editor-list editor-underline\" data-wysihtml5-command=\"underline\" title=\"CTRL+U\" unselectable=\"on\">\n      Underline\n      <svg width=\"12\" height=\"12\" viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.56 0H0L0.00437508 11.6L0.444375 12H12V0.4L11.56 0ZM5.68599 0.700012L4.88404 1.27844L1.5 11.4534H3.30401L4.22754 8.60839H8.27246L8.96227 10.6825L9.22994 11.4534H11L7.61596 1.27844L6.81401 0.700012H5.68599ZM7.7103 6.9181L6.25 2.52734L4.7897 6.9181H7.7103Z\" fill=\"var(--site-theme-color)\"/>\n      </svg>\n    </li>\n    <li class=\"editor-list editor-hyperlink\" data-wysihtml5-command=\"createLink\" unselectable=\"on\">\n      Hyperlink\n      <svg width=\"18\" height=\"12\" viewBox=\"0 0 18 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.8 0.5H6.46863L6.23431 0.734315L4.73431 2.23431L4.5 2.46863V2.8V3.5H3.8H3.46863L3.23431 3.73431L1.73431 5.23431L1.5 5.46863V5.8V8.8V9.13137L1.73431 9.36569L3.23431 10.8657L3.46863 11.1H3.8H11.8H12.1314L12.3657 10.8657L13.8657 9.36569L14.1 9.13137V8.8V8.1H14.8H15.1314L15.3657 7.86569L16.8657 6.36569L17.1 6.13137V5.8V2.3V1.87185L16.7438 1.63436L15.2438 0.63436L15.0422 0.5H14.8H6.8ZM14.1 6.5H14.4686L15.5 5.46863V2.72815L14.5578 2.1H7.13137L6.1 3.13137V3.5H11.8H12.0422L12.2438 3.63436L13.7438 4.63436L14.1 4.87185V5.3V6.5ZM6.1 5.1H11.5578L12.5 5.72815V6.5H7.13137L6.1 5.46863V5.1ZM4.5 5.1V5.8V6.13137L4.73431 6.36569L6.23431 7.86569L6.46863 8.1H6.8H12.5V8.46863L11.4686 9.5H4.13137L3.1 8.46863V6.13137L4.13137 5.1H4.5Z\" fill=\"black\"/>\n      </svg>\n    </li>\n    <li class=\"editor-list editor-speech\" data-wysihtml5-command=\"insertSpeech\">\n      Speech\n      <svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"width=\"23px\" height=\"23px\" viewBox=\"0 0 23 23\" enable-background=\"new 0 0 23 23\" xml:space=\"preserve\">\n        <g>\n          <path d=\"M11.5,5.33c-1.436,0-2.604,1.169-2.604,2.604v3.912c0,1.436,1.168,2.604,2.604,2.604s2.604-1.168,2.604-2.604V7.934C14.104,6.499,12.936,5.33,11.5,5.33z\"/>\n          <path d=\"M15.173,9.858h-0.089h-0.256v2.076c0,1.835-1.493,3.328-3.328,3.328c-1.834,0-3.327-1.493-3.327-3.328V9.858H7.915H7.827H7.543v2.21c0,2.029,1.578,3.618,3.582,3.8v1.099h-0.953v0.703h2.656v-0.703h-0.953v-1.098c1.979-0.18,3.536-1.73,3.575-3.727h0.007V9.858H15.173z\"/>\n        </g>\n      </svg>\n    </li>\n    <li class=\"charNum whatsleft\">0/250</li>\n\n    <li data-wysihtml5-dialog=\"createLink\" class=\"comments-editor-link-dialog\" style=\"display: none;\">\n      <svg width=\"16\" height=\"11\" viewBox=\"0 0 16 11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.3 0H4.96863L4.73431 0.234315L3.23431 1.73431L3 1.96863V2.3V3H2.3H1.96863L1.73431 3.23431L0.234315 4.73431L0 4.96863V5.3V8.3V8.63137L0.234315 8.86568L1.73431 10.3657L1.96863 10.6H2.3H10.3H10.6314L10.8657 10.3657L12.3657 8.86568L12.6 8.63137V8.3V7.6H13.3H13.6314L13.8657 7.36568L15.3657 5.86568L15.6 5.63137V5.3V1.8V1.37185L15.2438 1.13436L13.7438 0.13436L13.5422 0H13.3H5.3ZM12.6 6H12.9686L14 4.96863V2.22815L13.0578 1.6H5.63137L4.6 2.63137V3H10.3H10.5422L10.7438 3.13436L12.2438 4.13436L12.6 4.37185V4.8V6ZM4.6 4.6H10.0578L11 5.22815V6H5.63137L4.6 4.96863V4.6ZM3 4.6V5.3V5.63137L3.23431 5.86568L4.73431 7.36568L4.96863 7.6H5.3H11V7.96863L9.96863 9H2.63137L1.6 7.96863V5.63137L2.63137 4.6H3Z\" fill=\"black\"/>\n      </svg>\n      <div class=\"input-wrapper\">\n        <input data-wysihtml5-dialog-field=\"href\" placeholder=\"Enter a link\" value=\"\" class=\"text\">\n        <div class=\"fade-out\"></div>\n      </div>\n      <button class=\"btn-add\" data-wysihtml5-dialog-action=\"save\">Add</button>\n      <button class=\"btn-cancel\" data-wysihtml5-dialog-action=\"cancel\">Cancel</button>\n      <button class=\"btn-update\" data-wysihtml5-dialog-action=\"save\">Add</button>\n      <button class=\"btn-remove\" data-wysihtml5-dialog-action=\"cancel\">Remove</button>\n    </li>\n  </ul>\n  <div class=\"link-error\">\n    <div class=\"link-error-inner\">Please enter a valid link</div>\n  </div>\n</div>\n";
;
(function () {
  var html = window.litHTML.html;
  iorad.player.templates.layout_comments = ({
    allCommentsCount,
    commentList,
    commentListIsNonEmpty,
    editingOrReplying,
    userIsLoggedIn,
    userCanComment,
    editingCommentId,
    replyingCommentId,
    replyingComment,
    target,
    signinUrl,
    emojisBlockIsShow,
    emojis,
    commentEditorIsShow,
    expandCommentIds,
    isShowStepList,
    stepList,
    currentStepTarget,
    showFromAdvanced,
  }) => html`
<button class="close-popup-banner close-comments-popup" aria-label="${(!isShowStepList || showFromAdvanced) ? 'Back' : 'Close'}">
  <div class="close-info">
    ${replyingComment ? html`
      <span class="close-name">Reply Comment</span>
    ` : (
      isShowStepList ?
        html`
          <span class="close-name">${allCommentsCount === 0 ? 'Comments' : allCommentsCount === 1 ? '1 comment' : `${allCommentsCount} comments`}</span>
        `
        :
        html`
          <span class="close-name">${target.startsWith('step_') ? html`Step ${Number(target.split('_')[1]) + 1}` : 'Cover'}</span>
        `
    )}
  </div>
  ${(!isShowStepList || showFromAdvanced) ? html`
    <span class="close-text-hover">Back</span>
    <div class="close-back-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="9" height="15" viewBox="0 0 9 15" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.4343 0.934326L8.56567 2.0657L3.13136 7.50001L8.56567 12.9343L7.4343 14.0657L0.868617 7.50001L7.4343 0.934326Z" fill="black"/>
      </svg>
    </div>
  ` : html`
    <span class="close-text-hover">Close</span>
    <div class="close-close-icon">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.38281 1L13.3828 13M1.38281 13L13.3828 1" stroke="black" stroke-width="1.6"/>
      </svg>
    </div>
  `}
</button>
<div class="popup-content">
  <div class="content-wrapper comment_wrapper ${isShowStepList ? '' : 'showComment'}">
    <div class="step_list">
      ${stepList.map((step) => html`
        <div class="step_list_item" data-type="${step.commentsCount > 0 ? 'showTargetComments' : 'addTargetComments'}" data-target="${step.target}">
          <button
            aria-haspopup="true"
            aria-controls="comments-content-popup"
            aria-label="${step.commentsCount > 0 ? `Show comments for ${step.title}` : `Add comment for ${step.title}`}"
            class="step_list_item_title"
          >
            <span>${step.title}</span>
            ${step.target === currentStepTarget ? html`
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="23" viewBox="0 0 17 23" fill="none">
                <path d="M1 14L5.70769 20L16 5" stroke="black" stroke-width="1.6" stroke-linejoin="bevel"/>
              </svg>
            ` : ''}
          </button>
          ${step.commentsCount > 0 ?
            html `
              <div data-target="${step.target}" class="step_list_item_header_action_show_comments">
                <span>${step.commentsCount}</span>
                <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1H5H9H17V10.931H14.5V16.2586L10 10.931H1V5.96552V3.48276V1Z" stroke="black" stroke-width="1.6"
                    stroke-linejoin="bevel" />
                </svg>
              </div>
            ` :
            html`
              <div data-target="${step.target}" class="step_list_item_header_action_add_comments">
                <span>Comment</span>
              </div>
            `
          }
        </div>
      `)}
    </div>
    <div id="comments-content-popup" class="comment_popup">
      ${(commentListIsNonEmpty && userCanComment) ? html`
        <div class="comments_list ${replyingComment ? 'hide' : ''}">
          ${commentList.map((comment) => html`
            <div
              class="comments_list_item"
              data-id=${comment.id}
            >
              <div class="comments_list_item_header">
                <div class="comments_list_item_header_ioradicalAvatar">
                  <img
                    src=${comment.user__avatar_src}
                  />
                </div>
                <div class="comments_list_item_header_info">
                  <span class="comments_list_item_user_fullname notranslate">
                    ${comment.user__public_name}
                  </span>
                </div>
                <div class="comments_list_item_header_userCommentsActions">
                  ${comment.current_user__owns ? html`
                    <div class="comments_list_item_header_userCommentsActions_edit ${editingOrReplying ? 'disabled' : ''}" aria-label="Edit Comment" role="button" tabindex="0">
                      <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.5 2L11.2029 1.25722L10.9343 1.43431L11.5 2ZM3.5 10L2.93431 9.43431L2.73374 9.77012L3.5 10ZM2 15L1.23374 14.7701L0.851088 16.0456L2.15689 15.7845L2 15ZM7 14L7.15689 14.7845L7.54829 14.5826L7 14ZM15.5 6L16.0483 6.58256L16.2428 6.29711L15.5 6ZM16.5 3.5L17.2428 3.79711L17.0657 2.93431L16.5 3.5ZM14 1L14.5657 0.434315L13.7029 0.257219L14 1ZM10.9343 1.43431L2.93431 9.43431L4.06569 10.5657L12.0657 2.56569L10.9343 1.43431ZM2.73374 9.77012L1.23374 14.7701L2.76626 15.2299L4.26626 10.2299L2.73374 9.77012ZM2.15689 15.7845L7.15689 14.7845L6.84311 13.2155L1.84311 14.2155L2.15689 15.7845ZM7.54829 14.5826L16.0483 6.58256L14.9517 5.41744L6.45171 13.4174L7.54829 14.5826ZM16.2428 6.29711L17.2428 3.79711L15.7572 3.20289L14.7572 5.70289L16.2428 6.29711ZM17.0657 2.93431L14.5657 0.434315L13.4343 1.56569L15.9343 4.06569L17.0657 2.93431ZM13.7029 0.257219L11.2029 1.25722L11.7971 2.74278L14.2971 1.74278L13.7029 0.257219Z" fill="var(--site-theme-color)"/>
                        <path d="M11.5 2L15 5.5" stroke="var(--site-theme-color)" stroke-width="1.6"/>
                        <path d="M5.5 11.5L7.5 13.5" stroke="var(--site-theme-color)" stroke-width="1.6"/>
                      </svg>
                    </div>
                  ` : ''}
                  ${comment.current_user__can_remove ? html`
                    <div class="comments_list_item_header_userCommentsActions_remove ${editingOrReplying ? 'disabled' : ''}" aria-label="Delete Comment" role="button" tabindex="0">
                      <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 3L0 3" stroke="black" stroke-width="1.6" stroke-linejoin="round"/>
                        <path d="M9.09998 1L4.49998 1" stroke="black" stroke-width="1.6" stroke-linejoin="round"/>
                        <path d="M1.5 5.5V4.7H0.7V5.5H1.5ZM12.5 5.5H13.3V4.7H12.5V5.5ZM12.5 16.5V17.3L13.3 16.5H12.5ZM1.5 16.5H0.7L1.5 17.3V16.5ZM1.5 6.3H12.5V4.7H1.5V6.3ZM11.7 5.5V16.5H13.3V5.5H11.7ZM12.5 15.7H1.5V17.3H12.5V15.7ZM2.3 16.5V5.5H0.7V16.5H2.3Z" fill="black"/>
                        <path d="M5 7V15" stroke="black" stroke-width="1.6" stroke-linejoin="round"/>
                        <path d="M9 7V15" stroke="black" stroke-width="1.6" stroke-linejoin="round"/>
                      </svg>
                    </div>
                  ` : ''}
                </div>
              </div>
              <div
                class="comments_list_item_content ${comment.notranslate ? 'notranslate' : ''}"
                .innerHTML=${comment.contentParsed}
              ></div>
              <div class="comments_list_item_footer">
                <div class="comments_list_item_date_created">
                  ${comment.date_created__formatted}
                </div>
                ${(comment.current_user__can_reply && !comment.parent_tutorial_comment_id) ? html`
                  <div class="comments_list_item_userCommentsActions_reply ${editingOrReplying ? 'disabled' : ''}" aria-label="Reply to comment" role="button" tabindex="0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="25" viewBox="0 0 13 25" fill="none">
                      <path d="M0.699951 7.40565L5.64306 4.38477L5.59568 6.86488H12.2L13 7.66488V16.6649L12.5885 17.3642L8.09291 19.8617L11.4 16.1949V8.46488H5.56511L5.52069 10.7901L0.699951 7.40565Z" fill="black" />
                    </svg>
                    <span>Reply</span>
                  </div>
                ` : ''}
              </div>

            </div>
            ${comment.childs.length > 0 ? html`
              <div class="comments_list_item--childs ${expandCommentIds.includes(comment.id) ? 'active' : ''}">
                <div class="comments_list_item--childs_toggle" data-id=${comment.id}>
                  <span>${comment.childs.length} ${comment.childs.length > 1 ? 'replies' : 'reply'}</span>
                  <div class="comments_list_item--childs_avatar_list">
                    ${comment.childs.map((childComment) => html`
                      <img src=${childComment.user__avatar_src} />
                    `)}
                  </div>
                </div>
                <div class="comments_list_item--childs_toggle hide_childs" data-id=${comment.id}>
                  <span>Hide</span>
                </div>
                <ul class="comments_list childs">
                  ${comment.childs.map((childComment) => html`
                    <li
                      class="comments_list_item"
                      data-id=${childComment.id}
                    >
                      <div class="comments_list_item_header">
                        <div class="comments_list_item_header_ioradicalAvatar">
                          <img
                            src=${childComment.user__avatar_src}
                          />
                        </div>
                        <div class="comments_list_item_header_info">
                          <span class="comments_list_item_user_fullname notranslate">
                            ${childComment.user__public_name}
                          </span>
                        </div>
                        <div class="comments_list_item_header_userCommentsActions">
                          ${childComment.current_user__owns ? html`
                            <div class="comments_list_item_header_userCommentsActions_edit ${editingOrReplying ? 'disabled' : ''}" aria-label="Edit Comment" role="button" tabindex="0">
                              <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.5 2L11.2029 1.25722L10.9343 1.43431L11.5 2ZM3.5 10L2.93431 9.43431L2.73374 9.77012L3.5 10ZM2 15L1.23374 14.7701L0.851088 16.0456L2.15689 15.7845L2 15ZM7 14L7.15689 14.7845L7.54829 14.5826L7 14ZM15.5 6L16.0483 6.58256L16.2428 6.29711L15.5 6ZM16.5 3.5L17.2428 3.79711L17.0657 2.93431L16.5 3.5ZM14 1L14.5657 0.434315L13.7029 0.257219L14 1ZM10.9343 1.43431L2.93431 9.43431L4.06569 10.5657L12.0657 2.56569L10.9343 1.43431ZM2.73374 9.77012L1.23374 14.7701L2.76626 15.2299L4.26626 10.2299L2.73374 9.77012ZM2.15689 15.7845L7.15689 14.7845L6.84311 13.2155L1.84311 14.2155L2.15689 15.7845ZM7.54829 14.5826L16.0483 6.58256L14.9517 5.41744L6.45171 13.4174L7.54829 14.5826ZM16.2428 6.29711L17.2428 3.79711L15.7572 3.20289L14.7572 5.70289L16.2428 6.29711ZM17.0657 2.93431L14.5657 0.434315L13.4343 1.56569L15.9343 4.06569L17.0657 2.93431ZM13.7029 0.257219L11.2029 1.25722L11.7971 2.74278L14.2971 1.74278L13.7029 0.257219Z" fill="var(--site-theme-color)"/>
                                <path d="M11.5 2L15 5.5" stroke="var(--site-theme-color)" stroke-width="1.6"/>
                                <path d="M5.5 11.5L7.5 13.5" stroke="var(--site-theme-color)" stroke-width="1.6"/>
                              </svg>
                            </div>
                          ` : ''}
                          ${childComment.current_user__can_remove ? html`
                            <div class="comments_list_item_header_userCommentsActions_remove ${editingOrReplying ? 'disabled' : ''}" aria-label="Delete Comment" role="button" tabindex="0">
                              <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14 3L0 3" stroke="black" stroke-width="1.6" stroke-linejoin="round"/>
                                <path d="M9.09998 1L4.49998 1" stroke="black" stroke-width="1.6" stroke-linejoin="round"/>
                                <path d="M1.5 5.5V4.7H0.7V5.5H1.5ZM12.5 5.5H13.3V4.7H12.5V5.5ZM12.5 16.5V17.3L13.3 16.5H12.5ZM1.5 16.5H0.7L1.5 17.3V16.5ZM1.5 6.3H12.5V4.7H1.5V6.3ZM11.7 5.5V16.5H13.3V5.5H11.7ZM12.5 15.7H1.5V17.3H12.5V15.7ZM2.3 16.5V5.5H0.7V16.5H2.3Z" fill="black"/>
                                <path d="M5 7V15" stroke="black" stroke-width="1.6" stroke-linejoin="round"/>
                                <path d="M9 7V15" stroke="black" stroke-width="1.6" stroke-linejoin="round"/>
                              </svg>
                            </div>
                          ` : ''}
                        </div>
                      </div>
                      <div
                        class="comments_list_item_content ${childComment.notranslate ? 'notranslate' : ''}"
                        .innerHTML=${sanitizeHtml(childComment.content, iorad.base.Export.STEP_DESCRIPTION_APP_SANITIZE_RULES)}
                      ></div>
                      <div class="comments_list_item_footer">
                        <div class="comments_list_item_date_created">
                          ${childComment.date_created__formatted}
                        </div>
                        ${(childComment.current_user__can_reply && !childComment.parent_tutorial_comment_id) ? html`
                          <div class="comments_list_item_userCommentsActions_reply ${editingOrReplying ? 'disabled' : ''}" aria-label="Reply to comment" role="button" tabindex="0">
                            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="25" viewBox="0 0 13 25" fill="none">
                              <path d="M0.699951 7.40565L5.64306 4.38477L5.59568 6.86488H12.2L13 7.66488V16.6649L12.5885 17.3642L8.09291 19.8617L11.4 16.1949V8.46488H5.56511L5.52069 10.7901L0.699951 7.40565Z" fill="black" />
                            </svg>
                            <span>Reply</span>
                          </div>
                        ` : ''}
                      </div>
                    </li>
                  `)}
                </ul>
              </div>
            ` : ''}
          `)}
        </div>
        ` : html`
          <div class="comments_no_comment">
            ${!userIsLoggedIn ? html`<a class="comments_no_comment_signin" href=${signinUrl} target="_blank">Sign In</a>${' '}to comment`
              : (userCanComment ? 'No comments yet' : 'Need permission to view comments')
            }
          </div>
        `
      }

      ${userCanComment ? html`
        ${!commentEditorIsShow && !isShowStepList ? html`
          <button class="open_comment_btn" aria-label="Add a comment">
            <span>Leave a comment</span>
          </button>
        ` : ''}
        <div class="comments_editor_block ${!commentEditorIsShow ? 'hide' : ''} ${replyingComment ? 'replying' : ''}">
          ${replyingComment ? html`
            <div
              class="comments_list_item replying_comment_item"
              data-id=${replyingComment.id}
            >
              <div class="comments_list_item_header">
                <div class="comments_list_item_header_ioradicalAvatar">
                  <img
                    src=${replyingComment.user__avatar_src}
                  />
                </div>
                <div class="comments_list_item_header_info">
                  <span class="comments_list_item_user_fullname notranslate">
                    ${replyingComment.user__public_name}
                  </span>
                </div>
              </div>
              <div
                class="comments_list_item_content ${replyingComment.notranslate ? 'notranslate' : ''}"
                .innerHTML=${sanitizeHtml(replyingComment.content, iorad.base.Export.STEP_DESCRIPTION_APP_SANITIZE_RULES)}
              ></div>
              <div class="comments_list_item_footer">
                <div class="comments_list_item_date_created">
                  ${replyingComment.date_created__formatted}
                </div>
              </div>
            </div>
          ` : ''}
          <div class="comments_editor ${replyingCommentId ? 'replying' : ''} ${emojisBlockIsShow ? 'emojisBlockIsShow' : ''}">
            <div class="comments_editor_control">
              <div class="comments_editor_emoji_icon">
                ${emojisBlockIsShow ? html`
                  <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 6L19 18M7 18L19 6" stroke="black" stroke-width="1.6"/>
                  </svg>
                ` : html`
                  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12.5" r="11.2" stroke="#BABABA" stroke-width="1.6"/>
                    <circle cx="8" cy="10" r="2" fill="#BABABA"/>
                    <circle cx="16" cy="10" r="2" fill="#BABABA"/>
                    <path d="M15 14C15 15.6569 13.6569 17 12 17C10.3431 17 9 15.6569 9 14" stroke="#BABABA" stroke-width="1.6"/>
                  </svg>
                `}
              </div>
              <div
                class="comments_editor_control_content"
              >
                <!-- sub view added here -->
              </div>
            </div>
            <div
              class=${`comments_editor_emojis_block ${!emojisBlockIsShow ? 'hide' : ''}`}
            >
              ${emojis.map((emojiItem) => html`
                <span class="comments_editor_emoji_item" data-value="${emojiItem.emoji}">${emojiItem.emoji}</span>
              `)}
            </div>
            <div class="comments_editor_group_btn">
              <button
                class="comments_editor_group_btn_save"
              >
                ${editingCommentId ? 'Save' : 'Post'}
              </button>
            </div>
          </div>
        </div>
      ` : ''}
    </div>
  </div>
</div>
<div class="popup_overlay"></div>
`;
}());

;
(function () {
  const css = (prefix, fn) => {
    if (fn) {
      const subCss = (subPrefix, subFn) => css(
        prefix + (subPrefix ? ('_' + subPrefix) : ''),
        subFn
      );
      return fn(subCss);
    }
    return prefix;
  };

  const html = window.litHTML.html;
  iorad.player.templates.layout_share = ({
    visibleModeOptions,
    selectedModeOption,
    modePopupSearchIsFocus,
    modePopupSearchList,
    modePopupVisibled,
    showFromAdvanced,
  }) => html`
  <button class="close-popup-banner close-share-popup" aria-label="${(showFromAdvanced || modePopupVisibled) ? 'Back' : 'Close'}">
    <div class="close-info">
      <span class="close-name">${modePopupVisibled ? 'Player Mode' : 'Share'}</span>
    </div>
    ${(showFromAdvanced || modePopupVisibled) ? html`
    <span class="close-text-hover">Back</span>
    <div class="close-back-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="9" height="15" viewBox="0 0 9 15" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.4343 0.934326L8.56567 2.0657L3.13136 7.50001L8.56567 12.9343L7.4343 14.0657L0.868617 7.50001L7.4343 0.934326Z" fill="black"/>
      </svg>
    </div>
  ` : html`
    <span class="close-text-hover">Close</span>
    <div class="close-close-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
        <rect x="22.75" y="20.75" width="10.5" height="14.5" stroke="black" stroke-width="1.5"/>
      </svg>
    </div>
  `}
</button>
<div class="popup-content share-container" role="menu">
  ${css('share-container_inner', (_inner) => html`
    <div class="${_inner()}">
      ${_inner('shareList', (_shareList) => html`
        <div class="${_shareList()}" role="menuitem">
          ${_shareList('shareItem', (_shareItem) => html`
            <button
              aria-label="Mode list"
              aria-haspopup="true"
              aria-controls="share-select-mode-popup"
              class="${_shareItem()}"
              data-type="mode"
            >
              ${_shareItem('icon', (_icon) => html`
                <span class="${_icon()}">
                  ${iorad.player.router.selectorView.getModeIcon(selectedModeOption.tab, { size: 'S' })}
                </span>
              `)}
              ${_shareItem('label', (_label) => html`
                <span class="${_label()}">
                  <div class="tooltip">
                    <div class="tooltip-inner"><span>${selectedModeOption.label} ${i18next.t('Mode')}</span></div>
                    <div class="tooltip-text"><span>${i18next.t('Share')} ${selectedModeOption.label} ${i18next.t('Mode')}</span></div>
                  </div>
                </span>
              `)}
              ${_shareItem('button', (_button) => html`
                <span class="${_button()} ${_button() + '-mode'}">
                  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="14" viewBox="0 0 9 14" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.56568 13.5657L0.434311 12.4343L5.86863 6.99999L0.43431 1.56567L1.56568 0.434303L8.13137 6.99999L1.56568 13.5657Z" fill="black"/>
                  </svg>
                </span>
              `)}
            </button>
          `)}
          ${_shareList('shareItem', (_shareItem) => html`
            <button class="${_shareItem()}" data-copy="true" data-type="copy-url" aria-label="Copy URL">
              ${_shareItem('icon', (_icon) => html`
                <span class="${_icon()}">
                  <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.927734 0.920056L1.72773 0.120056H11.7277L12.5277 0.920056V2.82276H14.455L15.255 3.62276V15.3345L14.455 16.1345H4.45503L3.65503 15.3345V13.4318H1.72773L0.927734 12.6318V0.920056ZM3.65503 11.8318V3.62276L4.45503 2.82276H10.9277V1.72006H2.52773V11.8318H3.65503ZM5.25503 14.5345V4.42276H13.655V14.5345H5.25503Z" fill="black"/>
                  </svg>
                </span>
              `)}
              ${_shareItem('label', (_label) => html`
                <span class="${_label()}">
                  <div class="tooltip">
                    <div class="tooltip-inner">${i18next.t('Copy Direct URL')}</div>
                    <div class="tooltip-text"><span>${i18next.t('Copy Direct URL')}</span></div>
                  </div>
                </span>
              `)}
            </button>
          `)}
          ${_shareList('shareItem', (_shareItem) => html`
            <button class="${_shareItem()}" data-copy="true" data-type="copy-short" aria-label="Copy Short">
              ${_shareItem('icon', (_icon) => html`
                <span class="${_icon()}">
                  <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.927734 0.920056L1.72773 0.120056H11.7277L12.5277 0.920056V2.82276H14.455L15.255 3.62276V15.3345L14.455 16.1345H4.45503L3.65503 15.3345V13.4318H1.72773L0.927734 12.6318V0.920056ZM3.65503 11.8318V3.62276L4.45503 2.82276H10.9277V1.72006H2.52773V11.8318H3.65503ZM5.25503 14.5345V4.42276H13.655V14.5345H5.25503Z" fill="black"/>
                  </svg>
                </span>
              `)}
              ${_shareItem('label', (_label) => html`
                <span class="${_label()}">
                  <div class="tooltip">
                    <div class="tooltip-inner">${i18next.t('Copy Short URL')}</div>
                    <div class="tooltip-text"><span>${i18next.t('Copy Short URL')}</span></div>
                  </div>
                </span>
              `)}
            </button>
          `)}
          ${_shareList('shareItem', (_shareItem) => html`
            <button class="${_shareItem()}" data-copy="true" data-type="copy-embed" aria-label="Copy Embed">
              ${_shareItem('icon', (_icon) => html`
                <span class="${_icon()}">
                  <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.927734 0.920056L1.72773 0.120056H11.7277L12.5277 0.920056V2.82276H14.455L15.255 3.62276V15.3345L14.455 16.1345H4.45503L3.65503 15.3345V13.4318H1.72773L0.927734 12.6318V0.920056ZM3.65503 11.8318V3.62276L4.45503 2.82276H10.9277V1.72006H2.52773V11.8318H3.65503ZM5.25503 14.5345V4.42276H13.655V14.5345H5.25503Z" fill="black"/>
                  </svg>
                </span>
              `)}
              ${_shareItem('label', (_label) => html`
                <span class="${_label()}">
                  <div class="tooltip">
                    <div class="tooltip-inner">${i18next.t('Copy Embed URL')}</div>
                    <div class="tooltip-text"><span>${i18next.t('Copy Embed URL')}</span></div>
                  </div>
                </span>
              `)}
            </button>
          `)}
        </div>
      `)}

      ${_inner('modePopup', (_modePopup) => html`
        <div id="share-select-mode-popup" class="${_modePopup()} ${modePopupVisibled ? 'expanded' : ''}" tabindex="0">
          <div class="popup-content">
            <div class="mode-container">
              <div class="search-wrapper ${modePopupSearchIsFocus ? 'active' : ''}" style="display: none;">
                <label class="search-icon" for="mode-filter">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.3831 17.0676L12.4362 12.1208M14.3154 7.5C14.3154 11.0899 11.4053 14 7.81543 14C4.22558 14 1.31543 11.0898 1.31543 7.5C1.31543 3.91015 4.22558 0.999999 7.81543 1C11.4053 1 14.3154 3.91015 14.3154 7.5Z" stroke="black" stroke-width="1.6"/>
                  </svg>
                </label>
                <div class="filter-container">
                  <input aria-hidden="true" tabindex="-1" class="filter mode-filter" placeholder="${i18next.t('Search')}" />
                </div>
              </div>
              <ul class="mode-list notranslate" role="menu">
                ${visibleModeOptions.map(item => html`
                  <li
                    class=${`mode-item ${selectedModeOption.value === item.value ? 'active' : ''}`}
                    style=${(modePopupSearchList.length === 0 || modePopupSearchList.includes(item.label)) ? '' : 'display: none;'}
                    data-value=${item.value}
                    role="menuitem"
                  >
                    <button
                      aria-label="${item.label}"
                    >
                      <span>${item.label}</span>
                      ${selectedModeOption.value === item.value ? html`
                        <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                          <path d="M1 10L5.70769 16L16 1" stroke="black" stroke-width="1.6" stroke-linejoin="bevel"/>
                        </svg>
                      ` : ''}
                    </button>
                  </li>
                `)}
              </ul>
            </div>
          </div>
        </div>
      `)}
    </div>
  `)}
</div>
<div class="popup_overlay"></div>
`;
}());

;
(function () {
  var html = window.litHTML.html;
  // NOTE: add .notranslate to language name tooltip
  iorad.player.templates.layout_media = ({
    videoDisabled,
    videoUnchangeable,
    videoChecked,
    videoHidden,

    voiceoverDisabled,
    voiceoverUnchangeable,
    voiceoverChecked,
    voiceoverHidden,

    transcriptionDisabled,
    transcriptionChecked,
    transcriptionHidden,

    musicDisabled,
    musicChecked,
    musicHidden,

    languageDisabled,
    languageName,
    languageHidden,

    stepDisabled,
    stepChecked,
    stepHidden,

    showFromAdvanced,
  }) => html`
<button class="close-popup-banner close-media-popup" aria-label="${showFromAdvanced ? 'Back' : 'Close'}">
  <div class="close-info">
    <span class="close-name">Settings</span>
  </div>
  ${showFromAdvanced ? html`
    <span class="close-text-hover">Back</span>
    <div class="close-back-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="9" height="15" viewBox="0 0 9 15" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.4343 0.934326L8.56567 2.0657L3.13136 7.50001L8.56567 12.9343L7.4343 14.0657L0.868617 7.50001L7.4343 0.934326Z" fill="black"/>
      </svg>
    </div>
  ` : html`
    <span class="close-text-hover">Close</span>
    <div class="close-close-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
        <rect x="22.75" y="20.75" width="10.5" height="14.5" stroke="black" stroke-width="1.5"/>
      </svg>
    </div>
  `}
</button>
<div class="popup-content media-container" aria-label="Settings">
  <div class="media-inner">
    <button
      aria-label="Select language, current: ${languageName}"
      aria-haspopup="true"
      aria-controls="language"
      class="media-item ${languageHidden ? 'unselectable' : ''} ${languageDisabled ? 'disabled' : ''}" data-type="language">
      <span class="media-icon">
        <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M9.77251 0V0.990698H5.70764V2.5907H7.43959C7.58021 3.35629 7.8513 4.28942 8.18721 5.18404C8.54445 6.13545 9.00952 7.13686 9.5375 7.90256C8.824 8.6757 7.99463 9.35749 7.36084 9.82368L5.78926 5.09831L5.03014 4.55078H3.96238L3.20327 5.09831L0 14.7298H1.70764L2.58184 12.0367H6.41069L7.06365 14L7.31702 14.7298H8.99252L7.8889 11.4114C8.58517 10.933 9.65229 10.1079 10.5908 9.11843C11.6743 10.229 12.4758 10.8127 13.1472 11.3016L13.1473 11.3016C13.3058 11.4171 13.4571 11.5272 13.6031 11.6378L14.569 10.3622C14.4075 10.24 14.2463 10.1224 14.0819 10.0026C13.3966 9.5029 12.6559 8.96293 11.6105 7.87148C12.1414 7.09124 12.6275 6.13491 13.0134 5.19672C13.3777 4.31068 13.6742 3.38842 13.8311 2.5907H15.7076V0.990698H13.1401H11.3725V0H9.77251ZM9.6851 4.62161C9.4097 3.88814 9.19872 3.1719 9.07148 2.5907H10.5725H12.194C12.0539 3.18036 11.8267 3.87549 11.5336 4.58816C11.2475 5.28389 10.9136 5.95969 10.5664 6.53554C10.2557 5.99683 9.95085 5.32937 9.6851 4.62161ZM4.49626 6.28049L5.87855 10.4367H3.11397L4.49626 6.28049Z" fill="black"></path>
        </svg>
      </span>
      <span class="media-label">
        <div class="tooltip">
          <div class="tooltip-inner">${languageName}</div>
          <div class="tooltip-text notranslate"><span>${languageName}</span></div>
        </div>
      </span>
      <span class="media-button language">
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="14" viewBox="0 0 9 14" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M1.56568 13.5657L0.434311 12.4343L5.86863 6.99999L0.43431 1.56567L1.56568 0.434303L8.13137 6.99999L1.56568 13.5657Z" fill="black"/>
        </svg>
      </span>
    </button>
    <label
      for="settings-media-step-text"
      class="media-item ${stepHidden ? 'hidden' : ''} ${stepDisabled ? 'disabled' : ''} ${stepChecked ? 'checked' : ''}" data-type="step">
      <span class="media-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5 14.3H0.5V12.7H12.5V14.3Z" fill="black"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M8.5 9.30001H0.5V7.70001H8.5V9.30001Z" fill="black"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M16.5 4.30001H0.5V2.70001H16.5V4.30001Z" fill="black"/>
        </svg>
      </span>
      <span class="media-label">
        <div class="tooltip">
          <div class="tooltip-inner">${i18next.t('Step Text')}</div>
          <div class="tooltip-text"><span>${i18next.t('Step Text')}</span></div>
        </div>
      </span>
      <span class="media-checkbox">
        <input aria-label="Click to ${stepChecked ? 'disable' : 'enable'} step text" id="settings-media-step-text" class="checkbox-input" type="checkbox" .checked=${stepChecked} />
        <span class="checkbox-default"></span>
        <svg class="checkbox-checked" xmlns="http://www.w3.org/2000/svg" width="11" height="9" viewBox="0 0 11 9" fill="none">
          <path d="M1.5 5.3L4.01077 8.5L9.5 0.5" stroke="black" stroke-width="1.6" stroke-linejoin="bevel"/>
        </svg>
      </span>
    </label>
    <label
      for="settings-media-video"
      class="media-item ${videoHidden ? 'unselectable' : ''} ${videoDisabled ? 'disabled' : ''} ${(videoUnchangeable) ? 'unchangeable' : ''} ${videoChecked ? 'checked' : ''}" data-type="video">
      <span class="media-icon">
        <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M17.6866 2.99419L0.186638 4.10376L0 1.10957L17.5 0L17.5933 1.49709L17.6866 2.99419Z" fill="black" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M18.0317 4.09722V15.3L17.2317 16.1H0.980249L0.18025 15.3L0.18025 4.09722L18.0317 4.09722ZM16.4317 5.69722L1.78025 5.69722V14.5L16.4317 14.5V5.69722Z"
            fill="black" />
          <path d="M6.99326 6.59722L11.8892 9.69403L7.01676 13.0037L6.99326 6.59722Z" fill="black" />
        </svg>
      </span>
      <span class="media-label">
        <div class="tooltip">
          <div class="tooltip-inner">${i18next.t('Video')}</div>
          <div class="tooltip-text"><span>${i18next.t('Video')}</span></div>
        </div>
      </span>
      <span class="media-checkbox">
        <input aria-label="Click to ${videoChecked ? 'disable' : 'enable'} video" id="settings-media-video" class="checkbox-input" type="checkbox" .checked=${videoChecked} />
        <span class="checkbox-default"></span>
        <svg class="checkbox-checked" xmlns="http://www.w3.org/2000/svg" width="11" height="9" viewBox="0 0 11 9"
          fill="none">
          <path d="M1.5 5.3L4.01077 8.5L9.5 0.5" stroke="black" stroke-width="1.6" stroke-linejoin="bevel" />
        </svg>
      </span>
    </label>
    <label
      for="settings-media-voiceover"
      class="media-item ${voiceoverHidden ? 'unselectable' : ''} ${voiceoverDisabled ? 'disabled' : ''} ${(voiceoverUnchangeable) ? 'unchangeable' : ''} ${voiceoverChecked ? 'checked' : ''}" data-type="voiceover">
      <span class="media-icon">
        <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 2V16" stroke="black" stroke-width="1.6" stroke-linejoin="round"/>
          <path d="M9 17V1L4.5 6H1V12.5H4.5L9 17Z" stroke="black" stroke-width="1.6" stroke-linejoin="bevel"/>
          <path d="M12 5V13" stroke="black" stroke-width="1.6" stroke-linejoin="round"/>
        </svg>
      </span>
      <span class="media-label">
        <div class="tooltip">
          <div class="tooltip-inner">${i18next.t('Voiceover')}</div>
          <div class="tooltip-text"><span>${i18next.t('Voiceover')}</span></div>
        </div>
      </span>
      <span class="media-checkbox">
        <input aria-label="Click to ${voiceoverChecked ? 'disable' : 'enable'} VoiceOver" id="settings-media-voiceover" class="checkbox-input" type="checkbox" .checked=${voiceoverChecked} />
        <span class="checkbox-default"></span>
        <svg class="checkbox-checked" xmlns="http://www.w3.org/2000/svg" width="11" height="9" viewBox="0 0 11 9" fill="none">
          <path d="M1.5 5.3L4.01077 8.5L9.5 0.5" stroke="black" stroke-width="1.6" stroke-linejoin="bevel"/>
        </svg>
      </span>
    </label>
    <label
      for="settings-media-cc"
      class="media-item ${transcriptionHidden ? 'unselectable' : ''} ${transcriptionDisabled ? 'disabled' : ''} ${transcriptionChecked ? 'checked' : ''}" data-type="transcription">
      <span class="media-icon">
        <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0.8L0.8 0H20.8L21.6 0.8V14.8L20.8 15.6H10.8006L10.8001 14H20V1.6H1.6V14H10.8001L10.8006 15.6H0.8L0 14.8V0.8Z" fill="black"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M6.89279 6.6C6.14422 6.6 5.6 7.17106 5.6 7.8C5.6 8.42894 6.14422 9 6.89279 9C7.43563 9 7.88244 8.69246 8.07713 8.28182L9.52287 8.96728C9.06021 9.94309 8.04633 10.6 6.89279 10.6C5.32972 10.6 4 9.3802 4 7.8C4 6.2198 5.32972 5 6.89279 5C8.01394 5 9.0025 5.62033 9.48211 6.55034L8.06007 7.28369C7.85716 6.89022 7.41994 6.6 6.89279 6.6Z" fill="black"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8928 6.6C14.1442 6.6 13.6 7.17106 13.6 7.8C13.6 8.42894 14.1442 9 14.8928 9C15.4356 9 15.8824 8.69246 16.0771 8.28182L17.5229 8.96728C17.0602 9.94309 16.0463 10.6 14.8928 10.6C13.3297 10.6 12 9.3802 12 7.8C12 6.2198 13.3297 5 14.8928 5C16.0139 5 17.0025 5.62033 17.4821 6.55034L16.0601 7.28369C15.8572 6.89022 15.4199 6.6 14.8928 6.6Z" fill="black"/>
        </svg>
      </span>
      <span class="media-label">
        <div class="tooltip">
          <div class="tooltip-inner">${i18next.t('Closed Captions')}</div>
          <div class="tooltip-text"><span>${i18next.t('Closed Captions')}</span></div>
        </div>
      </span>
      <span class="media-checkbox">
        <input aria-label="Click to ${transcriptionChecked ? 'disable' : 'enable'} Closed Captions" id="settings-media-cc" class="checkbox-input" type="checkbox" .checked=${transcriptionChecked} />
        <span class="checkbox-default"></span>
        <svg class="checkbox-checked" xmlns="http://www.w3.org/2000/svg" width="11" height="9" viewBox="0 0 11 9" fill="none">
          <path d="M1.5 5.3L4.01077 8.5L9.5 0.5" stroke="black" stroke-width="1.6" stroke-linejoin="bevel"/>
        </svg>
      </span>
    </label>
    <label
      for="settings-media-music"
      class="media-item ${musicHidden ? 'unselectable' : ''} ${musicDisabled ? 'disabled' : ''} ${musicChecked ? 'checked' : ''}" data-type="music">
      <span class="media-icon">
        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.59998 0.990725L12.9999 3.49999L13.4999 4.99999V14.4375C13.4999 14.457 13.4999 14.8223 13.4999 15C13.4999 16.1046 12.2568 17 10.5999 17C8.94309 17 7.59995 16.1046 7.59995 15C7.59995 13.8954 8.94309 13 10.5999 13C11.321 13 11.9826 13.1696 12.4999 13.4521V5.99998L7 3.49072V11.4907C7 12.5953 5.65685 13.4907 4 13.4907C2.34315 13.4907 1 12.5953 1 11.4907C1 10.3862 2.34315 9.49072 4 9.49072C4.76835 9.49072 5.46924 9.68329 6 9.99998V1.99072L7.59998 0.990725Z" fill="black" />
        </svg>
      </span>
      <span class="media-label">
        <div class="tooltip">
          <div class="tooltip-inner">${i18next.t('Music')}</div>
          <div class="tooltip-text"><span>${i18next.t('Music')}</span></div>
        </div>
      </span>
      <span class="media-checkbox">
        <input aria-label="Click to ${musicChecked ? 'disable' : 'enable'} music" id="settings-media-music" class="checkbox-input" type="checkbox" .checked=${musicChecked} />
        <span class="checkbox-default"></span>
        <svg class="checkbox-checked" xmlns="http://www.w3.org/2000/svg" width="11" height="9" viewBox="0 0 11 9" fill="none">
          <path d="M1.5 5.3L4.01077 8.5L9.5 0.5" stroke="black" stroke-width="1.6" stroke-linejoin="bevel"/>
        </svg>
      </span>
    </label>
  </div>
</div>
<div class="popup_overlay"></div>
`;
}());

;
(function () {
  const html = window.litHTML.html;
  iorad.player.templates.layout_steps = ({
    steps,
    copyLinkIsHidden,
  }) => html`
<button class="close-popup-banner close-steps-popup aria-label="Close">
  <div class="close-info">
    <span class="close-name">Navigator</span>
  </div>
  <span class="close-text-hover">Close</span>
  <div class="close-close-icon">
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.38281 1L13.3828 13M1.38281 13L13.3828 1" stroke="black" stroke-width="1.6"/>
    </svg>
  </div>
</button>
<div class="popup-content">
  <div class="popup_steps_list ${copyLinkIsHidden ? 'copy-link-hidden' : ''}">
    ${steps.map(step => html`
      <div
        class=${`popup_steps_item ${step.active ? 'active' : ''}`}
      >
        <div class="popup_steps_item_title">
          <a href="#" aria-label="Go to ${step.title}">${step.title}</a>
          ${step.active ? html`
            <div class="popup_steps_item_checked_icon">
              <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 10L5.70769 16L16 1" stroke="black" stroke-width="1.6" stroke-linejoin="bevel"/>
              </svg>
            </div>
          ` : ''}
          ${(step.index && !copyLinkIsHidden) ? html`
            <button
              aria-label="Copy link to ${step.title}"
              class="popup_steps_item_copy_link_btn" data-index="${step.index}"
            >
              <svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.6833 0H5.35193L5.11762 0.234315L3.61762 1.73431L3.3833 1.96863V2.3V3H2.6833H2.35193L2.11762 3.23431L0.617615 4.73431L0.383301 4.96863V5.3V8.3V8.63137L0.617615 8.86569L2.11762 10.3657L2.35193 10.6H2.6833H10.6833H11.0147L11.249 10.3657L12.749 8.86569L12.9833 8.63137V8.3V7.6H13.6833H14.0147L14.249 7.36569L15.749 5.86569L15.9833 5.63137V5.3V1.8V1.37185L15.6271 1.13436L14.1271 0.13436L13.9255 0H13.6833H5.6833ZM12.9833 6H13.3519L14.3833 4.96863V2.22815L13.4411 1.6H6.01467L4.9833 2.63137V3H10.6833H10.9255L11.1271 3.13436L12.6271 4.13436L12.9833 4.37185V4.8V6ZM4.9833 4.6H10.4411L11.3833 5.22815V6H6.01467L4.9833 4.96863V4.6ZM3.3833 4.6V5.3V5.63137L3.61762 5.86569L5.11762 7.36569L5.35193 7.6H5.6833H11.3833V7.96863L10.3519 9H3.01467L1.9833 7.96863V5.63137L3.01467 4.6H3.3833Z" fill="#BABABA"/>
              </svg>
            </button>
          `: ''}
        </div>
        <div class="popup_steps_item_text">${step.text}</div>
      </div>
    `)}
  </div>
</div>
<div class="popup_overlay"></div>
<!-- <div class="popup_steps_search">
  <input type="text" placeholder="Search" />
</div> -->
`;
}());

;
(function () {
  const html = window.litHTML.html;
  iorad.player.templates.layout_export = ({
    isPrintLandscapeDisabled,
    isPrintPortraitDisabled,
    isPrintingLandscape,
    isPrintingPortrait,
    showFromAdvanced,
  }) => html`
<button class="close-popup-banner close-export-popup" aria-label="${showFromAdvanced ? 'Back' : 'Close'}">
  <div class="close-info">
    <span class="close-name">Download PDF</span>
  </div>
  ${showFromAdvanced ? html`
    <span class="close-text-hover">Back</span>
    <div class="close-back-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="9" height="15" viewBox="0 0 9 15" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.4343 0.934326L8.56567 2.0657L3.13136 7.50001L8.56567 12.9343L7.4343 14.0657L0.868617 7.50001L7.4343 0.934326Z" fill="black"/>
      </svg>
    </div>
  ` : html`
    <span class="close-text-hover">Close</span>
    <div class="close-close-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
        <rect x="22.75" y="20.75" width="10.5" height="14.5" stroke="black" stroke-width="1.5"/>
      </svg>
    </div>
  `}
</button>
<div class="popup-content">
  <div class="print-container">
    ${!isPrintPortraitDisabled
      ? html`<button aria-label="Download Portrait PDF" class=${`print-button print-portrait ${isPrintingPortrait ? 'loading' : ''}`}>
        <div class="print-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
            <rect x="22.75" y="20.75" width="10.5" height="14.5" stroke="black" stroke-width="1.5"/>
          </svg>
        </div>
        <span class="print-text">
          <div class="tooltip">
            <div class="tooltip-inner">${i18next.t('Portrait')}</div>
            <div class="tooltip-text"><span>${i18next.t('Portrait')}</span></div>
          </div>
        </span>
        <span class="print-text-loading">${i18next.t('Generating...')}</span>
      </button>`
      : ''
    }

    ${!isPrintLandscapeDisabled
      ? html`<button aria-label="Download Landscape PDF" class=${`print-button print-landscape ${isPrintingLandscape ? 'loading' : ''}`}>
        <div class="print-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
            <rect x="35.25" y="22.75" width="10.5" height="14.5" transform="rotate(90 35.25 22.75)" stroke="black" stroke-width="1.5"/>
          </svg>
        </div>
        <span class="print-text">
          <div class="tooltip">
            <div class="tooltip-inner">${i18next.t('Landscape')}</div>
            <div class="tooltip-text"><span>${i18next.t('Landscape')}</span></div>
          </div>
        </span>
        <span class="print-text-loading">${i18next.t('Generating...')}</span>
      </button>`
      : ''
    }
  </div>
</div>
<div class="popup_overlay"></div>
`;
}());

;
(function () {
  const html = window.litHTML.html;
  iorad.player.templates.layout_advanced = ({
    isSelectorBtnHidden,
    selectorActiveItem,

    isExportBtnHidden,
    isSettingBtnHidden,
    isShareBtnHidden,
    isCommentsBtnHidden,
  }) => html`
<button class="close-popup-banner close-advanced-popup" aria-label="Close">
  <div class="close-info">
    <span class="close-name">Advanced</span>
  </div>
  <span class="close-text-hover">Close</span>
  <div class="close-close-icon">
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.38281 1L13.3828 13M1.38281 13L13.3828 1" stroke="black" stroke-width="1.6"/>
    </svg>
  </div>
</button>
<div class="popup-content advanced-container">
  <div class="advanced-buttons">
    ${!isSelectorBtnHidden ? html`
      <div class="advanced-button selector-btn">
        ${selectorActiveItem.icon}
        <span>${selectorActiveItem.shortText}</span>
      </div>
    ` : ''}
    ${!isExportBtnHidden ? html`
      <button class="advanced-button download-btn" aria-label="Download PDF">
        <svg width="27" height="18" viewBox="0 0 27 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18.2773 8L13.2773 13M13.2773 13L8.27734 8M13.2773 13L13.2773 0M5.27734 16H21.2773" stroke="black" stroke-width="1.6"/>
        </svg>
        <span>
          <div class="tooltip">
            <div class="tooltip-inner">Download PDF</div>
            <div class="tooltip-text"><span>Download PDF</span></div>
          </div>
        </span>
      </button>
    ` : ''}
    ${!isSettingBtnHidden ? html`
      <button class="advanced-button settings-btn" aria-label="Settings">
        <svg width="27" height="18" viewBox="0 0 27 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.0576 10.3991L19.2325 9.57399V8.28251L20.0935 7.4574H21.2773C21.0621 6.30942 20.5957 5.26906 19.9859 4.3722L19.089 5.26906H17.9051L17.0083 4.3722L17.0442 3.15247L17.9051 2.29148C16.9724 1.64574 15.8603 1.17937 14.7123 1L14.7482 1.03587V2.32735L13.9231 3.15247H12.6316L11.7347 2.21973V1C10.6226 1.21525 9.58228 1.64574 8.64954 2.29148L9.58228 3.15247V4.33632L8.68542 5.23318H7.50156L6.56882 4.33632C5.95896 5.26906 5.49259 6.34529 5.27734 7.49327H6.49707L7.32219 8.31839V9.60987L6.49707 10.435H5.27734C5.49259 11.583 5.95896 12.6592 6.6047 13.5919L7.42981 12.8027H8.61367L9.51053 13.6996V14.8834L8.68542 15.7085C9.61815 16.3184 10.6585 16.7848 11.7706 16.9641V15.8161L12.5957 14.991H13.8872L14.7123 15.8161V16.9641C15.8962 16.7489 16.9724 16.2825 17.9051 15.6368L17.1159 14.7758V13.5919L18.0128 12.6951L19.2325 12.7309L20.0217 13.5202C20.6316 12.5874 21.098 11.5471 21.2773 10.3991H20.0576ZM13.2773 12.5157C11.3042 12.5157 9.72577 10.9372 9.72577 8.96412C9.72577 6.99103 11.3042 5.41256 13.2773 5.41256C15.2504 5.41256 16.8289 6.99103 16.8289 8.96412C16.8289 10.9372 15.2504 12.5157 13.2773 12.5157Z" fill="black"/>
        </svg>
        <span>
          <div class="tooltip">
            <div class="tooltip-inner">Settings</div>
            <div class="tooltip-text"><span>Settings</span></div>
          </div>
        </span>
      </button>
    ` : ''}
    ${!isShareBtnHidden ? html`
      <button class="advanced-button share-btn" aria-label="Share">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16 3C16 4.65685 14.6569 6 13 6C11.3431 6 10 4.65685 10 3C10 1.34315 11.3431 0 13 0C14.6569 0 16 1.34315 16 3Z" fill="black"></path>
          <path d="M16 13C16 14.6569 14.6569 16 13 16C11.3431 16 10 14.6569 10 13C10 11.3431 11.3431 10 13 10C14.6569 10 16 11.3431 16 13Z" fill="black"></path>
          <path d="M6 8C6 9.65685 4.65685 11 3 11C1.34315 11 0 9.65685 0 8C0 6.34315 1.34315 5 3 5C4.65685 5 6 6.34315 6 8Z" fill="black"></path>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M12.7764 2.55279L13.2236 3.44721L4.11803 8L13.2236 12.5528L12.7764 13.4472L1.88197 8L12.7764 2.55279Z" fill="black"></path>
        </svg>
        <span>
          <div class="tooltip">
            <div class="tooltip-inner">Share</div>
            <div class="tooltip-text"><span>Share</span></div>
          </div>
        </span>
      </button>
    ` : ''}
    ${!isCommentsBtnHidden ? html`
      <button class="advanced-button comments-btn" aria-label="Comments">
        <svg width="27" height="18" viewBox="0 0 27 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.27734 1H9.27734H13.2773H21.2773V10.931H18.7773V16.2586L14.2773 10.931H5.27734V5.96552V3.48276V1Z" stroke="black" stroke-width="1.6" stroke-linejoin="bevel"/>
        </svg>
        <span>
          <div class="tooltip">
            <div class="tooltip-inner">Comments</div>
            <div class="tooltip-text"><span>Comments</span></div>
          </div>
        </span>
      </button>
    ` : ''}
  </div>
</div>
<div class="popup_overlay"></div>
`;
}());

;
(function () {
  const html = window.litHTML.html;
  iorad.player.templates.layout_selector = ({
    items,
    activeTab,
    copyLinkIsHidden,
    showFromAdvanced,
  }) => html`
<button class="close-popup-banner close-selector-popup" aria-label="${showFromAdvanced ? 'Back' : 'Close'}">
  <div class="close-info">
    <span class="close-name">Player Modes</span>
  </div>
  ${showFromAdvanced ? html`
    <span class="close-text-hover">Back</span>
    <div class="close-back-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="9" height="15" viewBox="0 0 9 15" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.4343 0.934326L8.56567 2.0657L3.13136 7.50001L8.56567 12.9343L7.4343 14.0657L0.868617 7.50001L7.4343 0.934326Z" fill="black"/>
      </svg>
    </div>
  ` : html`
    <span class="close-text-hover">Close</span>
    <div class="close-close-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
        <rect x="22.75" y="20.75" width="10.5" height="14.5" stroke="black" stroke-width="1.5"/>
      </svg>
    </div>
  `}
</button>
<div class="popup-content">
  <ul class="mode-list ${copyLinkIsHidden ? 'copy-link-hidden' : ''}" role="menu">
    ${items.map((item) => html`
        <li
          role="menuitem"
          class=${`mode-item ${item.id === activeTab ? 'active' : ''} ${item.className || item.id}`}
        >
          <a
            role="button"
            href=${item.href}
            class="text-btn"
            aria-label="${item.text}"
          >
            <div class="name-wrapper">
              <div class="name-icon">${item.icon}</div>
              <div class="name">
                <div class="tooltip">
                  <div class="tooltip-inner">${item.text}</div>
                  <div class="tooltip-text"><span>${item.text}</span></div>
                </div>
              </div>
              ${(!copyLinkIsHidden) ? html`
                <div class="copy_link_btn" data-item-id=${item.id}>
                  <svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.6833 0H5.35193L5.11762 0.234315L3.61762 1.73431L3.3833 1.96863V2.3V3H2.6833H2.35193L2.11762 3.23431L0.617615 4.73431L0.383301 4.96863V5.3V8.3V8.63137L0.617615 8.86569L2.11762 10.3657L2.35193 10.6H2.6833H10.6833H11.0147L11.249 10.3657L12.749 8.86569L12.9833 8.63137V8.3V7.6H13.6833H14.0147L14.249 7.36569L15.749 5.86569L15.9833 5.63137V5.3V1.8V1.37185L15.6271 1.13436L14.1271 0.13436L13.9255 0H13.6833H5.6833ZM12.9833 6H13.3519L14.3833 4.96863V2.22815L13.4411 1.6H6.01467L4.9833 2.63137V3H10.6833H10.9255L11.1271 3.13436L12.6271 4.13436L12.9833 4.37185V4.8V6ZM4.9833 4.6H10.4411L11.3833 5.22815V6H6.01467L4.9833 4.96863V4.6ZM3.3833 4.6V5.3V5.63137L3.61762 5.86569L5.11762 7.36569L5.35193 7.6H5.6833H11.3833V7.96863L10.3519 9H3.01467L1.9833 7.96863V5.63137L3.01467 4.6H3.3833Z" fill="#BABABA"/>
                  </svg>
                </div>
              `: ''}
              <div class="checked-icon">
                <svg
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 10L5.70769 16L16 1"
                    stroke="black"
                    stroke-width="1.6"
                    stroke-linejoin="bevel"
                  />
                </svg>
              </div>
            </div>
          </a>
        </li>
    `)}
  </ul>
</div>
<div class="popup_overlay"></div>
`;
})();

;
iorad.player.templates.layout_offline_cache_overlay = "<div class=\"offline-cache-overlay-inner\">\n  <div class=\"offline-cache-overlay-text\">\n    Your last save might have been interrupted. Try again?\n  </div>\n  <div class=\"offline-cache-overlay-buttons\">\n    <button class=\"theme-v1-Button save-changes\">Save changes</button>\n    <button class=\"theme-v1-Button theme-v1-Button_alternate ignore-changes\">Ignore</button>\n  </div>\n</div>\n";
;
iorad.player.templates.layout_recommended_tutorials = "<div class=\"recommended-tutorials_inner\">\n  <div class=\"recommended-tutorials-section recommended_block {{#shouldHideRecommendedBlock}}hide{{/shouldHideRecommendedBlock}}\">\n    {{#recommendedListIsNonEmpty}}\n      <div class=\"recommended-tutorials_list\">\n        <div class=\"recommended-tutorials_list_label\">\n          Recommended Tutorials\n        </div>\n        <ul class=\"recommended-tutorials_list_ul\">\n          {{#recommendedList}}\n            <li class=\"recommended-tutorials_list_ul_li\" data-id=\"{{id}}\" role=\"button\" tabindex=\"0\">\n              <span>{{name}}</span>\n              <svg width=\"9\" height=\"14\" viewBox=\"0 0 9 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.56594 13.5657L0.43457 12.4343L5.86888 6.99999L0.43457 1.56567L1.56594 0.434303L8.13163 6.99999L1.56594 13.5657Z\" fill=\"black\"/>\n              </svg>\n            </li>\n          {{/recommendedList}}\n        </ul>\n      </div>\n    {{/recommendedListIsNonEmpty}}\n    {{^recommendedListIsNonEmpty}}\n      {{#isCustomPreviewMode}}\n        <div class=\"recommended-tutorials_list\">\n          <div class=\"recommended-tutorials_list_label\">\n            Recommended Tutorials\n          </div>\n          <div class=\"recommended-tutorials_list-empty\">\n            No recommended tutorials here yet. Choose 3 from the sidebar list\n          </div>\n        </div>\n      {{/isCustomPreviewMode}}\n    {{/recommendedListIsNonEmpty}}\n  </div>\n\n  <div class=\"recommended-tutorials-section share_block\">\n    {{#isShareVisible}}\n      <div class=\"recommended-tutorials_share\">\n        <div class=\"recommended-tutorials_share_title\">\n          Share This Tutorial\n        </div>\n        <div class=\"recommended-tutorials_share_button copy-url\" {{^isCopyLinkVisible}}style=\"display: none;\"{{/isCopyLinkVisible}}>\n          <svg width=\"17\" height=\"18\" viewBox=\"0 0 17 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.927734 0.920056L1.72773 0.120056H11.7277L12.5277 0.920056V2.82276H14.455L15.255 3.62276V15.3345L14.455 16.1345H4.45503L3.65503 15.3345V13.4318H1.72773L0.927734 12.6318V0.920056ZM3.65503 11.8318V3.62276L4.45503 2.82276H10.9277V1.72006H2.52773V11.8318H3.65503ZM5.25503 14.5345V4.42276H13.655V14.5345H5.25503Z\" fill=\"black\"/>\n          </svg>\n          <span>Copy URL</span>\n        </div>\n        <div class=\"recommended-tutorials_share_button copy-embed\" {{^isCopyEmbedVisible}}style=\"display: none;\"{{/isCopyEmbedVisible}}>\n          <svg width=\"17\" height=\"18\" viewBox=\"0 0 17 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.927734 0.920056L1.72773 0.120056H11.7277L12.5277 0.920056V2.82276H14.455L15.255 3.62276V15.3345L14.455 16.1345H4.45503L3.65503 15.3345V13.4318H1.72773L0.927734 12.6318V0.920056ZM3.65503 11.8318V3.62276L4.45503 2.82276H10.9277V1.72006H2.52773V11.8318H3.65503ZM5.25503 14.5345V4.42276H13.655V14.5345H5.25503Z\" fill=\"black\"/>\n          </svg>\n          <span>Copy Embed</span>\n        </div>\n      </div>\n    {{/isShareVisible}}\n    {{#isCaptureVisible}}\n      <div class=\"recommended-tutorials_capture\">\n        <div class=\"recommended-tutorials_capture_title\">\n          Share your knowledge\n        </div>\n        <div class=\"recommended-tutorials_capture_button\">\n          <svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n            <path d=\"M0 8H16\" stroke=\"black\" stroke-width=\"1.6\"/>\n            <path d=\"M8 0L8 16\" stroke=\"black\" stroke-width=\"1.6\"/>\n          </svg>\n          <span>Capture Tutorial</span>\n        </div>\n      </div>\n    {{/isCaptureVisible}}\n  </div>\n</div>\n";
;
(function () {
  const html = window.litHTML.html;
  iorad.player.templates.layout_playbar = ({
    isSelectorBtnDisabled,
    isSelectorBtnHidden,

    isExportBtnDisabled,
    isExportBtnHidden,

    isWatchModeSpeedBtnDisabled,
    isWatchModeSpeedBtnHidden,
    watchModeSpeedText,
    watchModeSpeedHref,

    isStepProgressBtnDisabled,
    isStepProgressBtnHidden,
    showStepProgressPlay,
    isStepProgressRemainingTimeHidden,
    stepProgressRemainingTimeText,

    isReplayBtnDisabled,
    isReplayBtnHidden,

    isCoverBtnDisabled,
    isCoverBtnHidden,

    isPrevBtnDisabled,
    isPrevBtnHidden,
    isNextBtnBlink,
    isPrevBtnRotated,
    prevBtnHref,

    isNextBtnDisabled,
    isNextBtnHidden,
    isNextBtnRotated,
    nextBtnHref,
    isNextBtnShowCheckbox,

    isMuteBtnDisabled,
    isMuteBtnHidden,
    showUnmute,
    isMuteBtnUnchangeable,

    isZoomBtnDisabled,
    isZoomBtnHidden,
    showZoomIn,

    isMediaBtnHidden,
    isMediaBtnDisabled,
    isMediaBtnAudioOnly,

    isShareBtnHidden,
    isShareBtnDisabled,

    isCommentsBtnHidden,
    isCommentsBtnDisabled,
    isCommentUnseen,

    isFullscreenBtnDisabled,
    isFullscreenBtnHidden,
    isFullscreenActive,

    isFreeBtnDisabled,
    isFreeBtnHidden,
    freeBtnText,

    isFreeFaviconContainerHidden,
    isAdvancedBtnHidden,

    isFaviconBtnDisabled,
    isFaviconBtnHidden,
    faviconImageSrc,
    faviconHref,

    activeMode,
    isCoverOpen,

    currentTab
  }) => html`

<button
  aria-label="Modes"
  aria-haspopup="true"
  aria-controls="selector"
  class=${`playbar-btn selector-btn ${currentTab === 'selector' ? 'active' : ''} ${isSelectorBtnDisabled ? 'disabled' : ''}`}
  tabindex=${isSelectorBtnDisabled ? '-1' : '0'}
  style=${`${isSelectorBtnHidden ? 'display: none;' : ''}`}
  data-for="selector"
>
  ${activeMode ? html`
    <div class="mode">
      <span class="mode-icon">${activeMode.icon}</span>
      ${isCoverOpen ? html`
        <span class="mode-text">${activeMode.text}</span>
      `: ''}
    </div>
  ` : html`
    <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.59981 5.3H7.5998V4.3H2.59981V5.3Z" fill="black"/>
      <path d="M2.59981 8.3H7.5998V7.3H2.59981V8.3Z" fill="black"/>
      <path d="M2.59981 11.3H7.5998V10.3H2.59981V11.3Z" fill="black"/>
      <path d="M16.5 7.21694L12.5 4.79999L12.5192 9.79999L16.5 7.21694Z" fill="black"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0.800001 15.6H18.8L19.6 14.8L19.6 0.8L18.8 0H11.3882L10.8178 0.23913L9.8 1.2743L8.78222 0.23913L8.21177 0H0.8L0 0.8V14.8L0.800001 15.6ZM9 14V2.74279L7.87642 1.6L1.6 1.6L1.6 14L9 14ZM10.6 14L18 14L18 1.6L11.7236 1.6L10.6 2.74279V14Z" fill="black"/>
    </svg>
  `}
  <span class="button-label">${activeMode ? 'Current Mode - ' + activeMode.text : 'Mode'}</span>
</button>

<a
  aria-label="Speed"
  class=${`playbar-btn watch-mode-speed ${isWatchModeSpeedBtnDisabled ? 'disabled' : ''}`}
  tabindex=${isWatchModeSpeedBtnDisabled ? '-1' : '0'}
  style=${`${isWatchModeSpeedBtnHidden ? 'display: none;' : ''}`}
  href=${watchModeSpeedHref}
>${watchModeSpeedText}</a>

<div
  class=${`playbar-btn step-progress-block ${isStepProgressBtnDisabled ? 'disabled' : ''}`}
  style=${`${isStepProgressBtnHidden ? 'display: none;' : ''}`}
>
  <button
    tabindex=${isStepProgressBtnDisabled ? '-1' : '0'}
    aria-label=${showStepProgressPlay ? 'Play' : 'Pause'}
    class="step-progress-btn"
    style=${`${isStepProgressRemainingTimeHidden ? 'display: flex;' : ''}`}
  >
    <div class=${`step-progress-icon ${showStepProgressPlay ? 'step-progress-play' : ''}`}>
      <svg class="step-progress-play-svg" width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_355_0)">
        <path d="M14 8L-1.90735e-06 16L-5.08584e-07 -2.70244e-07L14 8Z" fill="black"/>
        </g>
        <defs>
        <clipPath id="clip0_355_0">
        <rect width="14" height="16" fill="white"/>
        </clipPath>
        </defs>
      </svg>
      <svg class="step-progress-pause-svg" width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 0V16" stroke="black" stroke-width="1.6"/>
        <path d="M1 0V16" stroke="black" stroke-width="1.6"/>
      </svg>
    </div>
  </button>
  <span
    class="step-progress-remaining-time"
    style=${`${isStepProgressRemainingTimeHidden ? 'display: none;' : ''}`}
  >${stepProgressRemainingTimeText}</span>
  <span class="button-label">${showStepProgressPlay ? 'Play' : 'Pause'}</span>
</div>

<button
  aria-label="Replay"
  class=${`playbar-btn btn replay ${isReplayBtnDisabled ? 'disabled' : ''}`}
  tabindex=${isReplayBtnDisabled ? '-1' : '0'}
  style=${`${isReplayBtnHidden ? 'display: none;' : ''}`}
  href="#"
>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M12.5343 2L15.5552 6.94311L13.0751 6.89573L13.0751 13.2L12.2751 14L6 14L6 12.4L11.4751 12.4L11.4751 6.86516L9.14985 6.82074L12.5343 2Z" fill="black"/>
    <path d="M3.02089 14L5.8946e-08 9.05689L2.48012 9.10427L2.48012 2.8L3.28012 2L9.55517 2L9.55517 3.6L4.08012 3.6L4.08012 9.13484L6.40532 9.17926L3.02089 14Z" fill="black"/>
  </svg>
  <span class="button-label">Replay</span>
</button>

<button
  aria-label="Show Cover"
  class=${`playbar-btn btn showcover ${isCoverBtnDisabled ? 'disabled' : ''}`}
  tabindex=${isCoverBtnDisabled ? '-1' : '0'}
  style=${`${isCoverBtnHidden ? 'display: none;' : ''}`}
>
  <svg width="21" height="47" viewBox="0 0 21 47" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 16.5L5.5 24L13 31.5M19 16.5L11.25 24L19 31.5M1 16V32" stroke="black" stroke-width="1.6" />
  </svg>
  <span class="button-label">Show Cover</span>
</button>

<a
  aria-label="Previous"
  class=${`playbar-btn btn prev ${isPrevBtnRotated ? 'rotated' : ''} ${isPrevBtnDisabled ? 'disabled' : ''}`}
  tabindex=${isPrevBtnDisabled ? '-1' : '0'}
  style=${`${isPrevBtnHidden ? 'display: none;' : ''}`}
  href=${prevBtnHref}
>
  <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.43432 0.434311L8.56569 1.56568L3.13137 7L8.56569 12.4343L7.43432 13.5657L0.868633 7L7.43432 0.434311Z" fill="black"/>
  </svg>
  <span class="button-label">Previous</span>
</a>

<a
  aria-label="Next"
  class=${`playbar-btn btn next ${isNextBtnRotated ? 'rotated' : ''} ${isNextBtnBlink ? 'blink' : ''} ${isNextBtnDisabled ? 'disabled' : ''} ${isNextBtnShowCheckbox ? 'checkbox' : ''}`}
  tabindex=${isNextBtnDisabled ? '-1' : '0'}
  style=${`${isNextBtnHidden ? 'display: none;' : ''}`}
  href=${nextBtnHref}
>
  ${isNextBtnShowCheckbox ? html`
    <svg class="" width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.39474 10L6.10244 16L16.3947 1" stroke="black" stroke-width="1.6" stroke-linejoin="bevel"/>
    </svg>
  ` : html`
    <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M1.56569 13.5657L0.434318 12.4343L5.86863 7L0.434318 1.56569L1.56569 0.434318L8.13137 7L1.56569 13.5657Z" fill="black"/>
    </svg>
    <span class="button-label">Next</span>
  `}
</a>

<button
  aria-label="Zoom"
  class=${`playbar-btn zoom-btn ${isZoomBtnDisabled ? 'disabled' : ''} ${showZoomIn ? 'zoom-in' : ''}`}
  tabindex=${isZoomBtnDisabled ? '-1' : '0'}
  style=${`${isZoomBtnHidden ? 'display: none;' : ''}`}
>
  <svg class="zoom-out-svg" width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 12L17 16" stroke="black" stroke-width="1.8"/>
    <circle cx="7.5" cy="7.5" r="6.7" transform="matrix(-1 0 0 1 16 0)" stroke="black" stroke-width="1.6"/>
    <rect x="-0.15" y="-0.15" width="1.3" height="7.3" transform="matrix(4.37114e-08 1 1 -4.37114e-08 5 7)" fill="black" stroke="black" stroke-width="0.3"/>
  </svg>
  <svg class="zoom-in-svg" width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.6 7.5C2.6 10.7585 5.24152 13.4 8.5 13.4C11.7585 13.4 14.4 10.7585 14.4 7.5C14.4 4.24152 11.7585 1.6 8.5 1.6C5.24152 1.6 2.6 4.24152 2.6 7.5ZM1 7.5C1 11.6421 4.35786 15 8.5 15C10.2467 15 11.854 14.4029 13.1288 13.4016L16.3636 16.6364L17.6364 15.3636L14.4016 12.1288C15.4029 10.854 16 9.24674 16 7.5C16 3.35786 12.6421 0 8.5 0C4.35786 0 1 3.35786 1 7.5Z" fill="black"/>
    <mask id="path-2-outside-1_278_111" maskUnits="userSpaceOnUse" x="4" y="3" width="9" height="9" fill="black">
    <rect fill="white" x="4" y="3" width="9" height="9"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M8 4H9V7H12V8H9V11H8V8H5V7H8V4Z"/>
    </mask>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M8 4H9V7H12V8H9V11H8V8H5V7H8V4Z" fill="black"/>
    <path d="M9 4H9.3V3.7H9V4ZM8 4V3.7H7.7V4H8ZM9 7H8.7V7.3H9V7ZM12 7H12.3V6.7H12V7ZM12 8V8.3H12.3V8H12ZM9 8V7.7H8.7V8H9ZM9 11V11.3H9.3V11H9ZM8 11H7.7V11.3H8V11ZM8 8H8.3V7.7H8V8ZM5 8H4.7V8.3H5V8ZM5 7V6.7H4.7V7H5ZM8 7V7.3H8.3V7H8ZM9 3.7H8V4.3H9V3.7ZM9.3 7V4H8.7V7H9.3ZM12 6.7H9V7.3H12V6.7ZM12.3 8V7H11.7V8H12.3ZM9 8.3H12V7.7H9V8.3ZM9.3 11V8H8.7V11H9.3ZM8 11.3H9V10.7H8V11.3ZM7.7 8V11H8.3V8H7.7ZM5 8.3H8V7.7H5V8.3ZM4.7 7V8H5.3V7H4.7ZM8 6.7H5V7.3H8V6.7ZM7.7 4V7H8.3V4H7.7Z" fill="black" mask="url(#path-2-outside-1_278_111)"/>
  </svg>
  <span class="button-label">${showZoomIn ? 'Zoom In' : 'Zoom Out'}</span>
</button>

<button
  aria-label=${showUnmute ? 'Unmute' : 'Mute'}
  class=${`playbar-btn mute-btn ${isMuteBtnDisabled ? 'disabled' : ''} ${isMuteBtnUnchangeable ? 'unchangeable' : ''}`}
  tabindex=${isMuteBtnDisabled ? '-1' : '0'}
  style=${`${isMuteBtnHidden ? 'display: none;' : ''}`}
>
  ${showUnmute ? html`
    <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 17V1L4.5 6H1V12.5H4.5L9 17Z" stroke="black" stroke-width="1.6" stroke-linejoin="bevel"/>
      <path d="M11 11.5L16 6.5" stroke="black" stroke-width="1.6" stroke-linejoin="round"/>
      <path d="M16 11.5L11 6.5" stroke="black" stroke-width="1.6" stroke-linejoin="round"/>
    </svg>
  ` : html`
    <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15 2V16" stroke="black" stroke-width="1.6" stroke-linejoin="round"/>
      <path d="M9 17V1L4.5 6H1V12.5H4.5L9 17Z" stroke="black" stroke-width="1.6" stroke-linejoin="bevel"/>
      <path d="M12 5V13" stroke="black" stroke-width="1.6" stroke-linejoin="round"/>
    </svg>
  `}
  <span class="button-label">${showUnmute ? 'Unmute' : 'Mute'}</span>
</button>

<button
  aria-label="Media"
  aria-haspopup="true"
  aria-controls="media"
  class=${`playbar-btn media-btn ${currentTab === 'media' ? 'active' : ''} ${isMediaBtnDisabled ? 'disabled' : ''} ${isMediaBtnAudioOnly ? 'audioOnly' : ''}`}
  tabindex=${isMediaBtnDisabled ? '-1' : '0'}
  style=${`${isMediaBtnHidden ? 'display: none;' : ''}`}
  data-for="media"
>
    <svg class="audio" xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
      <path d="M15.675 9.3991L14.8499 8.57399V7.28251L15.7109 6.4574H16.8948C16.6795 5.30942 16.2132 4.26906 15.6033 3.3722L14.7064 4.26906H13.5226L12.6257 3.3722L12.6616 2.15247L13.5226 1.29148C12.5898 0.64574 11.4777 0.179372 10.3298 0L10.3656 0.0358744V1.32735L9.54052 2.15247H8.24904L7.35217 1.21973V0C6.24007 0.215247 5.19971 0.64574 4.26697 1.29148L5.19971 2.15247V3.33632L4.30285 4.23318H3.11899L2.18626 3.33632C1.57639 4.26906 1.11002 5.34529 0.894775 6.49327H2.11451L2.93962 7.31839V8.60987L2.11451 9.43498H0.894775C1.11002 10.583 1.57639 11.6592 2.22213 12.5919L3.04724 11.8027H4.2311L5.12796 12.6996V13.8834L4.30285 14.7085C5.23558 15.3184 6.27594 15.7848 7.38805 15.9641V14.8161L8.21316 13.991H9.50464L10.3298 14.8161V15.9641C11.5136 15.7489 12.5898 15.2825 13.5226 14.6368L12.7333 13.7758V12.5919L13.6302 11.6951L14.8499 11.7309L15.6392 12.5202C16.249 11.5874 16.7154 10.5471 16.8948 9.3991H15.675ZM8.89478 11.5157C6.92168 11.5157 5.34321 9.93722 5.34321 7.96412C5.34321 5.99103 6.92168 4.41256 8.89478 4.41256C10.8679 4.41256 12.4463 5.99103 12.4463 7.96412C12.4463 9.93722 10.8679 11.5157 8.89478 11.5157Z" fill="black"/>
    </svg>
    <svg class="media" xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
      <path d="M15.675 9.3991L14.8499 8.57399V7.28251L15.7109 6.4574H16.8948C16.6795 5.30942 16.2132 4.26906 15.6033 3.3722L14.7064 4.26906H13.5226L12.6257 3.3722L12.6616 2.15247L13.5226 1.29148C12.5898 0.64574 11.4777 0.179372 10.3298 0L10.3656 0.0358744V1.32735L9.54052 2.15247H8.24904L7.35217 1.21973V0C6.24007 0.215247 5.19971 0.64574 4.26697 1.29148L5.19971 2.15247V3.33632L4.30285 4.23318H3.11899L2.18626 3.33632C1.57639 4.26906 1.11002 5.34529 0.894775 6.49327H2.11451L2.93962 7.31839V8.60987L2.11451 9.43498H0.894775C1.11002 10.583 1.57639 11.6592 2.22213 12.5919L3.04724 11.8027H4.2311L5.12796 12.6996V13.8834L4.30285 14.7085C5.23558 15.3184 6.27594 15.7848 7.38805 15.9641V14.8161L8.21316 13.991H9.50464L10.3298 14.8161V15.9641C11.5136 15.7489 12.5898 15.2825 13.5226 14.6368L12.7333 13.7758V12.5919L13.6302 11.6951L14.8499 11.7309L15.6392 12.5202C16.249 11.5874 16.7154 10.5471 16.8948 9.3991H15.675ZM8.89478 11.5157C6.92168 11.5157 5.34321 9.93722 5.34321 7.96412C5.34321 5.99103 6.92168 4.41256 8.89478 4.41256C10.8679 4.41256 12.4463 5.99103 12.4463 7.96412C12.4463 9.93722 10.8679 11.5157 8.89478 11.5157Z" fill="black"/>
    </svg>
  <span class="button-label">Settings</span>
</button>

<button
  aria-label="Export"
  aria-haspopup="true"
  aria-controls="export"
  class=${`playbar-btn export-btn ${currentTab === 'pdf' ? 'active' : ''} ${isExportBtnDisabled ? 'disabled' : ''}`}
  tabindex=${isExportBtnDisabled ? '-1' : '0'}
  style=${`${isExportBtnHidden ? 'display: none;' : ''}`}
  data-for="export"
>
  <svg width="27" height="34" viewBox="0 0 27 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.6448 16L13.6448 21M13.6448 21L8.64478 16M13.6448 21L13.6448 8M5.64478 24H21.6448" stroke="black" stroke-width="1.6"/>
  </svg>
  <span class="button-label">Download PDF</span>
</button>

<button
  aria-label="Share"
  aria-haspopup="true"
  aria-controls="share"
  class=${`playbar-btn share-btn ${currentTab === 'share' ? 'active' : ''} ${isShareBtnDisabled ? 'disabled' : ''}`}
  tabindex=${isShareBtnDisabled ? '-1' : '0'}
  style=${`${isShareBtnHidden ? 'display: none;' : ''}`}
  data-for="share"
>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16 3C16 4.65685 14.6569 6 13 6C11.3431 6 10 4.65685 10 3C10 1.34315 11.3431 0 13 0C14.6569 0 16 1.34315 16 3Z" fill="black"></path>
    <path d="M16 13C16 14.6569 14.6569 16 13 16C11.3431 16 10 14.6569 10 13C10 11.3431 11.3431 10 13 10C14.6569 10 16 11.3431 16 13Z" fill="black"></path>
    <path d="M6 8C6 9.65685 4.65685 11 3 11C1.34315 11 0 9.65685 0 8C0 6.34315 1.34315 5 3 5C4.65685 5 6 6.34315 6 8Z" fill="black"></path>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.7764 2.55279L13.2236 3.44721L4.11803 8L13.2236 12.5528L12.7764 13.4472L1.88197 8L12.7764 2.55279Z" fill="black"></path>
  </svg>
  <span class="button-label">Share</span>
</button>

<button
  aria-label="Comments"
  aria-haspopup="true"
  aria-controls="comments"
  class=${`playbar-btn comments-btn ${currentTab === 'comments' ? 'active' : ''} ${isCommentsBtnDisabled ? 'disabled' : ''}`}
  tabindex=${isCommentsBtnDisabled ? '-1' : '0'}
  style=${`${isCommentsBtnHidden ? 'display: none;' : ''}`}
  data-for="commnents"
>
  ${isCommentUnseen ? html`
    <span class="comments-btn-newIndicator"></span>
  ` : ''}
  <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1H5H9H17V10.931H14.5V16.2586L10 10.931H1V5.96552V3.48276V1Z" stroke="black" stroke-width="1.6"
      stroke-linejoin="bevel" />
  </svg>
  <span class="button-label">Comments</span>
</button>

<button
  aria-label="Menu"
  aria-haspopup="true"
  aria-controls="advanced"
  class=${`playbar-btn advanced-btn ${currentTab === 'advanced' ? 'active' : ''}`}
  style=${`${isAdvancedBtnHidden ? 'display: none;' : ''}`}
  data-for="advanced"
>
  <svg width="5" height="16" viewBox="0 0 5 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.83325 0C3.93725 0 4.83325 0.896 4.83325 2C4.83325 3.105 3.93725 4 2.83325 4C1.72925 4 0.833252 3.105 0.833252 2C0.833252 0.896 1.72925 0 2.83325 0Z" fill="black"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.83325 6C3.93725 6 4.83325 6.896 4.83325 8C4.83325 9.105 3.93725 10 2.83325 10C1.72925 10 0.833252 9.105 0.833252 8C0.833252 6.896 1.72925 6 2.83325 6Z" fill="black"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.83325 12C3.93725 12 4.83325 12.896 4.83325 14C4.83325 15.104 3.93725 16 2.83325 16C1.72925 16 0.833252 15.104 0.833252 14C0.833252 12.896 1.72925 12 2.83325 12Z" fill="black"/>
  </svg>
  <span class="button-label right">Menu</span>
</button>

<button
  class=${`playbar-btn fullscreen-btn ${isFullscreenBtnDisabled ? 'disabled' : ''}`}
  tabindex=${isFullscreenBtnDisabled ? '-1' : '0'}
  style=${`${isFullscreenBtnHidden ? 'display: none;' : ''}`}
  aria-label="Full Screen"
>
  <div
    class=${`fullscreen-icon ${!isFullscreenActive ? 'activate' : ''} hint--left`}
  >
    <svg class="open-fs-svg" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.54167 1H1V6.54167M15 6.54167V1L9.45833 1M9.45833 15H15V9.45833M1 9.45833L1 15L6.54167 15"
        stroke="black" stroke-width="1.6" />
    </svg>

    <svg class="close-fs-svg" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.33333 1V6.33333H1M17 6.33333H11.6667V1M11.6667 17V11.6667H17M1 11.6667H6.33333V17" stroke="black"
        stroke-width="1.6" />
    </svg>
  </div>
  <span class="button-label right">Full Screen</span>
</button>

<div class="free-favicon-container" style=${`${isFreeFaviconContainerHidden ? 'display: none' : ''}`}>
  <div
    class=${`free-block ${isFreeBtnDisabled ? 'disabled' : ''} ${isFaviconBtnHidden ? 'full-width' : ''}`}
    style=${`${isFreeBtnHidden ? 'display: none;' : ''}`}
  >
    <button
      class="free-btn"
      tabindex=${isFreeBtnDisabled ? '-1' : '0'}
    >
      ${freeBtnText}
    </button>
  </div>

  <div
    class=${`favicon-block ${isFaviconBtnDisabled ? 'disabled' : ''}`}
    style=${`${isFaviconBtnHidden ? 'display: none;' : ''}`}
  >
    ${faviconHref ? html`
      <a
        aria-label="Favicon"
        class="favicon-btn"
        role="button"
        tabindex=${isFaviconBtnDisabled ? '-1' : '0'}
        href=${faviconHref}
        target="_blank"
      >
        <img class="favicon-icon" src=${faviconImageSrc} />
      </a>
      `
    : html`
      <div class="favicon-btn">
        <img class="favicon-icon" src=${faviconImageSrc} alt="Favicon" />
      </div>
    `}
  </div>
</div>
`;
}());

;
(function () {
  const html = window.litHTML.html;
  iorad.player.templates.layout_language_popup = ({
    languageList,
    languageCode,
    searchList,
    isFocus,
  }) => html`
  <button class="close-popup-banner close-language-popup" aria-label="Back">
    <div class="close-info">
      <span class="close-name">Language</span>
    </div>
    <span class="close-text-hover">Back</span>
    <div class="close-back-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="9" height="15" viewBox="0 0 9 15" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.4343 0.934326L8.56567 2.0657L3.13136 7.50001L8.56567 12.9343L7.4343 14.0657L0.868617 7.50001L7.4343 0.934326Z" fill="black"/>
      </svg>
    </div>
  </button>
  <div class="popup-content">
    <div class="language-container">
      <div class="search-wrapper ${isFocus ? 'active' : ''}">
        <div class="filter-container">
          <input aria-hidden="true" class="filter" id="language-filter" placeholder="Search" />
        </div>
      </div>
      <ul class="language-list notranslate" role="menu">
        ${languageList.map(item => html`
          <li
            class=${`language-item ${languageCode === item.code ? 'active' : ''}`}
            style=${searchList.length ? (searchList.indexOf(item.code) > -1 ? '' : 'display: none;') : ''}
            data-value=${item.code}
            role="menuitem"
          >
            <button aria-label="${item.name}">${item.name}</button>
    
            ${languageCode === item.code ? html`
              <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                <path d="M1 10L5.70769 16L16 1" stroke="black" stroke-width="1.6" stroke-linejoin="bevel"/>
              </svg>
            ` : ''}
          </li>
        `)}
      </ul>
    </div>
  </div>
  <div class="popup_overlay"></div>
  `;
}());

;
iorad.player.templates.meta_mobile_finished = "<div class=\"recommended-tutorials\"></div>";
;
iorad.player.templates.meta_interactive = "<div class=\"stepimg\">\n  <div id=\"interaction-blocker-overlay\"></div>\n  <div id=\"interactive-recommended-tutorials\" class=\"recommended-tutorials\"></div>\n  <div class=\"step-infotext\"></div>\n  <div id=\"interactive-image\" class=\"image\" style=\"height: 297px;\">\n\n    <div class=\"image-surround scrollbar-inner\" id=\"image-surround\">\n      <div class=\"containment\"></div>\n    </div>\n    <a class=\"btn-overlay next\">\n      <div class=\"wrapper\">\n        <svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 100 100\" enable-background=\"new 0 0 100 100\" xml:space=\"preserve\">\n          <g>\n            <path fill=\"#231F20\" d=\"M20.831,8.299c0-0.902,0.401-1.703,1.003-2.305l5.011-5.012c0.601-0.601,1.505-1.002,2.306-1.002\n              s1.704,0.4,2.306,1.002l46.712,46.713c0.601,0.601,1.002,1.504,1.002,2.306c0,0.801-0.4,1.704-1.002,2.306l-46.713,46.71\n              c-0.601,0.601-1.505,1.003-2.306,1.003s-1.704-0.401-2.306-1.003l-5.011-5.011c-0.601-0.601-1.003-1.504-1.003-2.306\n              c0-0.801,0.401-1.704,1.003-2.306L61.228,50L21.833,10.605C21.232,10.003,20.83,9.101,20.831,8.299z\"/>\n          </g>\n        </svg>\n        <div class=\"name\">{{#i18n}}Next{{/i18n}}</div>\n      </div>\n    </a>\n  </div>\n</div>\n\n<div class=\"stepnav\" id=\"interactive-nav\"></div>\n<div id=\"interactive-transcription\"></div>\n";
;
iorad.player.templates.meta_quick = "<div class=\"steps\">\n</div>\n\n<div class=\"finish\">\n  <div class=\"recommended-tutorials\"></div>\n</div>\n\n<div class=\"btn-overlay finished\"></div>\n";
;
iorad.player.templates.meta_print_short = "<div class=\"header\">\n    <div class=\"copyright\">\n        <span>{{#i18n}}powered by{{/i18n}}</span>\n        <img alt=\"logo\" src=\"{{logoUrl}}\" />\n    </div>\n    <h1 class=\"title\">{{title}}</h1>\n</div>\n\n<div class=\"steps\"></div>\n\n<div class=\"footer\">\n    <div class=\"author\">{{#i18n}}Author{{/i18n}}: <span class=\"notranslate\">{{author}}</span></div>\n    <div class=\"updated\">{{#i18n}}Last edited{{/i18n}} {{updated}}</div>\n</div>\n\n<div class=\"resources\">\n    <span class=\"logo-default\"></span>\n</div>\n\n<div class=\"texts\">\n    <div class=\"updated-text\">{{updated}}</div>\n    <div class=\"qr-text\">Scan to go to the interactive player</div>\n    <div class=\"page-text\">\n    {{#estimatedPages}}\n    {{#estimatedPageCounts}}\n        <div class=\"page-{{currentPage}}-of-{{.}}\">{{currentPage}} of {{.}}</div>\n    {{/estimatedPageCounts}}\n    {{/estimatedPages}}\n    </div>\n</div>";
;
iorad.player.templates.meta_print_long = "<div class=\"header\">\n    <div class=\"copyright\">\n        <span>{{#i18n}}powered by{{/i18n}}</span>\n        <img alt=\"logo\" src=\"{{logoUrl}}\" />\n    </div>\n    <h1 class=\"title\">{{title}}</h1>\n</div>\n\n<div class=\"steps\"></div>\n\n<div class=\"footer\">\n    <div class=\"author\">{{#i18n}}Author{{/i18n}}: <span class=\"notranslate\">{{author}}</span></div>\n    <div class=\"updated\">{{#i18n}}Last edited{{/i18n}} {{updated}}</div>\n</div>\n\n<div class=\"resources\">\n    <span class=\"logo-default\"></span>\n</div>\n\n<div class=\"texts\">\n    <div class=\"updated-text\">{{updated}}</div>\n    <div class=\"qr-text\">Scan to go to the interactive player</div>\n    <div class=\"page-text\">\n    {{#estimatedPages}}\n    {{#estimatedPageCounts}}\n        <div class=\"page-{{currentPage}}-of-{{.}}\">{{currentPage}} of {{.}}</div>\n    {{/estimatedPageCounts}}\n    {{/estimatedPages}}\n    </div>\n</div>";
;
iorad.player.templates.markers_common = "<div class=\"utils\"></div>";
;
iorad.player.templates.markers_info = "<div class=\"arrow-container\">\n    <div class=\"arrow arrow-top\"></div>\n    <div class=\"arrow arrow-left\"></div>\n    <div class=\"arrow arrow-bottom\"></div>\n    <div class=\"arrow arrow-right\"></div>\n</div>\n<div class=\"step-container\">\n  <div class=\"timer-progress\"></div>\n  <span class=\"step-icon read\">\n    <svg width=\"100%\" height=\"100%\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 8.8L8.8 8H31.2005L32.0005 8.8V31.2012L31.2005 32.0012H8.8L8 31.2012V8.8ZM9.6 9.6V30.4012H30.4005V9.6H9.6ZM20.0824 15.3L20.5 14.8824L20.5 13.7176L20.0824 13.3H18.9176L18.5 13.7176V14.8824L18.9176 15.3L20.0824 15.3ZM19 16.6H18V18.6H19L19 23.7H18V25.3H21.5V23.7H20.6V16.6H20H19Z\" class=\"fill\" fill=\"#fefefe\" />\n    </svg>\n  </span>\n  <span class=\"step-icon left-click\">\n    {{#tutorialIsMobile}}\n      <svg width=\"100%\" height=\"100%\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.1521 11.2136V8.21362H16.5521V11.2136H18.1521ZM16.2236 13.0105L17.2341 12H17.8657L18.8762 13.0105V19.5789L19.6774 18.7777H21.1065L21.6512 19.5789L22.2038 18.7777H23.6329L24.1578 19.5789L24.505 19.1567H25.9341L26.5657 19.7882L26.8617 20.5028L27.159 26.7826L27.0867 27.1579L25.6683 31.5753L24.7301 32.2105H17.7827L17.0155 31.8576L13.309 26.2927L13.0657 25.6351V20.5895L14.0762 19.5789H14.7078L15.7183 20.5895V23.7474L16.2236 24V13.0105ZM21.5928 10.0001L20.3297 12.188L18.944 11.388L20.2072 9.2001L21.5928 10.0001ZM15.9177 11.4343L14.1314 9.64794L13 10.7793L14.7864 12.5657L15.9177 11.4343Z\" class=\"fill\" fill=\"#fefefe\" />\n      </svg>\n    {{/tutorialIsMobile}}\n    {{^tutorialIsMobile}}\n      <svg width=\"100%\" height=\"100%\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M29 15C29 10.0294 24.9706 6 20 6C15.0294 6 11 10.0294 11 15V24C11 28.9706 15.0294 33 20 33C24.9706 33 29 28.9706 29 24V15ZM12.6 18.5V24C12.6 28.0869 15.9131 31.4 20 31.4C24.0869 31.4 27.4 28.0869 27.4 24V15C27.4 10.9131 24.0869 7.6 20 7.6V18.5H12.6Z\" class=\"fill\" fill=\"#fefefe\" />\n      </svg>\n    {{/tutorialIsMobile}}\n  </span>\n  <span class=\"step-icon right-click\">\n    {{#tutorialIsMobile}}\n      <svg width=\"100%\" height=\"100%\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.3657 8V10H16.7657V8H18.3657ZM20.2304 11L19.2421 11.9882L19.2421 19.647H18.748V13.2235L17.7598 12.2353H17.1421L16.1539 13.2235V23.9705L15.6598 23.7235V20.6352L14.6716 19.647H14.0539L13.0657 20.6352V25.5695L13.3036 26.2127L16.9283 31.6548L17.6787 31.9999H24.7237L25.6412 31.3787L27.0283 27.0588L27.099 26.6917L26.8082 20.5505L26.5188 19.8517L25.9011 19.234H24.5036L24.164 19.647L23.6507 18.8634H22.2531L21.8362 19.4679V11.9882L20.848 11H20.2304ZM21.3657 10V8H19.7657V10H21.3657ZM25.3339 11.7987L23.4559 13.2148L22.4925 11.9374L24.3705 10.5212L25.3339 11.7987ZM15.7946 11.9286L14.1314 10.2654L13 11.3967L14.6632 13.0599L15.7946 11.9286Z\" class=\"fill\" fill=\"#fefefe\" />\n      </svg>\n    {{/tutorialIsMobile}}\n    {{^tutorialIsMobile}}\n      <svg width=\"100%\" height=\"100%\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11 15C11 10.0294 15.0294 6 20 6C24.9706 6 29 10.0294 29 15V24C29 28.9706 24.9706 33 20 33C15.0294 33 11 28.9706 11 24V15ZM27.4 18.5V24C27.4 28.0869 24.0869 31.4 20 31.4C15.9131 31.4 12.6 28.0869 12.6 24V15C12.6 10.9131 15.9131 7.6 20 7.6V18.5H27.4Z\" class=\"fill\" fill=\"#fefefe\" />\n      </svg>\n    {{/tutorialIsMobile}}\n  </span>\n  <span class=\"step-icon typing\">\n    <svg width=\"100%\" height=\"100%\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 8.8L8.8 8H31.2005L32.0005 8.8V31.2012L31.2005 32.0012H8.8L8 31.2012V8.8ZM9.6 9.6V30.4012H30.4005V9.6H9.6Z\" class=\"fill\" fill=\"#fefefe\" />\n      <path d=\"M16.0039 15.009L24.0039 15.009V16.609H20.8039L20.8039 25.309H19.2039V16.609H16.0039V15.009Z\" class=\"fill\" fill=\"#fefefe\" />\n    </svg>\n  </span>\n  <span class=\"step-icon scroll\">\n    <svg width=\"100%\" height=\"100%\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M27.4 24V15C27.4 10.9131 24.0869 7.6 20 7.6C15.9131 7.6 12.6 10.9131 12.6 15V24C12.6 28.0869 15.9131 31.4 20 31.4C24.0869 31.4 27.4 28.0869 27.4 24ZM20 6C15.0294 6 11 10.0294 11 15V24C11 28.9706 15.0294 33 20 33C24.9706 33 29 28.9706 29 24V15C29 10.0294 24.9706 6 20 6ZM20.0209 25.9431L17 21L23 21L20.0209 25.9431ZM23 17.9431L19.9791 13L17 17.9431L23 17.9431Z\" class=\"fill\" fill=\"#fefefe\" />\n    </svg>\n  </span>\n  <span class=\"step-icon drag-n-drop\">\n    <svg width=\"100%\" height=\"100%\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M23 12.9431L19.9791 8L17 12.9431L19.2 12.9431V18.9H12.9431L12.9431 17L8 20.0209L12.9431 23L12.9431 20.5L19.2 20.5V27H17L20.0209 31.9431L23 27H20.8V20.5L27 20.5V23L31.9431 19.9791L27 17V18.9H20.8V12.9431L23 12.9431Z\" class=\"fill\" fill=\"#fefefe\" />\n    </svg>\n  </span>\n  <span class=\"step-icon hover\">\n    {{#tutorialIsMobile}}\n      <svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.8 12.8001C14.8 10.9291 16.1058 9.60006 17.5 9.60006C18.8942 9.60006 20.2 10.9291 20.2 12.8001H21.8C21.8 10.2528 19.9718 8.00006 17.5 8.00006C15.0282 8.00006 13.2 10.2528 13.2 12.8001H14.8ZM16.137 12.7272L17.1408 11.7234H17.7682L18.772 12.7272V19.2522L19.568 18.4562H20.9876L21.5287 19.2522L22.0776 18.4562H23.4972L24.0187 19.2522L24.3636 18.8327H25.7832L26.4106 19.4601L26.7046 20.1699L27 26.4081L26.9282 26.7809L25.5192 31.1691L24.5872 31.8001H17.6858L16.9236 31.4495L13.2417 25.9215L13 25.2682V20.256L14.0038 19.2522H14.6312L15.6351 20.256V23.393L16.137 23.6439V12.7272Z\" class=\"fill\" fill=\"#fefefe\" />\n      </svg>\n    {{/tutorialIsMobile}}\n    {{^tutorialIsMobile}}\n      <svg width=\"100%\" height=\"100%\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11 15C11 10.0294 15.0294 6 20 6C24.9706 6 29 10.0294 29 15V24C29 28.9706 24.9706 33 20 33C15.0294 33 11 28.9706 11 24V15ZM27.4 15V24C27.4 28.0869 24.0869 31.4 20 31.4C15.9131 31.4 12.6 28.0869 12.6 24V15C12.6 11.1834 15.4894 8.04161 19.2 7.64274L19.2 18.5H20.8L20.8 7.64274C24.5107 8.04163 27.4 11.1834 27.4 15Z\" class=\"fill\" fill=\"#fefefe\" />\n      </svg>\n    {{/tutorialIsMobile}}\n  </span>\n  <span class=\"step-icon select-text\">\n    <svg width=\"100%\" height=\"100%\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M31.2 8H14L8 31.2L8.8 32H26L32 8.8L31.2 8ZM24 15L16 15V16.6H19.2V25.3H20.8L20.8 16.6H24V15Z\" class=\"fill\" fill=\"#fefefe\" />\n    </svg>\n  </span>\n  <span class=\"step-description\"/>\n</div>\n";
;
iorad.player.templates.steps_interactive_nav_item = "<div class=\"steptext {{type}}\">\n  <div class=\"if-active\">\n    <i class=\"{{type}} small-icon\"></i>\n    <span class=\"icon number\">{{number}}</span>\n    <span class=\"count\">\n      <span class=\"count-number notranslate\">{{number}}</span>\n      {{#i18n}}OF{{/i18n}}\n      <span class=\"count-total notranslate\">{{total}}</span>\n    </span>\n\n    <div class=\"description-container\"></div>\n  </div>\n  <div class=\"if-not-active\">\n    <span>{{number}}</span>\n  </div>\n</div>\n";
;
iorad.player.templates.steps_interactive_nav = "<div class=\"ui-resizable-handle ui-resizable-n\"></div>\n<div class=\"ui-resizable-handle ui-resizable-s\"></div>\n<div class=\"stepscontainer {{#isFinishBtnVisible}}stepscontainer--finished{{/isFinishBtnVisible}}\">\n  <div class=\"video-visualizer\"></div>\n\n  <div class=\"marker\" style=\"{{#stepsPointerColor}}border-right-color: {{stepsPointerColor}};{{/stepsPointerColor}} {{#stepsPointerTop}}top: {{stepsPointerTop}};{{/stepsPointerTop}}\"></div>\n\n  <div class=\"step active tut-step start-step\">\n    <div class=\"step-progress-animation-overlay\"></div>\n    <div class=\"steptext\">\n      <div class=\"if-active\">\n        <div class=\"description-container\">\n          <div class=\"step-panel-dragHandler\" aria-label=\"Drag Step Text Panel\">\n            <svg width=\"16\" height=\"36\" viewBox=\"0 0 16 36\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n              <path d=\"M11 10L8.99999 12L11 14L13 12L11 10Z\" fill=\"black\" fill-opacity=\"0.4\"/>\n              <path d=\"M11 16L8.99999 18L11 20L13 18L11 16Z\" fill=\"black\" fill-opacity=\"0.4\"/>\n              <path d=\"M11 22L8.99999 24L11 26L13 24L11 22Z\" fill=\"black\" fill-opacity=\"0.4\"/>\n              <path d=\"M5 10L2.99999 12L5 14L7 12L5 10Z\" fill=\"black\" fill-opacity=\"0.4\"/>\n              <path d=\"M5 16L2.99999 18L5 20L7 18L5 16Z\" fill=\"black\" fill-opacity=\"0.4\"/>\n              <path d=\"M5 22L2.99999 24L5 26L7 24L5 22Z\" fill=\"black\" fill-opacity=\"0.4\"/>\n            </svg>\n          </div>\n          <button\n            aria-label=\"\"\n            aria-haspopup=\"true\"\n            aria-controls=\"steps\"\n            class=\"step-panel-currentstep\"\n          ></button>\n          <div class=\"step-panel-toggleCollapse-btn\" role=\"button\" tabindex=\"0\" aria-label=\"Close\">\n            <svg class=\"uncollapse\" width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n              <rect width=\"16\" height=\"4\" transform=\"matrix(1 0 0 -1 1 5)\" fill=\"#BABABA\" stroke=\"#BABABA\" stroke-width=\"1.6\" stroke-linejoin=\"bevel\"/>\n              <rect width=\"16\" height=\"12\" transform=\"matrix(1 0 0 -1 1 17)\" stroke=\"#BABABA\" stroke-width=\"1.6\" stroke-linejoin=\"bevel\"/>\n            </svg>\n            <svg class=\"collapse\" width=\"18\" height=\"6\" viewBox=\"0 0 18 6\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n              <rect x=\"17\" y=\"4.33331\" width=\"16\" height=\"2.66667\" transform=\"rotate(180 17 4.33331)\" fill=\"#BABABA\" stroke=\"#BABABA\" stroke-width=\"1.6\" stroke-linejoin=\"bevel\"/>\n            </svg>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div id=\"the-steps\"></div>\n  {{#copyright}}\n    <div class=\"step_copyright\">\n      <span class=\"notranslate\">{{copyright}}</span>\n    </div>\n  {{/copyright}}\n</div>\n\n<div class=\"quiz-report\">\n  <div class=\"section section-speed\">\n    <div class=\"section-title\">{{#i18n}}Speed{{/i18n}}</div>\n    <div class=\"section-content\">\n      <div class=\"section-content-row section-content-user\">\n        <div class=\"duration\"></div>\n        <div class=\"description\">{{#i18n}}your time{{/i18n}}</div>\n      </div>\n\n      <div class=\"section-content-row section-content-ideal\">\n        <div class=\"duration\"></div>\n        <div class=\"description\">{{#i18n}}ideal time{{/i18n}}</div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"section section-accuracy\">\n    <div class=\"section-title\">{{#i18n}}Accuracy{{/i18n}}</div>\n    <div class=\"section-content\">\n      <div class=\"section-content-row\">\n        <div class=\"accuracy\"></div>\n        <div class=\"description\">Correct</div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div aria-hidden=\"false\" class=\"step-footer {{#isFinishBtnVisible}}step-footer--finished{{/isFinishBtnVisible}}\">\n  {{#copyright}}\n    <div class=\"copyright\">\n      <span class=\"notranslate\">{{copyright}}</span>\n    </div>\n  {{/copyright}}\n</div>\n\n<div class=\"buttons {{#isFinishBtnVisible}}finished{{/isFinishBtnVisible}}\">\n  <div class=\"actions\" {{#isFinishBtnVisible}}style=\"display: none;\"{{/isFinishBtnVisible}}>\n    <a href=\"#\" aria-label=\"Play Next\" role=\"button\" class=\"next-tutorial-button button copy-link-btn\" style=\"display: none;\">\n      <svg width=\"12\" height=\"14\" viewBox=\"0 0 12 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path d=\"M12 7L-9.53674e-07 14L2.70245e-07 -1.04907e-06L12 7Z\" fill=\"black\"/>\n      </svg>\n      <span aria-label=\"Play Next\" class=\"play-next-text copy-link-text\"><span class=\"next-tutorial-title\">{{#i18n}}Play Next{{/i18n}}</span> <span class=\"next-tutorial-timer\"></span></span>\n    </a>\n\n    <a aria-label=\"Go Live\" role=\"button\" id=\"go-live\" class=\"button copy-link-btn\" href=\"#live\" {{^isGoLiveBtnVisible}}style=\"display: none;\"{{/isGoLiveBtnVisible}}>\n      <svg width=\"19\" height=\"13\" viewBox=\"0 0 19 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n        <circle cx=\"9.5\" cy=\"6.5\" r=\"2.5\" fill=\"black\"/>\n        <path d=\"M3.125 1C1.80248 2.43749 1 4.32575 1 6.39381C1 8.56536 1.8848 10.5387 3.32741 12M15.875 1C17.1975 2.43749 18 4.32575 18 6.39381C18 8.56536 17.1152 10.5387 15.6726 12\" stroke=\"black\" stroke-width=\"1.6\"/>\n        <path d=\"M5.375 3C4.51925 3.91477 4 5.11638 4 6.43242C4 7.81432 4.57252 9.07005 5.50597 10M13.625 3C14.4807 3.91477 15 5.11638 15 6.43242C15 7.81432 14.4275 9.07005 13.494 10\" stroke=\"black\" stroke-width=\"1.6\"/>\n      </svg>\n      <span aria-label=\"Go Live\" class=\"copy-link-text\">{{#i18n}}Go Live{{/i18n}}</span>\n    </a>\n\n    <a href=\"#\" aria-label=\"Replay\" role=\"button\" id=\"replay-btn\" class=\"button copy-link-btn\">\n      <svg class=\"replay-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\">\n        <path d=\"M12.5343 2L15.5552 6.94311L13.0751 6.89573L13.0751 13.2L12.2751 14L6 14L6 12.4L11.4751 12.4L11.4751 6.86516L9.14985 6.82074L12.5343 2Z\" fill=\"black\"/>\n        <path d=\"M3.02089 14L5.8946e-08 9.05689L2.48012 9.10427L2.48012 2.8L3.28012 2L9.55517 2L9.55517 3.6L4.08012 3.6L4.08012 9.13484L6.40532 9.17926L3.02089 14Z\" fill=\"black\"/>\n      </svg>\n      <svg class=\"complete-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"17\" height=\"17\" viewBox=\"0 0 17 17\" fill=\"none\">\n        <path d=\"M1 10L5.70769 16L16 1\" stroke=\"black\" stroke-width=\"1.6\" stroke-linejoin=\"bevel\"/>\n      </svg>\n      <span aria-label=\"Replay\" class=\"replay-text copy-link-text\" id=\"replay-text\"></span>\n    </a>\n\n    <a href=\"#\" aria-label=\"Copy Link\" role=\"button\" class=\"button copy-link-btn copy-short-tut-link\" {{^isCopyLinkVisible}}style=\"display: none;\"{{/isCopyLinkVisible}}>\n      <svg width=\"16\" height=\"17\" viewBox=\"0 0 16 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.927734 1.72004L1.72773 0.920044H11.7277L12.5277 1.72004V3.62274H14.455L15.255 4.42274V16.1345L14.455 16.9345H4.45503L3.65503 16.1345V14.2318H1.72773L0.927734 13.4318V1.72004ZM3.65503 12.6318V4.42274L4.45503 3.62274H10.9277V2.52004H2.52773V12.6318H3.65503ZM5.25503 15.3345V5.22274H13.655V15.3345H5.25503Z\" fill=\"black\"/>\n      </svg>\n      <span aria-label=\"Copy\" class=\"copy-link-text\">{{#i18n}}Copy Link{{/i18n}}</span>\n    </a>\n\n    <a href=\"#\" aria-label=\"Copy Embed\" role=\"button\" class=\"button copy-link-btn copy-embed-tut-link\" {{^isCopyEmbedVisible}}style=\"display: none;\"{{/isCopyEmbedVisible}}>\n      <svg width=\"16\" height=\"17\" viewBox=\"0 0 16 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.927734 1.72004L1.72773 0.920044H11.7277L12.5277 1.72004V3.62274H14.455L15.255 4.42274V16.1345L14.455 16.9345H4.45503L3.65503 16.1345V14.2318H1.72773L0.927734 13.4318V1.72004ZM3.65503 12.6318V4.42274L4.45503 3.62274H10.9277V2.52004H2.52773V12.6318H3.65503ZM5.25503 15.3345V5.22274H13.655V15.3345H5.25503Z\" fill=\"black\"/>\n      </svg>\n      <span aria-label=\"Copy\" class=\"copy-link-text\">{{#i18n}}Copy Embed{{/i18n}}</span>\n    </a>\n  </div>\n</div>\n\n<div class=\"quiz-webcam\">\n  <video></video>\n</div>\n";
;
iorad.player.templates.steps_quick_slide = "<div class=\"step tut-step {{type}}\">\n  <div class=\"stepimg-wrap\">\n    <div class=\"stepimg\">\n      <div class=\"imgcontainer\">\n        <ul class=\"markers\"></ul>\n      </div>\n      <div class=\"step-infotext\"></div>\n    </div>\n  </div>\n  <div class=\"steptext {{type}}\">\n    <div class=\"step-index\" role=\"button\" tabindex=\"0\" aria-label=\"Step {{number}} / {{total}}, Click to expand step navigator\">{{number}}/{{total}}</div>\n\n    <div class=\"description-container-wrapper\">\n      <div class=\"video-visualizer\"></div>\n      <div class=\"description\"></div>\n    </div>\n  </div>\n</div>\n";
;
iorad.player.templates.steps_print_slide = "<div class=\"step tut-step {{type}}\">\n  <div class=\"steptext {{type}}\">\n    <span class=\"{{type}} {{#tutorialIsMobile}}tutorialIsMobile{{/tutorialIsMobile}} icon\">&nbsp;</span>\n    <div class=\"description-wrap\">\n      <div class=\"description\"></div>\n    </div>\n    <span class=\"number\">{{{number}}}</span>\n  </div>\n  <div class=\"stepimg-wrap\">\n    <div class=\"stepimg\">\n      <div class=\"imgcontainer\">\n        <ul class=\"markers\"></ul>\n      </div>\n      <div class=\"step-infotext\"></div>\n    </div>\n  </div>\n</div>\n";
;
iorad.player.templates.steps_mobile_slide = "<!-- Height of the container depends on the height of the background image and of the viewpoint -->\n\n<div class=\"stepimg\">\n  <div class=\"prev\">\n    <div class=\"icon\">\n      <svg width=\"40\" height=\"47\" viewBox=\"0 0 40 47\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path d=\"M23.75 16L16 23.5L23.75 31\" stroke=\"black\" stroke-width=\"1.6\"/>\n      </svg>\n    </div>\n  </div>\n  <div class=\"next\">\n    <div class=\"icon\">\n      <svg width=\"40\" height=\"47\" viewBox=\"0 0 40 47\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path d=\"M16.25 31L24 23.5L16.25 16\" stroke=\"black\" stroke-width=\"1.6\"/>\n      </svg>\n    </div>\n  </div>\n\n  <div class=\"imgcontainer\">\n    <ul class=\"markers\"></ul>\n    <!-- screenshot view is attached here -->\n  </div>\n</div>\n\n<div class=\"steptext {{type}}\">\n  <div class=\"steptext-header\">\n    <div class=\"step-progress-animation-overlay\"></div>\n\n    <div class=\"dragHandler\">\n      <svg width=\"16\" height=\"36\" viewBox=\"0 0 16 36\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path d=\"M11 10L8.99999 12L11 14L13 12L11 10Z\" fill=\"black\" fill-opacity=\"0.4\"/>\n        <path d=\"M11 16L8.99999 18L11 20L13 18L11 16Z\" fill=\"black\" fill-opacity=\"0.4\"/>\n        <path d=\"M11 22L8.99999 24L11 26L13 24L11 22Z\" fill=\"black\" fill-opacity=\"0.4\"/>\n        <path d=\"M5 10L2.99999 12L5 14L7 12L5 10Z\" fill=\"black\" fill-opacity=\"0.4\"/>\n        <path d=\"M5 16L2.99999 18L5 20L7 18L5 16Z\" fill=\"black\" fill-opacity=\"0.4\"/>\n        <path d=\"M5 22L2.99999 24L5 26L7 24L5 22Z\" fill=\"black\" fill-opacity=\"0.4\"/>\n      </svg>\n    </div>\n    <div class=\"count\" role=\"button\" tabindex=\"0\" aria-label=\"Step {{number}} / {{total}}, Click to expand step navigator\">{{number}}/{{total}}</div>\n    <div class=\"toggleCollapse\" role=\"button\" tabindex=\"0\" aria-label=\"\">\n      <svg class=\"uncollapse\" width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n        <rect width=\"16\" height=\"4\" transform=\"matrix(1 0 0 -1 1 5)\" fill=\"#BABABA\" stroke=\"#BABABA\" stroke-width=\"1.6\" stroke-linejoin=\"bevel\"/>\n        <rect width=\"16\" height=\"12\" transform=\"matrix(1 0 0 -1 1 17)\" stroke=\"#BABABA\" stroke-width=\"1.6\" stroke-linejoin=\"bevel\"/>\n      </svg>\n      <svg class=\"collapse\" width=\"18\" height=\"6\" viewBox=\"0 0 18 6\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n        <rect x=\"17\" y=\"4.33331\" width=\"16\" height=\"2.66667\" transform=\"rotate(180 17 4.33331)\" fill=\"#BABABA\" stroke=\"#BABABA\" stroke-width=\"1.6\" stroke-linejoin=\"bevel\"/>\n      </svg>\n    </div>\n  </div>\n\n  <div class=\"description-container-wrapper\">\n    <div class=\"video-visualizer\"></div>\n    <div class=\"description-container\"></div>\n  </div>\n\n  {{#copyright}}\n  <div class=\"step_copyright\">\n    <span class=\"notranslate\">{{copyright}}</span>\n  </div>\n  {{/copyright}}\n</div>\n";
;
iorad.player.templates.steps_typingtool = "<textarea class=\"typingTool {{#notranslate}}notranslate{{/notranslate}} {{#event.password}}password{{/event.password}} {{#fullyTransparent}}fullyTransparent{{/fullyTransparent}}\"\n          {{^placeholderDisabled}}placeholder=\"{{#typingToolText}}{{typingToolText}}{{/typingToolText}}{{^typingToolText}}Type here{{/typingToolText}}\"{{/placeholderDisabled}} aria-label=\"Type here\">\n</textarea>";
;
iorad.player.templates.steps_select_text_tool = "<textarea class=\"selectTextTool\"></textarea>";
;
iorad.player.templates.steps_scrolltool = "<div class=\"scroll-wrapper\">\n    <div class=\"{{#event.horizontal}}horizontal{{/event.horizontal}}\">&nbsp;</div>\n</div>";
;
iorad.player.templates.steps_dragtool = "<div class=\"tool\">\n    <div class=\"textContainer\">\n        <span></span>\n    </div>\n    <canvas class=\"background\"></canvas>\n</div>";
;
iorad.player.templates.steps_droptool = "<div class=\"tool\">\n    <div class=\"textContainer\">\n        <span></span>\n    </div>\n</div>";
;
iorad.player.templates.step_infotext = "<div class=\"step-infotext_inner\">\n  <div class=\"overlay\"></div>\n  <div class=\"video-visualizer\"></div>\n  <div class=\"step-infotext_inner_inner\">\n    <div class=\"section section-title\"></div>\n    <div class=\"section section-text\"></div>\n  </div>\n</div>\n<div class=\"step-infotext_prev\"></div>\n<div class=\"step-infotext_next\"></div>\n";
;
iorad.player.templates.step_video_visualizer = "<div class=\"video-visualizer-overlay video-visualizer-playing\"></div>\n<div class=\"video-visualizer-overlay video-visualizer-paused\">Paused</div>\n<div class=\"video-visualizer-overlay video-visualizer-restart\">Replay</div>\n<div class=\"video-visualizer-transcription\">\n  <div class=\"video-visualizer-transcription-text\"></div>\n</div>\n";
;
iorad.player.templates.unsupported_download = "<div class=\"unsupported download\">\n    <p>{{#i18n}}To view this tutorial it needs to be hosted on a remote server.{{/i18n}}</p>\n</div>";
;
iorad.player.templates.container = "<div class=\"hint-box\"></div>\n  <header id=\"header\" class=\"with_footer\"></header>\n\n  <div id=\"advanced\" class=\"player-popup\" tabindex=\"1\"></div>\n  <div id=\"share\" class=\"player-popup\" tabindex=\"1\"></div>\n  <div id=\"comments\" class=\"player-popup\" tabindex=\"1\"></div>\n  <div id=\"media\" class=\"player-popup\" tabindex=\"1\"></div>\n  <div id=\"steps\" class=\"player-popup\" tabindex=\"1\"></div>\n  <div id=\"selector\" class=\"player-popup\" tabindex=\"1\"></div>\n  <div id=\"export\" class=\"player-popup\" tabindex=\"1\"></div>\n  <div id=\"language\" class=\"player-popup\"></div>\n\n  <div id=\"main\" class=\"with_footer\">\n    <div class=\"feedback-bar\"></div>\n\n    <div class=\"device-change-overlay\" style=\"display: none;\">\n      <div class=\"device-change-overlay-inner\">\n        <div class=\"mask-overlay\"></div>\n        <div class=\"side-panel\">\n          <div class=\"side-panel-inner\">\n            <div class=\"progressPageLoading\"></div>\n            <div class=\"description\">Loading</div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"offline-cache-overlay\" style=\"display: none;\">\n    </div>\n\n    <section class=\"mobile-quickview with_footer\">\n      <div class=\"step-infotext\"></div>\n\n      <div id='mobile-steps' class=\"steps-contain mobile-steps\" style=\"display: none;\">\n        <div class=\"step finished\">\n          <div class=\"cover\">\n          </div>\n        </div>\n      </div>\n    </section>\n\n    <section id=\"playing-player\"></section>\n\n    <section class=\"quick-view\">\n    </section>\n\n    <section class=\"print-view\">\n    </section>\n  </div>\n\n  <div\n    id=\"playbar\"\n    aria-label=\"Player controls\"\n    role=\"toolbar\"\n  ></div>\n\n  <div style=\"display: none\"><a class=\"notranslate\" id=\"google_translate_element\"></a></div>";
;
iorad.player.LazyCollectionView = iorad.base.CollectionView.extend({

  scrollContainer: undefined, // MANDATORY for child types

  initialize: function(options) {
    options = options || {};

    iorad.base.CollectionView.prototype.initialize.apply(this, arguments);

    this.isInViewport = false;

    // TODO: unbind handler on view remove to prevent memory leaks!
    this.scrollContainer.on('scroll', _.bind(this.readMoreIfNeeded, this));
  },

  notifyIsInViewport: function() {
    this.isInViewport = true;
    this.readMoreIfNeeded();
  },

  notifyIsNotInViewport: function() {
    this.isInViewport = false;
  },

  isReadMoreNeeded: function() {
    if (!this.isInViewport) {
      return false;
    }
    if (!this.collection.hasMore()) {
      // nothing to display
      return false;
    }
    if (this.scrollContainer[0].clientHeight === 0) {
      // still not ready (prevents tons of reads while initializing)
      return false;
    }

    var TOLERANCE = 500;
    var isBottomInViewport = this.scrollContainer.scrollTop() + this.scrollContainer[0].clientHeight >= this.scrollContainer[0].scrollHeight - TOLERANCE;
    return isBottomInViewport;
  },

  readMoreIfNeeded: function() {
    if (this.isReadMoreNeeded()) {
      this.collection.readMore();
    }
  }
});

;
iorad.player.views.meta_cover = iorad.base.View.extend({
  template: undefined, // to be setted by child views

  initialize: function() {
    // cache for the screenshot common colour
    this.commonColour = undefined;

    this.listenTo(this.model, 'change', this.modelChanged);
    this.render();
  },

  getTemplateData: function() {
    return _.extend(this.model.toJSON(), {
      created: iorad.base.Utils.toLocalTime(this.model.get('created')),
      updated: iorad.base.Utils.toLocalTime(this.model.get('updated')),
      duration: this.model.getFormattedDuration(),
      lastEditorImg: iorad.player.controllers.sync.getLastEditorAvatarURL(),
      commentCount: 0,
      steps: iorad.player.data.stepsCollection.length,
      description: this.model.getFormattedDescription(),
    });
  },

  modelChanged: function() {
    this.rerender();
  },

  rerender: function() {
    // nothing to update
    return false;
  },

  render: function() {
    iorad.base.View.prototype.render.apply(this, arguments);

    this.updateScreenshot();

    return this;
  },

  updateScreenshot: function() {
    var step = iorad.player.data.tutorial.steps.models[0];
    if (!step) return;

    var isIE = iorad.app.controllers.clientDetect.browser.isIE;

    var markerView = iorad.player.views.MarkerFactory.create(step.get('type'), {
      model: step,
      previousModel: null,
      slideView: iorad.player.router.layoutModes
    });
    var bounds = markerView.getBounds();
    var space = 50;
    var left = bounds.x - space;
    var top = bounds.y - space;

    var cW = window.innerWidth;
    var cH = window.innerHeight - $('#header').height() - $('#header').offset().top;

    var $screenshot = this.$('.screenshot');
    var $svg = $screenshot.find('svg');
    var $svgImage = $svg.find('image');

    step.getScreenshotCanvas().then(function(canvas) {
      var url = canvas.toDataURL();
      if (isIE) {
        // blur via svg image (http://www.broken-links.com/2013/11/20/cross-browser-filters-css-svg/)
        $svgImage.attr('xlink:href', url).css('filter', 'url(#blur)');
        $svg.show();

      } else {
        $screenshot.css('background-image', 'url("' + url + '")');
      }
    });

    var screenshotView = new iorad.player.views.step_screenshot();
    screenshotView.on('load', function() {

      var lgap = screenshotView.size.width - cW,
        tgap = screenshotView.size.height - cH;

      if (screenshotView.size.width < cW) {
        left = 0;
      } else if (left > lgap) {
        left = lgap + 10;
      }

      if (screenshotView.size.height < cH) {
        top = 0;
      } else if (top > tgap) {
        top = tgap;
      }

      if (left < 0) left = 0;
      if (top < 0) top = 0;

      if (isIE) {
        $screenshot.css('margin', '0');
        $svgImage.attr({
          width: screenshotView.size.width,
          height: screenshotView.size.height,
          x: -left,
          y: -top
        });

      } else {
        $screenshot.css('background-position', -left + 'px ' + -top + 'px');
      }

      $screenshot.css('background-color', this.getCommonColour(screenshotView));

    }, this);
    screenshotView.setStep(step);

  },

  // common colour is cached since screenshot is supposed to don't change
  // and calculating it every time is expensive.
  getCommonColour: function(screenshotView) {
    var commonColour;

    if (typeof this.commonColour != 'undefined') {
      commonColour = this.commonColour;
    } else {
      commonColour = this.commonColour = screenshotView.getCommonColour();
    }

    return commonColour;
  }

});

;
iorad.player.views.meta_mobile_finished = iorad.player.views.meta_cover.extend({
  template: iorad.player.templates.meta_mobile_finished,

  events: {
  },

  initialize: function() {
    iorad.player.views.meta_cover.prototype.initialize.apply(this, arguments);

    this.listenTo(iorad.player.events, 'ready:mobilequick', this.render);
    this.hideLayer();
    this.listenTo(iorad.player.events, 'slide_stop_with_no_index', function() {
      this.showLayer();
    });
    this.listenTo(
      this.model,
      [
        'change:recommendedEnabled',
        'change:direct_is_recommended_disabled',
        'change:embed_is_recommended_disabled',
        'change:widget_is_recommended_disabled'
      ],
      this.updateRecommendedTutorials
    );
  },

  showLayer: function() {
    this.$el.removeClass('hide');
  },

  hideLayer: function() {
    this.$el.addClass('hide');
  },

  getTemplateData: function() {
    var templateData = iorad.player.views.meta_cover.prototype.getTemplateData.apply(this, arguments);
    return _.extend(templateData, {});
  },

  rerender: function() {
    var attributesToRerender = [];
    if (
      _.intersection(
        this.model.changedAttributes(),
        attributesToRerender
      ).length > 0
    ) {
      return this.render();
    }
    this.updateRecommendedTutorials();
  },

  render: function() {
    if (this.recommendedTutorialsView) {
      this.recommendedTutorialsView.$el.detach();
    }

    iorad.player.views.meta_cover.prototype.render.apply(this, arguments);

    if (!this.recommendedTutorialsView) {
      this.recommendedTutorialsView = new iorad.player.views.layout_recommended_tutorials({
        model: this.model,
        collection: this.collection,
        el: this.$('.recommended-tutorials'),
      });
    } else {
      this.$('.recommended-tutorials').replaceWith(this.recommendedTutorialsView.$el);
    }
    this.updateRecommendedTutorials();

    return this;
  },

  updateRecommendedTutorials: function () {
    if (!this.recommendedTutorialsView) return; // too early
    this.recommendedTutorialsView.toggle(Boolean(
      !window.downloadPlayerType &&
      this.model.get('recommendedEnabled') &&
      !this.model.getLayoutOption('is_recommended_disabled')
    ));
  },
});

;
iorad.player.views.meta_interactive = iorad.base.View.extend({
  template: iorad.player.templates.meta_interactive,

  initialize: function() {
    this.render();

    this.listenTo(this.collection, 'changeCurrent reset', this.onCurrentStepChange);
    this.listenTo(iorad.player.events, 'ready:interactive', this.onCurrentStepChange);
    this.listenTo(iorad.player.events, 'change:stepPanel', function () { this.updateInteractiveNav(); });
    this.onCurrentStepChange();
  },

  onCurrentStepChange: function() {
    var currentStep = this.collection.getCurrentModel();
    if (!currentStep) return;
    this.$el.attr('data-type', currentStep.get('type'));
  },

  render: function() {
    const $autoplayCursor = this.$('#autoplay-cursor');
    if ($autoplayCursor.length) $autoplayCursor.detach();

    iorad.base.View.prototype.render.apply(this, arguments);

    if ($autoplayCursor.length) {
      // the autoplay cursor is added in this view DOM by the "autoplay" controller
      // => prevent it from being removed on re-render
      this.$el.prepend($autoplayCursor);
    }

    this.interactiveSlide = new iorad.player.views.steps_interactive_slide({
      collection: this.collection,
      model: this.model,
      el: '#interactive-image'
    });

    this.stepsInteractiveNav = new iorad.player.views.steps_interactive_nav({
      model: this.model,
      collection: this.collection,
      el: '.stepnav'
    });

    this.infotextView = new iorad.player.views.step_infotext({
      collection: this.collection,
      mode: 'interactive',
    });
    this.$('.step-infotext').replaceWith(this.infotextView.$el);

    this.setupRecommendedTutorialsView();

    this.$('#interactive-nav').draggable({
      handle: '.start-step',
      containment: $('#playing-player'),
      scroll: true,
      scrollSensitivity: 10,
      scrollSpeed: 10,
    });
    this.updateInteractiveNav();

    return this;
  },

  setupRecommendedTutorialsView: function () {
    this.recommendedTutorialsView = new iorad.player.views.layout_recommended_tutorials({
      model: this.model,
      collection: this.collection,
      el: this.$('.recommended-tutorials'),
    });

    var stepCompleted;
    var waitStartTimeStamp;
    var waitEndTimeStamp;
    var MIN_WAIT_MS = 4000;
    var timeout;
    var check = _.bind(function () {
      var shouldShow = Boolean(
        !window.downloadPlayerType &&
        iorad.player.getParameters.videoExport !== 'true' &&
        iorad.player.tab !== 'quiz' &&
        this.model.get('recommendedEnabled') &&
        !this.model.getLayoutOption('is_recommended_disabled') &&
        (!this.model.get('quizEnabled') || this.model.getLayoutOption('is_quizsteps_disabled')) && // don't show when "Quiz Starter" should be shown
        stepCompleted &&
        this.collection.position >= this.collection.length - 1 // last step
      );
      clearTimeout(timeout);
      timeout = undefined;
      if (shouldShow) {
        waitEndTimeStamp = Date.now();
        var waitedMS = waitEndTimeStamp - waitStartTimeStamp;
        var remainingWaitMS = Math.max(0, MIN_WAIT_MS - waitedMS);
        timeout = setTimeout(() => {
          timeout = undefined;
          this.recommendedTutorialsView.toggle(true);
          iorad.player.controllers.views.collapseStepPanel();
        }, remainingWaitMS);
      } else {
        waitStartTimeStamp = Date.now();
        this.recommendedTutorialsView.toggle(false);
      }
    }, this);
    this.listenTo(
      this.model,
      [
        'change:recommendedEnabled',
        'change:direct_is_recommended_disabled',
        'change:embed_is_recommended_disabled',
        'change:widget_is_recommended_disabled',

        'change:quizEnabled',
        'change:direct_is_quizsteps_disabled',
        'change:embed_is_quizsteps_disabled',
        'change:widget_is_quizsteps_disabled'
      ],
      _.bind(function () {
        check();
      }, this)
    );
    this.listenTo(iorad.player.events, 'interactive:stepCompleted', _.bind(function (newStepCompleted) {
      if (newStepCompleted !== stepCompleted) {
        stepCompleted = newStepCompleted;
        check();
      }
    }, this));
  },

  updateInteractiveNav: function() {
    var interactiveNav = this.$('#interactive-nav');

    var full = $('html').attr('data-stepPanel') === 'full';
    var hideEverything = $('html').attr('data-stepPanel') === 'hideEverything';
    var draggableEnabled = (!full && !hideEverything);
    interactiveNav.draggable(draggableEnabled ? 'enable' : 'disable');
    if (!draggableEnabled) {
      interactiveNav.css({
        'position': '',
        'top': '',
        'left': '',
      });
    }
    interactiveNav.removeAttr('aria-disabled');
  },
});

;
iorad.player.views.meta_quick = iorad.base.View.extend({
  template: iorad.player.templates.meta_quick,

  initialize: function() {
    this.lazyCollection = new iorad.player.collections.LazyCollection(this.collection);

    this.listenTo(this.lazyCollection, 'add', this.onLazyCollectionAdd);

    this.listenTo(iorad.player.events, 'quick:back', this.moveToPreviousStep);
    this.listenTo(iorad.player.events, 'quick:next', this.moveToNextStep);
    this.listenTo(iorad.player.events, 'quick:goTo', this.moveTo);

    this.listenToDOM($('#main'), 'scroll', _.debounce(this.handleViewportChange, 250));
    this.listenToDOM($('#main'), 'scroll', _.debounce(this.onScroll, 250));
    this.listenToDOM($(window), 'resize', _.debounce(this.handleViewportChange, 250));
    this.listenTo(iorad.player.events, 'ready:quick', this.onReady);
    this.listenTo(iorad.player.events, 'tab:view', this.onTab);

    this.listenTo(iorad.player.events, 'sound:play', this._onSoundPlay);
    this.listenTo(iorad.player.events, 'sound:end', this._onSoundEnd);
    this.listenTo(iorad.player.events, 'sound:mute', this._onSoundMute);
    this.listenTo(iorad.player.events, 'sound:unmute', this._onSoundUnMute);
    this.listenTo(iorad.player.events, 'sound:loaderror', this._onSoundLoadError);
    this.listenTo(iorad.player.events, 'sound:load', this._onSoundLoad);

    this.listenTo(iorad.player.events, 'video:play', this._onVideoPlay);
    this.listenTo(iorad.player.events, 'video:end', this._onVideoEnd);
    this.listenTo(iorad.player.events, 'video:mute', this._onVideoMute);
    this.listenTo(iorad.player.events, 'video:unmute', this._onVideoUnMute);
    this.listenTo(iorad.player.events, 'video:loaderror', this._onVideoLoadError);
    this.listenTo(iorad.player.events, 'video:load', this._onVideoLoad);

    this.listenTo(iorad.player.controllers.screenshots, 'change:zoom', this.update);

    this.listenTo(this.model, 'change', this.update);
    this.listenTo(this.collection, 'changeCurrent', this.onChangeCurrent);
    this.listenTo(iorad.player.events, 'device', this.update);
    this.listenTo(iorad.player.data.markerColors, 'change', this.update);
    this.listenTo(
      this.model,
      [
        'change:recommendedEnabled',
        'change:direct_is_recommended_disabled',
        'change:embed_is_recommended_disabled',
        'change:widget_is_recommended_disabled'
      ],
      this.update // for updateFinish
    );

    this.listenTo(this.collection, 'reset', _.debounce(this.handleViewportChange));

    this.isReplay = false;

    var client = new Clipboard('.copy-link-btn');
    client.on('success', this.onCopySuccess);

    this.render();
  },

  events: {
    'click .button.live': 'onGoLiveClick',
    'click #to-top': 'onToTopClick',
  },

  onReady: function () {
    iorad.player.controllers.video.toggleVideo(true);
    iorad.player.controllers.video.toggleDisplay(true);
    if (
      iorad.player.mode === 'quick' &&
      !iorad.player.controllers.video.videoPaused
    ) {
      iorad.player.controllers.autoplay.pauseAutoplay();

      iorad.player.controllers.video.videoPaused = true;
    }

    this.checkSteps();
    this.handleViewportChange();
  },

  onTab: function () {
    this.checkSteps();
  },

  onScroll: function() {
    if (iorad.player.mode !== 'quick') return;
    if (this.isReplay) {
      this.isReplay = false;
      return;
    }
    if ($('#main')[0].scrollTop === 0 && iorad.player.device !== 'desktop') {
      iorad.player.controllers.views.setCoverOpen(true);
    }
  },

  checkProgress: function() {
    var TOP_MARGIN = 0;
    var BOTTOM_MARGIN = 0;
    var stepElements = this.$('.steps').children().toArray();
    var visibleStepIndexes = stepElements.filter(_.bind(function(stepEl) {
      var stepElBounds = stepEl.getBoundingClientRect();
      var stepElBottom = stepElBounds.top + stepElBounds.height;
      return (stepElBottom > TOP_MARGIN && stepElBottom <= window.innerHeight - BOTTOM_MARGIN);
    }, this)).map(_.bind(function(stepEl) {
      return $(stepEl).index();
    }, this)).sort(function(a, b) { return a - b; }); // ASC sort
    var newVisibleStepIndexes = _.difference(visibleStepIndexes, this.oldVisibleStepIndexes || []);

    if (!iorad.player.notracking) {
      newVisibleStepIndexes.forEach(_.bind(function(stepIndex) {
        iorad.player.controllers.statistics.sendProgress(stepIndex);
        if (stepIndex === iorad.player.data.stepsCollection.length - 1) {
          iorad.player.controllers.statistics.sendComplete();
        }
      }, this));
    }

    this.oldVisibleStepIndexes = newVisibleStepIndexes;

    var scrollTop = $('#main')[0].scrollTop;
    var scrolledAll = $('#main')[0].scrollTop + $('#main')[0].clientHeight >= $('#main')[0].scrollHeight - 50;

    var currentStepNumber = this.collection.getCurrentStepNumber();
    var newCurrentStepNumber = (scrollTop === 0)
      ? 1
      : (scrolledAll && this.lazyCollection.length === this.collection.length)
        ? this.collection.length
        : (visibleStepIndexes.length === 0)
          ? currentStepNumber // keep current value
          : (visibleStepIndexes[0] + 1);
    if (
      newCurrentStepNumber !== currentStepNumber &&
      (Howler._muted && iorad.player.videoMuted)
    ) {
      this.collection.setCurrentStep(newCurrentStepNumber);
    }
  },

  onGoLiveClick: function (event) {
    event.preventDefault();
    iorad.player.controllers.live.tryLive();
  },

  onToTopClick: function (event) {
    event.preventDefault();
    iorad.player.events.trigger('quick:goTo', 0);
  },

  onChangeCurrent: function() {
    this.update();
  },

  getTemplateData: function() {
    var templateData = iorad.base.View.prototype.getTemplateData.apply(this, arguments);

    return _.extend(templateData, {
      isMobileDevice: iorad.player.device !== 'desktop',
      isGoLiveAvailable: this.model.isGoLiveAvailable(),
      isSharingDisabled: this.model.isSharingDisabled(),
      showFinishPlaceholder: this.lazyCollection.length === this.collection.length,
      showFinishSection: true,
    });
  },

  render: function() {
    // remove sub-views
    if (this.quickStepList) this.quickStepList.$el.detach();

    iorad.base.View.prototype.render.apply(this, arguments);

    if (!this.quickStepList) {
      // create sub-view
      this.quickStepList = new iorad.player.views.steps_quick_step_list_lazy({
        collection: this.lazyCollection,
        el: this.$('.steps')
      });
    } else {
      // add back sub-view
      this.$('.steps').replaceWith(this.quickStepList.$el);
      // prevent flickering #3124
      this.$('.fade-in').addClass('no-animation');
    }

    this.checkProgress();

    iorad.player.controllers.sync.getPlayerURL()
      .then(_.bind(function(playerUrlData) {
        var shortLinkForQuick = iorad.base.Utils.replaceAll(
          playerUrlData.SHORT_LINK_IFRAME_HASH_TEMPLATE,
          encodeURIComponent('{{IORAD_IFRAME_HASH_PLACEHOLDER}}'),
          'viewsteps'
        );
        var publicLinkForQuick = iorad.base.Utils.replaceAll(
          playerUrlData.PUBLIC_LINK_IFRAME_HASH_TEMPLATE,
          encodeURIComponent('{{IORAD_IFRAME_HASH_PLACEHOLDER}}'),
          'viewsteps'
        );
        var embedForQuick = iorad.base.Utils.replaceAll(
          playerUrlData.EMBED_IFRAME_HASH_TEMPLATE,
          encodeURIComponent('{{IORAD_IFRAME_HASH_PLACEHOLDER}}'),
          'viewsteps'
        );

        this.$('.copy-short-tut-link').attr('data-clipboard-text', shortLinkForQuick || publicLinkForQuick);
        this.$('.copy-embed-tut-link').attr('data-clipboard-text', embedForQuick);
      }, this));

    if (!this.recommendedTutorialsView) {
      this.recommendedTutorialsView = new iorad.player.views.layout_recommended_tutorials({
        model: this.model,
        collection: this.collection,
        el: this.$('.recommended-tutorials'),
      });
    }

    this.update();

    return this;
  },

  update: function() {
    var data = this.getTemplateData();

    this.updateFinish(data);
  },

  updateFinish: function(data) {
    var finishEl = this.$('.finish');
    finishEl.toggle(Boolean(data.showFinishPlaceholder));
    if (data.showFinishPlaceholder) {
      finishEl.find('.button.live').toggle(Boolean(
        !data.isMobileDevice &&
        data.isGoLiveAvailable
      ));

      finishEl.find('.copy-short-tut-link').toggle(Boolean(
        !data.isSharingDisabled
      ));

      finishEl.find('.copy-embed-tut-link').toggle(Boolean(
        !data.isMobileDevice
      ));
    }

    this.$('.btn-overlay.finished').toggle(Boolean(
      !data.showFinishSection
    ));

    this.recommendedTutorialsView.toggle(Boolean(
      !window.downloadPlayerType &&
      this.model.get('recommendedEnabled') &&
      !this.model.getLayoutOption('is_recommended_disabled')
    ));
  },

  onCopySuccess: function(event) {
    var button = $(event.trigger);
    var html = button.hasClass('copy-short-tut-link')
      ? i18next.t('Copy Link')
      : button.hasClass('copy-embed-tut-link')
        ? i18next.t('Copy Embed')
        : button.find('.copy-link-text').html();

    button.find('.copy-link-text').html(i18next.t('Copied'));
    button.addClass('active');

    setTimeout(function () {
      button.css('color', 'transparent');
      setTimeout(function () {
        button.css('color', '');
        button.find('.copy-link-text').html(html);
        button.removeClass('active');
      }, 150);
    }, 2850);
  },

  onLazyCollectionAdd: function() {
    this.checkSteps();
  },

  checkSteps: function () {
    if (Howler._muted && iorad.player.videoMuted) { // (audio/video have their own checks in other handlers)
      setTimeout(_.bind(function () { // HACK: wait for views to be rendered
        this.$('.steps>div:not([class])').addClass('fade-in');
      }, this), 200);
    }

    if (this.lazyCollection.length === this.collection.length) {
      // all steps loaded
      this.$('.finished').show();
      this.update(); // for new finish (showFinishPlaceholder)
    }
  },

  handleViewportChange: function() {
    if (iorad.player.mode !== 'quick') return;

    this.bindStepHoverEvents();
    this.checkProgress();
  },

  setCurrentStepEl: function(stepEl, ignoreAudio, ignoreVideo) {
    stepEl = $(stepEl);
    // We disabled auto play, thus we always need to set this to true (#3849)
    ignoreAudio = true;
    ignoreVideo = true;

    this._clearAutoPlayTimer();

    if (!stepEl.length) return; // too early

    // var stepModel = this.collection.getCurrentModel();
    // do not change step on scroll if current step has audio
    // if (stepModel && stepModel.get('audioModTime') && ignoreAudio !== true) return;
    // if (this.sound) {
    //   this.sound.stop();
    // }
    // do not change step on scroll if current step has video
    // if (stepModel && stepModel.get('videoModTime') && ignoreVideo !== true) return;
    // if (this.video) {
    //   this.video.stop();
    // }

    if (Howler._muted && iorad.player.videoMuted) {
      this.$('.steps>div:not([class])').addClass('fade-in');
    } else {
      this.$('.steps').children().not(stepEl).removeClass().addClass('fade-out');
    }

    var stepNumber = stepEl.index() + 1;
    this.collection.setCurrentStep(stepNumber);
    if (!iorad.player.videoMuted) {
      this._onVideoPlay(); // fake for video loading time
    } else {
      this._onSoundPlay(); // fake for audio loading time
    }
  },

  // current step: first whose total height is in the view port  whose bottom is in the viewport
  getCurrentScrolledStepEl: function() {
    var mainEl = $('#main');
    var stepElements = this.$('.steps').children().toArray();
    var isBotttom = Math.floor(mainEl[0].scrollHeight - mainEl[0].scrollTop) === Math.floor(mainEl[0].offsetHeight);

    var
      mainOffsetTop = mainEl.offset().top,
      secondStepEl;

    var firstStepEl = _.find(stepElements, function(stepEl) {
      var $stepEl = $(stepEl);
      var bottom = $stepEl.offset().top + $stepEl.height();
      secondStepEl = stepElements[stepElements.indexOf(stepEl) + 1];
      return bottom >= mainOffsetTop;
    });
    var firstOffset = firstStepEl ? $(firstStepEl).offset() : null;
    var secondOffset = secondStepEl ? $(secondStepEl).offset() : null;

    if (isBotttom && secondStepEl) {
      return $(secondStepEl);
    } else if (firstOffset && firstOffset.top + 10 >= mainOffsetTop) {
      return $(firstStepEl);
    } else if (secondStepEl && secondOffset) {
      //return the 2nd StepEl if it is within view
      var
        $secondStepEl = $(secondStepEl),
        secondBottom = secondOffset.top + $secondStepEl.height(),
        mainBottom = mainOffsetTop + mainEl.height();

      if (secondOffset.top >= mainOffsetTop && secondBottom <= mainBottom) {
        return $secondStepEl;
      }
    }

    return $(firstStepEl);
  },

  // when hover over step trigger audio/video for that step
  bindStepHoverEvents: function() {
    if (this.stepHoverListeners) {
      _.each(this.stepHoverListeners, _.bind(function(listener) {
        listener[0].off.apply(listener[0], listener.slice(1));
      }, this));
      this.stepHoverListeners = [];
    }

    var stepElements = this.$('.steps').children().toArray();
    this.stepHoverListeners = _.map(stepElements, _.bind(function(stepEl) {
      return [$(stepEl), 'mouseenter touchend focusin', this.onStepHover.bind(this, stepEl)];
    }, this));

    _.each(this.stepHoverListeners, _.bind(function(listener) {
      listener[0].on.apply(listener[0], listener.slice(1));
    }, this));
  },

  onStepHover: function(stepEl) {
    if (!Howler._muted || !iorad.player.videoMuted) {
      this.setCurrentStepEl(stepEl, true, true);
    }
  },

  scrollToStepEl: function(stepEl, time, easing, onComplete) {
    stepEl = $(stepEl);
    var mainEl = $('#main');

    mainEl.stop().animate({
      scrollTop: mainEl.scrollTop() + stepEl.offset().top - mainEl.offset().top,
    }, time, easing, onComplete);
  },

  _onSoundPlay: function(sound) {
    if (Howler._muted) return;

    var currentPosition = this.collection.position;
    var $currentStepEl = $(this.$('.steps').children()[currentPosition]);
    $currentStepEl.removeClass().addClass('fade-in');
  },

  _onVideoPlay: function(video) {
    if (iorad.player.videoMuted) return;

    var currentPosition = this.collection.position;
    var $currentStepEl = $(this.$('.steps').children()[currentPosition]);
    $currentStepEl.removeClass().addClass('fade-in');
  },

  _onSoundEnd: function(sound) {
    delete this.sound;
    //no auto advance, see: https://github.com/iorad/iorad/issues/3165
    // if (!Howler._muted && (this.collection.position < this.collection.length - 1) &&
    //     iorad.player.mode === 'quick') {
    //   var currentPosition = this.collection.position,
    //     $currentStepEl = $(this.$('.steps').children()[currentPosition]);
    //     $currentStepEl.removeClass().addClass('fade-out');
    //   // if (this.useAutoPlay()) this.autoPlay();
    //     this.moveToNextStep();
    // }
  },

  _onVideoEnd: function(video) {
    delete this.video;
    //no auto advance, see: https://github.com/iorad/iorad/issues/3165
    // if (!iorad.player.videoMuted && (this.collection.position < this.collection.length - 1) &&
    //     iorad.player.mode === 'quick') {
    //   var currentPosition = this.collection.position,
    //     $currentStepEl = $(this.$('.steps').children()[currentPosition]);
    //     $currentStepEl.removeClass().addClass('fade-out');
    //   // if (this.useAutoPlay()) this.autoPlay();
    //     this.moveToNextStep();
    // }
  },

  _onSoundMute: function(sound) {
    this.$('.steps').children().removeClass().addClass('fade-in');
  },

  _onVideoMute: function(video) {
    this.$('.steps').children().removeClass().addClass('fade-in');
  },

  _onSoundUnMute: function(sound) {
    var currentPosition = this.collection.position;
    var $currentStepEl = $(this.$('.steps').children()[currentPosition]);
    $currentStepEl.removeClass().addClass('fade-in');
    this.$('.steps').children().not($currentStepEl).removeClass().addClass('fade-out');
  },

  _onVideoUnMute: function(video) {
    var currentPosition = this.collection.position;
    var $currentStepEl = $(this.$('.steps').children()[currentPosition]);
    $currentStepEl.removeClass().addClass('fade-in');
    this.$('.steps').children().not($currentStepEl).removeClass().addClass('fade-out');
  },

  _onSoundLoad: function(sound) {
    var currentPosition = this.collection.position;
    var $currentStepEl = $(this.$('.steps').children()[currentPosition]);
    this.sound = sound;
    if (!Howler._muted) {
      this.$('.steps').children().not($currentStepEl).removeClass().addClass('fade-out');
    }
  },

  _onVideoLoad: function(video) {
    var currentPosition = this.collection.position;
    var $currentStepEl = $(this.$('.steps').children()[currentPosition]);
    this.video = video;
    if (!iorad.player.videoMuted) {
      this.$('.steps').children().not($currentStepEl).removeClass().addClass('fade-out');
    }
  },

  _onSoundLoadError: function(sound) {
    delete this.sound;
    //this.$('.steps').children().removeClass().addClass('fade-in');
    if (this.useAutoPlay()) this.autoPlay(); // with default delay
  },

  _onVideoLoadError: function(video) {
    delete this.video;
    //this.$('.steps').children().removeClass().addClass('fade-in');
    if (this.useAutoPlay()) this.autoPlay(); // with default delay
  },

  moveToPreviousStep: function() {
    return this.moveTo(this.collection.position - 1);
  },

  moveToNextStep: function() {
    return this.moveTo(this.collection.position + 1);
  },

  moveTo: function(stepIndex, options) {
    options = options || {};

    this.isReplay = true;
    if (stepIndex < 0 || stepIndex >= this.collection.length) {
      if (stepIndex < 0) {
        iorad.player.controllers.views.setCoverOpen(true);
      } else if (stepIndex >= this.collection.length) {
        $('.quick-view .finished').addClass('expanded');
      } else {
        $('.quick-view .finished').removeClass('expanded');
      }
      return;
    }

    // var currentPosition = this.collection.position;
    // var currentStepEl = this.$('.steps').children()[currentPosition];

    var check = _.bind(function() {
      var stepEl = this.$('.steps').children()[stepIndex];

      if (stepEl) {
        var self = this;
        this.scrollToStepEl(stepEl, options.animationTime, options.animationEasing || 'swing', function() {
          self.setCurrentStepEl(stepEl, true, true);
        });
      } else {
        // scroll to the bottom, lazy loading will load the next steps,
        // then try again
        var mainEl = $('#main');
        mainEl.stop().animate({
          scrollTop: mainEl[0].scrollHeight
        }, options.animationTime, options.animationEasing || 'swing', check);
      }
    }, this);
    check();
  },

  useAutoPlay: function() {
    return iorad.player.autoPlay && iorad.player.mode === 'quick';
  },

  // calculate the default waiting time for the current step (when not having audio/video).
  autoPlayDefaultDelay: function() {
    // one second per word
    var textDescription = this.getCurrentScrolledStepEl().find('.description').text();
    var wordsCount = iorad.base.Utils.countWords(textDescription);
    return wordsCount * 1000; // ms
  },

  _clearAutoPlayTimer: function() {
    if (typeof this.autoPlayTimer !== 'undefined') {
      clearTimeout(this.autoPlayTimer);
      this.autoPlayTimer = undefined;
    }
  },

  autoPlay: _.debounce(function(waitingTime) {
    if (typeof waitingTime === 'undefined') {
      waitingTime = this.autoPlayDefaultDelay();
    }

    this._clearAutoPlayTimer();
    this.autoPlayTimer = setTimeout(_.bind(function() {
      if (!this.useAutoPlay()) return; // too late
      this.moveToNextStep();
    }, this), waitingTime);
  }, 100),
});

;
iorad.player.views.meta_print = iorad.base.View.extend({
  template: undefined, // MUST be setted by child types

  initialize: function() {
    this.pdfMakeComponent = new iorad.player.PdfMakeComponent();
    this.qrCodeStylingComponent = new iorad.player.QrStylingComponent();

    // excluding header and footer space (keep sure there is enough space for them!)
    this.pageMargins = [30, 100, 30, 60];

    this.headerBackgroundHeight = 85;

    // set right logo url after theme has been applied
    this.listenTo(iorad.player.events, 'theme:applied', this.render);

    var realAccountType = this.model.get('editor_account_type') || // in case editor is previewing a theme (#2986)
      this.model.get('account_type');
    var isAccountNonFree = realAccountType !== 'free'; // this means a non-free user (private, premium or live plan). Yes it's misleading.
    this.isOrWasPremium = this.model.get('isPremiumTutorial') || isAccountNonFree;

    // <language code, language name>
    this.supportedLanguages = {
      'ar': 'arabic',
      'zh-cn': 'chinese', // (simplified)
      'zh-tw': 'chinese', // HACK: use simplified no matter what since we only support that
      'ko': 'korean',
      'hi': 'hindi',
      'ja': 'japanese',
    };

    this.listenTo(this.model, 'change', this.render);
    this.render();
  },

  getLogoImageData: function(options) {
    options = options || {};

    var defaultLogoEl = this.$('.resources .logo-default');
    var defaultLogoUrl = iorad.base.Utils.getBackgroundImageUrl(defaultLogoEl);

    var isCustomLogo;
    var logoUrl;
    var logoEl = $('#logo');
    if (!options.useDefault) {
      // custom logo
      logoUrl = logoEl.find('.logo-image').attr('src');
      isCustomLogo = true;
    } else {
      // default logo, use non-svg version (fixes IE bug)
      logoUrl = defaultLogoUrl;
      isCustomLogo = false;
    }

    return iorad.base.Utils.getUrlImageData(logoUrl, iorad.player.disableCORS)
      .catch(_.bind(function(err) {
        if (isCustomLogo) {
          // fallback to default logo
          return iorad.base.Utils.getUrlImageData(defaultLogoUrl, iorad.player.disableCORS);
        }

        return Promise.reject(err);
      }, this));
  },

  getSlideImageCommonColor: function(slideView) {
    var screenshotCanvas = slideView.$('.stepimg .screenshot-canvas')[0];

    var commonColor = iorad.base.Utils.mostCommonColor(screenshotCanvas);
    return Promise.resolve(commonColor);
  },

  // needed for RTL languages (e.g. arabic)
  // NOTE: this doesn't work for multiline texts as pdfmake will break the right part of the line instead that the left one.
  getDisplayedText: function (source) {
    if (!source) return '';

    // Credits https://stackoverflow.com/a/44699154
    // Get rendered text with rtl direction if any
    const handle = (container) => {
      var r = document.createRange(); // to get our nodes positions

      var nodes = []; // first grab all the nodes
      var treeWalker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null, false);
      while (treeWalker.nextNode()) nodes.push(treeWalker.currentNode);

      var chars = []; // then get all its contained characters
      nodes.forEach(n => {
        n.data.split('').forEach((c, i) => {
          r.setStart(n, i); // move the range to this character
          r.setEnd(n, i + 1);
          chars.push({
            text: c,
            rect: r.getBoundingClientRect() // save our range's DOMRect
          });
        });
      });

      return chars.filter(c => c.rect.height) // keep only the displayed ones (i.e no script textContent)
        .sort((a, b) => { // sort ttb ltr
          if (a.rect.top === b.rect.top) {
            return a.rect.left - b.rect.left;
          }
          return a.rect.top - b.rect.top;
        })
        .map(n => n.text)
        .join('');
    };

    const langIsRTL = false; // DISABLED FOR NOW // $('html').hasClass('translated-rtl');
    if (source instanceof HTMLElement) {
      if (!langIsRTL) return $(source).text();
      return handle(source);
    }
    // source is text
    if (!langIsRTL) return source;
    const parser = document.createElement('div');
    parser.style.direction = 'rtl';
    parser.style.textAlign = 'right';
    parser.style.whiteSpace = 'nowrap'; // as single line
    //parser.style.unicodeBidi = 'bidi-override'; // make sure it's rendered as rtl even if the text itself is ltr (e.g "1 of 3" => "3 fo 1")
    parser.className = 'notranslate';
    parser.innerText = source;
    document.body.appendChild(parser);
    try {
      return handle(parser);
    } finally {
      document.body.removeChild(parser);
    }
  },

  getElementPdfText: function(element, options) {
    element = $(element);
    options = options || {};
    var me = this;

    if (typeof options.fontSize === 'undefined') options.fontSize = 10;

    function computeElementPdfStyle(currentElement) {
      currentElement = $(currentElement);

      var color = currentElement.css('color');
      if (typeof color !== 'undefined') {
        color = iorad.base.Export.colorToHexTriplet(color);
      }

      var fontWeight = currentElement.css('font-weight');
      var bold = (fontWeight === 'bold' || fontWeight === 'bolder' ||
        (!isNaN(fontWeight) && parseInt(fontWeight, 10) >= 600));

      var fontStyle = currentElement.css('font-style');
      var italics = (fontStyle == 'italic');

      var closestAElement = currentElement.closest('A', element);
      var link = closestAElement.length > 0
        ? closestAElement.attr('href')
        : undefined;

      var decorationElement = closestAElement.length > 0 ? closestAElement : currentElement;
      var underlineTextDecoration = decorationElement.css('text-decoration') === 'underline';
      var borderBottomWidth = parseInt(decorationElement.css('border-bottom-width'), 10);
      var borderBottomColor = decorationElement.css('border-bottom-color');
      var decoration;
      var decorationColor;
      if (underlineTextDecoration || borderBottomWidth) {
        decoration = 'underline';
        decorationColor = (!underlineTextDecoration && borderBottomWidth)
          ? iorad.base.Export.colorToHexTriplet(borderBottomColor)
          : undefined;
      }

      var backgroundColor;
      var closestUElement = currentElement.closest('U', element);
      if (closestUElement.length > 0) {
        backgroundColor = closestUElement.css('background-color');
        backgroundColor = iorad.base.Export.colorToHexTriplet(backgroundColor);
      }

      var textAlign = currentElement.css('text-align');
      var alignment = textAlign === 'right' ? 'right'
        : textAlign === 'center' ? 'center'
          : 'left';

      var pdfStyle = {
        background: backgroundColor,
        color: color,
        bold: bold,
        italics: italics,
        decoration: decoration,
        decorationColor: decorationColor,
        link: link,
        alignment: alignment,
        ...options,
      };
      return pdfStyle;
    }

    // See https://github.com/iorad/iorad/issues/5832#issuecomment-375863898
    // https://github.com/bpampuch/pdfmake/issues/890
    // word breaking doesn't always work for long alphanumeric strings,
    // fix this by forcing breaking.
    function makeBreakable(text) {
      return text.replace(/[^\s]+/g, _.bind(function(word) {
        if (word.length > 20) return word.split('').join('\u200b');
        return word;
      }, this));
    }

    function getChildNodesText(parentNode, style) {
      var text = [];

      if (parentNode.nodeType === Node.ELEMENT_NODE) {
        style = computeElementPdfStyle(parentNode);
      }

      var childNodeList = parentNode.childNodes; // NodeList
      for (var i = 0; i < childNodeList.length; i++) {
        var childNode = childNodeList[i];
        var lastInlineText = text;

        var isInlineNode = ['SPAN', 'B', 'I', 'U', 'A'].includes(childNode.tagName) || childNode.nodeType === Node.TEXT_NODE;
        if (isInlineNode) {
          // Combine multiple inline nodes into `{ text: []Node }` structure instead of `[]Node`
          // To avoid new lines
          var lastNode = text[text.length - 1];
          if (!lastNode || !lastNode._inline || !Array.isArray(lastNode.text)) {
            lastInlineText = [];
            text.push({
              text: lastInlineText,
              _inline: true,
            });
          } else {
            lastInlineText = lastNode.text;
          }
        }

        if (childNode.nodeType === Node.TEXT_NODE) {
          // base
          // (style is that of the closest parent element)
          var childNodeText = _.extend({
            text: makeBreakable(childNode.textContent),
            fontSize: options.fontSize,
            _childNode: childNode,
          }, style);
          lastInlineText.push(childNodeText);
        } else {
          // recursion: append all the text of the node children
          if (childNode.tagName === 'UL') {
            text.push({
              ul: getChildNodesText(childNode, style)
            });
          } else if (childNode.tagName === 'OL') {
            text.push({
              ol: getChildNodesText(childNode, style)
            });
          } else if (childNode.tagName === 'LI') {
            // each LI is its own separate array item (no flat)
            text.push(getChildNodesText(childNode, style));
            // text.push({
            //   text: getChildNodesText(childNode, style),
            // });
          } else if (childNode.tagName === 'BR') {
            text.push('\n');
          } else {
            Array.prototype.push.apply(lastInlineText, getChildNodesText(childNode, style));
          }
        }
      }

      return text;
    }
    const pdfTexts = getChildNodesText(element[0]);

    // reverse consecutive sequences of texts
    // NOTE: this won't work for multiline texts as pdfmake will break the right part of the line instead that the left one.
    const listRoRTL = (list) => {
      const newList = [];
      let rtlSequence = [];
      const r = document.createRange(); // to get our nodes positions
      const endSequence = () => {
        // sort rtl sequence by display order
        if (!rtlSequence.length) return;
        rtlSequence.sort((a, b) => {
          if (a.charBounds.top === b.charBounds.top) {
            return a.charBounds.left - b.charBounds.left;
          }
          return a.charBounds.top - b.charBounds.top;
        });

        // Improvement: merge together consecutive characters having the same _childNode
        const mergedRtlSequence = [];
        for (let i = 0; i < rtlSequence.length; i += 1) {
          const rtlItem = rtlSequence[i];
          const lastMergedRtlItem = mergedRtlSequence[mergedRtlSequence.length - 1];
          if (lastMergedRtlItem && lastMergedRtlItem.item._childNode === rtlItem.item._childNode) {
            lastMergedRtlItem.text += rtlItem.char;
          } else {
            mergedRtlSequence.push({
              ...(_.omit(rtlItem, 'char')),
              text: rtlItem.char,
            });
          }
        }

        newList.push(...(mergedRtlSequence.map(rtlItem => {
          return {
            ...(_.omit(rtlItem.item, '_childNode')),
            text: rtlItem.text,
          };
        })));
        rtlSequence = [];
      };

      for (let i = 0; i < list.length; i += 1) {
        const item = list[i];
        if (item === '\n') {
          // end of rtl sequence, e.g. '\n'
          // just add as is
          endSequence();
          newList.push(item);
        } else if (item.ul) {
          // end of rtl sequence
          // => recursive call
          endSequence();
          newList.push({
            ...item,
            ul: item.ul.map((subList) => listRoRTL(subList)),
          });
        } else if (item.ol) {
          // end of rtl sequence
          // => recursive call
          endSequence();
          newList.push({
            ...item,
            ol: item.ol.map((subList) => listRoRTL(subList)),
          });
        } else {
          // start of rtl sequence
          const chars = item._childNode.textContent.split('');
          for (let charIndex = 0; charIndex < chars.length; charIndex += 1) {
            const char = chars[charIndex];
            r.setStart(item._childNode, charIndex); // move the range to this character
            r.setEnd(item._childNode, charIndex + 1);
            const charBounds = r.getBoundingClientRect();
            rtlSequence.push({
              item,
              char,
              charBounds,
            });
          }
        }
      }
      endSequence();
      return newList;
    };
    const langIsRTL = false; // DISABLED FOR NOW // $('html').hasClass('translated-rtl');
    if (!langIsRTL) return pdfTexts;
    const rtlPdfTexts = listRoRTL(pdfTexts);
    return rtlPdfTexts;
  },

  drawMarkersOnCanvas: function(slideView, croppedCanvas, screenshotCropBounds) {

    var markerElList = slideView.$('.marker').toArray();
    _.each(markerElList, function(markerEl) {
      markerEl = $(markerEl);

      var markerBounds = iorad.base.Utils.getElementBounds(markerEl, {
        useCSSForEl: true
      });
      // make bounds relative to the cropped canvas
      markerBounds.left = markerBounds.left - screenshotCropBounds.left;
      markerBounds.top = markerBounds.top - screenshotCropBounds.top;

      var isMarkerInView = markerBounds.left >= 0 && markerBounds.top >= 0 && markerBounds.left <= screenshotCropBounds.width && markerBounds.top <= screenshotCropBounds.height;
      if (isMarkerInView) {

        // draw the marker

        var borderColor = markerEl.css('border-left-color'); // specific border to make it work on FF too
        var borderWidth = parseInt(markerEl.css('border-left-width'), 10);

        // canvas draws border inside rectangular when we need it outside
        // so we expand marker by borderWidth
        var left = Math.max(0, markerBounds.left - borderWidth);
        var top = Math.max(0, markerBounds.top - borderWidth);
        var width = Math.min(
          screenshotCropBounds.width,
          markerBounds.width + borderWidth * 2
        );
        var height = Math.min(
          screenshotCropBounds.height,
          markerBounds.height + borderWidth * 2
        );

        var ctx = croppedCanvas.getContext("2d");
        ctx.beginPath();
        ctx.lineWidth = borderWidth;
        ctx.strokeStyle = borderColor;
        ctx.rect(left, top, width, height);
        ctx.stroke();
      }
    }, this);

    return croppedCanvas;
  },

  // default implementation: use the whole screenshot
  getScreenshotCropBounds: function(slideView) {
    var screenshotCanvas = slideView.$('.stepimg .screenshot-canvas')[0];

    return {
      left: 0,
      top: 0,
      width: screenshotCanvas.width,
      height: screenshotCanvas.height
    };
  },

  // convert slide screenshot and markers to an image
  getSlideImageData: function(slideView) {
    var screenshotCanvas = slideView.$('.stepimg .screenshot-canvas')[0];
    var screenshotCropBounds = this.getScreenshotCropBounds(slideView);

    var screenshotCroppedCanvas = iorad.base.Utils.cropCanvas(screenshotCanvas,
      screenshotCropBounds);

    // add markers
    screenshotCroppedCanvas = this.drawMarkersOnCanvas(slideView, screenshotCroppedCanvas,
      screenshotCropBounds);

    var slideImageData = screenshotCroppedCanvas.toDataURL("image/png");
    return Promise.resolve(slideImageData);
  },

  createPdfLayout: function(docDefinition) {

    docDefinition = _.extend(docDefinition, {
      pageSize: 'A4',
      pageMargins: this.pageMargins,

      styles: {
        header: {
          bold: true,
          fontSize: 16,
          //color: '#0D1232'
        },
        footer: {
          fontSize: 10,
          color: '#9C9C9C',
          lineHeight: 1
        }
      },

      defaultStyle: {
        fontSize: 10,
        color: '#717171'
      }
    });

    return Promise.resolve(docDefinition);
  },

  ptToPx: function(widthPt, heightPt) {
    var $div = $(document.createElement('div'));

    $div.width(widthPt + 'pt');
    $div.height(heightPt + 'pt');

    $('body').append($div);

    var widthPx = $div.width();
    var heightPx = $div.height();

    $div.remove();

    return {
      width: widthPx,
      height: heightPx,
    };
  },

  getHeaderBackground: function(options) {
    options = options || {};

    var canvasSize = this.ptToPx(this.headerBackgroundWidth, this.headerBackgroundHeight);

    var canvas = document.createElement('canvas');
    canvas.width = canvasSize.width;
    canvas.height = canvasSize.height;

    var context = canvas.getContext('2d');

    var tc = iorad.player.controllers.views.getThemeColors();
    var mask = tc.header.mask;
    var maskType = tc.header.headerMaskColor;

    var backgroundColor = options.useDefault ? '#ffffff' : tc.header.coverBackground;
    var contrastColor = options.useDefault ? '#000000' : tc.header.font;

    var promise;
    if (!options.useDefault && tc.header.coverBackgroundImage) {
      promise = iorad.base.Export.getUrlMaskedCanvas(tc.header.coverBackgroundImage, mask, maskType)
        .then(_.bind(function(maskedImgCanvas) {
          // resize to cover whole header
          var fullCanvas = document.createElement('canvas');
          fullCanvas.width = maskedImgCanvas.width;
          fullCanvas.height = maskedImgCanvas.height;
          while (fullCanvas.width < canvas.width || fullCanvas.height < canvas.height) {
            // increase size by keeping proportions
            fullCanvas.width += 1;
            fullCanvas.height += 1;
          }
          fullCanvas.getContext('2d').drawImage(maskedImgCanvas, 0, 0, fullCanvas.width, fullCanvas.height);

          // keep visible part
          context.drawImage(fullCanvas, 0, 0, canvas.width, canvas.height, 0, 0, canvas.width, canvas.height);
        }, this));
    } else {
      context.fillStyle = backgroundColor;
      context.fillRect(0, 0, canvas.width, canvas.height);
      promise = Promise.resolve();
    }

    return promise.then(_.bind(function() {
      return {
        image: canvas.toDataURL('image/png'),
        contrastColor: contrastColor,
        canvas,
      };
    }, this));
  },

  createPdfHeader: function(docDefinition) {
    var promise = Promise.all([
      this.getLogoImageData({ useDefault: this.isOrWasPremium === false }),
      this.getHeaderBackground({ useDefault: this.isOrWasPremium === false }),
    ])
      .then(([logoImageData, headerBackground]) => {
        var imageWidth = 70;
        var imageHeight = 30;
        var imageSeparatorWidth = 1;
        var secondColumnMargin = [20, 0, 0, 0];

        var backgroundImage = headerBackground.image;
        var backgroundContrastColor = headerBackground.contrastColor;

        docDefinition.header = () => {
          return [{
            image: backgroundImage,
            width: this.headerBackgroundWidth,
            height: this.headerBackgroundHeight,
            absolutePosition: { x: 0, y: 0 }
          }, {
            table: { // as a table to have the header background (fillColor)
              widths: ['100%'],
              body: [
                [ // single row
                  {
                    margin: [this.pageMargins[0], 20, this.pageMargins[2], 20],
                    // as a table to have the auto-span column
                    table: {
                      widths: [imageWidth + imageSeparatorWidth, 'auto'],
                      body: [
                        [ // single row
                          // Logo
                          {
                            // as a table to have borders used for the separator
                            table: {
                              widths: [imageWidth, imageSeparatorWidth],
                              body: [
                                [ // single row
                                  // image
                                  {
                                    image: logoImageData,
                                    width: imageWidth,
                                    height: 'auto',
                                    fit: [imageWidth, imageHeight]
                                  },
                                  // separator
                                  {
                                    text: ''
                                  }
                                ]
                              ],
                            },
                            layout: {
                              // borders only for the last column to create the separator
                              vLineWidth: (i, node) => {
                                return (i === 2) ? 1 : 0;
                              },
                              vLineColor: (i, node) => {
                                return backgroundContrastColor;
                              },
                              hLineWidth: (i, node) => {
                                return 0;
                              }
                            }
                          },
                          [
                            // Tutorial title
                            {
                              margin: secondColumnMargin,
                              text: this.getDisplayedText($('#header .title .text')[0]), // pick from header to use translated version
                              style: 'header',
                              color: backgroundContrastColor
                            },
                            // Author
                            {
                              margin: _.extend(_.clone(secondColumnMargin), {
                                1: 6 // margin-top
                              }),
                              text: this.model.getOption('is_info_disabled') ? '' : this.getDisplayedText(this.model.get('author')),
                              color: backgroundContrastColor
                            }
                          ]
                        ]
                      ]
                    },
                    layout: 'noBorders'

                  }
                ]
              ]
            },
            layout: 'noBorders'
          }];
        };

        return docDefinition;
      });
    return promise;
  },

  createPdfFooter: function(docDefinition) {
    var me = this;

    var ioradLogoWidth = 35;
    var ioradLogoHeight = 15;

    var asyncData = {
      ioradLogoData: this.getLogoImageData({
        useDefault: true
      })
    };

    var isOrWasPremium = this.isOrWasPremium;

    var promise = iorad.base.Utils.promiseHash(asyncData).then(function(data) {

      var updated = iorad.base.Utils.toLocalTime(me.model.get('updated'));
      var copyright = iorad.player.controllers.views.getCopyright();

      docDefinition.footer = function(currentPage, pageCount) {
        const updatedTextEl = me.$('.texts .updated-text');
        var columns = [{
          text: me.getDisplayedText(
            copyright ||
            // (me.model.getOption('is_info_disabled') ? '' : updated)
            (me.model.getOption('is_info_disabled') ? '' : me.getDisplayedText(updatedTextEl.length ? updatedTextEl.text() : updated)),
          ),
          style: 'footer',
        }];

        if (!isOrWasPremium) {
          columns.push({
            alignment: 'center',
            width: 'auto',
            columns: [{
              text: me.getDisplayedText('Powered By '),
              margin: [0, 0, 5, 0],
              style: 'footer'
            }, {
              image: data.ioradLogoData,
              width: ioradLogoWidth,
              fit: [ioradLogoWidth, ioradLogoHeight],
              margin: [0, 1, 0, 0]
            }],
          });
        }

        const pageTextEl = me.$(`.page-text .page-${currentPage}-of-${pageCount}`);

        columns.push({
          alignment: 'right',
          text: me.getDisplayedText(
            // currentPage.toString() + ' ' + i18next.t('of') + ' ' + pageCount.toString()
            (pageTextEl.length ?
              pageTextEl.text() :
              currentPage.toString() + ' ' + i18next.t('of') + ' ' + pageCount.toString()
            )
          ),
          style: 'footer'
        });
        return {
          margin: [me.pageMargins[0], 20, me.pageMargins[2], 20],
          columns: columns,
        };
      };

      return docDefinition;
    });
    return promise;
  },

  // default empty implementations
  createPdfContent: function(docDefinition) {
    return Promise.resolve(docDefinition);
  },

  createPdf: function(pdfMake) {
    if (this.pdf) return this.pdf;
    var me = this;
    var promise = Promise.resolve({})
      .then(me.createPdfLayout.bind(this))
      .then(me.createPdfHeader.bind(this))
      .then(me.createPdfFooter.bind(this))
      .then(me.createPdfContent.bind(this))
      .then(function(docDefinition) {
        // create pdf
        pdfMake.fonts = {
          // default
          Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Medium.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-MediumItalic.ttf'
          },

          // NOTE: we don't have italics & bolditalics
          arabic: {
            normal: 'Tajawal-Regular.ttf',
            bold: 'Tajawal-Bold.ttf',
            italics: 'Tajawal-Regular.ttf',
            bolditalics: 'Tajawal-Bold.ttf'
          },

          // NOTE: use a single version to optimize download time
          // (21MB!)
          chinese: {
            normal: 'NotoSansCJKsc-Regular.ttf',
            bold: 'NotoSansCJKsc-Regular.ttf',
            italics: 'NotoSansCJKsc-Regular.ttf',
            bolditalics: 'NotoSansCJKsc-Regular.ttf'
          },

          // NOTE: use a single version to optimize download time
          // (21MB!)
          korean: {
            normal: 'JejuGothic-Regular.ttf',
            bold: 'JejuGothic-Regular.ttf',
            italics: 'JejuGothic-Regular.ttf',
            bolditalics: 'JejuGothic-Regular.ttf'
          },

          // NOTE: we don't have italics & bolditalics
          hindi: {
            normal: 'NotoSansDevanagari-Regular.ttf',
            bold: 'NotoSansDevanagari-Bold.ttf',
            italics: 'NotoSansDevanagari-Regular.ttf',
            bolditalics: 'NotoSansDevanagari-Bold.ttf'
          },

          // NOTE: use a single version to optimize download time
          japanese: {
            normal: 'rounded-mgenplus-2m-regular.ttf',
            bold: 'rounded-mgenplus-2m-regular.ttf',
            italics: 'rounded-mgenplus-2m-regular.ttf',
            bolditalics: 'rounded-mgenplus-2m-regular.ttf'
          },
        };
        docDefinition.defaultStyle = docDefinition.defaultStyle || {};
        docDefinition.defaultStyle.font = me.language || 'Roboto';


        iorad.player.controllers.sync.getPlayerURL()
          .then(_.bind(function(playerUrlData) {
            if (me.model.getOption('is_print_qr_disabled')) {
              me.pdf = pdfMake.createPdf(docDefinition);
              me.trigger('pdf:create');
              return;
            }

            if (!Array.isArray(docDefinition.content)) {
              docDefinition.content = [docDefinition.content];
            }

            const qrCode = new QRCodeStyling({
              width: 300,
              height: 300,
              type: 'svg',
              data: playerUrlData.PUBLIC_LINK,
              image: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAwIiBoZWlnaHQ9IjQ5OCIgdmlld0JveD0iMCAwIDUwMCA0OTgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik01MDAgNDk3LjExSDBWMEg1MDBWNDk3LjExWk0xMjQuMjc3IDM3Mi44MzJIMzc4LjYxM1YxMjQuMjc3SDEyNC4yNzdWMzcyLjgzMloiIGZpbGw9IiNGRjAwRDYiLz4KPC9zdmc+Cg==',
              dotsOptions: {
                color: '#000000',
                type: 'square',
              },
              backgroundOptions: {
                color: '#ffffff',
              },
              imageOptions: {
                hideBackgroundDots: true,
                imageSize: 0.4,
                margin: 0
              },
            });
            const qrTextEl = me.$('.texts .qr-text');
            qrCode.getRawData().then(function(blobData) {
              const reader = new FileReader();
              reader.onload = function(e) {
                docDefinition.content.push(
                  {
                    image: e.target.result,
                    fit: [300, 300],
                    alignment: 'center',
                    margin: [0, 60, 0, 0],
                    ...(me.type !== 'long' ? {
                      pageBreak: 'before',
                    } : {}),
                    pageMargins: [100, 100],
                  },
                  {
                    // text: me.getDisplayedText(i18next.t('Scan to go to the interactive player')),
                    text: me.getDisplayedText(qrTextEl.length ? qrTextEl.text() : i18next.t('Scan to go to the interactive player')),
                    alignment: 'center'
                  }
                );

                me.pdf = pdfMake.createPdf(docDefinition);
                me.trigger('pdf:create');
              };
              reader.readAsDataURL(blobData);
            });
          }));
      });
    return promise;
  },

  getTemplateData: function() {
    var templateData = iorad.base.View.prototype.getTemplateData.apply(this, arguments);
    const stepLength = this.collection.length;
    const estimatedAdditionalPages = 10;
    const estimatedPageCounts = [...Array(estimatedAdditionalPages).keys()].map(pageCount => stepLength + pageCount);
    templateData = _.extend(templateData, {
      logoUrl: iorad.base.Utils.getBackgroundImageUrl($('#logo')), // whatever default or custom logo it's being used
      updated: iorad.base.Utils.toLocalTime(this.model.get('updated')),
      estimatedPages: [...Array(stepLength + estimatedAdditionalPages).keys()].map(currentPage => {
        return {
          currentPage: currentPage,
          estimatedPageCounts
        }
      })
    });
    return templateData;
  },

  render: function() {
    // remove sub-view
    if (this.printStepList) this.printStepList.$el.detach();

    iorad.base.View.prototype.render.apply(this, arguments);

    if (!this.printStepList) {
      // create sub-view
      this.printStepList = new iorad.player.views.steps_print_step_list({
        collection: this.collection,
        el: this.$('.steps')
      });
    } else {
      // add back sub-view
      this.$('.steps').replaceWith(this.printStepList.$el);
    }

    // reset pdf creation
    this.pdf = undefined;

    setTimeout(_.bind(function() { // wait css render
      this.detectLanguage().then(_.bind(function(language) {
        this.language = language;
        this.qrCodeStylingComponent.load().then(_.bind(function () {
          this.pdfMakeComponent.load(this.language).then(_.bind(this.createPdf, this));
        }, this));
      }, this));
    }, this), 500);

    return this;
  },

  detectLanguage: function() {
    var me = this;

    var promise = iorad.player.selectedTranslation
      ? Promise.resolve(iorad.player.selectedTranslation)
      : iorad.player.controllers.language.detectLanguage();

    return promise.then(function(languageCode) {
      // NOTE: language might be null
      // (we default to Roboto font in such a case)
      var language = languageCode ? me.supportedLanguages[languageCode.toLowerCase()] : undefined;
      return language;
    });
  },

  ready: function() {
    var me = this;
    return new Promise(function(resolve, reject) {
      if (me.pdf) resolve();
      else me.listenToOnce(me, 'pdf:create', resolve);
    });
  },

  print: function() {
    var me = this;
    return this.ready().then(function() {
      return new Promise(function(resolve, reject) {

        //me.pdf.open();resolve();return; // DEBUG

        var clientDetect = iorad.player.controllers.clientDetect;
        //var isDownloadForced = clientDetect.browser.isIE || // IE doesn't support print or open
        //                       clientDetect.browser.isFirefox; // Firefox adds extra white space
        var isDownloadForced = true; // always forced for consistency
        if (isDownloadForced) {
          var filename = me.model.get('title') + '.pdf';
          me.pdf.download(filename, resolve);
        } else {

          me.pdf.getDataUrl(function(dataUrl) {
            var iframe = document.createElement('iframe');
            iframe.style.position = 'absolute';
            iframe.style.left = '-99999px';
            iframe.onload = function() {
              function removeIFrame() {
                document.body.removeChild(iframe);
                document.removeEventListener('click', removeIFrame);
              }
              document.addEventListener('click', removeIFrame, false);
              resolve();
            };
            iframe.src = dataUrl;
            document.body.appendChild(iframe);
          }, {
            autoPrint: true
          });
        }
      });
    });
  }

});

;
iorad.player.views.meta_print_short = iorad.player.views.meta_print.extend({
  template: iorad.player.templates.meta_print_short,
  type: 'short',

  initialize: function() {
    this.descriptionContainerWidth = 230;
    this.screenshotWidth = 300;
    this.stepNumberDigitWidth = 7;

    this.headerBackgroundWidth = 600;

    iorad.player.views.meta_print.prototype.initialize.apply(this, arguments);
  },

  getScreenshotCropBounds: function(slideView) {
    var screenshotViewport = slideView.$('.stepimg');
    var screenshot = slideView.$('.stepimg .imgcontainer');
    var screenshotCanvas = slideView.$('.stepimg .screenshot-canvas')[0];

    var scale = slideView.getImgScale(); // TODO: does not work with scale > 1

    // resize DOM screenshot to have needed positioning
    // Note: pt will be converted in px by jquery
    // Note: height is dynamic
    screenshotViewport.width((this.screenshotWidth / scale) + 'pt');
    slideView.positionImage();

    function withinCanvasWidth(value) {
      return Math.max(
        0,
        Math.min(
          screenshotCanvas.width,
          value
        )
      );
    }
    function withinCanvasHeight(value) {
      return Math.max(
        0,
        Math.min(
          screenshotCanvas.height,
          value
        )
      );
    }

    var screenshotCropBounds = {
      left: withinCanvasWidth(parseInt(screenshot.css('left'), 10) * -1),
      top: withinCanvasHeight(parseInt(screenshot.css('top'), 10) * -1),
      width: withinCanvasWidth(screenshotViewport.width()),
      height: withinCanvasHeight(screenshotViewport.height())
    };

    return screenshotCropBounds;
  },

  getStepNumberWidth: function(stepNumber) {
    var numberOfDigits = (stepNumber + "").length;
    return numberOfDigits * this.stepNumberDigitWidth;
  },

  createPdfSlideInfotextFragment: function (infotextEl) {
    var stepLink = infotextEl.data('display-step-link');
    var hasEmbedOrVideo = stepLink && stepLink !== 'false'
    var newWindowLinkIconSrc = (window.STATIC_ROOT || '') + 'images/base/svg/new-window.svg';

    return Promise.all([
      this.getHeaderBackground({ useDefault: this.isOrWasPremium === false }),
      ...(hasEmbedOrVideo ? [iorad.base.Utils.getUrlImageData(newWindowLinkIconSrc, iorad.player.disableCORS)] : [])
    ])
      .then(([headerBackground, newWindowLinkIconData]) => {
        const headerBackgroundCommonColor = iorad.base.Utils.mostCommonColor(headerBackground.canvas);

        if (hasEmbedOrVideo) {
          return {
            fillColor: headerBackgroundCommonColor,
            margin: [this.pageMargins[0], 20, this.pageMargins[2], 20],
            columns: [
              {
                  text: "Open media in web browser",
                  fontSize: 15,
                  color: "#000000",
                  decoration: "underline",
                  decorationColor: "#000000",
                  link: stepLink,
                  alignment: "left",
                  width: 230,
              },
              {
                text: "     ",
                preserveLeadingSpaces: true,
                fontSize: 15,
                color: "#000000",
                link: stepLink,
                alignment: "left",
                width: 60,
                margin: [-35, 0, 0, 0]
              },
              ...(newWindowLinkIconData ? [{
                image: newWindowLinkIconData,
                width: 15,
                height: 15,
                fit: [15, 15],
                alignment: 'left',
                // left, top, right, bottom
                margin: [-95, 0, 0, 0]
              }] : []),
            ]
          }
        }

        return {
          fillColor: headerBackgroundCommonColor,
          margin: [this.pageMargins[0], 20, this.pageMargins[2], 20],
          stack: [
            this.getElementPdfText(infotextEl.find('.section-title'), {
              fontSize: 15,
            }),
            {
              text: ' ',
              margin: [0, 0, 0, 10],
            },
            this.getElementPdfText(infotextEl.find('.section-text')),
          ],
        };
      });
  },

  createPdfSlideFragment: function(slideView) {

    var descriptionEl = slideView.$('.description');
    // replace br with '\n' to be read by pdfmake as line breaks
    descriptionEl.html(descriptionEl.html().replace(/<br\s*\/?>/mg, '\n'));

    var descriptionText = this.getElementPdfText(descriptionEl);

    var iconSrc = slideView.$('img.icon').attr('src');
    var iconSize = 25;

    var stepNumber = slideView.$('.number').text();

    var infotextEl = slideView.$('.step-infotext');

    var asyncHash = {
      iconImageData: iorad.base.Utils.getUrlImageData(iconSrc, iorad.player.disableCORS),
      stepNumberWidth: this.getStepNumberWidth(stepNumber),
      slideImageData: this.getSlideImageData(slideView),
      slideInfotextFragment: infotextEl.is(':visible') ?
        this.createPdfSlideInfotextFragment(infotextEl)
        : null,
    };

    var me = this;
    var promise = iorad.base.Utils.promiseHash(asyncHash).then(function(data) {

      // row
      var fragment = [

        // icon + description + number
        {
          columns: [
            // icon
            {
              image: data.iconImageData,
              width: iconSize,
              height: iconSize,
              fit: [iconSize, iconSize],
              alignment: 'center',
              // left, top, right, bottom
              margin: [0, 13, -10, 0]
            },
            // description
            {
              width: '*',
              text: descriptionText,
              margin: [20, 13, 0, 0]
            },
            // number
            {
              width: data.stepNumberWidth + 24,
              // as a table to have borders
              table: {
                widths: [data.stepNumberWidth],
                body: [
                  [{
                    text: stepNumber,
                    alignment: 'center'
                  }]
                ]
              },
              layout: {
                hLineWidth: function(i, node) {
                  return (i === 1) ? 1 : 0; // bottom-border only
                },
                vLineWidth: function(i, node) {
                  return (i === 0) ? 1 : 0; // left-border only
                },
                hLineColor: function(i, node) {
                  return '#9ca1a4';
                },
                vLineColor: function(i, node) {
                  return '#9ca1a4';
                },
                paddingLeft: function(i, node) {
                  return 6;
                },
                paddingRight: function(i, node) {
                  return 6;
                },
                paddingTop: function(i, node) {
                  return 4;
                },
                paddingBottom: function(i, node) {
                  return 4;
                }
              },
              margin: [11, 0, 0, 0],
            }
          ]
        },

        // screenshot + markers
        // Note: screenshot height is dynamic
        data.slideInfotextFragment || {
          image: data.slideImageData,
          width: me.screenshotWidth,
          alignment: 'center'
        },
      ];
      return fragment;
    });
    return promise;
  },

  createPdfContent: function(docDefinition) {
    return this.printStepList.ready().then(() => { // wait steps preloading
      // create fragments
      const slideViews = this.printStepList.getSlideViews(); // hoping they are in DOM-order
      const slidePromises = _.map(slideViews, this.createPdfSlideFragment.bind(this));
      return Promise.all(slidePromises);
    }).then((slideFragments) => {
      const premiumMode = this.model.get('printAllowed') || (this.model.get('print_limit') > 0);
      const normalStepsCount = !premiumMode
        ? 5 // limit to 5 steps in free mode
        : slideFragments.length;

      docDefinition.content = [];

      const slideViews = this.printStepList.getSlideViews(); // hoping they are in DOM-order
      docDefinition.content.push(...(
        // each as its own table to have separate `dontBreakRows` rules
        slideFragments.slice(0, normalStepsCount).map((slideFragment, i) => {
          const slideView = slideViews[i];
          const infotextEl = slideView.$('.step-infotext');
          const slideHasInfotext = infotextEl.is(':visible');
          return {
            ...((slideHasInfotext && i > 0) ? {
              pageBreak: 'before', // TODO: switch to smart pageBreakBefore after library upgrade
            } : {}),
            margin: [0, -1, 0, 0], // to hide the double top border
            table: {
              dontBreakRows: !slideHasInfotext,
              widths: [this.descriptionContainerWidth, this.screenshotWidth],
              body: [slideFragment], // single row
            },
            layout: {
              hLineWidth: (i, node) => {
                return 1;
              },
              vLineWidth: (i, node) => {
                return 1;
              },
              hLineColor: (i, node) => {
                return '#9ca1a4';
              },
              vLineColor: (i, node) => {
                return '#9ca1a4';
              },
              paddingLeft: (i, node) => {
                return 0;
              },
              paddingRight: (i, node) => {
                return 0;
              },
              paddingTop: (i, node) => {
                return 0;
              },
              paddingBottom: (i, node) => {
                return 0;
              },
            },
          };
        })
      ));
      _.times(slideFragments.length - normalStepsCount, () => {
        docDefinition.content.push({
          pageBreak: 'before',
          text: [{
            text: this.getDisplayedText(i18next.t('Free plan limited to ' + normalStepsCount + ' steps.')),
            fontSize: 24,
            alignment: 'center',
          }],
          margin: [0, 300, 0, 0], // HACK: vertical align
        });
      });

      return docDefinition;
    });
  }

});

;
iorad.player.views.meta_print_long = iorad.player.views.meta_print.extend({
  template: iorad.player.templates.meta_print_long,
  type: 'long',

  initialize: function() {
    // add here
    this.headerBackgroundWidth = 850;

    iorad.player.views.meta_print.prototype.initialize.apply(this, arguments);

    // adjust top margin
    this.pageMargins[1] = 110;
  },

  createPdfLayout: function(docDefinition) {
    return iorad.player.views.meta_print.prototype.createPdfLayout.apply(this, arguments).then(function(docDefinition) {
      docDefinition = _.extend(docDefinition, {
        pageOrientation: 'landscape'
      });

      return docDefinition;
    });
  },

  createPdfFreeSlideFragment: function(isLastSlide) {
    return Promise.resolve().then(() => {
      return [{ // single column
        stack: [{
          text: [{
            text: this.getDisplayedText(i18next.t('Free plan is limited to a single page pdf preview.')),
            fontSize: 28,
            alignment: 'center',
          }],
          margin: [0, 175, 0, 0], // HACK: vertical align
          pageBreak: isLastSlide ? null : 'after',
        }]
      }];
    });
  },

  createPdfSlideInfotextFragment: function (infotextEl, isLastSlide) {
    var stepLink = infotextEl.data('display-step-link');
    var hasEmbedOrVideo = stepLink && stepLink !== 'false';
    var newWindowLinkIconSrc = (window.STATIC_ROOT || '') + 'images/base/svg/new-window.svg';

    return Promise.all([
      this.getHeaderBackground({ useDefault: this.isOrWasPremium === false }),
      ...(hasEmbedOrVideo ? [iorad.base.Utils.getUrlImageData(newWindowLinkIconSrc, iorad.player.disableCORS)] : [])
    ])
      .then(([headerBackground, newWindowLinkIconData]) => {
        const headerBackgroundCommonColor = iorad.base.Utils.mostCommonColor(headerBackground.canvas);

        if (hasEmbedOrVideo) {
          return {
            pageBreak: isLastSlide ? null : 'after',
            margin: [0, 15, 0, 0],
            table: { // as a table for the fillColor and row breaking
              dontBreakRows: false,
              widths: ['100%'],
              body: [
                [ // single row
                  {
                    fillColor: headerBackgroundCommonColor,
                    margin: [this.pageMargins[0], 20, this.pageMargins[2], 20],
                    columns: [
                      {
                          text: "Open media in web browser",
                          fontSize: 15,
                          color: "#000000",
                          decoration: "underline",
                          decorationColor: "#000000",
                          link: stepLink,
                          alignment: "left",
                          width: 230,
                      },
                      {
                        text: "     ",
                        preserveLeadingSpaces: true,
                        fontSize: 15,
                        color: "#000000",
                        link: stepLink,
                        alignment: "left",
                        width: 60,
                        margin: [-35, 0, 0, 0]
                      },
                      ...(newWindowLinkIconData ? [{
                        image: newWindowLinkIconData,
                        width: 15,
                        height: 15,
                        fit: [15, 15],
                        alignment: 'left',
                        // left, top, right, bottom
                        margin: [-95, 0, 0, 0]
                      }] : []),
                    ]
                  },
                ],
              ],
            },
            layout: 'noBorders',
          };
        }

        return {
          pageBreak: isLastSlide ? null : 'after',
          margin: [0, 15, 0, 0],
          table: { // as a table for the fillColor and row breaking
            dontBreakRows: false,
            widths: ['100%'],
            body: [
              [ // single row
                {
                  fillColor: headerBackgroundCommonColor,
                  margin: [this.pageMargins[0], 20, this.pageMargins[2], 20],
                  stack: [
                    this.getElementPdfText(infotextEl.find('.section-title'), {
                      fontSize: 15,
                    }),
                    {
                      text: ' ',
                      margin: [0, 0, 0, 20],
                    },
                    this.getElementPdfText(infotextEl.find('.section-text')),
                  ],
                },
              ],
            ],
          },
          layout: 'noBorders',
        };
      });
  },

  createPdfSlideFragment: function(slideView, isLastSlide) {
    const descriptionEl = slideView.$('.description');
    // remove line breaks (#2417#issuecomment-145906440)
    descriptionEl.html(
      descriptionEl.html().replace(/<br\s*\/?>/mg, ' ').replace(/\n/g, ' ')
    );

    const descriptionText = this.getElementPdfText(descriptionEl, {
      fontSize: 16
    });

    const iconSrc = slideView.$('img.icon').attr('src');
    const iconSize = 25;

    const infotextEl = slideView.$('.step-infotext');

    const asyncHash = {
      iconImageData: iorad.base.Utils.getUrlImageData(iconSrc, iorad.player.disableCORS),
      slideImageData: this.getSlideImageData(slideView),
      slideInfotextFragment: infotextEl.is(':visible') ?
        this.createPdfSlideInfotextFragment(infotextEl, isLastSlide)
        : null,
    };
    return iorad.base.Utils.promiseHash(asyncHash).then((data) => {
      // row
      const fragment = [{ // single column
        stack: [
          {
            columns: [
              // icon
              {
                image: data.iconImageData,
                width: iconSize,
                height: iconSize,
                fit: [iconSize, iconSize]
              },
              // description
              {
                width: '*',
                text: descriptionText,
                margin: [25, 0, 0, 0]
              }
            ]
          },
          // screenshot + markers
          data.slideInfotextFragment || {
            image: data.slideImageData,

            // TODO: make size based on available space
            width: 780,
            height: 360,
            fit: [780, 360], // don't stretch the image

            alignment: 'center',
            margin: [0, 15, 0, 0],
            pageBreak: isLastSlide ? null : 'after'
          }
        ]
      }];
      return fragment;
    });
  },

  createPdfContent: function(docDefinition) {
    return this.printStepList.ready().then(() => { // wait steps preloading
      // create fragments
      var slideViews = this.printStepList.getSlideViews(); // hoping they are in DOM-order
      var slidePromises = _.map(slideViews, (slideView, i) => {
        const premiumMode = this.model.get('printAllowed') || (this.model.get('print_limit') > 0);
        return (!premiumMode && i > 0) ?
          this.createPdfFreeSlideFragment(i + 1 === slideViews.length)
          :
          this.createPdfSlideFragment(slideView, i + 1 === slideViews.length);
      });
      return Promise.all(slidePromises);
    }).then((slideFragments) => {
      docDefinition.content = {
        table: {
          dontBreakRows: false,
          widths: ['100%'],
          body: slideFragments,
        },
        layout: 'noBorders',
      };
      return docDefinition;
    });
  },
});

;
iorad.player.views.step_screenshot = iorad.base.views.step_screenshot.extend({

  initialize: function() {
    iorad.base.views.step_screenshot.prototype.initialize.apply(this, arguments);

    this.setupEyeDropper();
  },

  // listen for eyedropper:enable, eyedropper:disable command messages
  setupEyeDropper: function() {
    this.listenTo(iorad.player.events, 'eyedropper:enable', this.enableEyeDropper);
    this.listenTo(iorad.player.events, 'eyedropper:disable', this.disableEyeDropper);

    if (iorad.player.isEyeDropperEnabled) this.enableEyeDropper();
    else this.disableEyeDropper();
  },

  enableEyeDropper: function() {
    this.eyeDropperEnabled = true;
    this.$('canvas').css('cursor', 'crosshair');
  },

  disableEyeDropper: function() {
    this.eyeDropperEnabled = false;
    this.$('canvas').css('cursor', 'auto');
  },

  events: {
    'click canvas': 'handleCanvasClick'
  },

  handleCanvasClick: function(e) {
    if (this.eyeDropperEnabled) {
      var canvas = e.currentTarget;

      var rect = canvas.getBoundingClientRect();
      var imageData = canvas.getContext('2d').getImageData(e.clientX - rect.left, e.clientY - rect.top, 1, 1);
      var selectedColor = iorad.base.Export.rgbToHex([imageData.data[0], imageData.data[1], imageData.data[2]]);

      //console.log('trigger eyedropper', selectedColor);
      this.trigger('eyedropper', selectedColor);
      siteWindow.parent.postMessage('eyedropper:' + selectedColor, Backbone.history.location.origin);
    }
  },

  // extract a given rectangle of the screenshot and returns the relative image data
  extract: function(rect) {
    rect = rect || {}; // defaults to whole image
    return this.canvas.getContext('2d').getImageData(rect.x, rect.y, rect.width, rect.height);
  }

});
;
// The marker item for just one step (if it has one). Ignores sub-steps

// Note: the auto play functionality implemented here is for "interactive" mode only.

iorad.player.views.markerCommon = function(BaseMarkerView) {
  return BaseMarkerView.extend({
    className: 'marker',
    tagName: 'li',

    template: iorad.player.templates.markers_common,

    initialize: function(options) {
      BaseMarkerView.prototype.initialize.apply(this, arguments);
      var events = {
        'click': 'onClick',
      };
      this.events = this.events || {};
      _.extend(this.events, events, BaseMarkerView.prototype.events);
      options = options || {};

      this.previousMarkerView = options.previousMarkerView;
      this.slideView = options.slideView;
      this.markerListView = options.markerListView;
      this.stepsCollection = options.stepsCollection; // TODO: not always set! E.g. for "Slide It" view
      this.isInteractivityEnabled = false;
      this.completed = false;

      this.markerInfoView = new iorad.player.views.MarkerInfo({
        model: this.model,
        markerView: this,
      });

      // make it executable only once to prevent multiple bindings of event listeners
      this.enableInteractivity = _.once(this.enableInteractivity);

      this.setupAutoPlay();
      this.setupProgressTimerDone();

      this.listenTo(iorad.player.data.markerColors, 'change', this.updateColor);
    },

    updateBounds: function(animateTransition) {
      animateTransition = animateTransition === undefined ? iorad.player.mode === 'interactive' : animateTransition;
      return BaseMarkerView.prototype.updateBounds.apply(this, [animateTransition]);
    },

    onClick: function() {
      if (this.stepAdvanceOnClick) this._completed();
    },

    getBounds: function() {
      var bounds = BaseMarkerView.prototype.getBounds.apply(this, arguments);

      var PADDING = 0;
      bounds.x -= PADDING;
      bounds.width += PADDING * 2;
      bounds.y -= PADDING;
      bounds.height += PADDING * 2;

      return bounds;
    },

    useAutoPlay: function() {
      return iorad.player.autoPlay && iorad.player.mode === 'interactive';
    },

    // calculate the default waiting time for the current step (when not having audio/video).
    autoPlayDefaultDelay: function() {
      // one second per word
      var textDescription = $('#interactive-nav .step.active .description-container').text();
      var wordsCount = iorad.base.Utils.countWords(textDescription);
      return wordsCount * 1000; // ms
    },

    setupAutoPlay: function() {
      this.listenTo(iorad.player.events, 'autoPlay:start', function() {
        var step = this.model;
        if (iorad.player.data.stepsCollection.getCurrentModel() !== step) return;

        // if step has no audio/video or if audio/video already finished playing
        if (
          step.get('audioId') == null &&
          step.get('videoId') == null
        ) {
          // with default delay
          this.autoPlay();
        } else if (
          (step.get('audioId') != null && this.audioEnded) ||
          (step.get('videoId') != null && this.videoEnded)
        ) {
          // immediately
          this.autoPlay(0);
        }
      });

      this.listenTo(iorad.player.events, 'sound:end', function() {
        var step = this.model;
        if (iorad.player.data.stepsCollection.getCurrentModel() !== step) return;

        this.audioEnded = true;
        if (this.useAutoPlay()) this.autoPlay(0);
      });
      this.listenTo(iorad.player.events, 'video:end', function() {
        var step = this.model;
        if (iorad.player.data.stepsCollection.getCurrentModel() !== step) return;

        this.videoEnded = true;
        if (this.useAutoPlay()) this.autoPlay(0);
      });

      this.listenTo(iorad.player.events, 'sound:loaderror', function() {
        var step = this.model;
        if (iorad.player.data.stepsCollection.getCurrentModel() !== step) return;

        this.audioEnded = true;
        if (this.useAutoPlay()) this.autoPlay(); // with default delay
      });
      this.listenTo(iorad.player.events, 'video:loaderror', function() {
        var step = this.model;
        if (iorad.player.data.stepsCollection.getCurrentModel() !== step) return;

        this.videoEnded = true;
        if (this.useAutoPlay()) this.autoPlay(); // with default delay
      });

      this.listenTo(iorad.player.events, 'sound:play', function() {
        var step = this.model;
        if (iorad.player.data.stepsCollection.getCurrentModel() !== step) return;

        // reset
        this.audioEnded = false;
      });
      this.listenTo(iorad.player.events, 'video:play', function() {
        var step = this.model;
        if (iorad.player.data.stepsCollection.getCurrentModel() !== step) return;

        // reset
        this.videoEnded = false;
      });

      this.listenTo(iorad.player.data.stepsCollection, 'changeCurrent', function() {
        this._clearAutoPlayTimer();
      });
    },

    setupProgressTimerDone: function () {
      let interval;
      const clearAnimation = () => {
        this.$el.css('transform', '');
        clearInterval(interval);
        interval = undefined;
      };
      const runAnimation = () => {
        if (interval) return;

        let move1 = true;
        let move2 = false;
        let move3 = false;
        let move4 = false;

        const h1 = 8;
        const h2 = 6;
        const h3 = 4;
        const h4 = 2;

        const a1 = -3000;
        const a2 = -3000;
        const a3 = -3000;
        const a4 = -3000;

        const frame = 10;
        const dt = frame / 1000;

        const v01 = Math.sqrt(2 * -a1 * h1);
        const v02 = Math.sqrt(2 * -a2 * h2);
        const v03 = Math.sqrt(2 * -a3 * h3);
        const v04 = Math.sqrt(2 * -a4 * h4);

        let t1 = 0;
        let t2 = 0;
        let t3 = 0;
        let t4 = 0;
        let x1 = 0;
        let x2 = 0;
        let x3 = 0;
        let x4 = 0;

        // https://codepen.io/Dariushhassani/pen/XWpdjpb
        interval = setInterval(() => {
          if (move1) {
            t1 += dt;
            x1 = (0.5 * a1 * t1 * t1) + (v01 * t1);
            if (x1 > 0) {
              this.$el.css('transform', `translateY(-${x1}px)`);
            } else {
              this.el.style.transform = '';
              move1 = false;
              move2 = true;
            }
          } else if (move2) {
            t2 += dt;
            x2 = (0.5 * a2 * t2 * t2) + (v02 * t2);
            if (x2 > 0) {
              this.$el.css('transform', `translateY(-${x2}px)`);
            } else {
              this.$el.css('transform', '');
              move2 = false;
              move3 = true;
            }
          } else if (move3) {
            t3 += dt;
            x3 = (0.5 * a3 * t3 * t3) + (v03 * t3);
            if (x3 > 0) {
              this.$el.css('transform', `translateY(-${x3}px)`);
            } else {
              this.$el.css('transform', '');
              move3 = false;
              move4 = true;
            }
          } else if (move4) {
            t4 += dt;
            x4 = (0.5 * a4 * t4 * t4) + (v04 * t4);
            if (x4 > 0) {
              this.$el.css('transform', `translateY(-${x4}px)`);
            } else {
              clearAnimation();
            }
          }
        }, frame);
      };

      const onStepProgressTimerDone = () => {
        if (
          iorad.player.tab === 'try' &&
          // this.model.get('type') !== 'READ' && // READ should have animation #13132
          this.isActive() &&
          !this.isTransparent()
        ) {
          if (!interval) {
            runAnimation();
          }
        }
      };

      this.listenTo(iorad.player.events, 'stepProgressTimer:done', onStepProgressTimerDone);
      this.listenTo(iorad.player.data.stepsCollection, 'changeCurrent', clearAnimation);
    },

    // can also be overriden by subtypes to specify custom style changes
    // (e.g. for the typing tool color)
    updateStyle: function(transition, callback) {
      this.updateColor();
      var screenshotView = this.slideView.screenshotView;
      if (screenshotView.isLoaded) this.updateShadow(callback);
      else this.listenToOnce(screenshotView, 'load', () => this.updateShadow(callback));
      return this.updateBounds(transition);
    },

    updateColor: function() {
      var type = this.model.get('type');
      var customColor = iorad.player.data.markerColors.get(type) || '';
      var fontColor = iorad.player.data.markerColors.get('font_' + type) ||
        iorad.base.Export.getContrastColor(customColor);
      var timerProgressColor = fontColor;
      var $container = this.$('.step-container');
      $container.css({
        background: customColor,
        color: fontColor,
      });
      $container.find('svg .fill').css({ fill: fontColor || '#fefefe' });
      $container.find('svg .stroke').css({ stroke: fontColor || '#fefefe' });
      $container.find('.timer-progress').css({ backgroundColor: timerProgressColor });

      if (!this.timerDuration && !this.$el.hasClass('custom-text')) {
        const parentModel = iorad.player.data.stepsCollection.find(aStepModel =>
          aStepModel === this.model ||
          aStepModel.steps.some(aSubStepModel => aSubStepModel === this.model)
        );
        const stepModelIsLast = parentModel.get('index') >= iorad.player.data.stepsCollection.length - 1;
        // #14495: only show done on try it mode, not is click & not is hyperlink checked
        const shouldShowDoneBtn = (
          false // DISABLED FOR NOW (See https://github.com/iorad/iorad/issues/14495#issuecomment-2206773754)
          // && stepModelIsLast
          // && iorad.player.tab === 'try'
          // && !(parentModel.get('type') === 'LEFT_CLICK' && parentModel.get('event.hyperlink'))
        );
        if (shouldShowDoneBtn) {
          const transparentCustomColor = iorad.base.Export.addTransparency(customColor, 2);
          const trKey = 'Done';
          const translationExistsNoFallback = (window.i18next && window.i18next.exists(trKey, { lngs: [window.i18next.language] }));
          this.$('.step-description')
            .text(i18next.t(trKey))
            .toggleClass('notranslate', !!translationExistsNoFallback);
          this.$el
            .addClass('last-step')
            .css({
              borderColor: transparentCustomColor
            });
          this.$('.arrow-container').css({
            borderColor: customColor,
          });
        } else {
          const stepLabelData = window.iorad.getStepLabel({
            step: this.model.toJSON(),
            mobile: iorad.player.data.tutorial.get('isMobile'),
            fullInfo: true,
          });
          this.$('.step-description')
            .text(stepLabelData.label)
            .toggleClass('notranslate', !!stepLabelData.translationExistsNoFallback);
          this.$el.css({
            borderColor: customColor
          });
          this.$('.arrow-container').css({
            borderColor: customColor,
          });
        }
      } else {
        this.$el.css({
          borderColor: customColor
        });
        this.$('.arrow-container').css({
          borderColor: customColor,
        });
      }
    },

    // Hide shadow if dominant color behind the marker is dark
    // (since doesn't look good).
    // Note: assumes the screenshot has been already loaded
    updateShadow: _.debounce(function(callback) {
      var markerBounds = this.getBounds();
      var screenshotCanvas = this.slideView.screenshotView.canvas;
      var commonColor = iorad.base.Utils.mostCommonColor(screenshotCanvas, markerBounds.x, markerBounds.y,
        markerBounds.width, markerBounds.height);

      if (iorad.base.Utils.isDarkColor(commonColor)) {
        this.$el.addClass('no-shadow');
      } else {
        this.$el.removeClass('no-shadow');
      }
      if (callback) callback();
    }, 100),

    getTemplateData: function() {
      return this.model.toJSON();
    },

    render: function() {
      this.$el.addClass(this.model.get('type'));
      if (this.timerDuration) this.$el.addClass('timer');

      this.markerInfoView.$el.detach();

      if (this.template) {
        var html = Mustache.render(this.template, this.getTemplateData());
        this.$el.html(html);
      } else {
        this.$el.html('');
      }

      this.$el.prepend(this.markerInfoView.$el);

      this.$el.toggleClass('transparent', !!this.isTransparent());
      this.$el.toggleClass('transparent-marker-info', !!this.isTransparentMarkerInfo()); // TODO: this seem unused

      // Animate from the last marker to this one
      if (this.previousMarkerView) {
        // console.log('transition started');
        this.isRenderTransitionRunning = true;
        if (this.transitionFinishedTimer) {
          clearInterval(this.transitionFinishedTimer);
          this.transitionFinishedTimer = undefined;
        }

        // this marker style but with old marker position (which is still appended to DOM)
        this.updateStyle(false);
        var oldBounds = this.previousMarkerView.getBounds();
        this.$el.css({
          'left': oldBounds.x,
          'top': oldBounds.y,
          'width': oldBounds.width,
          'height': oldBounds.height
        });
        this.markerInfoView.show();
        var $this = this;

        // Wait enough time for a reflow then set the final style
        // (css animation will animate between the two)
        setTimeout(_.bind(function() {
          this.updateStyle()
            .then(function() {
              // when the transition finished
              $this.isRenderTransitionRunning = false;
              $this.markerInfoView.show();
              $this.trigger('transitionFinished');
            });
        }, this), 0);
      } else {
        // no transition
        this.updateStyle(false, () => {
          this.markerInfoView.show();
        });
      }

      return this;
    },

    waitForTransition: function() {
      if (!this.isRenderTransitionRunning) return Promise.resolve();
      var thisMarkerCommonView = this;
      return new Promise(function(resolve) {
        thisMarkerCommonView.once('transitionFinished', resolve);
      })
        .then(function() {
          return iorad.base.Utils.setTimeoutPromise().promise;
        });
    },

    delegateEvents: function() {
      // don't enable events if the interactivity is not enabled!
      if (!this.isInteractivityEnabled) return;
      else return BaseMarkerView.prototype.delegateEvents.apply(this, arguments);
    },

    enableInteractivity: function() {
      this.isInteractivityEnabled = true;
      // enable events now!
      this.delegateEvents();
    },

    isActive: function() {
      return this.$el.hasClass('active');
    },

    showStepAdvanceButton: function(options) {
      options = options || {};

      this.stepAdvanceOnClick = true;
      if (!options.keepDefaultText) {
        this.$el.addClass('custom-text');
        this.$('.step-description').text(i18next.t('Next'));
      }
      // optionally also run timer
      if (typeof options.timerDuration === 'number') this.startTimer(options.timerDuration);
    },

    startTimer: function(timerDuration) {
      this.$el.addClass('timer');
      if (window.ioradAutoplayLog) {
        console.log('Start progress-bar, duration - ' + timerDuration);
      }
      this.timerDuration = timerDuration;
      var $timerProgress = this.$('.step-container .timer-progress');
      var loaderDisabled = this.isNextLoaderDisabled();
      $timerProgress.css({width: 0});
      // DISABLED FOR NOW: https://github.com/iorad/iorad/issues/12985#issuecomment-1440457151
      // if (!loaderDisabled) {
      //   this.timerAnimation = {durationLeft: this.timerDuration};
      //   this.resumeTimer();
      // }
    },
    resumeTimer: function(callback) {
      if (!this.timerAnimation) {
        if (callback) {
          setTimeout(callback, 10)
        }

        return;
      }
      var $timerProgress = this.$('.step-container .timer-progress');
      var _this = this;
      this.timerAnimation.resumeTime = Date.now();
      $timerProgress.animate(
        {width: '100%'},
        this.timerAnimation.durationLeft,
        'linear',
        function() {
          window.lastTimerFinish = Date.now();
          _this.timerAnimation = null;

          if (callback) {
            callback()
          }
        }
      );
    },
    pauseTimer: function() {
      if (!this.timerAnimation) return;
      this.timerAnimation.durationLeft -= Date.now() - this.timerAnimation.resumeTime;
      var $timerProgress = this.$('.step-container .timer-progress');
      $timerProgress.stop();
    },

    cancelTimer: function() {
      this.timerDuration = undefined;
      var $timerProgress = this.$('.step-container .timer-progress');
      $timerProgress.css({width: 0}).css({transition: 'none'}).removeClass('full');
    },

    isNextLoaderDisabled: function() {
      // default implementation
      return false;
    },

    isTransparent: function() {
      // default implementation
      return iorad.player.tab === 'quiz';
    },

    isTransparentMarkerInfo: function() {
      // default implementation
      return (
        iorad.player.tab === 'quiz' ||
        iorad.player.data.tutorial.getLayoutOption('is_actionlabel_disabled')
      );
    },

    // #15394: hide the marker info but show the above overlay
    isTransparentForceDisabled: function() {
      // default implementation
      const thisTutorial = iorad.player.data.tutorial;
      const activeStepModel = this.model;
      const screenshotOverlayEnabled = (
        thisTutorial.getScreenshotOverlayAllStepsEnabled() ||
        (
          activeStepModel &&
          activeStepModel.get('screenshotOverlayEnabled')
        )
      );
      if (!screenshotOverlayEnabled || activeStepModel.get('type') !== 'READ') {
        return false;
      }
      const screenshotOverlayHidden = Boolean(
        thisTutorial.getScreenshotOverlayHideOnTransparentInfoSteps() &&
        activeStepModel.get('type') === 'READ' && // INFO
        !!activeStepModel.get('event.transparent')
      );

      return screenshotOverlayEnabled && !screenshotOverlayHidden;
    },

    toggleActive: function(isActive, previousMarkerView) {
      if (typeof previousMarkerView !== 'undefined') {
        this.previousMarkerView = previousMarkerView;
      }

      if (isActive) {
        this.$el.addClass('active');
        this.trigger('activated');
        this.render();

        if (
          this.useAutoPlay() &&
          (this.model.get('audioId') == null || this.audioEnded) &&
          (this.model.get('videoId') == null || this.videoEnded)
        ) {
          // with default delay
          this.autoPlay();
        }
      } else {
        this.$el.removeClass('active');
        this.trigger('notActivated');
      }
    },

    _completedIf: function(result, resultOptions) {
      if (result) this._completed(resultOptions);
      else this._notCompleted();
      return result;
    },

    _completed: function(options) {
      // interaction with this marker completed
      this.completed = true;
      this.trigger('completed', options);
      this.trigger('isCompleted', true);
    },

    _notCompleted: function(options) {
      this.completed = false;
      this.trigger('notCompleted', options);
      this.trigger('isCompleted', false);
    },

    _clearAutoPlayTimer: function() {
      if (typeof this.autoPlayTimer !== 'undefined') {
        clearTimeout(this.autoPlayTimer);
        this.autoPlayTimer = undefined;
      }
    },

    autoPlay: _.debounce(function(waitingTime) {
      if (typeof waitingTime === 'undefined') {
        waitingTime = this.autoPlayDefaultDelay();
      }

      this._clearAutoPlayTimer();
      this.autoPlayTimer = setTimeout(_.bind(function() {
        if (!this.useAutoPlay()) return; // too late
        this._completed();
      }, this), waitingTime);
    }, 100),

  });
};

;
(function() {
  var Super = iorad.player.views.markerCommon(iorad.base.views.MarkerDefault);
  iorad.player.views.MarkerDefault = Super.extend({
    /* Keep this blank */
  });
})();
;
(function() {
  var Super = iorad.player.views.markerCommon(iorad.base.views.MarkerRead);
  iorad.player.views.MarkerRead = Super.extend({
    isTransparent: function() {
      return iorad.player.tab === 'quiz' ||
        !!this.model.get('event.transparent');
    },
  });
})();
;
(function() {
  var Super = iorad.player.views.markerCommon(iorad.base.views.MarkerLeftClick);
  iorad.player.views.MarkerLeftClick = Super.extend({

    initialize: function() {
      Super.prototype.initialize.apply(this, arguments);

      this.listenTo(iorad.player.events, 'press:comboKey', this.onShortcutPressed);
    },

    events: {
      'click': 'onClick',
      'dblclick': 'onDoubleClick',
      'mouseup': 'onMouseUp'
    },


    // copy from marker-typing.js
    onShortcutPressed: function(event) {
      var shortcut = this.model.get('event.clickShortcut') || [];
      if (shortcut.length) {
        event.preventDefault();

        var forMac = iorad.player.controllers.clientDetect.os.isMac;

        var specialKeyCodeToEvent = {
          16: event.shiftKey,
          17: event.ctrlKey,
          18: event.altKey,
        };

        // match all special keys and the final normal key
        var specialKeysMatch = shortcut.length === 1 ? true : _.every(shortcut.slice(0, -1), function (storedEvent) {
          return specialKeyCodeToEvent[storedEvent.keyCode] ||
            (
              // Mac: also advance on Command when CTRL was captured on Windows
              forMac &&
              (storedEvent.keyCode === 17 && !storedEvent.keyCapturedOnMac) && // CTRL captured on Windows
              event.metaKey
            ) ||
            (
              storedEvent.key === 'Meta' &&
              storedEvent.metaKey && // exclude "CTRL + SHIFT + ALT" which is reported as event.key === 'Meta'
              (
                forMac ? event.metaKey // Mac: Command
                  : storedEvent.keyCapturedOnMac
                    ? event.ctrlKey // Windows: Meta (CMD) captured on Mac is Ctrl on Windows
                    : event.metaKey // Windows: Meta captured on Windows is the "Windows" key on Windows
              )
            );
        });
        var normalKeyMatch = event.key === _.last(shortcut).key;
        if (specialKeysMatch && normalKeyMatch) {
          this._completed();
        } else {
          var shortcutFinished = (
            !_.contains(_.keys(specialKeyCodeToEvent), String(event.keyCode)) &&
            !event.metaKey
          );
          this._notCompleted({ force: shortcutFinished });
        }
      }
    },

    getActiveHyperlink: function() {
      var isActive = this.model.get('event.hyperlink');
      var url = this.model.get('event.hyperlinkUrl');
      return isActive && url ? url : null;
    },

    isNextLoaderDisabled: function() {
      return !!this.getActiveHyperlink();
    },

    openHyperlink: function() {
      var url = this.getActiveHyperlink();
      if (url && !this.timerDuration) {
        var absoluteUrl =
          (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('mailto:')) ?
          url :
          'https://' + url;
        window.open(absoluteUrl, '_blank');
        return true;
      }
      return false;
    },

    openHyperLinkOrComplete: function() {
      var opened = this.openHyperlink();
      if (opened && iorad.player.tab !== 'quiz') {
        this.showStepAdvanceButton({ timerDuration: 1000 });
      } else {
        this._completed();
      }
    },

    // left click
    onClick: function() {
      if (this.timerDuration) {
        this._completed();
        return;
      }

      if (this.model.get('event.dblclick')) {
        // this is the first click of an eventual double click,
        // we can't be sure if action will be a failure or not,
        // => don't do anything
        return;
      }

      this.openHyperLinkOrComplete();
    },

    onDoubleClick: function() {
      if (this.timerDuration) return;

      if (this.model.get('event.dblclick')) {
        this.openHyperLinkOrComplete();
      }
    },

    onMouseUp: function(event) {
      // handled just to give failed feedback on right click
      if (event.which === 3) { // right click
        this._notCompleted();
      }
    },

  });
})();
;
(function() {
  var Super = iorad.player.views.markerCommon(iorad.base.views.MarkerRightClick);
  iorad.player.views.MarkerRightClick = Super.extend({

    events: {
      'mouseup': 'onMouseUp',
      'touchstart': 'onTouchStart',
    },

    onMouseUp: function(event) {
      const isRealMobile = iorad.player.controllers.clientDetect.device.isMobile;
      if (!isRealMobile) {
        // Right Click
        // (implicitly also handle failure for left click / double click)
        this._completedIf(event.which === 3);
      }
    },

    onTouchStart: function(event) {
      const isRealMobile = iorad.player.controllers.clientDetect.device.isMobile;
      if (isRealMobile) {
        // Two Finger Tap
        // (implicitly also handle failure for single tap / double tap)
        this._completedIf(event.originalEvent.touches.length === 2);
      }
    },
  });
})();
;
(function() {
  var Super = iorad.player.views.markerCommon(iorad.base.views.MarkerTyping);
  iorad.player.views.MarkerTyping = Super.extend({
    template: iorad.player.templates.steps_typingtool,

    typingDoneTimeout: 2000,
    typingStepProgressionTimeout: 3000,

    initialize: function() {
      Super.prototype.initialize.apply(this, arguments);

      this.setupAutofocus();

      this.listenToDOM(window, 'keydown', _.bind(function(event) {
        var shortcut = this.model.get('event.shortcut') || [];
        if (
          shortcut.length &&
          (this.el !== event.target && !$.contains(this.el, event.target)) &&
          this.isActive()
        ) {
          // shortcut: handle when pressed anywhere (#10307)
          this.onKeyDown(event);
        }
      }, this));
    },

    setupAutofocus: function() {
      var check = _.bind(function() {
        const canFocus =
          !iorad.player.controllers.views.isCoverOpen() &&
          this.$el.hasClass('active') &&
          iorad.player.mode === 'interactive';
        if (canFocus) {
          // https://github.com/iorad/iorad/issues/8404
          // focus a fake input then real input
          var fakeInput = document.createElement('input');
          fakeInput.setAttribute('type', 'text');
          fakeInput.style = 'position:absolute;opacity:0;height:0;font-size:14px;';
          document.body.prepend(fakeInput);
          fakeInput.focus();

          setTimeout(_.bind(function() {
            this.$('.typingTool').focus();

            fakeInput.remove();
          }, this), 10);
        } else {
          this.$('.typingTool').blur();
        }
      }, this);

      this.listenTo(this, 'activated', check);
      this.listenTo(this, 'notActivated', check);
      this.listenTo(iorad.player.controllers.views, 'change:coverOpen', check);
      this.listenTo(iorad.player.events, 'marker:TYPING:focus', check);
    },

    getTemplateData: function() {
      var templateData = Super.prototype.getTemplateData.apply(this, arguments);

      var isPassword = this.model.get('event.password');
      var text = this.model.get('event.text');
      var shortcutText = this.getShortcutText(this.model.get('event.shortcut'));

      var typingToolText = isPassword ? '••••••' : (shortcutText || text);

      return _.extend({}, templateData, {
        typingToolText,
        notranslate: Boolean(typingToolText),
        placeholderDisabled: this.isTransparent(),
        fullyTransparent: (this.model.get('event.shortcut') || []).length > 0,
      });
    },

    getShortcutText: function(shortcut) {
      return (shortcut || []).map(_.bind(function(storedEvent) {
        var forMac = iorad.player.controllers.clientDetect.os.isMac;

        var key = storedEvent.key || 'key';
        var keyCode = storedEvent.which || storedEvent.keyCode;
        if (keyCode === 16) return 'Shift';
        if (keyCode === 17) {
          return (forMac && !storedEvent.keyCapturedOnMac) ? 'Command' : 'Ctrl';
        }
        if (key === 'Meta' && storedEvent.metaKey) { // (not using just event.key since it reports key as 'Meta' when doing CTRL + SHIFT + ALT)
          return forMac ? 'Command' :
            storedEvent.keyCapturedOnMac ? 'Ctrl' : 'Windows';
        }
        if (keyCode === 18) { // Alt (not using event.key since it reports key as 'Meta' when doing CTRL + SHIFT + ALT)
          return forMac ? 'Opt' : 'Alt';
        }
        if (key === ' ') return 'Space';
        return key;
      }, this)).join(' + ');
    },

    updateStyle: function() {
      return Super.prototype.updateStyle.apply(this, arguments)
        .then(function() {
          var markerColor = this.model.get('marker.color');
          var backgroundColor = (markerColor && markerColor !== 'rgba(0, 0, 0, 0)') ? markerColor : '#ffffff';
          var textColor = this.model.get('event.fontColor') || iorad.base.Export.contrastColor(backgroundColor);
          var fontSize = this.model.get('event.fontSize');
          const canInteract = iorad.player.mode === 'interactive';
          this.$('.typingTool').css({
            'background-color': backgroundColor,
            'color': textColor,
            'font-size': isNaN(fontSize) ? fontSize : (fontSize + 'px'),
            'font-family': this.model.get('event.fontFamily')
          });
          if (canInteract) {
            this.$('.typingTool').removeAttr('tabindex');
          } else {
            this.$('.typingTool').attr('tabindex', -1);
          }
        }.bind(this));
    },

    isTransparent: function() {
      var shortcut = this.model.get('event.shortcut') || [];
      return Super.prototype.isTransparent.apply(this, arguments) ||
        shortcut.length > 0;
    },

    events: {
      'keyup': 'onKeyUp',
      'keydown': 'onKeyDown'
    },

    validateText: function(enteredText, text) {
      if (!this.model.get('event.validate')) return true;

      const match = this.isEventMatch();
      const matchType = this.getEventMatchType();

      if (match && matchType === 'number') {
        const textIsNumber = text !== undefined && text !== '' && !Number.isNaN(Number(text));
        const enteredTextIsNumber = enteredText !== '' && !Number.isNaN(Number(enteredText));
        if (textIsNumber) {
          // actual number check
          return enteredTextIsNumber && Number(text) === Number(enteredText);
        }
        // ignore text, just make sure enteredText is a number
        return enteredTextIsNumber;
      }

      if (text !== undefined && text !== '') {
        if (match && matchType === 'case') {
          return String(enteredText) === String(text);
        }
        return String(enteredText).toLowerCase() === String(text).toLowerCase();
      }

      return true;
    },

    onKeyUp: function() {
      this.clearCompletedTimer();

      var text = this.model.get('event.text'); // Note: this might have typeof === 'number'!
      var shortcut = this.model.get('event.shortcut') || [];
      var enteredText = this.$('textarea').val();
      var isPassword = this.model.get('event.password');
      if (isPassword) {
        // replace text with asterisks
        this.$('textarea').val(this._getFixedLengthCharacters('•', enteredText.length));
        // check length only, no characters matched
        if (enteredText.length === 0) {
          this._notCompleted();
          return;
        }
      } else if (shortcut.length) {
        // handled by onKeyDown
        this._notCompleted();
        return;
      } else {
        // not completed if the user has typed the wrong text
        if (!this.validateText(enteredText, String(text))) {
          this._notCompleted();
          return;
        }
      }

      // deferred completition
      this.cancelTimer();
      this.completedTimer =
        setTimeout(_.bind(this.afterTypingTimeout, this), this.typingDoneTimeout);
      this._notCompleted();
    },

    afterTypingTimeout: function() {
      const isTypeAutoadvance = this.model.get('event.typeAutoadvance');
      const isLastStep = this.model.get('index') >= this.stepsCollection.length - 1;
      if (this.model.get('event.submit') && isTypeAutoadvance === false) {
        this.showStepAdvanceButton({ timerDuration: this.typingStepProgressionTimeout });
        return;
      }
      if (this.model.get('event.submit') || isLastStep || iorad.player.tab === 'quiz') {
        this._completed();
      } else {
        // === false for old tutorial
        if (isTypeAutoadvance === false) {
          this.showStepAdvanceButton({ timerDuration: this.typingStepProgressionTimeout });
          return;
        }
        this.completedTimer =
          setTimeout(_.bind(this._completed, this), this.typingStepProgressionTimeout);
        this.showStepAdvanceButton({ timerDuration: this.typingStepProgressionTimeout });
      }
    },

    onKeyDown: function(event) {
      var value = this.$('.typingTool').val();

      // no value then next/back arrow will trigger next/back action
      if (!value) {
        var isMobileDevice = iorad.player.device !== 'desktop';
        var isMobileTutorial = iorad.player.data.tutorial.get('isMobile');

        if (event.which == 37) {
          if (isMobileDevice && !isMobileTutorial) {
            return iorad.player.events.trigger('mobilequick:back');
          } else {
            return iorad.player.events.trigger('interactive:back');
          }
        } else if (event.which == 39) {
          if (isMobileDevice && !isMobileTutorial) {
            return iorad.player.events.trigger('mobilequick:next');
          } else {
            return iorad.player.events.trigger('interactive:next');
          }
        }
      }

      var shortcut = this.model.get('event.shortcut') || [];
      if (shortcut.length) {
        event.preventDefault();

        var forMac = iorad.player.controllers.clientDetect.os.isMac;

        var specialKeyCodeToEvent = {
          16: event.shiftKey,
          17: event.ctrlKey,
          18: event.altKey,
        };

        // match all special keys and the final normal key
        var specialKeysMatch = shortcut.length === 1 ? true : _.every(shortcut.slice(0, -1), function (storedEvent) {
          return specialKeyCodeToEvent[storedEvent.keyCode] ||
            (
              // Mac: also advance on Command when CTRL was captured on Windows
              forMac &&
              (storedEvent.keyCode === 17 && !storedEvent.keyCapturedOnMac) && // CTRL captured on Windows
              event.metaKey
            ) ||
            (
              storedEvent.key === 'Meta' &&
              storedEvent.metaKey && // exclude "CTRL + SHIFT + ALT" which is reported as event.key === 'Meta'
              (
                forMac ? event.metaKey // Mac: Command
                  : storedEvent.keyCapturedOnMac
                    ? event.ctrlKey // Windows: Meta (CMD) captured on Mac is Ctrl on Windows
                    : event.metaKey // Windows: Meta captured on Windows is the "Windows" key on Windows
              )
            );
        });
        var normalKeyMatch = event.key === _.last(shortcut).key;
        if (specialKeysMatch && normalKeyMatch) {
          this._completed();
        } else {
          var shortcutFinished = (
            !_.contains(_.keys(specialKeyCodeToEvent), String(event.keyCode)) &&
            !event.metaKey
          );
          this._notCompleted({ force: shortcutFinished });
        }
      } else if (event.which == 13 || event.which == 9) { // enter or tab
        event.preventDefault(); // prevent multi-line typing tool

        // handle enter/tab interaction wise
        if (this.completedTimer || this.completed) {
          // the user typed something and is waiting the timeout,
          // in the meantime pressed enter/tab
          // => instant complete
          return this._completed();
        }
        // user pressed enter/tab without completing
        return this._notCompleted({ force: true });
      } else {
        const validate = this.model.get('event.validate');
        const match = this.isEventMatch();
        const matchType = this.getEventMatchType();
        if (validate && match && matchType === 'number') {
          const typingNumber = (
            event.key.match(/^\d$/) ||
            (event.key === '.' && value.length > 0) ||
            (event.key === ',' && value.length > 0) ||
            ['Backspace', 'Delete', 'ArrowLeft', 'ArrowUp', 'ArrowRight', 'ArrowDown'].includes(event.key)
          );
          if (!typingNumber) {
            event.preventDefault();
            noty({
              type: 'error',
              text: 'Enter a number',
            });
          }
        }
      }
    },

    _getFixedLengthCharacters: function(character, length) {
      var chars = [];
      for (var i = 0; i < length; i++) {
        chars.push(character);
      }
      return chars.join('');
    },

    clearCompletedTimer: function() {
      if (this.completedTimer) {
        clearTimeout(this.completedTimer);
        this.completedTimer = undefined;
      }
    },

    _completed: function() {
      this.clearCompletedTimer();

      Super.prototype._completed.apply(this, arguments);
    }

  });
})();

;
(function() {
  var Super = iorad.player.views.markerCommon(iorad.base.views.MarkerScroll);
  iorad.player.views.MarkerScroll = Super.extend({
    template: iorad.player.templates.steps_scrolltool,

    events: {
      'mouseup': 'onMouseUp',
    },

    enableInteractivity: function() {
      Super.prototype.enableInteractivity.apply(this, arguments);

      var transitionDuration = $('#playing-player li.marker').css('transition-duration'); // eg '0.5s'
      transitionDuration = parseFloat(transitionDuration) * 1000; // converted to ms, eg '500'

      // HACK: fake 'invisible span' to advance slide when scrolling viewport
      this.scrollCustomTimer = setTimeout(_.bind(function() { // wait end of scroll animation to prevent premature call
        if (this.completed) return; // obsolete timer, action already completed, don't bind!

        var isHorizontal = this.model.get('event.horizontal') === true;
        var lastScrollTop = $('.image-surround').scrollTop();

        this.onImageSurroundScroll = _.bind(function(event) {
          if (this.completed) return;
          var scrollTop = $('.image-surround').scrollTop();
          var isThisScrollHorizontal = (scrollTop === lastScrollTop);
          if (isHorizontal === isThisScrollHorizontal) this._completed();
          lastScrollTop = scrollTop;
        }, this);
        $('.image-surround').on('scroll', this.onImageSurroundScroll);
      }, this), transitionDuration + 1); // +1 ms to be called as last handler
    },

    render: function() {
      Super.prototype.render.apply(this, arguments);

      // manually listen for the scroll event on the child element,
      // as it doesn't bubble like the other DOM events and thus
      // the normal Backbone event delegation wont't work for it
      this.$('.scroll-wrapper').on('scroll', _.bind(this.onScroll, this));

      return this;
    },

    onScroll: function() {
      if (this.completed) return;
      this._completed();
    },

    onMouseUp: function() {
      if (this.completed) return;
      this._completed();
    },

    remove: function() {
      clearTimeout(this.scrollCustomTimer);
      if (this.onImageSurroundScroll) { // check needed if the marker is removed before timer call
        $('.image-surround').off('scroll', this.onImageSurroundScroll);
      }

      this.$('.scroll-wrapper').off('scroll');

      return Super.prototype.remove.apply(this, arguments);
    }

  });
})();
;
(function() {
  var Super = iorad.player.views.markerCommon(iorad.base.views.MarkerDrag);
  iorad.player.views.MarkerDrag = Super.extend({
    template: iorad.player.templates.steps_dragtool,

    initialize: function() {
      Super.prototype.initialize.apply(this, arguments);

      this.listenToDOM($('.image-surround'), 'mouseup', this.onScrenshotMouseUp);
    },

    // catch mouse up events outside the drag marker
    onScrenshotMouseUp: function(event) {
      // mouse up outside the drag marker after the mouse down on it
      var isMouseUpOutsideEl = this.$el.hasClass('dragged') && $(event.target).closest('.marker.DRAG').length === 0;
      if (!isMouseUpOutsideEl) return; // normal mouse up

      // in case the mouse up is on the drop marker, it isn't a valid drop only if the drop marker is transitioning
      var dropMarkerView = this.markerListView.getMarkerView('DROP');
      if ($(event.target).closest('.marker.DROP') === 0 || (dropMarkerView && dropMarkerView.isRenderTransitionRunning)) {
        this.onMouseUp();
      }
    },

    // mouse position relative to the containment
    eventToMouseContainmentPosition: function(event) {
      var containmentBounds = this.slideContainmentEl[0].getBoundingClientRect();
      var viewportBounds = this.slideViewportEl[0].getBoundingClientRect();
      var scale = containmentBounds.width / this.slideContainmentEl.width(); // NOTE: assumes x & y scale are the same

      // mouse position relative to the viewport bounds
      var mouseViewportPositionY = (event.pageY - viewportBounds.top);
      var mouseViewportPositionX = (event.pageX - viewportBounds.left);

      // if the viewport is bigger than the containment,
      // the containment is vertically centered
      // => remove the margin
      if (containmentBounds.top > 0) {
        mouseViewportPositionY -= containmentBounds.top;
      }
      if (containmentBounds.left > 0) {
        mouseViewportPositionX -= containmentBounds.left;
      }

      var mouseContainmentPositionY = (mouseViewportPositionY + this.slideViewportEl.scrollTop()) / scale;
      var mouseContainmentPositionX = (mouseViewportPositionX + this.slideViewportEl.scrollLeft()) / scale;

      return {
        top: mouseContainmentPositionY,
        left: mouseContainmentPositionX,
      };
    },

    enableInteractivity: function() {
      Super.prototype.enableInteractivity.apply(this, arguments);

      this.slideViewportEl = this.$el.parents('.image-surround');
      this.slideContainmentEl = this.slideViewportEl.find('.containment');

      this.$el.draggable({
        containment: this.slideContainmentEl,
        scroll: true,
        scrollSensitivity: 10,
        scrollSpeed: 10,
        start: _.bind(this.onDragStart, this),
        drag: _.bind(function(event, ui) {
          var mouseContainmentPosition = this.eventToMouseContainmentPosition(event);
          ui.position.top = mouseContainmentPosition.top - this.dragStartMouseDistance.top;
          ui.position.left = mouseContainmentPosition.left - this.dragStartMouseDistance.left;
        }, this),
        stop: _.bind(this.onDragEnd, this)
      });

      this.isDropApproachingRunning = false;
    },

    enableDraggedState: function() {
      // copy the the drag marker screenshot background in the canvas
      this.drawBackground();

      this.$el.addClass('dragged');

      // remove css move transition when dragging element
      // to prevent sloppy dragging effect
      this.$el.addClass('no-transition');


      this.stashScreenshotOverlay();
    },

    disableDraggedState: function() {
      this.$el.removeClass('dragged');

      // restore original position
      var bounds = this.getBounds();
      this.$el.css({
        'left': bounds.x,
        'top': bounds.y
      });
      // make the original position visible
      //this.slideView.makeIntoView(this.$el, {useCSSForEl: true});
      this.markerListView.adjustPanelPosition();

      this.$el.removeClass('no-transition');

      this.unstashScreenshotOverlay();
    },

    events: {
      'mousedown': 'onMouseDown',
      'mouseup': 'onMouseUp'
    },

    // start drop marker approaching mode
    onMouseDown: function(event) {
      // console.log('mouse down');

      // handle right click
      // Note: the check is disabled on touch devices
      // since the event with which===3 seems to be triggered on longpress
      if (event && event.which === 3 && !('ontouchend' in document)) {
        this._notCompleted();
        return;
      }
      this.markerListView.trigger('dropToolReady', false);

      this.enableDraggedState();
      this._completed();

      //var markerDrop = this.slideContainmentEl.find('.marker.DROP');
      //if (iorad.base.Utils.isIntoView(markerDrop, this.slideViewportEl, {useCSSForEl: true})) {
      //    // no approaching needed
      //    return;
      //}

      this.isDropApproachingRunning = true;
      this.moveNearDropTool(_.bind(function() { // on finish
        this.putDropToolAboveOverlay();
        this.markerListView.adjustPanelPosition();
        this.isDropApproachingRunning = false;
        this.trigger('dropApproachingFinished');
        this.markerListView.trigger('dropToolReady', true);
      }, this));
    },

    onDragStart: function(event) {
      // console.log('drag start');

      var mouseContainmentPosition = this.eventToMouseContainmentPosition(event);
      this.dragStartMouseDistance = {
        top: mouseContainmentPosition.top - parseInt(this.$el.css('top'), 10),
        left: mouseContainmentPosition.left - parseInt(this.$el.css('left'), 10),
      };

      //this.stopDropApproaching();
      this.enableDraggedState();
    },

    stopDropApproaching: function() {
      if (this.isDropApproachingRunning) {
        // we are in the middle of a movement, stop it
        this.slideViewportEl.stop();
        this.$el.stop();
        this.isDropApproachingRunning = false;
        this.trigger('dropApproachingFinished');
      }
    },

    // this is needed on mouseup without having started the drag
    // Note: event is optional!
    onMouseUp: function(event) {
      if ('ontouchend' in document) {
        // check disabled on touch devices since the event is fired anyway before drop
        return;
      }

      if (event && event.which === 3) {
        // is the right-click mouse up after the right-click mouse down
        return;
      }

      //console.log('mouse up');
      this.stopDropApproaching();
      this.disableDraggedState();

      this.dropNotCompleted();
    },

    onDragEnd: function() {
      console.log('drag end');
      this.disableDraggedState();

      this.dropNotCompleted();
    },

    dropNotCompleted: function(argument) {
      // we actually dropped outside the drop marker
      // (NOTE: the code is coupled, but right now there is no way
      // for the drop marker to know by itself when this happens)
      var dropMarkerView = this.markerListView.getMarkerView('DROP');
      if (dropMarkerView) dropMarkerView._notCompleted();
    },

    stashScreenshotOverlay: function() {
      if (this.stashedCanvasAboveOverlay) {
        return;
      }

      if (iorad.player.data.tutorial.getScreenshotOverlayEnter() !== 'no-transition') {
        this.slideContainmentEl.find('.screenshot-overlay').addClass('hide');
      }

      var canvasAboveOverlay = this.slideContainmentEl.find('.canvas-above-overlay');
      this.stashedCanvasAboveOverlay = {
        imageData: canvasAboveOverlay[0].getContext('2d').getImageData(
          0,
          0,
          canvasAboveOverlay[0].width,
          canvasAboveOverlay[0].height
        ),
        bounds: {
          x: parseFloat(canvasAboveOverlay.css('left')),
          y: parseFloat(canvasAboveOverlay.css('top')),
          width: parseFloat(canvasAboveOverlay.css('width')),
          height: parseFloat(canvasAboveOverlay.css('height')),
        }
      };
      canvasAboveOverlay.addClass('hide');
    },

    putDropToolAboveOverlay: function() {
      var dropMarkerView = this.markerListView.getMarkerView('DROP');
      var markerDropBounds = dropMarkerView.getBounds();

      var canvasAboveOverlay = this.slideContainmentEl.find('.canvas-above-overlay');
      var imageData = this.slideView.screenshotView.extract(markerDropBounds);
      canvasAboveOverlay[0].width = markerDropBounds.width;
      canvasAboveOverlay[0].height = markerDropBounds.height;
      canvasAboveOverlay[0].getContext('2d').putImageData(imageData, 0, 0);
      canvasAboveOverlay.css({
        'left': markerDropBounds.x,
        'top': markerDropBounds.y,
        'width': markerDropBounds.width,
        'height': markerDropBounds.height,
      });
      canvasAboveOverlay.removeClass('hide');
    },

    unstashScreenshotOverlay: function() {
      if (!this.stashedCanvasAboveOverlay) {
        return;
      }

      this.slideContainmentEl.find('.screenshot-overlay').removeClass('hide');

      var canvasAboveOverlay = this.slideContainmentEl.find('.canvas-above-overlay');
      canvasAboveOverlay[0].width = this.stashedCanvasAboveOverlay.bounds.width;
      canvasAboveOverlay[0].height = this.stashedCanvasAboveOverlay.bounds.height;
      canvasAboveOverlay[0].getContext('2d').putImageData(this.stashedCanvasAboveOverlay.imageData, 0, 0);
      canvasAboveOverlay.css({
        left: this.stashedCanvasAboveOverlay.bounds.x,
        top: this.stashedCanvasAboveOverlay.bounds.y,
        width: this.stashedCanvasAboveOverlay.bounds.width,
        height: this.stashedCanvasAboveOverlay.bounds.height,
      });
      this.stashedCanvasAboveOverlay = undefined;
      canvasAboveOverlay.removeClass('hide');
    },

    moveNearDropTool: function(callback) {
      var dropMarkerView = this.markerListView.getMarkerView('DROP');
      var markerDropBounds = dropMarkerView.getBounds();

      // Do nothing if drop final position is already into view
      // (a placeholder is used since the drop gradually transitions to the final position)
      var finalDropPlaceholder = $(document.createElement("div"));
      finalDropPlaceholder.css({
        'left': markerDropBounds.x,
        'top': markerDropBounds.y,
        'width': markerDropBounds.width,
        'height': markerDropBounds.height,
        'display': 'none'
      });
      var isDropIntoView = iorad.base.Utils.isIntoView(finalDropPlaceholder, this.slideViewportEl, {
        useCSSForEl: true
      });
      finalDropPlaceholder.remove();
      if (isDropIntoView) {
        if (callback) {
          setTimeout(callback, 500); // still wait for drop to transition
        }
        return;
      }

      var containment = this.slideContainmentEl;
      var containmentBounds = containment[0].getBoundingClientRect();
      var scale = containmentBounds.width / containment.width(); // NOTE: assumes x & y scale are the same

      var margin = 75; // TODO: calculate real margin to keep relative distance
      var scrollTop = this.slideViewportEl.height() >= containmentBounds.height ?
        this.slideViewportEl.scrollTop()
        :
        (markerDropBounds.y - margin) * scale;
      var scrollLeft = this.slideViewportEl.width() >= containmentBounds.width ?
        this.slideViewportEl.scrollLeft()
        :
        (markerDropBounds.x - margin) * scale;

      // follow the scroll movement with the marker, by always keeping the same
      // relative position.
      // the marker movement must be equal to the actual travelled scrollbar distance


      // never scroll past the bottom/right edge of the screenshot
      // (needed when zooming out:
      // the viewport keeps the original scrollable area,
      // which is bigger than the screenshot)
      var maxScrollTop = Math.max(0, containmentBounds.height - this.slideViewportEl.height());
      var maxScrollLeft = Math.max(0, containmentBounds.width - this.slideViewportEl.width());

      var finalScrollTop = _.min([scrollTop, maxScrollTop]); // handle too high value (over the scrollbar limit)
      if (finalScrollTop < 0) finalScrollTop = 0; // handle too low value (negative)

      var finalScrollLeft = _.min([scrollLeft, maxScrollLeft]);
      if (finalScrollLeft < 0) finalScrollLeft = 0;

      // #14232: the drop tool is still in view and view is not scrolled down
      if (this.slideViewportEl.scrollTop() === 0 && (markerDropBounds.x + markerDropBounds.width) < this.slideViewportEl.width()) {
        finalScrollLeft = _.min([0, finalScrollLeft]);
      }

      // travelled scrollbar distance
      var scrollTopDelta = finalScrollTop - this.slideViewportEl.scrollTop(),
        scrollLeftDelta = finalScrollLeft - this.slideViewportEl.scrollLeft();

      // we also animate with the actual 'what will be' travelled scrollbar distance
      // also the scrollbars themselves
      // or jquery will just continue trying to move scrollbars with no effect when they
      // reached the limit;
      // with this instead we move only what is really needed
      // by thus keeping same velocity of marker
      // and hence without disrupting marker relative position
      this.slideViewportEl.animate({
        scrollTop: finalScrollTop,
        scrollLeft: finalScrollLeft,
      }, 500);

      var markerDragBounds = iorad.base.Utils.getElementBounds(this.$el, {
        useCSSForEl: true
      });
      this.$el.animate({
        top: markerDragBounds.top + (scrollTopDelta / scale),
        left: markerDragBounds.left + (scrollLeftDelta / scale),
      }, 500, callback);
    },

    // draw the screenshot portion behind the marker to the marker canvas
    // (so to reproduce the "move image" effect on drag)
    drawBackground: function() {
      var backgroundCanvas = this.$el.find('canvas')[0];
      var markerBounds = this.getBounds();

      var imageData = this.slideView.screenshotView.extract(markerBounds);

      // set the canvas size or the copied image won't span for all the canvas
      backgroundCanvas.width = markerBounds.width;
      backgroundCanvas.height = markerBounds.height;

      var backgroundCanvasCtx = backgroundCanvas.getContext("2d");
      backgroundCanvasCtx.putImageData(imageData, 0, 0);
    },
    waitForTransition: function() {
      var thisMarkerView = this;
      return this.constructor.__super__.waitForTransition.apply(this, arguments)
        .then(function() {
          if (!thisMarkerView.isDropApproachingRunning) return Promise.resolve();
          return new Promise(function(resolve) {
            thisMarkerView.once('dropApproachingFinished', resolve);
          })
            .then(function() {
              return iorad.base.Utils.setTimeoutPromise().promise;
            });
        });
    },
  });
})();
;
(function() {
  var Super = iorad.player.views.markerCommon(iorad.base.views.MarkerDrop);
  iorad.player.views.MarkerDrop = Super.extend({
    template: iorad.player.templates.steps_droptool,

    enableInteractivity: function(options) {
      Super.prototype.enableInteractivity.apply(this, arguments);

      this.$el.droppable({
        accept: ".marker.DRAG",
        tolerance: "touch", // accept when Draggable overlaps the droppable any amount.
        drop: _.bind(this.onDrop, this)
      });

      this.ready = false;

      this.listenTo(this.markerListView, 'dropToolReady', (ready) => {
        this.ready = ready;
      });
    },

    events: {
      'mouseup': 'onMouseUp'
    },

    onDrop: function(event, ui) {
      if (!this.completed) this._completed();
    },

    // needed when the DROP marker is exactly below the DRAG marker,
    // in this case no mouse movement happens and thus onDrop isn't called
    onMouseUp: function(e) {
      if (!this.ready) return;

      if (!this.completed) this._completed();
    },

  });
})();
;
(function() {
  var Super = iorad.player.views.markerCommon(iorad.base.views.MarkerHover);
  iorad.player.views.MarkerHover = Super.extend({

    hoverTimeout: 700,

    events: {
      'mouseover': 'onMouseOver',
      'mouseleave': 'onMouseLeave',
    },

    onMouseOver: function() {
      this.clearCompletedTimer();
      this.completedTimer = setTimeout(_.bind(this._completed, this), this.hoverTimeout);
    },

    onMouseLeave: function() {
      this.clearCompletedTimer();
    },

    clearCompletedTimer: function() {
      if (this.completedTimer) {
        clearTimeout(this.completedTimer);
        this.completedTimer = undefined;
      }
    },

    _completed: function() {
      this.clearCompletedTimer();

      Super.prototype._completed.apply(this, arguments);
    },

  });
})();

;
(function() {
  var Super = iorad.player.views.markerCommon(iorad.base.views.MarkerSelectText);
  iorad.player.views.MarkerSelectText = Super.extend({
    template: iorad.player.templates.steps_select_text_tool,

    initialize: function() {
      Super.prototype.initialize.apply(this, arguments);

      setTimeout(_.bind(function() {
        this.listenToDOM($('.image-surround'), 'mouseup', this.onScrenshotMouseUp);
      }, this));
    },

    events: {
      'mouseup': '_completedIfSelection',
      'keyup': '_completedIfSelection' // for CTRL + A
    },

    render: function() {
      Super.prototype.render.apply(this, arguments);

      var $selectTextTool = this.$('.selectTextTool');
      $selectTextTool.val(new Array(10000).join(' '));
      var markerBounds = this.getBounds();
      $selectTextTool.css({
        fontSize: markerBounds.height + 'px',
        lineHeight: markerBounds.height + 'px',
      });
      const canInteract = iorad.player.mode === 'interactive';
      if (canInteract) {
        $selectTextTool.removeAttr('tabindex');
      } else {
        $selectTextTool.attr('tabindex', -1);
      }
      return this;
    },

    // catch mouse up events outside the marker
    onScrenshotMouseUp: function(event) {
      var isMouseUpOutsideEl = $(event.target).closest('.marker.SELECT_TEXT').length === 0;
      if (!isMouseUpOutsideEl) return; // normal mouse up

      var completed = this._completedIfSelection();
      if (completed) {
        // prevent mouseup to register invalid action on next step (#7119)
        event.stopImmediatePropagation();
      }
    },

    _completedIfSelection: function() {
      var selection = window.getSelection();
      return this._completedIf(
        selection.anchorNode === this.el &&
        selection.focusNode === this.el &&
        selection.type === 'Range'
      );
    },
  });
})();
;
iorad.player.views.MarkerFactory = iorad.base.views.MarkerFactory.extend({}, { // STATIC PROPERTIES
  types: {
    'defaultType': iorad.player.views.MarkerDefault,
    'READ': iorad.player.views.MarkerRead,
    'LEFT_CLICK': iorad.player.views.MarkerLeftClick,
    'RIGHT_CLICK': iorad.player.views.MarkerRightClick,
    'TYPING': iorad.player.views.MarkerTyping,
    'SCROLL': iorad.player.views.MarkerScroll,
    'DRAG': iorad.player.views.MarkerDrag,
    'DROP': iorad.player.views.MarkerDrop,
    'HOVER': iorad.player.views.MarkerHover,
    'SELECT_TEXT': iorad.player.views.MarkerSelectText,
  }
});
;
iorad.player.views.MarkerInfo = iorad.base.View.extend({
  template: iorad.player.templates.markers_info,
  className: 'marker-info',

  initialize: function(options) {
    options = options || {};

    this.markerView = options.markerView;

    this.render();
  },

  getTemplateData: function() {
    return _.extend(this.model.toJSON(), {
      renderTimestamp: Date.now(),
      tutorialIsMobile: iorad.player.data.tutorial.get('isMobile'),
    });
  },

  render: function() {
    iorad.base.View.prototype.render.apply(this, arguments);

    this.$el.addClass(this.model.get('type'));
    this.hide();

    return this;
  },

  show: function() {
    var stepContainerHeight = this.$('.step-container').parent().height();
    var stepContainerWidth = this.$('.step-container').parent().width();
    if (!stepContainerHeight) return; // too early
    var topArrowHeight = parseInt(this.$('.arrow-top').css('border-bottom-width'), 10);
    stepContainerHeight = stepContainerHeight + topArrowHeight;
    stepContainerWidth = stepContainerWidth + topArrowHeight;

    // reset
    _.each(['top', 'right', 'bottom', 'left'], function(cssClass) {
      this.$el.removeClass(cssClass);
    }, this);

    var markerBounds = this.markerView.getBounds();
    var containmentEl = this.markerView.getSlideContainmentEl();
    var positionClass;

    var markerHCenter = markerBounds.x + (markerBounds.width / 2);
    var markerVCenter = markerBounds.y + (markerBounds.height / 2);
    var markerBottom = markerBounds.y + markerBounds.height;
    var markerRight = markerBounds.x + markerBounds.width;

    // info is displayed on center, thus we need half space on left/top and half space on right/bottom
    // for the icon width (i.e. the circle width)
    var minHorizontalAxisSpace = (stepContainerWidth / 2);
    var minVerticalAxisSpace = (stepContainerHeight / 2);
    var isHorizontalSuitable = (markerHCenter >= minHorizontalAxisSpace) && ((containmentEl.width() - markerHCenter) >= minHorizontalAxisSpace);
    var isVerticalSuitable = (markerVCenter >= minVerticalAxisSpace) && ((containmentEl.height() - markerVCenter) >= minVerticalAxisSpace);

    var isTopSuitable = (markerBounds.y >= stepContainerHeight && isHorizontalSuitable);
    var isLeftSuitable = (markerBounds.x >= stepContainerWidth && isVerticalSuitable);
    var isBottomSuitable = (containmentEl.height() - markerBottom >= stepContainerHeight) && isHorizontalSuitable;
    var isRightSuitable = (containmentEl.width() - markerRight >= stepContainerWidth) && isVerticalSuitable;

    if (isTopSuitable) {
      positionClass = 'top';
    } else if (isLeftSuitable) {
      positionClass = 'left';
    } else if (isBottomSuitable) {
      positionClass = 'bottom';
    } else if (isRightSuitable) {
      positionClass = 'right';
    } else {
      // there isn't enough space, don't display it at all
      positionClass = 'hide';
    }

    // prevent ugly overflow when marker-info is squashed all the way to the left
    if ((positionClass === 'top' || positionClass === 'bottom') && markerBounds.x <= 6) {
      if (isLeftSuitable) {
        positionClass = 'left';
      } else if (isRightSuitable) {
        positionClass = 'right';
      }
    }

    this.$el.addClass(positionClass);
    this.$el.show();
  },

  hide: function() {
    this.$el.hide();
  }

});

;
// Takes a step and draws the marker and listens user interaction with
// the marker
iorad.player.views.MarkerList = Backbone.View.extend({
  className: 'steps-list',
  tagName: 'ul',

  initialize: function(options) {
    _.bindAll(this, 'render', '_onMarkerCompleted');

    this.slideView = options.slideView;
    this.tutorial = options.tutorial;
    this.stepsCollection = options.stepsCollection;
    this.listenTo(this.slideView, 'mouseUpOutsideMarker', this._notCompleted);
    this.listenTo(iorad.player.events, 'showStepAdvanceButton', this.showStepAdvanceButton);
    this.listenTo(iorad.player.events, 'step:timerCanceled', this.stepTimerCanceled);

    this.markerViews = [];

    this.monitorFullscreen();
  },

  showStepAdvanceButton: function(options) {
    _.each(this.markerViews, function(markerView) {
      markerView.showStepAdvanceButton(options);
    });
  },

  stepTimerCanceled: function() {
    _.each(this.markerViews, function(markerView) {
      markerView.cancelTimer();
    });
  },

  monitorFullscreen: function() {
    if (!screenfull.enabled) return;
    document.addEventListener(screenfull.raw.fullscreenchange, _.bind(function() {
      var markerView = this.markerViews[0];
      if (markerView) {
        this.trigger('makeIntoViewRequest', markerView.$el, {useCSSForEl: true});
      }
    }, this));
  },

  setStep: function(step) {
    this.model = step;
  },

  getMarkerView: function(markerType) {
    return _.find(this.markerViews, function(markerView) {
      return markerView.model.get('type') == markerType;
    });
  },

  getActiveMarkers: function() {
    return _.filter(this.markerViews, function(markerView) {
      return markerView.isActive();
    });
  },

  enableInteractivity: function() {
    _.each(this.markerViews, function(markerView) {
      markerView.enableInteractivity();
    });
  },

  _onMarkerCompleted: function(markerView, options) {
    var type = this.model.get('type');

    var markerType = markerView.model.get('type');
    if (type == 'TYPING' && this.model.get('event.submit')) {
      // typing and click
      return this.onTypingAndClickCompleted(markerType, options);

    } else if (type == 'DRAG_AND_DROP') {
      return this.onDragAndDropCompleted(markerType, options);
    }

    // default
    this._completed();
  },

  onTypingAndClickCompleted: function(markerType, options) {

    var typingMarkerView = this.getMarkerView('TYPING');
    var clickMarkerView = this.getMarkerView('LEFT_CLICK');

    if (!clickMarkerView) {
      // Corrupted/Invalid captured step without the click sub step (See #13543)
      this._completed();
      return;
    }

    if (markerType == 'TYPING') { // the typing of the typing and click is done
      if (!options || !options.advance) { // advance option can be used to advance directly to the next slide
        // ok, now the user has to click the click marker
        typingMarkerView.toggleActive(false);
        clickMarkerView.toggleActive(true, typingMarkerView);
        //this.trigger('makeIntoViewRequest', clickMarkerView.$el, {useCSSForEl: true});
        return;
      }

    } else if (markerType == 'LEFT_CLICK') { // the click of the typing and click is done
      if (!typingMarkerView.completed) {
        // the user has not yet typed!
        this._notCompleted();
        return;
      }
    }

    this._completed();
  },

  onDragAndDropCompleted: function(markerType, options) {
    var dragMarkerView = this.getMarkerView('DRAG');
    var dropMarkerView = this.getMarkerView('DROP');

    if (markerType == 'DRAG') {
      // ok, now user has to drop
      dragMarkerView.toggleActive(false);
      dropMarkerView.toggleActive(true, dragMarkerView);
      return;
    }

    dragMarkerView.unstashScreenshotOverlay();
    this._completed();
  },

  onMarkerNotCompleted: function(markerView, options) {
    options = options || {};
    // check

    var markerType = markerView.model.get('type');

    if (markerType == 'TYPING') {
      // ignore not completed feedback for typing marker
      // (since is not completed after each keypress until the full text has been typed)
      if (!options.force) return;

    } else if (markerType == 'DROP') {
      // drop failed, user has to drag again
      var dragMarkerView = this.getMarkerView('DRAG');
      var dropMarkerView = markerView;
      dropMarkerView.toggleActive(false);
      dragMarkerView.toggleActive(true, dropMarkerView);
    }

    this._notCompleted();
  },

  _completed: function() {
    // interaction with ALL this list markers completed.
    this.trigger('completed');
    this.trigger('isCompleted', true); // single-name version with parameter for convenience
  },

  _notCompleted: function() {
    this.trigger('notCompleted');
    this.trigger('isCompleted', false);
  },

  render: function() {
    var me = this;

    // We need the previous marker view to perform the transition (morphing)
    // effect from old marker to new one(s).
    // Note that the view is took off from the array to avoid it from being removed on clean (see after).
    if (this.previousMarkerView) this.previousMarkerView.remove(); // remove eventual previous "previousMarkerView" (if leftover)
    this.previousMarkerView = _.find(this.markerViews, function(markerView) { // first old active marker view, could be undefined
      return markerView.isActive();
    });
    if (this.previousMarkerView) {
      // make sure is in right position immediately (hidden)
      this.previousMarkerView.previousMarkerView = undefined;
      this.previousMarkerView.toggleActive(false);
      this.previousMarkerView.render();
    }

    // remove all the old marker views except the "this.previousMarkerView"
    // that we need for the transition and that will thus be removed after
    if (this.previousMarkerView) {
      var previousMarkerViewIndex = this.markerViews.indexOf(this.previousMarkerView);
      this.markerViews.splice(previousMarkerViewIndex, 1); // remove from array
    }
    _.invoke(this.markerViews, 'remove');
    this.markerViews = [];

    function getStepsWithMarkers(step) {
      // If it has no sub-steps OR if it is a summary of its substeps
      if (
        step.steps.length > 0 &&
        !step.get('summary') &&
        step.get('type') !== 'SCROLL' // ignore broken non-postprocessed SCROLL substeps (See https://github.com/iorad/iorad/issues/12775)
      ) {
        return _.flatten(step.steps.map(getStepsWithMarkers));
      } else {
        return [step];
      }
    }

    var steps = getStepsWithMarkers(this.model);

    _.each(steps, function(step, i) {
      var markerView = iorad.player.views.MarkerFactory.create(step.get('type'), {
        model: step,
        stepsCollection: me.stepsCollection,
        previousMarkerView: me.previousMarkerView,
        slideView: me.slideView,
        markerListView: me
      });
      me.listenTo(markerView, 'completed', function(options) {
        me._onMarkerCompleted(markerView, options);
      });
      me.listenTo(markerView, 'notCompleted', function(options) {
        me.onMarkerNotCompleted(markerView, options);
      });
      me.listenTo(markerView, 'activated', function() {
        me.scrollToMarker(markerView);
      });
      me.$el.append(markerView.$el);
      markerView.render(); // to execute after append since has to do layout size calculations!

      me.markerViews.push(markerView);
    });

    // initially only show the first marker
    // (will also make it visible by scrolling to it)
    this.markerViews[0].toggleActive(true);

    if (steps) {
      setTimeout(_.bind(function() { // wait begin of transition first
        // transition just started here, delete the previous marker view
        if (this.previousMarkerView) this.previousMarkerView.remove();
        this.previousMarkerView = undefined;
      }, this));
    }

    return this;
  },

  reset: function() {
    this.render();
  },

  // (the scroll animation should follow the marker position change animation)
  scrollToMarker: function(markerView, options) {
    options = options || {};

    var imageSurround = $('#image-surround');
    if (markerView.model.get('type') === 'DROP') {
      // disable for drop steps since there is already the auto "moveNearDropTool"
      return;
    }

    imageSurround.stop(true, true);

    this.imageTransitionRunning = true;
    var thisTutorial = this.tutorial;
    var thisStepsCollection = this.stepsCollection;
    var thisMarkerList = this;
    var containment = imageSurround.find('.containment');
    var activeMarkers = this.getActiveMarkers();

    var activeStepModel = activeMarkers[0].model;

    var currentStepModel = thisStepsCollection.getCurrentModel();
    var screenshotOverlayEnabled = (
      thisTutorial.getScreenshotOverlayAllStepsEnabled() ||
      (
        currentStepModel &&
        currentStepModel.get('screenshotOverlayEnabled')
      )
    );
    var screenshotOverlayHidden = Boolean(
      thisTutorial.getScreenshotOverlayHideOnTransparentInfoSteps() &&
      activeStepModel.get('type') === 'READ' && // INFO
      !!activeStepModel.get('event.transparent')
    ) || Boolean(
      iorad.player.tab === 'quiz' ||
      (
        iorad.player.oldTab === 'quiz' &&
        iorad.player.controllers.views.isModalTab(iorad.player.tab)
      )
    );
    var screenshotOverlayEl = containment.find('.screenshot-overlay');
    screenshotOverlayEl.css({
      'background': thisTutorial.getScreenshotOverlayColor(),
      'opacity': thisTutorial.getScreenshotOverlayEnter() === 'no-transition' ?
        thisTutorial.getScreenshotOverlayOpacity() / 100
        : 0,
      'visibility': screenshotOverlayHidden ? 'hidden' : '',
    });
    screenshotOverlayEl.stop(true, true);
    screenshotOverlayEl.removeClass('fading-in');
    screenshotOverlayEl.removeClass('hide');
    screenshotOverlayEl.toggle(Boolean(screenshotOverlayEnabled));
    var canvasAboveOverlay = containment.find('.canvas-above-overlay');
    canvasAboveOverlay.removeClass('hide');
    canvasAboveOverlay.hide();

    // reset
    if (screenshotOverlayEnabled) {
      screenshotOverlayEl.stop(true).css('opacity', 0);
    }

    var transitionDuration = (!iorad.player.ready || $('#main .device-change-overlay').is(':visible'))
      ? 0  // prevent ugly transition on startup
      : (typeof options.transitionDuration !== 'undefined')
        ? options.transitionDuration
        : activeMarkers[0].transitionDuration;

    var adjustPanelPosition = this.adjustPanelPosition.bind(this);

    setTimeout(_.bind(function() { // wait begin of transition first
      var containmentBounds = containment[0].getBoundingClientRect();
      var scale = containmentBounds.width / containment.width(); // NOTE: assumes x & y scale are the same

      var originalBounds = markerView.getBounds(); // displayed bounds
      var bounds = _.extend({}, originalBounds, {
        x: originalBounds.x * scale,
        y: originalBounds.y * scale,
        width: originalBounds.width * scale,
        height: originalBounds.height * scale,
      });

      // center alignment
      var spaceVertical = (imageSurround.height() / 2) - (bounds.height / 2);
      var spaceHorizontal = (imageSurround.width() / 2) - (bounds.width / 2);
      // make sure to keep the marker left/top border visible
      var minSpace = iorad.player.data.MARKER_MARGIN * scale;
      if (spaceVertical < minSpace) spaceVertical = minSpace;
      if (spaceHorizontal < minSpace) spaceHorizontal = minSpace;

      // never scroll past the bottom/right edge of the screenshot
      // (needed when zooming out:
      // the viewport keeps the original scrollable area,
      // which is bigger than the screenshot)
      var maxScrollTop = Math.max(0, containmentBounds.height - imageSurround.height());
      var maxScrollLeft = Math.max(0, containmentBounds.width - imageSurround.width());

      var scrollTop = Math.min(
        maxScrollTop,
        Math.max(0, bounds.y - spaceVertical)
      );
      var scrollLeft = Math.min(
        maxScrollLeft,
        Math.max(0, bounds.x - spaceHorizontal)
      );

      var moveCanvasAboveOverlay = _.bind(function () {
        var canvas = containment.find('canvas');
        var canvasCtx = canvas[0].getContext('2d');
        var imageDataBelowMarker = canvasCtx.getImageData(
          originalBounds.x,
          originalBounds.y,
          originalBounds.width,
          originalBounds.height
        );

        canvasAboveOverlay[0].width = originalBounds.width;
        canvasAboveOverlay[0].height = originalBounds.height;
        canvasAboveOverlay[0].getContext('2d').putImageData(imageDataBelowMarker, 0, 0);
        canvasAboveOverlay.css({
          position: 'absolute',
          top: originalBounds.y,
          left: originalBounds.x,
          width: canvasAboveOverlay[0].width,
          height: canvasAboveOverlay[0].height,
        });

        canvasAboveOverlay.toggle(Boolean(
          screenshotOverlayEnabled &&
          (!markerView.isTransparent() || markerView.isTransparentForceDisabled())
        ));
      }, this);

      if (transitionDuration === 0) {
        imageSurround[0].scrollTop = scrollTop;
        imageSurround[0].scrollLeft = scrollLeft;
        if (screenshotOverlayEnabled) {
          moveCanvasAboveOverlay();
          screenshotOverlayEl.css('opacity', thisTutorial.getScreenshotOverlayOpacity() / 100);
        }
        adjustPanelPosition();
        thisMarkerList.imageTransitionRunning = false;
        thisMarkerList.trigger('imageTransitionFinished');
      } else {
        var afterScroll = function () {
          if (screenshotOverlayEnabled) {
            moveCanvasAboveOverlay();
            screenshotOverlayEl.addClass('fading-in');
            if (thisTutorial.getScreenshotOverlayEnter() !== 'no-transition') {
              screenshotOverlayEl.fadeTo(
                thisTutorial.getScreenshotOverlayFadeInDuration() * 1000, // duration
                thisTutorial.getScreenshotOverlayOpacity() / 100, // opacity
                'swing',
                function () {
                  screenshotOverlayEl.removeClass('fading-in');
                }
              );
            } else {
              screenshotOverlayEl.css('opacity', thisTutorial.getScreenshotOverlayOpacity() / 100);
            }
          }

          adjustPanelPosition();

          thisMarkerList.imageTransitionRunning = false;
          thisMarkerList.trigger('imageTransitionFinished');
        };

        var noScrollNeeded = (
          imageSurround[0].scrollTop === scrollTop &&
          imageSurround[0].scrollLeft === scrollLeft
        );
        if (false/*noScrollNeeded*/) {
          // TODO: still needs to wait for marker to transition bounds
          afterScroll();
        } else {
          // .animate has a delay even if no scroll is needed
          // (thus the check on noScrollNeeded)
          imageSurround.animate(
            {
              scrollTop: scrollTop,
              scrollLeft: scrollLeft,
            },
            transitionDuration,
            'swing',
            afterScroll
          );
        }
      }
    }, this), 0);
  },
  waitForImageTransition: function() {
    if (!this.imageTransitionRunning) return Promise.resolve();
    var $this = this;
    return new Promise(function(resolve) {
      $this.once('imageTransitionFinished', resolve);
    })
      .then(function() {
        return iorad.base.Utils.setTimeoutPromise().promise;
      });
  },

  adjustPanelPosition: function() {
    var minimizedPanel = $('html').attr('data-stepPanel') === 'minimized';
    var navbarOnly = $('html').attr('data-stepPanel') === 'navbarOnly';
    var steptextOnly = $('html').attr('data-stepPanel') === 'steptextOnly';
    var panel = (minimizedPanel || steptextOnly || navbarOnly)
      ? $('#playing-player .stepnav')
      : null;
    if (!panel) return;

    // NOTE: assumes only one active marker
    var markerView = this.getActiveMarkers()[0];
    if (!markerView || markerView.isTransparent()) return;

    // NOTE: assumes containment and panel are always fully visible
    // NOTE: do not confuse containment with the screenshot containment
    //       they are 2 different things. Here containment is likely #playing-player

    var containment = panel.draggable('option', 'containment');
    var containmentPageBounds = containment[0].getBoundingClientRect();

    // include marker + borders + info
    function getMarkerPageBounds() {
      var markerPageBounds = markerView.el.getBoundingClientRect();

      var markerInfo = markerView.el.querySelector('.marker-info');
      var markerInfoPageBounds = markerInfo ? markerInfo.getBoundingClientRect() : markerPageBounds;

      var left = Math.min(markerPageBounds.left, markerInfoPageBounds.left);
      var top = Math.min(markerPageBounds.top, markerInfoPageBounds.top);
      var width = Math.max(
        markerPageBounds.left + markerPageBounds.width,
        markerInfoPageBounds.left + markerInfoPageBounds.width
      ) - left;
      var height = Math.max(
        markerPageBounds.top + markerPageBounds.height,
        markerInfoPageBounds.top + markerInfoPageBounds.height
      ) - top;

      return {
        left: left,
        top: top,
        width: width,
        height: height,
      };
    }

    function pageToContainmentBounds(pageBounds) {
      var left = pageBounds.left - containmentPageBounds.left;
      var top = pageBounds.top - containmentPageBounds.top;
      var width = pageBounds.width;
      var height = pageBounds.height;
      return {
        left: left,
        top: top,
        width: width,
        height: height,
        right: left + width,
        bottom: top + height,
      };
    }

    function toVisibleBounds(bounds) {
      var left = bounds.left < 0 ? 0 : bounds.left;
      var top = bounds.top < 0 ? 0 : bounds.top;

      var width = bounds.left < 0 ? (bounds.width + bounds.left) : bounds.width;
      if (width + left > containmentPageBounds.width) {
        width = containmentPageBounds.width - left;
      }

      var height = bounds.top < 0 ? (bounds.height + bounds.top) : bounds.height;
      if (height + top > containmentPageBounds.height) {
        height = containmentPageBounds.height - top;
      }

      var right = left + width;
      var bottom = top + height;
      return {
        left: left,
        top: top,
        width: width,
        height: height,
        right: right,
        bottom: bottom,
      };
    }

    // page-relative (negative values if outside visible area)
    var markerPageBounds = getMarkerPageBounds();
    var panelPageBounds = panel[0].getBoundingClientRect();

    // containment-relative
    var markerBounds = pageToContainmentBounds(markerPageBounds);
    var markerVisibleBounds = toVisibleBounds(markerBounds);
    var panelBounds = pageToContainmentBounds(panelPageBounds);

    // check if panel overlaps with marker
    var overlaps = !(
      panelBounds.right <= markerVisibleBounds.left ||
      panelBounds.left >= markerVisibleBounds.right ||
      panelBounds.bottom <= markerVisibleBounds.top ||
      panelBounds.top >= markerVisibleBounds.bottom
    );
    // console.log('ADJUST PANEL POSITION: OVERLAPS?', overlaps, {
    //   panelBounds: panelBounds,
    //   markerPageBounds: markerPageBounds,
    //   markerPageElBounds: markerView.el.getBoundingClientRect(),
    //   markerPageInfoBounds: markerView.el.querySelector('.marker-info').getBoundingClientRect(),
    //   markerBounds: markerBounds,
    //   markerVisibleBounds: markerVisibleBounds,
    //   scrollTop: $('#image-surround')[0].scrollTop,
    // });
    if (!overlaps) return;

    var topSpace = markerVisibleBounds.top;
    var bottomSpace = containmentPageBounds.height - markerVisibleBounds.bottom;
    var leftSpace = markerVisibleBounds.left;
    var rightSpace = containmentPageBounds.width - markerVisibleBounds.right;

    if (topSpace > panelBounds.height) {
      // move to top (vertically centered)
      panel.css({
        top: Math.floor((topSpace / 2) - (panelBounds.height / 2)),
      });
    } else if (bottomSpace > panelBounds.height) {
      // move to bottom (vertically centered)
      panel.css({
        top: Math.floor(markerVisibleBounds.bottom + ((bottomSpace / 2) - (panelBounds.height / 2))),
      });
    } else if (leftSpace > panelBounds.width) {
      // move to left (horizontally centered)
      panel.css({
        left: Math.floor((leftSpace / 2) - (panelBounds.width / 2)),
      });
    } else if (rightSpace > panelBounds.width) {
      // move to right (horizontally centered)
      panel.css({
        left: Math.floor(markerVisibleBounds.right + ((rightSpace / 2) - (panelBounds.width / 2))),
      });
    } else {
      // nothing found
    }
  },
});
;
iorad.player.views.step_description = iorad.base.View.extend({
  tagName: 'p',

  events: {
    'click a': 'openLink',
  },

  initialize: function(options) {
    iorad.base.View.prototype.initialize.apply(this, arguments);
    options = options || {};

    this.disableStepsLinking = options.disableStepsLinking || false;

    this.description = undefined;

    this.setModel(this.model);

    this.listenTo(iorad.player.data.markerColors, 'change', this.updateStyle);
  },

  setModel: function(model) {
    if (this.model) this.stopListening(this.model);
    this.model = model;

    // model is a step
    this.listenTo(this.model, 'change', this.prepareRender);
    this.prepareRender();
  },

  // prepare async data for the synchronous render
  prepareRender: function() {
    this.calculateDescription()
      .then(_.bind(function(description) {

        this.description = description;
        this.render();

      }, this));
  },

  render: function() {
    this.$el.html(this.description);
    this.$el.toggleClass('notranslate', !iorad.player.controllers.language.learnerChangedLanguage());
    this.updateStyle();
  },

  // (argument provided to allow extensibility by child types)
  calculateDescription: function(description) {
    if (typeof description === 'undefined') {
      description = this.model.get('description');
    }

    return this.sanitize(description)
      .then(this.linkSteps.bind(this))
      .then(this.fixNonBreakingSpaces.bind(this));
  },

  sanitize: function(description) {
    return Promise.resolve(
      sanitizeHtml(description, iorad.base.Export.STEP_DESCRIPTION_APP_SANITIZE_RULES)
    );
  },

  // NOTE: description is already XSS safe
  linkSteps: function(description) {
    if (this.disableStepsLinking) return Promise.resolve(description);
    var routeHash = iorad.player.tab === 'watch' ? 'watchsteps'
      : iorad.player.tab === 'quiz' ? 'quizsteps'
      : 'trysteps';

    var stepLen = this.model.collection.length

    function processNode(node) {
      if (node.nodeType === Node.TEXT_NODE) {

        // base: wrap "Step X" phrase with an anchor
        // (\b is word boundary)

        // we can't directly use node.nodeValue or node.textContent
        // to get the text content as that would decode html entities
        // and open to XSS vulnerabilities.
        var textGetter = document.createElement('div');
        textGetter.appendChild(node.cloneNode(true));

        var newHtml = textGetter.innerHTML.replace(/\b(Step (\d+))/gi, function(match, p1, p2) {
          if (p2 && parseInt(p2) <= stepLen) {
            return '<a href="#' + routeHash + '-' + p2 + '" data-self="true">' + p1 + '</a>';
          }

          return p1
        });


        // parse html
        var newHtmlContainer = document.createElement('div');
        newHtmlContainer.innerHTML = newHtml;
        // replace text node with parsed nodes
        var newNodes = newHtmlContainer.childNodes;
        for (var i = 0; i < newNodes.length; i++) {
          node.parentNode.insertBefore(newNodes[i], node);
          i--; // child has been removed
        }
        node.parentNode.removeChild(node);

        return;
      }

      if (node.nodeType === Node.ELEMENT_NODE) {
        // recursion

        // ignore anchors!
        if (node.tagName === 'A') return;

        // process childs
        var childNodeList = node.childNodes; // NodeList
        for (var i = 0; i < childNodeList.length; i++) {
          var childNode = childNodeList[i];
          processNode(childNode);
        }
      }
    }

    var container = document.createElement('div');
    container.innerHTML = description;
    processNode(container);
    return Promise.resolve(container.innerHTML);
  },

  fixNonBreakingSpaces: function(description) {
    // https://stackoverflow.com/a/24469190
    // add a <wbr> element after the sequence of &nbsp;
    // thus keeping the spaces but still allowing line breaks
    return Promise.resolve(
      description.replace(/(&nbsp;)+/g, '$&<wbr>')
    );
  },

  // Note: this function is also called from the outside (mobile-slide)
  updateStyle: function() {
    this.updateBoldColors();
    this.updateAnchorColors();
    this.updateUnderlineColors();
  },

  updateBoldColors: function() {
    var type = this.model.get('type');
    var markerColor = iorad.player.data.markerColors.get(type);

    this.$('b, strong').each(function() {
      $(this).css('color', markerColor ? markerColor : '');
    });
  },

  updateAnchorColors: function() {
    var type = this.model.get('type');
    var markerColor = iorad.player.data.markerColors.get(type);

    this.$('a').each(function() {
      $(this).css({
        'border-color': markerColor ? markerColor : '',
      });
    });
  },

  updateUnderlineColors: function () {
    var type = this.model.get('type');
    var markerColor = iorad.player.data.markerColors.get(type);
    var contrastColor = iorad.base.Export.getContrastColor(markerColor);

    this.$('u').each(function () {
      $(this).css({
        'background-color': markerColor ? markerColor : '',
        'color': contrastColor ? contrastColor : '',
      });
    });
  },

  // Open links manually in another window by default.
  openLink: function (event) {
    var anchor = $(event.currentTarget);
    var href = anchor.attr('href');

    var isInternalPlayerUrl = anchor.attr('data-self') === 'true';

    var isShortPlayerUrl = anchor[0].hostname === 'ior.ad' &&
      !anchor[0].pathname.startsWith('/live/');
    var isRegularPlayerUrl = (
      anchor[0].hostname.endsWith('.iorad.com') ||
      anchor[0].hostname.endsWith('.iorad.dev') ||
      (window.IORAD_ROOT && new RegExp('^https?://' + anchor[0].hostname + '$').test(window.IORAD_ROOT)) ||
      (!window.IORAD_ROOT && anchor[0].hostname === document.location.hostname)
    ) && anchor[0].pathname.startsWith('/player/');
    var isExternalPlayerUrl = (isShortPlayerUrl || isRegularPlayerUrl) &&
      !isInternalPlayerUrl;

    var url;
    if (isExternalPlayerUrl) {
      var newAnchorQuery = iorad.base.Utils.getUrlParameters(href);
      if (iorad.player.router.isExtensionMode()) {
        newAnchorQuery.extensionEmbed = 'true';
        if (iorad.player.getParameters.playerExtensionWidth) {
          newAnchorQuery.playerExtensionWidth = iorad.player.getParameters.playerExtensionWidth;
        }
        if (iorad.player.getParameters.widgetEmbed === 'true') {
          newAnchorQuery.widgetEmbed = 'true';
        }
        newAnchorQuery.device = (iorad.player.data.tutorial.get('extensionDevice') || '');
      }
      if (iorad.player.router.isHelpcenterMode()) {
        newAnchorQuery.helpcenter = iorad.player.getParameters.helpcenter;
        if (iorad.player.getParameters.roleId) {
          newAnchorQuery.roleId = iorad.player.getParameters.roleId;
        }
      }
      if (iorad.player.getParameters.embedUrl) {
        newAnchorQuery.embedUrl = iorad.player.getParameters.embedUrl;
      }

      url = iorad.base.Utils.createUrl({
        base: 'https://' + anchor[0].hostname + anchor[0].pathname,
        urlParameters: newAnchorQuery,
        hash: anchor[0].hash,
      });
    } else {
      url = href;
    }

    var isNewWindow = isInternalPlayerUrl ? iorad.player.mode === 'mobilequick' // mobile can't show trysteps
      // : isExternalPlayerUrl ? iorad.player.router.isPreviewMode()
      : true;
    siteWindow.ioradNodeApp.setLocation(url, {
      isNewWindow: isNewWindow,
      isAssign: isExternalPlayerUrl && !isNewWindow, // allow browser history back
    });
    return false;
  },
});

;
(function() {
  var ClipboardCustomize = function() {
    Clipboard.apply(this, arguments);
  };
  ClipboardCustomize.prototype = Object.create(Clipboard.prototype);
  ClipboardCustomize.prototype.constructor = ClipboardCustomize;
  ClipboardCustomize.prototype.onClick = function(event) {
    event.preventDefault();

    Clipboard.prototype.onClick.apply(this, arguments);
  };

  iorad.player.views.steps_interactive_nav = iorad.base.View.extend({
    template: iorad.player.templates.steps_interactive_nav,

    events: {
      'click #go-live': 'onGoLiveClick',
      'click #replay-btn': 'onReplayClick',
      'click .step-panel-currentstep': 'onStepPanelCurrentstepClick',
      'click .step-panel-toggleCollapse-btn': 'onStepPanelToggleCollapseClick',

      'mousedown .ui-resizable-n': 'onTopResizeStart',
      'mousedown .ui-resizable-s': 'onBottomResizeStart',

      'mouseenter .start-step': 'onStartStepMouseEnter',
      'mouseleave .start-step': 'onStartStepMouseLeave',
      'dblclick .start-step': 'onStepStepDblclick',

      'keypress .step-panel-toggleCollapse-btn': 'accessibilityButtonOnKeyPress',
    },

    initialize: function() {
      this.AUDIO_END_DELAY = 2000;
      this.VIDEO_END_DELAY = 2000;
      this.nextTutorialData = null;

      this.trackAudio();
      this.trackVideo();

      this.listenTo(this.model, 'change', function() {
        var data = this.getTemplateData();
        this.updateActions(data);
        this.updateStartStep(data);
      });
      this.listenTo(this.collection, 'changeCurrent', this.onCurrentStepChange);
      this.listenTo(this.collection, 'reset', this.render);
      this.listenTo(iorad.player.events, 'ready:interactive resize:interactive tab', this.render);
      this.listenTo(iorad.player.data.markerColors, 'change', this.updateOverlays);
      this.listenTo(iorad.player.data.markerColors, 'change', this.updateStepPointer);
      this.listenTo(iorad.player.data.markerColors, 'change', function() {
        var data = this.getTemplateData();
        this.updateStartStep(data);
      });

      this.listenTo(iorad.player.controllers.views, 'change:coverOpen', this.onChangeCoverOpen);
      this.listenTo(iorad.player.controllers.audio, 'change:audioState', this.checkRequiredAudioCompletition);
      this.listenTo(iorad.player.controllers.video, 'change:videoState', this.checkRequiredVideoCompletition);
      this.listenTo(iorad.player.controllers.screenshots, 'change:zoom', this.render); // TODO: still needed?
      this.listenTo(iorad.player.controllers.autoplay, 'change:paused', function() {
        this.updateStartStep(this.getTemplateData());
      });
      this.listenTo(iorad.player.events, 'update:playbar', function () {
        this.updateStartStep();
      });
      this.listenTo(iorad.player.controllers.views, 'set:tutorialData', function(nextTutorialData) {
        this.nextTutorialData = nextTutorialData;
        this.updateNextTutorialButton(this.getTemplateData());
      });
      this.listenTo(iorad.player.events, 'item:last:rendered', function() {
        this.updateNextTutorialTimer(this.getTemplateData());
      });
      this.listenTo(iorad.player.events, 'change:stepPanel', function() {
        this.updateStartStep(this.getTemplateData());
        this.onStepPanelTypeChange();
      });
      this.listenTo(iorad.player.controllers.quiz, 'end', this.onQuizEnd);
      this.listenTo(iorad.player.controllers.quiz, 'active', this.render); // for updateQuizReport
      this.listenTo(iorad.player.controllers.quiz, 'recording:start recording:cancel recording:stop recording:inactive', this.render); // for updateQuizWebcam
      this.listenTo(this.model, 'change:quizResultsType', this.render); // for updateQuizReport

      this.listenTo(iorad.player.events, 'sound:end', this.onSoundEnd);
      this.listenTo(iorad.player.events, 'sound:play', this.onSoundPlay);
      this.listenTo(iorad.player.events, 'sound:loaderror', this.onSoundLoadError);

      this.listenTo(iorad.player.events, 'video:end', this.onVideoEnd);
      this.listenTo(iorad.player.events, 'video:play', this.onVideoPlay);
      this.listenTo(iorad.player.events, 'video:loaderror', this.onVideoLoadError);

      this.listenTo(iorad.player.events, 'interactive:replay', function() { this.onReplayClick(); });

      $(window).on('resize', () => {
        this.updateStepPointer(); // for google translate banner visibility change
        this.updateStartStep(this.getTemplateData()); // for currentstep visibility change
      });

      if (screenfull.enabled) { // fullscreen is optional
        siteWindow.document.addEventListener(screenfull.raw.fullscreenchange, _.bind(function () {
          this.clearTimers();
          setTimeout(() => {
            this.resetReadTimer();
          }, 100); // because we need to wait previousMarkerView to mounted (also in setTimeout)
          this.render();
        }, this));
      }

      var client = new ClipboardCustomize('.copy-link-btn');
      client.on('success', this.onCopySuccess);

      this.monitorScroll();
      this.checkRequiredAudioCompletition();
      this.checkRequiredVideoCompletition();

      this.resetReadTimer();
      this.render();

      this.listenTo(iorad.player.events, 'mode', function(mode) {
        if (mode !== iorad.player.oldMode && mode !== 'print') {
          this.clearTimers();
        }
      });
      this.listenTo(iorad.player.events, 'tab', function(tab) {
        if (tab !== 'try' && tab !== 'watch' && tab !== 'quiz') {
          this.clearTimers();
        }
      });

      this.listenToDOM(document, 'visibilitychange', function () {
        if (document.visibilityState === 'hidden') {
          if (!iorad.player.controllers.autoplay.paused) {
            iorad.player.controllers.autoplay.pauseAutoplay();
          }
        } else {
          if (iorad.player.controllers.autoplay.paused) {
            if (!iorad.player.controllers.views.isModalTab(iorad.player.tab)) {
              iorad.player.controllers.autoplay.resumeAutoplay();
            }
          }
        }
      });

      this.setupResizable();
    },

    onCurrentStepChange: function() {
      this.clearTimers();
      this.resetReadTimer();
      this.clearSoundEndPostTimer();
      this.clearVideoEndPostTimer();
      this.checkRequiredAudioCompletition();
      this.checkRequiredVideoCompletition();
      this.render();
    },

    onChangeCoverOpen: function() {
      this.resetReadTimer();
      this.clearSoundEndPostTimer();
      this.clearVideoEndPostTimer();
      this.render(); // for updateStartStep
    },

    clearTimers: function() {
      clearTimeout(this.stepReadAudioTimeout);
      clearTimeout(this.stepReadVideoTimeout);
      clearTimeout(this.soundEndPostTimer);
      clearTimeout(this.videoEndPostTimer);
      this.stepReadTick = undefined;
      iorad.player.interactiveReadRemainingTime = undefined;
      iorad.player.interactiveReadTotalTime = undefined;
    },

    onSoundPlay: function(audio) {
      if (iorad.player.tab !== 'try' && iorad.player.tab !== 'watch' && iorad.player.tab !== 'quiz') return;

      var totalTime = audio._duration * 1000 + this.AUDIO_END_DELAY;
      var stepModel = this.collection.getCurrentModel();
      var isLastStep = stepModel && stepModel.get('index') >= this.collection.length - 1;

      var stepNumber = this.collection.getCurrentStepNumber();
      var audioStateClasses = iorad.player.controllers.audio.getAudioStateClasses(stepNumber);
      var hasAudio = stepModel && stepModel.get('audioId') != null && audioStateClasses.indexOf('load-error') === -1;
      var audioCompletitionRequired = iorad.player.controllers.audio.isAudioCompletitionRequired();
      var noAutoadvance = stepModel && stepModel.get('event.autoadvance') === false;

      var showAdvanceButton = stepModel && stepModel.get('type') === 'READ' && hasAudio && !isLastStep;
      if (showAdvanceButton) {
        clearTimeout(this.stepReadAudioTimeout);
        if (!audioCompletitionRequired) {
          // immediately show "Next" button but actually keep the Info text & icon
          // (for UX reasons, otherwise the switch looks jarry and delayed)
          iorad.player.events.trigger('showStepAdvanceButton', {
            timerDuration: null,
            keepDefaultText: true,
          });
        } else {
          // audio is required: no immediate "Next" button.
        }
        // If autoadvance, animate "Next" for the last half,
        // If no autoadvance, just show "Next" after the whole audio has played.
        this.stepReadAudioTimeout = setTimeout(function () {
          iorad.player.events.trigger('showStepAdvanceButton', {
            timerDuration: noAutoadvance ? null : totalTime / 2
          });
        }, noAutoadvance ? (totalTime - this.AUDIO_END_DELAY) : (totalTime / 2));
      }
    },

    onVideoPlay: function(video) {
      if (iorad.player.tab !== 'try' && iorad.player.tab !== 'watch' && iorad.player.tab !== 'quiz') return;

      var totalTime = video._duration * 1000 + this.VIDEO_END_DELAY;
      var stepModel = this.collection.getCurrentModel();
      var isLastStep = stepModel && stepModel.get('index') >= this.collection.length - 1;

      var stepNumber = this.collection.getCurrentStepNumber();
      var videoStateClasses = iorad.player.controllers.video.getVideoStateClasses(stepNumber);
      var hasVideo = stepModel && stepModel.get('videoId') != null && videoStateClasses.indexOf('load-error') === -1;
      var videoCompletitionRequired = iorad.player.controllers.video.isVideoCompletitionRequired();
      var noAutoadvance = stepModel && stepModel.get('event.autoadvance') === false;

      var showAdvanceButton = stepModel && stepModel.get('type') === 'READ' && hasVideo && !isLastStep;
      if (showAdvanceButton) {
        clearTimeout(this.stepReadVideoTimeout);
        if (!videoCompletitionRequired) {
          // immediately show "Next" button but actually keep the Info text & icon
          // (for UX reasons, otherwise the switch looks jarry and delayed)
          iorad.player.events.trigger('showStepAdvanceButton', {
            timerDuration: null,
            keepDefaultText: true,
          });
        } else {
          // video is required: no immediate "Next" button.
        }
        // If autoadvance, animate "Next" for the last half,
        // If no autoadvance, just show "Next" after the whole video has played.
        this.stepReadVideoTimeout = setTimeout(function () {
          iorad.player.events.trigger('showStepAdvanceButton', {
            timerDuration: noAutoadvance ? null : totalTime / 2
          });
        }, noAutoadvance ? (totalTime - this.VIDEO_END_DELAY) : (totalTime / 2));
      }
    },

    onSoundLoadError: function() {
      if (iorad.player.tab !== 'try' && iorad.player.tab !== 'watch' && iorad.player.tab !== 'quiz') return;

      this.resetReadTimer();
    },

    onVideoLoadError: function() {
      if (iorad.player.tab !== 'try' && iorad.player.tab !== 'watch' && iorad.player.tab !== 'quiz') return;

      this.resetReadTimer();
    },

    onSoundEnd: function() {
      if (iorad.player.tab !== 'try' && iorad.player.tab !== 'watch' && iorad.player.tab !== 'quiz') return;

      this.clearSoundEndPostTimer();
      this.soundEndPostTimer =
        setTimeout(this.afterSoundEndPostDelay.bind(this), this.AUDIO_END_DELAY);

      this.updateNextTutorialTimer(this.getTemplateData());
    },

    onVideoEnd: function() {
      if (iorad.player.tab !== 'try' && iorad.player.tab !== 'watch' && iorad.player.tab !== 'quiz') return;

      this.clearVideoEndPostTimer();
      this.videoEndPostTimer =
        setTimeout(this.afterVideoEndPostDelay.bind(this), this.VIDEO_END_DELAY);

      this.updateNextTutorialTimer(this.getTemplateData());
    },

    resetReadTimer: function() {
      if (iorad.player.tab !== 'try' && iorad.player.tab !== 'watch' && iorad.player.tab !== 'quiz') return;

      // reset
      this.stepReadCompleted = undefined;
      iorad.player.events.trigger('interactive:stepCompleted', false);
      this.stepReadTick = undefined;
      iorad.player.interactiveReadRemainingTime = undefined;
      iorad.player.interactiveReadTotalTime = undefined;

      if (iorad.player.controllers.views.isCoverOpen()) return;
      var stepModel = this.collection.getCurrentModel();
      var readTime = stepModel && stepModel.getStepReadDuration(); // TODO
      var isLastStep = stepModel && stepModel.get('index') >= this.collection.length - 1;

      var stepNumber = this.collection.getCurrentStepNumber();
      var audioStateClasses = iorad.player.controllers.audio.getAudioStateClasses(stepNumber);
      var hasAudio = stepModel && stepModel.get('audioId') != null && audioStateClasses.indexOf('load-error') === -1;
      var audioMuted = audioStateClasses.indexOf('mute') >= 0;
      var videoStateClasses = iorad.player.controllers.video.getVideoStateClasses(stepNumber);
      var hasVideo = stepModel && stepModel.get('videoId') != null && videoStateClasses.indexOf('load-error') === -1;
      var videoMuted = videoStateClasses.indexOf('mute') >= 0;
      var noAutoadvance = stepModel && stepModel.get('event.autoadvance') === false;

      var showAdvanceButton = (
        stepModel &&
        stepModel.get('type') === 'READ' &&
        (!hasAudio || audioMuted) &&
        (!hasVideo || videoMuted) &&
        !isLastStep
      );
      if (showAdvanceButton) {
        // immediately show "Next" (no-animation)
        iorad.player.events.trigger('showStepAdvanceButton', {
          timerDuration: null
        });
      }

      iorad.player.interactiveReadRemainingTime = readTime;
      iorad.player.interactiveReadTotalTime = readTime;
      let showAdvanceButtonTriggered = false;
      let oldTime = Date.now();
      const stepReadTick = () => {
        if (this.stepReadTick !== stepReadTick) return; // cleared
        try {
          const currentTime = Date.now();
          const timeElapsed = currentTime - oldTime;
          oldTime = currentTime;
          if (!iorad.player.controllers.autoplay.paused) {
            iorad.player.interactiveReadRemainingTime -= timeElapsed;

            if (showAdvanceButton && !noAutoadvance) {
              if (!showAdvanceButtonTriggered && iorad.player.interactiveReadRemainingTime <= readTime / 2) {
                // If autoadvance, animate "Next" for the last half
                showAdvanceButtonTriggered = true;
                iorad.player.events.trigger('showStepAdvanceButton', {
                  timerDuration: readTime / 2
                });
              }
            }
            if (iorad.player.interactiveReadRemainingTime <= 0) {
              this.afterRead();
            }
          }
        } finally {
          if (iorad.player.interactiveReadRemainingTime > 0) {
            requestAnimationFrame(this.stepReadTick);
          } else {
            this.stepReadTick = undefined;
            iorad.player.interactiveReadRemainingTime = undefined;
            iorad.player.interactiveReadTotalTime = undefined;
          }
        }
      };
      this.stepReadTick = stepReadTick;
      requestAnimationFrame(this.stepReadTick);
    },

    clearSoundEndPostTimer: function() {
      if (this.soundEndPostTimer) {
        clearTimeout(this.soundEndPostTimer);
        this.soundEndPostTimer = undefined;
      }
      this.audioEndedPlusDelay = undefined;
      iorad.player.events.trigger('interactive:stepCompleted', false);
    },

    clearVideoEndPostTimer: function() {
      if (this.videoEndPostTimer) {
        clearTimeout(this.videoEndPostTimer);
        this.videoEndPostTimer = undefined;
      }
      this.audioEndedPlusDelay = undefined;
      iorad.player.events.trigger('interactive:stepCompleted', false);
    },

    afterRead: function() {
      this.stepReadCompleted = this.collection.getCurrentStepNumber();

      if (this.shouldAutoadvance()) {
        iorad.player.events.trigger('interactive:next');
      } else if (this.isStepCompleted()) {
        iorad.player.events.trigger('interactive:stepCompleted', true);
      }
    },

    afterSoundEndPostDelay: function() {
      this.audioEndedPlusDelay = this.collection.getCurrentStepNumber();

      if (this.shouldAutoadvance()) {
        iorad.player.events.trigger('interactive:next');
      } else if (this.isStepCompleted()) {
        iorad.player.events.trigger('interactive:stepCompleted', true);
      }
    },

    afterVideoEndPostDelay: function() {
      this.videoEndedPlusDelay = this.collection.getCurrentStepNumber();

      if (this.shouldAutoadvance()) {
        iorad.player.events.trigger('interactive:next');
      } else if (this.isStepCompleted()) {
        iorad.player.events.trigger('interactive:stepCompleted', true);
      }
    },

    isStepCompleted: function() {
      if (
        (
          iorad.player.device !== 'desktop' &&
          !iorad.player.data.tutorial.get('isMobile')
        ) &&
        iorad.player.controllers.views.isCoverOpen()
      ) {
        return false;
      }

      var stepModel = this.collection.getCurrentModel();
      var stepNumber = this.collection.getCurrentStepNumber();

      var audioStateClasses = iorad.player.controllers.audio.getAudioStateClasses(stepNumber);
      var hasAudio = stepModel && stepModel.get('audioId') != null && audioStateClasses.indexOf('load-error') === -1;
      var audioMuted = audioStateClasses.indexOf('mute') >= 0;
      var audioEnded = audioStateClasses.indexOf('end') >= 0 && (this.audioEndedPlusDelay === stepNumber);
      var videoStateClasses = iorad.player.controllers.video.getVideoStateClasses(stepNumber);
      var hasVideo = stepModel && stepModel.get('videoId') != null && videoStateClasses.indexOf('load-error') === -1;
      var videoMuted = videoStateClasses.indexOf('mute') >= 0;
      var videoEnded = videoStateClasses.indexOf('end') >= 0 && (this.videoEndedPlusDelay === stepNumber);
      var readCompleted = this.stepReadCompleted === stepNumber;
      var stepCompleted = (
        (hasVideo && !videoMuted) ? videoEnded :
          (hasAudio && !audioMuted) ? audioEnded :
            readCompleted
      );
      return stepCompleted;
    },

    shouldAutoadvance: function() {
      var stepModel = this.collection.getCurrentModel();
      var stepCompleted = this.isStepCompleted();
      var autoplayPaused = iorad.player.tab == 'try' && !!iorad.player.controllers.autoplay.paused;

      return (
        stepCompleted &&
        iorad.player.tab !== 'watch' &&
        stepModel &&
        stepModel.get('type') === 'READ' &&
        stepModel.get('event.autoadvance') !== false &&
        this.collection.position < this.collection.length - 1 && // not the last step
        !autoplayPaused
      );
    },

    monitorScroll: function() {
      var changeStep = _.debounce(function(newStepNumber) {
        iorad.player.router.navigateToInteractiveMode(null, newStepNumber);
      }, 200, true);

      // this.$el.on('mousewheel', _.bind(function(event) {
      //   var scrollDown = !(event.originalEvent.wheelDelta > 0 || event.originalEvent.detail < 0);
      //   var stepNumber = this.collection.getCurrentStepNumber();
      //   if (scrollDown) {
      //     if (stepNumber < this.collection.length) {
      //       event.preventDefault(); // disable scrolling of parent element/frame
      //       changeStep(stepNumber + 1);
      //     }
      //   } else {
      //     if (stepNumber > 1) {
      //       event.preventDefault(); // disable scrolling of parent element/frame
      //       changeStep(stepNumber - 1);
      //     }
      //   }
      // }, this));
    },

    onQuizEnd: function () {
      iorad.player.controllers.views.expandStepPanel();

      this.render(); // for updateQuizReport
    },

    onGoLiveClick: function (event) {
      event.preventDefault();
      iorad.player.controllers.live.tryLive();
    },

    onReplayClick: function (event) {
      if (event) {
        event.preventDefault();
      }

      iorad.player.router.navigateToInteractiveMode(null, 1);

      if (iorad.player.controllers.quiz.isActive()) {
        iorad.player.controllers.quiz.restart();
      }
    },

    trackAudio: function() {
      this.listenTo(iorad.player.events, 'sound:end sound:loaderror', function() {
        this.audioEnded = true;
      });

      var reset = _.bind(function() {
        this.audioEnded = false;
      }, this);
      this.listenTo(iorad.player.data.stepsCollection, 'changeCurrent', reset);
      this.listenTo(iorad.player.events, 'sound:play', reset);
    },

    trackVideo: function() {
      this.listenTo(iorad.player.events, 'video:end video:loaderror', function() {
        this.videoEnded = true;
      });

      var reset = _.bind(function() {
        this.videoEnded = false;
      }, this);
      this.listenTo(iorad.player.data.stepsCollection, 'changeCurrent', reset);
      this.listenTo(iorad.player.events, 'video:play', reset);
    },

    checkRequiredAudioCompletition: function () {
      var stepModel = this.collection.getCurrentModel();
      var audioStateClasses = iorad.player.controllers.audio.getAudioStateClasses();
      var audioId = stepModel && stepModel.get('audioId');
      var audioModTime = stepModel && stepModel.get('audioModTime');
      var audioCompleted = audioId != null &&
        audioStateClasses.indexOf('end') !== -1 &&
        audioStateClasses.indexOf('muted') === -1 &&
        audioStateClasses.indexOf('load-error') === -1 &&
        audioStateClasses.indexOf('load') === -1;
      if (audioCompleted) {
        iorad.player.controllers.audio.storeAudioCompletion(audioId, audioModTime);
      }

      var audioCompletitionRequired = iorad.player.controllers.audio.isAudioCompletitionRequired();
      $('#interaction-blocker-overlay').toggle(!!audioCompletitionRequired);
      this.updateStartStep(this.getTemplateData());
    },

    checkRequiredVideoCompletition: function () {
      var stepModel = this.collection.getCurrentModel();
      var videoStateClasses = iorad.player.controllers.video.getVideoStateClasses();
      var videoId = stepModel && stepModel.get('videoId');
      var videoModTime = stepModel && stepModel.get('videoModTime');
      var videoCompleted = videoId != null &&
        videoStateClasses.indexOf('end') !== -1 &&
        videoStateClasses.indexOf('muted') === -1 &&
        videoStateClasses.indexOf('load-error') === -1 &&
        videoStateClasses.indexOf('load') === -1;
      if (videoCompleted) {
        iorad.player.controllers.video.storeVideoCompletion(videoId, videoModTime);
      }

      var videoCompletitionRequired = iorad.player.controllers.video.isVideoCompletitionRequired();
      $('#interaction-blocker-overlay').toggle(!!videoCompletitionRequired);
      this.updateStartStep(this.getTemplateData());
    },

    // getTemplateData contains DOM operations,
    // this func made to isolate other data when we don't need to update the whole view
    getNavTemplateData: function() {
      var position = this.collection.position;
      var stepsLength = this.collection.models.length;

      var navData = {
        isFinishBtnVisible: position === stepsLength - 1 && iorad.player.getParameters.videoExport !== 'true',
        isStepsNumberDisabled: this.model.getLayoutOption('is_stepsnumber_disabled'),
      };

      return navData;
    },

    hasInfotextVideo: function() {
      const stepModel = this.collection.getCurrentModel();

      // for old tutorials
      let withVideo = false;
      if (stepModel && stepModel.isReadInfotext()) {
        if (!stepModel.get('event.infotextType')) {
          withVideo = stepModel.get('infotext.withVideo');
        } else if (stepModel.get('event.infotextType') === 'video') {
          const videoId = stepModel.get('videoId');
          withVideo = videoId != null;
        }
      }

      return withVideo;
    },

    getTemplateData: function() {
      var stepModel = this.collection.getCurrentModel();
      var markerColor = stepModel ? iorad.player.data.markerColors.get(stepModel.get('type')) : '';

      var templateData = iorad.base.View.prototype.getTemplateData.apply(this, arguments);

      var isSharingDisabled = this.model.isSharingDisabled();

      var navData = this.getNavTemplateData();

      return _.extend(templateData, navData, {
        stepsPointerTop: this.$('.marker').css('top'), // keep pointer position between render (if any)
        stepsPointerColor: markerColor ? markerColor : '',

        isGoLiveBtnVisible: this.model.isGoLiveAvailable() && iorad.player.tab !== 'quiz',
        isCopyLinkVisible: !isSharingDisabled && iorad.player.tab !== 'quiz',
        isCopyEmbedVisible: !isSharingDisabled && iorad.player.tab !== 'quiz',

        hash: iorad.player.tab === 'watch' ? 'watchsteps'
          : iorad.player.tab === 'quiz' ? 'quizsteps'
            : 'trysteps',

        total: this.collection.length,

        finished: stepModel && (stepModel.get('index') + 1) === this.collection.length,
        nextTutorialData: this.nextTutorialData ? this.nextTutorialData.tutorial : null,
        showTimer: this.nextTutorialData ? this.nextTutorialData.showTimer : false,

        isQuizTab: iorad.player.tab === 'quiz',
        quizFinalReport: iorad.player.controllers.quiz.getFinalReport(),

        copyright: iorad.player.controllers.views.getCopyright(),
        showDirectLink: false,//!isSharingDisabled,
      });
    },

    render: function() {
      // detach sub-views
      if (this.stepsInteractiveNavList) {
        this.stepsInteractiveNavList.$el.detach();
      }

      var startStepEl = this.$('.start-step');
      if (startStepEl.length) startStepEl.detach();

      var actionsEl = this.$('.actions');
      if (actionsEl.length) actionsEl.detach();

      var quizReportEl = this.$('.quiz-report');
      if (quizReportEl.length) quizReportEl.detach();

      var quizWebcamEl = this.$('.quiz-webcam');
      if (quizWebcamEl.length) quizWebcamEl.detach();

      var videoVisualizerEl = this.$('.video-visualizer');
      if (videoVisualizerEl.length) videoVisualizerEl.detach();

      iorad.base.View.prototype.render.apply(this, arguments);

      var data = this.getTemplateData();

      if (this.stepsInteractiveNavList) {
        // restore sub-view
        this.$('#the-steps').replaceWith(this.stepsInteractiveNavList.$el);
      } else {
        // create sub-view
        this.stepsInteractiveNavList = new iorad.player.views.steps_interactive_nav_list({
          model: this.model,
          collection: this.collection,
          el: this.$('#the-steps')
        });
      }

      if (startStepEl.length) this.$('.start-step').replaceWith(startStepEl);
      this.updateStartStep(data);

      if (actionsEl.length) this.$('.actions').replaceWith(actionsEl);
      this.updateActions(data);

      if (quizReportEl.length) {
        this.$('.quiz-report').replaceWith(quizReportEl);
      }

      if (quizWebcamEl.length) {
        this.$('.quiz-webcam').replaceWith(quizWebcamEl);
      }

      if (videoVisualizerEl.length) {
        this.$('.video-visualizer').replaceWith(videoVisualizerEl);
      } else {
        this.videoVisualizerView = new iorad.player.views.step_video_visualizer({
          el: this.$('.video-visualizer'),
          mode: 'interactive',
          wrapperEl: this.$el,
          isCurrent: () => {
            return (
              iorad.player.mode === 'interactive' &&
              !(
                this.hasInfotextVideo()
              )
            );
          },
        });
        this.videoVisualizerView.render();
      }

      this.updateQuizReport(data);
      this.updateQuizWebcam(data);

      this.updateOverlays();
      this.updateStepPointer();

      if (this.finishedTO) {
        clearInterval(this.finishedTO);
      }

      this.updateNextTutorialTimer(data);

      iorad.player.controllers.sync.getPlayerURL()
        .then(_.bind(function(playerUrlData) {
          var iframeHash = iorad.player.tab === 'watch' ? 'watchsteps'
            : iorad.player.tab === 'quiz' ? 'quizsteps'
              : 'trysteps';
          var shortLinkForInteractive = iorad.base.Utils.replaceAll(
            playerUrlData.SHORT_LINK_IFRAME_HASH_TEMPLATE,
            encodeURIComponent('{{IORAD_IFRAME_HASH_PLACEHOLDER}}'),
            iframeHash + '-1'
          );
          var publicLinkForInteractive = iorad.base.Utils.replaceAll(
            playerUrlData.PUBLIC_LINK_IFRAME_HASH_TEMPLATE,
            encodeURIComponent('{{IORAD_IFRAME_HASH_PLACEHOLDER}}'),
            iframeHash + '-1'
          );
          var embedForInteractive = iorad.base.Utils.replaceAll(
            playerUrlData.EMBED_IFRAME_HASH_TEMPLATE,
            encodeURIComponent('{{IORAD_IFRAME_HASH_PLACEHOLDER}}'),
            iframeHash + '-1'
          );

          this.$('.copy-short-tut-link').attr('data-clipboard-text', shortLinkForInteractive || publicLinkForInteractive);
          this.$('.copy-embed-tut-link').attr('data-clipboard-text', embedForInteractive);
        }, this));

      return this;
    },

    updateNextTutorialButton: function (data) {
      if (data.nextTutorialData && !this.$('.buttons').hasClass('primary')) {
        this.$('.buttons').addClass('primary');

        this.$('.next-tutorial-title').text(i18next.t(data.nextTutorialData.title));

        this.$('.next-tutorial-button').css('display', '').attr('href', data.nextTutorialData.url);
        this.$('.next-tutorial-button').unbind('click').on('click', _.bind(function(e) {
          if (siteWindow.parent !== siteWindow) {
            e.preventDefault();

            if (this.finishedTO) {
              clearInterval(this.finishedTO);
            }

            siteWindow.parent.postMessage({
              from: 'iorad-web-app',
              topic: 'player:redirect',
              data: data.nextTutorialData,
            }, '*');
          }
        }, this));
      }
    },

    updateNextTutorialTimer: function(data) {
      this.updateNextTutorialButton(data);

      if (data.nextTutorialData && data.finished && iorad.player.mode === 'interactive') {
        if (data.showTimer) {
          var stepModel = this.collection.getCurrentModel();
          var stepNumber = this.collection.getCurrentStepNumber();
          var audioStateClasses = iorad.player.controllers.audio.getAudioStateClasses(stepNumber);
          var hasAudio = stepModel && stepModel.get('audioId') != null && audioStateClasses.indexOf('load-error') === -1;
          var audioEnded = audioStateClasses.indexOf('end') >= 0;
          var videoStateClasses = iorad.player.controllers.video.getVideoStateClasses(stepNumber);
          var hasVideo = stepModel && stepModel.get('videoId') != null && videoStateClasses.indexOf('load-error') === -1;
          var videoEnded = videoStateClasses.indexOf('end') >= 0;
          var stepCompleted = (
            hasVideo ? videoEnded :
              hasAudio ? audioEnded :
                true
          );

          if (!stepCompleted) {
            return false;
          }

          var currentTime = 30;
          var currentTimerEl = this.$('.next-tutorial-timer');
          currentTimerEl.text('('+currentTime+'s)');
          if (this.finishedTO) {
            clearInterval(this.finishedTO);
          }
          this.finishedTO = setInterval(_.bind(function () {
            currentTime = currentTime - 1;
            currentTimerEl.text('('+currentTime+'s)');

            if (currentTime == 0) {
              clearInterval(this.finishedTO);

              this.$('.next-tutorial-button').click();
            }
          },this), 1000)
        }
      }
    },

    onCopySuccess: function(event) {
      var button = $(event.trigger);
      var html = button.hasClass('copy-short-tut-link')
        ? i18next.t('Copy Link')
        : button.hasClass('copy-embed-tut-link')
          ? i18next.t('Copy Embed')
          : button.html();

      button.find('.copy-link-text').attr({
        'role': 'alert',
        'aria-live': 'assertive'
      });
      button.addClass('active');
      button.find('.copy-link-text').html(i18next.t('Copied'));

      setTimeout(function () {
        button.css('color', 'transparent');
        setTimeout(function () {
          button.css('color', '');
          button.find('.copy-link-text').removeAttr('role').removeAttr('aria-live');
          button.find('.copy-link-text').html(html);
          button.removeClass('active');
        }, 150);
      }, 2850);
    },

    updateStartStep: function() {
      const data = this.getTemplateData();

      var startStepEl = this.$('.start-step');
      startStepEl.toggle(true);

      if (
        iorad.player.router &&
        iorad.player.router.playbarView
      ) {
        const playbarTemplateData = iorad.player.router.playbarView.templateData;
        if (
          playbarTemplateData &&
          !playbarTemplateData.isStepProgressBtnHidden &&
          !playbarTemplateData.isStepProgressAnimationHidden &&
          !(
            data.isFinishBtnVisible &&
            playbarTemplateData.stepProgressPercent === 100
          )
        ) {
          this.$('.step-progress-animation-overlay').css({
            width: `${playbarTemplateData.stepProgressPercent || 0}%`,
          });
        } else {
          this.$('.step-progress-animation-overlay').css({
            width: 0,
          });
        }
      }

      var currentStepText = this.collection.getCurrentStepNumber() + ' / ' + this.collection.length;

      this.$('.step-panel-currentstep')
        .toggle(Boolean(
          !this.model.getLayoutOption('is_step_counter_disabled')
        ))
        .toggleClass('disabled', iorad.player.tab === 'quiz')
        .attr('aria-label', `Currently on step ${currentStepText}, click to expand step navigator`)
        .text(currentStepText);
      this.$('.step-panel-toggleCollapse-btn').toggleClass('collapsed', iorad.player.controllers.views.isStepPanelCollapsed());
    },

    onStartStepMouseEnter: function () {
      this.$('.start-step').addClass('hovering');
      iorad.player.events.trigger('interactive-nav:header:hovering', true);
    },

    onStartStepMouseLeave: function () {
      this.$('.start-step').removeClass('hovering');
      iorad.player.events.trigger('interactive-nav:header:hovering', false);
    },

    updateActions: function(data) {
      var actionsEl = this.$('.actions');

      var replayButton = actionsEl.find('#replay-btn');
      var replayText = actionsEl.find('#replay-text');
      var replayIcon = replayButton.find('.replay-icon');
      var completeIcon = replayButton.find('.complete-icon');
      replayIcon.hide();
      completeIcon.hide();
      replayText.text(i18next.t(data.isQuizTab ? 'Retake' : 'Replay'));
      if (data.isQuizTab) {
        if (data.quizFinalReport && data.quizFinalReport.passed) {
          replayText.text(i18next.t('Complete'));
          replayButton.css('pointer-events', 'none');
          completeIcon.show();
        } else {
          replayText.text(i18next.t('Retake'));
          replayButton.css('pointer-events', '');
          replayIcon.show();
        }
      } else {
        replayText.text(i18next.t('Replay'));
        replayButton.css('pointer-events', '');
        replayIcon.show();
      }

      actionsEl.css({ display: !data.isFinishBtnVisible ? 'none' : '' });

      var goLiveEl = actionsEl.find('#go-live');
      goLiveEl.css({ display: !data.isGoLiveBtnVisible ? 'none' : '' });

      var copyLinkEl = actionsEl.find('.copy-short-tut-link');
      copyLinkEl.css({ display: !data.isCopyLinkVisible ? 'none' : '' });

      var copyEmbedEl = actionsEl.find('.copy-embed-tut-link');
      copyEmbedEl.css({ display: !data.isCopyEmbedVisible ? 'none' : '' });

      actionsEl.find('.button').css('margin-top', '');
      if (this.$('.buttons').hasClass('finished')) {
        actionsEl.find('.button:visible').first().css('margin-top', 0);
      }
    },

    updateQuizReport: function(data) {
      var quizReport = this.$('.quiz-report');
      var finalReport = data.quizFinalReport;

      var isReportVisible = !!finalReport && iorad.player.tab === 'quiz' && data.finished;

      quizReport.toggle(isReportVisible);
      this.$('.stepscontainer').toggle(!isReportVisible);
      if (!isReportVisible) return;

      var quizResultsType = this.model.get('quizResultsType') || 'all';
      this.$('.section-speed').toggle(['all', 'speed'].indexOf(quizResultsType) !== -1);
      this.$('.section-accuracy').toggle(['all', 'accuracy'].indexOf(quizResultsType) !== -1);

      this.$('.section-speed .section-content-user .duration').text(finalReport.userSpeed);
      this.$('.section-speed .section-content-ideal .duration').text(finalReport.idealSpeed);

      this.$('.section-accuracy .accuracy').text(finalReport.accuracyPercent + '%');

      quizReport.find('.section').css('margin-top', '');
      quizReport.find('.section:visible').first().css('margin-top', 0);
    },

    updateQuizWebcam: function(data) {
      var quizWebcam = this.$('.quiz-webcam');

      var isWebcamVisible = !!iorad.player.controllers.quiz.recorder &&
        !iorad.player.controllers.quiz.recorder.stopped;

      quizWebcam.toggle(isWebcamVisible);

      var $video = quizWebcam.find('video');
      if (isWebcamVisible && iorad.player.controllers.quiz.recorder.video !== $video[0]) {
        $video.replaceWith(
          iorad.player.controllers.quiz.recorder.video
        );
      }
    },

    onStepPanelCurrentstepClick: function () {
      if (iorad.player.tab !== 'quiz') {
        iorad.player.router.playbarView.setPlaybarPopupPosition(null, iorad.player.router.stepsView);
        // iorad.player.router.togglePlayerPopup(true);
        iorad.player.router.stepsView.toggle();
      }
    },

    onStepPanelToggleCollapseClick: function (event) {
      iorad.player.controllers.views.toggleCollapseStepPanel();
    },

    resetStepPanelPosition: function () {
      $('#interactive-nav').css({
        'position': '',
        'top': '',
        'left': '',
        'height': '',
      });
    },

    onStepPanelTypeChange: function () {
      if (this.resizing) {
        // do not reset while resizing,
        // the resize code does its own resetting if needed
        return;
      }
      this.resetStepPanelPosition();
    },

    // Show overlay back/next buttons only for READ steps
    // TODO: this code should go in a proper view!
    updateOverlays: function() {
      var stepModel = this.collection.getCurrentModel();
      if (!stepModel) return; // too early

      var overlayNextBtn = $('#playing-player').find('.btn-overlay.next');

      var nextStepPos = this.collection.position + 2;
      overlayNextBtn.attr('href', iorad.player.router.getInteractiveModeLink(null, nextStepPos)); // zero based, thus +2

      // Note: cssText needed for adding !important
      var markerColor = iorad.player.data.markerColors.get(stepModel.get('type'));
      overlayNextBtn.css('cssText', markerColor ?
        'background-color: ' + markerColor + " !important;"
      : '');

      overlayNextBtn.hide();
    },

    updateStepPointer: function() {
      var stepModel = this.collection.getCurrentModel();
      var step = stepModel ? stepModel.get('index') : -1;

      var markerColor = stepModel ? iorad.player.data.markerColors.get(stepModel.get('type')) : '';
      this.$('.marker').css('border-right-color', markerColor ? markerColor : '');
      $('#interactive-nav').css('border-right-color', markerColor ? markerColor : '');

      var stepEl = $('.step:eq(' + step + ')', this.$el.parent());
      if (stepEl.length !== 0 && stepEl.is(':visible')) {

        // in case with google translate banner is visible
        var $bannerFrame = $(`iframe#${CSS.escape(':2.container')}`),
          bannerHeight = $bannerFrame.is(':visible') ? $bannerFrame.height() : 0;

        var $header = $('.header-inner');
        var headerHeight = $header.is(':visible') ? $header.height() : 0;

        var posTop = (stepEl.find('.steptext p').offset() || { top: 0 }).top + $('.stepscontainer').scrollTop() - bannerHeight - headerHeight;

        this.$('.marker').css('top', posTop);
      }
    },

    setupResizable: function () {
      this.resizing = null;
      this.listenToDOM(window, 'mouseup', this.onResizeStop);
      this.listenToDOM(window, 'mousemove', _.bind((e) => {
        if (this.resizing) this.onResize(e);
      }));
    },

    onResizeStart: function (e) {
      const containmentEl = $('#playing-player');
      const containmentBounds = containmentEl[0].getBoundingClientRect();
      const elBounds = this.el.getBoundingClientRect();
      this.resizing = {
        startHeight: this.$el.height(),
        startClientY: e.clientY,
        remainingHeight: containmentBounds.height - (elBounds.top - containmentBounds.top)
      };
      this.resizing.minHeight = this.$('.start-step').outerHeight();
      this.resizing.maxHeight = this.resizing.startHeight + (elBounds.top - containmentBounds.top);
    },

    onTopResizeStart: function (e) {
      this.onResizeStart(e);
      this.resizing.pointer = 'top';
    },

    onBottomResizeStart: function (e) {
      this.onResizeStart(e);
      this.resizing.pointer = 'bottom';
    },

    onResize: function (e) {
      const elTop = this.el.style.top;
      const dragged = (elTop && elTop !== 'auto');
      const oldHeight = this.$el.height();

      if (this.resizing.pointer === 'top') {
        this.$el.css('height', `${Math.max(
          this.resizing.minHeight,
          Math.min(
            this.resizing.maxHeight,
            this.resizing.startHeight - (e.clientY - this.resizing.startClientY)
          )
        )}px`);
        if (dragged) {
          const newHeight = this.$el.height();
          this.$el.css('top', `${parseInt(elTop, 10) - (newHeight - oldHeight)}px`);
        }
      } else if (this.resizing.pointer === 'bottom') {
        this.$el.css('height', `${Math.max(
          this.resizing.minHeight,
          Math.min(
            this.resizing.remainingHeight,
            this.resizing.startHeight + (e.clientY - this.resizing.startClientY)
          )
        )}px`);
      }
    },

    onResizeStop: function () {
      if (!this.resizing) return;

      const elHeight = this.$el.height();
      const containmentHeight = $('#playing-player').height();
      if (elHeight <= this.resizing.minHeight) {
        iorad.player.controllers.views.collapseStepPanel();
        this.resetStepPanelPosition();
      } else if (containmentHeight - elHeight <= 5) {
        iorad.player.controllers.views.expandStepPanel();
        this.resetStepPanelPosition();
      } else {
        iorad.player.controllers.views.uncollapseStepPanel();
        // do not reset step panel position
      }

      iorad.player.events.trigger('resize:interactive-nav');

      this.resizing = null;
    },

    onStepStepDblclick: function () {
      iorad.player.controllers.views.toggleExpandStepPanel();
    },

    accessibilityButtonOnKeyPress: iorad.base.Utils.accessibilityButtonOnKeyPress,
  });
}());

;
iorad.player.views.steps_interactive_nav_item = Backbone.View.extend({
  className: 'step tut-step',
  template: iorad.player.templates.steps_interactive_nav_item,

  events: {
    'click .steptext': 'gotoStep',
  },

  initialize: function(options) {
    options = options || {};
    _.bindAll(this, 'render', 'gotoStep');

    this.position = options.position;

    this.descriptionView = new iorad.player.views.step_description({
      model: this.model
    });
  },

  render: function() {
    if (this.descriptionView) {
      // FIX IE11 "html disappearing" ISSUE
      this.descriptionView.$el.detach();
    }

    var countEl = this.$('.count');
    if (countEl.length) countEl.detach();

    var className = {
      'MOUSE': 'mouse',
      'READ': 'read',
      'TYPING': 'type',
      'SCROLL': 'scroll'
    }[this.model.get('type')] || (this.model.get('type') || '').toLowerCase();

    var obj = _.extend(this.model.toJSON(), {
      stepIndex: this.position,
      className: className,
      number: this.model.get('index') + 1,
      total: iorad.player.data.stepsCollection.length,
    });
    var html = Mustache.render(this.template, obj);
    this.$el.html(html);

    this.$('.description-container').append(this.descriptionView.$el);

    if (countEl.length) this.$('.count').replaceWith(countEl);
    this.updateCount(obj);

    if (obj.number == obj.total) {
      iorad.player.events.trigger('item:last:rendered');
    }

    return this;
  },

  updateCount: function(data) {
    this.$('.count-number').text(data.number);
    this.$('.count-total').text(data.total);
  },

  gotoStep: function() {
    var stepPos = this.$el.index() + 1;
    iorad.player.router.navigateToInteractiveMode(null, stepPos);
    return false;
  },
});

;
/* Steps list in interactive mode sidebar */

iorad.player.views.steps_interactive_nav_list = iorad.base.CollectionView.extend({
  itemView: iorad.player.views.steps_interactive_nav_item,

  initialize: function() {
    iorad.base.CollectionView.prototype.initialize.apply(this, arguments);

    this.listenTo(this.collection, 'changeCurrent reset', this.update);
    this.listenTo(iorad.player.events, 'ready:interactive', this.update);
    this.update();
  },

  update: function() {
    var stepIndex = this.collection.position;
    if (this.updateTimerData) {
      window.clearTimeout(this.updateTimerData.timeout);
      if (this.updateTimerData.stepIndex !== stepIndex) {
        this.updateTimerData.callback();
      }
    }

    var futureSteps = this.$('>.step:gt(' + stepIndex + ')');
    var previousSteps = this.$('>.step:lt(' + stepIndex + ')');
    var currentStep = this.$('>.step').eq(stepIndex);
    if (!currentStep.length || !currentStep.position()) return; // too early

    futureSteps.hide();
    currentStep.show();
    previousSteps.hide();

    $('#playing-player .stepnav')
      .toggleClass('no-transition', !iorad.player.ready);

    var callback = _.bind(function() {
      futureSteps.removeClass('active'); // needed when going back
      if (Backbone.history.location.hash.indexOf('#finished') === -1) {
        currentStep.addClass('active');
      }
    }, this);
    if (!iorad.player.ready) {
      callback();
    } else {
      this.updateTimerData = {
        timeout: setTimeout(callback, 50),
        callback: callback,
        stepIndex: stepIndex,
      };
    }
  },
});

;
// Take the collection of steps and display the current screenshot
iorad.player.views.steps_interactive_slide = iorad.base.View.extend({

  events: {
    'mouseup .image-surround': 'onMouseUp',
  },

  initialize: function() {
    this.renderTimers = [];

    this.listenTo(this.collection, 'reset add changeCurrent', this.render);
    this.listenTo(iorad.player.events, 'theme:applied', this.updateBackground);

    this.screenshotView = new iorad.player.views.step_screenshot();
    this.$('.containment').append(this.screenshotView.$el);

    var screenshotOverlayEl = $(document.createElement('div'));
    screenshotOverlayEl.addClass('screenshot-overlay');
    var canvasAboveOverlay = $(document.createElement('canvas'));
    canvasAboveOverlay.addClass('canvas-above-overlay');

    this.hlView = new iorad.player.views.MarkerList({
      slideView: this,
      tutorial: this.model,
      stepsCollection: this.collection,
    });

    this.$('.containment').append(screenshotOverlayEl);
    this.$('.containment').append(canvasAboveOverlay);
    this.$('.containment').append(this.hlView.$el);

    this.listenTo(iorad.player.events, 'interactive:back', this.moveToPreviousStep);
    this.listenTo(iorad.player.events, 'interactive:next', this.moveToNextStep);

    this.listenTo(this.hlView, 'makeIntoViewRequest', this.makeIntoView);
    this.listenTo(this.hlView, 'isCompleted', function(isCompleted) {
      iorad.player.controllers.quiz.checkStepCompletition(isCompleted);
      if (isCompleted) {
        this.moveToNextStep();
      }
      this.showInteractionFeedback(isCompleted);
    });

    // prevent context menu on the slide, so we can have a right click
    this.$('.image-surround').on('contextmenu', function() {
      return false
    });

    this.listenTo(iorad.player.events, 'ready:interactive', function() {
      if (iorad.player.oldMode !== 'interactive' && iorad.player.oldMode !== 'print') {
        this.render();
      }
    });

    this.listenTo(iorad.player.events, 'tab', function() {
      if (iorad.player.tab === 'try' || iorad.player.tab === 'watch' || iorad.player.tab === 'quiz') {
        this.render();
      }
    });

    var nextBtn = this.$('.btn-overlay.next'),
      nextSvg = nextBtn.find('svg');

    this.screenshotView.on('load', () => {
      this.updateBackground();

      //var colorNext = iorad.base.Utils.mostCommonColor(this.screenshotView.canvas,
      //        this.screenshotView.canvas.width - nextBtn.width(), 0, nextBtn.width(), null, 10),
      //    nextInvertColorRgb = iorad.base.Export.hexToRgb(iorad.base.Utils.invertColor(colorNext));
      //this.applyOverlayGradient(nextBtn, nextInvertColorRgb);
      //nextSvg.find('path').css('fill', colorNext);
    });

    this.listenTo(iorad.player.controllers.screenshots, 'change:zoom', this.updateContainment);
    this.listenTo(iorad.player.events, 'change:stepPanel embedded:init:show', this.updateContainment);
    this.listenTo(iorad.player.controllers.views, 'before:change:coverOpen', function () {
      // for adjustPanelPosition & moveCanvasAboveOverlay
      this.hlView.scrollToMarker(
        this.hlView.markerViews[0],
        // { transitionDuration: 0 }
      );
    });
    this.listenTo(iorad.player.events, 'change:stepPanel', function () {
      if (iorad.player.stepPanelType === 'full' || iorad.player.oldStepPanelType === 'full') {
        this.hlView.scrollToMarker(
          this.hlView.markerViews[0],
          { transitionDuration: 0 }
        );
      }
    });
    this.listenTo(iorad.player.events, 'player:ready', function () {
      // for adjustPanelPosition & moveCanvasAboveOverlay when cover is disabled
      setTimeout(_.bind(function () {
        this.hlView.scrollToMarker(
          this.hlView.markerViews[0],
          { transitionDuration: 0 }
        );
      }, this), 200);
    });
    $(window).on('resize', _.bind(() => {
      if (iorad.player.mode === 'interactive') {
        this.render();
      }
      this.updateContainment();
    }, this));
    this.updateContainment();

    this.setupTranscription();
    this.setupScreenshotOverlayHoverOpacity();
  },

  setupTranscription: function () {
    var transcriptionEl = $('#interactive-transcription');

    var transcriptionAudioState;
    var transcriptionVideoState;
    var check = _.bind(function () {
      var transcriptionState = (
        transcriptionVideoState ||
        transcriptionAudioState
      );
      if (transcriptionState) {
        transcriptionEl.text(transcriptionState.wordsToDisplay.join(' '));
        transcriptionEl.show();
      } else {
        transcriptionEl.hide();
      }
    }, this);
    var checkAudio = _.bind(function () {
      transcriptionAudioState = iorad.player.controllers.audio.getTranscriptionState();
      check();
    }, this);
    var checkVideo = _.bind(function () {
      // NOTE: when display isn't disabled, the transcription is displayed above the video
      // (See interactive-nav.js updateVideoVisualizer)
      transcriptionVideoState = (
        iorad.player.videoDisplayDisabled &&
        iorad.player.controllers.video.getTranscriptionState()
      );
      check();
    }, this);
    this.listenTo(iorad.player.controllers.audio, 'change:transcriptionState', checkAudio);
    this.listenTo(iorad.player.controllers.video, 'change:transcriptionState', checkVideo);
    this.listenTo(iorad.player.events, 'video:display', checkVideo);
    check();
  },

  // Reduce opacity proportionally to distance between mouse and marker
  setupScreenshotOverlayHoverOpacity: function() {
    var viewport = this.$('.image-surround');
    var containment = this.$('.containment');
    var screenshotOverlay = this.$('.screenshot-overlay');
    var originalOpacity = this.model.getScreenshotOverlayOpacity() / 100;

    var isEnabled = _.bind(function () {
      var currentStepModel = this.collection.getCurrentModel();
      var screenshotOverlayEnabled = (
        this.model.getScreenshotOverlayAllStepsEnabled() ||
        (
          currentStepModel &&
          currentStepModel.get('screenshotOverlayEnabled')
        )
      );
      return Boolean(
        screenshotOverlayEnabled &&
        this.model.getScreenshotOverlayDynamicMousePosition() &&
        this.model.getScreenshotOverlayEnter() !== 'no-transition' &&
        !this.$('.containment .marker.active').hasClass('transparent')
      );
    }, this);

    var calculateDistance = _.bind(function(rect, p) {
      if (
        (p.x >= rect.min.x && p.x <= rect.max.x) &&
        (p.y >= rect.min.y && p.y <= rect.max.y)
      ) {
        // p is inside rect
        return 0;
      }

      var dx = Math.max(rect.min.x - p.x, 0, p.x - rect.max.x);
      var dy = Math.max(rect.min.y - p.y, 0, p.y - rect.max.y);
      return Math.sqrt(dx * dx + dy * dy);
    }, this);

    var onMouseEnter = _.bind(function () {

    }, this);

    var onMouseMove = _.bind(function(event) {
      var markerEl = this.$('.containment .marker.active')[0];
      if (!markerEl) return;

      if (screenshotOverlay.hasClass('fading-in') || !isEnabled()) {
        return;
      }

      // relative to containment
      var markerRect = {
        min: {
          x: parseFloat(markerEl.style.left),
          y: parseFloat(markerEl.style.top),
        },
        max: {
          x: parseFloat(markerEl.style.left) + parseFloat(markerEl.style.width),
          y: parseFloat(markerEl.style.top) + parseFloat(markerEl.style.height),
        },
      };

      var containmentBounds = containment[0].getBoundingClientRect(); // relative to the page
      var scale = containmentBounds.width / containment.width(); // NOTE: assumes x & y scale are the same

      var viewportBounds = viewport[0].getBoundingClientRect(); // relative to the page

      function pageToContainmentPoint(clientX, clientY) {
        return {
          x: ((clientX - viewportBounds.left) + viewport.prop('scrollLeft')) * scale,
          y: ((clientY - viewportBounds.top) + viewport.prop('scrollTop')) * scale,
        };
      }

      // page-relative to containment-relative
      var mousePoint = pageToContainmentPoint(event.clientX, event.clientY);

      var topLeftPoint = pageToContainmentPoint(0, 0);
      var topRightPoint = pageToContainmentPoint(viewportBounds.left + viewportBounds.width, 0);
      var bottomLeftPoint = pageToContainmentPoint(0, viewportBounds.top + viewportBounds.height);
      var bottomRightPoint = pageToContainmentPoint(viewportBounds.left + viewportBounds.width, viewportBounds.top + viewportBounds.height);
      var maxDistance = Math.max(
        calculateDistance(markerRect, topLeftPoint),
        calculateDistance(markerRect, topRightPoint),
        calculateDistance(markerRect, bottomLeftPoint),
        calculateDistance(markerRect, bottomRightPoint)
      );

      var distance = calculateDistance(markerRect, mousePoint);
      var distancePercent = distance / maxDistance;

      var newOpacity = parseFloat(
        (originalOpacity * distancePercent).toFixed(2)
      );
      screenshotOverlay.css('opacity', newOpacity);

      // console.log('DISTANCE', {
      //   distance: distance,
      //   maxDistance: maxDistance,
      //   originalOpacity: originalOpacity,
      //   newOpacity: newOpacity,
      // });
    }, this);

    var onMouseLeave = _.bind(function () {
      if (screenshotOverlay.hasClass('fading-in') || !isEnabled()) {
        return;
      }
      screenshotOverlay.css('opacity', originalOpacity);
    }, this);

    this.listenToDOM(viewport, 'mouseenter', onMouseEnter);
    this.listenToDOM(viewport, 'mousemove', onMouseMove);
    this.listenToDOM(viewport, 'mouseleave', onMouseLeave);
  },

  getViewport: function() {
    return $('.image-surround');
  },

  updateContainment: function() {
    // adapted from iorad.player.helpers.positioning.hammerIt
    var getTransformForZoom = _.bind(function({ forcedZoomFactor } = {}) {
      var viewport = this.getViewport();
      var contentWidth = parseInt($('.image-surround .containment').css('width'), 10);
      var contentHeight = parseInt($('.image-surround .containment').css('height'), 10);
      function getMinScale() {
        var viewportWidth = viewport.width();
        var viewportHeight = viewport.height();
        return Math.min(
          1,
          viewportWidth / contentWidth,
          viewportHeight / contentHeight
        );
      }
      function calculateShift(aScale) {
        var scaledContentWidth = (contentWidth * aScale);
        var scaledContentHeight = (contentHeight * aScale);
        return {
          x: (scaledContentWidth >= contentWidth)
            ? (scaledContentWidth - contentWidth) / 2
            : -((contentWidth - scaledContentWidth) / 2),
          y: (scaledContentHeight >= contentHeight)
            ? (scaledContentHeight - contentHeight) / 2
            : -((contentHeight - scaledContentHeight) / 2),
        };
      }

      var posX = 0;
      var posY = 0;
      var scale = 1;

      function update() {
        var viewportWidth = viewport.width();
        var viewportHeight = viewport.height();

        var shift = calculateShift(scale);
        var leftmostX = shift.x;
        var topmostY = shift.y;
        var rightmostX = -(leftmostX + (contentWidth - viewportWidth));
        var downmostY = -(topmostY + (contentHeight - viewportHeight));

        var maxX = Math.max(leftmostX, rightmostX);
        var minX = Math.min(leftmostX, rightmostX);
        var maxY = Math.max(topmostY, downmostY);
        var minY = Math.min(topmostY, downmostY);

        posX = Math.min(posX, maxX);
        posX = Math.max(posX, minX);
        posY = Math.min(posY, maxY);
        posY = Math.max(posY, minY);

        return "translate3d(" + posX + "px," + posY + "px, 0) " +
          "scale3d(" + scale + ", " + scale + ", 1)";
      }

      update();
      var initialValidPosX = posX;
      var initialValidPosY = posY;

      var minScale = getMinScale();
      //console.log('MIN SCALE', minScale);

      var zoomFactor = typeof forcedZoomFactor !== 'undefined'
        ? forcedZoomFactor
        : iorad.player.controllers.screenshots.getCurrentZoom();

      var newScale;
      if (zoomFactor === 1) {
        newScale = Math.max(minScale, 1);
      } else if (zoomFactor >= 1) {
        newScale = zoomFactor;
      } else {
        newScale = minScale + ((1 - minScale) * zoomFactor);
      }

      scale = newScale;
      var newShift = calculateShift(newScale);
      var percentScale = (minScale === 1)
        ? newScale
        : (newScale - minScale) / (1 - minScale);
      posX = (initialValidPosX * percentScale) + newShift.x;
      posY = (initialValidPosY * percentScale) + newShift.y;
      return update();
    }, this);

    if ($('.containment').length) {
      var keys = ['left', 'top', 'transform'];
      var oldStyle = $('.containment').css(keys);
      var oldImageSurroundScrollTop = this.$('.image-surround')[0].scrollTop;
      var oldImageSurroundScrollLeft = this.$('.image-surround')[0].scrollLeft;

      // reset
      $('.containment').css({
        position: 'relative',
        left: 0,
        top: 0,
        transform: '',
      });

      if (iorad.player.controllers.screenshots.getCurrentZoom() !== 1) {
        $('.containment').css({
          transform: getTransformForZoom(),
        });
      }
      if (iorad.player.getParameters.videoExport === 'true') {
        // When the screenshot is already fully zoomed out regardless of zoom
        const slideContainmentEl = this.$('.image-surround');
        const containmentBounds = slideContainmentEl[0].getBoundingClientRect();
        // containmentBounds.width can be a floating like 5479.96875 while slideContainmentEl is 5480
        // => use Math.round
        const noScale = Math.round(containmentBounds.width) === Math.round(slideContainmentEl.width()); // NOTE: assumes x & y scale are the same
        if (noScale) {
          // when the screenshot has grey bars
          const viewportEl = $('#playing-player #interactive-image');
          const screenshotEl = viewportEl.find('.containment');
          const widthRatio = viewportEl.width() / screenshotEl.width();
          const heightRatio = viewportEl.height() / screenshotEl.height();
          const withGreyBars = widthRatio > 1 || heightRatio > 1;
          if (withGreyBars) {
            // zoom in as much as possible to remove grey bars
            const maxZoomFactor = 2;
            const forcedZoomFactor = Math.min(
              maxZoomFactor,
              iorad.player.controllers.screenshots.getCurrentZoom() === 0
                ? Math.min(widthRatio, heightRatio) // keep both sides visible (fully zoomed out), even if one grey bar can still remain
                : Math.max(widthRatio, heightRatio)
            );
            if (forcedZoomFactor !== 1) {
              $('.containment').css({
                transform: getTransformForZoom({ forcedZoomFactor }),
              });
            }
          }
        }
      }

      // keep image horizontally and vertically centered (when smaller than viewport)
      var containmentBounds = $('.containment')[0].getBoundingClientRect(); // takes scale into account
      var widthDifference = $('.containment').parent().width() - containmentBounds.width;
      var heightDifference = $('.containment').parent().height() - containmentBounds.height;
      $('.containment').css({
        left: widthDifference > 0 ? Math.max(0, widthDifference / 2) : 0,
        top: heightDifference > 0 ? Math.max(0, heightDifference / 2) : 0,
      });
      $('#playing-player .step-infotext').css({
        left: widthDifference > 0 ? $('.containment').css('left') : '',
        width: widthDifference > 0 ? containmentBounds.width : '',
        top: heightDifference > 0 ? $('.containment').css('top') : '',
        height: heightDifference > 0 ? containmentBounds.height : '',
      });

      var newStyle = $('.containment').css(keys);
      var newImageSurroundScrollTop = this.$('.image-surround')[0].scrollTop;
      var newImageSurroundScrollLeft = this.$('.image-surround')[0].scrollLeft;

      if (!_.isEqual(oldStyle, newStyle)) {
        if (
          this.hlView &&
          this.hlView.markerViews
        ) {
          var activeMarkerView = _.find(this.hlView.markerViews, _.bind(function (markerView) {
            return markerView.$el.hasClass('active');
          }, this));
          if (activeMarkerView) {
            this.hlView.scrollToMarker(
              this.hlView.markerViews[0],
              { transitionDuration: 0 }
            );
          }
        }
      } else { // equal style
        // resetting and recalculating the .containment style can cause the scroll position
        // to be reset to the top, even though the style is the same, so we need to restore it
        // See #14639
        if (oldImageSurroundScrollTop !== newImageSurroundScrollTop) {
          this.$('.image-surround')[0].scrollTop = oldImageSurroundScrollTop;
        }
        if (oldImageSurroundScrollLeft !== newImageSurroundScrollLeft) {
          this.$('.image-surround')[0].scrollLeft = oldImageSurroundScrollLeft;
        }
      }
    }
  },

  // applyOverlayGradient: function($el, colorRgb, isInvert) {
  //   colorRgb = colorRgb.join(', ');
  //   isInvert = isInvert || false;
  //   var aFirst = 0.18,
  //     aEnd = 0.72,
  //     pMiddle = '99%';
  //   if (isInvert) {
  //     aFirst = 0.72;
  //     aEnd = 0.18;
  //     pMiddle = '1%';
  //   }
  //   $el.css('background-image',
  //     '-webkit-gradient(linear, 0% 50%, 100% 50%, ' +
  //     'color-stop(0%, rgba(' + colorRgb + ', ' + aFirst + ')), ' +
  //     'color-stop(' + pMiddle + ', rgba(' + colorRgb + ', 0.71)), ' +
  //     'color-stop(100%, rgba(' + colorRgb + ', ' + aEnd + ')))');

  //   $el.css('background-image',
  //     '-webkit-linear-gradient(left, rgba(' + colorRgb + ', ' + aFirst + ') 0%, ' +
  //     'rgba(' + colorRgb + ', 0.71) ' + pMiddle + ', rgba(' + colorRgb + ', ' + aEnd + ') 100%)');

  //   $el.css('background-image',
  //     '-moz-linear-gradient(left, rgba(' + colorRgb + ', ' + aFirst + ') 0%, ' +
  //     'rgba(' + colorRgb + ', 0.71) ' + pMiddle + ', rgba(' + colorRgb + ', ' + aEnd + ') 100%)');

  //   $el.css('background-image',
  //     '-o-linear-gradient(left, rgba(' + colorRgb + ', ' + aFirst + ') 0%, ' +
  //     'rgba(' + colorRgb + ', 0.71) ' + pMiddle + ', rgba(' + colorRgb + ', ' + aEnd + ') 100%)');

  //   $el.css('background-image',
  //     'linear-gradient(to left, rgba(' + colorRgb + ', ' + aFirst + ') 0%, ' +
  //     'rgba(' + colorRgb + ', 0.71) ' + pMiddle + ', rgba(' + colorRgb + ', ' + aEnd + ') 100%)');
  // },

  render: function() {
    // deactivate previous render timers
    // (prevents unwanted side effects and memory leaks)
    _.each(this.renderTimers, clearTimeout);
    this.renderTimers = [];

    var self = this;
    var step = this.collection.getCurrentModel();
    if (step) {

      // Update the screenshot
      self.screenshotView.setStep(step);
      // Adjust size of slide image containment
      // NOTE: plus marker borders because of CANVAS margin
      var MARKER_BORDER = 6;
      self.$('.containment').css({
        width: self.screenshotView.size.width + (MARKER_BORDER * 2),
        height: self.screenshotView.size.height + (MARKER_BORDER * 2)
      });

      // Draw the markers and tools
      this.hlView.setStep(step);
      this.hlView.render();

      // Preload the image
      step.preload();

      var transitionDuration = $('#playing-player li.marker').css('transition-duration'); // eg '0.5s'
      transitionDuration = parseFloat(transitionDuration) * 1000; // converted to ms, eg '500'

      // Wait to let the markers animate
      this.renderTimers.push(
        setTimeout(function() {
          // Give focus to the typing tool (if any)
          iorad.player.events.trigger('marker:TYPING:focus');

          // Start preloading the next and previous screenshot
          var nextStep = self.collection.getNextModel();
          var previousStep = self.collection.getPreviousModel();
          if (nextStep) nextStep.preload();
          if (previousStep) previousStep.preload();
        }, transitionDuration)
      );

      // wait for the view to be fully rendered before enabling interactivity,
      // otherwise quick interactions of the user could seem to still happen in the old step (see #966)
      // TODO: we don't know when the browser has rendered it, hence we use an hacky timer.
      this.renderTimers.push(
        setTimeout(_.bind(this.hlView.enableInteractivity, this.hlView), 500)
      );
    }

    this.updateContainment();
    return this;
  },

  updateBackground: function () {
    const currentTheme = iorad.player.data.themesCollection.get(
      iorad.player.data.tutorial.get('theme')
    );

    const dynamicBackgroundEnabled = currentTheme ?
      currentTheme.get('dynamicBackgroundEnabled')
      : false;

    const backgroundColor = dynamicBackgroundEnabled ?
      this.screenshotView.getCommonColour()
      :
      ((currentTheme && currentTheme.get('staticBackground')) || '');

    this.$('.image-surround').css('background-color', backgroundColor);
  },

  // left click, right click or double click
  onMouseUp: function(event) {
    var target = $(event.target);

    if (!target.closest('.marker').length && !target.closest('.image-surround .scroll-element').length) {
      // outside marker (excluding custom scrollbars)
      this.trigger('mouseUpOutsideMarker');
    }
  },

  makeIntoView: function(el, options) {
    var imageSurround = this.$('.image-surround');

    options = _.defaults(options || {}, {
      marginCenter: true
    });

    if (!iorad.base.Utils.isIntoView(el, imageSurround, options)) {
      iorad.base.Utils.makeIntoView(el, imageSurround, undefined, options);
    }
  },

  moveToPreviousStep: function() {
    var currentStep = this.collection.position + 1; // position is 0-indexed!

    if (currentStep > 1) {
      iorad.player.router.navigateToInteractiveMode(null, (currentStep - 1));
    }
  },

  moveToNextStep: function() {
    var currentStep = this.collection.position + 1; // position is 0-indexed!

    if (currentStep < this.collection.length) {
      iorad.player.router.navigateToInteractiveMode(null, (currentStep + 1));
    }
  },

  showInteractionFeedback: function(isCompleted) {
    setTimeout(_.bind(function() { // needed because of the interal setTimeout

      var imageSurround = this.$('.image-surround');
      var feedbackBar = $('.feedback-bar');

      // stop eventual already running animation
      imageSurround.removeClass('slide-completed');
      feedbackBar.removeClass('slide-completed');
      imageSurround.removeClass('slide-notCompleted');
      feedbackBar.removeClass('slide-notCompleted');

      // wait reflow or if the new class is the same of the old,
      // the animation won't restart
      // Note: don't use defer since does not work!
      setTimeout(_.bind(function() {

        // run animation
        var animationClass = isCompleted ? 'slide-completed' : 'slide-notCompleted';
        imageSurround.addClass(animationClass);
        feedbackBar.addClass(animationClass);

        // on end, remove animation
        imageSurround.one("animationend webkitAnimationEnd oanimationend MSAnimationEnd", _.bind(function() {
          imageSurround.removeClass(animationClass);
        }, this));
        feedbackBar.one("animationend webkitAnimationEnd oanimationend MSAnimationEnd", _.bind(function() {
          feedbackBar.removeClass(animationClass);
        }, this));

      }, this), 0);

    }, this), 1);
  }

});

;
iorad.player.views.steps_quick_step = iorad.base.View.extend({

  // as function to fix circular dependency,
  // also intended for be overridable by child types (like print)
  getSlideViewType: function() {
    return iorad.player.views.steps_quick_slide;
  },
  getStepListViewType: function() {
    // TODO: sub-steps does not use lazy reading, this means that TONS of views will be displayed anyway
    // in case a step has tons of sub-steps (but this does not currently happens)
    return iorad.player.views.steps_quick_step_list_default;
  },

  initialize: function(options) {
    options = options || {};

    this.parentStep = options.parentStep;

    if (
      this.model.get('summary') ||
      this.model.get('type') === 'SCROLL' || // ignore broken non-postprocessed SCROLL substeps (See https://github.com/iorad/iorad/issues/12775)
      this.model.steps.length == 0
    ) {
      // display the slide for current step
      var SlideViewType = this.getSlideViewType();
      this.view = new SlideViewType({
        model: this.model,
        parentStep: this.parentStep
      });
    } else {
      // display sub-steps
      var StepListType = this.getStepListViewType();
      this.view = new StepListType({
        collection: this.model.steps,
        parentStep: this.model
      });
    }

  },

  render: function() {
    this.view.$el.detach(); // IE11 fix

    iorad.base.View.prototype.render.apply(this, arguments);

    this.$el.append(this.view.$el);

    // Render sub-view only if it isn't a Chaplin CollectionView,
    // since the latter is auto rendered and calling it manually would remove
    // the parent view (this view) element in IE11 (#1544)
    if (this.view instanceof Backbone.Chaplin.CollectionView == false) {
      this.view.render();
    }

    return this;
  },

  getSlideViews: function() {
    if (this.view instanceof this.getSlideViewType()) {
      return [this.view];
    }
    // this.view is a step-view list
    return this.view.getSlideViews();
  }

});
;
// BaseView is supposed to be a CollectionView or a subtype of it (e.g. LazyCollectionView).
// Note: DO NOT use this.collection since might be a "proxy" and thus have no extended methods, use
// this.realCollection instead.
iorad.player.views.steps_quick_step_list_common = function(BaseView) {
  return BaseView.extend({

    itemView: iorad.player.views.steps_quick_step,

    realCollection: undefined, // MANDATORY for child types

    initialize: function(options) {
      options = options || {};

      BaseView.prototype.initialize.apply(this, arguments);

      this.parentStep = options.parentStep;
    },

    initItemView: function(model) {
      // also pass parentStep to new models
      return new this.itemView({
        autoRender: false,
        model: model,
        parentStep: this.parentStep
      });
    },

    ready: function() {
      // Note: be sure that the preload already started when calling this or will be a fake success
      var tasks = [this.realCollection.preloaded()];
      return Promise.all(tasks);
    },

    getSlideViews: function() {
      var slideViews = [];

      var stepViewList = _.values(this.getItemViews());
      _.each(stepViewList, function(stepView) {
        var stepViewSlides = stepView.getSlideViews();
        // append all the step view slides to the main list
        Array.prototype.push.apply(slideViews, stepViewSlides);
      });

      return slideViews;
    }

  });
};
;
(function() {
  var Super = iorad.player.views.steps_quick_step_list_common(iorad.base.CollectionView);
  iorad.player.views.steps_quick_step_list_default = Super.extend({

    initialize: function(options) {
      options = options || {};

      this.realCollection = this.collection;
      Super.prototype.initialize.apply(this, arguments);
    }

  });
})();
;
(function() {
  var Super = iorad.player.views.steps_quick_step_list_common(iorad.player.LazyCollectionView);
  iorad.player.views.steps_quick_step_list_lazy = Super.extend({

    animationDuration: 0,

    initialize: function(options) {
      options = options || {};

      this.scrollContainer = $('#main');
      // the collection is a lazy collection, store the real one for methods calls, etc.
      this.realCollection = this.collection.collection;
      Super.prototype.initialize.apply(this, arguments);

      this.listenTo(iorad.player.events, 'ready', this.onModeChange);
      this.listenTo(this.collection, 'reset', this.onModeChange);
    },

    onModeChange: function(mode) {
      if (this.$el.is(':visible') || mode === 'quick') this.notifyIsInViewport();
      else this.notifyIsNotInViewport();
    }

  });
})();

;
iorad.player.views.step_quick_description = iorad.player.views.step_description.extend({

  initialize: function(options) {
    options = options || {};

    this.parentStep = options.parentStep;

    iorad.player.views.step_description.prototype.initialize.apply(this, arguments);
  },

  calculateDescription: function() {
    var description;
    if (!this.parentStep) {
      // top step
      description = this.model.get('description');
    } else {
      // sub-step
      if (this.parentStep.steps.getModelAt(0) === this.model) {
        // first sub-step, use parent description
        description = this.parentStep.get('description');
      } else {
        // other sub-step, show type as description
        description = this.model.get('type'); // "LEFT_CLICK"
        description = description.replace(new RegExp('_', 'g'), ' '); // "LEFT CLICK"
        description = description.toLowerCase(); // "left click"
        description = iorad.base.Utils.capitalize(description); // "Left click"
        if (description === 'Left click') { // overrides
          description = 'Click';
        }
        var trKey = 'STEP_TYPES::' + description;
        if (i18next.exists(trKey)) {
          description = i18next.t(trKey);
        }
      }
    }
    description = description.replace(/\s{2,}/g, ' ');

    return iorad.player.views.step_description.prototype.calculateDescription.call(this, description);
  }

});

;
iorad.player.views.steps_quick_slide = iorad.base.View.extend({
  template: iorad.player.templates.steps_quick_slide,

  events: {
    'click .step-index': 'onStepIndexClick',
    'keypress .step-index': 'accessibilityButtonOnKeyPress',
  },

  initialize: function(options) {
    _.bindAll(this, 'render', 'showMarkers', 'resetMarkers', 'isCurrent', 'isVisualizerDisplayed');

    this.options = options || {};
    this.parentStep = this.options.parentStep;

    this.screenshotView = new iorad.player.views.step_screenshot({
      model: this.model
    });
    this.markerViews = [];

    this.descriptionView = new iorad.player.views.step_quick_description({
      model: this.model,
      parentStep: this.parentStep,
      disableStepsLinking: true
    });

    this.infotextView = new iorad.player.views.step_infotext({
      model: this.model,
      mode: 'quick',
      isCurrent: this.isCurrent,
      isVisualizerDisplayed: this.isVisualizerDisplayed,
    });

    const tutorialIsMobile = iorad.player.data.tutorial.get('isMobile');
    var stepImages = {
      READ: 'read',
      LEFT_CLICK: tutorialIsMobile ? 'left-click_mobile' : 'left-click',
      RIGHT_CLICK: tutorialIsMobile ? 'right-click_mobile' : 'right-click',
      TYPING: 'type',
      SCROLL: 'scroll',
      DRAG_AND_DROP: 'drag-n-drop',
      DRAG: 'drag-n-drop',
      DROP: 'drag-n-drop',
      HOVER: tutorialIsMobile ? 'hover_mobile' : 'hover',
      SELECT_TEXT: 'select-text',
    };
    Object.keys(stepImages).map(function(k) {
      stepImages[k] = (window.STATIC_ROOT || '') + 'images/base/steps/flat-white/' + stepImages[k] + '.svg';
    });
    this.stepImages = stepImages;
    this.initialSvgColor = '#fefefe';

    this.listenTo(this.screenshotView, 'load', this.updateBackground);
    this.listenTo(iorad.player.events, 'theme:applied', this.updateBackground);
    this.listenTo(this.screenshotView, 'load', this.positionImage);
    this.listenTo(iorad.player.events, 'ready:quick', this.positionImage); // when the quick mode dom is 'visible'
    this.listenTo(iorad.player.events, 'resize:quick', this.positionImage);

    this.listenTo(iorad.player.data.markerColors, 'change:' + this.model.get('type'), this.updateSvgStepIconColor);

    this.listenTo(iorad.player.controllers.screenshots, 'change:zoom', this.zoom);
  },

  getTopStepModel: function() {
    // Note: assumes we don't have more than one level of sub-steps
    return this.parentStep ? this.parentStep : this.model;
  },

  isNonFirstSubStep: function() {
    return this.parentStep && this.parentStep.steps.getModelAt(0) !== this.model;
  },

  _calculateNumber: function() {
    var number;

    // Note: index, instead that number, is not increased by sub-steps
    var topNumber = this.getTopStepModel().get('index') + 1;

    if (this.isNonFirstSubStep()) {
      // non-first sub-step, use parent number + letter
      // e.g. 1b for second sub-step of the first step
      // NOTE: this method won't work if there are more sub-steps than the letters of the alphabet!
      var position = this.parentStep.steps.indexOf(this.model); // sub-step position
      var letter = 'abcdefghijklmnopqrstuvwxyz'.charAt(position);
      number = topNumber + letter;
    } else {
      // normal number
      number = topNumber;
    }

    return number;
  },

  _shouldHaveIcon: function() {
    return true; // always show (#2390)
    // hidden for non-first sub-steps
    // return !this.parentStep || this.parentStep.steps.getModelAt(0) === this.model;
  },

  isCurrent: function() {
    var number = this._calculateNumber();
    const stepId = parseInt(number, 10);
    const currentStepId = iorad.player.data.stepsCollection.getCurrentStepNumber();
    return currentStepId === stepId;
  },

  hasInfotextVideo: function() {
    const stepModel = this.getTopStepModel();

    // for old tutorials
    let withVideo = false;
    if (stepModel && stepModel.isReadInfotext()) {
      if (!stepModel.get('event.infotextType')) {
        withVideo = stepModel.get('infotext.withVideo');
      } else if (stepModel.get('event.infotextType') === 'video') {
        const videoId = stepModel.get('videoId');
        withVideo = videoId != null;
      }
    }

    return withVideo;
  },

  isVisualizerDisplayed: function() {
    return this.isCurrent() && !this.hasInfotextVideo();
  },

  getTemplateData: function() {
    var templateData = iorad.base.View.prototype.getTemplateData.apply(this, arguments);

    var number = this._calculateNumber();
    var stepId = parseInt(number, 10);

    return _.extend(templateData, {
      number: number,
      total: iorad.player.data.stepsCollection.length,
      tutorialIsMobile: iorad.player.data.tutorial.get('isMobile'),
    });
  },

  render: function() {
    if (this.descriptionView) {
      // FIX IE11 "html disappearing" ISSUE
      this.descriptionView.$el.detach();
    }
    if (this.infotextView) {
      // FIX IE11 "html disappearing" ISSUE
      this.infotextView.$el.detach();
    }


    var videoVisualizerEl = this.$('.steptext .video-visualizer');
    if (videoVisualizerEl.length) videoVisualizerEl.detach();

    iorad.base.View.prototype.render.apply(this, arguments);

    this.$('.imgcontainer').append(this.screenshotView.$el);
    this.$('.stepimg').css('max-width', this.screenshotView.size.width + 'px');
    this.$('.description').append(this.descriptionView.$el);
    this.$('.step-infotext').replaceWith(this.infotextView.$el);

    if (videoVisualizerEl.length) {
      this.$('.steptext .video-visualizer').replaceWith(videoVisualizerEl);
    } else {
      this.videoVisualizerView = new iorad.player.views.step_video_visualizer({
        el: this.$('.steptext .video-visualizer'),
        mode: 'quick',
        parentStep: this.parentStep,
        wrapperEl: this.$('.steptext'),
        onUpdate: () => {
          this.updateStepText();
        },
        isCurrent: (...args) => {
          return this.isVisualizerDisplayed();
        },
      });
      this.videoVisualizerView.render();
    }

    this.resetMarkers();
    this.screenshotView.render();

    this.setSvgStepIcon();
    this.positionImage();

    return this;
  },

  updateStepText: function() {
    const isDisplay = this.videoVisualizerView.$el.hasClass('visible');

    this.$('.description').toggle(!isDisplay);
  },

  showMarkers: function(step) {
    // If it has no sub-steps OR if it is a summary of its substeps
    if (
      step.steps.length > 0 &&
      !step.get('summary') &&
      step.get('type') !== 'SCROLL' // ignore broken non-postprocessed SCROLL substeps (See https://github.com/iorad/iorad/issues/12775)
    ) {
      step.steps.each(this.showMarkers);
    } else {
      var markerView = iorad.player.views.MarkerFactory.create(step.get('type'), {
        model: step,
        slideView: this
      });
      this.$('.markers').append(markerView.$el);
      markerView.render(); // to execute after append since has to do layout size calculations!

      this.markerViews.push(markerView);
    }
  },

  resetMarkers: function() {
    _.invoke(this.markerViews, 'remove');
    this.markerViews = [];
    this.showMarkers(this.model);
  },

  loadStepIcon: function(type) {
    var that = this;

    iorad.player.stepIconData = iorad.player.stepIconData || {}; // <icon type, promise(icon image data)>
    if (!iorad.player.stepIconData[type]) {
      iorad.player.stepIconData[type] = new Promise(function(resolve) {
        $.get(that.stepImages[type], function(data) {
          var $svg = $('svg', data);
          resolve($svg);
        });
      });
    }
    return iorad.player.stepIconData[type];
  },

  setSvgStepIcon: function() {
    var $step = this.$('.steptext');
    if ($step.has('svg').length) return;
    var that = this;
    var type = this.model.get('type');
    var markerColorDefault = iorad.player.data.markerColors.defaults()[type];
    var customColor = iorad.player.data.markerColors.get(type) || markerColorDefault;
    this.loadStepIcon(type).then(function($svg) {
      $svg = $svg.clone(true);
      $svg.find('[fill="' + that.initialSvgColor + '"]').each(function() {
        $(this).attr('fill', customColor).addClass('customFill');
      });
      $svg.find('[stroke="' + that.initialSvgColor + '"]').each(function() {
        $(this).attr('stroke', customColor).addClass('customFill');
      });
      $svg.addClass(type + ' icon' + (that._shouldHaveIcon() ? '' : ' hidden'));
      $svg.toggleClass('tutorialIsMobile', Boolean(iorad.player.data.tutorial.get('isMobile')));
      $step.prepend($svg);
      that.stepIconRendered && that.stepIconRendered($svg);
    });
  },

  updateSvgStepIconColor: function() {
    var type = this.model.get('type');
    var markerColorDefault = iorad.player.data.markerColors.defaults()[type];
    var customColor = iorad.player.data.markerColors.get(type) || markerColorDefault;

    var $svg = this.$('svg.icon');
    $svg.find('.customFill').each(function() {
      $(this).attr('fill', customColor);
    });
    $svg.find('.customStroke').each(function() {
      $(this).attr('stroke', customColor);
    });
  },

  updateBackground: function () {
    const currentTheme = iorad.player.data.themesCollection.get(
      iorad.player.data.tutorial.get('theme')
    );

    const dynamicBackgroundEnabled = currentTheme ?
      currentTheme.get('dynamicBackgroundEnabled')
      : false;

    const backgroundColor = dynamicBackgroundEnabled ?
      this.screenshotView.getCommonColour()
      :
      ((currentTheme && currentTheme.get('staticBackground')) || '');

    this.$('.stepimg').css('background-color', backgroundColor);
  },

  positionImage: function() {
    var bounds = this.model.get('marker.bounds');
    var MARGIN = 80;
    var imgHeight = Math.max(this.getMinImgHeight(), (bounds && bounds.height) ? bounds.height + (MARGIN * 2) : 0) / this.getImgScale();
    this.$('.stepimg').height(imgHeight);

    iorad.player.helpers.positioning.image(this.model, this.$el, {
      minSpace: MARGIN,
      hammerit: this.useHammerit(),
    });
  },

  getImgScale: function() {
    return 1;
  },

  // NOTE: this is the non-scaled amount (the scale is applied separately)
  getMinImgHeight: function() {
    return 500;
  },

  useHammerit: function() {
    return true;
  },

  zoom: function() {
    var hammertimeData = this.$('.imgcontainer').data('hammertime');
    if (hammertimeData) {
      hammertimeData.zoomTo(
        iorad.player.controllers.screenshots.getCurrentZoom()
      );
      hammertimeData.update();
    }
  },

  onStepIndexClick: function () {
    iorad.player.router.playbarView.setPlaybarPopupPosition(null, iorad.player.router.stepsView);
    // iorad.player.router.togglePlayerPopup(true);
    iorad.player.router.stepsView.toggle();
  },

  accessibilityButtonOnKeyPress: iorad.base.Utils.accessibilityButtonOnKeyPress,
});

;
iorad.player.views.steps_print_step = iorad.player.views.steps_quick_step.extend({

  getSlideViewType: function() {
    return iorad.player.views.steps_print_slide;
  },
  getStepListViewType: function() {
    return iorad.player.views.steps_print_step_list;
  },

});

;
/* Print-view is just a quick-view modified with some quirks to make it print correctly, like 
   replacing background-images with images tag, since they are not printed by default,
   or events that notify when all the images have been loaded, to not trigger the print too early. */

iorad.player.views.steps_print_step_list = iorad.player.views.steps_quick_step_list_default.extend({
  itemView: iorad.player.views.steps_print_step,

  // disable chaplin fade-in animation for view showing (#1919)
  animationDuration: 0

});
;
iorad.player.views.steps_print_slide = iorad.player.views.steps_quick_slide.extend({
  template: iorad.player.templates.steps_print_slide,

  initialize: function() {
    iorad.player.views.steps_quick_slide.prototype.initialize.apply(this, arguments);
    this.stopListening(iorad.player.events, 'ready:quick');

    this.listenTo(iorad.player.events, 'ready:print', this.positionImage); // when the print mode dom is 'visible'
  },

  render: function() {
    iorad.player.views.steps_quick_slide.prototype.render.apply(this, arguments);

    return this;
  },

  stepIconRendered: function($svg) {
    var iconEl = this.$('span.icon');
    var image = document.createElement('img');

    if (iorad.player.controllers.clientDetect.browser.isIE) {
      // IE doesn't support SVGs in PDF because of the getUrlImageData call
      // => use default JPG instead
      var backgroundImageUrl = (/^url\((['"]?)(.*)\1\)$/.exec(iconEl.css('background-image')) || [])[2];
      image.src = backgroundImageUrl;
    } else {
      var xml = (new XMLSerializer).serializeToString($svg[0]);
      image.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(xml);
    }

    image.className = iconEl[0].className;
    iconEl.replaceWith(image);
  },

  getImgScale: function() {
    return 0.6250;
  },

  getMinImgHeight: function() {
    return 250;
  },

  useHammerit: function() {
    return false;
  },

});

;
iorad.player.views.step_mobile_description = iorad.player.views.step_description.extend({

  initialize: function(options) {
    options = options || {};

    this.parentStep = options.parentStep;

    iorad.player.views.step_description.prototype.initialize.apply(this, arguments);
  },

  calculateDescription: function() {
    var description;
    if (!this.parentStep) {
      // top step
      description = this.model.get('description');
    } else {
      // sub-step
      if (this.parentStep.steps.getModelAt(0) === this.model) {
        // first sub-step, use parent description
        description = this.parentStep.get('description');
      } else {
        // other sub-step, show type as description
        description = this.model.get('type'); // "LEFT_CLICK"
        description = description.replace(new RegExp('_', 'g'), ' '); // "LEFT CLICK"
        description = description.toLowerCase(); // "left click"
        description = iorad.base.Utils.capitalize(description); // "Left click"
        if (description === 'Left click') { // overrides
          description = i18next.t('Click');
        }
      }
    }

    if (description) {
      // remove linebreaks
      description = description.replace(/<br(\s*?)\/?>/ig, '&nbsp;');
    }

    return iorad.player.views.step_description.prototype.calculateDescription.call(this, description);
  }

});
;
// Note: the screenshot is lazy rendered to prevent freezing in case of tutorials with many steps.
iorad.player.views.steps_mobile_slide = iorad.base.View.extend({
  template: iorad.player.templates.steps_mobile_slide,
  className: 'step tut-step',

  events: {
    'mousedown a': 'onAnchorMouseDown',
    'click .prev': 'onPrev',
    'click .next': 'onNext',
    'click .count': 'onCountClick',
    'click .toggleCollapse': 'onToggleCollapseClick',

    'keypress .count': 'accessibilityButtonOnKeyPress',
    'keypress .toggleCollapse': 'accessibilityButtonOnKeyPress',

    'mouseenter .steptext-header': 'onSteptextHeaderMouseEnter',
    'mouseleave .steptext-header': 'onSteptextHeaderMouseLeave',
    'dblclick .steptext-header': 'onSteptextHeaderDblClick',
  },

  initialize: function(options) {
    options = options || {};
    this.options = options;

    this.parentStep = options.parentStep;

    this.tutorial = iorad.player.data.tutorial;

    this.screenshotView = new iorad.player.views.step_screenshot(); // (step setted later since causes render)
    this.markerViews = [];

    this.descriptionView = new iorad.player.views.step_mobile_description({
      model: this.model,
      parentStep: this.parentStep,
    });

    this.listenTo(this.screenshotView, 'load', this.updateBackground);
    this.listenTo(iorad.player.events, 'theme:applied', this.updateBackground);
    this.listenTo(this.screenshotView, 'load', this.positionImage);
    this.listenTo(iorad.player.events, 'ready:mobilequick', this.ifCurrent(this.positionImage.bind(this)));
    this.listenTo(iorad.player.events, 'resize:mobilequick', this.ifCurrent(this.positionImage.bind(this)));
    this.listenTo(iorad.player.events, 'update:playbar', this.ifCurrent(this.updateStepText.bind(this))); // for the step progress animation

    this.listenTo(iorad.player.controllers.screenshots, 'change:zoom', this.zoom);
    this.listenTo(iorad.player.controllers.views, 'collapseStepPanel uncollapseStepPanel', this.onStepPanelCollapseToggled);

    this.listenTo(this.model, 'scale', this.resetMarkers);
    this.listenTo(iorad.player.events, 'device:desktop', function() {
      // put back original scale
      if (this.markerViews.length > 0) {
        // NOTE: assumes no sub-steps
        var markerBounds = this.markerViews[0].getBounds();
        this.model.setScale(1, markerBounds);
      }
    });
    this.listenTo(
      iorad.player.events,
      'slide_fully_initialized',
      this.disableTabIndexesIfNotCurrent
    );
  },

  ifCurrent: function (fn) {
    return function () { // non-anonymous function to use called "this"
      if (this.options.isCurrent()) {
        // OPTIMIZATION: only run in current slide
        fn();
      }
    };
  },

  // call this to prepare the view for display,
  // i.e. render screenshot if needed and update its position on screen.
  prepareForDisplay: function() {
    if (!this.screenshotView.hasStep()) {
      // (will also cause screenshot render,
      // positionImage automatically provided by load callback)
      this.screenshotView.setStep(this.model);
    } else {
      // just readjust screenshot position
      this.positionImage();
    }
  },

  getTopStepModel: function() {
    // Note: assumes we don't have more than one level of sub-steps
    return this.parentStep ? this.parentStep : this.model;
  },

  isNonFirstSubStep: function() {
    return this.parentStep && this.parentStep.steps.getModelAt(0) !== this.model;
  },

  calculateNumber: function() {
    var number;

    var topNumber = this.getTopStepModel().get('index') + 1;

    if (this.isNonFirstSubStep()) {
      // non-first sub-step, use parent number + letter
      // e.g. 1b for second sub-step of the first step
      // NOTE: this method won't work if there are more sub-steps than the letters of the alphabet!
      var position = this.parentStep.steps.indexOf(this.model); // sub-step position
      var letter = 'abcdefghijklmnopqrstuvwxyz'.charAt(position);
      number = topNumber + letter;
    } else {
      // normal number
      number = topNumber;
    }

    return number;
  },

  getTemplateData: function() {
    var templateData = iorad.base.View.prototype.getTemplateData.apply(this, arguments);
    return _.extend(templateData, {
      number: this.calculateNumber(),
      total: iorad.player.data.stepsCollection.length,
      copyright: iorad.player.controllers.views.getCopyright(),
    });
  },

  render: function() {
    if (this.descriptionView) {
      // FIX IE11 "html disappearing" ISSUE
      this.descriptionView.$el.detach();
    }

    var videoVisualizerEl = this.$('.video-visualizer');
    if (videoVisualizerEl.length) videoVisualizerEl.detach();

    iorad.base.View.prototype.render.apply(this, arguments);

    this.$('.steptext').draggable({
      handle: '.steptext-header',
      containment: this.$el,
      scroll: true,
      scrollSensitivity: 10,
      scrollSpeed: 10,
    });

    this.$('.imgcontainer').append(this.screenshotView.$el);
    this.$('.description-container').append(this.descriptionView.$el);
    if (videoVisualizerEl.length) {
      this.$('.video-visualizer').replaceWith(videoVisualizerEl);
    } else {
      this.videoVisualizerView = new iorad.player.views.step_video_visualizer({
        el: this.$('.video-visualizer'),
        mode: 'mobilequick',
        parentStep: this.parentStep,
        wrapperEl: this.$('.steptext'),
        onUpdate: () => {
          this.updateStepText();
        },
        isCurrent: (...args) => {
          const stepModel = this.getTopStepModel();

          // for old tutorials
          let withVideo = false;
          if (stepModel && stepModel.isReadInfotext()) {
            if (!stepModel.get('event.infotextType')) {
              withVideo = stepModel.get('infotext.withVideo');
            } else if (stepModel.get('event.infotextType') === 'video') {
              withVideo = true;
            }
          }

          return (
            this.options.isCurrent(...args) &&
            !(
              withVideo
            )
          );
        },
      });
      this.videoVisualizerView.render();
    }

    this.resetMarkers();
    this.disableTabIndexesIfNotCurrent();

    return this;
  },

  drawMarkers: function($container, step) {
    var markers = [];
    // If it has no sub-steps OR if it is a summary of its substeps
    if (
      step.steps.length > 0 &&
      !step.get('summary') &&
      step.get('type') !== 'SCROLL' // ignore broken non-postprocessed SCROLL substeps (See https://github.com/iorad/iorad/issues/12775)
    ) {
      step.steps.each(subStep => this.showMarkers(subStep));
    } else {
      var markerView = iorad.player.views.MarkerFactory.create(step.get('type'), {
        model: step,
        slideView: this
      });
      $container.append(markerView.$el);
      markerView.render(); // to execute after append since has to do layout size calculations!

      markers.push(markerView);
    }
    return markers;
  },

  showMarkers: function(step) {
    this.markerViews = this.markerViews.concat(
      this.drawMarkers(this.$('.markers'), step)
    );
  },

  resetMarkers: function() {
    _.invoke(this.markerViews, 'remove');
    this.markerViews = [];
    this.showMarkers(this.model);
  },

  updateBackground: function () {
    const currentTheme = iorad.player.data.themesCollection.get(
      iorad.player.data.tutorial.get('theme')
    );

    const dynamicBackgroundEnabled = currentTheme ?
      currentTheme.get('dynamicBackgroundEnabled')
      : false;

    const backgroundColor = dynamicBackgroundEnabled ?
      this.screenshotView.getCommonColour()
      :
      ((currentTheme && currentTheme.get('staticBackground')) || '');

    this.$('.stepimg').css('background-color', backgroundColor);
  },

  positionImage: function() {
    this.adjust();

    // adjust viewport size
    // todo: eliminate redundant triggering
    var adjustViewport = _.bind(function() {
      var stepimg = this.$('.stepimg');
      if (stepimg.length == 0) return; // too early
      if (stepimg.height() < 0) return; // the markup is still updating, e.g. after a resize that changed the device type (responsiveness)

      this.$('.imgcontainer').css({
        width: this.screenshotView.size.width + 'px',
        height: this.screenshotView.size.height + 'px'
      });

      // also adjust markers position
      _.each(this.markerViews, function(markerView) {
        markerView.updateBounds();
      });

      iorad.player.helpers.positioning.image(this.model, this.$el, {
        hammerit: true,
      });

      this.calculateViewportContrast();

      this.updateStepText();

      iorad.player.events.trigger('mobile:positionImage');
      return true;
    }, this);
    // in the worst case, the layout is broken (i.e. after modal closing)
    // and the first call just causes a reflow that fixes it,
    // so the viewport adjusting will be done in the broken layout and will be incorrect
    if (adjustViewport()) {
      // HACK: call it again after some time to adjust the viewport on the unbroken layout
      setTimeout(adjustViewport, 1000);
    }
  },

  updateStepText: function () {
    const floatingStepText = (
      this.videoVisualizerView.$el.hasClass('visible')
    );
    if (floatingStepText) {
      this.$('.steptext').addClass('floating').draggable('enable');
    } else {
      this.$('.steptext').removeClass('floating').draggable('disable').css({
        position: '',
        top: '',
        left: '',
      });
    }

    if (
      iorad.player.router &&
      iorad.player.router.playbarView
    ) {
      const playbarTemplateData = iorad.player.router.playbarView.templateData;
      if (
        playbarTemplateData &&
        !playbarTemplateData.isStepProgressBtnHidden &&
        !playbarTemplateData.isStepProgressAnimationHidden
      ) {
        this.$('.steptext-header .step-progress-animation-overlay').css({
          width: `${playbarTemplateData.stepProgressPercent || 0}%`,
        });
      } else {
        this.$('.steptext-header .step-progress-animation-overlay').css({
          width: 0,
        });
      }
    }

    const dragHandlerVisible = floatingStepText;
    this.$('.steptext-header .dragHandler').toggle(Boolean(dragHandlerVisible));

    const countVisible = (
      !this.tutorial.getLayoutOption('is_step_counter_disabled')
    );
    this.$('.steptext-header .count').toggle(Boolean(countVisible));

    const toggleCollapseVisible = true;
    this.$('.steptext-header .toggleCollapse')
      .toggleClass('hidden', Boolean(!toggleCollapseVisible))
      .toggleClass('collapsed', Boolean(iorad.player.controllers.views.isStepPanelCollapsed()))
      .attr('aria-label', (iorad.player.controllers.views.isStepPanelCollapsed() ? 'Expand' : 'Collapse') + ' Step Text Panel');

    this.$('.steptext-header').toggle(Boolean(
      dragHandlerVisible ||
      countVisible ||
      toggleCollapseVisible
    ));
  },

  onSteptextHeaderMouseEnter: function () {
    this.$('.steptext-header').addClass('hovering');
    iorad.player.events.trigger('mobile-slide:header:hovering', true);
  },

  onSteptextHeaderMouseLeave: function () {
    this.$('.steptext-header').removeClass('hovering');
    iorad.player.events.trigger('mobile-slide:header:hovering', false);
  },

  onSteptextHeaderDblClick: function () {
    iorad.player.controllers.views.toggleExpandStepPanel();
  },

  // NOTE: this depends heavily on the specific hammerIt implementation
  calculateViewportContrast: function() {
    return; // NOT NEEDED ANYMORE AND IS SLOW (see #13181)

    // var imgcontainer = this.$('.imgcontainer');
    // var contentWidth = imgcontainer.width();
    // var contentHeight = imgcontainer.height();

    // // translate3d(-697px, -351.404px, 0px) scale3d(0.273958, 0.273958, 1)
    // var transform = imgcontainer.css('transform') || '';
    // var match = transform.match(/translate3d\((.+), (.+), (.+)\) scale3d\((.+), (.+), 1\)/) || [];
    // var posX = parseFloat(match[1]) || 0;
    // var posY = parseFloat(match[2]) || 0;
    // var scale = parseFloat(match[4]) || 1;

    // // from calculateShift
    // var scaledContentWidth = (contentWidth * scale);
    // var scaledContentHeight = (contentHeight * scale);
    // var shift = {
    //   x: (scaledContentWidth >= contentWidth)
    //     ? (scaledContentWidth - contentWidth) / 2
    //     : -((contentWidth - scaledContentWidth) / 2),
    //   y: (scaledContentHeight >= contentHeight)
    //     ? (scaledContentHeight - contentHeight) / 2
    //     : -((contentHeight - scaledContentHeight) / 2),
    // };

    // var left = posX - shift.x;
    // var top = posY - shift.y;

    // var viewport = this.$('.stepimg');
    // var viewportWidth = viewport.width();
    // var viewportHeight = viewport.height();

    // var canvas = this.$('.imgcontainer canvas')[0];

    // // TODO: memoize? this is expensive and gets called a lot
    // var colorVarHex = iorad.base.Utils.mostDominantColor(
    //   canvas,
    //   left,
    //   top,
    //   Math.min(
    //     contentWidth,
    //     viewportWidth
    //   ),
    //   Math.min(
    //     contentHeight,
    //     viewportHeight
    //   )
    // );
    // var contrastColorHex = iorad.base.Export.getContrastColor(colorVarHex);
    // this.$('.stepimg .prev svg path, .stepimg .next svg path').css('stroke', contrastColorHex);
  },

  // scales the image and focuses on marker
  adjust: function() {
    this.scaleImage();
  },

  // scales the image so marker could be fully visible
  scaleImage: function() {
    if (
      !iorad.player.device ||
      iorad.player.device === 'desktop' ||
      this.markerViews.length === 0
    ) {
      return;
    }

    var minScale = 0.5;
    var margin = 80;

    var $image = this.$('.stepimg');

    var imageSize = {
      width: $image.width(),
      height: $image.height(),
    };

    // NOTE: assumes no sub-steps
    var markerBounds = this.markerViews[0].getBounds();
    var originalMarkerBounds = this.model.originalMarkerBounds(markerBounds);

    var requiredScaleWidth = imageSize.width / (originalMarkerBounds.width + margin);
    var requiredScaleHeight = imageSize.height / (originalMarkerBounds.height + margin);

    // choose smaller scale, but not less than minScale
    var requiredScale = _.max([
      _.min([requiredScaleHeight, requiredScaleWidth, 1]),
      minScale,
    ]);

    this.model.setScale(requiredScale, markerBounds);
  },

  onPrev: function() {
    iorad.player.events.trigger('mobilequick:back');
  },

  onNext: function() {
    iorad.player.events.trigger('mobilequick:next');
  },

  zoom: function() {
    var hammertimeData = this.$('.imgcontainer').data('hammertime');
    if (hammertimeData) {
      hammertimeData.zoomTo(
        iorad.player.controllers.screenshots.getCurrentZoom()
      );
      hammertimeData.update();
    }
  },

  onCountClick: function () {
    iorad.player.router.playbarView.setPlaybarPopupPosition(null, iorad.player.router.stepsView);
    // iorad.player.router.togglePlayerPopup(true);
    iorad.player.router.stepsView.toggle();
  },

  onToggleCollapseClick: function () {
    iorad.player.controllers.views.toggleCollapseStepPanel();
  },

  onStepPanelCollapseToggled: function () {
    // reset position
    this.$('.steptext').css({
      'position': '',
      'top': '',
      'left': '',
      'height': '',
    });
  },

  onAnchorMouseDown: function (event) {
    var anchorEl = $(event.currentTarget);

    // select the anchor text to make mobile copying easier
    var selection = window.getSelection();
    var range = window.document.createRange();
    range.selectNodeContents(anchorEl[0]);
    selection.removeAllRanges();
    selection.addRange(range);
  },

  disableTabIndexesIfNotCurrent: function () {
    const isCurrentStep = this.options.isCurrent();
    this.$('.count').attr('tabindex', isCurrentStep ? 0 : -1);
    this.$('.toggleCollapse').attr('tabindex', isCurrentStep ? 0 : -1);
    this.$('.typingTool').attr('tabindex', isCurrentStep ? 0 : -1);
  },

  accessibilityButtonOnKeyPress: iorad.base.Utils.accessibilityButtonOnKeyPress,
});

;
iorad.player.views.steps_mobile_slide_list = iorad.base.View.extend({

  initialize: function() {
    _.bindAll(this,
      'render', 'onStart', 'initSlider',
      'onSlideChange', 'onPrev', 'onNext', 'onStartOver', 'onResize');

    this.slideViews = [];
    this.winEl = $(window);

    this.infotextView = new iorad.player.views.step_infotext({
      collection: this.collection,
      mode: 'mobilequick',
    });
    this.$el.parent().children('.step-infotext').replaceWith(this.infotextView.$el);

    this.listenTo(iorad.player.events, 'mobilequick:back', this.onPrev);
    this.listenTo(iorad.player.events, 'mobilequick:next', this.onNext);
    this.listenTo(iorad.player.events, 'mobilequick:goTo', this.goToSlide);
    this.listenTo(iorad.player.events, 'restart:mobilequick', this.onStartOver);

    // show the view.
    // this is needed because the view doesn't have its own template,
    // the html is directly embedded in the container.tpl (bad)
    // and we want to avoid to show content (like finished slide)
    // before the view is actually loaded (with data ready).
    this.$el.show();

    this.listenToOnce(iorad.player.events, "slide_fully_initialized", function() {
      this.winEl.on('resize', this.onResize);
      this.listenTo(iorad.player.events, "ready", this.onResize);
      this.listenTo(this.model, 'change', this.onResize);
      this.listenTo(this.model, 'change', this.adjustNavButtons);

      this.listenTo(iorad.player.events, 'slide_start', this.onStart);
      this.listenTo(iorad.player.events, 'slide_restart', this.onStartOver);

      this.adjustNavButtons();
    });
    this.listenTo(iorad.player.events, "slide_fully_initialized", this.onResize);

    this.listenTo(this.collection, 'reset', this.render);
    this.render();

    this.listenTo(iorad.player.events, 'sound:load', this._onSoundLoad);
    this.listenTo(iorad.player.events, 'video:load', this._onVideoLoad);
    if (iorad.player.controllers.clientDetect.os.isIOS) {
      this.listenToOnce(iorad.player.events, 'sound:end', this._onSoundEnd);
      this.listenToOnce(iorad.player.events, 'video:end', this._onVideoEnd);
    }

    this.listenTo(iorad.player.events, 'mobile:positionImage', this.adjustNavButtons);
    this.listenTo(iorad.player.events, 'mobile:positionImage', this.adjustStepInfotext);
  },

  _onSoundLoad: function(sound) {
    this.sound = sound;
    if (iorad.player.controllers.clientDetect.os.isIOS) {
      if (Howler._iOSEnabled) {
        // this.sound.play();
      }
    } else {
      // this.sound.play();
    }
  },

  _onVideoLoad: function(video) {
    this.video = video;
    if (iorad.player.controllers.clientDetect.os.isIOS) {
      // this.video.play();
    } else {
      // this.video.play();
    }
  },

  _onSoundEnd: function() {
    this.soundPlayedOnce = true;
    this.autoAdvanceNext && this.onNext();
    this.autoAdvancePrev && this.onPrev();
  },

  _onVideoEnd: function() {
    this.videoPlayedOnce = true;
    this.autoAdvanceNext && this.onNext();
    this.autoAdvancePrev && this.onPrev();
  },

  notifyFullyInitialized: function() {
    this.fullyInitialized = true;
    this.initSlider();
    iorad.player.events.trigger('slide_fully_initialized');
  },

  // Composite steps have one slide per child step.
  createSlideViews: function(stepsCollection, parentStep) {
    var slideViews = [];

    stepsCollection.each(_.bind(function(stepModel) {
      if (
        stepModel.steps.length &&
        !stepModel.get('summary') &&
        stepModel.get('type') !== 'SCROLL' // ignore broken non-postprocessed SCROLL substeps (See https://github.com/iorad/iorad/issues/12775)
      ) {
        var childStepsSlideViews = this.createSlideViews(stepModel.steps, stepModel);
        Array.prototype.push.apply(slideViews, childStepsSlideViews);
      } else {
        var slideView = new iorad.player.views.steps_mobile_slide({
          model: stepModel,
          parentStep: parentStep,
          isCurrent: () => {
            if (!this.$el.getCurrentSlide) return false;
            var current = this.$el.getCurrentSlide();
            var currentStepSlide = this.slideViews[current];
            return slideView === currentStepSlide;
          },
        });
        slideViews.push(slideView);
      }
    }, this));

    return slideViews;
  },

  render: function() {
    _.defer(_.bind(function() {
      _.defer(_.bind(function() {
        _.each(this.slideViews, function(view) {
          view.remove();
        });
        this.slideViews = this.createSlideViews(this.collection);
        _.each(this.slideViews, _.bind(function(slideView) {
          slideView.$el.insertBefore($('.finished', this.$el));
          slideView.render();

          if (this.slideViews.indexOf(slideView) === (this.slideViews.length - 1)) {
            setTimeout(_.bind(function() {
              this.notifyFullyInitialized();
            }, this), 2000);
          }

        }, this));

        if (this.slideViews.length === 0) {
          // 0-steps tutorial
          this.notifyFullyInitialized();
        }
      }, this));
      _.defer(_.bind(this.initSlider, this));
    }, this));

    return this;
  },

  initSlider: function() {
    this.$el.bxSlider({
      startSlide: (this.fullyInitialized && !this.initSlideIndex) ? iorad.player.data.stepsCollection.position : this.initSlideIndex,
      touchEnabled: true,
      infiniteLoop: false,
      hideControlOnEnd: true,
      pager: false,
      slideSelector: 'div.step',
      auto: false,
      preloadImages: false, // NOTE: customlib option value!
      swipeThreshold: 80,
      adaptiveHeight: true,
      adaptiveHeightSpeed: 0,
      preventDefaultSwipeY: true,
      preventDefaultSwipeX: true,
      controls: false,
      onSlideBefore: _.bind(this.onSlideChange, this), // just before each transition
      onSlideAfter: _.bind(function () {
        this.onSlideChange();// just after each transition (workaround for invisible marker on startover on Chrome)
        this.slideViews.forEach((slideView) => {
          slideView.disableTabIndexesIfNotCurrent();
        });
      }, this)
    });

    this.onSlideChange();

    if (this.initSlideIndex && this.fullyInitialized) {
      _.defer(_.bind(function() {
        this.$el.goToSlide(this.initSlideIndex);
        delete this.initSlideIndex;
      }, this));
    }
  },

  goToSlide: function(index) {
    if (this.$el.goToSlide) {
      this.$el.goToSlide(index);
    } else {
      this.initSlideIndex = index;
    }
  },

  onStart: function() {
    //console.log('onstart: steps_mobile_slide_list, will go to slide 1');
    this.$el.goToSlide(0);
    return false;
  },

  onPrev: function() {
    console.log('onPrev');
    setTimeout(_.bind(function() {
      if (iorad.player.controllers.clientDetect.os.isIOS) {
        if (
          this.sound &&
          Howler._iOSEnabled &&
          !this.soundPlayedOnce
        ) {
          this.autoAdvancePrev = true;
          // this.sound.play();
          return;
        }
        if (
          this.video &&
          !this.videoPlayedOnce
        ) {
          this.autoAdvancePrev = true;
          // this.video.play();
          return;
        }
      }

      if (this.collection.getCurrentStepNumber() === 1) {
        console.log('currentstep is 1');
        iorad.player.controllers.views.setCoverOpen(true, false, true);
      } else {
        var total = this.$el.getSlideCount();
        var prev = this.$el.getCurrentSlide() - 1;
        var prevStepSlide = null;
        if (prev >= 0 && prev <= total - 2) { // "next" also takes into account the "finished" slide
          prevStepSlide = this.slideViews[prev];
        }
        if (prevStepSlide) {
          var topStepNumber = prevStepSlide.getTopStepModel().get('index') + 1;
          var topStepModel = this.collection.getModelAt(topStepNumber - 1);
          if (topStepModel && topStepModel.get('event.quizStarter') && !iorad.player.router.isQuizTabAvailable()) {
            // skip quizStarter step
            var prevBefore = prev - 1;
            if (prevBefore >= 0 && prevBefore <= total - 2) {
              this.$el.goToSlide(prevBefore);
              return;
            }
          }
        }
        this.$el.goToPrevSlide();
      }
    }, this), 0);
    return false;
  },

  onNext: function() {
    console.log('onNext');
    setTimeout(_.bind(function() {
      if (iorad.player.controllers.clientDetect.os.isIOS) {
        if (
          this.sound &&
          Howler._iOSEnabled &&
          !this.soundPlayedOnce
        ) {
          this.autoAdvanceNext = true;
          // this.sound.play();
          return;
        }
        if (
          this.video &&
          !this.videoPlayedOnce
        ) {
          this.autoAdvanceNext = true;
          // this.video.play();
          return;
        }
      }

      var total = this.$el.getSlideCount();
      var next = this.$el.getCurrentSlide() + 1;
      var nextStepSlide = null;
      if (next >= 0 && next <= total - 2) { // "next" also takes into account the "finished" slide
        nextStepSlide = this.slideViews[next];
      }
      if (nextStepSlide) {
        var topStepNumber = nextStepSlide.getTopStepModel().get('index') + 1;
        var topStepModel = this.collection.getModelAt(topStepNumber - 1);
        if (topStepModel && topStepModel.get('event.quizStarter') && !iorad.player.router.isQuizTabAvailable()) {
          // skip quizStarter step
          var nextAfter = next + 1;
          if (nextAfter >= 0 && nextAfter <= total - 2) {
            this.$el.goToSlide(nextAfter);
            return;
          }
        }
      }

      this.$el.goToNextSlide();

    }, this), 0);
    return false;
  },

  onStartOver: function() {
    this.$el.goToSlide(0);
    return false;
  },

  onSlideChange: function() {
    var total = this.$el.getSlideCount();
    var current = this.$el.getCurrentSlide();

    $('#toggle-description').removeClass('collapsed');

    if (current === total - 1) { // current is 0-indexed!
      // we are on finished slide
      iorad.player.events.trigger('slide_stop_with_no_index');
    }

    var currentStepSlide = null;
    if (current >= 0 && current <= total-2) { // "current" also takes into account the "finished" slide
      currentStepSlide = this.slideViews[current];
    }

    // (lazy) render item image (allows also the setting of the image position since now its dom is 'visible')
    if (currentStepSlide) {
      var topStepNumber = currentStepSlide.getTopStepModel().get('index') + 1;
      this.collection.setCurrentStep(topStepNumber);
      iorad.player.router.navigate('#mobilequick-' + topStepNumber);

      this.prepareForDisplay(current);
    } else {
      if (current === 0) {
        // we are on start slide
        iorad.player.router.navigate('/');
      } else if (current === total - 1) {
        // we are on finished slide
        iorad.player.router.navigate('#finished');
      }
    }

    this.adjustNavButtons();

    this.trigger('slideChange', current);
  },

  // Prepare for display the slide that is being displayed
  // or the ones that might be displayed after (e.g. by means of next/back button).
  // This way we achieve lazy loading of screenshots instead that preloading everything on start
  // and thus we avoid freezing in case of tutorials with many steps.
  prepareForDisplay: function(current) {
    var currentStepSlide = this.slideViews[current];
    var nextStepSlide = this.slideViews[current + 1];
    var previousStepSlide = this.slideViews[current - 1];

    if (currentStepSlide) currentStepSlide.prepareForDisplay();
    if (nextStepSlide) nextStepSlide.prepareForDisplay();
    if (previousStepSlide) previousStepSlide.prepareForDisplay();
  },

  adjustNavButtons: function() {
    if (!this.fullyInitialized) return;
    var current = this.$el.getCurrentSlide();
    var total = this.$el.getSlideCount();
    var finish = current === total - 1;

    this.infotextView.$el[finish ? 'addClass' : 'removeClass']('finish');
    $('#navi')[finish ? 'addClass' : 'removeClass']('finish');
  },

  // adjust the .step-infotext to cover img only (including padding)
  // NOTE: it is outside the slide
  adjustStepInfotext: function () {
    var current = this.$el.getCurrentSlide();
    var total = this.$el.getSlideCount();
    if (current >= 0 && current <= total - 2) { // "current" also takes into account the "finished" slide
      var currentStepSlide = this.slideViews[current];
      if (currentStepSlide) {
        var stepimg = currentStepSlide.$('.stepimg');
        var stepInfotext = $('.mobile-quickview .step-infotext');
        if (stepimg[0] && stepInfotext[0]) {
          var stepimgBounds = stepimg[0].getBoundingClientRect();
          var stepInfotextBounds = stepInfotext[0].getBoundingClientRect();
          var height = stepimgBounds.height + (stepimgBounds.y - stepInfotextBounds.y);
          stepInfotext.css({
            height: height + 'px',
          });
        }
      }
    }
  },

  onResize: _.throttle(function() {
    var bH = this.winEl.height() - $('#header').outerHeight() - $('#header').offset().top; // offset required for optional translate bar

    var cH = bH;

    this.$('.finished').height(bH);
    this.$('.cover').height(cH);
    this.$('.cover .overlay').height(cH);
  }, 500)

});

;
iorad.player.views.step_infotext = iorad.base.View.extend({
  template: iorad.player.templates.step_infotext,
  className: 'step-infotext',

  events: {
    'click': 'onClick',

    'click a': 'openLink',

    'click .step-infotext_prev': 'onPrevClick',
    'click .step-infotext_next': 'onNextClick',
  },

  initialize: function (options) {
    iorad.base.View.prototype.initialize.apply(this, arguments);
    options = options || {};
    this.options = options;

    this.disableStepsLinking = options.disableStepsLinking || false;

    this.tutorial = iorad.player.data.tutorial;
    this.themesCollection = iorad.player.data.themesCollection;

    this.titleOverride = undefined;
    this.textOverride = undefined;

    if (!this.model) {
      this.listenTo(this.collection, 'changeCurrent', this.onChangeCurrent);
      this.listenTo(iorad.player.events, 'router:dataReady', this.onChangeCurrent);
      this.listenTo(iorad.player.events, 'ready', this.onChangeCurrent);
      this.listenTo(iorad.player.events, 'video:display', this.onChangeCurrent);
    } else {
      this.listenTo(iorad.player.events, 'router:dataReady', this.update);
      this.listenTo(iorad.player.events, 'ready', this.update);
      this.listenTo(iorad.player.events, 'video:display', this.update);
    }

    this.listenTo(this.tutorial, 'change:theme', this.updateStyle);
    this.listenTo(this.themesCollection, 'add remove sort reset change', this.updateStyle);
    this.listenTo(iorad.player.data.markerColors, 'change', this.updateStyle);
    this.listenToDOM(window, 'resize', this.updateStyle);
    this.listenTo(iorad.player.events, 'change:stepPanel embedded:init:show', this.updateStyle);
    this.listenTo(iorad.player.controllers.views, 'change:coverOpen', (isCoverOpen) => {
      if (isCoverOpen) {
        this.resetIframe();
      }
    });

    this.render();
    if (!this.model) {
      this.onChangeCurrent();
    } else {
      this.handleModel();
    }

    this.setupMediaTimingsMonitor();
  },

  setupMediaTimingsMonitor: function () {
    const calculateOverrides = () => {
      // everytime this.model changes (including its attributes change)

      if (!this.model) return null;

      const mediaTimings = this.model.get('infotext.mediaTimings');
      if (!mediaTimings) return null;

      const audioId = this.model.get('audioId');
      const videoId = this.model.get('videoId');
      const mediaType = audioId ? 'audio' : videoId ? 'video' : null;
      if (!mediaType) return null;
      if (mediaType !== mediaTimings.mediaType) return null;
      const mediaId = mediaType === 'audio' ? audioId : videoId;
      if (mediaId !== mediaTimings.mediaId) return null;

      const title = this.model.get('infotext.title');
      const titleIsHTML = this.model.get('infotext.titleIsHTML');
      if (!title || !titleIsHTML) return null;

      const text = this.model.get('infotext.text');
      const textIsHTML = this.model.get('infotext.textIsHTML');
      if (!text || !textIsHTML) return null;

      const parser = document.createElement('div');
      parser.innerHTML = text;
      const ul = parser.querySelector('ul');
      if (!ul) return null;
      const liList = Array.from(ul.querySelectorAll('li'));
      if (liList.length !== mediaTimings.textBulletPoints.length) return null;

      // everytime the media changes

      let seekMS;
      if (mediaType === 'audio') {
        const sound = iorad.player.controllers.audio.sound;
        if (!sound) return null;
        if (!iorad.player.controllers.audio.audioPlaying) return null;
        seekMS = Math.floor(sound.pos() * 1000);
      } else {
        const video = iorad.player.controllers.video.video;
        if (!video) return null;
        if (!iorad.player.controllers.video.videoPlaying) return null;
        seekMS = Math.floor(video.pos() * 1000);
      }

      const titleAppeared = !mediaTimings.title || mediaTimings.title <= seekMS;
      const visibleLiList = liList.filter((li, index) => {
        const liTiming = mediaTimings.textBulletPoints[index];
        return !liTiming || liTiming <= seekMS;
      });

      const titleOverride = titleAppeared ? title : '';
      const textOverride = '<ul>' + visibleLiList.map(li => li.outerHTML).join('\n') + '</ul>';
      return {
        titleOverride,
        textOverride,
      };
    };
    const onAnimationFrame = () => {
      try {
        const oldTitleOverride = this.titleOverride;
        const oldTextOverride = this.textOverride;

        const overrides = calculateOverrides();
        if (!overrides) {
          this.titleOverride = undefined;
          this.textOverride = undefined;
        } else {
          this.titleOverride = overrides.titleOverride;
          this.textOverride = overrides.textOverride;
        }

        // update accordingly
        if (
          this.titleOverride !== oldTitleOverride ||
          this.textOverride !== oldTextOverride
        ) {
          this.update();
        }
      } finally {
        requestAnimationFrame(onAnimationFrame);
      }
    };
    onAnimationFrame();
  },

  onChangeCurrent: function () {
    var model = this.collection.getCurrentModel();
    if (this.model) this.stopListening(this.model);
    this.model = model;
    if (!model) return;

    this.handleModel();
  },

  handleModel: function () {
    // model is a step
    this.listenTo(this.model, 'change', this.update);
    this.update();
  },

  hasInfotextEmbed: function() {
    return this.model.get('event.infotextType') === 'embed' &&
      this.model.get('event.infotextEmbedCode');
  },

  hasInfotextVideo: function () {
    // for old tutorials
    let withVideo = false;

    if (this.model && this.model.isReadInfotext()) {
      if (!this.model.get('event.infotextType')) {
        withVideo = this.model.get('infotext.withVideo');
      } else if (this.model.get('event.infotextType') === 'video') {
        const videoId = this.model.get('videoId');
        withVideo = videoId != null;
      }
    }

    return withVideo;
  },

  render: function () {
    const videoVisualizerEl = this.$('.video-visualizer');
    if (videoVisualizerEl.length) videoVisualizerEl.detach();

    iorad.base.View.prototype.render.apply(this, arguments);

    if (videoVisualizerEl.length) {
      this.$('.video-visualizer').replaceWith(videoVisualizerEl);
    } else {
      this.videoVisualizerView = new iorad.player.views.step_video_visualizer({
        el: this.$('.video-visualizer'),
        mode: this.options.mode,
        wrapperEl: this.$el,
        isCurrent: () => {
          return Boolean(
            (this.options.isCurrent ? this.options.isCurrent() : true) &&
            this.hasInfotextVideo() &&
            iorad.player.mode === this.options.mode
          );
        },

        // #14241
        isKeepVisualizer: this.options.mode === 'quick',
        isVisualizerDisplayed: this.options.isVisualizerDisplayed,
        parentStep: this.model,
      });
      this.videoVisualizerView.render();
    }

    return this;
  },

  resetIframe: function() {
    // https://github.com/iorad/iorad/issues/13959#issuecomment-1922719241
    // pause or reset src for all iframe of other modes as some iframe may autoplay
    $('.embed-container iframe').each(function() {
      const src = $(this).attr('src');

      if (iorad.base.Utils.isYoutubeUrl(src)) {
        // required enablejsapi=1 in youtube iframe query
        // youtube iframe will not blink when cover shown
        this.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      } else if (iorad.base.Utils.isVimeoUrl(src)) {
        // vimeo iframe will not blink when cover shown
        this.contentWindow.postMessage('{ "method": "pause" }', "*");
      } else if (iorad.base.Utils.isGoogleDocsUrl(src)) {
        // docs iframe will not blink when cover shown
      } else {
        // #13986
        // still blink for other when cover shown
        $(this).attr('src', src);
      }
    });
  },

  getStepLink: function(playerUrlData) {
    var routeHash = iorad.player.tab === 'watch' ? 'watchsteps'
      : iorad.player.tab === 'quiz' ? 'quizsteps'
        : 'trysteps';
    var newUrl = new URL(playerUrlData.PUBLIC_LINK);

    newUrl.hash = routeHash + '-' + (this.model.get('index')+1);
    return newUrl.toString();
  },

  getPlayerUrl: function() {
    if (this.getPlayerURL) return this.getPlayerURL;

    return this.getPlayerURL = iorad.player.controllers.sync.getPlayerURL();
  },

  // prepare async data for the synchronous render
  update: function () {
    let shouldShow = this.model.isReadInfotext();
    const hasEmbed = this.hasInfotextEmbed();
    const hasVideo = this.hasInfotextVideo();

    if (this.options.mode === 'quick' && hasVideo) {
      const videoDisplayDisabled = typeof iorad.player.videoDisplayDisabled === 'undefined' ? true : iorad.player.videoDisplayDisabled;
      shouldShow = shouldShow && hasVideo && !videoDisplayDisabled;
    }

    const updatePromise = Promise.all([
      !shouldShow ? '' : this.calculateTitle(this.titleOverride),
      !shouldShow ? '' : this.calculateText(this.textOverride),
      this.getPlayerUrl()
    ])
      .then(_.bind(function (result) {
        if (updatePromise !== this.updatePromise) return; // too late
        this.$el.toggle(Boolean(shouldShow));
        this.$el.data('display-step-link', 'false');

        if (hasEmbed || hasVideo) {
          this.$el.data('display-step-link', this.getStepLink(result[2]));
        }

        if (hasEmbed) {
          const elEmebedId = `step-emebed-${this.model.get('index')}`;

          this.$el.find('.overlay .embed-container').hide();

          // use cache to prevent iframe blinking when switch step
          if (this.$el.find(`.${elEmebedId}`).length) {
            this.$el.find(`.${elEmebedId}`).show();
          } else {
            const parser = document.createElement('div');
            parser.className = `embed-container ${elEmebedId}`;
            parser.innerHTML = sanitizeHtml(
              this.model.get('event.infotextEmbedCode'),
              iorad.base.Export.STEP_INFOTEXT_EMBED_SANITIZE_RULES,
            );
            $(parser).find('iframe').each(function() {
              const src = $(this).attr('src');
              if (iorad.base.Utils.isYoutubeUrl(src)) {
                const newSrc = new URL(src);
                newSrc.searchParams.set('enablejsapi', 1); // to comnunicate with youtube
                $(this).attr('src', newSrc);
              }
            });

            this.$el.find('.overlay').append(parser.outerHTML);
            this.$el.find(`.${elEmebedId}`).show();
          }

          this.resetIframe();
          this.$el.find('.overlay').show();

          return;
        } else {
          this.resetIframe();
          this.$el.find('.overlay').hide();
        }

        this.$('.section-title').html(result[0]);
        this.$('.section-text').html(result[1]);
        this.$el.toggleClass('notranslate', !iorad.player.controllers.language.learnerChangedLanguage());

        this.updateStyle();
      }, this));
    this.updatePromise = updatePromise;
  },

  // (argument provided to allow extensibility by child types)
  calculateTitle: function (title) {
    if (typeof title === 'undefined') {
      title = this.model.get('infotext.title') || '';
      const titleIsHTML = this.model.get('infotext.titleIsHTML');
      if (title && !titleIsHTML) {
        title = '<b>' + _.escape(title) + '</b>';
      }

      title = iorad.base.Export.fixInfotextTitle(title);
    }

    return this.sanitize(title)
      .then(this.linkSteps.bind(this))
      .then(this.fixNonBreakingSpaces.bind(this));
  },

  // (argument provided to allow extensibility by child types)
  calculateText: function (text) {
    if (typeof text === 'undefined') {
      text = this.model.get('infotext.text') || '';
    }

    return this.sanitize(text)
      .then(this.linkSteps.bind(this))
      .then(this.fixNonBreakingSpaces.bind(this));
  },

  sanitize: function (html) {
    return Promise.resolve(
      sanitizeHtml(html, iorad.base.Export.STEP_INFOTEXT_SANITIZE_RULES)
    );
  },

  // NOTE: text is already XSS safe
  linkSteps: function (text) {
    if (this.disableStepsLinking) return Promise.resolve(text);
    var routeHash = iorad.player.tab === 'watch' ? 'watchsteps'
      : iorad.player.tab === 'quiz' ? 'quizsteps'
        : 'trysteps';

    var stepLen = this.model.collection.length;

    function processNode(node) {
      if (node.nodeType === Node.TEXT_NODE) {

        // base: wrap "Step X" phrase with an anchor
        // (\b is word boundary)

        // we can't directly use node.nodeValue or node.textContent
        // to get the text content as that would decode html entities
        // and open to XSS vulnerabilities.
        var textGetter = document.createElement('div');
        textGetter.appendChild(node.cloneNode(true));

        var newHtml = textGetter.innerHTML.replace(/\b(Step (\d+))/gi, function (match, p1, p2) {
          if (p2 && parseInt(p2) <= stepLen) {
            return '<a href="#' + routeHash + '-' + p2 + '" data-self="true">' + p1 + '</a>';
          }

          return p1;
        });


        // parse html
        var newHtmlContainer = document.createElement('div');
        newHtmlContainer.innerHTML = newHtml;
        // replace text node with parsed nodes
        var newNodes = newHtmlContainer.childNodes;
        for (var i = 0; i < newNodes.length; i++) {
          node.parentNode.insertBefore(newNodes[i], node);
          i--; // child has been removed
        }
        node.parentNode.removeChild(node);

        return;
      }

      if (node.nodeType === Node.ELEMENT_NODE) {
        // recursion

        // ignore anchors!
        if (node.tagName === 'A') return;

        // process childs
        var childNodeList = node.childNodes; // NodeList
        for (var i = 0; i < childNodeList.length; i++) {
          var childNode = childNodeList[i];
          processNode(childNode);
        }
      }
    }

    var container = document.createElement('div');
    container.innerHTML = text;
    processNode(container);
    return Promise.resolve(container.innerHTML);
  },

  fixNonBreakingSpaces: function (text) {
    // https://stackoverflow.com/a/24469190
    // add a <wbr> element after the sequence of &nbsp;
    // thus keeping the spaces but still allowing line breaks
    return Promise.resolve(
      text.replace(/(&nbsp;)+/g, '$&<wbr>')
    );
  },

  // Note: this function is also called from the outside (mobile-slide)
  updateStyle: function () {
    this.$el.toggleClass('step-infotext--small', Boolean(
      this.$el.width() <= 750 ||
      this.$el.height() <= 550
    ));

    this.$el.toggleClass('step-infotext-has-video', Boolean(this.hasInfotextVideo()));

    var currentTheme = this.themesCollection.get(this.tutorial.get('theme'));
    var ic = iorad.base.Export.themeToItemColors(
      currentTheme && currentTheme.attributes,
      this.tutorial.get('baseThemes'),
      this.tutorial.get('theme'),
      true // coverOpen
    );
    var ich = ic.header;

    var backgroundImgUrl = ic.header.coverBackgroundImage || '';
    this.$('.step-infotext_inner')[backgroundImgUrl ? 'addClass' : 'removeClass']('background-image')
      .css('background-image', backgroundImgUrl ? 'url("' + backgroundImgUrl + '")' : 'none');

    this.$('.step-infotext_inner_inner').css('background-color', ich.coverBackground);

    this.$el.css({
      'color': ic.header.font,
    });

    this.updateUnderlineColors(ic);
  },

  updateUnderlineColors: function (ic) {
    var contrastColor = iorad.base.Export.getContrastColor(ic.header.font);
    this.$('u').each(function () {
      $(this).css({
        'background-color': ic.header.font,
        'color': contrastColor,
      });
    });
  },

  onClick: function () {
    if (this.model.get('event.quizStarter')) {
      if (iorad.player.router.isQuizTabAvailable()) {
        window.setLocationHash('#quizsteps-1');
      } else {
        noty({
          type: 'error',
          text: 'Quiz is not available',
        });
      }
    }
  },

  // Open links manually in another window by default.
  openLink: function (event) {
    var anchor = $(event.currentTarget);
    var href = anchor.attr('href');

    var isInternalPlayerUrl = anchor.attr('data-self') === 'true';

    var isShortPlayerUrl = anchor[0].hostname === 'ior.ad' &&
      !anchor[0].pathname.startsWith('/live/');
    var isRegularPlayerUrl = (
      anchor[0].hostname.endsWith('.iorad.com') ||
      anchor[0].hostname.endsWith('.iorad.dev') ||
      (window.IORAD_ROOT && new RegExp('^https?://' + anchor[0].hostname + '$').test(window.IORAD_ROOT)) ||
      (!window.IORAD_ROOT && anchor[0].hostname === document.location.hostname)
    ) && anchor[0].pathname.startsWith('/player/');
    var isExternalPlayerUrl = (isShortPlayerUrl || isRegularPlayerUrl) &&
      !isInternalPlayerUrl;

    var url;
    if (isExternalPlayerUrl) {
      var newAnchorQuery = iorad.base.Utils.getUrlParameters(href);
      if (iorad.player.router.isExtensionMode()) {
        newAnchorQuery.extensionEmbed = 'true';
        if (iorad.player.getParameters.playerExtensionWidth) {
          newAnchorQuery.playerExtensionWidth = iorad.player.getParameters.playerExtensionWidth;
        }
        if (iorad.player.getParameters.widgetEmbed === 'true') {
          newAnchorQuery.widgetEmbed = 'true';
        }
        newAnchorQuery.device = (iorad.player.data.tutorial.get('extensionDevice') || '');
      }
      if (iorad.player.router.isHelpcenterMode()) {
        newAnchorQuery.helpcenter = iorad.player.getParameters.helpcenter;
        if (iorad.player.getParameters.roleId) {
          newAnchorQuery.roleId = iorad.player.getParameters.roleId;
        }
      }
      if (iorad.player.getParameters.embedUrl) {
        newAnchorQuery.embedUrl = iorad.player.getParameters.embedUrl;
      }

      url = iorad.base.Utils.createUrl({
        base: 'https://' + anchor[0].hostname + anchor[0].pathname,
        urlParameters: newAnchorQuery,
        hash: anchor[0].hash,
      });
    } else {
      url = href;
    }

    var isNewWindow = isInternalPlayerUrl ? iorad.player.mode === 'mobilequick' // mobile can't show trysteps
      // : isExternalPlayerUrl ? iorad.player.router.isPreviewMode()
      : true;
    siteWindow.ioradNodeApp.setLocation(url, {
      isNewWindow: isNewWindow,
      isAssign: isExternalPlayerUrl && !isNewWindow, // allow browser history back
    });
    return false;
  },

  onPrevClick: function () {
    iorad.player.events.trigger('mobilequick:back');
  },

  onNextClick: function () {
    iorad.player.events.trigger('mobilequick:next');
  },
});

;
iorad.player.views.step_video_visualizer = iorad.base.View.extend({
  template: iorad.player.templates.step_video_visualizer,

  events: {
    'click .video-visualizer-restart': 'onVideoRestartClick',
    'click .video-visualizer-paused': 'onVideoPausedClick',
    'click .video-visualizer-playing': 'onVideoPlayingClick',
  },

  initialize: function (options) {
    iorad.base.View.prototype.initialize.apply(this, arguments);
    options = options || {};
    this.options = options;

    this.tutorial = iorad.player.data.tutorial;
    this.stepsCollection = iorad.player.data.stepsCollection;

    this.listenTo(this.tutorial, 'change', this.updateVideoVisualizer);
    this.listenTo(this.stepsCollection, 'change changeCurrent reset', this.updateVideoVisualizer);
    this.listenTo(iorad.player.events, 'ready tab mode device', this.updateVideoVisualizer);
    this.listenTo(iorad.player.events, 'mobile:positionImage', this.updateVideoVisualizer);
    this.listenTo(iorad.player.events, 'change:stepPanel', this.updateVideoVisualizer);
    this.listenTo(iorad.player.controllers.views, 'change:coverOpen change:coverCollapsing set:tutorialData change:forceStepPanel', this.updateVideoVisualizer);
    this.listenTo(iorad.player.controllers.video, 'change:videoState change:transcriptionState change:transcriptionEnabled', this.updateVideoVisualizer);
    this.listenTo(iorad.player.events, 'video:load video:end video:play video:loaderror video:mute video:unmute', this.updateVideoVisualizer);
    this.listenTo(iorad.player.events, 'video:display video:volume', this.updateVideoVisualizer);
    this.listenToDOM(window, 'resize', this.updateVideoVisualizer);
    if (this.options.mode === 'interactive') {
      this.listenTo(iorad.player.events, 'resize:interactive-nav', this.updateVideoVisualizer);
    }
    this.listenTo(iorad.player.controllers.autoplay, 'change:paused change:resume', this.updateVideoVisualizer);

    this.setupVideoVisualizer();
  },

  // NOTE: only one video-visualizer instance should "take ownership" of the video element at any given time
  //       meaning only one can have it added to its DOM (check unset function)
  setupVideoVisualizer: function () {
    const draw = () => {
      const {
        paused,
        videoEl,
      } = this.videoVisualizer;
      if (paused) return;
      requestAnimationFrame(draw);

      if (!videoEl || videoEl !== this.$('video')[0]) {
        this.$('video').detach(); // if any, without removing event handlers
        if (videoEl) {
          this.$el.append(videoEl);
        }
      }
    };
    this.videoVisualizer = {
      videoEl: null,
      paused: false,
      started: false,
      start: () => {
        if (this.videoVisualizer.started) return;
        this.videoVisualizer.started = true;
        draw();
      },
      pause: () => {
        if (this.videoVisualizer.paused) return;
        this.videoVisualizer.paused = true;
      },
      resume: () => {
        if (!this.videoVisualizer.paused) return;
        this.videoVisualizer.paused = false;
        draw();
      },
      unset: () => {
        if (
          this.videoVisualizer.started &&
          !this.videoVisualizer.paused
        ) {
          this.videoVisualizer.pause();
        }
        this.$('video').detach();
      },
    };
  },

  render: function () {
    const res = iorad.base.View.prototype.render.apply(this, arguments);

    this.updateVideoVisualizer();

    return res;
  },

  updateVideoVisualizer: function () {
    const hide = () => {
      if (this.videoVisualizer) {
        this.videoVisualizer.unset();
      }
      this.$el.removeClass('visible');
    };

    // already displayed visualize in quick mode
    if (this.options.isVisualizerDisplayed && this.options.isVisualizerDisplayed()) {
      return hide();
    }

    // OPTIMIZATION: only run in current slide
    // on quick mode: keep video visualizer
    const isCurrent = this.options.isCurrent();
    if (!isCurrent && !this.options.isKeepVisualizer) {
      return hide();
    }

    const stepModel = this.options.parentStep || this.stepsCollection.getCurrentModel();
    if (!stepModel) {
      return hide();
    }

    const stepId = stepModel.get('index') + 1;
    const classes = iorad.player.controllers.video.getVideoStateClasses(stepId);
    const stepModelIsLast = Boolean(stepModel && stepModel.get('index') >= this.stepsCollection.length - 1);

    const videoVisualizer = this.$el;

    const isVisualizerVisible = Boolean(
      iorad.player.mode === this.options.mode
      && stepModel
      && stepModel.get('videoId') != null
      && !classes.includes('load-error')
      && !classes.includes('mute')
      && !iorad.player.videoDisplayDisabled
    );

    const isVisualizerPaused = !isVisualizerVisible || (
      // do not add .showing class at current step when loaded
      isCurrent ? !iorad.player.controllers.video.isVideoLoaded(stepId) : classes.includes('load')
    );

    videoVisualizer.toggleClass('visible', Boolean(isVisualizerVisible));
    videoVisualizer.toggleClass('showing', this.options.isKeepVisualizer && !isCurrent ? false : Boolean(isVisualizerVisible && isVisualizerPaused));

    $(this.options.wrapperEl).toggleClass('withVideoVisualizer', Boolean(isVisualizerVisible));

    const aboveCopyright = Boolean(
      isVisualizerVisible &&
      iorad.player.controllers.views.getCopyright()
    );
    $(this.options.wrapperEl).toggleClass('withVideoVisualizer-aboveCopyright', Boolean(aboveCopyright));

    const $theSteps = $(this.options.wrapperEl).find('#the-steps');
    const belowText = Boolean(
      isVisualizerVisible &&
      iorad.player.mode === 'interactive' &&
      $('html').attr('data-stepPanel') === 'full' &&
      $theSteps[0]
    );
    $(this.options.wrapperEl).toggleClass('withVideoVisualizer-belowText', Boolean(belowText));
    $theSteps.css('max-height', ''); // reset
    if (belowText) {
      const remainingHeightForSteptext = (
        videoVisualizer[0].getBoundingClientRect().top -
        $theSteps[0].getBoundingClientRect().top
      );
      if (remainingHeightForSteptext < 80) { // TODO: remove magic number, this is 3 lines of text
        // not enough space, keep only video
        $(this.options.wrapperEl).removeClass('withVideoVisualizer-belowText');
      } else {
        $theSteps.css('max-height', `${remainingHeightForSteptext}px`);
      }
    }

    this.videoVisualizer.videoEl = (
      iorad.player.controllers.video.video &&
      iorad.player.controllers.video.video._videoEl
    );

    if (isVisualizerPaused) {
      this.videoVisualizer.pause();
    } else {
      if (!this.videoVisualizer.started) {
        this.videoVisualizer.start();
      } else {
        this.videoVisualizer.resume();
      }
    }

    const transcriptionState = iorad.player.controllers.video.getTranscriptionState();
    const transcriptionEl = this.$('.video-visualizer-transcription');
    if (transcriptionState) {
      transcriptionEl.find('.video-visualizer-transcription-text').text(transcriptionState.wordsToDisplay.join(' '));
      transcriptionEl.show();
    } else {
      transcriptionEl.hide();
    }

    var readStepAutoadvance = stepModel && stepModel.get('type') === 'READ' && stepModel.get('event.autoadvance') !== false;
    var videoStateClasses = iorad.player.controllers.video.getVideoStateClasses();
    var withAutoplay = (
      iorad.player.tab === 'watch' ||
      (iorad.player.tab === 'try' && readStepAutoadvance)
    );
    const paused = (
      iorad.player.controllers.video.videoPaused &&
      (
        iorad.player.tab !== 'quiz'
      )
    );
    const restart = (
      !paused &&
      (!withAutoplay || stepModelIsLast) &&
      videoStateClasses.includes('end')
    );

    // to fix bug jquery toggle display: block; instead of flex; when switch mode
    function toogleEl(el, isDisplay) {
      el.css('display', isDisplay ? 'flex' : 'none');
    }

    toogleEl(this.$('.video-visualizer-playing'), Boolean(!paused));
    toogleEl(this.$('.video-visualizer-paused'), Boolean(paused));
    toogleEl(this.$('.video-visualizer-restart'), Boolean(restart));
    this.$('.video-visualizer-paused').text(iorad.player.controllers.video.getVideoCurrentTime(stepId) > 0 ? 'Paused' : 'Play');

    if (this.options.onUpdate) {
      this.options.onUpdate();
    }
  },

  onVideoRestartClick: function () {
    iorad.player.controllers.video.toggleVideo(false);
    iorad.player.controllers.video.toggleVideo(true);
  },

  onVideoPausedClick: function () {
    iorad.player.controllers.autoplay.resumeAutoplay();
  },

  onVideoPlayingClick: function () {
    iorad.player.controllers.autoplay.pauseAutoplay();
  },
});

;
iorad.player.views.layout_player = Backbone.View.extend({
  el: '#playing-player',

  initialize: function() {
    this.winEl = $(window);

    this.listenTo(iorad.player.data.markerColors, 'change', this.updateCSSVariables);
    this.listenTo(iorad.player.data.overridedThemeData, 'change', this.updateCSSVariables);
    this.updateCSSVariables();

    this.listenTo(iorad.player.events, 'mode:interactive mode:quick header:rendered', function() { this.updateMenuTheme(); });
    this.listenTo(iorad.player.controllers.views, 'change:coverOpen', function() { this.updateMenuTheme(); });

    var translatorView = new iorad.player.views.layout_translator();
    $(document.body).append(translatorView.$el);
    translatorView.render();
    translatorView.start();

    this.translatorView = translatorView;

    // Theme change handling via data
    this.themesCollection = iorad.player.data.themesCollection;
    this.tutorial = iorad.player.data.tutorial;
    var onCurrentThemeChange = _.bind(function() {
      this.currentTheme = this.themesCollection.get(this.tutorial.get('theme'));
      this.updateMenuTheme();
      iorad.player.events.trigger('theme:applied');
    }, this);
    this.listenTo(this.tutorial, 'change:theme', onCurrentThemeChange);
    this.listenTo(this.themesCollection, 'add remove sort reset change', onCurrentThemeChange);
    onCurrentThemeChange();

    this.checkDisabled();
    this.monitorStepsChangeCurrent();
  },

  updateCSSVariables: function() {
    var markerColor = iorad.player.data.markerColors.get('READ') || '#FF00D6';
    var markerColorContrast = iorad.base.Export.getContrastColor(markerColor);
    var markerColor10 = iorad.player.data.overridedThemeData.get('BACKGROUND_COLOR') || iorad.base.Export.addTransparency(markerColor, 1);
    document.documentElement.style.setProperty('--marker-color', markerColor);
    document.documentElement.style.setProperty('--marker-color-contrast', markerColorContrast);
    document.documentElement.style.setProperty('--marker-color-10', markerColor10);
    document.documentElement.style.setProperty('--playerExtensionWidth', iorad.player.getParameters.playerExtensionWidth || '374px');
  },

  monitorStepsChangeCurrent: function() {
    var stepsCollection = iorad.player.data.stepsCollection;
    this.listenTo(stepsCollection, 'changeCurrent', function(stepIndex) {
      if (siteWindow.parent !== siteWindow) {
        var flattenedStepIndex = stepsCollection.getFlattenedPosition();
        siteWindow.parent.postMessage({
          topic: 'player:steps:changeCurrent',
          from: 'iorad-web-app',
          data: {
            stepIndex: stepIndex,
            flattenedStepIndex: flattenedStepIndex,
          },
        }, '*');
      }
    });
  },

  checkDisabled: function() {
    if (window.downloadPlayerType) return;
    if (iorad.player.router.isPreviewMode()) return; // DISABLED in preview (https://github.com/iorad/iorad/issues/13679#issuecomment-1684401502)

    if (this.tutorial.get('isDraft')) {
      iorad.player.controllers.sync.hasEditAccess()
        .then(_.bind(function(editAccess) {
          if (!editAccess) return;
          noty({
            text: i18next.t('Draft Mode'),
            type: 'information',
            buttons: [{
              addClass: 'btn btn-primary btn-small',
              text: 'Publish',
              onClick: _.bind(function($noty) {
                $noty.close();

                noty({
                  text: i18next.t('Confirmation: Publish this draft?'),
                  type: 'information',
                  buttons: [{
                    addClass: 'btn btn-primary btn-small',
                    text: 'Yes',
                    onClick: _.bind(function($confirmationNoty) {
                      $confirmationNoty.close();

                      if (iorad.player.router.isPreviewMode()) {
                        siteWindow.parent.postMessage({
                          topic: 'preview:publishDraft',
                        }, Backbone.history.location.origin);
                        return;
                      }
                      iorad.player.controllers.sync.publishDraft();
                    }, this),
                  }]
                });
              }, this)
            }],
          });
        }, this));
      return;
    }

    if (this.tutorial.get('disabled')) {
      iorad.player.controllers.sync.canUpdateDisabledStatus()
        .then(_.bind(function(allowed) {
          if (!allowed) return;
          noty({
            text: i18next.t('Deactivated and only visible to you.'),
            type: 'information',
            buttons: [{
              addClass: 'btn btn-primary btn-small',
              text: 'Activate',
              onClick: _.bind(function($noty) {
                $noty.close();
                if (iorad.player.router.isPreviewMode()) {
                  siteWindow.parent.postMessage({
                    topic: 'preview:updateDisabledStatus',
                    data: {
                      disabled: false,
                    },
                  }, Backbone.history.location.origin);
                  return;
                }
                iorad.player.controllers.sync.updateDisabledStatus(false)
                  .then(_.bind(function() {
                    this.tutorial.set('disabled', false);
                    noty({
                      text: iorad.player.successNotificationList.tutorialActivated(),
                      type: 'success',
                    });
                  }, this))
                  .catch(function(err) {
                    console.error(err);
                    noty({
                      text: 'Operation failed.',
                      type: 'error',
                    });
                  });
              }, this)
            }],
          });
        }, this));
    }
  },

  getItemColors: function() {
    var coverOpen = iorad.player.controllers.views.isCoverOpen();
    var ic = iorad.base.Export.themeToItemColors(
      this.currentTheme && this.currentTheme.attributes,
      this.tutorial.get('baseThemes'),
      this.tutorial.get('theme'),
      coverOpen
    );
    return ic;
  },

  updateMenuTheme: function() {
    var ic = this.getItemColors();
    var ich = ic.header;
    var icl = ic.logo;
    var icf = ic.font;
    var cc = ic.cc;
    var coverOpen = iorad.player.controllers.views.isCoverOpen();

    // update font theme config
    document.documentElement.style.setProperty('--step-text-font-size', icf.stepTextFontSize + 'px');

    // update closed caption theme config
    document.documentElement.style.setProperty('--cc-background-color', cc.ccBackgroundColorRgba);
    document.documentElement.style.setProperty('--cc-font-color', cc.ccFontColor);
    document.documentElement.style.setProperty('--cc-font-size', cc.ccFontSize + 'px');

    $('.header-font-color').css({
      color: ich.font,
    });

    if (coverOpen) {
      $('#header .header-inner').css('background-color', ich.coverBackground);
    } else {
      $('#header .header-inner').css('background-color', ich.collapsedCoverBackground);
    }

    var backgroundImgUrl = ic.header.coverBackgroundImage || '';
    if ($('#header .header-themed').data('backgroundImgUrl') !== backgroundImgUrl) {
      $('#header .header-themed')
        [backgroundImgUrl ? 'addClass' : 'removeClass']('background-image')
        .css('background-image', backgroundImgUrl ? 'url("' + backgroundImgUrl + '")' : 'none')
        .data('backgroundImgUrl', backgroundImgUrl);
      iorad.player.controllers.views.registerImageUrlRender('header.backgroundImage', backgroundImgUrl);
    }

    // LOGO
    const $logoImageEl = $('#logo').find('.logo-image');
    const logoIsCustom = Boolean(icl.image && !icl.isBaseTheme);
    $('#logo').toggleClass('custom-logo', Boolean(logoIsCustom));
    let logoUrl;
    if (icl.image && !icl.isBaseTheme) {
      logoUrl = icl.image.indexOf('.svg') === -1 ?
        icl.croppedImage :
        icl.image;
    } else {
      // logoImage property is optional even for base themes
      logoUrl = (icl.baseImage || iorad.base.Export.getDefaultLogoUrl()) || '';
    }
    if ($logoImageEl.data('logoUrl') !== logoUrl) {
      $logoImageEl
        .attr('src', logoUrl)
        .data('logoUrl', logoUrl);
      iorad.player.controllers.views.registerImageElementRender('header.logo', $logoImageEl[0]);
    }

    const logoHref = (
      icl.href ||
      (!logoIsCustom ? '/' : null)
    );
    if (logoHref) {
      $('#logo').attr('href', logoHref);
    } else {
      // no hyperlink
      $('#logo').removeAttr('href');
    }
    if (icl.href) $('#logo').attr('href', icl.href);
    if (icl.targetBlank) $('#logo').attr('target', '_blank');

    // FONTS
    [
      {
        name: 'default_primary',
        family: 'Libre Franklin',
        defaultFamily: 'default_Libre Franklin',
      },
      {
        name: 'default_secondary',
        family: 'Fahkwang',
        defaultFamily: 'default_Fahkwang',
      },
      {
        name: 'primary',
        family: icf.primaryFamily,
        defaultFamily: 'Libre Franklin',
      },
      {
        name: 'secondary',
        family: icf.secondaryFamily,
        defaultFamily: 'Fahkwang',
      },
      {
        name: 'closed_caption',
        family: cc.ccFontFamily,
        defaultFamily: 'closed_caption_Poppins',
      }
    ].forEach((fontRule) => {
      var dataId = 'iorad-custom-font-' + fontRule.name;
      var $existingFontEl = $('[data-id="' + dataId + '"]');
      if ($existingFontEl.attr('data-font-family') !== fontRule.family) {
        iorad.player.controllers.views.registerRenderOperation('player.fontFamily.' + fontRule.name, (onComplete) => {
          var cleared = false;

          iorad.player.controllers.sync.getCustomFontCSSText(
            fontRule.family,
            fontRule.defaultFamily
          )
            .then((cssText) => {
              if (cleared) return; // too late

              var $style = $('<style>');
              $style.attr('data-id', dataId);
              $style.attr('data-font-family', fontRule.family);
              $style.html(cssText);
              $existingFontEl.remove();
              $('head').append($style);
              onComplete();
            })
            .catch((err) => {
              console.warn(err);
              if (!cleared) onComplete();
            });

          return () => { // clear function
            cleared = true;
          };
        });
      }
    });
  },
});

;
iorad.player.views.layout_header = iorad.base.View.extend({
  events: {
    'click #logo': 'onLogoClick',
    'click .header-themed, .collapse-btn, .expanded-overlay': 'onCollapseBtnClick',
    'click .buttons a.live': 'tryLive',
    'click .modalLiveRedirecting': 'onModalLiveRedirectingClick',
    'click .modalLive': 'onModalLiveClick',
  },

  initialize: function() {
    if (screenfull.enabled) { // fullscreen is optional
      document.addEventListener(screenfull.raw.fullscreenchange, _.bind(function () {
        this.render();
      }, this));
    }

    this.tutorial = iorad.player.data.tutorial;
    this.stepsCollection = iorad.player.data.stepsCollection;
    this.themesCollection = iorad.player.data.themesCollection;

    this.listenTo(iorad.player.events, 'theme:applied', this.onThemeApplied);

    this.listenTo(iorad.player.events, 'device', this.render);
    this.listenTo(iorad.player.controllers.views, 'change:coverOpen', this.handleCoverOpen);
    this.listenTo(iorad.player.controllers.views, 'change:coverCollapsing', this.onThemeApplied);
    this.listenTo(iorad.player.events, 'slide_start_with_no_index', function() { this.onExpandBtnClick(); }); // make sure to call it with no arguments
    this.listenTo(iorad.player.controllers.live, 'change:bannerData', this.render); // to update live tab
    this.listenTo(iorad.player.events, 'tab', this.render); // to update Start button in case of live tab
    this.listenToDOM(window, 'resize', () => {
      this.setTooltipOnOverflow();
    });

    this.monitorAutoClose();

    // for setting the initial 'expanded' class
    this.handleCoverOpen();

    if (iorad.player.router.isCoverDisabled()) {
      iorad.player.controllers.views.setCoverOpen(false, true);
    }
    this.listenTo(this.model, 'change', function() {
      if (this.model.hasLayoutOptionChanged('is_cover_disabled')) {
        iorad.player.controllers.views.setCoverOpen(!iorad.player.router.isCoverDisabled(), true);
      }
      this.render();
    });

    this.getPlayerUserFinished = false;
    this.userIsAuthor = false;
    this.userIsLoggedIn = false;
    if (window.downloadPlayerType) {
      this.getPlayerUserFinished = true;
      this.render();
    } else {
      iorad.player.controllers.views.registerRenderOperation('header.getPlayerUser', (onComplete) => {
        let cleared = false;

        iorad.player.controllers.sync.getPlayerUser()
          .then(_.bind(function (data) {
            this.getPlayerUserFinished = true;
            this.userIsAuthor = data.userIsAuthor;
            this.userIsLoggedIn = data.userIsLoggedIn;
            this.render();
            if (!cleared) onComplete();
          }, this))
          .catch(_.bind(function (err) {
            this.getPlayerUserFinished = true;
            console.error(err);
            this.render();
            if (!cleared) onComplete();
          }, this));

        return function clear() {
          cleared = true;
        };
      });
    }
  },

  monitorAutoClose: function() {
    if (siteWindow === window.top) { // disable in embedded mode since usability isn't great there
      $('html').on('mousewheel', _.bind(function(event) {
        var scrollDown = !(event.originalEvent.wheelDelta > 0 || event.originalEvent.detail < 0);
        if (
          scrollDown &&
          iorad.player.controllers.views.isCoverOpen() &&
          !iorad.player.controllers.views.isPopupOpen() &&
          $(event.target).closest(this.$('.header-themed')).length === 0
        ) {
          event.preventDefault(); // disable scrolling of parent element/frame
          this.onCollapseBtnClick();
        }
      }, this));
    }
  },

  handleCoverOpen: function () {
    var coverOpen = iorad.player.controllers.views.isCoverOpen();
    this.$el.toggleClass('expanded', coverOpen);

    // re-render for the :visible checks
    this.render();

    // focus Start Tutorial as it should for Accessibility
    if (coverOpen) {
      iorad.base.Utils.accessibilityFocus(this.$el);
    }/*  else {
      iorad.base.Utils.accessibilityFocusBack('steps');
    } */
  },

  getTemplateData: function() {
    const liveBannerData = iorad.player.controllers.live.getBannerData();
    var liveTabIsActive = iorad.player.tab === 'live';
    var quizTabIsActive = iorad.player.tab === 'quiz';
    var userIsAuthor = this.userIsAuthor;
    var userIsLoggedIn = this.userIsLoggedIn;
    var stepsCount = this.stepsCollection.length;
    var tutorialFormattedCreateDuration = this.model.getFormattedDuration();
    var tutorialFormattedPlayDuration = this.model.getFormattedPlayDuration(this.stepsCollection);

    var realAccountType = this.model.get('editor_account_type') || // in case editor is previewing a theme (#2986)
      this.model.get('account_type');
    var isAccountNonFree = realAccountType !== 'free'; // this means a non-free user (private, premium or live plan). Yes it's misleading.
    var isOrWasPremium = this.model.get('isPremiumTutorial') || isAccountNonFree;

    return {
      liveBannerData,
      liveTabIsActive,
      quizTabIsActive,
      learnerChangedLanguage: iorad.player.controllers.language.learnerChangedLanguage(),
      title: this.model.get('title'),
      lastUpdated: this.model.getFormattedDate('updated'),
      lastEditorPublicName: this.model.get('last_editor_public_name'),
      lastEditorImg: iorad.player.controllers.sync.getLastEditorAvatarURL(),
      updateSubscriptionUrl: iorad.base.Settings.get('updateSubscription.url'),
      signupUrl: iorad.base.Settings.get('signup.url'),
      isOrWasPremium,
      userIsAuthor,
      userIsLoggedIn,
      stepsCount,
      tutorialFormattedCreateDuration,
      tutorialFormattedPlayDuration,
      copyright: iorad.player.controllers.views.getCopyright(),
      isLogoDisabled: this.model.getLayoutOption('is_logo_disabled'),
      isInfoDisabled: this.model.getLayoutOption('is_info_disabled'),
      isDurationDisabled: this.model.getLayoutOption('is_duration_disabled'),
      isStepsnumberDisabled: this.model.getLayoutOption('is_stepsnumber_disabled'),
      madeForFreeText: 'made this for free with iorad',
    };
  },

  renderLit: function ({
    learnerChangedLanguage,
    title,
    liveBannerData,
    liveTabIsActive,

    quizTabIsActive,
    isOrWasPremium,
    lastEditorImg,
    lastUpdated,
    lastEditorPublicName,
    tutorialFormattedCreateDuration,
    userIsAuthor,
    updateSubscriptionUrl,
    userIsLoggedIn,
    signupUrl,
    stepsCount,
    tutorialFormattedPlayDuration,
    copyright,
    isLogoDisabled,
    isInfoDisabled,
    isDurationDisabled,
    isStepsnumberDisabled,
    madeForFreeText,
  }) {
    const html = window.litHTML.html;
    return html`
      <div class="expanded-overlay">
      </div>
      <div class="header-themed header-font-color" aria-hidden="false" aria-label="Cover">
        <div class="header-inner cf">
          <div class="header-cover center">
            <a class="logo ${isLogoDisabled ? 'hide' : ''}" id="logo" href="/">
              <img alt="Logo" class="logo-image" src="" />
            </a>

            <div class="title">
              <h1 class="text ${!learnerChangedLanguage ? 'notranslate' : ''}">${quizTabIsActive ? 'Quiz: ' : ''}${title}</h1>
            </div>

            <div class="group-actions">
              <div class="buttons">
                ${liveTabIsActive ? (
                  (liveBannerData.type === 'waiting_live_redirect' ? html`
                    <div class="modalLiveRedirecting active">
                      <div class="modalLiveRedirecting_icon">
                        <svg width="70" height="50" viewBox="0 0 70 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect x="1" y="1" width="68" height="48" stroke="black" stroke-width="1.6" stroke-linejoin="bevel"/>
                          <path d="M46.8 49L46.8 33L69 33" stroke="black" stroke-width="1.6" stroke-linejoin="bevel"/>
                          <rect x="46" y="45" width="22.6667" height="4" fill="black"/>
                          <path d="M43 16V32" stroke="black" stroke-width="1.6" stroke-linejoin="round"/>
                          <path d="M40 19V29" stroke="black" stroke-width="1.6" stroke-linejoin="round"/>
                          <path d="M27 32L27 16" stroke="black" stroke-width="1.6" stroke-linejoin="round"/>
                          <path d="M30 29L30 19" stroke="black" stroke-width="1.6" stroke-linejoin="round"/>
                          <path d="M38 24C38 22.344 36.656 21 35 21C33.344 21 32 22.344 32 24C32 25.6575 33.344 27 35 27C36.656 27 38 25.6575 38 24Z" fill="black"/>
                        </svg>
                      </div>
                      <div class="modalLiveRedirecting_text">
                        ${liveBannerData.message}
                      </div>
                      <div class="modalLiveRedirecting_status">
                        ${liveBannerData.buttonText}
                      </div>
                    </div>
                    `
                    : liveBannerData.type === 'extension_installed' ? html`
                      <a
                        href="javascript:void(0);"
                        role="button"
                        class="cover-btn live active"
                        .innerHTML=${liveBannerData.buttonText}
                      />
                    `
                    :
                    html`
                      <div class="modalLive active">
                        <div class="modalLive_text">
                          ${liveBannerData.message}
                        </div>
                        <a
                          href="javascript:void(0);"
                          role="button"
                          href
                          class="modalLive_buttonStart cover-btn ignore-theme live active"
                          .innerHTML=${liveBannerData.buttonText}
                        />
                        <a
                          href="javascript:void(0);"
                          role="button"
                          class="modalLive_buttonSkip collapse-btn cover-btn ignore-theme default active"
                        >${i18next.t('Skip')}</a>
                      </div>
                    `)
                ) : ''}
                <button
                  aria-label="Start tutorial with Total Steps is ${stepsCount} and Completion Time is ${tutorialFormattedPlayDuration}"
                  class="collapse-btn cover-btn default ${!liveTabIsActive ? 'active' : ''}"
                >${i18next.t(quizTabIsActive ? 'Start Quiz' : 'Start Tutorial')}</button>
              </div>

              <div class="time ${isStepsnumberDisabled && isDurationDisabled ? 'hide' : ''}">
                <span class="${isStepsnumberDisabled ? 'hide' : ''}">Total Steps — ${stepsCount}</span>
                <span class="${isDurationDisabled ? 'hide' : ''}">Completion Time — ${tutorialFormattedPlayDuration}</span>
              </div>
            </div>

            <div class="footer">
              <div class="footer-inner">
              <div class="creator ${!isOrWasPremium ? 'hide_mobile' : ''} ${isInfoDisabled ? 'hide' : ''}"><img src=${lastEditorImg} /></div>
              <div class="details">
                <div class="details-phrase">
                  ${!isOrWasPremium ? html`
                    <div>
                      <div class="tooltip ${isInfoDisabled ? 'hide' : ''}">
                        <div class="tooltip-inner">${lastUpdated} — <span class="notranslate">${lastEditorPublicName}</span></div>
                        <div class="tooltip-text notranslate"><span>${lastUpdated} - ${lastEditorPublicName}</span></div>
                      </div>
                    </div>
                    <div class="made_for_free_text">
                      <div class="tooltip">
                        <div class="tooltip-inner">
                          <span>&nbsp;${madeForFreeText}</span>
                          <span class="${isDurationDisabled ? 'hide' : ''}">
                            in just ${tutorialFormattedCreateDuration}.
                          </span>
                        </div>
                        <div class="tooltip-text notranslate"><span>${madeForFreeText}${isDurationDisabled ? '' : ` - in just ${tutorialFormattedCreateDuration}.`}</span></div>
                      </div>

                      ${userIsAuthor ? html`
                      <a class="free_link" href=${updateSubscriptionUrl}>Remove this</a>
                      ` : ''}
                      ${!userIsLoggedIn ? html`
                        <a class="free_link" href=${signupUrl}>Join them</a>
                      ` : ''}
                    </div>
                  `
                  :
                  html`
                    <div class="tooltip ${isInfoDisabled ? 'hide' : ''}">
                      <div class="tooltip-inner">${lastUpdated} — <span class="notranslate">${lastEditorPublicName}</span></div>
                      <div class="tooltip-text notranslate"><span>${lastUpdated} - ${lastEditorPublicName}</span></div>
                    </div>
                  `}
                </div>
              </div>

              ${copyright ? html`
                <div class="copyright">
                  <div class="tooltip ${isInfoDisabled ? 'hide' : ''}">
                    <div class="tooltip-inner"><span class="notranslate">${copyright}</span></div>
                    <div class="tooltip-text notranslate"><span>${copyright}</span></div>
                  </div>
                </div>
              ` : ''}
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  },

  render: function() {
    const data = this.getTemplateData();
    const litTemplate = this.renderLit(data);
    window.litHTML.render(litTemplate, this.el);

    // TODO: make reactive
    const detailsEl = this.$('.header-themed .details');
    // reset visibility for proper checks
    detailsEl.removeClass('hide');
    this.$('.header-themed').removeClass('hide');
    // hide .details when is fully blank or when it only shows "made this for free with iorad"
    const detailsInnerTextTrimmed = detailsEl[0].innerText.trim();
    const madeForFreeText = this.$('.header-themed .made_for_free_text').text().trim() || ''; // also handles google translated text
    detailsEl.toggleClass(
      'hide',
      Boolean(
        detailsInnerTextTrimmed === '' ||
        (
          madeForFreeText &&
          detailsInnerTextTrimmed === (madeForFreeText + ' .')
        )
      )
    );
    // hide .header-themed if is fully blank OR if only copyright is visible
    const visibleCoverEls = this.$('.header-cover > *').toArray().filter(childEl => {
      return $(childEl).css('display') !== 'none';
    });
    this.$('.header-themed').toggleClass(
      'hide',
      Boolean(
        visibleCoverEls.length === 0 ||
        (
          visibleCoverEls.length === 1 &&
          $(visibleCoverEls[0]).hasClass('copyright')
        )
      )
    );

    this.onThemeApplied();
    this.updateAria();
    this.setTooltipOnOverflow();

    iorad.player.events.trigger('header:rendered');

    this.registerRenderOperations();

    return this;
  },

  setTooltipOnOverflow: _.debounce(function() {
    iorad.player.controllers.views.setTooltipOnOverflow(this.$('.header-themed .footer'), 'top');
  }, 200),

  registerRenderOperations: function() {
    iorad.player.controllers.views.registerImageElementRender('header.creatorImg', this.$('.creator img')[0]);
  },

  onThemeApplied: function() {
    var ic = iorad.player.controllers.views.getThemeColors();
    var ich = ic.header;

    this.$('#header-theme-styles').remove();
    var $headerThemeStyle = $('<style>')
      .attr({ id: 'header-theme-styles' })
      .html(`
        #header .header-inner .buttons .cover-btn:not(.ignore-theme) {
          background-color: ${ich.buttonBackground};
          color: ${ich.buttonFont};
        }
        #header .header-inner .buttons .cover-btn:not(.ignore-theme):hover {
          background-color: ${ich.dark ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.3)'};
        }
        #header .header-inner .header-cover {
          border-color: ${ich.borderColor};
        }
      `);
    /*#header .tooltip .tooltip-inner:after {
      background: linear-gradient(
        to left,
        ${ich.coverBackground} 13.81%,
        rgba(255, 255, 255, 0) 99.61%
      );
    }*/

    this.$('.header-inner').prepend($headerThemeStyle);

    if (
      iorad.player.router &&
      iorad.player.router.isPreviewMode()
    ) {
      // when cover closed or popup open
      $('#app-container').css({
        borderColor: '#CACACA',
      });
      // when cover open and popups closed
      $('#header .header-cover, #playbar .favicon-block').css({
        borderColor: 'transparent',
      });
      $('#header .header-themed').css({
        border: '',
        'border-bottom': '',
      });
      $('#playbar').css({
        border: '',
        'border-top': 'none',
      });
    } else if (
      iorad.player.getParameters.extensionEmbed === 'true' &&
      iorad.player.getParameters.social
    ) {
      // when cover closed or popup open
      $('#app-container').css({
        borderColor: 'transparent',
      });
      // when cover open and popups closed
      $('#header .header-cover, #playbar .favicon-block').css({
        borderColor: 'transparent',
      });
      $('#header .header-themed').css({
        border: '',
        'border-bottom': '',
      });
      $('#playbar').css({
        border: '',
        'border-top': 'none',
      });
    } else if (
      iorad.player.controllers.views.isCoverOpen() &&
      !iorad.player.controllers.views.isCoverCollapsing() &&
      !iorad.player.router.isExtensionMode() &&
      !iorad.player.getParameters.social
    ) {
      // when cover closed or popup open
      $('#app-container').css({
        borderColor: 'black',
      });
      // when cover open and popups closed
      $('#header .header-cover, #playbar .favicon-block').css({
        borderColor: '',
      });
      if (
        window.innerWidth <= 890 && // when .heder-themed is full size
        iorad.player.router &&
        iorad.player.router.isEmbedded()
      ) {
        // when cover open and popups closed => add border around player
        $('#header .header-themed').css({
          border: '1px solid rgba(0,0,0,.2)',
          'border-bottom': 'none',
        });
        $('#playbar').css({
          border: '1px solid rgba(0,0,0,.2)',
          'border-top': 'none',
        });
      } else {
        $('#header .header-themed').css({
          border: '',
          'border-bottom': '',
        });
        $('#playbar').css({
          border: '',
          'border-top': 'none',
        });
      }
    } else {
      // when cover closed or popup open
      $('#app-container').css({
        borderColor: '',
      });
      // when cover open and popups closed
      $('#header .header-cover, #playbar .favicon-block').css({
        borderColor: '',
      });
      $('#header .header-themed').css({
        border: '',
        'border-bottom': '',
      });
      $('#playbar').css({
        border: '',
        'border-top': 'none',
      });
    }
  },

  onLogoClick: function() {
    if (iorad.player.getParameters.themeSettings === 'true') {
      return true; // #14270
    }
    if (iorad.base.Utils.isEmbedded()) {
      // don't allow exiting from player if embedded
      return false;
    }
  },

  onModalLiveRedirectingClick: function (event) {
    event.stopPropagation();
  },
  onModalLiveClick: function (event) {
    event.stopPropagation();
  },
  getStepPosition: function() {
    const hash = Backbone.history.location.hash || window.location.hash;
    if (
      iorad.base.Utils.startsWith(hash, '#trysteps-') ||
      iorad.base.Utils.startsWith(hash, '#watchsteps-') ||
      iorad.base.Utils.startsWith(hash, '#mobilequick-') ||
      iorad.base.Utils.startsWith(hash, '#step-')
    ) {
      // check if the requested step exists
      const stepNumber = parseInt(hash.substring(hash.indexOf('-') + 1), 10);
      if (!isNaN(stepNumber) && stepNumber >= 1 && stepNumber <= iorad.player.data.stepsCollection.length) {
        return stepNumber;
      }
    }

    return 1;
  },

  onCollapseBtnClick: function(event) {
    var handle = _.bind(function() {
      var isControlledEmbed = iorad.player.router.isExtensionMode();
      if (
        event &&
        (
          iorad.player.tab === 'view' ||
          iorad.player.tab === 'try' ||
          iorad.player.tab === 'watch' ||
          iorad.player.tab === 'quiz'
        ) &&
        iorad.player.device !== 'desktop' &&
        !(
          iorad.player.data.tutorial.get('isMobile') &&
          iorad.player.tab === 'try'
        )
      ) {
        if (iorad.player.tab === 'view') {
          iorad.player.router.navigate('#viewsteps', { trigger: false });
        } else {
          const stepPosition = this.getStepPosition();
          iorad.player.router.navigateToInteractiveMode(iorad.player.tab, stepPosition, null, { trigger: false });
        }

        if (isControlledEmbed) {
          iorad.player.router.embedToggleTryMode(true);
        } else {
          iorad.player.controllers.views.toggleFullscreen();
        }
        return;
      }
      iorad.player.controllers.views.setCoverOpen(false);
    }, this);

    if (iorad.player.tab === 'quiz') {
      iorad.player.controllers.quiz.setupRecording()
        .then(handle, handle);
    } else {
      handle();
    }
  },

  // NOTE: event is optional
  onExpandBtnClick: function(event) {
    iorad.player.controllers.views.setCoverOpen(true, false, !!event);
  },

  updateAria: function() {
    var coverOpen = iorad.player.controllers.views.isCoverOpen();

    // VISIBILITY

    $(
      [
        '#main a',
        '#main [role="button"]',
        '#main button',
        '#main #playing-player .stepnav',
      ].join(', ')
    )
      .filter(_.bind(function (index, el) {
        return (
          $(el).closest('.step-infotext, .recommended-tutorials').length === 0
        );
      }, this))
      .css('visibility', (coverOpen) ? 'hidden' : '');
  },

  tryLive: function(e) {
    e.preventDefault();
    e.stopPropagation();
    iorad.player.controllers.live.tryLive();
  },
});

;
iorad.player.views.comments_editor = iorad.base.View.extend({
  template: iorad.player.templates.comments_editor,
  initialize: function (options) {
    options = options || {};
    this.options = options;

    this.render();

    this.countEl = this.$('.charNum');
    this.maxChars = typeof options.maxChars !== 'undefined' ? options.maxChars : 500;
    this.maxLineBreaks = typeof options.maxLineBreaks !== 'undefined' ? options.maxLineBreaks : Infinity;

    this.editorExpanded = false;
    this.editorWindowSelection = null;

    _.bindAll(this, 'onEditorValueChange', 'setCharCount');

    var wysihtml5ParserRules = {
      classes: {
        // white-listed classes
      },
      tags: {
        // white-listed elements
        '*': function (oldNode) {
          var className = (oldNode.classList && oldNode.getAttribute('class')) || '';
          if (className.indexOf('_wysihtml5-temp') >= 0) {
            // don't mess with internal nodes
            return {};
          }

          if (oldNode.nodeName === 'A') {
            return {
              set_attributes: {
                target: "_blank",
                rel: "nofollow",
                style: "",
              },
              check_attributes: {
                href: _.bind(function (link) {
                  var REG_EXP = /^(https?:\/\/|mailto:)/i;

                  link = (link || '').trim();
                  if (!link) return null;
                  if (!link.match(REG_EXP)) {
                    return 'https://' + link;
                  }
                  return link.replace(REG_EXP, function (match) {
                    return match.toLowerCase();
                  });
                }, this),
              }
            };
          }

          var markerColors = iorad.player.data.markerColors;
          var markerColorsDefaults = iorad.player.data.markerColors.defaults();
          var singleColor = markerColors.get('READ') || markerColorsDefaults.READ;
          var isPseudoBold = (
            (oldNode.nodeName === 'SPAN' || oldNode.nodeName === 'FONT') &&
            oldNode.style && oldNode.style.color &&
            iorad.base.Utils.areColorsEqual(oldNode.style.color, singleColor)
          );

          return {
            remove_attributes: 1,
            rename_tag: ['B', 'BR', 'U', 'UL', 'OL', 'LI', 'DIV'].indexOf(oldNode.nodeName) >= 0 ? '' // keep as is
              : (oldNode.nodeName === 'STRONG' || isPseudoBold) ? 'b'
                : 'span',
          };
        },
      }
    };

    this.editorFocused = false;

    this.editor = new wysihtml5.Editor(this.editorId || this.$('.comments-editor-textarea')[0], {
      name: 'comments-editor-iframe',
      toolbar: this.$('.comments-editor-toolbar')[0],
      parserRules: wysihtml5ParserRules,
      stylesheets: [iorad.base.Settings.get('player.wysihtml5.commentsStyleFilename')], // custom style
      cleanUp: false, // otherwise the span tags will be removed! (in Firefox)
      dynamicPlaceholder: true, // IORAD option
    });

    this.editor.on('load', _.bind(function (event) {
      this.editorWindow = this.$('.wysihtml5-sandbox')[0].contentWindow;

      $(this.editorWindow.document.body).on("keydown", _.bind(this.onEditorBodyKeydown, this));
      $(this.editorWindow.document.body).on("paste", _.bind(this.onEditorBodyPaste, this));
      $(this.editorWindow.document).on("selectionchange", _.bind(this.onEditorSelectionChange, this));
      this.updateStyle();
      this.observeLink();
    }, this));

    // TODO: these event handlers must be unbinded on view remove to avoid memory leaks
    this.editor.on('keyup', this.onEditorValueChange);
    this.editor.on('paste', this.onEditorValueChange);
    this.editor.on('change', this.onEditorValueChange);
    this.editor.on('focus', _.bind(this.onFocusEditor, this));
    this.editor.on('blur', _.bind(this.onBlurEditor, this));
    // update description and text count when applying complex tags that show dialog (like links) to text
    this.editor.on('show:dialog', _.bind(this.onDialogShow, this));
    this.editor.on('hide:dialog', _.bind(this.onDialogHide, this));
    this.editor.on('save:dialog', _.bind(this.onDialogSave, this));
    this.editor.on('beforeSave:dialog', _.bind(this.onDialogBeforeSave, this));
    this.editor.on('cancel:dialog', _.bind(this.onDialogCancel, this));
    this.editor.on('load', this.setCharCount);

    this.setEditorDynamicMaxHeight();

    this.listenToDOM(window, 'click', this.handleWindowClick, true);

    this.listenTo(iorad.player.data.themesCollection, 'change changeCurrent reset', this.updateStyle);
  },

  events: {
    // update description and text count when applying tags to text (bold, underline, etc.)
    'click .editor-list': 'onEditorValueChange',
    'input [data-wysihtml5-dialog-field="href"]': 'onLinkChange',
  },

  // NOTE: called from the outside
  updateStyle: function () {
    const currentTheme = iorad.player.data.themesCollection.get(
      iorad.player.data.tutorial.get('theme')
    );
    const ic = iorad.base.Export.themeToItemColors(
      currentTheme && currentTheme.attributes,
      iorad.player.data.tutorial.get('baseThemes'),
      iorad.player.data.tutorial.get('theme'),
      true // coverOpen
    );

    var markerColors = iorad.player.data.markerColors;

    var singleColor = markerColors.get('READ');
    var contrastColor = iorad.base.Export.getContrastColor(singleColor);

    if (this.editorWindow) {
      $('head style[data-id="iorad-custom-colors"]', this.editorWindow.document).remove();
      var style = this.editorWindow.document.createElement('style');
      style.setAttribute('data-id', 'iorad-custom-colors');
      style.innerText = [
        'body { ' + [
          'caret-color: ' + singleColor + ' !important',
        ].join('; ') + '  }',
        'b { ' + [
          'color: ' + singleColor + ' !important',
        ].join('; ') + '  }',
        'u { ' + [
          'background-color: ' + singleColor,
          'color: ' + contrastColor,
        ].join('; ') + '  }',
      ].join(' ');
      $(this.editorWindow.document.head).append(style);

      // FONTS
      var icf = ic.font;
      [
        {
          name: 'primary',
          family: icf.primaryFamily,
          defaultFamily: 'Libre Franklin',
        }, {
          name: 'secondary',
          family: icf.secondaryFamily,
          defaultFamily: 'Fahkwang',
        }
      ].forEach(_.bind(function (fontRule) {
        var dataId = 'iorad-custom-font-' + fontRule.name;
        var $existingFontEl = $('head style[data-id="' + dataId + '"]', this.editorWindow.document);
        if ($existingFontEl.attr('data-font-family') !== fontRule.family) {
          var promise = iorad.player.controllers.sync.getCustomFontCSSText(
            fontRule.family,
            fontRule.defaultFamily
          )
            .then(_.bind(function (cssText) {
              if (promise !== this.getCustomFontCSSTextPromises[dataId]) return; // too late
              var fontStyle = this.editorWindow.document.createElement('style');
              fontStyle.setAttribute('data-id', dataId);
              fontStyle.setAttribute('data-font-family', fontRule.family);
              fontStyle.innerHTML = cssText;
              $existingFontEl.remove();
              $(this.editorWindow.document.head).append(fontStyle);
              this.getCustomFontCSSTextPromises[dataId] = undefined;
            }, this))
            .catch(_.bind(function (err) {
              console.error(err);
              if (promise !== this.getCustomFontCSSTextPromises[dataId]) return; // too late
              this.getCustomFontCSSTextPromises[dataId] = undefined;
            }, this));
          this.getCustomFontCSSTextPromises = this.getCustomFontCSSTextPromises || {};
          this.getCustomFontCSSTextPromises[dataId] = promise;
        }
      }, this));
    }

    this.$('.editor-list.editor-bold svg path').attr('fill', singleColor);

    this.$('.editor-list.editor-underline svg').css('background', contrastColor);
    this.$('.editor-list.editor-underline svg path').attr('fill', singleColor);
  },

  // NOTE: called from the outside
  focus: function () {
    if (this.editor) {
      this.editor.focus(true);
    }
  },

  onFocusEditor: function () {
    this.editorFocused = true;
    this.removePlaceholder();
    this.expandEditor();
    this.options.onEditorFocus();
  },

  onBlurEditor: function () {
    this.editorFocused = false;
  },

  handleWindowClick: function (event) {
    var stepEditorEl = this.$('.comments-editor')[0];
    var outsideClick = (stepEditorEl !== event.target) &&
      !($.contains(stepEditorEl, event.target));
    if (outsideClick) {
      this.collapseEditor();
    } else {
      this.expandEditor();
    }
  },

  setEditorDynamicMaxHeight: function () {
    if (this.editorExpanded) return;

    this.$('.comments-editor').css('max-height', '');
    this.$('.comments-editor').css('flex-basis', '');

    var containerEl = this.$('.comments-wysihtml5-sandbox-container');
    containerEl.css('max-height', '');
    containerEl.css('flex-basis', '');
  },

  expandEditor: function () {
    if (this.editorExpanded) return;
    this.editorExpanded = true;

    this.editorWindow.document.body.style.height = 'auto'; // fit content without extra space
    var fullIframeHeight = this.editorWindow.document.body.scrollHeight;
    this.editorWindow.document.body.style.height = '';

    var containerEl = this.$('.comments-wysihtml5-sandbox-container');
    var fullContainerHeight = fullIframeHeight;
    var currentContainerHeight = parseInt(containerEl.height(), 10);
    if (fullContainerHeight > currentContainerHeight) {
      this.$('.comments-editor').css('max-height', 'none');
      containerEl.css({
        'max-height': 'none',
        'flex-basis': fullContainerHeight,
      });
    }
  },

  collapseEditor: function () {
    if (!this.editorExpanded) return;
    this.editorExpanded = false;

    var containerEl = this.$('.comments-wysihtml5-sandbox-container');
    this.$('.comments-editor').css('max-height', '');
    containerEl.css({
      'max-height': '',
      'flex-basis': '',
    });
    this.setEditorDynamicMaxHeight();
  },

  observeLink: function () {
    const editorLink = this.$('.comments-editor-link-dialog')[0];

    const observer = new MutationObserver(() => {
      if (!this.$(editorLink).is(':visible')) {
        this.resetLinkClasses();
      }
    });

    observer.observe(editorLink, {
      subtree: false,
      childList: false,
      attributes: true,
    });
  },

  resetLinkClasses: function () {
    this.$('.comments-editor')
      .removeClass('has-link-dialog-open')
      .removeClass('has-link-initial')
      .removeClass('has-link-initial-changed')
      .removeClass('has-link-error');
    this.$('[data-wysihtml5-dialog-action="save"]').removeClass('filled');
  },

  onDialogShow: function (obj) {
    if (obj.command === 'createLink') {
      var url = obj.dialogContainer.querySelector('input').value;
      this.initialLinkUrl = url;
      this.$('.comments-editor')
        .addClass('has-link-dialog-open')
        .toggleClass('has-link-initial', !!url)
        .removeClass('has-link-initial-changed')
        .removeClass('has-link-error');
      this.$('[data-wysihtml5-dialog-action="save"]').toggleClass('filled', Boolean(url.length > 0));

      this.editorValue = this.editor.getValue();
    }
  },

  onDialogHide: function (obj) {
    if (obj.command === 'createLink') {
      this.resetLinkClasses();
    }
  },

  onLinkChange: function (e) {
    var $input = $(e.currentTarget);
    var url = $input.val();
    this.$('.comments-editor').toggleClass('has-link-initial-changed', Boolean(this.initialLinkUrl && url !== this.initialLinkUrl));
    this.$('[data-wysihtml5-dialog-action="save"]').toggleClass('filled', Boolean(url.length > 0));
  },

  onDialogCancel: function (obj) {
    if (obj.command === 'createLink') {
      this.editor.composer.commands.exec('unlink');
      this.resetLinkClasses();
    }
  },

  onDialogBeforeSave: function (obj) {
    if (obj.command === 'createLink') {
      var REG_EXP = /^(https?:\/\/|mailto:)/i;

      var url = obj.dialogContainer.querySelector('input').value;

      if (url && !url.match(REG_EXP)) {
        url = 'https://' + url;

        obj.dialogContainer.querySelector('input').value = url;

        this.$('button[data-wysihtml5-dialog-action="save"]').click();

        throw new Error('Validating Url');
      }

      if (!this.isValidUrl(url)) {
        this.$('.comments-editor').addClass('has-link-error');

        // if (this.editorValue) {
        //   this.editor.setValue(this.editorValue);

        //   this.editorValue = null;
        // }

        throw new Error('Invalid Url');
      }

      this.$('.comments-editor').removeClass('has-link-error');
    }
  },

  onDialogSave: function (obj) {
    if (obj.command === 'createLink') {
      // HACK/FIX LIBRARY BUG: force apply parser rules
      // COMMENTED OUT since break the cursor position: https://github.com/iorad/iorad/issues/10470#issuecomment-787435560
      //this.editor.setValue(this.editor.getValue(), true);
      this.resetLinkClasses();
    }

    this.onEditorValueChange();
  },

  isValidUrl: function (string) {
    try {
      var url = new URL(string);

      if (string.match(/^(mailto:)/i)) {
        return true;
      }

      if (!url.host.split('.')[0] || !url.host.split('.')[1]) {
        return false;
      }
    } catch (_) {
      return false;
    }

    return true;
  },

  onEditorSelectionChange: function () {
    this.editorWindowSelection = this.editorWindow.document.getSelection();
  },

  onEditorBodyKeydown: function (event) {
    var editorText = this.getEditorText();
    var selectionText = this.editorWindowSelection
      ? this.editorWindowSelection.toString()
      : '';

    if (event.keyCode === 13) { // Enter
      // count newlines
      var editorTextLineBreaks = this.getTextLineBreaks(editorText);
      var selectionTextLineBreaks = this.getTextLineBreaks(selectionText);
      var newLineBreaks = (editorTextLineBreaks - selectionTextLineBreaks) + 1;
      if (newLineBreaks > this.maxLineBreaks) {
        this.toggleLineBreaksNoty({ visible: true });
        return false;
      }
    }

    var keyIsTyping =
      event.key !== 'Backspace' &&
      event.key !== 'Delete' &&
      event.key !== 'Enter' &&
      event.key !== 'ArrowLeft' &&
      event.key !== 'ArrowRight' &&
      event.key !== 'ArrowUp' &&
      event.key !== 'ArrowDown' &&
      !event.ctrlKey &&
      !event.metaKey;
    if (keyIsTyping) {
      var editorTextCharCount = this.getTextCharCount(editorText);
      var selectionTextCharCount = this.getTextCharCount(selectionText);

      var newCharCount = (editorTextCharCount - selectionTextCharCount) + 1;
      var goneover = newCharCount > this.maxChars;
      if (goneover) {
        this.toggleGoneoverNoty({ visible: true });
        return false;
      }
    }
  },

  onEditorBodyPaste: function (e) {
    var originalEvent = e.originalEvent || e;
    if (originalEvent.clipboardData && originalEvent.clipboardData.getData) {
      var pastedText = originalEvent.clipboardData.getData('text/plain');
      var editorText = this.getEditorText();
      var selectionText = this.editorWindow.getSelection().toString();

      var editorTextLineBreaks = this.getTextLineBreaks(editorText);
      var selectionTextLineBreaks = this.getTextLineBreaks(selectionText);
      var pastedTextLineBreaks = this.getTextLineBreaks(pastedText);
      var newLineBreaks = (editorTextLineBreaks - selectionTextLineBreaks) + pastedTextLineBreaks;
      if (newLineBreaks > this.maxLineBreaks) {
        e.preventDefault();
        this.toggleLineBreaksNoty({ visible: true });
      }

      var editorTextCharCount = this.getTextCharCount(editorText);
      var selectionTextCharCount = this.getTextCharCount(selectionText);
      var pastedTextCharCount = this.getTextCharCount(pastedText);
      var newCharCount = (editorTextCharCount - selectionTextCharCount) + pastedTextCharCount;
      var goneover = newCharCount > this.maxChars;
      if (goneover) {
        e.preventDefault();
        this.toggleGoneoverNoty({ visible: true });
      }
    }
  },

  onEditorValueChange: function () {
    const charCount = this.getTextCharCount(this.getEditorText());
    if (charCount <= this.maxChars) {
      this.options.onEditorValueChange(this.getEditorValue());
    }

    this.setCharCount();
  },

  fixEditorText: function (val, options) {
    options = options || {};

    // when pasting text, wysihtml5 appends an \uFEFF (zero-width white space) character! (library bug?)
    // we need to strip that from the string; for convenience, we also strip other common zero-width
    // utf8 characters, see http://stackoverflow.com/a/11305926
    val = val.replace(/[\u200B-\u200D\uFEFF]/g, '');

    // for some reason, wysihtml5 adds an 'invisible' extra <br> at the end of text
    // (starts happening once a newline is manually entered, even after deleting it)
    if (options.isHTML) {
      val = val.replace(/<br>$/, '');
    } else {
      val = val.replace(/\n$/, '');
    }

    return val;
  },

  // NOTE: called from the outside
  setEditorValue: function (description) {
    if (!this.editor) return;

    var descriptionText = iorad.base.Utils.stripHtmlTags(description, iorad.base.Export.STEP_DESCRIPTION_APP_SANITIZE_RULES);
    if (descriptionText) {
      if (this.getEditorValue() !== description) this.editor.setValue(description);
    } else {
      if (
        this.editor &&
        this.editor.composer
      ) {
        this.editor.composer.clear();
      }
      if (!this.editorFocused) {
        // show placeholder (https://github.com/iorad/iorad/issues/8554#issuecomment-631004006)
        this.editor.fire('set_placeholder');
      }
    }

    this.setCharCount();
  },

  // return the properly stripped editor value (HTML)
  // NOTE: also called from the outside
  getEditorValue: function () {
    var val = this.editor.getValue();
    return this.fixEditorText(val, { isHTML: true });
  },

  // NOTE: also called from the outside
  getEditorText: function () {
    if (!this.editorWindow || $(this.editorWindow.document.body).hasClass('placeholder')) {
      return '';
    }

    // get plain text, no html tags, includes newlines
    return this.fixEditorText(this.editorWindow.document.body.innerText);
  },

  // NOTE: assumes text is already fixed
  getTextCharCount: function (val) {
    // remove newlines as they don't count towards the char limit
    val = val.replace(/\n/g, '');
    return val.length;
  },

  // NOTE: assumes text is already fixed
  getTextLineBreaks: function (val) {
    return (val.match(/\n/g) || []).length;
  },

  setCharCount: function () {
    var charCount = this.getTextCharCount(this.getEditorText());

    var goneover = charCount > this.maxChars;
    this.$('.charNum').toggleClass('goneover', !!goneover);
    this.toggleGoneoverNoty({ visible: goneover, silent: true });

    this.countEl.text(charCount + '/' + this.maxChars);
  },

  toggleGoneoverNoty: function ({ visible, silent = false }) {
    if (!visible) {
      if (this.goneoverNoty) this.goneoverNoty.close();
    } else {
      if (!this.goneoverNoty && !silent) {
        this.goneoverNoty = noty({
          text: "The comment can't be more than " + this.maxChars + ' characters.',
          type: 'error',
          callback: {
            afterClose: _.bind(function () {
              this.goneoverNoty = undefined;
            }, this),
          },
        });
      }
    }
  },

  toggleLineBreaksNoty: function ({ visible, silent = false }) {
    if (!visible) {
      if (this.lineBreaksNoty) this.lineBreaksNoty.close();
    } else {
      if (!this.lineBreaksNoty && !silent) {
        this.lineBreaksNoty = noty({
          type: 'error',
          text: 'You have reached the maximum number of allowed lines.',
          callback: {
            afterClose: _.bind(function () {
              this.lineBreaksNoty = undefined;
            }, this),
          },
        });
      }
    }
  },

  // NOTE: called from the outside
  removePlaceholder: function () {
    if (this.editorWindow || $(this.editorWindow.document.body).hasClass('placeholder')) {
      this.editor.fire('unset_placeholder');
    }
  },

  // NOTE: called from the outside
  setPlaceholder: function (value) {
    this.$('.comments-editor-textarea').attr('placeholder', value);
    this.editor.fire('set_placeholder');
  },
});

;
iorad.player.views.layout_comments = iorad.base.View.extend({
  template: iorad.player.templates.layout_comments,

  events: {
    'click .header-popup': 'onHeaderPopupClick',
    'click .comments_editor_group_btn_save': 'onSaveClick',
    'click .comments_editor_group_btn_cancel': 'onCancelClick',
    'click .comments_list_item_userCommentsActions_reply': 'onReplyCommentClick',
    'click .comments_list_item_header_userCommentsActions_edit': 'onEditCommentClick',
    'click .comments_list_item_header_userCommentsActions_remove': 'onRemoveCommentClick',
    'click .comments_list_item_content a': 'openLink',
    'click .comments_editor_emoji_icon': 'onClickEmojiIcon',
    'click .comments_editor_emoji_item': 'onClickEmojiItem',
    'click .open_comment_btn': 'onOpenCommentClick',
    'click .comments_list_item--childs_toggle': 'onToggleChildsCommentClick',
    'click .close-comments-popup, .popup_overlay': 'onCloseCommentsPopupClick',
    'click .step_list_item[data-type="showTargetComments"]': 'onShowTargetComments',
    'click .step_list_item[data-type="addTargetComments"]': 'onAddTargetComments',
  },

  initialize: function () {
    this.tutorial = iorad.player.data.tutorial;
    this.stepsCollection = iorad.player.data.stepsCollection;

    this.emojisComponent = new iorad.player.EmojisComponent();
    this.wysihtml5Component = new iorad.player.Wysihtml5Component();

    this.fetchCache = {}; // { params, promise }
    this.getCommentListCache = {}; // { args, result }

    this.CONTENT_MAX_LENGTH = 250;
    this.CONTENT_MAX_LINE_BREAKS = 10;

    this.unseen = undefined; // boolean
    this.maxSeenTimeStampByTarget = {}; // <target, timestamp>

    this.stepCover = {
      target: 'cover',
      title: 'Cover',
      text: '',
    };

    this.model = new Backbone.Model({
      userIsLoggedIn: false,
      userCanComment: false,
      fullList: [],
      target: null,
      editingCommentId: undefined,
      replyingCommentId: undefined,
      emojisBlockIsShow: false,
      commentEditorIsShow: false,
      isShowStepList: true,
      expandCommentIds: [],
      showFromAdvanced: false,
    });
    this.listenTo(this.model, 'change', () => {
      this.checkUnseen();
      if (!this.$el.hasClass('visible')) return;
      this.render();
    });

    this.listenTo(this, 'checked', () => {
      if (!this.$el.hasClass('visible')) return;
      this.$el.removeClass('showing');
      // remder in case this check didn't change the model
      // if it changed while the view was still hidden
      this.render();
    });
    this.listenTo(this.tutorial, 'change', this.check);
    this.listenTo(this.stepsCollection, 'change changeCurrent reset', this.check);
    this.listenTo(iorad.player.events, 'ready tab change:coverOpen mode', this.check);
    this.listenTo(iorad.player.events, 'selectedTranslation', this.check);
    this.listenTo(iorad.player.events, 'press:esc', this.onCloseCommentsPopupClick);
    this.check();
  },

  fetch: function () {
    const newParams = {
      language_code: iorad.player.selectedTranslation,
    };
    if (!_.isEqual(this.fetchCache.params, newParams)) {
      this.fetchCache.params = newParams;
      this.fetchCache.promise = iorad.player.controllers.sync.listComments({
        assets_key: this.tutorial.get('assetsKey'),
        ...newParams,
      });
    }
    return this.fetchCache.promise;
  },

  // NOTE: also check while not visible for external "pink dot" new unseen comments indicator
  check: function () {
    if (!iorad.player.router || this.tutorial.isCommentingDisabled()) return;
    const promise = Promise.resolve()
      .then(() => {
        if (this.checkPromise !== promise) return Promise.resolve(); // too late

        // this.stepCover = {
        //   title: iorad.player.data.tutorial.get('title'),
        //   text: `Total Steps — ${this.stepsCollection.length}<br>Completion Time — ${iorad.player.data.tutorial.getFormattedPlayDuration(this.stepsCollection)}`,
        // }

        return Promise.all([
          this.fetch(),
          this.$el.hasClass('visible') ? this.emojisComponent.load() : Promise.resolve(), // lazy load before render
          this.$el.hasClass('visible') ? this.wysihtml5Component.load() : Promise.resolve(), // lazy load before render
        ])
          .then(([result]) => {
            if (this.checkPromise !== promise) return Promise.resolve(); // too late

            // only show comments related to either cover or current step
            const coverOpen = iorad.player.controllers.views.isCoverOpen();
            const currentStepIndex = Math.max(
              0,
              Math.min(
                this.stepsCollection.length - 1,
                this.stepsCollection.position
              )
            );
            const target = coverOpen ? 'cover' : ('step_' + currentStepIndex);

            let editingCommentId = this.model.get('editingCommentId');
            if (editingCommentId) {
              const editingCommentStillExists = result.fullList.some((aComment) => {
                return aComment.id === editingCommentId && aComment.target === target;
              });
              if (!editingCommentStillExists) {
                editingCommentId = undefined;
              }
            }
            let replyingCommentId = this.model.get('replyingCommentId');
            if (replyingCommentId) {
              const replyingCommentStillExists = result.fullList.some((aComment) => {
                return aComment.id === replyingCommentId && aComment.target === target;
              });
              if (!replyingCommentStillExists) {
                replyingCommentId = undefined;
              }
            }

            // const currentTargetHasComment = result.list.find((comment) => {
            //   return comment.target === target;
            // })

            this.model.set({
              userIsLoggedIn: result.userIsLoggedIn,
              userCanComment: result.userCanComment,
              fullList: result.list,
              target: target,
              // isShowStepList: !currentTargetHasComment,
              editingCommentId: editingCommentId,
              replyingCommentId: replyingCommentId,
            });

            this.trigger('checked');

            return Promise.resolve();
          });
      });
    this.checkPromise = promise;
  },

  calculateDescription: function (description) {
    description = sanitizeHtml(description, iorad.base.Export.STEP_DESCRIPTION_APP_SANITIZE_RULES);
    description = this.linkSteps(description);
    description = this.fixNonBreakingSpaces(description);
    return description;
  },

  // NOTE: description is already XSS safe
  linkSteps: function (description) {
    if (this.disableStepsLinking) return description;
    var routeHash = this.returnToTab === 'watch' ? 'watchsteps'
      : this.returnToTab === 'quiz' ? 'quizsteps'
        : 'trysteps';

    var stepLen = this.stepsCollection.length;

    function processNode(node) {
      if (node.nodeType === Node.TEXT_NODE) {

        // base: wrap "Step X" phrase with an anchor
        // (\b is word boundary)

        // we can't directly use node.nodeValue or node.textContent
        // to get the text content as that would decode html entities
        // and open to XSS vulnerabilities.
        var textGetter = document.createElement('div');
        textGetter.appendChild(node.cloneNode(true));

        var newHtml = textGetter.innerHTML.replace(/\b(Step (\d+))/gi, function (match, p1, p2) {
          if (p2 && parseInt(p2) <= stepLen) {
            return '<a href="#' + routeHash + '-' + p2 + '" data-self="true">' + p1 + '</a>';
          }

          return p1;
        });


        // parse html
        var newHtmlContainer = document.createElement('div');
        newHtmlContainer.innerHTML = newHtml;
        // replace text node with parsed nodes
        var newNodes = newHtmlContainer.childNodes;
        for (var i = 0; i < newNodes.length; i++) {
          node.parentNode.insertBefore(newNodes[i], node);
          i--; // child has been removed
        }
        node.parentNode.removeChild(node);

        return;
      }

      if (node.nodeType === Node.ELEMENT_NODE) {
        // recursion

        // ignore anchors!
        if (node.tagName === 'A') return;

        // process childs
        var childNodeList = node.childNodes; // NodeList
        for (var i = 0; i < childNodeList.length; i++) {
          var childNode = childNodeList[i];
          processNode(childNode);
        }
      }
    }

    var container = document.createElement('div');
    container.innerHTML = description;
    processNode(container);
    return container.innerHTML;
  },

  fixNonBreakingSpaces: function (description) {
    // https://stackoverflow.com/a/24469190
    // add a <wbr> element after the sequence of &nbsp;
    // thus keeping the spaces but still allowing line breaks
    return description.replace(/(&nbsp;)+/g, '$&<wbr>');
  },

  // NOTE: memoized with last arguments
  getCommentList: function (fullList, target) {
    const newArgs = Array.prototype.slice.call(arguments);
    if (!_.isEqual(this.getCommentListCache.args, newArgs)) {
      const targetCommentList = fullList
        .filter((comment) => {
          return comment.target === target;
        })
        .map(comment => {
          return {
            ...comment,
            user__public_name: comment.current_user__owns ? 'You' : comment.user__public_name,
            contentParsed: this.calculateDescription(comment.content),
          };
        });

      // parent comments sorted
      const commentParentListSorted = targetCommentList
        .filter(comment => !comment.parent_tutorial_comment_id)
        .sort((commentA, commentB) => {
          // date_created ASC
          return new Date(commentA.date_created).getTime() - new Date(commentB.date_created).getTime();
        });
      // sort and map child comments
      const commentListSorted = commentParentListSorted.map(comment => {
        const childs = targetCommentList
          .filter(childComment => childComment.parent_tutorial_comment_id === comment.id)
          .sort((commentA, commentB) => {
            // date_created ASC
            return new Date(commentA.date_created).getTime() - new Date(commentB.date_created).getTime();
          });
        return {
          ...comment,
          childs,
        };
      });

      this.getCommentListCache.args = newArgs;
      this.getCommentListCache.result = commentListSorted;
    }
    return this.getCommentListCache.result;
  },

  // calculate derived props here based on commentList to
  // avoid creating a new list everytime on this.check to
  // avoid extra useless renders
  // NOTE: only use props from modelJson or static data that never change,
  //       otherwise move them to this.check
  getTemplateData: function () {
    const modelJson = this.model.toJSON();

    const stepList = [{
      ...this.stepCover,
      commentsCount: modelJson.fullList.filter(comment => comment.target === `cover`).length
    }].concat(this.stepsCollection.map(stepModel => {
      const stepIndex = stepModel.get('index');
      const target = `step_${stepIndex}`;
      return {
        target,
        title: `Step ${stepIndex+1}`,
        text: sanitizeHtml(stepModel.get('description'), iorad.base.Export.STEP_DESCRIPTION_APP_SANITIZE_RULES),
        commentsCount: modelJson.fullList.filter(comment => comment.target === target).length
      }
    }));

    const allCommentsCount = stepList.reduce((result, step) => result + step.commentsCount, 0);
    const commentList = this.getCommentList(modelJson.fullList, modelJson.target);
    const commentListIsNonEmpty = commentList.length !== 0;
    const coverOpen = iorad.player.controllers.views.isCoverOpen();
    const currentStepIndex = Math.max(
      0,
      Math.min(
        this.stepsCollection.length - 1,
        this.stepsCollection.position
      )
    );
    const currentStepTarget = coverOpen ? 'cover' : ('step_' + currentStepIndex);

    return _.extend({}, modelJson, {
      allCommentsCount,
      stepList,
      commentList,
      commentListIsNonEmpty,
      editingOrReplying: Boolean(modelJson.editingCommentId || modelJson.replyingCommentId),
      replyingComment: commentList.find(comment => comment.id === modelJson.replyingCommentId),
      signinUrl: iorad.base.Settings.get('login.url'),
      emojis: window.emojis || [],
      editorPlaceholder: i18next.t(
        modelJson.replyingCommentId ? 'Type your comment here'
          : modelJson.editingCommentId ? 'Type your updated comment here'
            : 'Type your comments here'
      ),
      currentStepTarget,
    });
  },

  render: function () {
    const oldTemplateData = this.templateData || {};
    this.templateData = this.getTemplateData();

    window.litHTML.render(this.template(this.templateData), this.el);

    const editorEl = this.$('.comments_editor_control_content')[0];
    if (editorEl && typeof wysihtml5 !== 'undefined') {
      if (!this.editorView) {
        this.editorView = new iorad.player.views.comments_editor({
          el: editorEl,
          maxChars: this.CONTENT_MAX_LENGTH,
          maxLineBreaks: this.CONTENT_MAX_LINE_BREAKS,
          onEditorValueChange: () => {
            if (!this.editorView) return;
            this.updateEditor(this.templateData);
          },
          onEditorFocus: () => {
            if (this.model.get('emojisBlockIsShow')) {
              this.onCloseEmojisBlock();
            }
          },
        });
      } else {
        if (editorEl !== this.editorView.el) {
          $(editorEl).replaceWith(this.editorView.el);
        }
      }
    }

    this.componentDidUpdate(oldTemplateData);

    return this;
  },

  componentDidUpdate: function (oldTemplateData) {
    this.updateEditor(oldTemplateData);
  },

  updateEditor: function (oldTemplateData) {
    if (!this.model.get('userIsLoggedIn') || typeof wysihtml5 === 'undefined') return;
    if (oldTemplateData.editorPlaceholder !== this.templateData.editorPlaceholder) {
      this.editorView.setPlaceholder(this.templateData.editorPlaceholder);
    }

    if (
      oldTemplateData.editingCommentId !== this.templateData.editingCommentId &&
      this.templateData.editingCommentId
    ) {
      const editingComment = this.templateData.commentList.find((aComment) => {
        return aComment.id === this.templateData.editingCommentId;
      });
      this.editorView.setEditorValue(editingComment.content);
    }
    if (
      oldTemplateData.editingCommentId !== this.templateData.editingCommentId &&
      !this.templateData.editingCommentId
    ) {
      this.editorView.setEditorValue('');
    }

    if (
      oldTemplateData.replyingCommentId !== this.templateData.replyingCommentId
    ) {
      this.editorView.setEditorValue('');
    }

    if (
      oldTemplateData.commentEditorIsShow !== this.templateData.commentEditorIsShow &&
      this.templateData.commentEditorIsShow
    ) {
      this.editorView.focus();
    }

    const editorText = this.editorView.getEditorText() || '';
    this.$('.comments_editor_group_btn_save').prop(
      'disabled',
      editorText.trim().length === 0
    );

    // for current target, store last seen max date_created from other users (or all if logged out)
    if (
      this.templateData.target !== oldTemplateData.target ||
      this.templateData.commentList !== oldTemplateData.commentList
    ) {
      const maxSeenTimeStamp = this.getMaxOtherTimeStamp(this.templateData);
      if (maxSeenTimeStamp) {
        this.maxSeenTimeStampByTarget[this.templateData.target] = maxSeenTimeStamp;
        try {
          localStorage.setItem('iorad-player-comments-' + iorad.player.tutorialId + '-target-' + this.templateData.target + '-maxSeenTimeStamp', maxSeenTimeStamp);
        } catch (err) {
          // 3rd party cookies/data are disabled
          console.error(err);
        }
      }
      this.checkUnseen();
    }
  },

  // NOTE: also called from the outside
  getMaxOtherTimeStamp: function (templateData) {
    templateData = templateData || this.getTemplateData();
    const otherTimeStampList = templateData.commentList
      .filter((comment) => {
        return !comment.current_user__owns;
      })
      .map((comment) => {
        return new Date(comment.date_created).getTime();
      });
    return otherTimeStampList.length > 0 ?
      Math.max.apply(Math, otherTimeStampList)
      : null;
  },

  checkUnseen: function () {
    const newUnseen = (() => {
      const templateData = this.getTemplateData();
      const maxOtherTimeStamp = this.getMaxOtherTimeStamp(templateData);
      if (maxOtherTimeStamp) {
        const target = templateData.target;
        let maxSeenTimeStamp = null;
        try {
          maxSeenTimeStamp = (
            this.maxSeenTimeStampByTarget[target] ||
            Number(localStorage.getItem('iorad-player-comments-' + iorad.player.tutorialId + '-target-' + target + '-maxSeenTimeStamp')) ||
            null
          );
        } catch (err) {
          // 3rd party cookies/data are disabled
          console.error(err);
        }
        if (
          !maxSeenTimeStamp ||
          (maxSeenTimeStamp < maxOtherTimeStamp)
        ) {
          return true;
        }
      }

      return false;
    })();
    if (newUnseen !== this.unseen) {
      this.unseen = newUnseen;
      this.trigger('change:unseen', this.unseen);
    }
  },

  // NOTE: called from the outside
  isVisible: function () {
    return this.$el.hasClass('visible');
  },

  // NOTE: called from the outside
  show: function () {
    if (this.$el.hasClass('visible')) return;
    this.$el.addClass('visible');
    this.$el.addClass('showing');
    this.check();
    this.returnToTab = iorad.player.tab;
    iorad.player.router.changeTab('comments');
    iorad.player.events.trigger('comments:show');
    iorad.base.Utils.accessibilityFocus(this.$el);
  },

  // NOTE: called from the outside
  hide: function () {
    if (!this.$el.hasClass('visible')) return;
    if (this.removeCommentNoty) {
      this.removeCommentNoty.close();
    }
    iorad.player.router.changeTab(this.returnToTab);
    this.$el.removeClass('visible');
    this.$el.removeClass('showing');

    iorad.player.events.trigger('comments:hide');
    iorad.base.Utils.accessibilityFocusBack(this.$el);
  },

  toggle: function (value) {
    if (typeof value === 'undefined') {
      value = !this.isVisible();
    }
    if (value) this.show();
    else this.hide();
  },

  // NOTE: called from the outside
  setShowFromAdvanced: function () {
    this.model.set({
      showFromAdvanced: true,
    });
  },

  onHeaderPopupClick: function () {
    this.hide();
  },

  onSaveClick: function () {
    const replyingCommentId = this.model.get('replyingCommentId');
    const editingCommentId = this.model.get('editingCommentId');
    const content = this.editorView.getEditorValue();

    const syncPromise = editingCommentId ?
      iorad.player.controllers.sync.editComment({
        tutorial_comment_id: editingCommentId,
        action: 'update',
        language_code: iorad.player.selectedTranslation,
        content: content,
      })
      :
      iorad.player.controllers.sync.createComment({
        assets_key: this.tutorial.get('assetsKey'),
        parent_tutorial_comment_id: replyingCommentId,
        answer_id: iorad.player.answerId,
        target: this.model.get('target'),
        language_code: iorad.player.selectedTranslation,
        content: content,
      });
    syncPromise
      .then((result) => {
        return iorad.player.controllers.sync.listComments({
          assets_key: this.tutorial.get('assetsKey'),
          tutorial_comment_id: editingCommentId || result.tutorialCommentId,
          language_code: iorad.player.selectedTranslation,
        });
      })
      .then((listResult) => {
        if (!editingCommentId && !replyingCommentId) {
          this.editorView.setEditorValue('');
        }

        const newComment = listResult.list[0];
        const fullList = this.model.get('fullList');
        let newFullList;
        let commentNoty = 'Comment posted';
        if (replyingCommentId) {
          newFullList = fullList.concat([newComment]);
          this.model.set({
            fullList: newFullList,
            replyingCommentId: undefined,
          });
        } else if (editingCommentId) {
          // replace edited comment
          const editingCommentIndex = fullList.findIndex((aComment) => {
            return aComment.id === editingCommentId;
          });
          newFullList = []
            .concat(fullList.slice(0, editingCommentIndex))
            .concat([newComment])
            .concat(fullList.slice(editingCommentIndex + 1));
          this.model.set({
            fullList: newFullList,
            editingCommentId: undefined,
          });
          commentNoty = 'Comment edited';
        } else {
          newFullList = fullList.concat([newComment]);
          this.model.set({
            fullList: newFullList,
          });
        }
        this.model.set({
          commentEditorIsShow: false,
        });
        this.fetchCache = {
          ...this.fetchCache,
          promise: this.fetchCache.promise.then(result => ({
            ...result,
            list: newFullList,
          })),
        };
        noty({
          type: 'success',
          text: commentNoty,
        });
      })
      .catch((err) => {
        console.error(err);
        noty({
          type: 'error',
          text: 'Operation failed.',
        });
      });
  },

  onCancelClick: function () {
    this.model.set({
      editingCommentId: undefined,
      replyingCommentId: undefined,
      commentEditorIsShow: false,
    });
  },

  onReplyCommentClick: function (e) {
    const commentId = Number($(e.currentTarget).closest('[data-id]').attr('data-id'));
    this.model.set({
      replyingCommentId: commentId,
      commentEditorIsShow: true,
    });
  },

  onEditCommentClick: function (e) {
    const commentId = Number($(e.currentTarget).closest('[data-id]').attr('data-id'));
    this.model.set({
      editingCommentId: commentId,
      commentEditorIsShow: true,
    });
  },

  onRemoveCommentClick: function (e) {
    const commentId = Number($(e.currentTarget).closest('[data-id]').attr('data-id'));

    if (this.removeCommentNoty) {
      this.removeCommentNoty.close();
    }
    this.removeCommentNoty = noty({
      text: 'Are you sure? This is permanent.',
      type: 'information',
      buttons: [{
        addClass: 'btn btn-primary btn-green btn-small',
        text: 'Yes',
        onClick: _.bind(function ($noty) {
          $noty.close();

          iorad.player.controllers.sync.editComment({
            tutorial_comment_id: commentId,
            action: 'remove',
          })
            .then(() => {
              const newFullList = this.model.get('fullList').filter((aComment) => {
                return aComment.id !== commentId && aComment.parent_tutorial_comment_id !== commentId;
              });
              this.model.set({
                fullList: newFullList,
              });
              this.fetchCache = {
                ...this.fetchCache,
                promise: this.fetchCache.promise.then(result => ({
                  ...result,
                  list: newFullList,
                })),
              };
              noty({
                type: 'success',
                text: 'Comment deleted',
              });
            })
            .catch((err) => {
              console.error(err);
              noty({
                type: 'error',
                text: 'Operation failed.',
              });
            });
        }, this),
      }],
      callback: {
        afterClose: () => {
          this.removeCommentNoty = undefined;
        },
      },
    });
  },

  // Open links manually in another window by default.
  openLink: function (event) {
    var anchor = $(event.currentTarget);
    var href = anchor.attr('href');

    var isInternalPlayerUrl = anchor.attr('data-self') === 'true';

    var isShortPlayerUrl = anchor[0].hostname === 'ior.ad' &&
      !anchor[0].pathname.startsWith('/live/');
    var isRegularPlayerUrl = (
      anchor[0].hostname.endsWith('.iorad.com') ||
      anchor[0].hostname.endsWith('.iorad.dev') ||
      (window.IORAD_ROOT && new RegExp('^https?://' + anchor[0].hostname + '$').test(window.IORAD_ROOT)) ||
      (!window.IORAD_ROOT && anchor[0].hostname === document.location.hostname)
    ) && anchor[0].pathname.startsWith('/player/');
    var isExternalPlayerUrl = (isShortPlayerUrl || isRegularPlayerUrl) &&
      !isInternalPlayerUrl;

    var url;
    if (isExternalPlayerUrl) {
      var newAnchorQuery = iorad.base.Utils.getUrlParameters(href);
      if (iorad.player.router.isExtensionMode()) {
        newAnchorQuery.extensionEmbed = 'true';
        if (iorad.player.getParameters.playerExtensionWidth) {
          newAnchorQuery.playerExtensionWidth = iorad.player.getParameters.playerExtensionWidth;
        }
        if (iorad.player.getParameters.widgetEmbed === 'true') {
          newAnchorQuery.widgetEmbed = 'true';
        }
        newAnchorQuery.device = (iorad.player.data.tutorial.get('extensionDevice') || '');
      }
      if (iorad.player.router.isHelpcenterMode()) {
        newAnchorQuery.helpcenter = iorad.player.getParameters.helpcenter;
        if (iorad.player.getParameters.roleId) {
          newAnchorQuery.roleId = iorad.player.getParameters.roleId;
        }
      }
      if (iorad.player.getParameters.embedUrl) {
        newAnchorQuery.embedUrl = iorad.player.getParameters.embedUrl;
      }

      url = iorad.base.Utils.createUrl({
        base: 'https://' + anchor[0].hostname + anchor[0].pathname,
        urlParameters: newAnchorQuery,
        hash: anchor[0].hash,
      });
    } else {
      url = href;
    }

    var isNewWindow = isInternalPlayerUrl ? iorad.player.mode === 'mobilequick' // mobile can't show trysteps
      // : isExternalPlayerUrl ? iorad.player.router.isPreviewMode()
      : true;
    if (!isNewWindow) {
      // close popup first
      this.onCloseCommentsPopupClick();
      iorad.player.controllers.views.setCoverOpen(false, true);
    }
    siteWindow.ioradNodeApp.setLocation(url, {
      isNewWindow: isNewWindow,
      isAssign: isExternalPlayerUrl && !isNewWindow, // allow browser history back
    });
    return false;
  },

  onClickEmojiIcon: function () {
    this.model.set({
      emojisBlockIsShow: !this.model.get('emojisBlockIsShow'),
    });
  },

  onCloseEmojisBlock: function () {
    this.model.set({
      emojisBlockIsShow: false,
    });
  },

  onClickEmojiItem: function (e) {
    const emoji = this.$(e.currentTarget).data('value');
    const content = this.editorView.getEditorValue();
    if (!content) {
      this.editorView.removePlaceholder();
    }
    this.editorView.editor.composer.commands.exec('insertHTML', `<span>${emoji}</span>`);
    this.onCloseEmojisBlock();
  },

  onOpenCommentClick: function (e) {
    this.model.set({
      commentEditorIsShow: true,
    });
  },

  onToggleChildsCommentClick: function (e) {
    const commentId = this.$(e.currentTarget).data('id');
    const expandCommentIds = this.model.get('expandCommentIds');
    const commentIndex = expandCommentIds.indexOf(commentId);
    const newExpandCommentIds = expandCommentIds.slice();
    if (commentIndex > -1) {
      newExpandCommentIds.splice(commentIndex, 1);
    } else {
      newExpandCommentIds.push(commentId);
    }
    this.model.set({
      expandCommentIds: newExpandCommentIds,
    });
  },

  onShowStepList: function() {
    this.model.set({
      isShowStepList: true,
      commentEditorIsShow: false,
    });
  },

  onShowTargetComments: function (e) {
    const target = $(e.currentTarget).data('target');

    this.model.set({
      target,
      isShowStepList: false,
    });

    iorad.player.router.stepsView.onStepItemClick(null, target === 'cover' ? 0 : Number(target.replace('step_', '')) + 1);

    // TODO: should focus on first comment or add comment button
    iorad.base.Utils.accessibilityFocus(this.$el);
  },

  onAddTargetComments: function (e) {
    const target = $(e.currentTarget).data('target');

    this.model.set({
      target,
      isShowStepList: false,
      commentEditorIsShow: true,
    });

    iorad.player.router.stepsView.onStepItemClick(null, target === 'cover' ? 0 : Number(target.replace('step_', '')) + 1);
  },

  onCloseCommentsPopupClick: function (e) {
    if (!this.isVisible()) return;

    if (e) {
      e.preventDefault();
    }
    if (this.model.get('editingCommentId') || this.model.get('replyingCommentId')) {
      this.onCancelClick();
      return;
    }
    if (!this.model.get('isShowStepList')) {
      this.onShowStepList();
    } else {
      if (!this.model.get('showFromAdvanced')) {
        iorad.player.router.togglePlayerPopup(false);
      }
      iorad.player.router.commentsView.toggle();
    }
  },
});

;
iorad.player.views.layout_share = iorad.base.View.extend({
  template: iorad.player.templates.layout_share,

  events: {
    'click .close-share-popup, .popup_overlay': 'onCloseSharePopupClick',
    'click .share-container_inner_shareList_shareItem[data-type="mode"]': 'onToggleDropdown',
    'click .close-mode-popup': 'onToggleDropdown',
    'click .mode-item': 'onDropdownItemClick',

    'focus .mode-filter': 'handleSearchFocus',
    'blur .mode-filter': 'handleSearchBlur',
    'change .mode-filter': 'handleSearchChange',
    'paste .mode-filter': 'handleSearchChange',
    'keyup .mode-filter': 'handleSearchChange',
  },

  initialize: function () {
    this.tutorial = iorad.player.data.tutorial;
    this.stepsCollection = iorad.player.data.stepsCollection;

    this.model = new Backbone.Model({
      playerMode: '',
      modePopupSearchIsFocus: false,
      modePopupSearchList: [],
      modePopupVisibled: false,
      showFromAdvanced: false,
    });

    this.listenTo(this.model, 'change', this.check);
    this.listenTo(this.tutorial, 'change', this.check);
    this.listenTo(
      this.stepsCollection,
      'change changeCurrent reset',
      this.check
    );
    this.listenTo(
      iorad.player.events,
      'ready tab mode device change:coverOpen',
      this.check
    );
    this.listenTo(iorad.player.events, 'press:esc', this.onCloseSharePopupClick);

    var client = new Clipboard('.share-container_inner_shareList_shareItem[data-copy="true"]');
    client.on('success', this.onCopySuccess);

    this.check();
  },

  check: function () {
    if (!iorad.player.router || !this.$el.hasClass('visible')) return;
    this.$el.removeClass('showing');
    this.render();
  },

  getModeOptions: function () {
    const modeOptions = [
      // {
      //   label: 'Default',
      //   value: 'default',
      //   disabled: false,
      // },
      {
        label: i18next.t('Try'),
        value: 'trysteps-1',
        tab: 'try',
        disabled: false,
      },
      {
        label: i18next.t('Scroll'),
        value: 'viewsteps',
        tab: 'view',
        disabled: false,
      },
      {
        label: i18next.t('Slide'),
        value: 'mobilequick-1',
        tab: 'slide',
        disabled: false,
      },
      {
        label: i18next.t('Watch'),
        value: 'watchsteps-1',
        tab: 'watch',
        disabled: false,
      },
      {
        label: i18next.t('Quiz'),
        value: 'quizsteps-1',
        tab: 'quiz',
        disabled: !(
          iorad.player.router.isQuizTabAvailable() &&
          !this.tutorial.getLayoutOption('is_quizsteps_disabled')
        ),
      },
      {
        label: i18next.t('Live'),
        value: 'live',
        tab: 'live',
        disabled: !(
          this.tutorial.isDoItAvailable() &&
          !this.tutorial.getLayoutOption('is_live_disabled')
        ),
      },
    ];
    return modeOptions;
  },

  getInitialPlayerMode: function () {
    const activeTab = iorad.player.controllers.views.isModalTab(iorad.player.tab) ? iorad.player.oldTab : iorad.player.tab;
    const modeOptions = this.getModeOptions();
    const visibleModeOptions = modeOptions.filter(option => !option.disabled);
    const initialPlayerMode = visibleModeOptions.find(o => o.tab === activeTab) || visibleModeOptions[0];
    return initialPlayerMode.value;
  },

  getTemplateData: function () {
    const playerMode = this.model.get('playerMode');
    const modeOptions = this.getModeOptions();
    const visibleModeOptions = modeOptions.filter(option => !option.disabled);
    const selectedModeOption = visibleModeOptions.find(o => o.value === playerMode) || visibleModeOptions[0];

    return {
      visibleModeOptions,
      selectedModeOption,
      modePopupSearchIsFocus: this.model.get('modePopupSearchIsFocus'),
      modePopupSearchList: this.model.get('modePopupSearchList'),
      modePopupVisibled: this.model.get('modePopupVisibled'),
      showFromAdvanced: this.model.get('showFromAdvanced'),
    };
  },

  render: function () {
    const oldTemplateData = this.templateData || {};
    this.templateData = this.getTemplateData();

    window.litHTML.render(this.template(this.templateData), this.el);

    this.componentDidUpdate(oldTemplateData);

    return this;
  },

  componentDidUpdate: function (oldTemplateData) {
    const playerMode = this.model.get('playerMode');
    const iframeHash = playerMode === 'default' ? '' : playerMode;
    iorad.player.controllers.sync.getPlayerURL()
      .then(_.bind(function (playerUrlData) {
        var shortLink = !iframeHash ?
          playerUrlData.SHORT_LINK
          :
          iorad.base.Utils.replaceAll(
            playerUrlData.SHORT_LINK_IFRAME_HASH_TEMPLATE,
            encodeURIComponent('{{IORAD_IFRAME_HASH_PLACEHOLDER}}'),
            iframeHash
          );
        var publicLink = !iframeHash ?
          playerUrlData.PUBLIC_LINK
          :
          iorad.base.Utils.replaceAll(
            playerUrlData.PUBLIC_LINK_IFRAME_HASH_TEMPLATE,
            encodeURIComponent('{{IORAD_IFRAME_HASH_PLACEHOLDER}}'),
            iframeHash
          );
        var embed = !iframeHash ?
          playerUrlData.EMBED
          :
          iorad.base.Utils.replaceAll(
            playerUrlData.EMBED_IFRAME_HASH_TEMPLATE,
            encodeURIComponent('{{IORAD_IFRAME_HASH_PLACEHOLDER}}'),
            iframeHash
          );

        this.$('.share-container_inner_shareList_shareItem[data-type="copy-url"]').attr('data-clipboard-text', publicLink);
        this.$('.share-container_inner_shareList_shareItem[data-type="copy-short"]').attr('data-clipboard-text', shortLink || publicLink);
        this.$('.share-container_inner_shareList_shareItem[data-type="copy-embed"]').attr('data-clipboard-text', embed);
      }, this));
  },

  onCopySuccess: function (event) {
    var button = $(event.trigger);
    var label = button.find('.share-container_inner_shareList_shareItem_label');
    var html = label.html();

    label.html(i18next.t('Copied'));

    setTimeout(function () {
      label.html(html);
    }, 3000);
  },

  onToggleAccessibilityFocusForModePopup: function(show) {
    const $target = this.$el.find('#share-select-mode-popup');
    if (show) {
      iorad.base.Utils.accessibilityFocus($target);
    } else {
      iorad.base.Utils.accessibilityFocusBack($target);
    }
  },

  onToggleDropdown: function (e) {
    e.preventDefault();
    this.model.set({
      modePopupVisibled: !this.model.get('modePopupVisibled'),
    });
    this.onToggleAccessibilityFocusForModePopup(this.model.get('modePopupVisibled'));
  },

  onDropdownItemClick: function (e) {
    const newPlayerMode = $(e.currentTarget).attr('data-value');
    this.model.set('playerMode', newPlayerMode);
    this.model.set({
      modePopupVisibled: false,
    });
  },

  handleSearchFocus: function () {
    this.model.set({
      modePopupSearchIsFocus: true,
    });
  },

  handleSearchBlur: function (event) {
    const value = $(event.currentTarget).val();
    if (!value) {
      this.model.set({
        modePopupSearchIsFocus: false,
      });
    }
  },

  handleSearchChange: function (event) {
    const key = $(event.target).val().toLowerCase().trim();

    if (!key) {
      this.model.set({
        modePopupSearchList: []
      });

      return;
    }

    const filteredList = this.templateData.visibleModeOptions
      .filter((item) => item.label.toLowerCase().startsWith(key))
      .map(item => item.label);

    this.model.set({
      modePopupSearchList: filteredList
    });
  },

  // NOTE: called from the outside
  isVisible: function () {
    return this.$el.hasClass('visible');
  },

  // NOTE: called from the outside
  show: function () {
    if (this.$el.hasClass('visible')) return;
    this.$el.addClass('visible');
    this.$el.addClass('showing');
    this.model.set('playerMode', this.getInitialPlayerMode(), { silent: true });
    this.check();
    this.returnToTab = iorad.player.tab;
    iorad.player.router.changeTab('share');
    iorad.player.events.trigger('share:show');
    iorad.base.Utils.accessibilityFocus(this.$el);
  },

  // NOTE: called from the outside
  hide: function () {
    if (!this.$el.hasClass('visible')) return;
    iorad.player.router.changeTab(this.returnToTab);
    this.$el.removeClass('visible');
    this.$el.removeClass('showing');

    iorad.player.events.trigger('share:hide');
    iorad.base.Utils.accessibilityFocusBack(this.$el);
  },

  toggle: function (value) {
    if (typeof value === 'undefined') {
      value = !this.isVisible();
    }
    if (value) this.show();
    else this.hide();
  },

  // NOTE: called from the outside
  setShowFromAdvanced: function () {
    this.model.set({
      showFromAdvanced: true,
    });
  },

  onCloseSharePopupClick: function (event) {
    if (!this.isVisible()) return;
    event && event.preventDefault();
    if (this.model.get('modePopupVisibled')) {
      this.model.set({
        modePopupVisibled: false,
      });

      this.onToggleAccessibilityFocusForModePopup(false);
    } else {
      if (!this.model.get('showFromAdvanced')) {
        iorad.player.router.togglePlayerPopup(false);
      }
      iorad.player.router.shareView.toggle();
    }
  },
});

;
iorad.player.views.layout_media = iorad.base.View.extend({
  template: iorad.player.templates.layout_media,

  events: {
    'click .media_right_footer_btnOk': 'onOkClick',
    'click .media-item[data-type="video"] [type="checkbox"]': 'toggleVideo',
    'click .media-item[data-type="voiceover"] [type="checkbox"]': 'toggleVoiceover',
    'click .media-item[data-type="transcription"] [type="checkbox"]': 'onTranscriptionClick',
    'click .media-item[data-type="music"] [type="checkbox"]': 'onMusicClick',
    'click .media-item[data-type="step"] [type="checkbox"]': 'toggleStep',
    'click .media-item[data-type="language"]': 'toggleLanguage',
    'click .close-media-popup, .popup_overlay': 'onCloseMediaPopupClick',
  },

  initialize: function () {
    this.tutorial = iorad.player.data.tutorial;
    this.stepsCollection = iorad.player.data.stepsCollection;

    this.transcriptionClicked = false; // NOTE: read from the outside!

    this.model = new Backbone.Model({
      showFromAdvanced: false,
    });

    this.listenTo(this.model, 'change', this.check);
    this.listenTo(this.tutorial, 'change', this.check);
    this.listenTo(this.stepsCollection, 'change changeCurrent reset', this.check);
    this.listenTo(iorad.player.events, 'ready tab change:coverOpen mode', this.check);
    this.listenTo(iorad.player.controllers.audio, 'change:audioState', this.check);
    this.listenTo(iorad.player.controllers.video, 'change:videoState', this.check);
    this.listenTo(iorad.player.events, 'video:display', this.check);
    this.listenTo(iorad.player.events, 'video:volume audio:volume', this.check);
    this.listenTo(iorad.player.events, 'press:esc', this.onCloseMediaPopupClick);
    this.listenTo(iorad.player.controllers.audio, 'change:transcriptionState change:transcriptionEnabled', this.check);
    this.listenTo(iorad.player.controllers.video, 'change:transcriptionState change:transcriptionEnabled', this.check);
    this.listenTo(iorad.player.controllers.music, 'change:musicState', this.check);
    this.check();
  },
  check: function () {
    if (!iorad.player.router || !this.$el.hasClass('visible')) return;
    this.$el.removeClass('showing');
    this.render();
  },

  // NOTE: also called from the outside!
  getTemplateData: function () {
    const allVideoClasses = iorad.player.controllers.video.getVideoStateClasses();
    const allAudioClasses = iorad.player.controllers.audio.getAudioStateClasses();
    const videoTranscriptionClasses = iorad.player.controllers.video.getTranscriptionStateClasses();
    const audioTranscriptionClasses = iorad.player.controllers.audio.getTranscriptionStateClasses();
    const musicClasses = iorad.player.controllers.music.getMusicStateClasses();
    const tutorialHasVideo = !allVideoClasses.includes('tutorial-no-video');
    const tutorialHasAudio = !allAudioClasses.includes('tutorial-no-audio');
    const tutorialHasMusic = Boolean(this.tutorial.get('musicId')) && !musicClasses.includes('load-error');
    const tutorialHasVideoTranscription = this.stepsCollection.some(stepModel =>
      stepModel.get('videoTranscription')
    );
    const tutorialHasAudioTranscription = this.stepsCollection.some(stepModel =>
      stepModel.get('audioTranscription')
    );
    const tutorialVideoTranscriptionEnabled = this.tutorial.get('videoTranscriptionEnabled');
    const tutorialAudioTranscriptionEnabled = this.tutorial.get('audioTranscriptionEnabled');
    const requireVideoCompletition = this.tutorial.get('requireVideoCompletition');
    const requireAudioCompletition = this.tutorial.get('requireAudioCompletition');

    // when the whole tutorial doesn't have video
    const videoHidden = !tutorialHasVideo;
    // when current step cannot play video
    const videoDisabled = (
      !tutorialHasVideo ||
      allVideoClasses.includes('load-error')
    );
    // when the video is enabled in general
    const videoChecked = (
      !videoHidden && 
      !allVideoClasses.includes('mute') &&
      !iorad.player.videoDisplayDisabled
    );
    const videoUnchangeable = (
      videoChecked &&
      tutorialHasVideo &&
      requireVideoCompletition
    );

    // when the whole tutorial doesn't have voiceover
    const voiceoverHidden = !tutorialHasVideo && !tutorialHasAudio;
    // when current step cannot play voiceover
    const voiceoverDisabled = (
      (!tutorialHasVideo || allVideoClasses.includes('load-error')) &&
      (!tutorialHasAudio || allAudioClasses.includes('load-error'))
    );
    // when the voiceover is enabled in general
    const voiceoverChecked = (
      (tutorialHasVideo && (
        !allVideoClasses.includes('mute') &&
        !iorad.player.videoVolumeDisabled
      )) ||
      (tutorialHasAudio && (
        !allAudioClasses.includes('mute') &&
        !iorad.player.audioVolumeDisabled
      ))
    );
    const voiceoverUnchangeable = !voiceoverDisabled && voiceoverChecked && (
      (tutorialHasVideo && requireVideoCompletition) ||
      (tutorialHasAudio && requireAudioCompletition)
    );

    // when current step cannot play transcription
    const transcriptionDisabled = (
      (!tutorialHasVideo || videoTranscriptionClasses.includes('step-no-transcription')) &&
      (!tutorialHasAudio || audioTranscriptionClasses.includes('step-no-transcription'))
    );
    // when the transcription is enabled in general
    const transcriptionChecked = (
      (tutorialHasVideo && videoTranscriptionClasses.includes('enabled')) ||
      (tutorialHasAudio && audioTranscriptionClasses.includes('enabled'))
    );
    // when the whole tutorial doesn't have transcription
    const transcriptionHidden = (
      (
        !tutorialHasVideo ||
        !tutorialHasVideoTranscription ||
        !tutorialVideoTranscriptionEnabled
      ) &&
      (
        !tutorialHasAudio ||
        !tutorialHasAudioTranscription ||
        !tutorialAudioTranscriptionEnabled
      )
    );

    // there is only one music for the whole tutorial,
    // thus a "load-error" actually means that the whole tutorial doesn't have music
    // thus the whole button should be hidden and never disabled
    const musicHidden = !tutorialHasMusic;
    const musicDisabled = false;
    const musicChecked = !musicClasses.includes('mute') && !musicHidden;

    const languageDisabled = false;
    const languageName = iorad.player.controllers.language.getLanguageName(
      iorad.player.getParameters.lang ||
      (iorad.player.data.tutorial.get('language') || 'en')
    );
    const languageHidden = this.tutorial.getLayoutOption('is_language_disabled');

    const stepChecked = iorad.player.stepTextDisabled;
    const stepHidden = true; // REMOVED FOR NOW

    return _.extend({}, {
      videoDisabled,
      videoUnchangeable,
      videoChecked,
      videoHidden,

      voiceoverDisabled,
      voiceoverUnchangeable,
      voiceoverChecked,
      voiceoverHidden,
      tutorialHasAudio,

      transcriptionDisabled,
      transcriptionChecked,
      transcriptionHidden,

      musicDisabled,
      musicChecked,
      musicHidden,

      languageDisabled,
      languageName,
      languageHidden,

      stepChecked,
      stepHidden,

      showFromAdvanced: this.model.get('showFromAdvanced'),
    });
  },

  render: function () {
    const oldTemplateData = this.templateData || {};
    this.templateData = this.getTemplateData();

    window.litHTML.render(this.template(this.templateData), this.el);

    this.componentDidUpdate(oldTemplateData);

    return this;
  },

  componentDidUpdate: function (oldTemplateData) {
    iorad.player.events.trigger('update:media');
  },

  // NOTE: called from the outside
  isVisible: function () {
    return this.$el.hasClass('visible');
  },

  // NOTE: called from the outside
  show: function () {
    if (this.$el.hasClass('visible')) return;
    this.$el.addClass('visible');
    this.$el.addClass('showing');
    this.check();
    this.returnToTab = iorad.player.tab;
    iorad.player.router.changeTab('media');
    iorad.player.events.trigger('media:show', this.$el.height());
    iorad.base.Utils.accessibilityFocus(this.$el);
  },

  // NOTE: called from the outside
  hide: function () {
    if (!this.$el.hasClass('visible')) return;
    iorad.player.router.changeTab(this.returnToTab);
    this.$el.removeClass('visible');
    this.$el.removeClass('showing');

    iorad.player.events.trigger('media:hide');
    iorad.base.Utils.accessibilityFocusBack(this.$el);
  },

  toggle: function (value) {
    if (typeof value === 'undefined') {
      value = !this.isVisible();
    }
    setTimeout(() => {
      console.log(value, this.$el.height());
    }, 200);
    if (value) this.show();
    else this.hide();
  },

  // NOTE: called from the outside
  setShowFromAdvanced: function () {
    this.model.set({
      showFromAdvanced: true,
    });
  },

  onOkClick: function () {
    this.hide();
  },

  noMediaNoty: function(e, text) {
    if (e) {
      e.preventDefault();
    }

    noty({
      type: 'error',
      text: text || 'Feature disabled',
    });
  },

  // NOTE: also called from the outside
  toggleVideo: function (e) {
    // DO NOT use this.templateData as it can be outdated when calling it from the outside
    // (Since the view doesn't re-renders while hidden)
    const templateData = this.getTemplateData();

    if (templateData.videoUnchangeable) {
      return this.noMediaNoty(e, 'Not available in this tutorial.');
    }

    if (templateData.videoHidden) {
      return this.noMediaNoty(e, 'Tutorial does not have video');
    }

    // prevent access via Tab key
    if (templateData.videoDisabled) {
      e.preventDefault();
      return false;
    }

    if (!templateData.videoChecked) {
      iorad.player.controllers.video.toggleVideo(true); // also unmute
      iorad.player.controllers.video.toggleDisplay(true);
      iorad.player.controllers.video.toggleVolume(templateData.voiceoverChecked); // keep same checked state
      if (!templateData.transcriptionHidden) {
        iorad.player.controllers.video.toggleTranscription(templateData.transcriptionChecked); // keep same checked state
      }
    } else {
      iorad.player.controllers.video.toggleDisplay(false);
      if (!templateData.voiceoverChecked && !templateData.transcriptionChecked) {
        // also mute
        iorad.player.controllers.video.toggleVideo(false);
      }
    }
  },

  // NOTE: also called from the outside
  toggleVoiceover: function (e) {
    // DO NOT use this.templateData as it can be outdated when calling it from the outside
    // (Since the view doesn't re-renders while hidden)
    const templateData = this.getTemplateData(); // before changes

    if (templateData.voiceoverUnchangeable) {
      return this.noMediaNoty(e, 'Not available in this tutorial.');
    }

    if (templateData.voiceoverHidden) {
      return this.noMediaNoty(e, 'Tutorial does not have voiceover');
    }

    // prevent access via Tab key
    if (templateData.voiceoverDisabled) {
      e.preventDefault();
      return false;
    }

    // toggle video voiceover
    if (!templateData.videoHidden) {
      if (!templateData.voiceoverChecked) {
        iorad.player.controllers.video.toggleVideo(true); // also unmute
        iorad.player.controllers.video.toggleDisplay(templateData.videoChecked); // keep same checked state
        iorad.player.controllers.video.toggleVolume(true);
        if (!templateData.transcriptionHidden) {
          iorad.player.controllers.video.toggleTranscription(templateData.transcriptionChecked); // keep same checked state
        }
      } else {
        iorad.player.controllers.video.toggleVolume(false);
        if (!templateData.videoChecked && !templateData.transcriptionChecked) {
          // also mute
          iorad.player.controllers.video.toggleVideo(false);
        }
      }
    }

    // toggle audio voiceover
    if (templateData.tutorialHasAudio) {
      if (!templateData.voiceoverChecked) {
        iorad.player.controllers.audio.toggleAudio(true); // also unmute
        iorad.player.controllers.audio.toggleVolume(true);
        if (!templateData.transcriptionHidden) {
          iorad.player.controllers.audio.toggleTranscription(templateData.transcriptionChecked); // keep same checked state
        }
      } else {
        iorad.player.controllers.audio.toggleVolume(false);
        if (!templateData.transcriptionChecked) {
          // also mute
          iorad.player.controllers.audio.toggleAudio(false);
        }
      }
    }
  },

  onTranscriptionClick: function (e) {
    this.transcriptionClicked = true;

    this.toggleTranscription(e);
  },

  // NOTE: also called from the outside
  toggleTranscription: function (e) {
    // DO NOT use this.templateData as it can be outdated when calling it from the outside
    // (Since the view doesn't re-renders while hidden)
    const templateData = this.getTemplateData(); // before changes

    if (templateData.transcriptionHidden) {
      return this.noMediaNoty(e, 'Tutorial does not have closed captioning');
    }

    // prevent access via Tab key
    if (templateData.transcriptionDisabled) {
      e.preventDefault();
      return false;
    }

    if (!templateData.videoHidden) {
      if (!templateData.transcriptionChecked) {
        iorad.player.controllers.video.toggleVideo(true); // also unmute
        iorad.player.controllers.video.toggleDisplay(templateData.videoChecked); // keep same checked state
        iorad.player.controllers.video.toggleVolume(templateData.voiceoverChecked); // keep same checked state
        iorad.player.controllers.video.toggleTranscription(true);
      } else {
        iorad.player.controllers.video.toggleTranscription(false);
        if (!templateData.videoChecked && !templateData.voiceoverChecked) {
          // also mute
          iorad.player.controllers.video.toggleVideo(false);
        }
      }
    }

    if (templateData.tutorialHasAudio) {
      if (!templateData.transcriptionChecked) {
        iorad.player.controllers.audio.toggleAudio(true); // also unmute
        iorad.player.controllers.audio.toggleVolume(templateData.voiceoverChecked); // keep same checked state
        iorad.player.controllers.audio.toggleTranscription(true);
      } else {
        iorad.player.controllers.audio.toggleTranscription(false);
        if (!templateData.voiceoverChecked) {
          // also mute
          iorad.player.controllers.audio.toggleAudio(false);
        }
      }
    }
  },

  onMusicClick: function (e) {
    this.musicUnchecked = !e.target.checked;

    this.toggleMusic(e);
  },

  // NOTE: also called from the outside
  toggleMusic: function (e) {
    const templateData = this.getTemplateData();

    if (templateData.musicHidden) {
      return this.noMediaNoty(e, 'Tutorial does not have background music');
    }

    iorad.player.controllers.music.toggleMusic();
  },

  toggleStep: function (e) {
    const templateData = this.getTemplateData();

    if (templateData.stepHidden) {
      return this.noMediaNoty(e, 'Feature disabled');
    }

    iorad.player.stepTextDisabled = !e.target.checked;
    iorad.player.events.trigger('change:stepTextDisabled');
  },

  setPlaybarBtnEl: function(playbarBtnEl) {
    this.playbarBtnEl = playbarBtnEl;
  },

  toggleLanguage: function (e) {
    e.preventDefault();

    const templateData = this.getTemplateData();

    if (templateData.languageHidden) {
      return this.noMediaNoty(e, 'Feature disabled');
    }

    iorad.player.router.playbarView.setPlaybarPopupPosition(this.playbarBtnEl, iorad.player.router.languageView);
    // iorad.player.router.togglePlayerPopup(true);
    iorad.player.router.languageView.toggle();
  },

  onCloseMediaPopupClick: function (event) {
    if (!this.isVisible()) return;
    event && event.preventDefault();
    if (iorad.player.router.languageView.isVisible()) {
      return;
    }
    if (!this.model.get('showFromAdvanced')) {
      iorad.player.router.togglePlayerPopup(false);
    }
    iorad.player.router.mediaView.toggle();
  },
});

;
iorad.player.views.layout_steps = iorad.base.View.extend({
  template: iorad.player.templates.layout_steps,

  events: {
    'click .popup_steps_item': 'onStepItemClick',
    'input .popup_steps_search input': 'onFilterChange',
    'click .popup_steps_item_copy_link_btn': 'onStepCopyLinkClick',
    'click .close-steps-popup, .popup_overlay': 'onCloseStepsPopupClick',
  },

  initialize: function () {
    this.tutorial = iorad.player.data.tutorial;
    this.stepsCollection = iorad.player.data.stepsCollection;

    this.model = new Backbone.Model({
      filter: '',
      clipboardWriteDenied: false,
    });

    this.listenTo(this.model, 'change', this.check);
    this.listenTo(this.tutorial, 'change', this.check);
    this.listenTo(this.stepsCollection, 'change changeCurrent reset', this.check);
    this.listenTo(iorad.player.events, 'ready tab mode device change:coverOpen', this.check);
    this.listenTo(iorad.player.events, 'press:esc', this.onCloseStepsPopupClick);

    this.check();
  },

  checkClipboardPermissions: function () {
    if (!this.checkClipboardPermissionsPromise) {
      this.checkClipboardPermissionsPromise = Promise.resolve()
        .then(() => {
          if (
            navigator &&
            navigator.permissions &&
            navigator.permissions.query
          ) {
            return navigator.permissions.query({
              name: 'clipboard-write'
            }).then(
              result => {
                return result.state === 'denied';
              },
              err => {
                console.error(err);
                return false;
              }
            );
          }
          return Promise.resolve(false);
        })
        .then((clipboardWriteDenied) => {
          this.model.set({
            clipboardWriteDenied,
          }, { silent: true });
        });
    }
    return this.checkClipboardPermissionsPromise;
  },

  check: function () {
    if (!iorad.player.router || !this.$el.hasClass('visible')) return;
    this.checkClipboardPermissions()
      .then(() => {
        this.$el.removeClass('showing');
        this.render();
      });
  },

  // NOTE: also called from the outside!
  getTemplateData: function () {
    const filter = this.model.get('filter');
    const steps = [{
      title: 'Cover',
      text: '',
    }].concat(this.stepsCollection.map(stepModel => {
      const stepIndex = stepModel.get('index') + 1;
      return {
        index: stepIndex,
        title: `Step ${stepIndex}`,
        text: iorad.base.Utils.stripHtmlTags(
          stepModel.get('description'),
          iorad.base.Export.STEP_DESCRIPTION_APP_SANITIZE_RULES
        ),
      };
    }))
      .map((item, i) => {
        const active = (
          iorad.player.controllers.views.isCoverOpen() ?
            i === 0
            :
            (this.stepsCollection.position === i - 1) // -1 because i includes cover
        );
        return {
          ...item,
          active,
        };
      })
      .filter(item => {
        if (!filter) return item;
        return (
          item.title.toLowerCase().includes(filter.toLowerCase()) ||
          item.text.toLowerCase().includes(filter.toLowerCase())
        );
      });

    const clipboardWriteDenied = this.model.get('clipboardWriteDenied');
    const isSharingDisabled = this.tutorial.isSharingDisabled();
    const copyLinkIsHidden = clipboardWriteDenied || isSharingDisabled;

    return _.extend({}, {
      steps,
      copyLinkIsHidden,
    });
  },

  render: function () {
    const oldTemplateData = this.templateData || {};
    this.templateData = this.getTemplateData();

    window.litHTML.render(this.template(this.templateData), this.el);

    this.componentDidUpdate(oldTemplateData);

    return this;
  },

  componentDidUpdate: function (oldTemplateData) {
    if (this.isVisible()) {
      iorad.base.Utils.accessibilityFocus(this.$el);
    }
  },

  // NOTE: called from the outside
  isVisible: function () {
    return this.$el.hasClass('visible');
  },

  // NOTE: called from the outside
  show: function () {
    if (this.$el.hasClass('visible')) return;
    this.$el.addClass('visible');
    this.$el.addClass('showing');
    this.check();
    this.returnToTab = iorad.player.tab;
    iorad.player.router.changeTab('steps');
    iorad.player.events.trigger('steps:show');
  },

  // NOTE: called from the outside
  hide: function () {
    if (!this.$el.hasClass('visible')) return;
    iorad.player.router.changeTab(this.returnToTab);
    this.$el.removeClass('visible');
    this.$el.removeClass('showing');

    iorad.player.events.trigger('steps:hide');
    iorad.base.Utils.accessibilityFocusBack(this.$el);
  },

  toggle: function (value) {
    if (typeof value === 'undefined') {
      value = !this.isVisible();
    }
    if (value) this.show();
    else this.hide();
  },

  onStepItemClick: function (event, gotoStepIndex) {
    let stepIndex = gotoStepIndex;
    if (event) {
      const $stepItemEl = $(event.currentTarget);

      this.onCloseStepsPopupClick(event);

      if ($stepItemEl.hasClass('active')) return;

      stepIndex = $stepItemEl.index();
    }

    if (stepIndex === 0) {
      if (!iorad.player.controllers.views.isCoverOpen()) {
        iorad.player.controllers.views.setCoverOpen(true, true, true);
      }
    } else {
      // NOTE: stepIndex here is already +1 given the cover step

      if (iorad.player.controllers.views.isCoverOpen()) {
        iorad.player.controllers.views.setCoverOpen(false, true, true);
      }

      if (iorad.player.mode === 'interactive') {
        iorad.player.router.navigateToInteractiveMode(null, stepIndex);
      } else if (iorad.player.mode === 'quick') {
        iorad.player.events.trigger('quick:goTo', stepIndex - 1);
      } else if (iorad.player.mode === 'mobilequick') {
        iorad.player.events.trigger('mobilequick:goTo', stepIndex - 1);
      }
    }
  },

  onFilterChange: function (event) {
    this.model.set({
      filter: event.target.value.trim(),
    });
  },

  onStepCopyLinkClick: function (event) {
    event.stopPropagation();
    const modeTab = iorad.player.controllers.views.isModalTab(iorad.player.tab) ? iorad.player.oldTab : iorad.player.tab;
    const stepIndex = $(event.currentTarget).data('index');
    iorad.player.controllers.sync.getPlayerURL()
      .then(function(playerURL) {
        const stepLink = playerURL.PUBLIC_LINK + iorad.player.router.getInteractiveModeLink(modeTab, stepIndex);
        navigator.clipboard.writeText(stepLink)
          .then(() => {
            noty({
              type: 'information',
              text: 'Step URL copied',
            });
          })
          .catch(err => {
            console.error(err);
            noty({
              type: 'error',
              text: 'Error: unable to copy the Step URL',
            });
          });
      });
  },

  onCloseStepsPopupClick: function (event) {
    if (!this.isVisible()) return;
    event && event.preventDefault();
    iorad.player.router.togglePlayerPopup(false);
    iorad.player.router.stepsView.toggle();
  }
});

;
iorad.player.views.layout_export = iorad.base.View.extend({
  template: iorad.player.templates.layout_export,

  events: {
    'click .print-landscape': 'handlePrintLandscape',
    'click .print-portrait': 'handlePrintPortrait',
    'click .close-export-popup, .popup_overlay': 'onCloseExportPopupClick',
  },

  initialize: function () {
    this.tutorial = iorad.player.data.tutorial;
    this.stepsCollection = iorad.player.data.stepsCollection;

    this.model = new Backbone.Model({
      isPrintingLandscape: false,
      isPrintingPortrait: false,
      showFromAdvanced: false,
    });

    this.listenTo(this.model, 'change', this.check);
    this.listenTo(this.tutorial, 'change', this.check);
    this.listenTo(
      this.stepsCollection,
      'change changeCurrent reset',
      this.check
    );
    this.listenTo(
      iorad.player.events,
      'ready tab mode device change:coverOpen',
      this.check
    );
    this.listenTo(iorad.player.events, 'mode:print', this.check);
    this.listenTo(iorad.player.events, 'press:esc', this.onCloseExportPopupClick);
    this.listenTo(
      iorad.player.events,
      'pdfDownload:done',
      this.onPdfDownloadDone
    );
    this.listenTo(
      iorad.player.events,
      'tab:pdf',
      this.show
    );

    this.check();
  },

  check: function () {
    if (!iorad.player.router || !this.$el.hasClass('visible')) return;
    this.$el.removeClass('showing');
    this.render();
  },

  // NOTE: also called from the outside!
  getTemplateData: function () {
    return _.extend(
      {},
      {
        isPrintLandscapeDisabled: this.tutorial.getLayoutOption(
          'is_print_landscape_disabled'
        ) && iorad.player.getParameters.forcePrintVisible !== 'true',
        isPrintPortraitDisabled: this.tutorial.getLayoutOption(
          'is_print_portrait_disabled'
        ) && iorad.player.getParameters.forcePrintVisible !== 'true',

        isPrintingLandscape: this.model.get('isPrintingLandscape'),
        isPrintingPortrait: this.model.get('isPrintingPortrait'),
        showFromAdvanced: this.model.get('showFromAdvanced'),
      }
    );
  },

  render: function () {
    const oldTemplateData = this.templateData || {};
    this.templateData = this.getTemplateData();

    window.litHTML.render(this.template(this.templateData), this.el);

    this.componentDidUpdate(oldTemplateData);

    return this;
  },

  componentDidUpdate: function (oldTemplateData) {},

  // NOTE: called from the outside
  isVisible: function () {
    return this.$el.hasClass('visible');
  },

  // NOTE: called from the outside
  show: function () {
    if (this.$el.hasClass('visible')) return;
    this.$el.addClass('visible');
    this.$el.addClass('showing');
    this.check();
    this.returnToTab = iorad.player.tab;
    iorad.player.router.changeTab('pdf');
    iorad.player.events.trigger('pdf:show');
    iorad.base.Utils.accessibilityFocus(this.$el);
  },

  // NOTE: called from the outside
  hide: function () {
    if (!this.$el.hasClass('visible')) return;
    iorad.player.router.changeTab(this.returnToTab);
    this.$el.removeClass('visible');
    this.$el.removeClass('showing');

    iorad.player.events.trigger('pdf:hide');
    iorad.base.Utils.accessibilityFocusBack(this.$el);
  },

  toggle: function (value) {
    if (typeof value === 'undefined') {
      value = !this.isVisible();
    }
    if (value) this.show();
    else this.hide();
  },

  // NOTE: called from the outside
  setShowFromAdvanced: function () {
    this.model.set({
      showFromAdvanced: true,
    });
  },

  handlePrintLandscape: function (e) {
    e.preventDefault();
    if (
      this.model.get('isPrintingLandscape') ||
      this.model.get('isPrintingPortrait')
    ) {
      return;
    }

    this.model.set({
      isPrintingLandscape: true,
    });

    iorad.player.router.changeMode('print', 'long');
  },

  handlePrintPortrait: function (e) {
    e.preventDefault();
    if (
      this.model.get('isPrintingLandscape') ||
      this.model.get('isPrintingPortrait')
    ) {
      return;
    }

    this.model.set({
      isPrintingPortrait: true,
    });

    iorad.player.router.changeMode('print', 'short');
  },

  onPdfDownloadDone: function (layoutType) {
    console.log('layoutType', layoutType);
    if (layoutType === 'long') {
      this.model.set({
        isPrintingLandscape: false,
      });
    } else if (layoutType === 'short') {
      this.model.set({
        isPrintingPortrait: false,
      });
    }
  },

  onCloseExportPopupClick: function (event) {
    if (!this.isVisible()) return;
    event && event.preventDefault();
    if (!this.model.get('showFromAdvanced')) {
      iorad.player.router.togglePlayerPopup(false);
    }
    iorad.player.router.exportView.toggle();

    console.log('current tab', iorad.player.tab);
    // reset default when go to #print as a direct link
    if (iorad.player.tab === 'pdf') {
      window.setLocationHash('#');
    }
  },
});

;
iorad.player.views.layout_advanced = iorad.base.View.extend({
  template: iorad.player.templates.layout_advanced,

  events: {
    'click .close-advanced-popup, .popup_overlay': 'onCloseAdvancedPopupClick',
    'click .selector-btn': 'onSelectorBtnClick',
    'click .download-btn': 'onDownloadBtnClick',
    'click .settings-btn': 'onSettingsBtnClick',
    'click .share-btn': 'onShareBtnClick',
    'click .comments-btn': 'onCommentsBtnClick',
  },

  initialize: function () {
    this.tutorial = iorad.player.data.tutorial;
    this.stepsCollection = iorad.player.data.stepsCollection;

    this.model = new Backbone.Model({
    });

    this.listenTo(this.model, 'change', this.check);
    this.listenTo(this.tutorial, 'change', this.check);
    this.listenTo(this.stepsCollection, 'change changeCurrent reset', this.check);
    this.listenTo(iorad.player.events, 'ready tab mode device change:coverOpen', this.check);
    this.listenTo(iorad.player.events, 'press:esc', this.onCloseAdvancedPopupClick);

    this.check();
  },

  check: function () {
    if (!iorad.player.router || !this.$el.hasClass('visible')) return;
    this.$el.removeClass('showing');
    this.render();
  },

  // NOTE: also called from the outside!
  getTemplateData: function () {
    const { advancedPopupShowsSelectorButton } = iorad.player.router.playbarView.getTemplateData();
    const isSelectorBtnHidden = !advancedPopupShowsSelectorButton;
    const selectorTemplateData = iorad.player.router.selectorView.getTemplateData();
    const selectorActiveItem = (
      selectorTemplateData.items.find(anItem => anItem.id === selectorTemplateData.activeTab) ||
      selectorTemplateData.items[0]
    );

    const isExportBtnHidden = (
      this.tutorial.getLayoutOption('is_print_portrait_disabled') &&
      this.tutorial.getLayoutOption('is_print_landscape_disabled')
    );
    const isShareBtnHidden = this.tutorial.isSharingDisabled();
    const isCommentsBtnHidden = this.tutorial.isCommentingDisabled();
    const mediaData = iorad.player.router.mediaView.getTemplateData();

    const isSettingBtnHidden =
      mediaData.videoHidden &&
      mediaData.voiceoverHidden &&
      mediaData.transcriptionHidden &&
      mediaData.musicHidden &&
      mediaData.languageHidden &&
      mediaData.stepHidden;

    return _.extend({}, {
      isSelectorBtnHidden,
      selectorActiveItem,

      isExportBtnHidden,
      isSettingBtnHidden,
      isShareBtnHidden,
      isCommentsBtnHidden,
    });
  },

  render: function () {
    const oldTemplateData = this.templateData || {};
    this.templateData = this.getTemplateData();

    window.litHTML.render(this.template(this.templateData), this.el);

    this.componentDidUpdate(oldTemplateData);

    return this;
  },

  componentDidUpdate: function (oldTemplateData) {
  },

  // NOTE: called from the outside
  isVisible: function () {
    return this.$el.hasClass('visible');
  },

  // NOTE: called from the outside
  show: function () {
    if (this.$el.hasClass('visible')) return;
    this.$el.addClass('visible');
    this.$el.addClass('showing');
    this.check();
    this.returnToTab = iorad.player.tab;
    iorad.player.router.changeTab('advanced');
    iorad.player.events.trigger('advanced:show');
    iorad.base.Utils.accessibilityFocus(this.$el);
  },

  // NOTE: called from the outside
  hide: function () {
    if (!this.$el.hasClass('visible')) return;
    iorad.player.router.changeTab(this.returnToTab);
    this.$el.removeClass('visible');
    this.$el.removeClass('showing');

    iorad.player.events.trigger('advanced:hide');
    iorad.base.Utils.accessibilityFocusBack(this.$el);
  },

  toggle: function (value) {
    if (typeof value === 'undefined') {
      value = !this.isVisible();
    }
    if (value) this.show();
    else this.hide();
  },

  setPlaybarBtnEl: function(playbarBtnEl) {
    this.playbarBtnEl = playbarBtnEl;
  },

  onSelectorBtnClick: function () {
    iorad.player.router.playbarView.setPlaybarPopupPosition(this.playbarBtnEl, iorad.player.router.selectorView);
    // iorad.player.router.togglePlayerPopup(true);
    // iorad.player.router.advancedView.toggle();
    iorad.player.router.selectorView.toggle();
    iorad.player.router.selectorView.setShowFromAdvanced();
  },

  onDownloadBtnClick: function() {
    iorad.player.router.playbarView.setPlaybarPopupPosition(this.playbarBtnEl, iorad.player.router.exportView);
    // iorad.player.router.togglePlayerPopup(true);
    // iorad.player.router.advancedView.toggle();
    iorad.player.router.exportView.toggle();
    iorad.player.router.exportView.setShowFromAdvanced();
  },

  onSettingsBtnClick: function() {
    iorad.player.router.playbarView.setPlaybarPopupPosition(this.playbarBtnEl, iorad.player.router.mediaView);
    // iorad.player.router.togglePlayerPopup(true);
    // iorad.player.router.advancedView.toggle();
    iorad.player.router.mediaView.setPlaybarBtnEl(this.playbarBtnEl);
    iorad.player.router.mediaView.toggle();
    iorad.player.router.mediaView.setShowFromAdvanced();
  },

  onShareBtnClick: function() {
    iorad.player.router.playbarView.setPlaybarPopupPosition(this.playbarBtnEl, iorad.player.router.shareView);
    // iorad.player.router.togglePlayerPopup(true);
    // iorad.player.router.advancedView.toggle();
    iorad.player.router.shareView.toggle();
    iorad.player.router.shareView.setShowFromAdvanced();
  },

  onCommentsBtnClick: function() {
    iorad.player.router.playbarView.setPlaybarPopupPosition(this.playbarBtnEl, iorad.player.router.commentsView);
    // iorad.player.router.togglePlayerPopup(true);
    // iorad.player.router.advancedView.toggle();
    iorad.player.router.commentsView.toggle();
    iorad.player.router.commentsView.setShowFromAdvanced();
  },

  onCloseAdvancedPopupClick: function (event) {
    if (!this.isVisible()) return;
    event && event.preventDefault();
    event.preventDefault();
    this.playbarBtnEl = null;
    iorad.player.router.togglePlayerPopup(false);
    iorad.player.router.advancedView.toggle();
  },
});

;
iorad.player.views.layout_selector = iorad.base.View.extend({
  template: iorad.player.templates.layout_selector,

  events: {
    'click .interactive': 'onTryClick',
    'click .watch': 'onWatchClick',
    'click .quiz': 'onQuizClick',
    'click .view': 'onViewClick',
    'click .slide': 'onSlideClick',
    'click .pdf-btn': 'onPdfTabClick',
    'click .live': 'onLiveClick',
    'click .edit': 'onEditClick',
    'click .copy_link_btn': 'onCopyLinkClick',
    'click .close-selector-popup, .popup_overlay': 'onCloseSelectorPopupClick',
  },

  initialize: function () {
    this.tutorial = iorad.player.data.tutorial;
    this.stepsCollection = iorad.player.data.stepsCollection;

    this.model = new Backbone.Model({
      clipboardWriteDenied: false,
      showFromAdvanced: false,
    });

    this.listenTo(this.model, 'change', this.check);
    this.listenTo(this.tutorial, 'change', this.check);
    this.listenTo(this.stepsCollection, 'change changeCurrent reset', this.check);
    this.listenTo(iorad.player.events, 'ready tab mode device change:coverOpen', this.check);
    this.listenTo(iorad.player.events, 'press:esc', this.onCloseSelectorPopupClick);

    this.hasEditAccess = false;
    if (!window.downloadPlayerType) {
      iorad.player.controllers.sync.hasEditAccess()
        .then(_.bind(function (value) {
          if (value !== this.hasEditAccess) {
            this.hasEditAccess = value;
            this.check();
          }
        }, this));
    }

    this.check();
  },

  checkClipboardPermissions: function () {
    if (!this.checkClipboardPermissionsPromise) {
      this.checkClipboardPermissionsPromise = Promise.resolve()
        .then(() => {
          if (
            navigator &&
            navigator.permissions &&
            navigator.permissions.query
          ) {
            return navigator.permissions.query({
              name: 'clipboard-write'
            }).then(
              result => {
                return result.state === 'denied';
              },
              err => {
                console.error(err);
                return false;
              }
            );
          }
          return Promise.resolve(false);
        })
        .then((clipboardWriteDenied) => {
          this.model.set({
            clipboardWriteDenied,
          }, { silent: true });
        });
    }
    return this.checkClipboardPermissionsPromise;
  },

  check: function () {
    if (!iorad.player.router || !this.$el.hasClass('visible')) return;
    this.checkClipboardPermissions()
      .then(() => {
        this.$el.removeClass('showing');
        this.render();
      });
  },

  // NOTE: also called from the outside!
  getModeIcon: function (id, { size } = {}) {
    const isMobilePortrait = iorad.player.router.doMatchMobilePortrait();
    return iorad.base.Utils.getPlayerModeIcon(id, { size: size || (isMobilePortrait ||  window.innerWidth <= 750 ? 'M' : 'L') });
  },

  // NOTE: also called from the outside!
  getTemplateData: function () {
    var activeTab = iorad.player.controllers.views.isModalTab(iorad.player.tab) ? iorad.player.oldTab : iorad.player.tab;

    var liveBannerData = iorad.player.controllers.live.getBannerData();

    const clipboardWriteDenied = this.model.get('clipboardWriteDenied');
    const isSharingDisabled = this.tutorial.isSharingDisabled();
    const copyLinkIsHidden = clipboardWriteDenied || isSharingDisabled;

    const items = iorad.base.Utils.getPlayerModeInArray('S').map((mode) => {
      const result = {
        ...mode
      };

      switch (result.id) {
        case 'try':
          result.className = 'interactive';
          result.hidden = !(
            iorad.player.router.isTryTabAvailable() &&
            !this.tutorial.getLayoutOption('is_trysteps_disabled')
          );
          break;
        case 'view':
          result.hidden = !(
            iorad.player.router.isViewTabAvailable() &&
            !this.tutorial.getLayoutOption('is_viewsteps_disabled')
          );
          break;
        case 'slide':
          result.hidden = !(
            iorad.player.router.isSlideTabAvailable() &&
            !this.tutorial.getLayoutOption('is_mobilequick_disabled')
          );
          break;
        case 'watch':
          result.hidden = !(
            iorad.player.router.isWatchTabAvailable() &&
            !this.tutorial.getLayoutOption('is_watchsteps_disabled')
          );
          break;
        case 'quiz':
          result.hidden = !(
            iorad.player.router.isQuizTabAvailable() &&
            !this.tutorial.getLayoutOption('is_quizsteps_disabled')
          );
          break;
        case 'live':
          result.message = liveBannerData.message;
          result.hidden = !(
            this.tutorial.isDoItAvailable() &&
            !this.tutorial.getLayoutOption('is_live_disabled')
          );
          break;

        default:
          break;
      }

      return result;
    });

    items.push({
      id: 'edit',
      href: '#edit',
      icon: this.getModeIcon('edit', { size: 'S' }),
      text: i18next.t('Edit'),
      shortText: i18next.t('Edit'),
      message: i18next.t('Only visible to you the creator'),
      hidden: !this.hasEditAccess,
    });

    return _.extend({}, {
      activeTab,
      items: items.filter(item => !item.hidden).sort((a, b) => ((a.id === activeTab) ? -1 : 1)),
      copyLinkIsHidden,
      showFromAdvanced: this.model.get('showFromAdvanced'),
      // pdfTabHint: i18next.t('Publish a step-by-step PDF'),
    });
  },

  render: function () {
    const oldTemplateData = this.templateData || {};
    this.templateData = this.getTemplateData();

    window.litHTML.render(this.template(this.templateData), this.el);

    this.componentDidUpdate(oldTemplateData);

    return this;
  },

  componentDidUpdate: function (oldTemplateData) {
    if (this.isVisible()) {
      iorad.base.Utils.accessibilityFocus(this.$el);
    }
  },

  // NOTE: called from the outside
  isVisible: function () {
    return this.$el.hasClass('visible');
  },

  // NOTE: called from the outside
  show: function () {
    if (this.$el.hasClass('visible')) return;
    this.$el.addClass('visible');
    this.$el.addClass('showing');
    this.check();
    this.returnToTab = iorad.player.tab;
    iorad.player.router.changeTab('selector');
    iorad.player.events.trigger('selector:show');
  },

  // NOTE: called from the outside
  hide: function () {
    if (!this.$el.hasClass('visible')) return;
    iorad.player.router.changeTab(this.returnToTab);
    this.$el.removeClass('visible');
    this.$el.removeClass('showing');

    iorad.player.events.trigger('selector:hide');
    iorad.base.Utils.accessibilityFocusBack(this.$el);
  },

  toggle: function (value) {
    if (typeof value === 'undefined') {
      value = !this.isVisible();
    }
    if (value) this.show();
    else this.hide();
  },

  // NOTE: called from the outside
  setShowFromAdvanced: function () {
    this.model.set({
      showFromAdvanced: true,
    });
  },

  selectTab: function(tab) {
    var currentStepNumber = this.stepsCollection.getCurrentStepNumber();

    setTimeout(function() {
      iorad.player.router.navigate('#', { trigger: false }); // HACK: makes sure to always trigger route (even if it's the same)
      var stepNumber;
      if (tab === 'try') {
        stepNumber = (iorad.player.tab === 'watch' || iorad.player.tab === 'quiz') ? currentStepNumber : 1;
        if (iorad.player.device === 'desktop' || iorad.player.data.tutorial.get('isMobile')) {
          iorad.player.router.navigateToInteractiveMode('try', stepNumber);
        } else {
          iorad.player.router.navigate('#practice', { trigger: true });
        }
      } else if (tab === 'watch') {
        stepNumber = (iorad.player.tab === 'try' || iorad.player.tab === 'quiz') ? currentStepNumber : 1;
        iorad.player.router.navigateToInteractiveMode('watch', stepNumber);
      } else if (tab === 'quiz') {
        // always reset to step 1
        iorad.player.router.navigateToInteractiveMode('quiz', 1);
      } else if (tab === 'view') {
        if (iorad.player.device === 'desktop') {
          iorad.player.router.navigate('#viewsteps', { trigger: true });
        } else {
          iorad.player.router.navigate('#viewpractice', { trigger: true });
        }
      } else if (tab === 'slide') {
        iorad.player.router.navigate('#mobilequick-1', { trigger: true });
      } else if (tab === 'live') {
        iorad.player.router.navigate('#live', { trigger: true });
      } else if (tab === 'pdf') {
        iorad.player.router.navigate('#print', { trigger: true });
      }
    });
  },

  goToSelector: function() {
    iorad.player.router.selectorView.toggle();
    iorad.player.router.togglePlayerPopup(false);
  },

  onTryClick: function(event) {
    event.preventDefault();

    var tab = 'try';
    this.selectTab(tab);

    iorad.player.controllers.views.setCoverOpen(false, true);

    if (
      !iorad.player.controllers.views.isCoverOpen() &&
      iorad.player.device !== 'desktop' &&
      !iorad.player.data.tutorial.get('isMobile')
    ) {
      var isControlledEmbed = iorad.player.router.isExtensionMode();
      if (isControlledEmbed) {
        iorad.player.router.embedToggleTryMode(true);
      } else {
        iorad.player.controllers.views.toggleFullscreen();
      }
    }

    this.goToSelector();
  },

  onWatchClick: function(event) {
    event.preventDefault();
    var tab = 'watch';
    this.selectTab(tab);

    iorad.player.controllers.views.setCoverOpen(false, true);

    if (
      !iorad.player.controllers.views.isCoverOpen() &&
      iorad.player.device !== 'desktop'
    ) {
      iorad.player.router.navigateToInteractiveMode('watch', 1, null, { trigger: false });

      var isControlledEmbed = iorad.player.router.isExtensionMode();
      if (isControlledEmbed) {
        iorad.player.router.embedToggleTryMode(true);
      } else {
        iorad.player.controllers.views.toggleFullscreen();
      }
    }

    this.goToSelector();
  },

  onQuizClick: function(event) {
    event.preventDefault();

    iorad.player.controllers.views.setCoverOpen(false, true);

    var handle = _.bind(function() {
      var tab = 'quiz';
      this.selectTab(tab);

      if (
        !iorad.player.controllers.views.isCoverOpen() &&
        iorad.player.device !== 'desktop'
      ) {
        iorad.player.router.navigateToInteractiveMode('quiz', 1, null, { trigger: false });

        var isControlledEmbed = iorad.player.router.isExtensionMode();
        if (isControlledEmbed) {
          iorad.player.router.embedToggleTryMode(true);
        } else {
          iorad.player.controllers.views.toggleFullscreen();
        }
      }
    }, this);
    if (iorad.player.tab !== 'quiz' && !iorad.player.controllers.views.isCoverOpen()) {
      iorad.player.controllers.quiz.setupRecording()
        .then(handle, handle);
    } else {
      handle();
    }

    this.goToSelector();
  },

  onViewClick: function(event) {
    event.preventDefault();

    var tab = 'view';
    this.selectTab(tab);

    iorad.player.controllers.views.setCoverOpen(false, true);

    if (
      !iorad.player.controllers.views.isCoverOpen() &&
      iorad.player.device !== 'desktop'
    ) {
      var isControlledEmbed = iorad.player.router.isExtensionMode();
      if (isControlledEmbed) {
        iorad.player.router.embedToggleTryMode(true);
      } else {
        iorad.player.controllers.views.toggleFullscreen();
      }
    }

    this.goToSelector();
  },

  onSlideClick: function (event) {
    event.preventDefault();

    var tab = 'slide';
    this.selectTab(tab);

    iorad.player.controllers.views.setCoverOpen(false, true);

    this.goToSelector();
  },

  onLiveClick: function(event) {
    event.preventDefault();

    var tab = 'live';
    this.selectTab(tab);

    // live "tab" in panel is gone, use cover button
    iorad.player.controllers.views.setCoverOpen(true, true);

    this.goToSelector();
  },

  onEditClick: function(event) {
    event.preventDefault();

    iorad.player.router.editMode({ hash: '#fullscreen' });

    this.goToSelector();
  },

  onCopyLinkClick: function (event) {
    event.stopPropagation();
    event.preventDefault();

    const itemId = $(event.currentTarget).attr('data-item-id');
    const item = this.templateData.items.find(aItem => aItem.id === itemId);
    const hash = item.href;
    iorad.player.controllers.sync.getPlayerURL()
      .then((playerURL) => {
        // use short URL for tutorial embedded inside helpcenter if viewing one,
        // otherwise short URL
        const urlTemplate = (
          playerURL.SHORT_LINK_HELP_CENTER_IFRAME_HASH_TEMPLATE ||
          playerURL.SHORT_LINK_IFRAME_HASH_TEMPLATE ||
          playerURL.PUBLIC_LINK_IFRAME_HASH_TEMPLATE
        );
        const url = iorad.base.Utils.replaceAll(
          urlTemplate,
          encodeURIComponent('{{IORAD_IFRAME_HASH_PLACEHOLDER}}'),
          hash.slice(1)
        );
        navigator.clipboard.writeText(url)
          .then(() => {
            noty({
              type: 'information',
              text: 'URL copied',
            });
          })
          .catch(err => {
            console.error(err);
            noty({
              type: 'error',
              text: 'Error: unable to copy',
            });
          });
      });
  },

  onCloseSelectorPopupClick: function (event) {
    if (!this.isVisible()) return;
    event && event.preventDefault();
    if (!this.model.get('showFromAdvanced')) {
      iorad.player.router.togglePlayerPopup(false);
    }
    iorad.player.router.selectorView.toggle();
  },
});

;
iorad.player.views.layout_offline_cache_overlay = iorad.base.View.extend({
  template: iorad.player.templates.layout_offline_cache_overlay,

  events: {
    'click .save-changes': 'onSaveChangesClick',
    'click .ignore-changes': 'onIgnoreChangesClick'
  },

  initialize: function() {
    this.tutorial = iorad.player.data.tutorial;

    this.render();
  },

  getTemplateData: function() {
    return {

    };
  },

  onSaveChangesClick: function () {
    iorad.player.router.editMode();
  },

  onIgnoreChangesClick: function () {
    this.$el.hide();
  },
});

;
iorad.player.views.layout_recommended_tutorials = iorad.base.View.extend({
  template: iorad.player.templates.layout_recommended_tutorials,

  events: {
    'click .recommended-tutorials_capture_button': 'onCaptureClick',
    'click .recommended-tutorials_list_ul_li': 'onTutorialClick',
  },

  initialize: function () {
    this.tutorial = iorad.player.data.tutorial;
    this.stepsCollection = iorad.player.data.stepsCollection;

    this.fetchCache = {}; // { params, Promise<result>> }

    this.model = new Backbone.Model({});
    this.listenTo(this.model, 'change', this.render);

    this.listenTo(this, 'checked', function () {
      if (!this.$el.hasClass('visible')) return;
      this.$el.removeClass('showing');
    });
    this.listenTo(this.tutorial, 'change', this.check);
    this.listenTo(this.stepsCollection, 'change', this.check);

    var client = new Clipboard('.recommended-tutorials_share_button');
    client.on('success', this.onCopySuccess);

    this.check();
  },

  fetch: function (url, urlRuleContains) {
    var newParams = {
      url: url,
      url_rule_contains: urlRuleContains,
      manage: false,
      customRecommended: this.tutorial.get('customRecommended'),
      customRecommendedListModTime: this.tutorial.get('customRecommendedListModTime'), // to refetch after saving custom recommended tutorials in Editor
    };
    if (!this.fetchCache || !_.isEqual(this.fetchCache.params, newParams)) {
      this.fetchCache.params = newParams;
      this.fetchCache.promise = iorad.player.controllers.sync.getRecommendedSuggestions({
        assets_key: this.tutorial.get('assetsKey'),
        ...newParams,
      });
    }
    return this.fetchCache.promise;
  },

  onCopySuccess: function(event) {
    var button = $(event.trigger);
    var html = button.hasClass('copy-url')
                ? i18next.t('Copy URL')
                : button.hasClass('copy-embed')
                  ? i18next.t('Copy Embed')
                  : button.find('span').html();

    button.find('span').html(i18next.t('Copied'));
    button.addClass('active');

    setTimeout(function (){
      button.css('color', 'transparent');
      setTimeout(function (){
        button.css('color', '');
        button.find('span').html(html);
        button.removeClass('active');
      }, 150);
    }, 2850);
  },

  check: function () {
    if (!this.$el.hasClass('visible')) return;
    var promise = Promise.resolve()
      .then(_.bind(function () {
        if (this.checkPromise !== promise) return Promise.resolve(); // too late

        var domainUrl = this.tutorial.getDomainUrl();
        var dmainUrlRuleContains = this.tutorial.getDomainUrlRuleContains();
        var domainLabel = domainUrl ? this.tutorial.getDomainLabel(domainUrl, { base: true }) : '';
        return this.fetch(domainUrl || '', dmainUrlRuleContains || '')
          .then(_.bind(function (result) {
            if (this.checkPromise !== promise) return Promise.resolve(); // too late

            var productUrl = result.product ? iorad.player.controllers.sync.getProductQuestionsUrl({
              roleId: result.product.role_id,
              urlId: result.product.help_center__url_id,
              productId: result.product.unique_id,
              helpCenterShare: true,
            }) : '';
            var isSharingDisabled = this.tutorial.isSharingDisabled();
            var isCopyLinkVisible = !isSharingDisabled && iorad.player.tab !== 'quiz';
            var isCopyEmbedVisible = !isSharingDisabled && iorad.player.tab !== 'quiz';

            const recommendedListIsNonEmpty = result.list.length !== 0;
            const isCustomPreviewMode = this.tutorial.get('customRecommended') && iorad.player.router.isPreviewMode();
            const isCaptureVisible = (
              this.tutorial.get('account_type') === 'free' ||
              result.tutorialAuthorIsAmbassador ||
              result.tutorialAuthorIsIorad
            );

            const shouldHideRecommendedBlock = !recommendedListIsNonEmpty && !isCustomPreviewMode;

            this.model.set({
              isShareVisible: isCopyLinkVisible || isCopyEmbedVisible,
              isCopyLinkVisible,
              isCopyEmbedVisible,
              domainLabel: domainLabel,
              recommendedList: result.list,
              shouldHideRecommendedBlock,
              recommendedListIsNonEmpty,
              productUrl,
              isCustomPreviewMode,
              isCaptureVisible,
            });

            this.trigger('checked');

            return Promise.resolve();
          }, this));
      }, this));
    this.checkPromise = promise;
  },

  getTemplateData: function () {
    return this.model.toJSON();
  },

  render: function () {
    var result = iorad.base.View.prototype.render.apply(this, arguments);

    iorad.player.controllers.sync.getPlayerURL()
      .then(_.bind(function(playerUrlData) {
        var shortLinkForQuick = iorad.base.Utils.replaceAll(
          playerUrlData.SHORT_LINK_IFRAME_HASH_TEMPLATE,
          encodeURIComponent('{{IORAD_IFRAME_HASH_PLACEHOLDER}}'),
          'viewsteps'
        );
        var publicLinkForQuick = iorad.base.Utils.replaceAll(
          playerUrlData.PUBLIC_LINK_IFRAME_HASH_TEMPLATE,
          encodeURIComponent('{{IORAD_IFRAME_HASH_PLACEHOLDER}}'),
          'viewsteps'
        );
        var embedForQuick = iorad.base.Utils.replaceAll(
          playerUrlData.EMBED_IFRAME_HASH_TEMPLATE,
          encodeURIComponent('{{IORAD_IFRAME_HASH_PLACEHOLDER}}'),
          'viewsteps'
        );

        this.$('.copy-url').attr('data-clipboard-text', shortLinkForQuick || publicLinkForQuick);
        this.$('.copy-embed').attr('data-clipboard-text', embedForQuick);
      }, this));

    return result;
  },

  // NOTE: called from the outside
  show: function () {
    if (this.$el.hasClass('visible')) return;
    this.$el.addClass('visible');
    this.$el.addClass('showing');
    this.check();
  },

  // NOTE: called from the outside
  hide: function () {
    if (!this.$el.hasClass('visible')) return;
    this.$el.removeClass('visible');
    this.$el.removeClass('showing');
  },

  toggle: function (value) {
    if (value) this.show();
    else this.hide();
  },

  onCaptureClick: function () {
    window.open(iorad.base.Settings.get('createNewTutorial.url'), '_blank');
  },

  onTutorialClick: function (event) {
    var tutorialId = Number($(event.currentTarget).attr('data-id'));
    var tutorial = this.model.get('recommendedList').find(_.bind(function (item) {
      return item.id === tutorialId;
    }, this));
    window.open(tutorial.playerURL, '_blank');
  },
});

;
iorad.player.views.layout_playbar = iorad.base.View.extend({
  template: iorad.player.templates.layout_playbar,

  events: {
    'click .selector-btn': 'onSelectorBtnClick',
    'click .export-btn': 'onExportBtnClick',
    'click .step-progress-btn': 'onStepProgressBtnClick',
    'click .btn.replay': 'onReplayClick',
    'click .btn.showcover': 'onShowCoverClick',
    'click .btn.prev': 'onPrevClick',
    'click .btn.next': 'onNextClick',
    'click .mute-btn': 'onMuteClick',
    'click .zoom-btn': 'onZoomClick',
    'click .media-btn': 'onMediaClick',
    'click .share-btn': 'onShareClick',
    'click .comments-btn': 'onCommentsClick',
    'click .fullscreen-btn': 'onFullscreenBtnClick',
    'click .currentstep': 'onCurrentstepBtnClick',
    'click .free-btn': 'onFreeBtnClick',
    'click .advanced-btn': 'onAdvancedBtnClick',
  },

  initialize: function () {
    this.tutorial = iorad.player.data.tutorial;
    this.stepsCollection = iorad.player.data.stepsCollection;
    this.themesCollection = iorad.player.data.themesCollection;

    this.model = new Backbone.Model({
      stepProgressRemainingTimeText: '',
      stepProgressPercent: 0,
      stepCountButtonHidden: false,
    });
    this.isAdvancedBtnHidden = true; // outside model since it is handled directly inside the render function

    this.modeMap = iorad.base.Utils.getPlayerMode();

    this.listenTo(this.model, 'change', this.check);
    this.listenTo(this.tutorial, 'change', this.check);
    this.listenTo(this.stepsCollection, 'change changeCurrent reset', this.check);
    this.listenTo(this.themesCollection, 'add remove sort reset change', this.check);
    this.listenTo(iorad.player.events, 'ready tab mode device change:coverOpen', this.check);
    this.listenTo(iorad.player.data.markerColors, 'change', this.check);
    this.listenTo(iorad.player.controllers.views, 'change:coverOpen change:coverCollapsing set:tutorialData change:forceStepPanel', this.check);
    this.listenTo(iorad.player.controllers.audio, 'change:audioState change:transcriptionState change:transcriptionEnabled', this.check);
    this.listenTo(iorad.player.controllers.video, 'change:videoState change:transcriptionState change:transcriptionEnabled', this.check);
    this.listenTo(iorad.player.events, 'video:display video:volume audio:volume', this.check);
    this.listenTo(iorad.player.controllers.music, 'change:musicState', this.check);
    this.listenTo(iorad.player.router.commentsView, 'change:unseen', this.check);
    this.listenTo(iorad.player.controllers.screenshots, 'change:zoom', this.check);
    this.listenTo(iorad.player.controllers.autoplay, 'change:paused change:resume', this.check);
    this.listenTo(iorad.player.events, 'item:last:rendered', this.check);
    this.listenTo(iorad.player.events, 'change:stepPanel', this.check);
    this.listenTo(iorad.player.controllers.quiz, 'end active', this.check);
    this.listenTo(iorad.player.controllers.quiz, 'recording:start recording:cancel recording:stop recording:inactive', this.check);
    this.listenTo(this.tutorial, 'change:quizResultsType', this.check);
    this.listenTo(iorad.player.events, 'sound:load sound:end sound:play sound:loaderror sound:mute sound:unmute', this.check);
    this.listenTo(iorad.player.events, 'video:load video:end video:play video:loaderror video:mute video:unmute', this.check);
    this.listenToDOM(window, 'resize', () => {
      this.check();

      this.setCurrentPlaybarPopupPosition();

      this.setTooltipOnOverflow();
    });
    if (screenfull.enabled) { // fullscreen is optional
      this.listenToDOM(document, screenfull.raw.fullscreenchange, this.check);
    }
    this.listenTo(iorad.player.events, 'autoplaySpeedChanged', this.check);
    this.listenToDOM(document, 'visibilitychange', this.check);
    this.listenTo(iorad.player.events, 'quick:back quick:next quick:goTo mobilequick:goTo', this.check);
    this.listenToDOM($('#main'), 'scroll', _.debounce(this.check.bind(this), 250));
    this.listenTo(iorad.player.events, 'ready:quick', this.check);
    this.listenTo(iorad.player.events, 'mobilequick:back mobilequick:next', this.check);
    this.listenToOnce(iorad.player.events, 'slide_fully_initialized slide_start slide_restart', this.check);
    this.listenTo(iorad.player.events, 'mobile:positionImage', this.check);
    this.listenTo(iorad.player.events, 'theme:applied', this.check);
    this.listenTo(iorad.player.events, 'selectedTranslationName', this.check);
    this.listenTo(iorad.player.events, 'toggle:languageDropdown', this.check);
    this.listenTo(iorad.player.events, 'slide_start_with_no_index', this.check);
    this.listenTo(iorad.player.events, 'interactive-nav:header:hovering mobile-slide:header:hovering', this.check);
    this.listenTo(iorad.player.events, 'before:change:deviceChangeOverlay change:deviceChangeOverlay', this.check);
    this.listenTo(iorad.player.events, 'update:media', this.check);
    this.listenTo(iorad.player.controllers.live, 'change:bannerData', this.check);

    this.listenTo(iorad.player.controllers.autoplay, 'setWatchModeProgressTimer', this.setStepProgressTimer);

    this.listenTo(iorad.player.events, 'playerPopup', this.restorePlaybarPopupPosition);

    this.listenToDOM(window, 'click', (event) => {
      if (
        this.interactiveZoomDisabledNoty &&
        $(event.target).closest(this.$('.zoom-btn')).length === 0
      ) {
        this.interactiveZoomDisabledNoty.close();
      }
    }, true);

    this.getPlayerUserFinished = false;
    this.userIsAuthor = false;
    this.userIsLoggedIn = false;
    if (window.downloadPlayerType) {
      this.getPlayerUserFinished = true;
      this.check();
    } else {
      this.check();
      iorad.player.controllers.views.registerRenderOperation('playbar.getPlayerUser', (onComplete) => {
        let cleared = false;

        iorad.player.controllers.sync.getPlayerUser()
          .then((data) => {
            this.getPlayerUserFinished = true;
            this.userIsAuthor = data.userIsAuthor;
            this.userIsLoggedIn = data.userIsLoggedIn;
            this.check();
            if (!cleared) onComplete();
          })
          .catch((err) => {
            this.getPlayerUserFinished = true;
            console.error(err);
            this.check();
            if (!cleared) onComplete();
          });

        return function clear() {
          cleared = true;
        };
      });
    }
  },

  check: function () {
    if (!iorad.player.router) return;
    if (iorad.player.deviceChangeOverlayVisible && !iorad.player.deviceChangeOverlayHiding) {
      // PERFORMANCE OPTIMIZATION: https://github.com/iorad/iorad-extension/issues/2435
      // limit re-renders or the browser won't keep up and will keep showing the old graphics
      // even if the render actually already completed and the overlay was hidden
      return;
    }

    this.render();
  },

  getMobilequickSlideData: function () {
    const $mobileSlideListEl = (
      iorad.player.router.layoutModes.mobileSlideList &&
      iorad.player.router.layoutModes.mobileSlideList.$el
    );
    if (!$mobileSlideListEl || !$mobileSlideListEl.getCurrentSlide) return null;
    const currentSlideIndex = $mobileSlideListEl.getCurrentSlide();
    const totalSlidesLength = $mobileSlideListEl.getSlideCount();
    return {
      currentSlideIndex,
      totalSlidesLength,
    };
  },

  getMobilequickFinished: function () {
    if (iorad.player.mode === 'mobilequick') {
      const mobilequickSlidesData = this.getMobilequickSlideData();
      if (mobilequickSlidesData) {
        const { currentSlideIndex, totalSlidesLength } = mobilequickSlidesData;
        const recommendedShouldShow = Boolean(
          !window.downloadPlayerType &&
          this.tutorial.get('recommendedEnabled') &&
          !this.tutorial.getLayoutOption('is_recommended_disabled')
        );
        const mobilequickFinishedIsLastSlide = recommendedShouldShow;
        const mobilequickFinished = mobilequickFinishedIsLastSlide ?
          (currentSlideIndex === totalSlidesLength - 1)
          :
          (currentSlideIndex >= totalSlidesLength - 2);
        return {
          mobilequickFinished,
          mobilequickFinishedIsLastSlide,
        };
      }
    }
    return { mobilequickFinished: false, mobilequickFinishedIsLastSlide: false };
  },

  getIsStepProgressAnimationHovering: function () {
    if (iorad.player.mode === 'interactive') {
      return $('#playing-player .start-step').hasClass('hovering');
    }
    if (iorad.player.mode === 'mobilequick') {
      const $mobileSlideListEl = (
        iorad.player.router.layoutModes.mobileSlideList &&
        iorad.player.router.layoutModes.mobileSlideList.$el
      );
      if ($mobileSlideListEl && $mobileSlideListEl.getCurrentSlide) {
        const current = $mobileSlideListEl.getCurrentSlide();
        const total = $mobileSlideListEl.getSlideCount();
        if (current >= 0 && current <= total - 2) { // "current" also takes into account the "finished" slide
          const currentStepSlide = iorad.player.router.layoutModes.mobileSlideList.slideViews[current];
          if (currentStepSlide) {
            return currentStepSlide.$('.steptext-header').hasClass('hovering');
          }
        }
      }
    }
    return false;
  },

  getTemplateData: function () {
    const isRealMobile = iorad.player.controllers.clientDetect.device.isMobile;
    const isMobileTutorial = this.tutorial.get('isMobile');
    const modeTab = iorad.player.controllers.views.isModalTab(iorad.player.tab) ? iorad.player.oldTab : iorad.player.tab;
    const position = this.stepsCollection.position;
    const stepsLength = this.stepsCollection.length;
    const stepModel = this.stepsCollection.getCurrentModel();
    const coverOpen = iorad.player.controllers.views.isCoverOpen();
    const validQuizStep = iorad.player.mode === 'interactive' && modeTab == 'quiz';
    const validAdvanceableQuizStep = validQuizStep && !(
      stepModel &&
      stepModel.get('type') === 'READ' &&
      stepModel.get('event.autoadvance') === false
    );
    const { mobilequickFinished, mobilequickFinishedIsLastSlide } = this.getMobilequickFinished();
    const tabIsModal = iorad.player.controllers.views.isModalTab(iorad.player.tab);
    const tutorialHasReadStepAutoadvance = iorad.player.data.stepsCollection.some(aStepModel =>
      aStepModel.isReadAutoadvance()
    );
    const videoStateClasses = iorad.player.controllers.video.getVideoStateClasses();
    const audioStateClasses = iorad.player.controllers.audio.getAudioStateClasses();
    const tutorialHasVideo = !videoStateClasses.includes('tutorial-no-video');
    const tutorialHasAudio = !audioStateClasses.includes('tutorial-no-audio');
    const stepTryAutoadvance = modeTab === 'try' && stepModel && stepModel.isReadAutoadvance();
    const stepAnyAutoadvance = modeTab === 'watch' || stepTryAutoadvance;
    const stepHasVideo = Boolean(stepModel && stepModel.get('videoId') != null);
    const stepHasAudio = Boolean(stepModel && stepModel.get('audioId') != null);
    const stepUseVideo = (
      tutorialHasVideo &&
      !videoStateClasses.includes('load-error') &&
      !videoStateClasses.includes('mute')
    );
    const stepUseAudio = (
      tutorialHasAudio &&
      !audioStateClasses.includes('load-error') &&
      !audioStateClasses.includes('mute')
    );
    const isPopupOpen = iorad.player.controllers.views.isPopupOpen();
    const realAccountType = this.tutorial.get('editor_account_type') || // in case editor is previewing a theme (#2986)
      this.tutorial.get('account_type');
    const isAccountNonFree = realAccountType !== 'free'; // this means a non-free user (private, premium or live plan). Yes it's misleading.
    const isOrWasPremium = this.tutorial.get('isPremiumTutorial') || isAccountNonFree;
    const referralsEnabled = Boolean(this.tutorial.get('referrals_enabled'));
    const currentTheme = this.themesCollection.get(this.tutorial.get('theme'));
    const ic = iorad.base.Export.themeToItemColors(
      currentTheme && currentTheme.attributes,
      this.tutorial.get('baseThemes'),
      this.tutorial.get('theme'),
      coverOpen
    );

    const isSelectorPopupUnsupported = isRealMobile && !isMobileTutorial;
    const isSelectorBtnDisabled = isPopupOpen;
    const isSelectorBtnHidden = isSelectorPopupUnsupported || (
      iorad.player.device !== 'desktop' &&
      !coverOpen
    );

    const advancedPopupShowsSelectorButton = (
      isSelectorBtnHidden &&
      !isSelectorPopupUnsupported
    );
    const breakpointSmBoth = (window.innerHeight <= 550 || window.innerWidth <= 750);
    const isAdvancedBtnHidden = (
      !breakpointSmBoth ||
      (isRealMobile && coverOpen)
    ) && !advancedPopupShowsSelectorButton;

    const isExportBtnDisabled = false;
    const isExportBtnHidden = (
      this.tutorial.getLayoutOption('is_print_portrait_disabled') &&
      this.tutorial.getLayoutOption('is_print_landscape_disabled')
    ) || !isAdvancedBtnHidden;

    const isWatchModeSpeedBtnHidden = true; // always hidden for now
    const isWatchModeSpeedBtnDisabled = (
      isWatchModeSpeedBtnHidden ||
      coverOpen ||
      tabIsModal
    );
    let watchModeSpeedText = '';
    let watchModeSpeedHref = '#';
    if (!isWatchModeSpeedBtnHidden) {
      const autoplaySpeed = iorad.player.controllers.autoplay.getSpeedOptions();
      const speedPresets = _.keys(iorad.player.controllers.autoplay.getSpeedOptionsMap());
      const selectedSpeedIndex = speedPresets.indexOf(iorad.player.controllers.autoplay.getSpeed());
      const newSpeedIndex = (selectedSpeedIndex + 1) < speedPresets.length ? (selectedSpeedIndex + 1) : 0;

      watchModeSpeedText = autoplaySpeed.navLabel;
      watchModeSpeedHref = iorad.player.router.getInteractiveModeLink(modeTab, null, speedPresets[newSpeedIndex]);
    }

    const stepProgressRemainingTimeText = this.model.get('stepProgressRemainingTimeText');
    const stepProgressPercent = this.model.get('stepProgressPercent');

    // console.log('stepProgressPercent', stepProgressPercent, stepProgressRemainingTimeText)
    const forceShowProgress = (modeTab === 'try' && stepModel && stepModel.get('description').length); // #13132
    const stepHasProgress = (
      modeTab === 'watch' ||
      (modeTab === 'try' && tutorialHasReadStepAutoadvance) ||
      tutorialHasVideo ||
      tutorialHasAudio
    );
    const interactiveFinished = (
      iorad.player.mode === 'interactive' &&
      position >= stepsLength - 1
    );
    const quickFinished = (
      iorad.player.mode === 'quick' &&
      position >= stepsLength - 1
    );
    const finishedIncludingProgress = (
      (interactiveFinished && (
        !stepHasProgress ||
        stepProgressPercent === 100)
      ) ||
      quickFinished ||
      (
        mobilequickFinished &&
        (
          mobilequickFinishedIsLastSlide ||
          !stepHasProgress ||
          stepProgressPercent === 100
        )
      )
    );
    const isProgressBarHidden = this.tutorial.getLayoutOption('is_progress_bar_disabled');
    const isStepProgressBtnHidden = isProgressBarHidden || (
      coverOpen ||
      !stepHasProgress ||
      finishedIncludingProgress
    );
    const isStepProgressBtnDisabled = coverOpen || tabIsModal || (
      !isStepProgressBtnHidden &&
      !stepAnyAutoadvance && // because button can be used to pause autoadvance
      (
        (stepHasVideo && (
          // button can be used to pause video
          videoStateClasses.includes('load-error') ||
          videoStateClasses.includes('end') ||
          videoStateClasses.includes('mute')
        )) ||
        (stepHasAudio && (
          // button can be used to pause audio
          audioStateClasses.includes('load-error') ||
          audioStateClasses.includes('end') ||
          audioStateClasses.includes('mute')
        )) ||
        (!stepHasVideo && !stepHasAudio)
      )
    );
    const showStepProgressPlay = Boolean(iorad.player.controllers.autoplay.paused);

    let stepProgressDuration;
    if (
      modeTab !== 'watch' && // watch is handled by autoplay controller
      !coverOpen &&
      !tabIsModal &&
      !isStepProgressBtnHidden &&
      (
        stepAnyAutoadvance ||
        (
          (stepHasVideo && (
            // (end is fine, since progress should show even after media ended)
            !videoStateClasses.includes('load') &&
            !videoStateClasses.includes('load-error') &&
            !videoStateClasses.includes('mute')
          )) ||
          (stepHasAudio && (
            // (end is fine, since progress should show even after media ended)
            !audioStateClasses.includes('load') &&
            !audioStateClasses.includes('load-error') &&
            !audioStateClasses.includes('mute')
          ))
        )
      )
    ) {
      if (stepTryAutoadvance) {
        stepProgressDuration = (!stepUseVideo && !stepUseAudio) ?
          'interactiveReadRemainingTime'
          : stepUseVideo ? 'videoRemainingPlayTime'
            : 'audioRemainingPlayTime';
      } else {
        // just video or audio
        stepProgressDuration = stepUseVideo ?
          'videoRemainingPlayTime'
          : 'audioRemainingPlayTime';
      }
    } else if (forceShowProgress) {
      stepProgressDuration = (!stepUseVideo && !stepUseAudio) ?
        'interactiveReadRemainingTime'
        : stepUseVideo ? 'videoRemainingPlayTime'
          : 'audioRemainingPlayTime';
    }
    const isStepProgressAnimationHidden = (
      modeTab !== 'watch' &&
      typeof stepProgressDuration === 'undefined'
    );
    const isStepProgressAnimationHovering = this.getIsStepProgressAnimationHovering();
    const isStepProgressRemainingTimeHidden = (
      isStepProgressAnimationHidden ||
      !isStepProgressAnimationHovering
    );

    const isReplayBtnDisabled = coverOpen || tabIsModal;
    const isReplayBtnHidden = !finishedIncludingProgress;

    const isCoverBtnHidden = true; // use prev button
    const isCoverBtnDisabled = coverOpen || tabIsModal;

    const isPrevBtnHidden = coverOpen || this.tutorial.getLayoutOption('is_navigation_disabled');
    const isPrevBtnDisabled = (
      coverOpen ||
      tabIsModal ||
      position < 0 ||
      validQuizStep
    );
    const isPrevBtnRotated = iorad.player.mode === 'quick';
    const prevStepNumber = position; // position is zero based, thus prev is +0
    const prevBtnHref = iorad.player.router.getInteractiveModeLink(modeTab, prevStepNumber);

    const isNextBtnHidden = this.tutorial.getLayoutOption('is_navigation_disabled') || coverOpen;
    const isNextBtnDisabled = (() => {
      if (iorad.player.mode === 'interactive') {
        return (
          coverOpen ||
          tabIsModal ||
          position >= stepsLength - 1 ||
          validAdvanceableQuizStep ||
          iorad.player.controllers.audio.isAudioCompletitionRequired() ||
          iorad.player.controllers.video.isVideoCompletitionRequired()
        );
      }
      if (iorad.player.mode === 'mobilequick') {
        return (
          coverOpen ||
          tabIsModal ||
          mobilequickFinished
        );
      }
      return coverOpen || tabIsModal || position >= stepsLength - 1;
    })();
    const isNextBtnRotated = iorad.player.mode === 'quick';
    const isNextBtnBlink = (() => {
      if (iorad.player.mode === 'mobilequick') {
        const mobilequickSlidesData = this.getMobilequickSlideData();
        if (mobilequickSlidesData) {
          const { currentSlideIndex } = mobilequickSlidesData;
          const stepCompleted = (
            (stepModel && stepModel.get('videoId') != null && !videoStateClasses.includes('mute')) ? videoStateClasses.includes('end') : // videoCompleted
              (stepModel && stepModel.get('audioId') != null && !audioStateClasses.includes('mute')) ? audioStateClasses.includes('end') : // audioCompleted
                true // readCompleted
          );
          return currentSlideIndex === 0 && stepCompleted;
        }
      }
      return false;
    })();
    const nextStepNumber = position + 2; // position is zero based, thus next is +2
    const nextBtnHref = iorad.player.router.getInteractiveModeLink(modeTab, nextStepNumber);

    const isNextBtnShowCheckbox = isNextBtnDisabled && (mobilequickFinished || position >= stepsLength - 1);

    const isZoomBtnHidden = coverOpen;
    const isZoomBtnDisabled = (
      coverOpen ||
      tabIsModal ||
      (mobilequickFinished && mobilequickFinishedIsLastSlide)
    );
    const showZoomIn = iorad.player.controllers.screenshots.isNextZoomIn();

    const mediaData = iorad.player.router.mediaView.getTemplateData();

    const mediaBtnShouldHidden =
      (mediaData.videoHidden || mediaData.videoUnchangeable) &&
      (mediaData.voiceoverHidden || mediaData.voiceoverUnchangeable) &&
      mediaData.transcriptionHidden &&
      mediaData.musicHidden &&
      mediaData.languageHidden &&
      mediaData.stepHidden;

    const tutorialWithVideo = !videoStateClasses.includes('tutorial-no-video');
    const isMediaBtnHidden = !isAdvancedBtnHidden || mediaBtnShouldHidden;
    const isMediaBtnDisabled = isPopupOpen;
    const isMediaBtnAudioOnly = Boolean(!tutorialWithVideo);

    const isShareBtnHidden = this.tutorial.isSharingDisabled() || !isAdvancedBtnHidden;
    const isShareBtnDisabled = isPopupOpen;

    const isCommentsBtnHidden = this.tutorial.isCommentingDisabled() || !isAdvancedBtnHidden ||
      (this.tutorial.get('commentEnabledFor') !== 'everyone' && !this.userIsLoggedIn);
    const isCommentsBtnDisabled = isPopupOpen;
    const isCommentUnseen = iorad.player.router.commentsView.unseen;

    const isFullscreenBtnDisabled = isPopupOpen;
    const isFullscreenBtnHidden = (
      !screenfull.enabled ||
      this.tutorial.getLayoutOption('is_fullscreen_disabled')
    );
    const isFullscreenActive = iorad.player.controllers.views.isFullscreen();

    const isFreeBtnDisabled = false;
    const isFreeBtnHidden = !(
      (!isOrWasPremium || referralsEnabled)
    );
    const freeBtnText = !this.userIsLoggedIn ? (
      breakpointSmBoth ?
        i18next.t('Join iorad')
        :
        i18next.t('Join iorad for free')
    ) : (
      this.userIsAuthor ?
        i18next.t('Upgrade')
        :
        i18next.t('Capture')
    );

    const faviconIsCustom = (ic.favicon.image && !ic.favicon.isBaseTheme);
    const isFaviconBtnDisabled = false;
    const isFaviconBtnHidden = (
      (isOrWasPremium && !faviconIsCustom) ||
      this.tutorial.getLayoutOption('is_favicon_disabled')
    );
    const faviconImageSrc = faviconIsCustom ?
      (ic.favicon.image.indexOf('.svg') === -1 ?
        ic.favicon.croppedImage :
        ic.favicon.image
      )
      :
      (
        ic.favicon.baseImage ||
        iorad.base.Export.getDefaultFaviconUrl()
      );
    const faviconHref = (
      ic.logo.href ||
      (!faviconIsCustom ? '/' : null)
    );

    const activeMode = this.modeMap[modeTab];
    const isFreeFaviconContainerHidden = !isAdvancedBtnHidden || (
      isFaviconBtnHidden && isFreeBtnHidden
    );

    const advancedBtnShouldHidden = mediaBtnShouldHidden &&
      this.tutorial.isSharingDisabled() &&
      this.tutorial.isCommentingDisabled() &&
      this.tutorial.getLayoutOption('is_print_portrait_disabled') &&
      this.tutorial.getLayoutOption('is_print_landscape_disabled');

    const hidden = (
      (iorad.player.getParameters.playbarDisabled === 'true') ||
      this.tutorial.getLayoutOption('is_playbar_disabled')
    );

    const currentZoom = iorad.player.controllers.screenshots.getCurrentZoom();

    const isMuteBtnHidden = (
      mediaData.voiceoverHidden &&
      mediaData.musicHidden
    ) || modeTab === 'quick';
    const isMuteBtnDisabled = (
      (mediaData.voiceoverHidden || mediaData.voiceoverDisabled || mediaData.voiceoverUnchangeable) &&
      (mediaData.musicHidden || mediaData.musicDisabled)
    ) || (
      // if something is unchangeable, then disable everything
      mediaData.voiceoverUnchangeable && !mediaData.voiceoverHidden && !mediaData.voiceoverDisabled
    );
    // only show unmute when there is nothing to mute
    const showUnmute = (
      (!mediaData.voiceoverChecked || mediaData.voiceoverHidden || mediaData.voiceoverDisabled || mediaData.voiceoverUnchangeable) &&
      (!mediaData.musicChecked || mediaData.musicHidden || mediaData.musicDisabled)
    );

    return _.extend({}, {
      currentTab: iorad.player.tab,

      hidden,
      currentZoom,

      advancedPopupShowsSelectorButton, // HACK: read from the outside
      isSelectorBtnDisabled,
      isSelectorBtnHidden,

      isExportBtnDisabled,
      isExportBtnHidden,

      isWatchModeSpeedBtnDisabled,
      isWatchModeSpeedBtnHidden,
      watchModeSpeedText,
      watchModeSpeedHref,

      isStepProgressBtnHidden, // HACK: read from the outside
      isStepProgressBtnDisabled, // HACK: read from the outside
      showStepProgressPlay, // HACK: read from the outside
      isStepProgressAnimationHidden, // HACK: read from the outside
      isStepProgressRemainingTimeHidden,
      stepProgressDuration,
      stepProgressRemainingTimeText,
      stepProgressPercent, // HACK: read from the outside

      isReplayBtnDisabled,
      isReplayBtnHidden,

      isCoverBtnHidden,
      isCoverBtnDisabled,

      isPrevBtnHidden, // HACK: read from the outside
      isPrevBtnDisabled, // HACK: read from the outside
      isPrevBtnRotated,
      prevBtnHref,

      isNextBtnHidden, // HACK: read from the outside
      isNextBtnDisabled, // HACK: read from the outside
      isNextBtnRotated,
      isNextBtnBlink,
      nextBtnHref,
      isNextBtnShowCheckbox,

      isMuteBtnHidden,
      isMuteBtnDisabled,
      showUnmute,
      isMuteBtnUnchangeable: mediaData.voiceoverUnchangeable,

      isZoomBtnHidden, // HACK: read from the outside
      isZoomBtnDisabled, // HACK: read from the outside
      showZoomIn,

      isMediaBtnHidden,
      isMediaBtnDisabled,
      isMediaBtnAudioOnly,

      isShareBtnHidden,
      isShareBtnDisabled,

      isCommentsBtnHidden,
      isCommentsBtnDisabled,
      isCommentUnseen,

      isFullscreenBtnDisabled,
      isFullscreenBtnHidden,
      isFullscreenActive,

      isFreeBtnDisabled,
      isFreeBtnHidden,
      freeBtnText,

      isFreeFaviconContainerHidden,
      isAdvancedBtnHidden: advancedBtnShouldHidden || isAdvancedBtnHidden,

      isFaviconBtnDisabled,
      isFaviconBtnHidden,
      faviconImageSrc,
      faviconHref,

      activeMode,
      isCoverOpen: coverOpen,
    });
  },

  render: function () {
    const oldTemplateData = this.templateData || {};

    if (this.$('.free-btn:hover').length) {
      // hovering the .free-btn causes it to be fully displayed (if overflow)
      // this also leads to jumping effects
      // with the advance button being shown / hidden repeatedly
      // => prevent this via regular render
      this.templateData = this.getTemplateData();
      window.litHTML.render(this.template(this.templateData), this.el);
    } else {
      // first render is always without the advance button
      // to be able to do calculations on the full layout
      this.isAdvancedBtnHidden = true;
      this.templateData = this.getTemplateData();
      window.litHTML.render(this.template(this.templateData), this.el);
      // then check if advance button is actually needed
      const visibleWidth = (
        (this.$el.width() || 0) -
        (this.$('.free-favicon-container:visible').width() || 0)
      );
      const isAdvancedBtnHidden = visibleWidth > 300;
      if (!isAdvancedBtnHidden) {
        // re-render with it
        this.isAdvancedBtnHidden = false;
        this.templateData = this.getTemplateData();
        window.litHTML.render(this.template(this.templateData), this.el);
      }
    }

    this.componentDidUpdate(oldTemplateData);

    return this;
  },

  componentDidUpdate: function (oldTemplateData) {
    if (
      oldTemplateData.currentZoom === this.templateData.currentZoom && // #13132
      typeof this.templateData.stepProgressDuration !== 'undefined' &&
      (
        oldTemplateData.stepProgressDuration !== this.templateData.stepProgressDuration ||
        typeof this.stepProgressGetRemainingTime === 'undefined' ||
        typeof this.stepProgressGetTotalTime === 'undefined'
      )
    ) {
      const getRemainingTime = ({
        'interactiveReadRemainingTime': () => iorad.player.interactiveReadRemainingTime || 0,
        'videoRemainingPlayTime': () => iorad.player.controllers.video.getRemainingPlayTime(),
        'audioRemainingPlayTime': () => iorad.player.controllers.audio.getRemainingPlayTime(),
      })[this.templateData.stepProgressDuration];
      const getTotalTime = ({
        'interactiveReadRemainingTime': () => iorad.player.interactiveReadTotalTime || 0,
        'videoRemainingPlayTime': () => iorad.player.controllers.video.getTotalPlayTime(),
        'audioRemainingPlayTime': () => iorad.player.controllers.audio.getTotalPlayTime(),
      })[this.templateData.stepProgressDuration];
      this.setStepProgressTimer(getRemainingTime, getTotalTime);
    }

    if (this.templateData.hidden !== oldTemplateData.hidden) {
      this.$el.toggleClass('hide', Boolean(this.templateData.hidden));
      $('html').toggleClass('playbarHidden', Boolean(this.templateData.hidden));
    }

    iorad.player.events.trigger('update:playbar');
  },

  setStepProgressTimer: function (getRemainingTime, getTotalTime) {
    if (typeof getRemainingTime !== 'function') {
      const totalTime = getRemainingTime;
      let remainingTime = getRemainingTime;
      let oldTime = Date.now();
      getRemainingTime = () => {
        const currentTime = Date.now();
        const elapsedTime = currentTime - oldTime;
        oldTime = currentTime;
        if (!iorad.player.controllers.autoplay.paused) {
          remainingTime -= elapsedTime;
        }
        return remainingTime;
      };
      getTotalTime = () => totalTime;
    }

    if (this.stepProgressGetRemainingTime) {
      // existing tick will handle the new function
      this.stepProgressGetRemainingTime = getRemainingTime;
      this.stepProgressGetTotalTime = getTotalTime;
      return;
    }
    this.stepProgressGetRemainingTime = getRemainingTime;
    this.stepProgressGetTotalTime = getTotalTime;
    const tick = () => {
      const remainingTime = this.stepProgressGetRemainingTime();
      const totalTime = this.stepProgressGetTotalTime();
      try {
        if (iorad.player.controllers.autoplay.paused) return;

        var seconds = Math.max(0, remainingTime) / 1000;
        // console.log('seconds', seconds, remainingTime);
        this.model.set({
          stepProgressRemainingTimeText: Math.floor(seconds) + 's',
          stepProgressPercent: !totalTime ?
            100
            :
            (Math.min(100, (100 - Math.floor((remainingTime / totalTime) * 100))) || 0),
        });
      } finally {
        if (remainingTime > 0) {
          requestAnimationFrame(tick);
        } else {
          this.stepProgressGetRemainingTime = undefined;
          this.stepProgressGetTotalTime = undefined;
          iorad.player.events.trigger('stepProgressTimer:done');
        }
      }
    };
    requestAnimationFrame(tick);
  },

  restorePlaybarPopupPosition: function(isPopupOpen) {
    if (!isPopupOpen) {
      $('.player-popup.small-popup').removeClass('small-popup').css({
        width: '',
        left: '',
        right: '',
      });

      this.$el.find('.playbar-btn.active').removeClass('active');

      $('[data-inert-for-popup]').each((i, el) => {
        el.inert = undefined;
        el.removeAttribute('data-inert-for-popup');
      });
    }
  },

  setTooltipOnOverflow: _.debounce(function() {
    $('.player-popup').each(function() {
      iorad.player.controllers.views.setTooltipOnOverflow($(this));
    })
  }, 200),

  setCurrentPlaybarPopupPosition: function() {
    // copy this.check
    if (!iorad.player.router) return;
    if (iorad.player.deviceChangeOverlayVisible && !iorad.player.deviceChangeOverlayHiding) {
      return;
    }

    const self = this;

    const windowWidth = window.innerWidth;

    let changedPosition = false;

    const setStyle = (el, popupView) => {
      if (!el) return;

      changedPosition = true;

      const bounds = el.getBoundingClientRect();

      let popupWidth = 275;

      if (el.clientWidth > popupWidth) {
        popupWidth = el.clientWidth;
      }

      const styles = {
        width: `${popupWidth}px`,
      }

      if (popupWidth + bounds.x > windowWidth) {
        styles.left = windowWidth - popupWidth;
      } else {
        styles.left = bounds.x;
      }

      popupView.css(styles);
    }

    const menuPlaybarEl = this.$el.find('.playbar-btn.advanced-btn');

    $('.player-popup.small-popup').each(function() {
      const popupView = $(this);

      const activePlaybarEls = self.$el.find(`[data-for="${popupView.attr('id')}"]`);

      if (activePlaybarEls.length) {
        activePlaybarEls.each(function() {
          if ($(this).is(':visible')) {
            setStyle(this, popupView);
          }

          // trying move to advanced-btn position
          if (!changedPosition && menuPlaybarEl.is(':visible')) {
            setStyle(menuPlaybarEl.get(0), popupView);
          }
        });
      } else if (popupView.attr('id') === 'steps') {
        // to right side
        const popupWidth = 275;
        popupView.css({
          width: `${popupWidth}px`,
          left: windowWidth - popupWidth
        });
      }
    });
  },

  setPlaybarPopupPosition: function(playbarEl, popupView) {
    this.setTooltipOnOverflow();

    if (
      iorad.player.controllers.clientDetect.device.isMobile ||
      iorad.player.router.doMatchMobilePortrait() ||
      window.innerWidth <= 750
    ) {
      iorad.player.router.togglePlayerPopup(true);

      return;
    }

    // #15011 user can navigate by press Tab key (for Accessibility) and bypass overlay-popup to close this steps navigator and cause 200% zoom cutof
    iorad.player.router.stepsView.onCloseStepsPopupClick();

    if (playbarEl) {
      playbarEl.closest('.playbar-btn').addClass('active').attr('data-for', popupView.$el.attr('id'));
    }

    popupView.$el.addClass('small-popup');

    $('#main, #playbar').each((i, el) => {
      el.inert = true;
      el.setAttribute('data-inert-for-popup', 'true');
    });

    this.setCurrentPlaybarPopupPosition();
  },

  onSelectorBtnClick: function(event) {
    // event.stopPropagation();
    event.preventDefault();

    this.setPlaybarPopupPosition($(event.currentTarget), iorad.player.router.selectorView);
    // iorad.player.router.togglePlayerPopup(true);
    iorad.player.router.selectorView.toggle();
  },

  onExportBtnClick: function(event) {
    // event.stopPropagation();
    event.preventDefault();

    this.setPlaybarPopupPosition($(event.currentTarget), iorad.player.router.exportView);
    // iorad.player.router.togglePlayerPopup(true);
    iorad.player.router.exportView.toggle();
  },

  onStepProgressBtnClick: function(event) {
    event.preventDefault();
    if (iorad.player.controllers.autoplay.paused) {
      iorad.player.controllers.autoplay.resumeAutoplay();
    } else {
      iorad.player.controllers.autoplay.pauseAutoplay();
    }
  },

  onReplayClick: function (e) {
    e.preventDefault();

    if (iorad.player.mode === 'interactive') {
      iorad.player.events.trigger('interactive:replay');
    } else if (iorad.player.mode === 'mobilequick') {
      iorad.player.events.trigger('restart:mobilequick');
    } else if (iorad.player.mode === 'quick') {
      iorad.player.events.trigger('quick:goTo', 0);
    } else {
      throw new Error('Not implemented: ' + iorad.player.mode);
    }
  },

  onShowCoverClick: function (e) {
    e.preventDefault();
    iorad.player.controllers.views.setCoverOpen(true, false, true);
  },

  resetFocus: function() {
    window.parent.focus();
  },

  onPrevClick: function(e) {
    this.resetFocus();

    if (this.stepsCollection.position === 0) {
      e.preventDefault();
      iorad.player.controllers.views.setCoverOpen(true, false, true);
      return;
    }

    if (iorad.player.mode === 'quick') {
      e.preventDefault();
      iorad.player.events.trigger('quick:back');
    } else if (iorad.player.mode === 'mobilequick') {
      e.preventDefault();
      iorad.player.events.trigger('mobilequick:back');
    } else {
      // no-op: just follow link
    }
  },

  onNextClick: function (e) {
    this.resetFocus();

    if (iorad.player.mode === 'quick') {
      e.preventDefault();
      iorad.player.events.trigger('quick:next');
    } else if (iorad.player.mode === 'mobilequick') {
      e.preventDefault();
      iorad.player.events.trigger('mobilequick:next');
    } else {
      // no-op: just follow link
    }
  },

  onMuteClick: function (e) {
    e.preventDefault();

    // NOTE: media is toggled even if disabled (while not hidden)
    // this is because "disabled and not hidden" means that other steps still have media
    const mediaData = iorad.player.router.mediaView.getTemplateData();

    if (mediaData.voiceoverUnchangeable) {
      noty({
        type: 'error',
        text: 'Media completion required.',
      });

      return;
    }

    if (this.templateData.showUnmute) {
      // unmute
      if (!mediaData.voiceoverHidden && !mediaData.voiceoverUnchangeable && !mediaData.voiceoverChecked) {
        iorad.player.router.mediaView.toggleVoiceover();
      }
      if (!iorad.player.router.mediaView.musicUnchecked && !mediaData.musicHidden && !mediaData.musicChecked) {
        iorad.player.router.mediaView.toggleMusic();
      }
      if (
        !iorad.player.router.mediaView.transcriptionClicked &&
        !mediaData.transcriptionHidden &&
        !mediaData.transcriptionDisabled &&
        mediaData.transcriptionChecked
      ) {
        // uncheck transcription
        iorad.player.router.mediaView.toggleTranscription();
      }
    } else {
      // mute
      if (!mediaData.voiceoverHidden && !mediaData.voiceoverUnchangeable && mediaData.voiceoverChecked) {
        iorad.player.router.mediaView.toggleVoiceover();
      }
      if (!iorad.player.router.mediaView.musicUnchecked && !mediaData.musicHidden && mediaData.musicChecked) {
        iorad.player.router.mediaView.toggleMusic();
      }
      if (
        !iorad.player.router.mediaView.transcriptionClicked &&
        !mediaData.transcriptionHidden &&
        !mediaData.transcriptionDisabled &&
        !mediaData.transcriptionChecked
      ) {
        // check transcription
        iorad.player.router.mediaView.toggleTranscription();
      }
    }
  },

  onZoomClick: function (event) {
    event.preventDefault();

    if (iorad.player.mode === 'interactive') {
      const viewportEl = $('#playing-player #interactive-image');
      const screenshotEl = viewportEl.find('.containment');
      if (
        // NOTE: jQuery width/height returns size without scale (zoom independent)
        screenshotEl.width() <= viewportEl.width() &&
        screenshotEl.height() <= viewportEl.height()
      ) {
        // screenshot is fully zoomed out even without any zoom
        if (!this.interactiveZoomDisabledNoty) {
          this.interactiveZoomDisabledNoty = noty({
            type: 'information',
            text: 'Image is at full resolution.',
            buttons: [{
              addClass: 'btn btn-primary btn-green btn-small',
              text: 'OK',
              onClick: $noty => {
                $noty.close();
              },
            }],
            callback: {
              afterClose: () => {
                this.interactiveZoomDisabledNoty = undefined;
              }, // for manual closing
            }
          });
        }
        return;
      }
    }
    iorad.player.controllers.screenshots.zoomNext();
  },

  onMediaClick: function (event) {
    // event.stopPropagation();
    event.preventDefault();

    this.setPlaybarPopupPosition($(event.currentTarget), iorad.player.router.mediaView);
    // iorad.player.router.togglePlayerPopup(true);
    iorad.player.router.mediaView.setPlaybarBtnEl($(event.currentTarget));
    iorad.player.router.mediaView.toggle();
  },

  onShareClick: function (event) {
    // event.stopPropagation();
    event.preventDefault();

    this.setPlaybarPopupPosition($(event.currentTarget), iorad.player.router.shareView);
    // iorad.player.router.togglePlayerPopup(true);
    iorad.player.router.shareView.toggle();
  },

  onCommentsClick: function (event) {
    // event.stopPropagation();
    event.preventDefault();

    this.setPlaybarPopupPosition($(event.currentTarget), iorad.player.router.commentsView);
    // iorad.player.router.togglePlayerPopup(true);
    iorad.player.router.commentsView.toggle();
  },

  onFullscreenBtnClick: function (event) {
    if (event) {
      event.preventDefault();
    }

    iorad.player.controllers.views.toggleFullscreen();
    return false;
  },

  onCurrentstepBtnClick: function (event) {
    if (event) {
      event.preventDefault();
    }
    iorad.player.router.togglePlayerPopup(true);
    iorad.player.router.stepsView.toggle();
  },

  onFreeBtnClick: function () {
    if (!this.userIsLoggedIn) {
      window.open(iorad.base.Settings.get('signup.url'), '_blank');
    } else {
      if (this.userIsAuthor) {
        window.open(iorad.base.Settings.get('updateSubscription.url'), '_blank');
      } else {
        window.open(iorad.base.Settings.get('createNewTutorial.url'), '_blank');
      }
    }
  },

  onAdvancedBtnClick: function (event) {
    event.preventDefault();

    this.setPlaybarPopupPosition($(event.currentTarget), iorad.player.router.advancedView);
    // iorad.player.router.togglePlayerPopup(true);
    iorad.player.router.advancedView.setPlaybarBtnEl($(event.currentTarget));
    iorad.player.router.advancedView.toggle();
  },
});

;
iorad.player.views.layout_language_popup = iorad.base.View.extend({
  template: iorad.player.templates.layout_language_popup,

  events: {
    'click .close-language-popup, .popup_overlay': 'hide',
    'click .language-item': 'handleClick',
    'focus #language-filter': 'handleSearchFocus',
    'blur #language-filter': 'handleSearchBlur',
    'change #language-filter': 'handleSearchChange',
    'paste #language-filter': 'handleSearchChange',
    'keyup #language-filter': 'handleSearchChange',
    'click .language-item.active': 'hide',
  },

  initialize: function () {
    this.tutorial = iorad.player.data.tutorial;
    this.stepsCollection = iorad.player.data.stepsCollection;

    const langArr = [].concat(iorad.player.controllers.language.list);

    const engItem = langArr.shift();

    const languageList = _.sortBy(langArr, 'name');

    languageList.unshift(engItem);

    this.languageList = languageList;

    this.model = new Backbone.Model({
      isFocus: false,
      languageList: this.languageList,
      searchList: []
    });

    this.listenTo(this.model, 'change', this.check);
    this.listenTo(this.tutorial, 'change', this.check);
    this.listenTo(iorad.player.events, 'selectedTranslation', this.check);
    this.listenTo(iorad.player.events, 'media:show', this.setMaxHeight);
    this.listenTo(iorad.player.events, 'media:hide', this.removeMaxHeight);
    this.listenTo(iorad.player.events, 'press:esc', this.hide);

    this.check();
  },

  check: function () {
    if (!iorad.player.router || !this.$el.hasClass('visible')) return;
    this.$el.removeClass('showing');
    this.render();
  },

  // NOTE: also called from the outside!
  getTemplateData: function () {
    return _.extend({}, {
      languageList: this.model.get('languageList'),
      searchList: this.model.get('searchList'),
      languageCode: iorad.player.selectedTranslation || iorad.player.getParameters.lang || (iorad.player.data.tutorial.get('language') || 'en'),
      isFocus: this.model.get('isFocus'),
    });
  },

  render: function () {
    const oldTemplateData = this.templateData || {};
    this.templateData = this.getTemplateData();

    window.litHTML.render(this.template(this.templateData), this.el);

    this.componentDidUpdate(oldTemplateData);

    return this;
  },

  componentDidUpdate: function (oldTemplateData) {
  },

  // NOTE: called from the outside
  isVisible: function () {
    return this.$el.hasClass('visible');
  },

  // NOTE: called from the outside
  show: function () {
    if (this.$el.hasClass('visible')) return;
    this.$el.addClass('visible');
    this.$el.addClass('showing');
    this.check();
    iorad.player.events.trigger('toggle:languageDropdown', true);
    this.$el.find('#language-filter').focus();
  },

  // NOTE: called from the outside
  hide: function () {
    if (!this.$el.hasClass('visible')) return;
    this.$el.removeClass('visible');
    this.$el.removeClass('showing');
    iorad.player.events.trigger('toggle:languageDropdown', false);
    iorad.base.Utils.accessibilityFocusBack(this.$el);
  },

  toggle: function (value) {
    if (typeof value === 'undefined') {
      value = !this.isVisible();
    }
    if (value) this.show();
    else this.hide();
  },


  handleSearchFocus: function(event) {
    this.model.set({
      isFocus: true,
    });
  },

  handleSearchBlur: function() {
    if ($(event.target).val() == '') {
      this.model.set({
        isFocus: false,
      });
    }
  },

  handleSearchChange: function(event) {
    const key = $(event.target).val().toLowerCase();


    if (event.which == 13) {
      if (!key) return false;

      const searchItem = this.languageList
        .find(function (item) {
          return item.name.toLowerCase().startsWith(key);
        });

      console.log('searchItem', key, searchItem);

      if (searchItem) {
        if (searchItem.code == this.model.get('languageCode')) {
          this.hide();

          return false;
        }

        this.changeLanguage(searchItem.code);
      }

      return false;
    }

    // if (event.key === 'Tab') {
    //   return;
    // }

    // if (event.key === 'Escape') {
    //   this.hide();
    //   return;
    // }

    if (key === '') {
      this.model.set({
        searchList: []
      });

      return;
    }

    const filteredList = this.languageList
      .filter(function(item) {
        return item.name.toLowerCase().startsWith(key);
      })
      .map(function(item) {
        return item.code;
      });

    this.model.set({
      searchList: filteredList
    });
  },

  changeLanguage: function(languageCode) {
    iorad.player.router.layoutPlayer.translatorView.changeLanguage(languageCode);
  },

  handleClick: function (event) {
    //iorad.player.router.togglePlayerPopup(false);
    this.changeLanguage($(event.currentTarget).data('value'));
  },

  setMaxHeight: function (height) {
    this.$el.css('max-height', height);
  },

  removeMaxHeight: function () {
    this.$el.css('max-height', '100%');
  },
});

;
iorad.player.views.layout_modes = iorad.base.View.extend({
  router: null,

  initialize: function(options) {
    this.listenTo(iorad.player.events, 'mode', this.onModeChange);
    this.listenTo(iorad.player.events, 'mode:print', this.showPrint);

    this.playerEl = $('#playing-player');
    this.quickEl = $('.quick-view');
    this.printEl = $('.print-view');

    this.listenTo(this.model, 'change', this.render);
    this.render();
  },

  onModeChange: function(mode) {
    if (mode === 'print') return; // not a real mode
    if (!iorad.player.device) return; // too early

    var args = Array.prototype.slice.call(arguments);
    var rest = args.slice(1);

    iorad.player.mode = mode;
    iorad.player.current = iorad.player.router.getCurrent();
    $('html').attr('data-mode', iorad.player.mode);
    if (!iorad.player.ready) $('html').addClass('init');
    iorad.player.events.trigger('change:mode');

    var handler = this['show' + iorad.base.Utils.capitalize(mode)];
    handler.apply(this, rest).then(_.bind(function() {
      iorad.player.events.trigger('ready:' + mode);
      iorad.player.events.trigger('ready', mode);
      if (siteWindow.parent !== siteWindow && iorad.player.ready) {
        // report mode ready
        siteWindow.parent.postMessage({
          from: 'iorad-web-app',
          topic: 'player:ready',
          data: {},
        }, '*');
      }
      $('html').removeClass('init');
      iorad.player.router.hideDeviceChangeOverlay();
    }, this));
  },

  showInteractive: function(finished) {
    var onReady;
    var promise = new Promise(function(resolve) { onReady = resolve; });

    var self = this;

    if (!this.metaInteractiveView) {
      this.metaInteractiveView = new iorad.player.views.meta_interactive({
        model: this.model,
        collection: this.collection,
        el: '#playing-player'
      });
      // this.metaInteractiveView.$('.scrollbar-inner').scrollbar({
      //   ignoreOverlay: false,
      // });
      this.metaInteractiveView.$('.scrollbar-inner').on('mousewheel', function(event) {
        if (!event.originalEvent.isTrusted) return; // only handle manual events
        if ($(this).is(':animated')) return; // DO NOT block running animations (e.g. step "make into view" animation)

        // the scrollHeight doesn't change in case of scale, since the CSS transform is just a style change,
        // => calculate the scale-adjusted max scrollTop to avoid scrolling past the scaled image
        const slideContainmentEl = $(this).find('.containment');
        const containmentBounds = slideContainmentEl[0].getBoundingClientRect();
        const scale = containmentBounds.height / slideContainmentEl.height();
        const scaledScrollHeight = Math.max(this.clientHeight, this.scrollHeight * scale);
        const maxScaledScrollTop = scaledScrollHeight - this.clientHeight;

        var newScrollTop = Math.min(
          maxScaledScrollTop,
          this.scrollTop + ((event.deltaY * event.deltaFactor) * -1)
        );

        // detect if we reached min/max scroll and prevent scroll in that case
        var oldScrollTop = this.scrollTop;
        this.scrollTop = newScrollTop;
        if (this.scrollTop === oldScrollTop) return;
        this.scrollTop = oldScrollTop;

        event.preventDefault();
        $(this).stop().animate({ scrollTop: newScrollTop }, 50);
        //console.log(event.deltaY, event.deltaFactor, event.originalEvent.deltaMode, event.originalEvent.wheelDelta);
      });
    }

    function run() {
      self.quickEl.hide();
      $('#main').scrollTop(0); // fix #1816
      self.playerEl.show();
      self.playerEl.find('#interactive-nav').fadeIn(200);
      if (finished) iorad.player.events.trigger('interactive:finished');
      onReady();
    }

    if (!iorad.player.router.isCoverDisabled()) {
      run();
    } else {
      setTimeout(run, 300);
    }

    return promise;
  },

  showMobilequick: function(slideNumber) {
    if (!isNaN(slideNumber)) slideNumber = parseInt(slideNumber, 10);

    var onReady;
    var promise = new Promise(function(resolve) { onReady = resolve; });

    this.mobileSlideList = this.mobileSlideList || new iorad.player.views.steps_mobile_slide_list({
      model: this.model,
      collection: this.collection,
      el: '#mobile-steps'
    });

    if (slideNumber !== undefined && !(slideNumber === 1 && !iorad.player.ready) && !iorad.player.router.gotoHashListener) {
      var slideIndex = slideNumber - 1;

      var slideInitListener;
      var slideChangeListener;
      var handleReady = _.bind(function() {
        this.stopListening.apply(this, slideChangeListener);
        this.stopListening.apply(this, slideInitListener);
        onReady();
      }, this);
      slideInitListener = [iorad.player.events, 'slide_fully_initialized', handleReady];
      slideChangeListener = [this.mobileSlideList, 'slideChange', function(newIndex) {
        if (newIndex === slideIndex) handleReady();
      }];
      this.listenTo.apply(this, slideInitListener);
      this.listenTo.apply(this, slideChangeListener);

      if (this.mobileSlideList.fullyInitialized && this.mobileSlideList.$el.getCurrentSlide() === slideIndex) {
        this.mobileSlideList.$el.redrawSlider();
        handleReady();
      } else {
        setTimeout(_.bind(function() { // wait for bxSlider to be ready or slides change will fail and slider will break
          this.mobileSlideList.goToSlide(slideIndex);
        }, this), 1000);
      }
    } else {
      iorad.player.events.trigger('slide_start_with_no_index');
      onReady();
    }

    return promise;
  },

  // Note: this preparations can be skipped by the user by directly pressing "Print" via the browser menu,
  // thus we don't support direct browser printing.
  showPrint: function(layoutType) {
    var self = this;

    var metaPrintView = this.createMetaPrintView(layoutType);

    setTimeout(function() { // avoid grayish overlay in printed content (view still not fully loaded)
      metaPrintView.print().then(function() { // wait images preloading, etc.
        iorad.player.events.trigger('pdfDownload:done', layoutType);
      });
    }, 500);
  },

  createMetaPrintView: function(layoutType) {
    this.metaPrintViewMap = this.metaPrintViewMap || {};
    this.MetaPrintViewTypeMap = this.metaPrintViewTypeMap || {
      'long': iorad.player.views.meta_print_long,
      'short': iorad.player.views.meta_print_short
    };

    var metaPrintView = this.metaPrintViewMap[layoutType];
    if (!metaPrintView) {
      // create
      var MetaPrintViewType = this.MetaPrintViewTypeMap[layoutType];
      metaPrintView = this.metaPrintViewMap[layoutType] = new MetaPrintViewType({
        model: this.model,
        collection: this.collection,
        el: '#main .print-view'
      });
    } else {
      // force new render to re-generate the pdf, otherwise looks messed up
      metaPrintView.render();
    }

    return metaPrintView;
  },

  showQuick: function() {
    var onReady;
    var promise = new Promise(function(resolve) { onReady = resolve; });

    var self = this;

    this.metaQuickView = this.metaQuickView || new iorad.player.views.meta_quick({
      model: this.model,
      collection: this.collection,
      el: '#main .quick-view'
    });

    function run() {
      self.quickEl.fadeIn(200, function() { // on shown
        onReady();
      });
      self.playerEl.hide();
    }

    if (!iorad.player.router.isCoverDisabled()) {
      run();
    } else {
      setTimeout(run, 300);
    }

    return promise;
  },
});

;
(() => {
  const GOOGLE_TRANSLATE_ELEMENT_SELECTOR = '#google_translate_element';

  iorad.player.views.layout_translator = iorad.base.View.extend({
    start: function () {
      _.defer(_.bind(function () {
        // true if the popup with the language selection is currently being displayed
        this.isPopupDisplayed = false;

        // translation is disabled on ios due to https://github.com/iorad/iorad/issues/1311
        // (the widget falls back to flash which isn't available)
        var isSupported = true; //iorad.player.controllers.clientDetect.os.isIOS == false;
        if (!isSupported) return;

        if (iorad.base.Export.getCookie('googtrans')) {
          // load google translate immediately since it must translate the page
          this.loadGoogleTranslate();
        } else {
          // lazy load google translate after any click
          var handleClick = _.bind(function (event) {
            window.removeEventListener('click', handleClick);
            this.loadGoogleTranslate();
          }, this);

          window.addEventListener('click', handleClick);
        }
      }, this));
    },

    loadGoogleTranslate: function () {
      // handle callback fired by google translate script when loaded
      window.googleTranslateElementInit = _.bind(this.googleTranslateElementInit, this);

      var translateScheme = iorad.base.Settings.get('translate.scheme');
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.defer = true;
      script.id = '';
      script.src = translateScheme + 'translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
      this.$el.append(script);
    },

    googleTranslateElementInit: function () {
      var translateElement = new window.google.translate.TranslateElement({
        layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE
      }, GOOGLE_TRANSLATE_ELEMENT_SELECTOR.slice(1));

      // for firefox, to prevent google translate from breaking stylesheet
      $('head').addClass('skiptranslate');

      // iorad.player.events.trigger('translator:loaded');
    },

    changeLanguage: function (languageCode) {
      // reload the page by using new language
      // (so to also translate UI, language sync will also trigger google translate)

      if (iorad.player.router.isPreviewMode()) {
        // editor will make sure to reload the preview player accordingly
        siteWindow.parent.postMessage({
          topic: 'preview:language',
          data: { language: languageCode },
        }, Backbone.history.location.origin);
        return;
      }

      var newUrl;

      if (!window.downloadPlayerType && languageCode !== (iorad.player.data.tutorial.get('language') || 'en')) {
        var toCustomTranslation = _.find(
          (iorad.player.data.tutorial.get('translations') || []),
          function (t) {
            return t.language_code === languageCode;
          });

        var fromCustomTranslation = _.find(
          (iorad.player.data.tutorial.get('translations') || []),
          function (t) {
            return t.language_code === (iorad.player.data.tutorial.get('language') || 'en');
          });

        // NOTE: originalCustomTranslation is always set
        // when "coming from / going to" a custom translation
        var originalCustomTranslation = _.find(
          (iorad.player.data.tutorial.get('translations') || []),
          function (t) {
            if (iorad.player.getParameters.originalLang) {
              return t.language_code === iorad.player.getParameters.originalLang;
            }
            if (iorad.player.data.tutorial.get('translationOf')) {
              return t.tutorial_id === iorad.player.data.tutorial.get('translationOf');
            }
            return null;
          }) || fromCustomTranslation;

        if (toCustomTranslation) {
          newUrl = toCustomTranslation.playerURL;
          if (toCustomTranslation !== originalCustomTranslation) {
            newUrl += (newUrl.indexOf('?') >= 0 ? '&' : '?') +
              'originalLang=' + originalCustomTranslation.language_code;
          }
        } else if (
          fromCustomTranslation &&
          fromCustomTranslation !== originalCustomTranslation
        ) {
          // switch from custom to non-custom
          // => apply google translate to original tutorial
          // (so to use original audio/video)
          newUrl = originalCustomTranslation.playerURL;
          newUrl += (newUrl.indexOf('?') >= 0 ? '&' : '?') +
            'lang=' + languageCode;
        }

        if (newUrl) {
          if (iorad.player.router.isHelpcenterMode()) {
            newUrl += (newUrl.indexOf('?') >= 0 ? '&' : '?') +
              'helpcenter=' + iorad.player.getParameters.helpcenter +
              (iorad.player.getParameters.roleId ? ('&roleId=' + encodeURIComponent(iorad.player.getParameters.roleId)) : '') +
              (iorad.player.getParameters.embedUrl ? ('&embedUrl=' + encodeURIComponent(iorad.player.getParameters.embedUrl)) : '') +
              window.location.hash;
          } else if (iorad.player.router.isExtensionMode()) {
            newUrl += (newUrl.indexOf('?') >= 0 ? '&' : '?') +
              'extensionEmbed=' + iorad.player.getParameters.extensionEmbed +
              (iorad.player.getParameters.playerExtensionWidth ? ('&playerExtensionWidth=' + iorad.player.getParameters.playerExtensionWidth) : '') +
              (iorad.player.getParameters.widgetEmbed ? ('&widgetEmbed=' + iorad.player.getParameters.widgetEmbed) : '') +
              (iorad.player.getParameters.embedUrl ? ('&embedUrl=' + encodeURIComponent(iorad.player.getParameters.embedUrl)) : '') +
              '&coverDisabled=' + (iorad.player.getParameters.coverDisabled || '') +
              '&device=' + (iorad.player.data.tutorial.get('extensionDevice') || '') +
              window.location.hash;
          }
          siteWindow.ioradNodeApp.setLocation(newUrl);
          return;
        }
      }

      var newGetParameters = iorad.base.Utils.deepClone(iorad.player.getParameters);
      newGetParameters.lang = languageCode;
      if (iorad.player.router.isExtensionMode()) {
        newGetParameters.device = (iorad.player.data.tutorial.get('extensionDevice') || '');
      }

      newUrl = iorad.base.Utils.createUrl({
        urlParameters: newGetParameters,
      });

      if (iorad.player.controllers.clientDetect.browser.isFirefox) {
        // googtrans cookie is not set when trying to use historyReplaceState
        // See #11470
        // => use regular page reload
        siteWindow.ioradNodeApp.setLocation(newUrl);
      } else {
        // change url without reloading the page
        siteWindow.ioradNodeApp.setLocation(newUrl, { historyReplaceState: true });
        siteWindow.ioradNodeApp.reloadIframe();
      }
    },
  });
})();

;
iorad.player.routers.main = iorad.base.Router.extend({
  routes: {
    '': 'gotoDefault',
    'step-:index': 'gotoDefaultNoReset',
    'trysteps-:index(/:speed)': 'goToInteractive',
    'finished': 'gotoFinished',
    'watchsteps-:index(/:speed)': 'gotoWatch',
    'quizsteps-:index': 'gotoQuiz',
    'viewsteps': 'gotoQuickView',
    'mobilequick-:index': 'gotoMobileQuick',
    'practice': 'gotoPractice',
    'viewpractice': 'gotoViewPractice',
    'live': 'gotoLive',
    'print(/:autoType)': 'gotoPrint',
  },

  previewMode: undefined,

  initialize: function(options) {
    iorad.base.Router.prototype.initialize.apply(this, arguments);

    if (!screenfull) {
      screenfull = {
        enabled: false
      }
    } else {
      document.addEventListener(screenfull.raw.fullscreenchange, _.bind(this.onFullscreenStatusChange, this));
    }
    $(window).on('beforeunload', _.bind(function() {
      // close fullscreen first
      iorad.player.controllers.views.exitFullscreen();
    }, this));

    _.bindAll(this, 'back', 'dataReady');

    var tutorialModel = this.tutorial = iorad.player.data.tutorial;
    var stepsCollection = this.stepsCollection = iorad.player.data.stepsCollection;
    this.previewModel = iorad.player.data.previewModel;

    this.playerPopupOpen = false;
    const onWindowClick = () => {
      siteWindow.parent.postMessage({
        from: 'iorad-web-app',
        topic: 'player:click',
        data: {
          popupOpen: this.playerPopupOpen,
        },
      }, '*');
    };
    $(siteWindow).on('click', onWindowClick);
    $(window).on('click', onWindowClick);

    // store last hash fragment, useful for implementing a Backbone-app 'history back'
    $(window).on('hashchange', _.bind(function() { // just before hash change
      this.previousFragment = Backbone.history.fragment;
    }, this));

    var initialHashIsModal;
    var initialHash = iorad.player.getParameters.iframeHash ?
      ('#' + iorad.player.getParameters.iframeHash)
      :
      window.location.hash;
    if (
      ['#practice', '#viewpractice', '#live', '#print'].indexOf(initialHash) >= 0 ||
      iorad.base.Utils.startsWith(initialHash, '#print/')
    ) {
      initialHashIsModal = true;
      window.setLocationHash('#');
    } else if (iorad.player.getParameters.isViewLive === 'true') {
      // auto open live tab
      initialHash = '#live';
      initialHashIsModal = true;
      window.setLocationHash('#');
    }

    this.bindStepNavigationShortcuts();
    this.setHelpCenterConfigs();

    // When data is ready and theme applied, show the app
    this.dataReady(function() {
      // reset to the new initial view
      // when there are layout and other changes (mainly editor preview)
      this.listenTo(
        this.tutorial,
        _.flatten(window.iorad.defaultViewOptions.concat(window.iorad.visibilityOptions).map(function(option) {
          return ['direct', 'embed', 'widget'].map(function(shareMode) {
            return 'change:' + shareMode + '_' + option;
          });
        })).concat([
          'change:previewFrameMode',

          'change:quizEnabled',
          'change:doitEnabled',
          'change:commentingEnabled',
          'change:recommendedEnabled',

          // for "go live" visibility change
          'change:isLiveTutorial', 'change:liveDisabled', 'change:guideMeMode',
        ]).join(' '),
        function () { this.gotoDefault(true); }
      );

      this.listenTo(this.previewModel, 'change', () => {
        const changedAttributes = this.previewModel.changedAttributes();
        if ('previewDevice' in changedAttributes) {
          if ('previewType' in changedAttributes) {
            // player preview will reload, prevent handlers from being called
            // or the whole reload will break, e.g. if siteWindow.parent.postMessage is called
            // since during reload siteWindow.parent is undefined
            // See https://github.com/iorad/iorad/issues/13641#issuecomment-1665848865
            return;
          }
          this.checkDeviceChange();
        }
      });

      this.listenTo(this.tutorial, 'change:extensionDevice', this.checkDeviceChange);
      this.listenTo(this.tutorial, [
        'change:direct_is_adaptive_device',
        'change:embed_is_adaptive_device',
        'change:widget_is_adaptive_device',
        'change:direct_is_mobile_device',
        'change:embed_is_mobile_device',
        'change:widget_is_mobile_device',
        'change:direct_is_desktop_device',
        'change:embed_is_desktop_device',
        'change:widget_is_desktop_device',
      ].join(' '), this.checkDeviceChange);

      this.listenTo(this.tutorial, [
        'change:direct_is_adaptive_screenshot_zoom',
        'change:embed_is_adaptive_screenshot_zoom',
        'change:widget_is_adaptive_screenshot_zoom',

        'change:direct_is_75_screenshot_zoom',
        'change:embed_is_75_screenshot_zoom',
        'change:widget_is_75_screenshot_zoom',

        'change:direct_is_half_screenshot_zoom',
        'change:embed_is_half_screenshot_zoom',
        'change:widget_is_half_screenshot_zoom',

        'change:direct_is_full_screenshot_zoom',
        'change:embed_is_full_screenshot_zoom',
        'change:widget_is_full_screenshot_zoom',
      ].join(' '), function() {
        iorad.player.controllers.screenshots.resetZoom();
      });
      iorad.player.controllers.screenshots.resetZoom();

      var isAccountNonFree = this.tutorial.get('account_type') !== 'free'; // this means a non-free user (private, premium or live plan). Yes it's misleading.
      var isOrWasPremium = this.tutorial.get('isPremiumTutorial') || isAccountNonFree;
      var referralsEnabled = Boolean(this.tutorial.get('referrals_enabled'));
      var templateData = {
        isFullscreenSupported: screenfull.enabled,
        isFullscreenDisabled: this.tutorial.getLayoutOption('is_fullscreen_disabled'),
        isMobileDevice: iorad.player.device !== 'desktop',
        isStepsNumberDisabled: this.tutorial.getLayoutOption('is_stepsnumber_disabled'),
      };
      this.templateData = templateData;
      $('#app-container').html(Mustache.render(iorad.player.templates.container, templateData));

      var isMobile = iorad.app.controllers.clientDetect.device.isMobile;
      $('#app-container').toggleClass('is_mobile', isMobile);

      var isEmbedded = this.isEmbedded();
      $('.player-popup').toggleClass('is_embedded', isEmbedded);

      var isExtensionMode = this.isExtensionMode();
      $('.player-popup').toggleClass('is_extension_mode', isExtensionMode);

      var layoutShareView = new iorad.player.views.layout_share({
        el: '#share'
      });
      this.shareView = layoutShareView;
      if (iorad.player.getParameters.shareOpen === 'true') {
        this.listenToOnce(iorad.player.events, 'player:ready', () => {
          this.shareView.show();
        });
      }

      var layoutCommentsView = new iorad.player.views.layout_comments({
        el: '#comments'
      });
      this.commentsView = layoutCommentsView;
      if (iorad.player.getParameters.commentsOpen === 'true') {
        this.listenToOnce(iorad.player.events, 'player:ready', () => {
          this.commentsView.show();
        });
      }

      var layoutMediaView = new iorad.player.views.layout_media({
        el: '#media'
      });
      this.mediaView = layoutMediaView;

      var layoutStepsView = new iorad.player.views.layout_steps({
        el: '#steps'
      });
      this.stepsView = layoutStepsView;

      var layoutSelectorView = new iorad.player.views.layout_selector({
        el: '#selector'
      });
      this.selectorView = layoutSelectorView;

      var layoutExportView = new iorad.player.views.layout_export({
        el: '#export'
      });
      this.exportView = layoutExportView;

      var layoutAdvancedView = new iorad.player.views.layout_advanced({
        el: '#advanced'
      });
      this.advancedView = layoutAdvancedView;

      var layoutHeaderView = new iorad.player.views.layout_header({
        model: tutorialModel,
        el: '#header'
      });
      this.header = layoutHeaderView;

      var layoutPlaybarView = new iorad.player.views.layout_playbar({
        el: '#playbar'
      });
      this.playbarView = layoutPlaybarView;

      var layoutLanguageView = new iorad.player.views.layout_language_popup({
        el: '#language'
      });
      this.languageView = layoutLanguageView;

      // cover views
      var metaMobileFinishedView = this.metaMobileFinishedView = new iorad.player.views.meta_mobile_finished({
        model: tutorialModel,
        collection: stepsCollection,
        el: '#mobile-steps .step.finished'
      });

      this.layoutPlayer = new iorad.player.views.layout_player({
        model: tutorialModel
      });

      var layoutModes = new iorad.player.views.layout_modes({
        model: tutorialModel,
        collection: stepsCollection
      });
      this.layoutModes = layoutModes;

      $('#app-container').show();

      if (iorad.player.getParameters.draftPublished === 'true') {
        noty({
          text: iorad.player.successNotificationList.draftPublished(),
          type: 'success',
        });
      }
    });

    $(window).on('resize', _.bind(function() {
      this.checkDeviceChange();
    }, this));
    $(window).on('resize', _.debounce(_.bind(function() {
      if (iorad.player.mode) iorad.player.events.trigger('resize:' + iorad.player.mode);
    }, this), 300));

    // when data is ready and first route has been established, start the magic!
    this.listenTo(this, 'started', _.bind(function() {
      this.checkDeviceChange();
    }, this));

    this.listenToOnce(iorad.player.events, 'ready', function() {
      iorad.player.controllers.views.waitForRenderOperations({
        timeoutMS: iorad.player.getParameters.videoExport === 'true' ? 600000 // 10 mins
                                                                     : 3000 // 3 secs
      }).then(function() {
        this.notifyPlayerReady();

        var initialHashAllowed = (
          (initialHash !== '#live' || this.tutorial.isDoItAvailable()) &&
          (!iorad.base.Utils.startsWith(initialHash, '#viewsteps') || this.isViewTabAvailable()) &&
          (!iorad.base.Utils.startsWith(initialHash, '#mobilequick-') || this.isSlideTabAvailable()) &&
          (!iorad.base.Utils.startsWith(initialHash, '#trysteps-') || this.isTryTabAvailable()) &&
          (!iorad.base.Utils.startsWith(initialHash, '#watchsteps-') || this.isWatchTabAvailable()) &&
          (!iorad.base.Utils.startsWith(initialHash, '#quizsteps-') || this.isQuizTabAvailable())
        ) || iorad.base.Utils.startsWith(initialHash, '#step-');
        if (
          initialHashIsModal ||
          iorad.player.device !== 'desktop'
        ) {
          // HERE the current hash is the default
          // => got to the custom hash if allowed
          if (initialHashAllowed) {
            window.setLocationHash(initialHash);
          }
        } else if (iorad.player.device === 'desktop') {
          // HERE the current hash is already initialHash
          // => go back to the default if not allowed
          if (!initialHashAllowed) {
            window.setLocationHash('#');
          }
        }
      }.bind(this));
    });
  },

  start: function() {
    // call original (Backbone.Router) start method
    iorad.base.Router.prototype.start.apply(this, arguments);

    if (this.isPreviewMode()) this.startPreviewMode();
    else if (this.isHelpcenterMode()) this.startHelpcenterMode();
    else if (this.isExtensionMode()) this.startExtensionMode();
    else if (this.isThemeSettingsMode()) this.startThemeSettingsMode();
    else this.startRegularMode();
  },

  isEmbedded: function() {
    if (this.isPreviewMode()) {
      // preview override
      return ['embed', 'widget'].indexOf(this.tutorial.get('previewFrameMode')) !== -1;
    }

    return iorad.base.Utils.isEmbedded();
  },

  getFrameMode: function() {
    if (this.isPreviewMode()) {
      // preview override
      return this.tutorial.get('previewFrameMode');
    }

    return this.isExtensionMode() ? 'widget'
      : this.isEmbedded()
        ? 'embed'
        : 'direct';
  },

  isPreviewMode: function() {
    // Can raise a cross origin error if the player is embedded
    var previewMode;
    try {
      previewMode = siteWindow.parent != siteWindow && siteWindow.parent.iorad.editor !== undefined;
    } catch (e) {
      previewMode = false;
    }
    return previewMode;
  },

  isThemeSettingsMode: function() {
    return !!iorad.player.getParameters.themeSettings;
  },

  isHelpcenterMode: function() {
    return !!iorad.player.getParameters.helpcenter;
  },

  isExtensionMode: function() {
    return iorad.player.getParameters.extensionEmbed === 'true';
  },

  startPreviewMode: function() {
    // on preview we can take missing images (i.e. those still not preloaded in editor)
    // directly from the editor capture service
    var captureController = siteWindow.parent.iorad.editor.controllers.capture;
    iorad.player.controllers.screenshots.setCaptureController(captureController);

    // populate slides collection with the slides in the editor
    var editorTutorial = siteWindow.parent.iorad.editor.data.tutorial;
    var editorPreviewModel = siteWindow.parent.iorad.editor.data.previewModel;
    var editorThemesCollection = siteWindow.parent.iorad.editor.data.themesCollection;
    var editorStepsCollection = editorTutorial.steps;
    var editorMarkerColors = siteWindow.parent.iorad.editor.data.markerColors;
    var editorLiveUrlConfig = siteWindow.parent.iorad.editor.data.liveUrlConfig;
    var editorFramesUrlCache = siteWindow.parent.iorad.editor.data.framesUrlCache;

    var me = this;
    this.listenTo(editorTutorial, "change", function() {
      me.tutorial.set(editorTutorial.changed);
    });

    this.listenTo(editorPreviewModel, "change", function() {
      me.previewModel.set(editorPreviewModel.changed);
    });

    this.listenTo(editorThemesCollection, "add remove sort reset change", function() {
      iorad.player.data.themesCollection.reset(editorThemesCollection.toJSON());
    });

    this.listenTo(editorMarkerColors, "change", function() {
      iorad.player.data.markerColors.set(editorMarkerColors.changed);
    });

    this.listenTo(editorLiveUrlConfig, "change", function () {
      iorad.player.data.liveUrlConfig.set(editorLiveUrlConfig.changed);
    });

    this.listenTo(editorFramesUrlCache, "change", function () {
      iorad.player.data.framesUrlCache.set(editorFramesUrlCache.changed);
    });

    iorad.player.data.themesCollection.reset(editorThemesCollection.toJSON());
    this.stepsCollection.reset(editorStepsCollection.map(function(step) {
      return step.toJSON();
    }));
    this.tutorial.set(editorTutorial.toJSON());
    this.previewModel.set(editorPreviewModel.toJSON());
    iorad.player.data.markerColors.set(editorMarkerColors.toJSON());
    iorad.player.data.liveUrlConfig.set(editorLiveUrlConfig.toJSON());
    iorad.player.data.framesUrlCache.set(editorFramesUrlCache.toJSON());

    this.setupPreviewEyeDropper();

    var onCurrentThemeChange = function() {
      if (this.tutorial.get('theme') > 0) { // custom theme is being used
        // force premium preview (#2620)
        this.tutorial.set('editor_account_type', editorTutorial.get('account_type'));
        this.tutorial.set('account_type', 'premium');
      } else {
        // restore default
        this.tutorial.unset('editor_account_type');
        this.tutorial.set('account_type', editorTutorial.get('account_type'));
      }
    };
    this.listenTo(this.tutorial, 'change:theme', onCurrentThemeChange);
    onCurrentThemeChange.call(this);

    this.setupPublicTutorialNoty();

    this.tutorialFetched();

    // notify parent editor
    siteWindow.parent.postMessage({ topic: 'preview:ready' }, Backbone.history.location.origin);
  },

  setupOfflineCacheOverlay: function () {
    if (iorad.base.Settings.env === 'live') {
      return; // DISABLED FOR NOW (#11347)
    }
    if (window.downloadPlayerType) return;

    iorad.player.controllers.sync.hasEditAccess()
      .then(_.bind(function (editAccess) {
        if (!editAccess) {
          return;
        }

        return iorad.player.controllers.sync.getCacheStore()
          .then(_.bind(_.bind(function (cacheStore) {
            return cacheStore.keys();
          }, this)))
          .then(_.bind(function (keys) {
            var cacheKeyPrefix = iorad.player.controllers.sync.getCacheTutorialKeyPrefix();
            var offlineCacheExists = keys.some(_.bind(function (key) {
              return key.startsWith(cacheKeyPrefix);
            }, this));
            console.log('OFFLINE CACHE?', offlineCacheExists);
            if (offlineCacheExists) {
              var layoutOfflineCacheOverlay = new iorad.player.views.layout_offline_cache_overlay({
                el: '.offline-cache-overlay',
              });
              layoutOfflineCacheOverlay.$el.show();
            }
          }, this));
      }, this))
  },

  setupPublicTutorialNoty: function () {
    if (window.downloadPlayerType) return;

    var handle = _.bind(function () {
      var isPreview = this.isPreviewMode();
      if (!isPreview) {
        // #15303
        return;
      }
      iorad.player.controllers.sync.hasEditAccess()
        .then(_.bind(function (editAccess) {
          if (!editAccess) {
            return;
          }

          var tutorialIsPublic;
          var publicNoty;
          var publicNotyDismissed = false;
          var isPremium = this.tutorial.get('account_type') !== 'free';

          try {
            publicNotyDismissed = localStorage.getItem('iorad.player.publicNotyDismissed.' + iorad.player.tutorialId) === 'true';
          } catch (err) {
            // 3rd party cookies/data are disabled
            console.error(err);
          }
          var dismissPublicNoty = _.bind(function () {
            publicNotyDismissed = true;
            try {
              localStorage.setItem('iorad.player.publicNotyDismissed.' + iorad.player.tutorialId, 'true');
            } catch (err) {
              // 3rd party cookies/data are disabled
              console.error(err);
            }
          }, this);

          var checkForPublicNoty = _.bind(function () {
            var newTutorialIsPublic = this.tutorial.isPublic();
            if (newTutorialIsPublic !== tutorialIsPublic) {
              tutorialIsPublic = newTutorialIsPublic;

              if (tutorialIsPublic && !publicNotyDismissed) {
                if (!publicNoty) {
                  publicNoty = noty({
                    featureName: !isPremium ? 'TUTORIAL_PRIVACY' : undefined,
                    type: 'information',
                    customType: !isPremium ? 'featureAccessError' : undefined,
                    text: iorad.player.successNotificationList.tutorialPublicCheck(),
                    // buttons: [{
                    //   addClass: 'btn btn-primary btn-green btn-small',
                    //   text: !isPremium ? 'Upgrade' : 'Change',
                    //   onClick: _.bind(function ($noty) {
                    //     $noty.close();
                    //     dismissPublicNoty();

                    //     if (!isPremium) {
                    //       // upgrade
                    //       window.open(iorad.base.Settings.get('updateSubscription.url'), '_blank').focus();
                    //     } else {
                    //       // change
                    //       if (isPreview) {
                    //         siteWindow.parent.postMessage({
                    //           topic: 'preview:openPrivacyDropdown',
                    //           data: {
                    //           },
                    //         }, '*');
                    //       } else {
                    //         var editUrl = iorad.base.Settings.get('editTutorial.url', {
                    //           tutorialID: iorad.player.tutorialId,
                    //           userID: iorad.player.userId,
                    //           returnTo: '',
                    //           hash: '#finish/privacy',
                    //         });
                    //         window.open(editUrl, '_blank').focus();
                    //       }
                    //     }
                    //   }, this)
                    // }],
                    closeButton: {
                      onClick: function ($noty) {
                        $noty.close();
                        dismissPublicNoty();
                      }
                    },
                  });
                }
              } else {
                if (publicNoty) {
                  // NOTE: this won't dismiss the noty
                  publicNoty.close();
                  publicNoty = undefined;
                }
              }
            }
          }, this);
          this.listenTo(this.tutorial, 'change', checkForPublicNoty);
          checkForPublicNoty();
        }, this));
    }, this);
    if (iorad.player.ready) handle();
    else this.listenTo(iorad.player.events, 'player:ready', handle);
  },

  setupRevisionNoty: function() {
    if (!iorad.player.getParameters.revision) return;

    var handle = _.bind(function() {
      noty({
        type: 'information',
        text: iorad.player.successNotificationList.revisionPreview(),
      });
    }, this);
    if (iorad.player.ready) handle();
    else this.listenTo(iorad.player.events, 'player:ready', handle);
  },

  // https://github.com/iorad/iorad/issues/10642
  // Rationale is probably to let the creator know that
  // regular users won't be able to see the embedded tutorial
  // (login page will show)
  setupEmbeddedSettingsNoty: function () {
    if (iorad.player.getParameters.social) return;

    var handle = _.bind(function () {
      if (
        !this.isEmbedded() ||
        this.isPreviewMode() ||
        window.downloadPlayerType ||
        this.isExtensionMode() ||
        this.isHelpcenterMode()
      ) return;

      var allowedDomains = window.allowedDomains || [];
      var tutorialIsInviteOnly = !this.tutorial.get('public') && allowedDomains.length === 0;

      var isEmbedOnlyNotWhitelisted = _.bind(function () {
        if (!allowedDomains.length) return false; // not Embed Only

        var referer = siteWindow.document.referrer || '';

        // copied from api/utils/tutorial::isRefererAllowed
        var regExp = _.bind(function (dn) {
          return new RegExp(`^https?://(.+\.)?${dn.replace(/\\^-/g, '').replace(/\./g, '\\.').replace(/\*/g, '.*')}/.*$`);
        }, this);
        var whitelisted = allowedDomains.some(_.bind(function (dn) {
          return referer.match(regExp(dn));
        }, this));
        return !whitelisted;
      }, this);

      if (tutorialIsInviteOnly || isEmbedOnlyNotWhitelisted()) {
        iorad.player.controllers.sync.hasEditAccess()
          .then(_.bind(function (editAccess) {
            if (editAccess) {
              noty({
                type: 'information',
                text: tutorialIsInviteOnly ?
                  'Change privacy to Embed Only to bypass login'
                  :
                  'Add domain to whitelist',
                buttons: [
                  {
                    addClass: 'btn btn-primary btn-green btn-small',
                    text: 'Settings',
                    onClick: _.bind(function ($noty) {
                      $noty.close();
                      this.editMode({
                        hash: '#finish'
                      });
                    }, this)
                  }
                ],
              });
            }
          }, this));
      }
    }, this);
    if (iorad.player.ready) handle();
    else this.listenTo(iorad.player.events, 'player:ready', handle);
  },

  // listen for eyedropper:enable, eyedropper:disable command messages
  setupPreviewEyeDropper: function() {
    function enable() {
      iorad.player.isEyeDropperEnabled = true;
      iorad.player.events.trigger('eyedropper:enable');
    }

    function disable() {
      iorad.player.isEyeDropperEnabled = false;
      iorad.player.events.trigger('eyedropper:disable');
    }

    var self = this;
    var onMessage = function(e) {
      if (e.origin !== Backbone.history.location.origin) return;

      //console.log(e.data);
      if (e.data === 'eyedropper:enable') enable();
      else if (e.data === 'eyedropper:disable') disable();
    };
    siteWindow.removeEventListener('message', onMessage, false);
    siteWindow.addEventListener('message', onMessage, false);

    if (siteWindow.parent.iorad.editor.isPreviewEyeDropperEnabled) enable()
    else disable();
  },

  // Note: this is called directly from editor
  stopPreview: function() {
    // prevent editor listeners from being called after the preview ended!
    this.stopListening(siteWindow.parent.iorad.editor.data.tutorial);
    this.stopListening(siteWindow.parent.iorad.editor.data.themesCollection);
  },

  startRegularMode: function() {
    var onClick = _.bind(function (e) {
      var coverOpen = iorad.player.controllers.views.isCoverOpen();
      siteWindow.parent.postMessage({
        from: 'iorad-web-app',
        topic: 'player:click',
        data: {
          coverOpen: coverOpen,
        },
      }, '*');
    }, this);
    $(siteWindow).on('click', onClick);
    $(window).on('click', onClick);

    // fetch tutorial
    this.syncController = iorad.player.controllers.sync;
    this.syncController.userId = iorad.player.userId;
    this.syncController.tutorialId = iorad.player.tutorialId;
    this.syncController.fetch(_.bind(function() { // success
      this.tutorialFetched();
      this.setupRevisionNoty();
      this.setupEmbeddedSettingsNoty();
      this.setupOfflineCacheOverlay();
      this.setupPublicTutorialNoty();
    }, this), _.bind(function(errorMsg) { // failure
      // redirect to error page
      siteWindow.ioradNodeApp.setLocation(iorad.base.Settings.get('siteError.url', {
        error_message: errorMsg
      }));
    }, this));
  },

  startHelpcenterMode: function() {
    this.startRegularMode();
    var onMessage = _.bind(function(e) {
      var message = e.data;
      if (typeof message !== 'object' || message === null) return;
      if (message.to !== 'iorad-player' && message.from !== 'iorad-help-center') return;
      if (message.data && message.topic === 'setOverridedThemeData') {
        iorad.player.data.overridedThemeData.set(message.data);
      }
    }, this);
    siteWindow.removeEventListener('message', onMessage, false);
    siteWindow.addEventListener('message', onMessage, false);
  },

  startThemeSettingsMode: function() {
    this.startRegularMode();

    var onMessage = _.bind(function(e) {
      var message = e.data;
      if (typeof message !== 'object' || message === null) return;
      if (message.to !== 'iorad-player' && message.from !== 'iorad-theme-settings') return;
      console.log('received theme message', message);
      if (message.topic === 'themeSettings:replaceThemeData') {
        const themeData = message.data;

        if (this.tutorial.get('theme') !== themeData.id) {
          this.tutorial.set({
            theme: themeData.id,
          });
        }

        const replacingTheme = iorad.player.data.themesCollection.get(themeData.id);

        if (replacingTheme) {
          replacingTheme.set(themeData);
        } else if (themeData.id > 0) { // is add new
          iorad.player.data.themesCollection.add(themeData);
        }

        iorad.player.controllers.views.waitForRenderOperations({
          timeoutMS: undefined, // no timeout
        }).then(() => {
          siteWindow.parent.postMessage({
            from: message.to,
            to: message.from,
            topic: 'themeSettings:replaceThemeData:done',
            data: {
              replyTo: message.uuid,
            },
          }, '*');
        });
      }
    }, this);
    siteWindow.removeEventListener('message', onMessage, false);
    siteWindow.addEventListener('message', onMessage, false);
  },

  startExtensionMode: function() {
    this.startRegularMode();

    var onMessage = _.bind(function(e) {
      //console.log(e.data);
      var message = e.data;
      if (typeof message !== 'object' || message === null) return;
      if (message.topic === 'extension:change:device') {
        this.tutorial.set('extensionDevice', message.data);
      } else if (message.topic === 'extension:change:colors') {
        iorad.player.data.markerColors.setColors(message.data.markerColor, message.data.markerFontColor);
      } else if (message.topic === 'extension:exitPractice') {
        if (!this.editModeActive) {
          iorad.player.router.embedClose();
        } else {
          window.postMessage({
            type: 'api',
            command: 'editor:close',
          });
        }
      }
    }, this);
    siteWindow.removeEventListener('message', onMessage, false);
    siteWindow.addEventListener('message', onMessage, false);

    if (iorad.player.getParameters.device) {
      this.tutorial.set('extensionDevice', iorad.player.getParameters.device);
    }
  },

  isValidRouteCandidate: function(hash) {
    if (typeof hash === 'undefined') {
      hash = window.location.hash; // candidate
    }

    if (
      iorad.base.Utils.startsWith(hash, '#trysteps-') ||
      iorad.base.Utils.startsWith(hash, '#watchsteps-') ||
      iorad.base.Utils.startsWith(hash, '#quizsteps-') ||
      iorad.base.Utils.startsWith(hash, '#step-')
    ) {
      // check if the requested step exists
      var stepNumber = parseInt(hash.substring(hash.indexOf('-') + 1), 10);
      return !isNaN(stepNumber) && stepNumber >= 1
        && stepNumber <= this.stepsCollection.length;
    } else if (iorad.base.Utils.startsWith(hash, '#viewsteps')) {
      // check if there is at least one step to display
      return this.stepsCollection.length != 0;
    }

    return true;
  },

  tutorialFetched: function() {
    // Redirect to the default route if the requested route isn't valid
    // Note: is done before the triggering of the dataReady event in order to change the first route
    if (!this.isValidRouteCandidate()) {
      window.setLocationHash('');
    }

    this.notifyDataReady();
  },

  notifyPlayerReady: function() {
    if (window.performance && typeof window.performance.now === 'function') {
      iorad.base.withLoggingEnabled(function() { // also log in production
        console.log('Player ready! It took', window.performance.now() / 1000, 'seconds');
      });
    }
    iorad.player.ready = true;
    iorad.player.events.trigger('player:ready');
    siteWindow.postMessage('player:ready', Backbone.history.location.origin);
    if (siteWindow.parent !== siteWindow) {
      siteWindow.parent.postMessage({
        from: 'iorad-web-app',
        topic: 'player:ready',
        data: this.isExtensionMode() ? {
          tutorialJson: window.tutorialJson,
        } : {},
      }, '*');
    }
    $('#loading-app').hide();
    $('#app-container').css('visibility', '');
  },

  isCoverDisabled: function () {
    if (iorad.player.getParameters.videoExport === 'true') {
      // video export always needs cover for initial pre-recording setup
      return false;
    }
    return (
      this.tutorial.getLayoutOption('is_cover_disabled') ||
      iorad.player.getParameters.coverDisabled === 'true'
    );
  },

  isViewTabAvailable: function () {
    var isFullscreenSupported = screenfull.enabled;
    var isPhone = iorad.app.controllers.clientDetect.device.isPhone;

    return iorad.player.device === 'desktop' ||
      (!isPhone && this.isExtensionMode()) ||
      (!isPhone && isFullscreenSupported);
  },

  isSlideTabAvailable: function () {
    return true;
  },

  isTryTabAvailable: function() {
    var isFullscreenSupported = screenfull.enabled;
    var isPhone = iorad.app.controllers.clientDetect.device.isPhone;

    return iorad.player.device === 'desktop' ||
      (!isPhone && this.isExtensionMode()) ||
      (!isPhone && isFullscreenSupported) ||
      this.tutorial.get('isMobile');
  },

  isWatchTabAvailable: function() {
    var isFullscreenSupported = screenfull.enabled;
    var isPhone = iorad.app.controllers.clientDetect.device.isPhone;

    return iorad.player.device === 'desktop' ||
      (!isPhone && this.isExtensionMode()) ||
      (!isPhone && isFullscreenSupported);
  },

  isQuizTabAvailable: function() {
    if (!this.tutorial.isQuizAvailable()) return false;

    var isFullscreenSupported = screenfull.enabled;
    var isPhone = iorad.app.controllers.clientDetect.device.isPhone;

    return iorad.player.device === 'desktop' ||
      (!isPhone && this.isExtensionMode()) ||
      (!isPhone && isFullscreenSupported);
  },

  checkDefaultToViewSteps: function() {
    // default to view steps option
    return this.tutorial.getLayoutOption('is_viewsteps_default') &&
      (window.location.hash == '' || window.location.hash == '#') &&
      this.isValidRouteCandidate('#viewsteps') &&
      this.isViewTabAvailable() &&
      (
        (
          !this.doMatchMobilePortrait() &&
          !this.doMatchMobileLandscape()
        ) ||
        (
          iorad.player.controllers.views.isCoverOpen() &&
          !this.tutorial.getLayoutOption('is_cover_disabled') &&
          iorad.player.getParameters.coverDisabled !== 'true'
        )
      );
  },

  checkDefaultToMobileQuick: function() {
    // default to view steps option
    return this.tutorial.getLayoutOption('is_mobilequick_default') &&
      (window.location.hash == '' || window.location.hash == '#') &&
      this.isValidRouteCandidate('#mobilequick-1');
  },

  checkDefaultToTrySteps: function() {
    // default to view steps option
    return this.tutorial.getLayoutOption('is_trysteps_default') &&
      (window.location.hash == '' || window.location.hash == '#') &&
      this.isValidRouteCandidate('#trysteps-1') &&
      !this.doMatchMobilePortrait() &&
      !this.doMatchMobileLandscape();
  },

  checkDefaultToWatchSteps: function() {
    // default to view steps option
    return this.tutorial.getLayoutOption('is_watchsteps_default') &&
      (window.location.hash == '' || window.location.hash == '#') &&
      this.isValidRouteCandidate('#watchsteps-1') &&
      this.isWatchTabAvailable() &&
      (
        (
          !this.doMatchMobilePortrait() &&
          !this.doMatchMobileLandscape()
        ) ||
        (
          iorad.player.controllers.views.isCoverOpen() &&
          !this.tutorial.getLayoutOption('is_cover_disabled') &&
          iorad.player.getParameters.coverDisabled !== 'true'
        )
      );
  },

  checkDefaultToQuizSteps: function() {
    // default to view steps option
    return this.tutorial.getLayoutOption('is_quizsteps_default') &&
      (window.location.hash == '' || window.location.hash == '#') &&
      this.isValidRouteCandidate('#quizsteps-1') &&
      this.isQuizTabAvailable() &&
      (
        (
          !this.doMatchMobilePortrait() &&
          !this.doMatchMobileLandscape()
        ) ||
        (
          iorad.player.controllers.views.isCoverOpen() &&
          !this.tutorial.getLayoutOption('is_cover_disabled') &&
          iorad.player.getParameters.coverDisabled !== 'true'
        )
      );
  },

  checkDefaultToPractice: function() {
    // default to practice option ("Try It" tab selected in mobile cover)
    return this.tutorial.getLayoutOption('is_trysteps_default') &&
      this.isValidRouteCandidate('#practice') &&
      this.doMatchMobilePortrait() &&
      !this.tutorial.get('isMobile') &&
      iorad.player.controllers.views.isCoverOpen() &&
      !this.tutorial.getLayoutOption('is_cover_disabled') &&
      iorad.player.getParameters.coverDisabled !== 'true' &&
      this.isTryTabAvailable();
  },

  checkDefaultToViewPractice: function () {
    // default to view practice option ("Scroll It" tab selected in mobile cover)
    return this.tutorial.getLayoutOption('is_viewsteps_default') &&
      this.isValidRouteCandidate('#viewpractice') &&
      this.doMatchMobilePortrait() &&
      !this.tutorial.get('isMobile') &&
      iorad.player.controllers.views.isCoverOpen() &&
      !this.tutorial.getLayoutOption('is_cover_disabled') &&
      iorad.player.getParameters.coverDisabled !== 'true' &&
      this.isViewTabAvailable();
  },

  checkDefaultToPdf: function() {
    return this.tutorial.getLayoutOption('is_pdf_default') &&
      (window.location.hash == '' || window.location.hash == '#') &&
      this.isValidRouteCandidate('#print') &&
      !this.tutorial.isPrintDisabled();
  },

  checkDefaultToLive: function() {
    return this.tutorial.getLayoutOption('is_live_default') &&
      (window.location.hash == '' || window.location.hash == '#') &&
      this.isValidRouteCandidate('#live') &&
      this.tutorial.isDoItAvailable();
  },

  // navigate to the previous hash fragment if any, to the home otherwise.
  // takes same options as Backbone Router navigate method.
  // WARNING: we don't mantain the full history, so calling it two times in a row will redirect you to the original fragment.
  back: function(options) {
    var fragment;
    if (this.previousFragment !== undefined) fragment = this.previousFragment;
    else fragment = ''; // home
    this.navigate('#' + fragment, options);
  },

  denyIfEmptyTutorial: function(options) {
    options = options || {};

    if (iorad.player.data.stepsCollection.length == 0) {
      noty({
        text: iorad.player.successNotificationList.emptyTutorial(),
        layout: 'center',
        type: 'info',
      });
      if (!options.preventBack) this.back({
        trigger: false
      });
      return true; // denied
    }

    return false;
  },

  doMatchMobilePortrait: function() {
    var mobileForced = (
      this.tutorial.getLayoutOption('is_mobile_device') ||
      this.getFrameMode() === 'widget'
    ) && !iorad.player.controllers.views.isFullscreen();

    var desktopForced = this.tutorial.getLayoutOption('is_desktop_device') &&
      this.getFrameMode() !== 'widget';

    if (this.isPreviewMode() && !mobileForced && !desktopForced && !iorad.player.controllers.views.isFullscreen()) {
      // preview override
      return this.previewModel.get('previewDevice') == 'mobilePortrait';
    }
    if (this.isExtensionMode() && this.tutorial.get('extensionDevice')) {
      // library override
      return this.tutorial.get('extensionDevice') == 'mobilePortrait';
    }
    if (iorad.player.getParameters.device) {
      // URL override
      return iorad.player.getParameters.device === 'mobilePortrait';
    }

    var width = $(window).width();
    var height = $(window).height();
    return (iorad.app.controllers.clientDetect.device.isPhone ||
      (width <= 575 && width !== 0) || // Player rendering while in display:none will report width===0, breaking initial hash (will report as mobile and switch device)
      mobileForced
    )/* && width < height*/ && !desktopForced;
  },

  doMatchMobileLandscape: function() {
    return false; // LANDSCAPE DISABLED FOR NOW

    // var mobileForced = this.getFrameMode() === 'widget'
    //   ? false
    //   : (this.tutorial.getLayoutOption('is_mobile_device') && !iorad.player.controllers.views.isFullscreen());

    // var desktopForced = this.getFrameMode() === 'widget'
    //   ? false
    //   : this.tutorial.getLayoutOption('is_desktop_device');
    //
    //
    // if (this.isPreviewMode() && !mobileForced) {
    //   // preview override
    //   return this.previewModel.get('previewDevice') == 'mobileLandscape';
    // }
    // if (this.isExtensionMode() && this.tutorial.get('extensionDevice')) {
    //   // library override
    //   return this.tutorial.get('extensionDevice') == 'mobilePortrait';
    // }
    // if (iorad.player.getParameters.device) {
    //   // URL override
    //   return iorad.player.getParameters.device === 'mobileLandscape';
    // }

    // var width = $(window).width();
    // var height = $(window).height();
    // return (iorad.app.controllers.clientDetect.device.isPhone ||
    //   mobileForced
    // ) && width >= height && !desktopForced;
  },

  changeDeviceMode: function(isMobilePortrait, isMobileLandscape) {
    if (!Backbone.History.started) return; // too early

    this.isMobilePortrait = isMobilePortrait || false;
    this.isMobileLandscape = isMobileLandscape || false;

    var deviceChange = Boolean(iorad.player.device);
    var device;
    if (this.isMobilePortrait) device = 'mobilePortrait';
    else if (this.isMobileLandscape) device = 'mobileLandscape';
    else device = 'desktop';

    if (deviceChange) {
      this.applyThemeToDeviceChangeOverlay();
      this.showDeviceChangeOverlay();
      //iorad.player.controllers.views.setCoverOpen(true);
    }

    $('html').attr('data-device', device);
    iorad.player.device = device;
    iorad.player.events.trigger('device', device);
    iorad.player.events.trigger('device:' + device);

    var forceDefault = this.isPreviewMode() && !iorad.player.controllers.views.isFullscreen();
    this.gotoDefault(forceDefault);
  },

  checkDeviceChange: function() {
    var wasMobilePortrait = this.isMobilePortrait;
    var isMobilePortrait = this.doMatchMobilePortrait();

    var wasMobileLandscape = this.isMobileLandscape;
    var isMobileLandscape = this.doMatchMobileLandscape();

    if (
      isMobilePortrait !== wasMobilePortrait ||
      isMobileLandscape !== wasMobileLandscape
    ) {
      this.changeDeviceMode(isMobilePortrait, isMobileLandscape);
    }
  },

  showDeviceChangeOverlay: function() {
    $('#main .device-change-overlay').show();
    iorad.player.deviceChangeOverlayVisible = true;
    iorad.player.events.trigger('change:deviceChangeOverlay', true);
    if (siteWindow.parent !== siteWindow) {
      siteWindow.parent.postMessage({
        from: 'iorad-web-app',
        topic: 'player:deviceChangeOverlay:show',
        data: {},
      }, '*');
    }
  },

  hideDeviceChangeOverlay: function() {
    iorad.player.deviceChangeOverlayHiding = true;
    iorad.player.events.trigger('before:change:deviceChangeOverlay', false);
    setTimeout(() => { // let browser draw first (https://github.com/iorad/iorad-extension/issues/2435)
      $('#main .device-change-overlay').hide();
      iorad.player.deviceChangeOverlayHiding = false;
      iorad.player.deviceChangeOverlayVisible = false;
      iorad.player.events.trigger('change:deviceChangeOverlay', false);
      if (siteWindow.parent !== siteWindow) {
        siteWindow.parent.postMessage({
          from: 'iorad-web-app',
          topic: 'player:deviceChangeOverlay:hide',
          data: {},
        }, '*');
      }
    });
  },

  changeMode: function(mode) {
    if (iorad.player.mode === mode) return;
    var args = Array.prototype.slice.call(arguments);
    var rest = args.slice(1);

    iorad.player.oldMode = iorad.player.mode;
    iorad.player.events.trigger.apply(iorad.player.events, ['mode:' + mode].concat(rest));
    iorad.player.events.trigger.apply(iorad.player.events, ['mode', mode].concat(rest));
  },

  changeTab: function(tab) {
    if (iorad.player.tab === tab) return;
    iorad.player.oldTab = iorad.player.tab;
    $('html').attr('data-tab', tab);
    iorad.player.tab = tab;
    iorad.player.events.trigger('tab:' + tab);
    iorad.player.events.trigger('tab', tab);
    if (siteWindow.parent !== siteWindow) {
      siteWindow.parent.postMessage({
        from: 'iorad-web-app',
        topic: 'player:change:tab',
        data: {
          tab,
        },
      }, '*');
    }
  },

  gotoDefault: function (reset) {
    if (!iorad.player.device) return; // too early

    this.clearGotoHash();

    var portraitMobile = this.doMatchMobilePortrait();
    var landscapeMobile = this.doMatchMobileLandscape();

    var hash = Backbone.history.location.hash;
    var stepNumber = this.stepsCollection.getCurrentStepNumber();
    var finished = (hash.indexOf('finished') > -1);
    var slideNumber = finished
      ? this.stepsCollection.length
      : hash.indexOf('-') != -1 // 'mobilequick-X' or 'trysteps-X' or 'watchsteps-X' or 'quizsteps-X' or 'step-X'
        ? hash.split('-')[1]
        : this.stepsCollection.getCurrentStepNumber();

    slideNumber = Math.max(1, slideNumber);
    slideNumber = Math.min(slideNumber, this.stepsCollection.length);

    var oldHash = window.location.hash;
    var coverOpenable = (
      !iorad.player.controllers.views.isCoverOpen() &&
      !this.tutorial.getLayoutOption('is_cover_disabled') &&
      iorad.player.getParameters.coverDisabled !== 'true'
    );

    if (reset) {
      if (
        coverOpenable
      ) {
        iorad.player.controllers.views.setCoverOpen(true, true);
        coverOpenable = false;
      }

      slideNumber = 1;
      window.setLocationHash('#');
    }

    var gotoDefaultNoSettings = _.bind(function () {
      var validHashes = [
        ['#trysteps-' + slideNumber, (
          (this.isTryTabAvailable() && !this.tutorial.getLayoutOption('is_trysteps_disabled')) ||
          iorad.player.getParameters.videoExport === 'true'
        )],
        ['#watchsteps-' + slideNumber, this.isWatchTabAvailable() && !this.tutorial.getLayoutOption('is_watchsteps_disabled')],
        ['#quizsteps-' + slideNumber, this.isQuizTabAvailable() && !this.tutorial.getLayoutOption('is_quizsteps_disabled')],
        ['#viewsteps', this.isViewTabAvailable() && !this.tutorial.getLayoutOption('is_viewsteps_disabled')],
        ['#mobilequick-' + slideNumber, this.isSlideTabAvailable() && !this.tutorial.getLayoutOption('is_mobilequick_disabled')],
        // ['#print', !this.tutorial.getLayoutOption('is_print_portrait_disabled') && !this.tutorial.getLayoutOption('is_print_landscape_disabled')],
        // ['#live', this.tutorial.isDoItAvailable() && !this.tutorial.getLayoutOption('is_live_disabled')],
      ]
        .filter(_.bind(function (rule) {
          return rule[1];
        }, this))
        .map(_.bind(function (rule) {
          return rule[0];
        }, this));

      var findValidHash = function (hashCandidate) {
        return validHashes.find(_.bind(function (validHash) {
          return validHash === hashCandidate;
        }, this));
      };

      var newHash;
      if (portraitMobile) {
        newHash = (
          findValidHash(hash) ||
          (this.tutorial.get('isMobile') && findValidHash('#trysteps-' + slideNumber)) ||
          findValidHash('#mobilequick-' + slideNumber) ||
          validHashes[0] ||
          ('#mobilequick-' + slideNumber)
        );
        if (newHash !== ('#mobilequick-' + slideNumber) && coverOpenable) {
          iorad.player.controllers.views.setCoverOpen(true, true);
          coverOpenable = false;
        }
      } else if (landscapeMobile) {
        newHash = (
          findValidHash(hash) ||
          findValidHash('#viewsteps') ||
          validHashes[0] ||
          '#viewsteps'
        );
      } else {
        newHash = (
          findValidHash(hash) ||
          findValidHash('#trysteps-' + slideNumber) ||
          validHashes[0] ||
          '#trysteps-' + slideNumber
        );
      }

      if (newHash && newHash !== hash) {
        window.setLocationHash(newHash);
      }
    }, this);

    var pendingModalHash;
    if (this.checkDefaultToPractice()) {
      pendingModalHash = '#practice';
    } else if (this.checkDefaultToViewPractice()) {
      pendingModalHash = '#viewpractice';
    } else if (this.checkDefaultToPdf()) {
      pendingModalHash = '#print';
    } else if (this.checkDefaultToLive()) {
      pendingModalHash = '#live';
    } else if (this.checkDefaultToTrySteps()) {
      window.setLocationHash('#trysteps-1');
    } else if (this.checkDefaultToViewSteps()) {
      window.setLocationHash('#viewsteps');
    } else if (this.checkDefaultToMobileQuick()) {
      window.setLocationHash('#mobilequick-1');
    } else if (this.checkDefaultToWatchSteps()) {
      window.setLocationHash('#watchsteps-1');
    } else if (this.checkDefaultToQuizSteps()) {
      window.setLocationHash('#quizsteps-1');
    } else {
      gotoDefaultNoSettings();
    }

    if (pendingModalHash) {
      iorad.player.mode = null; // force ready event otherwise gotoHashLater hangs forever if oldMode === mode
      this.gotoHashLater(pendingModalHash);
      gotoDefaultNoSettings();
    } else {
      // force mode change otherwise hideDeviceChangeOverlay will never be called
      // if new and old mode are the same
      iorad.player.mode = null;
    }

    if (window.location.hash === oldHash) {
      Backbone.history.loadUrl();
    }
  },

  gotoDefaultNoReset: function () {
    return this.gotoDefault(false);
  },

  gotoHashLater: function(hash) {
    this.clearGotoHash();

    this.gotoHashListener = [iorad.player.events, 'ready', function() {
      this.gotoHashListener = undefined;
      window.setLocationHash(hash);
    }.bind(this)];

    this.listenToOnce.apply(this, this.gotoHashListener);
  },

  clearGotoHash: function() {
    if (this.gotoHashListener) {
      this.stopListening.apply(this, this.gotoHashListener);
      this.gotoHashListener = undefined;
    }
  },

  gotoQuickView: function() {
    this.changeTab('view');

    if (!this.isMobilePortrait) {
      if (!this.denyIfEmptyTutorial()) {
        this.stepsCollection.setCurrentStep(1);
        this.changeMode('quick');
      }
    } else {
      this.changeMode('mobilequick', 1);
    }
  },

  gotoMobileQuick: function(stepNumber) {
    this.changeTab('slide');

    this.changeMode('mobilequick', stepNumber);
  },

  // Note: index is 1-indexed!
  goToInteractive: function(stepNumber, speed, finished) {
    stepNumber = parseInt(stepNumber, 10);

    this.changeTab('try');

    if (
      !this.isMobilePortrait ||
      iorad.player.data.tutorial.get('isMobile')
    ) {
      if (!this.denyIfEmptyTutorial()) {
        var oldStepNumber = this.stepsCollection.getCurrentStepNumber();
        var isNext = stepNumber > oldStepNumber;
        var step = this.stepsCollection.getModelAt(stepNumber - 1);
        if (step && step.get('event.quizStarter') && !this.isQuizTabAvailable()) {
          // skip quizStarter step
          if (isNext) {
            if (stepNumber + 1 <= this.stepsCollection.length) {
              window.setLocationHash('#trysteps-' + (stepNumber + 1), { isReplace: true });
              return;
            }
          } else { // prev
            if (stepNumber - 1 >= 1) {
              window.setLocationHash('#trysteps-' + (stepNumber - 1), { isReplace: true });
              return;
            }
          }
        }
        this.stepsCollection.setCurrentStep(stepNumber);
        this.changeMode('interactive', finished);
      }
      if (speed) {
        iorad.player.controllers.autoplay.setSpeed(speed);
      }
    } else {
      this.changeMode('mobilequick', finished ? (this.stepsCollection.length + 1) : stepNumber);
    }
  },

  gotoFinished: function() {
    if (this.isMobilePortrait) {
      this.gotoMobileQuick(this.stepsCollection.length + 1);
    } else {
      // last step
      this.goToInteractive(this.stepsCollection.length, undefined, true);
    }
  },

  gotoWatch: function(stepNumber, speed) {
    stepNumber = parseInt(stepNumber, 10);

    this.changeTab('watch');

    if (!this.isMobilePortrait) {
      if (!this.denyIfEmptyTutorial()) {
        var oldStepNumber = this.stepsCollection.getCurrentStepNumber();
        var isNext = stepNumber > oldStepNumber;
        var step = this.stepsCollection.getModelAt(stepNumber - 1);
        if (step && step.get('event.quizStarter') && !this.isQuizTabAvailable()) {
          // skip quizStarter step
          if (isNext) {
            if (stepNumber + 1 <= this.stepsCollection.length) {
              window.setLocationHash('#watchsteps-' + (stepNumber + 1), { isReplace: true });
              return;
            }
          } else { // prev
            if (stepNumber - 1 >= 1) {
              window.setLocationHash('#watchsteps-' + (stepNumber - 1), { isReplace: true });
              return;
            }
          }
        }
        this.stepsCollection.setCurrentStep(stepNumber);
        this.changeMode('interactive');
      }
      iorad.player.controllers.autoplay.setSpeed(speed);
    } else {
      this.changeMode('mobilequick', stepNumber);
    }
  },

  gotoQuiz: function(stepNumber) {
    stepNumber = parseInt(stepNumber, 10);

    this.changeTab('quiz');

    if (!this.isMobilePortrait) {
      if (!this.denyIfEmptyTutorial()) {

        if (this.tutorial.get('quizIncludedStepsType') !== 'all') {
          // skip READ steps (except the last one).
          var newStepNumber = stepNumber;
          while (
            newStepNumber < this.stepsCollection.length &&
            this.stepsCollection.getModelAt(newStepNumber - 1).get('type') === 'READ'
          ) {
            newStepNumber += 1;
          }
          if (newStepNumber !== stepNumber) {
            window.setLocationHash('#quizsteps-' + newStepNumber, { isReplace: true });
            return;
          }
        }

        this.stepsCollection.setCurrentStep(stepNumber);
        this.changeMode('interactive');
      }
    } else {
      this.changeMode('mobilequick', stepNumber);
    }
  },

  gotoPractice: function() {
    this.changeTab('try');
  },

  gotoViewPractice: function () {
    this.changeTab('view');
  },

  gotoLive: function() {
    this.changeTab('live');
  },

  gotoPrint: function(autoType) {
    // this.togglePlayerPopup(true);
    siteWindow.parent.postMessage({
      from: 'iorad-web-app',
      topic: 'player:click',
      data: {
        popupOpen: true,
      },
    }, '*');

    this.changeTab('pdf');

    if (autoType) {
      iorad.player.controllers.views.setCoverOpen(false, true, true);

      if (autoType === 'portrait') {
        this.exportView.$el.find('.print-portrait').click();
      } else if (autoType === 'landscape') {
        this.exportView.$el.find('.print-landscape').click();
      }
    }
  },

  applyThemeToDeviceChangeOverlay: function(coverOpenOverride) {
    var coverOpen = typeof coverOpenOverride !== 'undefined'
      ? coverOpenOverride
      : iorad.player.controllers.views.isCoverOpen();
    var ic = this.layoutPlayer.getItemColors();
    var ich = ic.header;
    var $deviceChangeOverlay = $('.device-change-overlay');
    var $sidePanel = $deviceChangeOverlay.find('.side-panel');
    var $sidePanelInner = $deviceChangeOverlay.find('.side-panel-inner');
    var $progressPageLoading = $deviceChangeOverlay.find('.progressPageLoading');

    // don't wait for css
    $sidePanel.css({
      width: '',
    });

    // if (coverOpen) {
    //   $sidePanelInner.css('background-color', ich.coverBackground);
    // } else {
    //   $sidePanelInner.css('background-color', 'white');
    // }

    // var backgroundImgUrl = (coverOpen && ic.header.coverBackgroundImage) || '';
    // if ($sidePanel.data('backgroundImgUrl') !== backgroundImgUrl) {
    //   $sidePanel
    //     [backgroundImgUrl ? 'addClass' : 'removeClass']('background-image')
    //     .css('background-image', backgroundImgUrl ? 'url(' + backgroundImgUrl + ')' : 'none')
    //     .data('backgroundImgUrl', backgroundImgUrl);
    // }

    // var opacity = 50;
    // $deviceChangeOverlay.css({
    //   color: coverOpen
    //     ? (ich.font + parseInt(opacity / 100 * 255, 10).toString(16))
    //     : 'rgba(0, 0, 0, .' + opacity + ')',
    // });

    $progressPageLoading.css({
      backgroundColor: iorad.player.data.markerColors.get('READ') || '',
    });
  },

  embedIsTryMode: function() {
    var customDevice = this.tutorial.get('extensionDevice');
    var isTryMode = customDevice === 'desktop';
    return isTryMode;
  },

  embedToggleTryMode: function(startOrStop) {
    setTimeout(function() {
      this.applyThemeToDeviceChangeOverlay();
      this.showDeviceChangeOverlay(); // show loader right away to prevent ugly transition
      iorad.player.controllers.views.setCoverOpen(false, true, true);
      setTimeout(function() {
        if (startOrStop) {
          siteWindow.parent.postMessage({
            from: 'iorad-web-app',
            topic: 'player:try',
            data: {},
          }, '*');
        } else {
          siteWindow.parent.postMessage({
            from: 'iorad-web-app',
            topic: 'player:close',
            data: {},
          }, '*');
        }

        setTimeout(function() {
          this.tutorial.set('extensionDevice', startOrStop ? 'desktop' : 'mobilePortrait');
        }.bind(this), 0);
      }.bind(this), 0);
    }.bind(this), 0);
  },

  embedClose: function() {
    if (this.embedIsTryMode()) {
      // stop try mode first
      this.embedToggleTryMode(false);
      return;
    }
    siteWindow.parent.postMessage({
      from: 'iorad-web-app',
      topic: 'player:close',
      data: {},
    }, '*');
  },

  editMode: function(options) {
    options = options || {};

    try {
      localStorage.setItem('editorReturnToStep', this.stepsCollection.getCurrentStepNumber());
    } catch (err) {
      // local storage disabled (e.g. 3rd party cookies disabled in the embedded case)
      console.error(err);
    }

    var editUrl;
    if (this.isPreviewMode()) {
      // load in a new tab
      editUrl = iorad.base.Settings.get('editTutorial.url', {
        tutorialID: iorad.player.tutorialId,
        userID: iorad.player.userId,
        returnTo: '',
        hash: options.hash || '',
      });
      siteWindow.ioradNodeApp.setLocation(editUrl, {
        isNewWindow: true,
      });
    } else if (this.isEmbedded()) {

      this.editModeActive = true;
      siteWindow.parent.postMessage({
        from: 'iorad-web-app',
        topic: 'player:editMode:start',
        data: {},
      }, '*');

      var resizeToBigPanel = this.isExtensionMode() && !this.embedIsTryMode();
      if (resizeToBigPanel) {
        this.applyThemeToDeviceChangeOverlay(false);
        this.showDeviceChangeOverlay();
        siteWindow.parent.postMessage({
          from: 'iorad-web-app',
          topic: 'player:try',
          data: {},
        }, '*');
      }

      // load in iframe
      editUrl = iorad.base.Settings.get('editTutorial.url', {
        tutorialID: iorad.player.tutorialId,
        userID: iorad.player.userId,
        returnTo: '',
        hash: options.hash || '',
      });
      var $iframe = $('<iframe frameborder="0" allowfullscreen="allowfullscreen" allow="camera; microphone; clipboard-write" />');
      $iframe.css({
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        'z-index': '99999999999',
        'border': '1px solid #ccc',
      });
      $iframe.on('load', _.bind(function() {
        if (resizeToBigPanel) {
          this.hideDeviceChangeOverlay();
        }
      }, this));
      $iframe.attr('src', editUrl);
      $('body').append($iframe);
      var handleWindowMessage = _.bind(function(e) {
        var message = e.data;

        if (typeof message !== 'object' || message === null) return;
        if (message.type !== 'api') return;

        if (message.command === 'editor:close') {
          window.removeEventListener('message', handleWindowMessage, true);

          // soft reload to updated player
          iorad.player.controllers.sync.loadPlayer(
            iorad.player.getParameters.lang || undefined,
            iorad.player.getParameters.helpcenter || undefined,
            iorad.player.getParameters.roleId || undefined
          )
            .then(_.bind(function (newPlayerData) {
              // even if we were in try mode,
              // the player is going to be reloaded
              // and we won't be able to keep desktop override
              // once it reloads
              // => reset to mobile small player
              if (resizeToBigPanel || this.embedIsTryMode()) {
                siteWindow.parent.postMessage({
                  from: 'iorad-web-app',
                  topic: 'player:close',
                  data: {},
                }, '*');
              }

              this.editModeActive = false;
              siteWindow.parent.postMessage({
                from: 'iorad-web-app',
                topic: 'player:editMode:stop',
                data: {},
              }, '*');
              siteWindow.__dataPlayer = newPlayerData;
              siteWindow.ioradNodeApp.reloadIframe();
            }, this))
            .catch(_.bind(function (err) {
              if (resizeToBigPanel) {
                siteWindow.parent.postMessage({
                  from: 'iorad-web-app',
                  topic: 'player:close',
                  data: {},
                }, '*');
              }
              $iframe.remove();
              this.editModeActive = false;
              siteWindow.parent.postMessage({
                from: 'iorad-web-app',
                topic: 'player:editMode:stop',
                data: {},
              }, '*');
              console.error(err);
              noty({
                text: 'Operation failed.',
                type: 'error',
              });
            }, this));
        }
      }, this);
      window.addEventListener('message', handleWindowMessage, true);
    } else {
      editUrl = iorad.base.Settings.get('editTutorial.url', {
        tutorialID: iorad.player.tutorialId,
        userID: iorad.player.userId,
        returnTo: encodeURIComponent(window.location.href),
        hash: options.hash || '',
      });
      siteWindow.ioradNodeApp.setLocation(editUrl);
    }
  },

  onFullscreenStatusChange: function() {
    if (this.isExtensionMode() && !this.editModeActive) {
      if (iorad.player.controllers.views.isFullscreen() && !this.embedIsTryMode()) {
        this.embedToggleTryMode(true);
      } else if (!iorad.player.controllers.views.isFullscreen() && this.embedIsTryMode()) {
        this.embedClose();
      }
    }
  },

  setHelpCenterConfigs: function() {
    siteWindow.addEventListener('message', _.bind(function(event) {
      var message = event.data;
      // console.log('setHelpCenterConfigs message', message);
      if (typeof message !== 'object' || message === null) return;
      if (message.to !== 'iorad-web-app') return;
      if (message.topic === 'set-next-tutorial-data') {
        iorad.player.controllers.views.setNextPlayerData(message.data);
      }
    }, this));
    // if (siteWindow.top !== siteWindow) {
    //   siteWindow.parent.postMessage({
    //     from: 'iorad-web-app',
    //     topic: 'save:statistics',
    //     data: path,
    //   }, '*');
    // }
  },

  bindStepNavigationShortcuts: function() {
    function isValid(event) {
      if (!_.contains(['#trysteps', '#viewsteps', '#mobilequick', '#watchsteps'], window.location.hash.split('-')[0])) return false;
      if (!event.fromIoradExtension && !_.contains([document.body, window, siteWindow.document.body, siteWindow], event.target)) return false;
      return true;
    }

    var ctrlPress = false;
    const specialKeys = {
      16: 'shift',
      17: 'ctrl',
      18: 'alt',
      91: 'meta',
    };
    let comboPress = false;

    var handle = _.throttle(_.bind(function(e) {
      var isMobileDevice = iorad.player.device !== 'desktop';
      var isMobileTutorial = iorad.player.data.tutorial.get('isMobile');
      var viewsteps = window.location.hash === '#viewsteps';
      var mobilequick = _.contains(['#mobilequick'], window.location.hash.split('-')[0]);
      var coverOpen = iorad.player.controllers.views.isCoverOpen();
      var playbarData = this.playbarView.getTemplateData();

      if (e.keyCode === 37 && !coverOpen) { // arrow left
        const { isPrevBtnHidden, isPrevBtnDisabled } = playbarData;
        if (
          this.stepsCollection.position > 0 &&
          !isPrevBtnHidden &&
          !isPrevBtnDisabled
        ) {
          if (viewsteps) {
            iorad.player.events.trigger('quick:back');
          } else if (mobilequick) {
            iorad.player.events.trigger('mobilequick:back');
          } else {
            if (isMobileDevice && !isMobileTutorial) iorad.player.events.trigger('mobilequick:back');
            else iorad.player.events.trigger('interactive:back');
          }
        } else {
          iorad.player.controllers.views.setCoverOpen(true);
        }
      } else if (e.keyCode === 39) { // arrow right
        if (coverOpen) {
          iorad.player.controllers.views.setCoverOpen(false);
        } else {
          const { isNextBtnHidden, isNextBtnDisabled } = playbarData;
          if (
            this.stepsCollection.position < this.stepsCollection.length - 1 &&
            !isNextBtnHidden &&
            !isNextBtnDisabled
          ) {
            if (viewsteps) {
              iorad.player.events.trigger('quick:next');
            } else if (mobilequick) {
              iorad.player.events.trigger('mobilequick:next');
            } else {
              if (isMobileDevice && !isMobileTutorial) iorad.player.events.trigger('mobilequick:next');
              else iorad.player.events.trigger('interactive:next');
            }
          }
        }
      } else if (e.keyCode === 187 && !coverOpen) { // '+'
        const { isZoomBtnHidden, isZoomBtnDisabled } = playbarData;
        if (!isZoomBtnHidden && !isZoomBtnDisabled) {
          iorad.player.controllers.screenshots.zoomNext();
        }
      } else if (e.keyCode === 189 && !coverOpen) { // '-'
        const { isZoomBtnHidden, isZoomBtnDisabled } = playbarData;
        if (!isZoomBtnHidden && !isZoomBtnDisabled) {
          iorad.player.controllers.screenshots.zoomPrevious();
        }
      } else {
        const pressedSpecialKey = (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey);
        if (
          !comboPress &&
          // current event is no special keys
          !specialKeys[e.keyCode] &&
          (
            pressedSpecialKey ||
            (
              !pressedSpecialKey && e.keyCode === 9 // single press Tab key
            )
          )
        ) {
          // comboPress = true; // disabled: on next step user has to release the special keys and pressing again

          iorad.player.events.trigger('press:comboKey', e);
        }
      }
    }, this), 200, { trailing: false });

    var check = _.bind(function(e) {
      if (e.keyCode === 27) {
        iorad.player.events.trigger('press:esc');
      }

      if (isValid(e)) {
        var viewsteps = window.location.hash === '#viewsteps';

        if (ctrlPress && e.keyCode === 82) {
          if (viewsteps) {
            return iorad.player.events.trigger('quick:goTo', 0);
          }

          return iorad.player.router.navigateToInteractiveMode(null, 1);
        }

        if (e.keyCode === 17) {
          ctrlPress = true;
        } else {
          ctrlPress = false;
        }

        handle(e);
      }
    }, this);

    var uncheck = function(e) {
      ctrlPress = false;
      comboPress = false;
    };

    $(siteWindow).on('keydown', check);
    $(window).on('keydown', check);

    $(siteWindow).on('keyup', uncheck);
    $(window).on('keyup', uncheck);

    siteWindow.addEventListener('message', _.bind(function(event) {
      var message = event.data;
      if (typeof message !== 'object' || message === null) return;
      if (message.to !== 'iorad-web-app') return;
      if (message.topic === 'extension:keydown') {
        check(_.extend(message.data, {
          fromIoradExtension: true,
        }));
      }
    }, this));
  },
  getInteractiveModeLink: function(tab, stepPosition, watchModeSpeed) {
    tab = tab || iorad.player.tab;
    var isWatchMode = tab === 'watch';
    var isQuizMode = tab === 'quiz';
    var tabRoute = isWatchMode ? 'watchsteps'
      : isQuizMode ? 'quizsteps'
        : 'trysteps';
    stepPosition = (stepPosition !== undefined && stepPosition !== null)
      ? stepPosition
      : iorad.player.data.stepsCollection.position + 1;
    if (isWatchMode) {
      watchModeSpeed = watchModeSpeed || iorad.player.controllers.autoplay.getSpeed();
    }
    return ('#' + tabRoute + '-' + stepPosition) + ((watchModeSpeed && watchModeSpeed !== '1x') ? ('/' + watchModeSpeed) : '');
  },
  navigateToInteractiveMode: function(tab, stepPosition, watchModeSpeed, navigateOpts) {
    return this.navigate(
      this.getInteractiveModeLink(tab, stepPosition, watchModeSpeed),
      _.extend({ trigger: true }, navigateOpts)
    );
  },
  togglePlayerPopup: function (isOpen) {
    isOpen = Boolean(isOpen);
    this.playerPopupOpen = isOpen;
    iorad.player.events.trigger('playerPopup', isOpen);
  },
});

;
(function() {
  var isEmbedded = false;
  try {
    isEmbedded = siteWindow.top !== siteWindow;
  } catch (e) {
    // embedded with cross-origin restrictions
    isEmbedded = true;
  }

  if (isEmbedded) {
    var htmlEl = document.getElementsByTagName('html')[0];
    htmlEl.classList.add('waiting');

    siteWindow.addEventListener('message', function onMessage(e) {
      if (e.data === 'player:ready') {
        siteWindow.removeEventListener('message', onMessage, false);
        htmlEl.classList.remove('waiting');
      }
    }, false);
  }
})();

;
jQuery(function() {
  (iorad.player.controllers.clientDetect = new iorad.player.ClientDetectController())
    .start().then(_.bind(function() {
      iorad.player.controllers.language = new iorad.player.LanguageController();

      // detect if unsupported
      var isUnsupportedDownload = window.downloadPlayerType === 'zip' &&
        window.location.href.split('/')[0] === "file:" &&
        (iorad.player.controllers.clientDetect.browser.isChrome || iorad.player.controllers.clientDetect.browser.isNewEdge);
      if (isUnsupportedDownload) {
        $('#app-container').html(Mustache.render(iorad.player.templates.unsupported_download)).show();
        return;
      }

      iorad.player.disableCORS = (window.downloadPlayerIsSCORM == true);


      //TODO(hoatle): check if the above getParameters could be removed when we got pretty url
      // stuff integrated, currently keep it for using both
      // <-- must be kept for envs such as dev and downloaded where there is no pretty url support!
      // Get info from GET parameters
      var getParameters = iorad.player.getParameters = iorad.base.Utils.getUrlParameters();
      iorad.player.userId = window.authorId;
      iorad.player.tutorialId = getParameters['module'];
      iorad.player.answerId = getParameters['answerId'];

      if (iorad.player.getParameters.extensionEmbed === 'true') {
        $('html').attr('data-extensionEmbed', 'true');
      }
      if (iorad.player.getParameters.videoExport === 'true') {
        $('html').attr('data-videoExport', 'true');
      }

      var prettyPlayerUrlParameters = iorad.base.Utils.getPlayerParameters();
      if (prettyPlayerUrlParameters) {
        console.log('is pretty player url => setting tutorialId by its url pattern now...');
        iorad.player.tutorialId = prettyPlayerUrlParameters['module'];
      }
      if (!iorad.player.tutorialId) {
        // fallback for exported player
        var dataJSON = window.tutorialJson || {};
        if (typeof dataJSON == 'string') dataJSON = JSON.parse(dataJSON);
        if (dataJSON.tutorial) {
          iorad.player.tutorialId = dataJSON.tutorial.moduleID;
        }
      }
      if (!iorad.player.userId || !iorad.player.tutorialId) {
        // redirect to error page
        siteWindow.ioradNodeApp.setLocation(iorad.base.Settings.get('siteError.url', {
          error_message: 'Undefined userId or tutorialId'
        }));
        return;
      }

      iorad.player.data.stepsCollection = new iorad.player.collections.steps();
      iorad.player.data.themesCollection = new iorad.player.collections.themes();

      iorad.player.data.tutorial = new iorad.player.models.tutorial();
      iorad.player.data.tutorial.setSteps(iorad.player.data.stepsCollection);

      iorad.player.data.previewModel = new Backbone.Model();

      iorad.player.data.overridedThemeData = new Backbone.Model();

      iorad.player.data.markerColors = new iorad.player.models.markerColors();

      iorad.player.data.liveUrlConfig = new iorad.player.models.liveUrlConfig();

      iorad.player.data.framesUrlCache = new iorad.player.models.framesUrlCache();

      iorad.player.controllers.sync = new iorad.player.SyncController(iorad.player,
        iorad.player.data.tutorial,
        iorad.player.data.stepsCollection,
        iorad.player.data.themesCollection,
        null, // no default settings
        iorad.player.data.markerColors,
        iorad.player.data.liveUrlConfig,
        iorad.player.data.framesUrlCache
      );
      _.extend(iorad.player.controllers.sync, _.pick(iorad.player, 'userId', 'tutorialId'));

      iorad.player.controllers.screenshots = new iorad.player.ScreenshotsController(
        iorad.player.controllers.sync,
        null, {
          disableCORS: iorad.player.disableCORS
        }
      );

      iorad.player.notracking = Boolean(
        window.downloadPlayerType ||
        !iorad.base.Export.isCookieConsentAccepted('analytics.player_tracking') ||
        (
          window.tutorialJson &&
          window.tutorialJson.tutorial &&
          window.tutorialJson.tutorial.notracking
        )
      );

      if (!iorad.player.notracking) {
        iorad.player.controllers.tracking = new iorad.player.TrackingController(iorad.player.data.tutorial, {
          providers: _.compact([
            //new iorad.player.HubspotController(iorad.player.data.tutorial),
            new iorad.player.GoogleAnalyticsController(iorad.player.data.tutorial),
            new iorad.player.EmbeddedTrackingController(iorad.player.data.tutorial)
          ]),
          exclusions: {
            hubspot: true,
          },
        });
      }

      if (window.downloadPlayerIsSCORM) {
        iorad.player.controllers.scorm = new iorad.player.SCORMController();
      }

      iorad.player.controllers.views = new iorad.player.ViewsController(
        iorad.player.data.tutorial,
        iorad.player.data.stepsCollection,
        iorad.player.data.themesCollection
      );

      iorad.player.controllers.quiz = new iorad.player.QuizController(
        iorad.player.data.tutorial,
        iorad.player.data.stepsCollection
      );

      if (!iorad.player.notracking || window.downloadPlayerIsSCORM) { // progress controller is required for sending SCORM messages
        iorad.player.controllers.progress = new iorad.player.ProgressController(
          iorad.player.data.stepsCollection,
          iorad.player.controllers.scorm
        );
        _.extend(iorad.player.controllers.progress, _.pick(iorad.player, 'tutorialId'));
      }

      if (!iorad.player.notracking) {
        iorad.player.controllers.statistics = new iorad.player.StatisticsController(
          iorad.player.data.stepsCollection,
          iorad.player.data.tutorial,
          iorad.player.tutorialId
        );
      }

      if (iorad.player.getParameters.videoExport === 'true') {
        iorad.player.controllers.videoExport = new iorad.player.VideoExportController(
          iorad.player.data.stepsCollection,
          iorad.player.data.tutorial
        );
      }

      iorad.player.controllers.autoplay = new iorad.player.AutoplayController({
        model: iorad.player.data.tutorial,
        collection: iorad.player.data.stepsCollection,
      });

      iorad.player.controllers.audio = new iorad.player.AudioController(
        iorad.player.data.tutorial,
        iorad.player.data.stepsCollection
      );

      iorad.player.controllers.video = new iorad.player.VideoController(
        iorad.player.data.tutorial,
        iorad.player.data.stepsCollection
      );

      iorad.player.controllers.music = new iorad.player.MusicController(
        iorad.player.data.tutorial,
        iorad.player.data.stepsCollection
      );

      iorad.player.controllers.live = new iorad.player.LiveController(
        iorad.player.data.tutorial,
        iorad.player.data.stepsCollection
      );

      const isEmbedded = siteWindow.parent !== siteWindow;
      const isLegacyPreview = getParameters.isPreview === 'true';
      if (isEmbedded && !isLegacyPreview) {
        siteWindow.document.body.style.display = 'none';
      }
      iorad.player.controllers.language
        .start(('lang' in getParameters ? getParameters.lang : window.userAcceptedLocale) || 'en')
        .then(_.bind(function(defaultLanguage) {
          iorad.player.controllers.language.changeLanguage(defaultLanguage);

          iorad.player.router = new iorad.player.routers.main({
            globalBus: iorad.player.events
          });

          // HACK: fix firefox bug not firing hashchange event the first time (#3746)
          var originalHash = getParameters.iframeHash || window.location.hash;
          window.setLocationHash('#_');
          setTimeout(function() {
            window.setLocationHash(originalHash);
            iorad.player.router.start();
            if (isEmbedded && !isLegacyPreview) {
              const onReady = () => {
                siteWindow.document.body.style.display = '';
                iorad.player.events.trigger('embedded:init:show');
              };
              if (iorad.player.ready) onReady();
              else iorad.player.events.once('player:ready', onReady);
            }
          }, 0);
        }, this));
    }, this));
});
